(function () {
	'use strict';

	angular
		.module('app.front', ['ui.utils.masks', 'ui.calendar', 'slickCarousel'])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.home', {
				url: '/home',
				views: {
					'content@app': {
						templateUrl: 'app/main/home/home.html',
						controller: 'HomeController as vm'
					}
				},
				data: {
					permissions: ['AGENDA']
				}
			})
			.state('app.empty', {
				url: '/empty',
				views: {
					'content@app': {
						templateUrl: 'app/main/home/empty.html',
						controller: 'EmptyController as vm'
					}
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/home');

		// moment.defineLocale('fr', {
		//   months : 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split('_'),
		//   monthsShort : 'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split('_'),
		//   monthsParseExact : true,
		//   weekdays : 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
		//   weekdaysShort : 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
		//   weekdaysMin : 'Di_Lu_Ma_Me_Je_Ve_Sa'.split('_'),
		//   weekdaysParseExact : true,
		//   longDateFormat : {
		//     LT : 'HH:mm',
		//     LTS : 'HH:mm:ss',
		//     L : 'DD/MM/YYYY',
		//     LL : 'D MMMM YYYY',
		//     LLL : 'D MMMM YYYY HH:mm',
		//     LLLL : 'dddd D MMMM YYYY HH:mm'
		//   },
		//   calendar : {
		//     sameDay: '[Aujourd\'hui à] LT',
		//     nextDay: '[Demain à] LT',
		//     nextWeek: 'dddd [à] LT',
		//     lastDay: '[Hier à] LT',
		//     lastWeek: 'dddd [dernier à] LT',
		//     sameElse: 'L'
		//   },
		//   relativeTime : {
		//     future : 'dans %s',
		//     past : 'il y a %s',
		//     s : 'quelques secondes',
		//     m : 'une minute',
		//     mm : '%d minutes',
		//     h : 'une heure',
		//     hh : '%d heures',
		//     d : 'un jour',
		//     dd : '%d jours',
		//     M : 'un mois',
		//     MM : '%d mois',
		//     y : 'un an',
		//     yy : '%d ans'
		//   },
		//   ordinalParse: /\d{1,2}(er|)/,
		//   ordinal : function (number) {
		//     return number + (number === 1 ? 'er' : '');
		//   },
		//   week : {
		//     dow : 1, // Monday is the first day of the week.
		//     doy : 4  // The week that contains Jan 4th is the first week of the year.
		//   }
		// });

	}
})();

(function () {
  'use strict';

  angular.module('app.front').controller('addContactCtrl', addContactCtrl);

  function addContactCtrl($scope, $translate, $mdDialog, companyId, contactService) {

    $scope.newContact = {};
    $scope.addContactMode = true;

    contactService.getCategories($translate.preferredLanguage()).then(function (data) {
      $scope.categories = data;
    }).catch(function (response) {

    });

    $scope.saveContact = function () {
      contactService.addModel($scope.categories, $scope.newContact, companyId).then(function (response) {
        $mdDialog.hide();
      }).catch(function () {

      });
    };

    $scope.hidePopup = function () {
      $mdDialog.cancel();
    };
  }
})();

(function(){
	'use strict';

	angular.module('app.front').controller('addInscriptionFormController', addInscriptionFormController);

	function addInscriptionFormController($scope, $mdDialog, $translate, $filter, eventId, form, toastr, modelService, inscriptionFormService, inscriptionSubCategoryService, 
			inscriptionStatusService, logisticalStatusService){
		var modelType = 'COMPANY_MODEL';
		var baseUrl = './api/rest/model/' + modelType;
		if (form != null){
			$scope.newForm = angular.copy(form);
		}else{
			$scope.newForm = {
				eventId: eventId
			};
		}

		inscriptionSubCategoryService.list($translate.preferredLanguage()).then(function(response){
			$scope.subcategories = response.data;
		}).catch(function(){

		});

		inscriptionStatusService.list($translate.preferredLanguage()).then(function(response){
			$scope.defaultRegistrationsStatus = response.data;
		}).catch(function(){

		});

		logisticalStatusService.list($translate.preferredLanguage()).then(function(response){
			$scope.defaultLogisticalsStatus = response.data;
		}).catch(function(){

		});

		modelService.getSubTypes(baseUrl, $translate.preferredLanguage(), true).then(function (response) {
			$scope.subtypes = response.data;
		}).catch(function(response){

		});

		$scope.save = function(){
			inscriptionFormService.save($scope.newForm).then(function(response){
				$mdDialog.hide(response);
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};
	}
})();
(function () {
  'use strict';

  angular.module('app.front').controller('PageController', PageController);

  function PageController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, $stateParams, SitesManagementService) {

    $scope.sites = [];
    $scope.blocs = [];
    $scope.languages = [];
    $scope.page = {
      pageBlocs: []
    };
    $scope.ngChangeFlag = false;
    $scope.pageId = angular.copy($stateParams.id);

    // UTILS

    $scope._pagesListFn = function () {
      $state.go('app.pages');
    };

    $scope._getCleanKey = function (key) {
      var _cleanKey = angular.copy(key);
      return _cleanKey.replace(/[{()}]/g, '');
    };

    $scope._siteLanguagesBuilderFn = function (itemSite) {
      if (itemSite) {
        for (var i = 0; i < itemSite.languages.length; i++) {
          var lang = itemSite.languages[i];
          delete lang.activated;
          delete lang.preferred;
          var alreadyHere = false;
          for (var j = 0; j < $scope.languages.length; j++) {
            if ($scope.languages[j].key === lang.key) {
              alreadyHere = true;
            }
          }
          if (!alreadyHere) {
            lang.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + lang.key);
            $scope.languages.push(lang);
          }
        }
      }
      /*angular.forEach(itemSite.languages, function (lang) {
        var _lang = angular.copy(lang);
        var _index = $scope.languages.map(function(thisLang) {
          return thisLang.key;
        }).indexOf(_lang.key);
        if(_index===-1) {
          _lang.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + _lang.key);
          $scope.languages.push(_lang);
        }
      });*/
    };

    // BLOCKS
    SitesManagementService.findAll('blocs').then(function (response) {
      $scope.blocs = response.data;
    }).catch(function (error) {
      toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
    });

    $scope.initWatcherBlocs = function () {
      if ($scope.page) {
        angular.forEach($scope.page.watchers, function (item, index) {
          if (item.watcher) {
            item.watcher();
          }
        });
        $scope.page.watchers = [];
        angular.forEach($scope.page.pageBlocs, function (item, index) {
          var watcherVar = { key: index };
          watcherVar.watcher = $scope.$watch("page.pageBlocs[" + index + "].bloc", function (newValue, oldValue, scope) {
            if (newValue && newValue.id && oldValue && oldValue.id && newValue.id != oldValue.id) {
              $scope.page.pageBlocs[index].html = angular.copy($scope.page.pageBlocs[index].bloc.html);
              $scope.page.pageBlocs[index].pageBlocTranslations = [];
              angular.forEach($scope.page.pageBlocs[index].bloc.keys, function (_item, _index) {
                $scope.page.pageBlocs[index].pageBlocTranslations.push({
                  key: _item,
                  value: null,
                  index: _index
                });
              });
            }
          });
          $scope.page.watchers.push(angular.copy(watcherVar));
        });
      }
    };

    // ENTRY POINT
    $scope.initPage = function () {
      if ($scope.pageId) {
        SitesManagementService.find('page', $scope.pageId).then(function (response) {

          $scope.page = response.data;
          if ($scope.page && $scope.page.targetLanguage) {
            $scope.page.targetLanguage.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + angular.copy($scope.page.targetLanguage.key));
          }
          angular.forEach($scope.page.sites, function (site) {
            $scope._siteLanguagesBuilderFn(angular.copy(site));
          });
          $timeout(function () {
            $scope.ngChangeFlag = true;
          }, 5000);
          //$scope.initWatcherBlocs();
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
        SitesManagementService.findAll('sites').then(function (response) {
          $scope.sites = response.data;
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      } else {
        SitesManagementService.findAll('sites').then(function (response) {
          $scope.sites = response.data;
          angular.forEach($scope.sites, function (itemSite, indexSite) {
            $scope._siteLanguagesBuilderFn(angular.copy(itemSite));
          });
          $timeout(function () {
            $scope.ngChangeFlag = true;
          }, 5000);
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }
    };

    $scope.initPage();

    // PAGE

    // Change site
    $scope._changeSiteFn = function () {
      //$scope.languages = [];
      angular.forEach($scope.page.sites, function (site) {
        $scope._siteLanguagesBuilderFn(angular.copy(site));
      });
    };

    // Change language
    $scope._changeLanguageFn = function () {
      if ($scope.page.id && $scope.page.targetLanguage) {
        SitesManagementService.findPage($scope.page.id, $scope.page.targetLanguage.key).then(function (response) {
          $scope.page = response.data;
          if ($scope.page && $scope.page.targetLanguage) {
            $scope.page.targetLanguage.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + angular.copy($scope.page.targetLanguage.key));
          }
          angular.forEach($scope.page.sites, function (site) {
            $scope._siteLanguagesBuilderFn(angular.copy(site));
          });
          //$scope.initWatcherBlocs();
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }
    };

    // Add new block
    $scope._addPageBlocFn = function () {
      if ($scope.blocs && $scope.blocs.length > 0) {
        var newPageBlock = {
          index: $scope.page.pageBlocs && $scope.page.pageBlocs.length > 0 ? $scope.page.pageBlocs[$scope.page.pageBlocs.length - 1].index + 1 : 0,
          bloc: angular.copy($scope.blocs[0]),
          pageBlocTranslations: [],
          html: angular.copy($scope.blocs[0].html)
        };
        angular.forEach(newPageBlock.bloc.keys, function (item, _index) {
          newPageBlock.pageBlocTranslations.push({
            key: item,
            value: null,
            index: _index
          });
        });
        $scope.page.pageBlocs.push(newPageBlock);
        SitesManagementService.save('page', $scope.page).then(function (response) {
          $scope.page = response.data;
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });

      }
    };

    // Remove a block
    $scope._removePageBlocFn = function (bloc) {
      /*angular.forEach($scope.page.watchers, function(item, index) {
        $timeout(function() {
          item.watcher();
        })
      });
      $scope.page.watchers = [];*/
      for (var i = 0; i < $scope.page.pageBlocs.length; i++) {
        if ($scope.page.pageBlocs[i].id === bloc.id) {
          $scope.page.pageBlocs.splice(i, 1);
          break;
        } else if ($scope.page.pageBlocs[i].index > bloc.index) {
          $scope.page.pageBlocs[i].index -= 1;
        }
      }
      //$scope.initWatcherBlocs();
    };

    // Change block
    $scope._changePageBlocFn = function (index) {
      console.log($scope.page.pageBlocs[index]);
      if ($scope.ngChangeFlag) {
        $scope.page.pageBlocs[index].html = angular.copy($scope.page.pageBlocs[index].bloc.html);
        $scope.page.pageBlocs[index].pageBlocTranslations = [];
        angular.forEach($scope.page.pageBlocs[index].bloc.keys, function (item, _index) {
          $scope.page.pageBlocs[index].pageBlocTranslations.push({
            key: item,
            value: null,
            index: _index
          });
        });
        var element = document.getElementById('html' + index);
        if (element) {
          var cm = element.nextElementSibling.CodeMirror;
          var value = html_beautify($scope.page.pageBlocs[index].html);
          cm.setValue(value)
          cm.setOption("smartIndent", true);
        }

      }
    };

    // Save page
    $scope._save = function (pageForm) {
      pageForm.$setSubmitted();

      if (pageForm.$valid) {
        SitesManagementService.save('page', $scope.page).then(function (response) {
          pageForm.$setPristine();
          $scope.pageId = angular.copy(response.data.id);
          $state.transitionTo('app.pages.page', { id: response.data.id }, {
            location: true,
            inherit: true,
            relative: $state.$current,
            notify: false
          });
          $scope.initPage();
          toastr.success($filter('translate')('SITES_MANAGEMENT.PAGES.TOASTR_OPERATION_SUCCESS'));
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      } else {
        toastr.error("Vous devez renseigner tous les champs requis avant de valider.");
      }
    };

    // Delete page
    $scope._delete = function () {
      SitesManagementService.delete('page', $scope.page.id).then(function (response) {
        $scope._pagesListFn();
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.showHtml = function (bloc) {
      bloc.showHtml = !bloc.showHtml;
    };

    $scope.moveBloc = function (bloc, up) {
      if (bloc.index != null && $scope.page.id != null) {
        SitesManagementService.moveBloc($scope.page.id, bloc.index, up).then(function (res) {
          if ($scope.page.id && $scope.page.targetLanguage) {
            SitesManagementService.findPage($scope.page.id, $scope.page.targetLanguage.key).then(function (response) {
              $scope.page = response.data;
              if ($scope.page && $scope.page.targetLanguage) {
                $scope.page.targetLanguage.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + angular.copy($scope.page.targetLanguage.key));
              }
              angular.forEach($scope.page.sites, function (site) {
                $scope._siteLanguagesBuilderFn(angular.copy(site));
              });
              //$scope.initWatcherBlocs();
            }).catch(function (error) {
              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
          }
        }).catch(function (err) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
          console.log(err);
        });
      } else {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      }
    };

  }

})();

(function () {
  'use strict';

  angular.module('app.front').controller('BlocController', BlocController);

  function BlocController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, $stateParams, $templateRequest, $sce, SitesManagementService) {

    $scope.bloc = {};
    $scope.loaded=false;
    $scope.types = SitesManagementService.getBlocTypes();

    if ($stateParams.id) {

      SitesManagementService.find('bloc', $stateParams.id).then(function (response) {
      $scope.bloc = response.data;
      $scope.loaded=true;


      }).catch(function (error) {
      console.log(error)
      $scope.loaded=true;
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });

    }

    $scope._blocsListFn = function () {
      $state.go('app.blocs');
    };

    $scope.getBloc = function () {
      if ($scope.bloc && $scope.bloc.type) {

        // Carousel type process
        var templateUrl = null;
        if ($scope.bloc.type === 'CAROUSEL') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/carousel.template.type.html');
        } if ($scope.bloc.type === 'CAROUSEL_PURE') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/carousel_pure.template.type.html');
        } else if ($scope.bloc.type === 'BLOG') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/blog.template.type.html');
        } else if ($scope.bloc.type === 'BLOG_PURE') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/blog_pure.template.type.html');
        } else if ($scope.bloc.type === 'ARTICLE') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/article.template.type.html');
        } else if ($scope.bloc.type === 'ARTICLE_PURE') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/article_pure.template.type.html');
        } else if ($scope.bloc.type === 'SEARCH_COMPANY') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/search_companies.template.type.html');
        } else if ($scope.bloc.type === 'COMPANY') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/company.template.type.html');
        } else if ($scope.bloc.type === 'SEARCH_PACKAGE') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/search_packages.template.type.html');
        } else if ($scope.bloc.type === 'PACKAGE') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/package.template.type.html');
        } else if ($scope.bloc.type === 'SEARCH_TOURIST_ATTRACTIONS') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/search_tourist_attractions.template.type.html');
        } else if ($scope.bloc.type === 'TOURIST_ATTRACTION') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/tourist_attraction.template.type.html');
        } else if ($scope.bloc.type === 'FESTIVALS') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/festivals.template.type.html');
        } else if ($scope.bloc.type === 'FESTIVAL') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/festival.template.type.html');
        } else if ($scope.bloc.type === 'EVENT_INSCRIPTION') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/event/event_inscription.template.type.html');
        } else if ($scope.bloc.type === 'GALLERIES') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/galleries.template.type.html');
        } else if ($scope.bloc.type === 'GALLERY') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/gallery.template.type.html');
        } else if ($scope.bloc.type === 'CONTACT') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/contact.template.type.html');
        } else if ($scope.bloc.type === 'TABLE') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/table.template.type.html');
        } else if ($scope.bloc.type === 'FAVORITE') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/favorite.template.type.html');
        } else if ($scope.bloc.type === 'ARTICLE_100') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/article_100.template.type.html');
        } else if ($scope.bloc.type === 'ARTICLE_50') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/article_50.template.type.html');
        } else if ($scope.bloc.type === 'ARTICLE_33') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/article_33.template.type.html');
        } else if ($scope.bloc.type === 'ARTICLE_25') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/article_25.template.type.html');
        } else if ($scope.bloc.type === 'SEARCH_COMPANY_WITH_STATUS') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/search_company_with_status.template.type.html');
        } else if ($scope.bloc.type === 'YOUTUBE') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/youtube.template.type.html');
        } else if ($scope.bloc.type === 'GOOGLE_MAPS') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/maps.template.type.html');
        } else if ($scope.bloc.type === 'COMPANY_WITH_STATUS') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/company_with_status.template.type.html');
        } else if ($scope.bloc.type === 'COMPANY_SELECTION') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/company_selection.template.type.html');
        } else if ($scope.bloc.type === 'BANNER') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/banner.template.type.html');
        } else if ($scope.bloc.type === 'NEWSLETTER') {
          templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/newsletter.template.type.html');
        } else if ($scope.bloc.type === 'BANNER_CAROUSEL') {
			templateUrl = $sce.getTrustedResourceUrl('app/main/sites_management/blocs/bloc/banner_carousel.template.type.html');
		  }

        if (templateUrl != null) {

          $templateRequest(templateUrl).then(function (template) {
				$scope.bloc.html = html_beautify(template);
				var cm = document.querySelector(".CodeMirror").CodeMirror;
				cm.setValue($scope.bloc.html)
				cm.setOption("smartIndent",true);
				cm.refresh();

          }, function () {
            console.log('Error template type reading !!');
          });
        } else {
          $scope.bloc.html = '';
        }

      }

    };

    $scope._save = function (blocForm) {
      blocForm.$setSubmitted();
      if (blocForm.$valid) {
        SitesManagementService.save('bloc', $scope.bloc).then(function (response) {
          blocForm.$setPristine();
          $scope._blocsListFn();
        }).catch(function (error) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }
    };

    $scope._delete = function () {
      SitesManagementService.delete('bloc', $scope.bloc.id).then(function (response) {
        $scope._blocsListFn();
      }).catch(function (error) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };


  }

})();

(function () {
	'use strict';

	angular.module('app.front').controller('DetailsMembersController', DetailsMembersController);

	function DetailsMembersController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, $location, $stateParams,
		RequestForProposalService) {

		RequestForProposalService.findMemberById($stateParams.id, $translate.preferredLanguage()).then(function (response) {
			$scope.member = response.data;
		}).catch(function (error) {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});
		}
	}
)();

(function () {
	'use strict';

	angular.module('app.front').controller('MailingTriggerController', MailingTriggerController);

	function MailingTriggerController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, $stateParams, MailingService, languageService,
		modelService, InscriptionsAdminService, eventService, inscriptionFormService, logisticalStatusService, inscriptionStatusService,
		inscriptionSubCategoryService) {

		$scope.MODELS_TYPES = {
			COMPANY_MODEL: 'COMPANY_MODEL',
			CONTACT_MODEL: 'CONTACT_MODEL',
			INSCRIPTION_MODEL: 'INSCRIPTION_MODEL',
			LOGISTIC_MODEL: 'LOGISTIC_MODEL',
		};
		$scope.pages = [];
		$scope.languages = [];
		$scope.types = [{
				value: "DROPDOWN_TRIGGER"
			},
			{
				value: "REGISTRATION_VALIDATED_TRIGGER"
			}
		];

		$scope.fields = {
			contact: [],
			company: [],
			inscription: [],
			logistic: []
		};

		$scope.trigger = {};

		var FIXE_FIELD_REGISTRATION_STATUS_ID = -1;
		var FIXE_FIELD_LOGISTIC_STATUS_ID = -2;
		var FIXE_FIELD_REGISTRATION_SUBCATEGORY_ID = -3;

		// UTILS

		// md-select input search
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope._triggersListFn = function () {
			$state.go('app.mailing_triggers');
		};

		// LANGUAGES
		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
		}).catch(function (error) {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		// FIELDS
		modelService.listFieldsByType(
			$scope.MODELS_TYPES.CONTACT_MODEL,
			$translate.preferredLanguage()
		).then(function (resp) {
			$scope.fields.contact = $filter('filter')(resp.data, function (item) {
				return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
			});
		}).catch(function (err) {
			console.log(err);
		});

		modelService.listFieldsByType(
			$scope.MODELS_TYPES.COMPANY_MODEL,
			$translate.preferredLanguage()
		).then(function (resp) {
			$scope.fields.company = $filter('filter')(resp.data, function (item) {
				return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
			});
		}).catch(function (err) {
			console.log(err);
		});

		modelService.listFieldsByType(
			$scope.MODELS_TYPES.INSCRIPTION_MODEL,
			$translate.preferredLanguage()
		).then(function (resp) {
			$scope.fields.inscription = $filter('filter')(resp.data, function (item) {
				return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
			});
			// Registration status
			inscriptionStatusService.list($translate.preferredLanguage()).then(function (resp) {
				var registrationStatus = $scope._setTriggerDetailFixefield(FIXE_FIELD_REGISTRATION_STATUS_ID, "INSCRIPTION_MODEL", "LIST_SELECT",
					$filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_REGISTRATION_STATUS'),
					"FIXE_FIELD_REGISTRATION_STATUS", resp.data, null);
				$scope.fields.inscription.push(registrationStatus);
			}).catch(function (err) {
				console.log(err);
			});
			// Registration sub-categories
			inscriptionSubCategoryService.list($translate.preferredLanguage()).then(function (resp) {
				var registrationSubCat = $scope._setTriggerDetailFixefield(FIXE_FIELD_REGISTRATION_SUBCATEGORY_ID, "INSCRIPTION_MODEL", "LIST_SELECT",
					$filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_REGISTRATION_SUBCATEGORY'),
					"FIXE_FIELD_REGISTRATION_SUBCATEGORY", resp.data, null);
				$scope.fields.inscription.push(registrationSubCat);
			}).catch(function (err) {
				console.log(err);
			});
		}).catch(function (err) {
			console.log(err);
		});

		modelService.listFieldsByType(
			'LOGISTIC_MODEL',
			$translate.preferredLanguage()
		).then(function (resp) {
			$scope.fields.logistic = $filter('filter')(resp.data, function (item) {
				return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
			});
			// Logistic status
			logisticalStatusService.list($translate.preferredLanguage()).then(function (resp) {
				var logisticStatus = $scope._setTriggerDetailFixefield(FIXE_FIELD_LOGISTIC_STATUS_ID, "LOGISTIC_MODEL", "LIST_SELECT",
					$filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_LOGISTIC_STATUS'),
					"FIXE_FIELD_LOGISTIC_STATUS", resp.data, null);
				$scope.fields.logistic.push(logisticStatus);
			}).catch(function (err) {
				console.log(err);
			});
		}).catch(function (err) {
			console.log(err);
		});

		// EVENTS
		eventService.findAll().then(function (response) {
			$scope.events = response.data;
		}).catch(function (err) {
			console.log(err);
		});

		// TEMPLATES
		MailingService.findAll('pages', null).then(function (response) {
			$scope.pages = response.data;
		}).catch(function (error) {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		// ENTRY POINT
		$scope.initTrigger = function (id, lang) {
			MailingService.find('trigger', id, lang).then(function (response) {
				$scope.trigger = response.data;
				if ($scope.trigger && $scope.trigger.type) {
					if ($scope.trigger.type == 'DROPDOWN_TRIGGER') {
						if ($scope.trigger.subType && $scope.trigger.subType == 'FIXE_FIELD_LOGISTIC_STATUS') {
							var _customFixeField = $scope._setTriggerDetailFixefield(FIXE_FIELD_LOGISTIC_STATUS_ID, "LOGISTIC_MODEL", "LIST_SELECT",
								$filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_LOGISTIC_STATUS'),
								"FIXE_FIELD_LOGISTIC_STATUS", $scope.trigger.logisticsStatus, $scope.trigger.logisticStatus.id);
							$scope.trigger.field = angular.copy(_customFixeField);
						} else if ($scope.trigger.subType && $scope.trigger.subType == 'FIXE_FIELD_REGISTRATION_STATUS') {
							var _customFixeField = $scope._setTriggerDetailFixefield(FIXE_FIELD_REGISTRATION_STATUS_ID, "INSCRIPTION_MODEL", "LIST_SELECT",
								$filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_REGISTRATION_STATUS'),
								"FIXE_FIELD_REGISTRATION_STATUS", $scope.trigger.registrationsStatus, $scope.trigger.registrationStatus.id);
							$scope.trigger.field = angular.copy(_customFixeField);
						} else if ($scope.trigger.subType && $scope.trigger.subType == 'FIXE_FIELD_REGISTRATION_SUBCATEGORY') {
							var _customFixeField = $scope._setTriggerDetailFixefield(FIXE_FIELD_REGISTRATION_SUBCATEGORY_ID, "INSCRIPTION_MODEL", "LIST_SELECT",
								$filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_REGISTRATION_SUBCATEGORY'),
								"FIXE_FIELD_REGISTRATION_SUBCATEGORY", $scope.trigger.registrationsSubCategories, $scope.trigger.registrationSubCategory.id);
							$scope.trigger.field = angular.copy(_customFixeField);
						}
					} else if ($scope.trigger.type == 'REGISTRATION_VALIDATED_TRIGGER') {
						if ($scope.trigger.event && $scope.trigger.event.id) {
							inscriptionFormService.listByEvent($scope.trigger.event.id, $translate.preferredLanguage()).then(function (response) {
								$scope.registrationForms = response.data;
							}).catch(function (err) {
								console.log(err);
							});
						}
					}
				}
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope._setTriggerDetailFixefield = function (_idField, _modelType, _typeChamps, _libelle,
			_fixedFieldLangKey, _listValues, _idValue) {
			var _customFixeField = {
				id: _idField,
				modelType: _modelType,
				typeChamps: _typeChamps,
				libelle: _libelle,
				fixedFieldLangKey: _fixedFieldLangKey,
				listFieldsDTO: []
			};
			angular.forEach(_listValues, function (item, index) {
				if (_idValue && item.id == _idValue) {
					$scope.trigger.fieldValue = {
						id: item.id,
						index: item.index,
						value: item.name
					}
				}
				_customFixeField.listFieldsDTO.push({
					id: item.id,
					index: item.index,
					value: item.name
				});
			});
			return _customFixeField;
		};

		// MAJ
		if ($stateParams.id) {
			$scope.initTrigger($stateParams.id, null);
		}

		// Model type handle
		$scope._modelTypeChangeFn = function () {
			delete $scope.trigger.field;
			delete $scope.trigger.fieldValue;
		};

		// Field handle
		$scope._fieldChangeFn = function () {
			delete $scope.trigger.fieldValue;
		};

		// Trigger type handle
		$scope._triggerTypeChangeFn = function () {};

		// Event handle
		$scope.listRegistrationFormsByEvent = function (event) {
			delete $scope.trigger.registrationForm;
			inscriptionFormService.listByEvent(event.id, $translate.preferredLanguage()).then(function (response) {
				$scope.registrationForms = response.data;
			}).catch(function (err) {
				console.log(err);
			});
		};

		// Save
		$scope._save = function (triggerForm) {
			triggerForm.$setSubmitted();
			if (triggerForm.$valid) {
				MailingService.save('trigger', $scope.trigger, null).then(function (response) {
					triggerForm.$setPristine();
					if ($stateParams.id) {
						$scope.initTrigger($stateParams.id, null);
					} else {
						$state.transitionTo('app.mailing_triggers.trigger', {
							id: response.data.id
						}, {
							location: true,
							inherit: true,
							relative: $state.$current,
							notify: false
						});
						$scope.trigger.id = response.data.id;
					}
					toastr.success($filter('translate')('MAILING.DO_MAILING.SUCCESS'));
				}).catch(function (error) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			} else {
				toastr.error("Vous devez renseigner tous les champs requis avant de valider.");
			}
		};

		// Delete
		$scope._delete = function () {
			MailingService.delete('trigger', $scope.trigger.id).then(function (response) {
				$scope._triggersListFn();
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('MailingPageController', MailingPageController).filter('inscriptionGroupBy', function () {
		return function (items, group) {
			return items.filter(function (element, index, array) {
				return element.insriptionFormId == group.insriptionFormId;
			});
		}
	});

	function MailingPageController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, $stateParams, MailingService, languageService,
		MODELS_TYPES, modelService, InscriptionsAdminService, inscriptionFormService, $window, MailingTagsService) {

		$scope.blocs = [];
		$scope.languages = [];

		$scope.page = {
			htmlHeader: "<head>\n\n</head>",
			pageBlocs: []
		};

		$scope.fields = {
			contact: [],
			company: [],
			inscription: []
		};
		$scope.ngChangeFlag = false;

		// UTILS

		// md-select input search
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope._pagesListFn = function () {
			$state.go('app.mailing_pages');
		};

		$scope._getCleanKey = function (key) {
			var _cleanKey = angular.copy(key);
			return _cleanKey.replace(/[{()}]/g, '');
		};

		$scope.getInscriptionFormGroups = function () {
			var groupArray = [];
			angular.forEach($scope.fields.inscription, function (item, index) {
				var _thisGroupIndex = groupArray.map(function (mapper) {
					return mapper.insriptionFormId;
				}).indexOf(item.insriptionFormId);
				if (_thisGroupIndex == -1) {
					groupArray.push(item);
				};
			});
			return groupArray;
		};

		// LANGUAGES

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
		}).catch(function (error) {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		// BLOCKS

		MailingService.findAll('blocs', null).then(function (response) {
			$scope.blocs = response.data;
		}).catch(function (error) {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		// All model fields : Contact, Company & Inscription

		modelService.listFieldsByType(
			"CONTACT_MODEL",
			$translate.preferredLanguage()
		).then(function (resp) {
			$scope.fields.contact = $filter('filter')(resp.data, function (item) {
				return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT';
			});
		}).catch(function (err) {
			$scope.initDataInProgress = false;
			console.log(err);
		});

		modelService.listFieldsByType(
			"COMPANY_MODEL",
			$translate.preferredLanguage()
		).then(function (resp) {
			$scope.fields.company = $filter('filter')(resp.data, function (item) {
				return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT';
			});
		}).catch(function (err) {
			$scope.initDataInProgress = false;
			console.log(err);
		});

		modelService.listFieldsByType(
			"INSCRIPTION_MODEL",
			$translate.preferredLanguage()
		).then(function (resp) {
			$scope.fields.inscription = $filter('filter')(resp.data, function (item) {
				return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT';
			});
		}).catch(function (err) {
			$scope.initDataInProgress = false;
			console.log(err);
		});

		/*inscriptionFormService.listAllFields(
		  $translate.preferredLanguage(), false
		).then(function (resp) {
		  $scope.fields.inscription = $filter('filter')(resp.data, function (item) {
		      return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT';
		  });
		}).catch(function (err) {
		  $scope.initDataInProgress = false;
		  console.log(err);
		});*/

		// tags

		MailingTagsService.list($translate.preferredLanguage()).then(function (response) {
			$scope.tags = response.data;
		}).catch(function (error) {
			console.log(error);
		});


		// ENTRY POINT

		$scope.initPage = function (pageId, lang) {
			$scope.ngChangeFlag = false;
			MailingService.find('page', pageId, lang).then(function (response) {
				$scope.page = response.data;
				$timeout(function () {
					$scope.ngChangeFlag = true;
				}, 5000);
				console.log( $scope.page.pageBlocs)
			}).catch(function (error) {
				$scope.ngChangeFlag = true;
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		// MAJ Page
		if ($stateParams.id) {
			$scope.initPage($stateParams.id, $translate.preferredLanguage());
		} else {
			$timeout(function () {
				$scope.ngChangeFlag = true;
			}, 5000);
		}

		// Change language
		$scope._changeLanguageFn = function () {
			if ($scope.page.id && $scope.page.language) {
				$scope.initPage($scope.page.id, $scope.page.language.key);
			}
		};

		// Add new block
		$scope._addPageBlocFn = function () {
			if ($scope.blocs && $scope.blocs.length > 0) {
				var newPageBlock = {
					index: $scope.page.pageBlocs.length + 1,
					bloc: angular.copy($scope.blocs[0]),
					pageBlocTranslations: [],
					html: angular.copy($scope.blocs[0].html)
				};
				angular.forEach(newPageBlock.bloc.keys, function (item, index) {
					newPageBlock.pageBlocTranslations.push({
						simpleField: true,
						key: item,
						value: null
					});
				});
				angular.forEach(newPageBlock.bloc.keys2, function (item, index) {
					newPageBlock.pageBlocTranslations.push({
						simpleField: false,
						key: item,
						value: null
					});
				});
				var _pageBlocsLength = $scope.page.pageBlocs.push(newPageBlock);
			}
		};

		// Remove a block
		$scope._removePageBlocFn = function (_pageBloc) {
			for (var i = 0; i < $scope.page.pageBlocs.length; i++) {
				if ($scope.page.pageBlocs[i].id === _pageBloc.id) {
				  $scope.page.pageBlocs.splice(i, 1);
				  break;
				}else if($scope.page.pageBlocs[i].index > _pageBloc.index){
				 $scope.page.pageBlocs[i].index-=1;
				}
			 }
		};

		// Change block
		$scope._changePageBlocFn = function (pageBloc) {
			if ($scope.ngChangeFlag) {
				pageBloc.html = angular.copy(pageBloc.bloc.html);
				pageBloc.pageBlocTranslations = [];
				angular.forEach(pageBloc.bloc.keys, function (item, index) {
					pageBloc.pageBlocTranslations.push({
						simpleField: true,
						key: item,
						value: null
					});
				});
				angular.forEach(pageBloc.bloc.keys2, function (item, index) {
					pageBloc.pageBlocTranslations.push({
						simpleField: false,
						key: item,
						value: null
					});
				});
			}
		};

		// Save page
		$scope._save = function (pageForm) {
			var isUpdate = angular.copy($scope.page.id != null);
			pageForm.$setSubmitted();
			if (pageForm.$valid) {
				MailingService.save('page', $scope.page, null).then(function (response) {
					pageForm.$setPristine();
					//$scope.initPage(response.data.id, $scope.page.language.key);
					$scope.page = response.data;
					MailingService.exportToHtmlFile(response.data.id, $scope.page.language.key).then(function (res) {
						$state.transitionTo('app.mailing_pages.page', {
							id: response.data.id
						}, {
							location: true,
							inherit: true,
							relative: $state.$current,
							notify: false
						});
						$scope.pageSrcCode = res.data;
						if (isUpdate) {
							toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE'));
						} else {
							toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SAVE'));
						}
					}).catch(function (err) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
						console.log(err);
					});
				}).catch(function (error) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			} else {
				toastr.error("Vous devez renseigner tous les champs requis avant de valider.");
			}
		};

		// Delete page
		$scope._delete = function () {
			MailingService.delete('page', $scope.page.id).then(function (response) {
				$scope._pagesListFn();
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.showHtml = function (bloc) {
			bloc.showHtml = !bloc.showHtml;
		};

		$scope.moveBloc = function (bloc, up) {
			if (bloc.index != null && $scope.page.id != null) {
				MailingService.moveBloc($scope.page.id, bloc.index, up, $scope.page.language.key).then(function (res) {
					$scope.page = res.data;
				}).catch(function (err) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(err);
				});
			} else {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			}
		};

		$scope._viewSrcCode = function () {
			if (!$scope.showSrcCode) {
				MailingService.exportToHtmlFile($scope.page.id, $scope.page.language.key).then(function (res) {
					$scope.pageSrcCode = res.data;
				}).catch(function (err) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(err);
				});
			}
			$scope.showSrcCode = !$scope.showSrcCode;
		}

		// Export to html file
		$scope.exportToHtmlFile = function () {
			MailingService.exportToHtmlFile($scope.page.id, $scope.page.language.key).then(function (res) {
				var element = document.createElement('a');
				element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(res.data));
				element.setAttribute('download', $scope.page.name + ".html");
				element.style.display = 'none';
				document.body.appendChild(element);
				element.click();
				document.body.removeChild(element);
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(err);
			});
		};

		// preview
		$scope.previewMail = function () {
			var url = $state.href('mailing_preview.app', {
				id: $scope.page.id,
				lang: $scope.page.language.key
			});
			window.open(url, '_blank');
		};

	}

})();

(function () {
    'use strict';

    angular.module('app.front').controller('MailingBlocController', MailingBlocController);

    function MailingBlocController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, $stateParams, $templateRequest, $sce, MailingService) {

        $scope.bloc = {};
      $scope.loaded = false;
        $scope.types = MailingService.getBlocTypes();

        if($stateParams.id) {
          MailingService.find('bloc', $stateParams.id, null).then(function(response){
          $scope.bloc = response.data;

          $scope.loaded=true;

			    }).catch(function(error){
            $scope.loaded=true;
				    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
          });
        }

        $scope._blocsListFn = function() {
          $state.go('app.mailing_blocs');
        };

        $scope.getBloc = function(){
          if ($scope.bloc && $scope.bloc.type) {

            var templateUrl = null;
            if ($scope.bloc.type === 'TEST') {
              templateUrl = $sce.getTrustedResourceUrl('app/main/mailing/blocs/bloc/templates/test.template.type.html');
            }

            if (templateUrl != null) {
              $templateRequest(templateUrl).then(function (template) {
					$scope.bloc.html = html_beautify(template);
              var cm = document.querySelector(".CodeMirror").CodeMirror;
              cm.setValue($scope.bloc.html)
              cm.setOption("smartIndent",true);
              }, function () {
                console.log('Error template type reading !!');
              });
            } else {
              $scope.bloc.html = '';
            }

          }
        };

        $scope._save = function(blocForm) {
          blocForm.$setSubmitted();
  			  if (blocForm.$valid) {
            MailingService.save('bloc', $scope.bloc, null).then(function(response){
              blocForm.$setPristine();
              $scope._blocsListFn();
            }).catch(function(error){
              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
          }
        };

        $scope._delete = function() {
          MailingService.delete('bloc', $scope.bloc.id).then(function(response){
				    $scope._blocsListFn();
			    }).catch(function(error){
				    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			    });
        };

    }

})();

(function () {
    'use strict';

    angular.module('app.front').controller('InscriptionsAdminSettingsController', InscriptionsAdminSettingsController);

    function InscriptionsAdminSettingsController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, $element, toastr, MODELS_TYPES, modelService, 
        InscriptionsAdminService) {

    }
    
})();
(function () {
  'use strict';

  angular.module('app.front').controller('statsClicksController', statsClicksController);

  function statsClicksController($rootScope, $scope, $filter, $translate, $mdSelect, toastr, $state, companyService) {
    var now = new Date();
    $scope.filter = {
      date: angular.copy(now),
      dateCustom: angular.copy(now),
      month: null,
      year: null
    };
    $scope.periodModes = [];
    $scope.periodMode = {
      value: null
    };
    $scope.monthNames = [];
    $scope.yearValues = [];
    $scope.customYear = {
      value: null
    };
    $scope.statistics = {};
    var companyID = $state.params.id;

    initPeriodModes();
    initMonthAndYears();

    $scope.searchStatisticsCustomYear = function () {
      var customYear;
      var period;

      if (validateYearFormat($scope.customYear.value)) {
        $scope.filter.year = 'custom';
        $mdSelect.hide();
      } else {
        toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
      }
    };

    $scope.getStatistics = function () {
      var begin = null;
      var end = null;
      var momentVar = null;

      switch ($scope.periodMode.value) {
        case 'day':
          {
            momentVar = moment($scope.filter.date);

            momentVar.set({
              'hour': 0,
              'minute': 0,
              'second': 0,
              'millisecond': 0
            });
            begin = momentVar.valueOf();

            momentVar.add(1, 'days');
            end = momentVar.valueOf();

            break;
          }
        case 'month':
          {
            momentVar = moment(now);

            momentVar.set({
              'date': 1,
              'hour': 0,
              'minute': 0,
              'second': 0,
              'millisecond': 0
            });

            momentVar.month($scope.filter.month);
            if ($scope.filter.year === 'custom') {
              momentVar.year($scope.customYear);
            } else {
              momentVar.year($scope.filter.year);
            }

            begin = momentVar.valueOf();

            momentVar.add(1, 'months');
            end = momentVar.valueOf();

            break;
          }
        case 'year':
          {
            momentVar = moment(now);

            momentVar.set({
              'month': 0,
              'date': 1,
              'hour': 0,
              'minute': 0,
              'second': 0,
              'millisecond': 0
            });

            if ($scope.filter.year === 'custom') {
              momentVar.year($scope.customYear);
            } else {
              momentVar.year($scope.filter.year);
            }

            begin = momentVar.valueOf();

            momentVar.add(1, 'years');
            end = momentVar.valueOf();

            break;
          }
        case 'custom':
          {
            momentVar = moment($scope.filter.date);

            momentVar.set({
              'hour': 0,
              'minute': 0,
              'second': 0,
              'millisecond': 0
            });
            begin = momentVar.valueOf();

            momentVar = moment($scope.filter.dateCustom);
            momentVar.add(1, 'days');

            momentVar.set({
              'hour': 0,
              'minute': 0,
              'second': 0,
              'millisecond': 0
            });

            end = momentVar.valueOf();

            if (end < begin) {
              toastr.error($filter('translate')('STATS_CLICKS.TOAST_INVALD_DATES'));
            }

            break;
          }
      }

      var postDTO;

      if (begin && end) {
        postDTO = {
          beginDate: begin,
          endDate: end,
          companyID: companyID
        };
      } else {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        return;
      }

      companyService.findStatsClickByCompanyIDAndDates(postDTO).then(function (res) {
        if (res.data) {
          $scope.statistics = res.data;
        }

        console.log(res.data);
      }).catch(function (err) {
        console.log(err);
      });
    };

    //Init range years and months
    function initMonthAndYears() {
      for (var i = 0; i < 12; i++) {
        $scope.monthNames.push({
          value: i,
          name: $filter('translate')('GENERAL.MONTH_NAMES.' + i)
        });
      }

      var yearNow = now.getFullYear();

      for (var i = -3; i <= 3; i++) {
        $scope.yearValues.push(yearNow + i);
      }
    }

    function initPeriodModes() {
      $scope.periodModes = [{
          name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.DAY'),
          value: 'day'
        },
        {
          name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.MONTH'),
          value: 'month'
        },
        {
          name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.YEAR'),
          value: 'year'
        },
        {
          name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.CUSTOM'),
          value: 'custom'
        }
      ];
      $scope.periodMode.value = 'day';

      $rootScope.$on('$translateChangeSuccess', function () {
        console.log('tra,slaye');
        $scope.periodModes = [{
            name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.DAY'),
            value: 'day'
          },
          {
            name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.MONTH'),
            value: 'month'
          },
          {
            name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.YEAR'),
            value: 'year'
          },
          {
            name: $filter('translate')('STATS_CLICKS.PERIOD_MODES.CUSTOM'),
            value: 'custom'
          }
        ];
        $scope.periodMode.value = $filter('translate')('STATS_CLICKS.PERIOD_MODES.DAY');
      });
    }

    function validateYearFormat(year) {
      if (year >= (now.getFullYear() - 100) && year <= (now.getFullYear() + 100)) {
        return true;
      }

      return false;
    }

    //For iput select year
    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
    };
  }
})();

(function () {
    'use strict';
 
    angular.module('app.front').service('researchEngineSortService', researchEngineSortService);
 
    function researchEngineSortService($http, $q, $filter) {
 
        var service = {};
        
        // Fixe fields
        var fieldSorts = [{
                fieldSortIndex: 999,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'ASC',
                fixeFieldSqlKey: 'creationdate',
                fixeFieldSortKeyLang: 'CREATION_DATE',
                libelle: 'COMPANIES.COMPANY_SORT.CREATION_DATE',
            },
            {
                fieldSortIndex: 1000,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'DESC',
                fixeFieldSqlKey: 'creationdate',
                fixeFieldSortKeyLang: 'CREATION_DATE',
                libelle: 'COMPANIES.COMPANY_SORT.CREATION_DATE',
            },
            {
                fieldSortIndex: 1001,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'ASC',
                fixeFieldSqlKey: 'updatedate',
                fixeFieldSortKeyLang: 'MODIFICATION_DATE',
                libelle: 'COMPANIES.COMPANY_SORT.MODIFICATION_DATE',
            },
            {
                fieldSortIndex: 1002,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'DESC',
                fixeFieldSqlKey: 'updatedate',
                fixeFieldSortKeyLang: 'MODIFICATION_DATE',
                libelle: 'COMPANIES.COMPANY_SORT.MODIFICATION_DATE',
            },
            {
                fieldSortIndex: 1003,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'ASC',
                fixeFieldSqlKey: 'activated',
                fixeFieldSortKeyLang: 'ENABLE',
                libelle: 'COMPANIES.COMPANY_SORT.ENABLE',
                searchEngineOwner : 'COMPANY_MODEL'
            },
            {
                fieldSortIndex: 1004,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'DESC',
                fixeFieldSqlKey: 'activated',
                fixeFieldSortKeyLang: 'ENABLE',
                libelle: 'COMPANIES.COMPANY_SORT.ENABLE',
                searchEngineOwner : 'COMPANY_MODEL'
            },
            {
                fieldSortIndex: 1005,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'ASC',
                fixeFieldSqlKey: 'activated',
                fixeFieldSortKeyLang: 'DISABLE',
                libelle: 'COMPANIES.COMPANY_SORT.DISABLE',
                searchEngineOwner : 'COMPANY_MODEL'
            },
            {
                fieldSortIndex: 1006,
                fieldSortBaseType: 'FIXE_FIELD',
                sortType: 'DESC',
                fixeFieldSqlKey: 'activated',
                fixeFieldSortKeyLang: 'DISABLE',
                libelle: 'COMPANIES.COMPANY_SORT.DISABLE',
                searchEngineOwner : 'COMPANY_MODEL'
            }
        ];

        var modelSorts = {
            sorts: []
        };

        service.init = function(modelType) {
            modelSorts = { sorts: [] };
            var _thisFieldSorts = $filter('filter')(fieldSorts, function (_sort) {
                return !_sort.searchEngineOwner || (_sort.searchEngineOwner && _sort.searchEngineOwner == modelType)
            });
            var modelSort = {
                fieldSorts: _thisFieldSorts,
                fieldSortSelected: null
            };
            modelSorts.sorts.push(angular.copy(modelSort));
            modelSorts.sorts.push(angular.copy(modelSort));
            return modelSorts;
        };

        service.setSort = function(_modelSorts) {
            modelSorts = _modelSorts;
        };
   
        service.getSort = function() {
            return modelSorts;
        };
 
        return service;
 
    }
 
 })(); 
(function() {

    'use strict';

    angular.module('app.front').directive('researchEngineSort', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {

        return {
            restrict: 'E',
            controller: 'researchEngineSortController',
            controllerAs: 'researchEngineSortController',
            templateUrl: 'app/main/globe_network/companies/sort/sort.html',
            scope: {
                modelType: '@',
                subTypeId: '=',
                onSort: '&'
            }
        };

    }]);

})();

(function(){
    'use strict';

    angular.module('app.front').controller('researchEngineSortController', researchEngineSortController);

    function researchEngineSortController($rootScope, $scope, $state, $translate, $mdDialog, $timeout, $filter, toastr, 
        companyService, modelService, ResearchPageCreationService, researchEngineSortService) {
        
        // Init sort list

        $scope.modelSortsDto = angular.copy(researchEngineSortService.init($scope.modelType));

        ResearchPageCreationService.findSort($scope.modelType, $scope.subTypeId, $translate.preferredLanguage()).then(function (resp) {
            angular.forEach($scope.modelSortsDto.sorts, function(_sort) {
                _sort.fieldSorts = _sort.fieldSorts.concat(resp.data.fieldSorts);
            });
        }).catch(function (error) {
            console.log(error);
        });

        // Sort function

        $scope.sortModelFn = function() {
            $scope.onSort({ sort : $scope.modelSortsDto } );
        };
       
    }

})();
(function () {
  'use strict';

  angular.module('app.front').service('researchEngineFilterService', researchEngineFilterService);

  function researchEngineFilterService($http, $q, $filter) {

     var service = {};

     var modelFilters = { filters : [] };

     // Custom model field filter
     var customModelFieldFilter = [
       {
         customModelFieldFilter : true,
         fieldFilterBaseType: "MODEL_FIELD",
         fieldFilterIndex : -5, 
         fieldFilterSize: 25,
         modelFieldFilterKeyLang : 'MODEL_FIELD_KEYWORD',
         modelFieldFilterKeyLangForTanslate : 'MODEL_FIELD_KEYWORD',
         includeInFilter : true,
         typeChamps : 'STRING',
         fixedFieldFilter : {}
       }
     ];

     // Custom fixe field filter
     var customFixeFieldFilter = [
       {
         customFixeFieldFilter : true,
         fieldFilterBaseType: "FIXE_FIELD",
         fieldFilterIndex : -4, 
         fieldFilterSize: 25,
         fixeFieldFilterKeyLang : 'FIXE_FIELD_CREATION_DATE', 
         fixeFieldFilterKeyLangForTranslate : 'FIXE_FIELD_CREATION_DATE_COMPANY', 
         includeInFilter : true,
         typeChamps : 'DATE',
         fixedFieldFilter : {},
         searchEngineOwner : 'COMPANY_MODEL'
       },{
         customFixeFieldFilter : true,
         fieldFilterBaseType: "FIXE_FIELD",
         fieldFilterIndex : -3, 
         fieldFilterSize: 25,
         fixeFieldFilterKeyLang : 'FIXE_FIELD_MODIFICATION_DATE', 
         fixeFieldFilterKeyLangForTranslate : 'FIXE_FIELD_MODIFICATION_DATE_COMPANY', 
         includeInFilter : true,
         typeChamps : 'DATE',
         fixedFieldFilter : {},
         searchEngineOwner : 'COMPANY_MODEL'
       },{
         customFixeFieldFilter : true,
         fieldFilterBaseType: "FIXE_FIELD",
         fieldFilterIndex : -2, 
         fieldFilterSize: 25,
         fixeFieldFilterKeyLang : 'FIXE_FIELD_CREATION_DATE_CONTACT', 
         fixeFieldFilterKeyLangForTranslate : 'FIXE_FIELD_CREATION_DATE_CONTACT', 
         includeInFilter : true,
         typeChamps : 'DATE',
         fixedFieldFilter : {},
         searchEngineOwner : 'COMPANY_MODEL'
       },{
         customFixeFieldFilter : true,
         fieldFilterBaseType: "FIXE_FIELD",
         fieldFilterIndex : -1, 
         fieldFilterSize: 25,
         fixeFieldFilterKeyLang : 'FIXE_FIELD_MODIFICATION_DATE_CONTACT', 
         fixeFieldFilterKeyLangForTranslate : 'FIXE_FIELD_MODIFICATION_DATE_CONTACT', 
         includeInFilter : true,
         typeChamps : 'DATE',
         fixedFieldFilter : {},
         searchEngineOwner : 'COMPANY_MODEL'
       },{
         customFixeFieldFilter : true,
         fieldFilterBaseType: "FIXE_FIELD",
         fieldFilterIndex : -4, 
         fieldFilterSize: 25,
         fixeFieldFilterKeyLang : 'FIXE_FIELD_CREATION_DATE', 
         fixeFieldFilterKeyLangForTranslate : 'FIXE_FIELD_CREATION_DATE_INSCRIPTION', 
         includeInFilter : true,
         typeChamps : 'DATE',
         fixedFieldFilter : {},
         searchEngineOwner : 'INSCRIPTION_MODEL'
       },{
         customFixeFieldFilter : true,
         fieldFilterBaseType: "FIXE_FIELD",
         fieldFilterIndex : -3, 
         fieldFilterSize: 25,
         fixeFieldFilterKeyLang : 'FIXE_FIELD_MODIFICATION_DATE', 
         fixeFieldFilterKeyLangForTranslate : 'FIXE_FIELD_MODIFICATION_DATE_INSCRIPTION', 
         includeInFilter : true,
         typeChamps : 'DATE',
         fixedFieldFilter : {},
         searchEngineOwner : 'INSCRIPTION_MODEL'
       }
     ];

     service.init = function() {
        modelFilters = { filters : [] };
     };

     service.getCustomModelFieldFilterFn = function(modelType) {
        return $filter('filter')(customModelFieldFilter, function (_filter) {
          return !_filter.searchEngineOwner || (_filter.searchEngineOwner && _filter.searchEngineOwner == modelType)
        });
     };

     service.getCustomFixeFieldFilterFn = function(modelType) {
        return $filter('filter')(customFixeFieldFilter, function (_filter) {
          return !_filter.searchEngineOwner || (_filter.searchEngineOwner && _filter.searchEngineOwner == modelType)
        });
     };

     service.setFilter = function(_filters) {
        modelFilters.filters = _filters;
     };

     service.getFilter = function() {
        return modelFilters;
     };

     return service;

  }

})();

(function() {

    'use strict';

    angular.module('app.front').directive('researchEngineFilter', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {

        return {
            restrict: 'E',
            controller: 'researchEngineFilterController',
            controllerAs: 'researchEngineFilterController',
            templateUrl: 'app/main/globe_network/companies/filter/filter.html',
            scope: {
                modelType: '@',
                subTypeId: '=',
                onFilter: '&'
            }
        };

    }]);

})();

(function(){
    'use strict';

    angular.module('app.front').controller('researchEngineFilterController', researchEngineFilterController);

    function researchEngineFilterController($rootScope, $scope, $state, $translate, $mdDialog, $timeout, $filter, toastr, 
        companyService, modelService, ResearchPageCreationService, researchEngineFilterService) {
            
        window.mdSelectOnKeyDownOverride = function (event) {
            event.stopPropagation();
        };

        researchEngineFilterService.init();
        $scope.arrayFilters = [];
        $scope.actualFilter = {};

        ResearchPageCreationService.findFilter($scope.modelType, $scope.subTypeId, $translate.preferredLanguage()).then(function (resp) {

            $scope.actualFilter = resp.data;

            // Custom model field for filter
            angular.forEach(researchEngineFilterService.getCustomModelFieldFilterFn($scope.modelType), function(item, index) {
                $scope.actualFilter.fieldFilters.push(angular.copy(item));
            });
            
            // Custom fixe field for filter
            angular.forEach(researchEngineFilterService.getCustomFixeFieldFilterFn($scope.modelType), function(item, index) {
                $scope.actualFilter.fieldFilters.push(angular.copy(item));
            });

            // Fixe field libelle translation
            angular.forEach($scope.actualFilter.fieldFilters, function(item, index) {
                var _fixeFieldLibelle = null;
                if(item.fixeFieldFilterClazz == 'CompanyDisposition') {
                    _fixeFieldLibelle = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.' + item.fixeFieldFilterKeyLang;
                } else if(item.fieldFilterBaseType == "FIXE_FIELD" && !item.customFixeFieldFilter) {
                    _fixeFieldLibelle = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.' + item.fixeFieldFilterKeyLang;
                } else if(item.fieldFilterBaseType == "FIXE_FIELD" && item.customFixeFieldFilter) {
                    _fixeFieldLibelle = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.' + item.fixeFieldFilterKeyLangForTranslate;
                    item.fieldFilterIndex += 1000;
                } else if(item.fieldFilterBaseType == "MODEL_FIELD" && item.customModelFieldFilter) {
                    _fixeFieldLibelle = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.' + item.modelFieldFilterKeyLangForTanslate;
                } else if(item.fieldFilterBaseType == "MODEL_FIELD") {
                    item.libellePrefix = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.INPUT_PLACEHOLDER_PREFIX.' + item.modelType
                }
                if(_fixeFieldLibelle != null) {
                    item.libelle = angular.copy($filter('translate')(_fixeFieldLibelle));
                }
            });

            $scope.arrayFilters.push(angular.copy($scope.actualFilter));
            researchEngineFilterService.setFilter(angular.copy($scope.arrayFilters));

        }).catch(function (error) {
            console.log(error);
        });


        // Expand search
        $scope.expandSearchFn = function() {
            $scope.arrayFilters.push(angular.copy($scope.actualFilter));  
        };

        // Remove filter
        $scope.removeFilterFn = function($index) {
            $scope.arrayFilters.splice($index, 1);
        };

        // Filtre functions

        $scope.filterModelFn = function() {
            var modelFilters = { filters : [] };
            modelFilters.filters = angular.copy($scope.arrayFilters);
            $scope.onFilter({ filter : modelFilters } );
        };

        $scope.changeDate = function(filter) {
            if (filter != null && filter.dateTime != null){
                filter.criteria = $filter('date')(filter.dateTime, 'dd/MM/yyyy');
            }
        };

        $scope.changeDateRangeMin = function(filter, format) {
            if (filter != null && filter.fixedFieldFilter != null) {
                var _date = angular.copy(filter.minValue);
                _date.setHours(0, 1, 0, 0);
                if(format) {
                    filter.fixedFieldFilter.minValue = $filter('date')(_date, format);
                } else {
                    filter.fixedFieldFilter.minValue = angular.copy(_date.getTime());
                }
            }
        };

        $scope.changeDateRangeMax = function(filter, format) {
            if (filter != null && filter.fixedFieldFilter != null) {
                var _date = angular.copy(filter.maxValue);
                _date.setHours(23, 59, 0, 0);
                if(format) {
                    filter.fixedFieldFilter.maxValue = $filter('date')(_date, 'dd/MM/yyyy');
                } else {
                    filter.fixedFieldFilter.maxValue = angular.copy(_date.getTime());
                }
            }
        };
       
    }

})();
(function () {
  'use strict';

  angular.module('app.front').controller('companyLogsController', companyLogsController);

  function companyLogsController($rootScope, $scope, LOGS_ACTIONS, adminService, $state, $translate, $mdDialog, $timeout, $filter, toastr, companyService, modelService, researchEngineFilterService, researchEngineSortService, MODELS_TYPES) {
    $scope.logs = [];
    $scope.ACTIONS = LOGS_ACTIONS;
    $scope.allLoaded = false;

    var companyID = $state.params.id;
    var filter = {
      page: 0,
      output: 100
    };

    $scope.getLogs = function () {
      adminService.getByCompanyID(companyID, filter).then(function (res) {
        if (res.data) {
          $scope.logs = $scope.logs.concat(res.data);
        }
        if (res.data.length < 100) {
          $scope.allLoaded = true;
        } else {
          filter.page++;
        }
        console.log(res.data);
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.getLogs();

  }
})();

(function () {
	'use strict';

	angular.module('app.front').controller('DuplicationToolModalController', DuplicationToolModalController);

	function DuplicationToolModalController($rootScope, $scope, $mdDialog, $state, $filter, $translate, dtToolData, toastr, modelService, MODELS_TYPES) {

		$scope.MODELS_TYPES = MODELS_TYPES;
		$scope.initDataInProgress = false;

		if (dtToolData != null && dtToolData._modelType != null) {
			$scope._dtToolData = angular.copy(dtToolData);
			$scope._dtToolData._fields = [{}, {}];
			$scope.initDataInProgress = true;
			if ($scope._dtToolData._modelType == MODELS_TYPES.COMPANY_MODEL && $scope._dtToolData._modelSubTypeId != null) {
				modelService.listFieldsBySubType(
					MODELS_TYPES.COMPANY_MODEL,
					$scope._dtToolData._modelSubTypeId,
					$translate.preferredLanguage()
				).then(function (resp) {
					$scope.fields = $filter('filter')(resp.data, function (item) {
						return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
					});
					$scope.initDataInProgress = false;
				}).catch(function (err) {
					$scope.initDataInProgress = false;
					console.log(err)
				});
			} else if ($scope._dtToolData._modelType == MODELS_TYPES.CONTACT_MODEL) {
				modelService.listFieldsByType(
					MODELS_TYPES.CONTACT_MODEL,
					$translate.preferredLanguage()
				).then(function (resp) {
					$scope.fields = $filter('filter')(resp.data, function (item) {
						return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
					});
					$scope.initDataInProgress = false;
				}).catch(function (err) {
					$scope.initDataInProgress = false;
					console.log(err);
				});
			}
		} else {
			$scope.hidePopup();
		}

		// md-select input search
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.hidePopup = function () {
			$mdDialog.cancel();
		};

		$scope._lookForDuplicates = function (_form) {
			_form.$setSubmitted();
			if (_form.$valid) {
				var _fields = $scope._dtToolData._fields.filter(function (_field) {
					return _field.id != null
				});
				$state.go('app.duplication_tool', {
					_modelType: $scope._dtToolData._modelType,
					_modelSubTypeId: $scope._dtToolData._modelSubTypeId,
					_companyId: $scope._dtToolData._companyId,
					_modelPaginationDto: $scope._dtToolData._modelPaginationDto,
					_fields: _fields
				});
				$scope.hidePopup();
			}
		};

	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('logisticController', logisticController);

	function logisticController($rootScope, $scope, $state, $filter, $translate, $window, toastr, logisticService, inscriptionStatusService, inscriptionService, inscriptionSubCategoryService, logisticalStatusService, URL, DISPLAY_MODELS_ICONS) {

		$scope.generalInfosShowed = true;
		$scope.transportPlansShowed = true;
		$scope.alternatedocroots = URL.alternatedocroots;
		$scope.logistic = {};

		$scope.iconsDisplay = {};
		angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
			$scope.iconsDisplay[elt.name] = elt.value;
		});


		logisticService.get($state.params.logisticId, $translate.preferredLanguage(), true).then(function (response) {
			$scope.categories = angular.copy(response.data.categories);
			$scope.logistic = response.data;
			angular.forEach($scope.logistic.transportPlans, function (item, key) {
				$scope.logistic.transportPlans[key] = buildTransportPlan(item);
			});
		}).catch(function () {

		});

		$scope.modelType = 'LOGISTIC_MODEL';

		inscriptionStatusService.list($translate.preferredLanguage()).then(function (response) {
			$scope.inscriptionStatuses = response.data;
		}).catch(function () {

		});

		logisticalStatusService.list($translate.preferredLanguage()).then(function (response) {
			$scope.logisticStatus = response.data;
		}).catch(function () {

		});

		inscriptionSubCategoryService.list($translate.preferredLanguage()).then(function (response) {
			$scope.subCategories = response.data;
		}).catch(function () {

		});

		$scope.addTransportPlan = function () {
			$scope.transportPlansShowed = true;
			logisticService.addTransport($scope.logistic.id).then(function (response) {
				$scope.logistic.transportPlans.push(response.data);
			}).catch(function () {

			});
		};

		$scope.updateTransportPlan = function (plan) {
			var dto = angular.copy(plan);
			if (plan._arrivalDate != null) {
				dto.arrivalDate = $filter('date')(plan._arrivalDate, 'yyyy-MM-dd');
			}
			if (plan._arrivalTime != null) {
				dto.arrivalTime = $filter('date')(plan._arrivalTime, 'HH:mm');
			}
			if (plan._departureDate != null) {
				dto.departureDate = $filter('date')(plan._departureDate, 'yyyy-MM-dd');
			}
			if (plan._departureTime != null) {
				dto.departureTime = $filter('date')(plan._departureTime, 'HH:mm');
			}
			logisticService.updateTransport($scope.logistic.id, dto).then(function (response) {

			}).catch(function () {

			});
		};


		$scope.uploadTicket = function (plan) {
			var fmData = new FormData();
			var input = document.getElementById('ticket_' + plan.id);
			if (input != null && input.files != null) {
				fmData.append('file', input.files[0]);
				logisticService.uploadTicket($scope.logistic.id, plan.id, fmData).then(function (response) {
					for (var i = 0; i < $scope.logistic.transportPlans.length; i++) {
						if ($scope.logistic.transportPlans[i].id === plan.id) {
							$scope.logistic.transportPlans[i] = buildTransportPlan(response.data);
							break;
						}
					}
				}).catch(function () {

				});
			}
		};

		$scope.downloadTicket = function (planId) {
			$window.open(logisticService.downloadTicket($scope.logistic.id, planId));
		};

		$scope.deleteTransportPlan = function (planId) {
			logisticService.removeTransport($scope.logistic.id, planId).then(function (response) {
				for (var i = 0; i < $scope.logistic.transportPlans.length; i++) {
					if ($scope.logistic.transportPlans[i].id === planId) {
						$scope.logistic.transportPlans.splice(i, 1);
						break;
					}
				}
			}).catch(function () {

			});
		};

		$scope.openDeleteTransportPlan = function (planId) {
			var content = {
				title: $filter('translate')('LOGISTIC.DELETE_PLAN'),
				message: $filter('translate')('LOGISTIC.DELETE_PLAN_MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				$scope.deleteTransportPlan(planId);
			}).catch(function () {

			});
		};

		$scope.deleteTicket = function (planId) {
			logisticService.removeTicket($scope.logistic.id, planId).then(function (response) {
				for (var i = 0; i < $scope.logistic.transportPlans.length; i++) {
					if ($scope.logistic.transportPlans[i].id === planId) {
						$scope.logistic.transportPlans[i].ticketLocation = null;
						$scope.logistic.transportPlans[i].ticketOriginalName = null;
						break;
					}
				}
			}).catch(function () {

			});
		};

		$scope.openDeleteTicket = function (planId) {
			var content = {
				title: $filter('translate')('LOGISTIC.DELETE_TICKET'),
				message: $filter('translate')('LOGISTIC.DELETE_TICKET_MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				$scope.deleteTicket(planId);
			}).catch(function () {

			});
		};




		/* LIVE UPDATE */
		$scope.$on('modelUpdated', function (event, args) {
			if (args != null && args.model != null) {
				logisticService.updateField($scope.logistic.id, args.model).then(function (response) {
					// $scope.listSubscriptions();
					//refreshModelContact();
				}).catch(function (error) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(error);
				});
			}
		});
		$scope.changeInscriptionStatus = function () {
			inscriptionService.updateInscriptionStatus($scope.logistic.inscription.id, $scope.logistic.inscription.inscriptionStatus.id).then(function (response) {

			}).catch(function () {

			});
		};
		$scope.changeSubCategory = function () {
			inscriptionService.updateSubCategory($scope.logistic.inscription.id, $scope.logistic.inscription.subCategory.id).then(function (response) {

			}).catch(function () {

			});
		};

		$scope.changeLogisticStatus = function () {
			if ($scope.logistic.status != null) {
				logisticService.updateStatus($scope.logistic.id, $scope.logistic.status.id).then(function () {

				}).catch(function () {

				});
			}
		};

		function buildTransportPlan(plan) {
			var item = angular.copy(plan);
			if (item.departureDate != null) {
				item._departureDate = new Date(item.departureDate.year, item.departureDate.month - 1, item.departureDate.day);
			}
			if (item.arrivalDate != null) {
				item._arrivalDate = new Date(item.arrivalDate.year, item.arrivalDate.month - 1, item.arrivalDate.day);
			}
			if (item.departureTime != null) {
				item._departureTime = new Date(1970, 0, 1, item.departureTime.hour, item.departureTime.minute);
			}
			if (item.arrivalTime != null) {
				item._arrivalTime = new Date(1970, 0, 1, item.arrivalTime.hour, item.arrivalTime.minute);
			}
			return item;
		}

		$scope.onDeleteRegistration = function () {
			if ($scope.logistic && $scope.logistic.inscription && $scope.logistic.inscription.id) {
				var content = {
					title: $filter('translate')('LOGISTIC.DELETE_REGISTRATION'),
					message: $filter('translate')('LOGISTIC.DELETE_REGISTRATION_MESSAGE')
				};
				$rootScope.openConfirmPopup(content).then(function () {
					inscriptionService.deleteResgistration($scope.logistic.inscription.id).then(function (response) {
						toastr.success($filter('translate')('LOGISTIC.REGISTRATION_DELETED_SUCCEEDEED'));
						window.history.back();
					}, function (error) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}).catch(function () {

				});
			}
		};
	}
})();
(function () {
	'use strict';

	angular.module('app.front').service('contactService', contactService);

	function contactService($q, $http, $filter, $rootScope) {

		var BASE_URL_CONTACT = './api/rest/contact/';
		var FIRST_CATEGORY_INDEX = 1;

		var categories = null;
		var selectedModel = null;

		var service = {};

		service.buildModel = function (categories, contact, hideManagerFields) {
			$rootScope.buildingModel = true;
			var firstCategory = findFirstCategory(categories);
			for (var i = 0; i < firstCategory.values.length; i++) {
				var field = firstCategory.values[i];
				if (field.fixField) {
					if ((field.selectableObject == null || field.selectableObject.length < 1)) {
						field.value = contact[field.keyJava];
					} else {
						if (field.typeChamps === 'OBJECT') {
							field.value = setSelectedObject(field, contact);
						} else {
							field.value = setSelectedMultipleObject(field, contact);
						}
					}
				}
			}
			angular.forEach(categories, function (category, key) {
				for (var i = 0; i < category.values.length; i++) {
					var field = category.values[i];
					field.hidden = (!!hideManagerFields && !field.visibleByManager && contact.company != null
						&& contact.company.manager != null && contact.company.manager.id === $rootScope.user.id);
					if (field.typeChamps === 'LIST_SELECT') {
						field.value = setSelectedList(field);
					} else if (field.typeChamps === 'DATE') {
						if (field.value != null && field.value !== '') {
							field.dateTime = $filter('stringToDate')(field.value);
						}
					} else if (field.typeChamps === 'BOOLEAN') {
						field.value = 'true' === field.value;
					}
				}
				angular.forEach(category.subCategories, function (category, key) {
					for (var i = 0; i < category.values.length; i++) {
						var field = category.values[i];
						field.hidden = (!!hideManagerFields && !field.visibleByManager && contact.company != null
							&& contact.company.manager != null && contact.company.manager.id === $rootScope.user.id);
						if (field.typeChamps === 'LIST_SELECT') {
							field.value = setSelectedList(field);
						} else if (field.typeChamps === 'DATE') {
							if (field.value != null && field.value !== '') {
								field.dateTime = $filter('stringToDate')(field.value);
							}
						} else if (field.typeChamps === 'BOOLEAN') {
							field.value = 'true' === field.value;
						}
					}
				});
			});
			$rootScope.buildingModel = false;
			return categories;
		};

		/** Details */

		service.getSelectedModel = function (modelId, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + modelId,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					categories = null;
					selectedModel = response.data;
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.listContacts = function (companyId, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + 'company/' + companyId,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.listContactsDisplay = function (companyId, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + 'company/display/' + companyId,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.listContactsHidden = function (companyId, subTypeId, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + 'company/display/' + companyId,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
						'showHidden': true
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.getCategories = function (lang, modelId, hideManagerFields) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + 'categories/',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'id': modelId,
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					if (modelId != null) {
						categories = service.buildModel(response.data, selectedModel, hideManagerFields);
						resolve(categories);
					} else {
						resolve(response.data);
					}
				}).catch(function (response) {
					reject(response);
				});
			});
		};



		service.addModel = function (categories, newModel, companyId) {
			return $q(function (resolve, reject) {
				var fmData = new FormData();
				var internalSaveModel = function (_category) {
					if (angular.isArray(_category.subCategories) && _category.subCategories.length > 0) {
						angular.forEach(_category.subCategories, function (_subCategories) {
							internalSaveModel(_subCategories);
						});
					}
					angular.forEach(_category.values, function (item) {
						if (!item.fixField) {
							var valuedField = {
								idBaseField: item.id,
								id: item.idValue
							};
							if (item.typeChamps === 'BOOLEAN') {
								valuedField.value = '' + item.value;
							} else if (item.typeChamps === 'DATE') {
								if (item.dateTime != null) {
									valuedField.value = $filter('date')(item.dateTime, 'dd/MM/yyyy');
								}
							} else if (item.typeChamps === 'LIST_SELECT') {
								valuedField.listFieldId = item.value.id;
							} else if (item.typeChamps === 'MULTIPLE_SELECT') {
								valuedField.values = [];
								angular.forEach(item.values, function (objectSelected) {
									valuedField.values.push({
										id: objectSelected.id,
										libelle: objectSelected.libelle
									});
								});
							} else if (item.typeChamps === 'FILE' || item.typeChamps === 'IMAGE') {
								var input = document.getElementById('genericField_file_' + item.id + '_' + item.index);
								var file = null;
								if (input != null) {
									file = input.files[0];
								}
								fmData.append('file_' + valuedField.idBaseField, file);
							} else if (item.typeChamps === 'NUMBER' || item.typeChamps === 'INTEGER') {
								if ('null' === item.value) {
									valuedField.value = '';
								} else {
									valuedField.value = item.value;
								}
							} else {
								valuedField.value = item.value;
							}
							newModel.valuedFields.push(valuedField);
						} else {
							newModel[item.keyJava] = item.value;
						}
					});
				};
				newModel.valuedFields = [];

				angular.forEach(categories, function (_category) {
					internalSaveModel(_category);
				});

				fmData.append('modelDTO', angular.toJson(newModel));
				$http({
					url: BASE_URL_CONTACT + companyId,
					method: 'POST',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': undefined,
						'authorization': []
					},
					transformRequest: angular.identity,
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateField = function (id, dto) {
			return $q(function (resolve, reject) {
				if (!dto.fixField) {
					var fmData = new FormData();
					var valuedField = {
						idBaseField: dto.id,
						id: dto.idValue
					};
					if (dto.typeChamps === 'BOOLEAN') {
						valuedField.value = '' + dto.value;
					} else if (dto.typeChamps === 'DATE') {
						if (dto.dateTime != null) {
							valuedField.value = $filter('date')(dto.dateTime, 'dd/MM/yyyy');
						}
					} else if (dto.typeChamps === 'LIST_SELECT') {
						if (!!dto.value) {
							valuedField.listFieldId = dto.value.id;
						}
					} else if (dto.typeChamps === 'MULTIPLE_SELECT') {
						valuedField.values = [];
						angular.forEach(dto.values, function (objectSelected) {
							valuedField.values.push({
								id: objectSelected.id,
								libelle: objectSelected.libelle
							});
						});
					} else if (dto.typeChamps === 'FILE' || dto.typeChamps === 'IMAGE') {
						var input = document.getElementById('genericField_file_' + dto.id + '_' + dto.index);
						var file = null;
						if (input != null) {
							file = input.files[0];
						}
						fmData.append('file', file);
					} else if (dto.typeChamps === 'NUMBER' || dto.typeChamps === 'INTEGER') {
						if ('null' === dto.value) {
							valuedField.value = '';
						} else {
							valuedField.value = dto.value;
						}
					} else {
						valuedField.value = dto.value;
					}
					fmData.append('modelDTO', angular.toJson(valuedField));
					$http({
						url: BASE_URL_CONTACT + id + '/field',
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': undefined,
							'authorization': []
						},
						data: fmData
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				}
			});
		};

		service.downloadValuedFile = function (fieldId) {
			var url = BASE_URL_CONTACT + 'download/' + fieldId + '/' + selectedModel.id;
			return url;
		};

		service.setActivated = function (id, activated) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + id + '/activate',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'active': activated
					},
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.setChecked = function (id, checked) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + id + '/checked',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'checked': checked
					},
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.deleteModel = function (id, toDelete) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime(),
						'delete': toDelete
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.move = function (id, companyId) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + id + '/move/' + companyId,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.copy = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_CONTACT + id + '/copy',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		function findFirstCategory(categories) {
			var found = false;
			var index = 0;
			while (!found && index < categories.length) {
				var category = categories[index];
				if (category.index === FIRST_CATEGORY_INDEX) {
					return category;
				}
				index++;
			}
		}

		function setSelectedList(field) {
			var valueReturned = null;
			if (field.listFieldId) {
				for (var k = 0; k < field.listFieldsDTO.length; k++) {
					if (field.listFieldId === field.listFieldsDTO[k].id) {
						valueReturned = field.listFieldsDTO[k];
					}
				}
			}
			return valueReturned;
		}

		function setSelectedObject(field, data) {
			var valueReturned = null;
			if (data[field.keyJava]) {
				for (var k = 0; k < field.selectableObject.length; k++) {
					if (data[field.keyJava].id === field.selectableObject[k].id) {
						valueReturned = field.selectableObject[k];
					}
				}
			}
			return valueReturned;
		}

		function setSelectedMultipleObject(field, data) {
			var values = [];
			if (data[field.keyJava]) {
				for (var l = 0; l < data[field.keyJava].length; l++) {
					for (var k = 0; k < field.selectableObject.length; k++) {
						if (data[field.keyJava][l].id === field.selectableObject[k].id) {
							values.push(field.selectableObject[k]);
						}
					}
				}
			}
			return values;
		}

		return service;
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('contactController', contactController);

	function contactController($rootScope, DISPLAY_MODELS_ICONS, $scope, $filter, $state, $q, $translate, $mdDialog, toastr, contactService, companyService, userService, eventService, inscriptionService,
		SettingsMessageService, STORAGE_PREFIX, MessageService, MODELS_TYPES, DuplicationToolService) {
		$scope.userService = userService;
		userService.getCurrent($translate.preferredLanguage(), false).then(function (response) {
			$scope.showSettings = userService.containsRole('CONTACT_SETTINGS');
		}).catch(function () {

		});
		$scope.companyId = $state.params.id;
		$scope.id = $state.params.contactId;
		$scope.subTypeId = $state.params.subType;
		$scope.modelType = 'CONTACT_MODEL';
		$scope.logsShowed = false;

		$scope.iconsDisplay = {};
		angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
			$scope.iconsDisplay[elt.name] = elt.value;
		});

		$scope.users = [];
		$scope.actions = [];
		$scope.contacts = [];
		$scope.companyIdCopy;
		$scope.message = {
			actionForm: null,
			receiverForm: null
		};
		$scope.filter = {
			sender: null,
			action: null
		};
		$scope.messages = [];
		$scope.typeAction = {
			ALL: 'ALL',
			TO_DO: 'TO_DO',
			DONE: 'DONE'
		};
		$scope.searchText = '';
		$scope.showForm = false;
		$scope.showRegistrations = false;
		$scope.init = false;

		var timeoutCanceler = $q.defer();

		// $scope.searchCompany = function () {
		//   companyService.filterByString('BON').then(function (res) {
		//     console.log(res.data);
		//   }).catch(function (err) {
		//     toastr.error('Erreur lors de la récupération des résultats de la recherche');
		//     console.log(err);
		//   });
		// };
		// $scope.searchCompany();


		if ($scope.id != null && $scope.companyId != null && $scope.subTypeId != null) {
			companyService.getSelectedModelDisplay($scope.companyId, $scope.subTypeId).then(function (response) {
				$scope.company = response.data;
				putContactFavFirst();
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});

			refreshModelContact();

			$scope.refreshContacts = function () {
				contactService.listContactsDisplay($scope.companyId, $translate.preferredLanguage()).then(function (response) {
					$scope.contacts = response.data;
					putContactFavFirst();
				}).catch(function (response) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(response);
				});
			};
			$scope.refreshContacts();

		} else if ($scope.companyId != null && $scope.subTypeId != null) {
			$state.go('app.companies.details', {
				subType: $scope.subTypeId,
				id: $scope.companyId
			});
		} else {
			$state.go('app.home');
		}

		// companyService.findAll($translate.preferredLanguage()).then(function (response) {
		// 	$scope.companies = response.data;
		// }).catch(function (response) {
		// 	toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		// 	console.log(response);
		// });

		$scope.showDeleteContact = function (toDelete) {
			var content = null;
			if (toDelete) {
				content = {
					title: $filter('translate')('CONTACTS.DELETE'),
					message: $filter('translate')('CONTACTS.CONFIRM_DELETE')
				};
			} else {
				content = {
					title: $filter('translate')('CONTACTS.CANCEL_DELETE'),
					message: $filter('translate')('CONTACTS.CONFIRM_CANCEL_DELETE')
				};
			}
			$rootScope.openConfirmPopup(content).then(function () {
				contactService.deleteModel($scope.selectedContact.id, toDelete).then(function (response) {
					if (toDelete) {
						$state.go('app.companies.details', {
							subType: $scope.subTypeId,
							id: $scope.companyId
						});
					} else {
						for (var i = 0; i < $scope.contacts.length; i++) {
							if ($scope.contacts[i].id === $scope.selectedContact.id) {
								$scope.contacts[i].deleted = toDelete;
								break;
							}
						}
						$scope.selectedContact.deleted = toDelete;
					}
				}).catch(function (response) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(response);
				});
			}).catch(function () {

			});
		};

		$scope.detailsContact = function (id) {
			$state.go('app.companies.details.contact', {
				contactId: id
			});
		};

		$scope.setPrincipal = function () {
			companyService.setPrincipal($scope.id).then(function (response) {
				$scope.company.favouriteId = angular.copy(parseInt($scope.id));
				for (var i = 0; $scope.contacts.length; i++) {
					if ($scope.contacts[i].id === parseInt($scope.id)) {
						var contact = angular.copy($scope.contacts[i]);
						$scope.contacts.splice(i, 1);
						$scope.contacts.unshift(contact);
						break;
					}
				}
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});
		};

		/* DEPLACER SOCIETE */

		$scope.openMove = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/contacts/popup/move_contact.html',
				preserveScope: true,
				scope: $scope,
				clickOutsideToClose: true
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.printCompany = function (item) {
			if (item != null) {
				var result = item.modelPattern;
				if (item.subTypes != null && item.subTypes.length > 0) {
					result += ' (';
					for (var i = 0; i < item.subTypes.length; i++) {
						result += item.subTypes[i].name;
						if (i < item.subTypes.length - 1) {
							result += ' ';
						}
					}
					result += ')';
				}
				$scope.resultCopy = item;
				return result;
			} else {
				return '';
			}

		};

		$scope.searchCompany = function (text) {
			if (timeoutCanceler != null) {
				timeoutCanceler.resolve();
			}
			timeoutCanceler = $q.defer();
			return companyService.filterByString(text, null, $translate.preferredLanguage(), timeoutCanceler, null).then(function (res) {
				return res.data;
			}).catch(function (err) {
				if (err.status === 500) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}
				return [];
			});
		};

		$scope.moveContact = function () {
			contactService.move($scope.selectedContact.id, $scope.contact.company != null ? $scope.contact.company.id : $scope.companyIdCopy).then(function (response) {
				$mdDialog.hide();
				$state.go('app.companies.details', {
					id: $scope.companyId,
					subType: $scope.subTypeId
				});
			}).catch(function (response) {
				console.log(response);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.selectedItemChange = function (company) {
			$scope.companyIdCopy = company ? company.id : '';
			if ($scope.companyIdCopy) {
				$scope.disabled = true;
				$scope.buttonDisabled = false;
			}
		}

		$scope.modifyContact = function () {
			$scope.disabled = !$scope.disabled;
			$scope.searchText = '';
			$scope.buttonDisabled = true;
		}

		/* DEPLACER SOCIETE */

		/* COPIE SOCIETE */
		$scope.openCopy = function () {
			var content = {
				title: $filter('translate')('CONTACTS.COPY'),
				message: $filter('translate')('CONTACTS.COPY_CONFIRM')
			};

			$rootScope.openConfirmPopup(content).then(function () {
				contactService.copy($scope.id).then(function () {
					toastr.success($filter('translate')('CONTACTS.COPY_SUCCESS'));
					$scope.refreshContacts();
				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(response);
				});
			}).catch(function () {

			});
		};




		$scope.setActivated = function (id, activate) {
			contactService.setActivated(id, activate).then(function () {
				for (var i = 0; i < $scope.contacts.length; i++) {
					if ($scope.contacts[i].id === parseInt(id)) {
						$scope.contacts[i].activate = activate;
						break;
					}
				}
				if ($scope.selectedContact.id === parseInt(id)) {
					$scope.selectedContact.activate = activate;
				}
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});
		};

		$scope.$on('activatedUpdated', function (event, args) {
			$scope.setActivated($scope.id, args.model.activate);
		});

		$scope.$on('checkedUpdated', function (event, args) {
			contactService.setChecked($scope.id, args.model.checked).then(function () { }).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});
		});
		/* LIVE UPDATE */

		/* Company */

		$scope.backToCompany = function () {
			$state.go('app.companies.details', {
				id: $scope.companyId,
				subType: $scope.subTypeId
			});
		};

		$scope.setCompanyActivated = function (id, activate) {
			companyService.setActivated(id, activate).then(function (response) {

			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});
		};



		//MESSAGES
		$scope.findAllUsers = function () {
			userService.findAllUsers().then(function (users) {
				$scope.users = users.data;
			}).catch(function (data) {

			});
		};

		$scope.findAllUsers();

		$scope.findAllActions = function () {
			SettingsMessageService.findAllAction(localStorage[STORAGE_PREFIX + 'language']).then(function (actions) {
				$scope.actions = actions.data;
			}).catch(function (data) {

			});
		};

		$scope.findAllActions();

		$scope.cancelFormMessage = function () {
			$scope.message = {
				actionForm: null,
				receiverForm: null
			};
			$mdDialog.hide();
		};

		$scope.saveMessage = function () {
			if ($scope.message.actionForm != null) {
				$scope.message.dateAction = moment($scope.message.startDateForm).set('hours', $scope.message.startTime.split(':')[0]).set('minutes', $scope.message.startTime.split(':')[1]).toDate().getTime();
				if (!$scope.message.actionDone) {
					$scope.message.actionDone = false;
				}
				$scope.message.action = angular.fromJson($scope.message.actionForm);
			}

			if ($scope.message.receiverForm != null && $scope.message.receiverForm != "null") {
				$scope.message.receiver = angular.fromJson($scope.message.receiverForm);
				$scope.message.receiverID = angular.fromJson($scope.message.receiverForm).id;
			} else {
				$scope.message.receiverID = null;
			}
			$scope.message.contactId = $scope.id;
			MessageService.saveMessage($scope.message).then(function (data) {
				$scope.findAllMessages();
				$scope.cancelFormMessage();
				$mdDialog.hide();
			}).catch(function (data) {

			});
		};

		$scope.findAllMessages = function () {
			switch ($scope.filter.action) {
				case null:
					delete $scope.filter.actionToDo;
					$scope.filter.actionExist = false;
					break;
				case $scope.typeAction.ALL:
					delete $scope.filter.actionToDo;
					$scope.filter.actionExist = true;
					break;
				case $scope.typeAction.DONE:
					$scope.filter.actionToDo = false;
					break;
				case $scope.typeAction.TO_DO:
					$scope.filter.actionToDo = true;
					break;
				default:
					break;
			}
			$scope.filter.addressee = [];
			angular.forEach($scope.filter.receiverForm, function (item, key) {
				$scope.filter.addressee.push(angular.fromJson(item));
			});
			$scope.filter.contactId = $scope.id;
			MessageService.findAllMessage($scope.filter, localStorage[STORAGE_PREFIX + 'language']).then(function (messages) {
				$scope.messages = messages.data;
			}).catch(function (data) {

			});
		};
		$scope.findAllMessages();

		$scope.getDate = function (date) {
			return moment(date).toDate();
		};


		$scope.confirmAction = function (action) {
			var content = {
				title: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL_TITLE') : $filter('translate')('MESSAGE.ACTION_CONFIRM_TITLE'),
				message: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL') : $filter('translate')('MESSAGE.ACTION_CONFIRM')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				action.actionDone = !action.actionDone;
				MessageService.confirmAction(action).then(function (data) { }).catch(function (data) { });
			}).catch(function () {

			});
		};

		$scope.showPopUpMessage = function () {
			$scope.message = {
				actionForm: null,
				receiverForm: null
			};

			for (var i = 0; i < $scope.users.length; i++) {
				if ($scope.users[i].id === $rootScope.user.id) {
					$scope.message.receiverForm = angular.toJson($scope.users[i]);
					break;
				}
			}

			var now = new Date();
			$scope.message.startDateForm = now;
			$scope.message.startTime = (now.getHours() < 10 ? '0' + now.getHours() : now.getHours()) + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());

			$mdDialog.show({
				templateUrl: 'app/main/message/popup/update_message.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.openAddContact = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/contacts/popup/add_contact.html',
				clickOutsideToClose: true,
				controller: 'addContactCtrl',
				locals: {
					companyId: parseInt($scope.companyId)
				}
			}).then(function () {
				$scope.refreshContacts();
			}).catch(function () {


			});
		};

		function refreshModelContact() {
			contactService.getSelectedModel($scope.id, $translate.preferredLanguage()).then(function (response) {
				$scope.selectedContact = response.data;
				$scope.selectedContact.companyId = parseInt(angular.copy($scope.companyId));
				contactService.getCategories($translate.preferredLanguage(), $scope.id, true).then(function (data) {
					$scope.categories = data;
					if (!$scope.init) {
						$scope.init = true;
						/* LIVE UPDATE */
						$scope.$on('modelUpdated', function (event, args) {
							contactService.updateField($scope.id, args.model).then(function (response) {
								$scope.refreshContacts();
								//refreshModelContact();
							}).catch(function (error) {
								toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
								console.log(error);
							});
						});

					}
				}).catch(function () {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(response);
				});
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});
		}

		$scope.setContactActivated = function (id, activate) {
			contactService.setActivated(id, activate).then(function (response) {
				$scope.refreshContacts();
				$scope.hiddenContact = false;
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(response);
			});
		};

		$scope.showMoreContacts = function () {
			contactService.listContactsHidden($scope.companyId, $translate.preferredLanguage()).then(function (response) {
				$scope.hiddenContact = true;
				$scope.contacts = $scope.contacts.concat(response.data);
			}).catch(function (response) {

			});
		};


		$scope.hideMoreContacts = function () {
			contactService.listContactsHidden($scope.companyId, $translate.preferredLanguage()).then(function (response) {
				$scope.hiddenContact = false;
				$scope.contacts = $scope.contacts.filter(function (el) {
					return $filter("filter")(response.data, {
						id: el.id
					}).length == 0;
				})
			}).catch(function (response) {

			});
		};

		$scope.updateMessage = function (message) {
			$scope.message = angular.copy(message);
			// $scope.message.receiverForm = angular.copy(angular.toJson(msg.receiver).toString());
			// console.log($scope.message);
			if (message.action != null) {
				var actionID = angular.copy(message.action.actionID);
				angular.forEach($scope.actions, function (action) {
					if (action.id === actionID) {
						$scope.message.actionForm = angular.toJson(action);
					}
				});
			} else {
				$scope.message.actionForm = null;
			}

			if (message.receiver != null) {
				var receiverID = angular.copy(message.receiver.id);
				angular.forEach($scope.users, function (user) {
					if (user.id === receiverID) {
						$scope.message.receiverForm = angular.toJson(user);
					}
				});
			} else {
				$scope.message.receiverForm = 'null';
			}

			if (message.action != null && message.action.dateAction != null) {
				var date = new Date(message.action.dateAction);

				$scope.message.startDateForm = date;
				$scope.message.startTime = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
			} else {
				var now = new Date();
				$scope.message.startDateForm = now;
				$scope.message.startTime = (now.getHours() < 10 ? '0' + now.getHours() : now.getHours()) + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());
			}

			$mdDialog.show({
				templateUrl: 'app/main/message/popup/update_message.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.showLogs = function () {
			$scope.logsShowed = !$scope.logsShowed;
		};

		function putContactFavFirst() {
			if ($scope.contacts.length > 0 && $scope.company && $scope.company.favouriteId) {
				for (var i = 0; i < $scope.contacts.length; i++) {
					var contact = angular.copy($scope.contacts[i]);
					if (contact.id === $scope.company.favouriteId) {
						$scope.contacts.splice(i, 1);
						$scope.contacts.unshift(contact);
					}
				}
			}
		}

		// Outils de duplication
		$scope._lookForContactDuplicates = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/duplication_tool/duplication_tool_modal.html',
				clickOutsideToClose: true,
				controller: 'DuplicationToolModalController',
				locals: {
					dtToolData: {
						_modelType: MODELS_TYPES.CONTACT_MODEL,
						_modelSubTypeId: parseInt($scope.subTypeId),
						_companyId: $scope.companyId
					}
				}
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope._contactDuplicatesAutoMergeFn = function () {
			$scope._mdProgressLinear = true;
			DuplicationToolService._autoMergeDuplicatesModel(MODELS_TYPES.CONTACT_MODEL, null, $scope.companyId).then(function (response) {
				if (!JSON.parse(response.data)) {
					toastr.error($filter('translate')('DUPLICATION_TOOL.ANY_OCCURENCE_FOUND'));
				} else {
					$scope.backToCompany();
					toastr.success($filter('translate')('DUPLICATION_TOOL.MERGE.MERGE_ACTION_SUCCESS'));
				}
				$scope._mdProgressLinear = false;
			}).catch(function (error) {
				console.log(error);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$scope._mdProgressLinear = false;
			});
		};

		/* Subscription */

		$scope.setStatusStyle = function (status) {
			if (status != null && status.color != null) {
				return {
					'background-color': status.color,
					'color': 'white',
					'font-weight': 600
				};
			} else {
				return {
					'font-weight': 600
				};
			}
		};

		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};
		$scope.event = {};
		$scope.openSubscribe = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/contacts/popup/subscribe.html',
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.listSubscriptions = function () {
			inscriptionService.list($scope.id, $translate.preferredLanguage()).then(function (response) {
				$scope.inscriptions = response.data;
				var _inscriptionFound = false;
				angular.forEach($scope.inscriptions, function (item, key) {
					$scope.inscriptions[key].categories = inscriptionService.buildModel(angular.copy(item.categories), item, true);

					// Target inscription from isncriptions list
					if (!_inscriptionFound && $state.params.inscriptionId && item.id === $state.params.inscriptionId) {
						item._showDetails = true;
						_inscriptionFound = true;
					}
				});
			}).catch(function () {

			});
		};

		$scope.subscribe = function () {
			if ($scope.event != null) {
				inscriptionService.save($scope.id, $scope.event.id).then(function (response) {
					$mdDialog.hide();
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_CREATE'));
					$scope.refreshEvents();
					$scope.listSubscriptions();
				}).catch(function (response) {
					if (response.status === 409) {
						toastr.error($filter('translate')('INSCRIPTION.ERROR_SAVE_409'));
					} else if (response.status === 404) {
						toastr.error($filter('translate')('INSCRIPTION.ERROR_SAVE_404'));
					} else {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					}
				});
			}
		};

		$scope.refreshEvents = function () {
			eventService.listNotSubscribed($scope.id).then(function (response) {
				$scope.events = response.data;
			}).catch(function () {

			});
		};
		$scope.listSubscriptions();
		$scope.refreshEvents();

		/* LIVE UPDATE */
		$scope.$on('inscriptionUpdated', function (event, args) {
			inscriptionService.updateField(args.inscription.id, args.model).then(function (response) {
				// $scope.listSubscriptions();
				//refreshModelContact();
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(error);
			});
		});
		$scope.$on('inscriptionStatusUpdated', function (event, args) {
			inscriptionService.updateInscriptionStatus(args.model.id, args.model.inscriptionStatus.id).then(function (response) {

			}).catch(function () {

			});
		});
		$scope.$on('subCategoryUpdated', function (event, args) {
			inscriptionService.updateSubCategory(args.model.id, args.model.subCategory.id).then(function (response) {

			}).catch(function () {

			});
		});
		$scope.$on('logisticalStatusUpdated', function (event, args) {
			inscriptionService.updateLogisticalStatus(args.model.id, args.model.logistic.id).then(function (response) {

			}).catch(function () {

			});
		});

		$scope.goToLogistics = function (logisticId) {
			$state.go('app.companies.details.contact.logistic', {
				logisticId: logisticId
			});
		};
		/*
		 * Mailing
		 */
		$scope._mailingDialogOpenFn = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/mailing/mailing_modal.html',
				clickOutsideToClose: false,
				controller: 'MailingModalController',
				locals: {
					data: {
						modelType: MODELS_TYPES.CONTACT_MODEL,
						modelSubTypeId: $scope.subTypeId,
						contactId: $scope.id,
						filter: null
					}
				}
			}).then(function () { }).catch(function () { });
		};

		$scope.checkMyProfileOnline = function () {
			window.open(" https://www.leisure-in-lebanon.com/leisure/provider?param1=" + $scope.companyId, "blank");
		};

	}

})();

(function(){
	'use strict';

	angular.module('app.front').controller('inscriptionFormsController', inscriptionFormsController);

	function inscriptionFormsController($rootScope, $scope, $state, $translate, $mdDialog, $filter, toastr, inscriptionFormService){

		$scope.refresh = function(){
			if ($state.params.id != null){
				inscriptionFormService.listByEvent($state.params.id, $translate.preferredLanguage()).then(function(response){
					$scope.forms = response.data;
				}).catch(function(){
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}
		};

		$scope.refresh();

		$scope.showPopUpDelete = function(form){
			var content = {
				title: $filter('translate')('INSCRIPTION_FORMS.DELETE_TITLE'),
				message: $filter('translate')('INSCRIPTION_FORMS.DELETE_MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				inscriptionFormService.remove(form.id, $state.params.id).then(function(){
					$scope.refresh();
				}).catch(function(){
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(function(){

			});
		};

		$scope.update = function(form){
			$mdDialog.show({
				templateUrl: 'app/main/events/inscriptions/forms/popup/add_form.html',
				controller: 'addInscriptionFormController',
				clickOutsideToClose : true,
				locals: {
					eventId: $state.params.id,
					form: form
				}
			}).then(function(response){
				$scope.refresh();
			}).catch(function(){

			});
		};

		$scope.details = function(form){
			$state.go('app.events.inscriptionFields', {id: $state.params.id, formId: form.id});
		};

		$scope.openAdd = function(){
			$mdDialog.show({
				templateUrl: 'app/main/events/inscriptions/forms/popup/add_form.html',
				controller: 'addInscriptionFormController',
				clickOutsideToClose : true,
				locals: {
					eventId: $state.params.id,
					form: null
				}
			}).then(function(response){
				$state.go('app.events.inscriptionFields', {id: $state.params.id, formId : response.data});
			}).catch(function(){

			});
		};
	}
})();
(function(){
	'use strict';

	angular.module('app.front').service('inscriptionFormService', inscriptionFormService);

	function inscriptionFormService($http, $q){
		var service = {};

		service.save = function(dto){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form',
					method: 'POST',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					data: dto,
					params: {'_v': new Date().getTime()}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.remove = function(id, eventId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id,
					method: 'DELETE',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'eventId': eventId}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.list = function(lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form',
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.listByEvent = function(eventId, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/event/' + eventId,
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.findById = function(id, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/' + id,
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.addField = function(id, page, dto, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id+'/field',
					method: 'POST',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					data: dto,
					params: {'_v': new Date().getTime(), 'lang': lang, 'page': page}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.updateField = function(id, dto, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id+'/field',
					method: 'PUT',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					data: dto,
					params: {'_v': new Date().getTime(), 'lang': lang}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.removeField = function(id, fieldId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id+'/field/'+fieldId,
					method: 'DELETE',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime()}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.upField = function(id, fieldId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id+'/field/up/'+fieldId,
					method: 'PUT',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime()}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.downField = function(id, fieldId){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id+'/field/down/'+fieldId,
					method: 'PUT',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime()}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.listFields = function(id, page, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/'+id+'/field',
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang, 'page': page}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.listAllFields = function(lang, removeDuplicatesField){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-form/field/all',
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang, 'removeDuplicatesField': removeDuplicatesField}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		/* PUBLIC SITES */

		service.publicFindById = function(id, inscriptionNumber, lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/public/sitegen/inscription-form/' + id,
					method: 'GET',
					headers: {'Content-Type': 'application/json;charset=utf-8'},
					params: {'_v': new Date().getTime(), 'lang': lang, 'inscriptionNumber': inscriptionNumber}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		return service;
	}
})();
(function () {
	'use strict';

	angular.module('app.front').controller('inscriptionFieldsController', inscriptionFieldsController);

	function inscriptionFieldsController($rootScope, $scope, $state, $filter, $translate, $mdDialog, toastr, languageService, inscriptionFormService, modelService, TYPES_INSCRIPTION_FIELD, MODEL_TYPES) {
		var companyFields = null;
		var contactFields = null;
		var eventFields = null;
		var logisticFields = null;
		$scope.language = {};
		$scope.typeFields = TYPES_INSCRIPTION_FIELD;
		$scope.newField1 = {
			typeField: 'FIELD',
			column: 1
		};
		$scope.newField2 = {
			typeField: 'FIELD',
			column: 2
		};
		
		$scope.modelTypes = MODEL_TYPES;
		$scope.pagination = {page: 1};
		$scope.conditionalFields = [];

		$scope.refreshFields = function(){
			$scope.loaded = false;
			inscriptionFormService.listFields($state.params.formId, $scope.pagination.page, $scope.language.key).then(function(response){
				$scope.inscriptionFields = response.data;
				$scope.copyInscriptionFields = angular.copy(response.data);
				if($scope.pagination.page === 1) {
					$scope.conditionalFields = [];
				}
				angular.forEach($scope.inscriptionFields, function(item, key){
					if (item.typeField === 'FIELD'){
						$scope.getFields($scope.inscriptionFields[key]);
						if (item.field != null && (item.field.typeChamps === 'LIST_SELECT' || item.field.typeChamps === 'MULTIPLE_SELECT')){
							var _index = $scope.conditionalFields.map(function(_field) {
								return _field.id;
							}).indexOf(item.field.id);
							if(_index === -1) {
								$scope.conditionalFields.push(angular.copy(item));
							}
						}
					}
				});
			}).catch(function(){
				
			});
		};
		
		$scope.refresh = function(){
			if ($state.params.formId != null){
				inscriptionFormService.findById($state.params.formId, $scope.language.key).then(function(response){
					$scope.form = response.data;
				}).catch(function(response){
					
				});
			}
			$scope.refreshFields();
		};
		$scope.refresh();

		$scope.addItem = function(column, form){
			inscriptionFormService.addField($state.params.formId, $scope.pagination.page, $scope['newField'+column], $scope.language.key).then(function(response){
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_CREATE'));
				$scope.refresh($scope.language.key);
				$scope['newField'+column] = {
					typeField: 'FIELD',
					column: column
				};
				$scope.getFields($scope['newField'+column]);
				form.$setPristine();
				form.$setUntouched();
			}).catch(function(response){

			});
		};

		$scope.getFields = function(newField){
			if (newField.modelType === 'COMPANY_MODEL'){
				if (companyFields != null){
					newField.fields = angular.copy(companyFields);
				}else{
					modelService.listFieldsBySubType(newField.modelType, $scope.form.subtype.id, $translate.preferredLanguage()).then(function(response){
						companyFields = angular.copy(response.data);
						newField.fields = response.data;
					}).catch(function(response){
	
					});
				}
			}else if (newField.modelType === 'CONTACT_MODEL'){
				if (contactFields != null){
					newField.fields = angular.copy(contactFields);
				}else{
					modelService.listFieldsByType(newField.modelType, $translate.preferredLanguage()).then(function(response){
						contactFields = angular.copy(response.data);
						newField.fields = response.data;
					}).catch(function(response){
	
					});
				}

			}else if (newField.modelType === 'INSCRIPTION_MODEL'){
				if (eventFields != null){
					newField.fields = angular.copy(eventFields);
				}else{
					modelService.listFieldsByType(newField.modelType, $translate.preferredLanguage(), $state.params.id).then(function(response){
						eventFields = angular.copy(response.data);
						newField.fields = response.data;
					}).catch(function(response){
						
					});
				}
			}else if (newField.modelType === 'LOGISTIC_MODEL'){
				if (logisticFields != null){
					newField.fields = angular.copy(logisticFields);
				}else{
					modelService.listFieldsByType(newField.modelType, $translate.preferredLanguage(), $state.params.id).then(function(response){
						logisticFields = angular.copy(response.data);
						newField.fields = response.data;
					}).catch(function(response){
						
					});
				}
			}
		};
		$scope.getFields($scope.newField1);
		$scope.getFields($scope.newField2);
		
		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.refresh();
			});
		}).catch(function (error) {

		});

		$scope.updateField = function(field){
			inscriptionFormService.updateField($state.params.formId, field, $scope.language.key).then(function(response){
				for (var i = 0; i < $scope.inscriptionFields.length; i++){
					if ($scope.inscriptionFields[i].id === response.data.id){
						$scope.inscriptionFields[i] = response.data;
						$scope.getFields($scope.inscriptionFields[i]);
						break;
					}
				}
			}).catch(function(){

			});
		};

		$scope.removeField = function(field, index){
			var content = {
				title: $filter('translate')('INSCRIPTION_FORMS.FIELDS.DELETE_TITLE'),
				message: $filter('translate')('INSCRIPTION_FORMS.FIELDS.DELETE_MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				inscriptionFormService.removeField($state.params.formId, field.id).then(function(){
					$scope.refresh($scope.language.key);
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_DELETE'));
				}).catch(function(){
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(function(){});
		};

		$scope.up =function(field){
			inscriptionFormService.upField($state.params.formId, field.id).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.down =function(field){
			inscriptionFormService.downField($state.params.formId, field.id).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.enabledFieldUpdating = function(field){
			field.active = true;
		};

		$scope.cancelFieldUpdating = function(field, index, form){
			for (var i = 0; i < $scope.copyInscriptionFields.length; i++){
				if (field.id === $scope.copyInscriptionFields[i].id){

					$scope.inscriptionFields[i] = angular.copy($scope.copyInscriptionFields[i]);
					$scope.getFields($scope.inscriptionFields[i]);
					break;
				}
			}
		};

		$scope.openConditional = function(field){
			$scope.field = angular.copy(field);
			$mdDialog.show({
				templateUrl: 'app/main/events/inscriptions/forms/popup/condition.html',
				preserveScope: true,
				scope: $scope,
				clickOutsideToClose: true
			}).then(function(){
			
			}).catch(function(){

			});
		};

		$scope.saveCondition = function(){
			inscriptionFormService.updateField($state.params.formId, $scope.field, $scope.language.key).then(function(response){
				for (var i = 0; i < $scope.inscriptionFields.length; i++){
					if ($scope.inscriptionFields[i].id === response.data.id){
						$scope.inscriptionFields[i] = response.data;
						$scope.getFields($scope.inscriptionFields[i]);
						$mdDialog.hide();
						break;
					}
				}
			}).catch(function(){

			});
		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};
	}
})();

(function () {
    'use strict';

    angular.module('app.front').controller('JunkBoxDetailsController', JunkBoxDetailsController);

    function JunkBoxDetailsController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, $element, toastr, MODELS_TYPES, 
            modelService, DuplicationToolService) {

        $scope.loaded = true;
        $scope.modelType = "LOGISTIC_MODEL";
        
        function onInit() {         
            DuplicationToolService._junkBoxDetails($state.params.id, $translate.preferredLanguage()).then(function (response) {
                $scope.model = response.data.model;
                $scope.categories = response.data.categories;
                $scope.loaded = false;
            }).catch(function (response) {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                $scope.loaded = false;
            });
        }

        onInit();
        
    }
    
})();
(function () {
	'use strict';

	angular.module('app.front').controller('editUserController', editUserController);

	function editUserController($rootScope, $translate, $scope, $filter, $mdDialog, user, URL, toastr, userService, groupService, roleService, modelService, eventService) {
		$scope.user = angular.copy(user);
		$scope.user.rights.forEach(function (role) {
			role.nameTranslated = $filter('translate')('ROLES.' + role.name);
		});
		if (!$scope.user.seeInactiveContact) {
			$scope.user.seeInactiveContact = false;
		}
		if (user.pictureLocation != null) {
			$scope.user.src = URL.alternatedocroots + '/' + user.pictureLocation;
		}

		$scope.search = '';

		$scope.roles = [];
		$scope.events = [];
		$scope.companySubTypes = [];
		var modelType = 'COMPANY_MODEL';
		var baseUrl = './api/rest/model/' + modelType;

		roleService.find().then(function (response) {
			$scope.roles = response.data;
			$scope.roles.forEach(function (role) {
				role.nameTranslated = $filter('translate')('ROLES.' + role.name);
			});
		}).catch(function () {

		});
		modelService.getSubTypes(baseUrl, $translate.preferredLanguage(), null).then(function (response) {
			$scope.companySubTypes = response.data;
		}).catch(function () {

		});

		eventService.findAll().then(function (response) {
			$scope.events = response.data;
		}).catch(function () {

		});

		$scope.allEventsChanged = function () {
			if ($scope.user.allEvents) {
				$scope.user.eventIds = [];
			}
		};

		$scope.allSubTypesChanged = function () {
			if ($scope.user.allCompanySubTypes) {
				$scope.user.subTypeIds = [];
			}
		};

		$scope.fieldsSelected = function (fields, selectedFields) {
			var res = [];
			if (angular.isArray(selectedFields)) {
				var fieldIds = selectedFields.map(function (item) {
					return item.id;
				});
				angular.forEach(fields, function (item) {
					if (fieldIds.lastIndexOf(item.id) === -1) {
						res.push(item);
					}
				});
				return res;
			} else {
				return fields;
			}
		};

		$scope.addField = function (chip, fields) {
			// $scope.companyFields = $filter('fieldsSelected', fields)
			if (chip == null || chip.id == null) {
				fields.splice(fields.length - 1, 1);
			}
		};

		$scope.orderByCustom = function (role) {
			return $filter('translate')('ROLES.' + role.name);
		};

		groupService.findGroups().then(function (response) {
			$scope.groups = response.data;
		}).catch(function () {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		$scope.update = function () {
			var fmData = new FormData();
			fmData.append('dto', angular.toJson($scope.user));
			var input = document.getElementById('edit_user_dropify');
			if (input != null && input.files != null && input.files.length > 0) {
				fmData.append('file', input.files[0]);
			}
			userService.updateUser(fmData).then(function (response) {
				if ($rootScope.user != null && $rootScope.user.id === $scope.user.id) {
					$rootScope.$broadcast('getCurrentUser');
				}
				$mdDialog.hide();
			}).catch(function (err) {
				if (err.status === 409) {
					if (err.data === 'ALREADY_EXIST_MAIL') {
						toastr.error($filter('translate')('USERS.ALREADY_EXIST_MAIL'));
					} else if (err.data === 'ALREADY_EXIST_LOGIN') {
						toastr.error($filter('translate')('USERS.ALREADY_EXIST_LOGIN'));
					} else {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					}
				} else {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}
			});
		};

		$scope.hidePopup = function () {
			$mdDialog.cancel();
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('addUserController', addUserController);

	function addUserController($rootScope, $scope, $filter, $mdDialog, $translate, toastr, company, userService, groupService, roleService, eventService, modelService) {

		$scope.groups = [];
		$scope.newUser = {
			rights: [],
			eventIds: [],
			subTypeIds: []
		};
		$scope.search = '';
		$scope.company = company;
		$scope.events = [];

		$scope.roles = [];
		$scope.companySubTypes = [];
		var modelType = 'COMPANY_MODEL';
		var baseUrl = './api/rest/model/' + modelType;

		roleService.find().then(function (response) {
			$scope.roles = response.data;
			$scope.roles.forEach(function (role) {
				role.nameTranslated = $filter('translate')('ROLES.' + role.name);
			});
		}).catch(function () {

		});

		modelService.getSubTypes(baseUrl, $translate.preferredLanguage(), null).then(function (response) {
			$scope.companySubTypes = response.data;
		}).catch(function () {

		});

		eventService.findAll().then(function (response) {
			$scope.events = response.data;
		}).catch(function () {

		});

		$scope.allEventsChanged = function () {
			if ($scope.newUser.allEvents) {
				$scope.newUser.eventIds = [];
			}
		};

		$scope.allSubTypesChanged = function () {
			if ($scope.newUser.allCompanySubTypes) {
				$scope.newUser.subTypeIds = [];
			}
		};

		$scope.fieldsSelected = function (fields, selectedFields) {
			var res = [];
			if (angular.isArray(selectedFields)) {
				var fieldIds = selectedFields.map(function (item) {
					return item.id;
				});
				angular.forEach(fields, function (item) {
					if (fieldIds.lastIndexOf(item.id) === -1) {
						res.push(item);
					}
				});
				return res;
			} else {
				return fields;
			}
		};

		$scope.addField = function (chip, fields) {
			// $scope.companyFields = $filter('fieldsSelected', fields)
			if (chip == null || chip.id == null) {
				fields.splice(fields.length - 1, 1);
			}
		};

		$scope.orderByCustom = function (role) {
			return $filter('translate')('ROLES.' + role.name);
		};

		if (!company) {
			groupService.findGroups().then(function (response) {
				$scope.groups = response.data;
			}).catch(function () {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

		$scope.saveUser = function () {
			var fmData = new FormData();
			if (company != null) {
				$scope.newUser.activated = true;
				$scope.newUser.companyId = company.id;
			}
			fmData.append('dto', angular.toJson($scope.newUser));
			var input = document.getElementById('add_user_dropify');
			if (input != null && input.files != null && input.files.length > 0) {
				fmData.append('file', input.files[0]);
			}
			userService.addUser(fmData, company != null).then(function () {
				$mdDialog.hide();
			}).catch(function (err) {
				if (err.status === 409) {
					if (err.data == 'ALREADY_EXIST_MAIL') {
						toastr.error($filter('translate')('USERS.ALREADY_EXIST_MAIL'));
					} else if (err.data == 'ALREADY_EXIST_LOGIN') {
						toastr.error($filter('translate')('USERS.ALREADY_EXIST_LOGIN'));
					} else {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					}
				} else {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}
				console.log(err);
			});
		};

		$scope.addManager = function () {
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/users/popup/add_user.html',
				controller: 'addUserController',
				clickOutsideToClose: true,
				locals: {
					fromAssociation: true
				}
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.hidePopup = function () {
			$mdDialog.cancel();
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('editGroupController', editGroupController);

	function editGroupController($scope, $mdDialog, $translate, $filter, group, toastr, groupService, roleService, modelService, eventService) {
		$scope.group = angular.copy(group);
		$scope.group.roles.forEach(function (role) {
			role.nameTranslated = $filter('translate')('ROLES.' + role.name);
		});

		$scope.roles = [];
		$scope.companySubTypes = [];
		$scope.events = [];

		$scope.search = '';
		var modelType = 'COMPANY_MODEL';
		var baseUrl = './api/rest/model/' + modelType;

		roleService.find().then(function (response) {
			$scope.roles = response.data;
			$scope.roles.forEach(function (role) {
				role.nameTranslated = $filter('translate')('ROLES.' + role.name);
			});
		}).catch(function () {

		});

		modelService.getSubTypes(baseUrl, $translate.preferredLanguage(), null).then(function (response) {
			$scope.companySubTypes = response.data;
		}).catch(function () {

		});

		eventService.findAll().then(function (response) {
			$scope.events = response.data;
		}).catch(function () {

		});

		$scope.allEventsChanged = function () {
			if ($scope.newGroup.allEvents) {
				$scope.newGroup.eventIds = [];
			}
		};

		$scope.allSubTypesChanged = function () {
			if ($scope.newGroup.allCompanySubTypes) {
				$scope.newGroup.subTypeIds = [];
			}
		};

		$scope.fieldsSelected = function (fields, selectedFields) {
			var res = [];
			if (angular.isArray(selectedFields)) {
				var fieldIds = selectedFields.map(function (item) {
					return item.id;
				});
				angular.forEach(fields, function (item) {
					if (fieldIds.lastIndexOf(item.id) === -1) {
						res.push(item);
					}
				});
				return res;
			} else {
				return fields;
			}
		};

		$scope.addField = function (chip, fields) {
			// $scope.companyFields = $filter('fieldsSelected', fields)
			if (chip == null || chip.id == null) {
				fields.splice(fields.length - 1, 1);
			}
		};

		$scope.orderByCustom = function (role) {
			return $filter('translate')('ROLES.' + role.name);
		};

		$scope.update = function () {
			groupService.updateGroup($scope.group).then(function () {
				$mdDialog.hide();
			}).catch(function () {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.hidePopup = function () {
			$mdDialog.cancel();
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('addGroupController', addGroupController);


	function addGroupController($scope, $mdDialog, $filter, toastr, $translate, groupService, roleService, modelService, eventService) {
		$scope.newGroup = {
			index: 0,
			roles: [],
			subTypeIds: [],
			eventIds: []
		};
		$scope.roles = [];
		$scope.companySubTypes = [];
		$scope.events = [];

		$scope.search = '';
		var modelType = 'COMPANY_MODEL';
		var baseUrl = './api/rest/model/' + modelType;

		roleService.find().then(function (response) {
			$scope.roles = response.data;
			$scope.roles.forEach(function (role) {
				role.nameTranslated = $filter('translate')('ROLES.' + role.name);
			});
		}).catch(function () {

		});

		modelService.getSubTypes(baseUrl, $translate.preferredLanguage(), null).then(function (response) {
			$scope.companySubTypes = response.data;
		}).catch(function () {

		});

		eventService.findAll().then(function (response) {
			$scope.events = response.data;
		}).catch(function () {

		});

		$scope.allEventsChanged = function () {
			if ($scope.newGroup.allEvents) {
				$scope.newGroup.eventIds = [];
			}
		};

		$scope.allSubTypesChanged = function () {
			if ($scope.newGroup.allCompanySubTypes) {
				$scope.newGroup.subTypeIds = [];
			}
		};

		$scope.fieldsSelected = function (fields, selectedFields) {
			var res = [];
			if (angular.isArray(selectedFields)) {
				var fieldIds = selectedFields.map(function (item) {
					return item.id;
				});
				angular.forEach(fields, function (item) {
					if (fieldIds.lastIndexOf(item.id) === -1) {
						res.push(item);
					}
				});
				return res;
			} else {
				return fields;
			}
		};

		$scope.addField = function (chip, fields) {
			// $scope.companyFields = $filter('fieldsSelected', fields)
			if (chip == null || chip.id == null) {
				fields.splice(fields.length - 1, 1);
			}
		};

		$scope.orderByCustom = function (role) {
			return $filter('translate')('ROLES.' + role.name);
		};

		$scope.save = function () {
			groupService.addGroup($scope.newGroup).then(function (response) {
				$mdDialog.hide();
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.hidePopup = function () {
			$mdDialog.cancel();
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('editAssociationController', editAssociationController);

	function editAssociationController($scope, $mdDialog, $filter, toastr, association, URL, associationService, userService) {
		$scope.association = angular.copy(association);
		if ($scope.association.logo != null) {
			$scope.association.src = URL.alternatedocroots + '/' + $scope.association.logo;
		}

		var full = location.protocol + '//' + location.hostname + (location.port ? ':' + location.port : '');
		$scope.associationUrl = full + '/login?associationId=' + association.id;

		userService.findActive().then(function (response) {
			$scope.users = response.data;
		}).catch(function () {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		$scope.hidePopup = function () {
			$mdDialog.cancel();
		};

		$scope.update = function () {
			var fmData = new FormData();
			fmData.append('dto', angular.toJson($scope.association));
			var input = document.getElementById('edit_association_dropify');
			if (input != null && input.files != null && input.files.length > 0) {
				fmData.append('file', input.files[0]);
			}
			associationService.update(fmData).then(function (response) {
				$mdDialog.hide();
			}).catch(function () {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('addAssociationController', addAssociationController);

	function addAssociationController($scope, $mdDialog, $filter, $translate, toastr, associationService, userService){

		$scope.newAssociation = {};

		userService.findActive().then(function(response){
			$scope.users = response.data;
		}).catch(function(){
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};

		$scope.save = function(){
			var fmData = new FormData();
			fmData.append('dto', angular.toJson($scope.newAssociation));
			var input = document.getElementById('add_association_dropify');
			if (input != null && input.files != null && input.files.length > 0){
				$scope.missingFile = false;
				fmData.append('file', input.files[0]);
				associationService.save(fmData, $translate.preferredLanguage()).then(function(response){
					$mdDialog.hide();
				}).catch(function(){
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}else{
				$scope.missingFile = true;
			}
		};

	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function(){
	'use strict';

	angular.module('app.front').controller('addTouristAttractionController', addTouristAttractionController);

	function addTouristAttractionController($scope, $translate, $state, $filter, $mdDialog, toastr, modelService, touristAttractionService, languageService, DocumentService){
		$scope.modelType = 'COMPANY_MODEL';
		var baseUrl = './api/rest/model/' + $scope.modelType;
		$scope.updateMode = false;
		$scope.tourist = {};
		$scope.language = {};
		$scope.photos = [];

		modelService.findSpecificByType(baseUrl, $translate.preferredLanguage(), 'REGION').then(function (response) {
			$scope.regions = response.data.listFieldsDTO;
		}).catch(function () {

		});

		modelService.findSpecificByType(baseUrl, $translate.preferredLanguage(), 'TOURISM').then(function (response) {
			$scope.tourisms = response.data.listFieldsDTO;
		}).catch(function () {

		});

		modelService.findSpecificByType(baseUrl, $translate.preferredLanguage(), 'CITY').then(function (response) {
			$scope.cities = response.data.listFieldsDTO;
		}).catch(function () {

		});

		$scope.findTourist = function(id){
			touristAttractionService.findById(id, $scope.language.key).then(function(res){
				$scope.tourist = res.data;
				$scope.updateMode = true;
			}).catch(function(){

			});
		};

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}

			if ($state.params.id) {
				$scope.findTourist($state.params.id);
			}
		}).catch(function (error) {

		});

		$scope.add = function(){
			var fmData = new FormData();
			fmData.append('dto', angular.toJson($scope.tourist));
			var maxIndex = 0;
			for (var i = 0; i < $scope.photos.length; i++){
				var input = document.getElementById('tourist_photo_' + i);
				var file = null;
				if (input != null) {
					file = input.files[0];
				}
				if (file != null){
					fmData.append('file_' + maxIndex, file);
					maxIndex++;
				}
			}
			fmData.append('maxIndex', maxIndex);
			touristAttractionService.save(fmData, $scope.language.key).then(function(){
				$state.go('app.touristAttractions');
			}).catch(function(){

			});
		};

		$scope.displayPopUpDeletePhoto = function (photo, index) {
			$scope.photoToDelete = angular.copy(photo);
			$scope.indexToDelete = index;
			$mdDialog.show({
				templateUrl: 'app/main/tourist_attractions/popup/delete_photo.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

		$scope.deletePhotoPermanentely = function () {
			touristAttractionService.deletePhoto($state.params.id, $scope.photoToDelete.id).then(function (res) {
				$scope.tourist.photos.splice($scope.indexToDelete, 1);
				toastr.success($filter('translate')('PACKAGES.ADD.TOAST.SUCCESS_DELETE_PHOTO'));
				$scope.hidePopup();
			}).catch(function (err) {
				toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_DELETE_PHOTO'));
			});
		};

		$scope.langageChanged = function () {
			if ($scope.updateMode) {
				if ($state.params.id != null) {
					$scope.findTourist($state.params.id);
				}
			}
		};
	}
})();
(function () {
	'use strict';

	angular
		.module('app.front')
		.controller('reportingStatisticsController', reportingStatisticsController);

	/** @ngInject */
	function reportingStatisticsController($scope, DISPLAY_MODELS_ICONS, groupService, userService, SettingsMessageService, MessageService, languageService, statisticsService, companyService, STORAGE_PREFIX, STATISTICS_NATIONALITIES, $filter, $rootScope, toastr, $mdDialog, $mdSelect, $window) {
		$scope.iconsDisplay = {};
		angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
			$scope.iconsDisplay[elt.name] = elt.value;
		});
		$scope.language = {};
		$scope.groups = [];
		$scope.actions = [];
		$scope.filter = {
			groupIDs: [],
			actionIDs: [],
			userIDs: [],
			begin: {},
			end: {}
		};
		$scope.stats = [];
		$scope.monthNames = [];
		$scope.yearValues = [];
		$scope.year = {
			value: null
		};
		$scope.customPeriod = false;
		$scope.customFilter = {
			begin: {},
			end: {}
		};
		$scope.customPeriods = {
			filter: null,
			period: {
				begin: {
					year: null
				},
				end: {
					year: null
				}
			}
		};
		$scope.displayCustomPeriod = false;
		$scope.messagesArray = [];
		$scope.inProgress = false;

		$scope.searchUser = '';

		var now = new Date();

		//For iput select year
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.getStatisticsReporting = function () {
			$scope.inProgress = true;
			var year;
			var filter = angular.copy($scope.filter);
			if (!$scope.customPeriod) {
				if ($scope.year.value === 'custom') {
					year = angular.copy($scope.customPeriods.filter);
				} else if ($scope.year.value === 'all') {
					year = null;
				} else {
					year = angular.copy($scope.year.value);
				}
				if ($scope.filter.userIDs != null) {
					filter.userIDs = $scope.filter.userIDs.map(function (user) {
						return user.id;
					});
				}

				statisticsService.getStatisticReporting(filter, $scope.language.key, year).then(function (res) {
					$scope.displayCustomPeriod = false;
					$scope.stats = res.data;
					iniStatsMonthValues();
					initStatsAccrued();
					initStatsMessages();
					$scope.inProgress = false;
				}).catch(function (err) {
					$scope.inProgress = false;
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			} else {
				if ($scope.customFilter.begin.date == null || $scope.customFilter.end.date == null) {
					$scope.inProgress = false;
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					return;
				}

				var filter = angular.copy($scope.filter);
				filter.begin = {
					date: $scope.customFilter.begin.date.getTime()
				};
				var dat = new Date($scope.customFilter.end.date);
				dat.setDate(dat.getDate() + 1);
				filter.end = {
					date: dat.getTime()
				};

				if ($scope.filter.userIDs != null) {
					filter.userIDs = $scope.filter.userIDs.map(function (user) {
						return user.id;
					});
				}

				// if ($scope.customFilter.begin.year === 'custom') {
				// 	filter.begin.year = $scope.customPeriods.period.begin.year;
				// } else {
				// 	filter.begin.year = $scope.customFilter.begin.year;
				// }

				// if ($scope.customFilter.end.year === 'custom') {
				// 	filter.end.year = $scope.customPeriods.period.end.year;
				// } else {
				// 	filter.end.year = $scope.customFilter.end.year;
				// }

				if ($scope.customFilter.begin.date > $scope.customFilter.end.date) {
					$scope.inProgress = false;
					toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INVALID_PERIOD'));
					return;
				}


				statisticsService.getStatisticReporting(filter, $scope.language.key, null).then(function (res) {
					$scope.displayCustomPeriod = true;
					$scope.stats = res.data;
					iniStatsCustomPeriod();
					initStatsMessages();
					$scope.inProgress = false;
				}).catch(function (err) {
					$scope.inProgress = false;
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}
		};

		$scope.getUsersByGroups = function () {
			$scope.users = [];
			userService.findByGroups($scope.filter.groupIDs).then(function (res) {
				$scope.users = res.data;
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.confirmAction = function (action) {
			var content = {
				title: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL_TITLE') : $filter('translate')('MESSAGE.ACTION_CONFIRM_TITLE'),
				message: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL') : $filter('translate')('MESSAGE.ACTION_CONFIRM')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				action.actionDone = !action.actionDone;
				MessageService.confirmAction(action).then(function (data) { }).catch(function (data) { });
			}).catch(function () {

			});
		};

		$scope.downloadStatisticsReporting = function () {
			$scope.inProgress = true;
			if (!$scope.customPeriod) {
				var year;
				var filter = angular.copy($scope.filter);
				if ($scope.year.value === 'custom') {
					year = angular.copy($scope.customPeriods.filter);
				} else if ($scope.year.value === 'all') {
					year = null;
				} else {
					year = angular.copy($scope.year.value);
				}
				if ($scope.filter.userIDs != null) {
					filter.userIDs = $scope.filter.userIDs.map(function (user) {
						return user.id;
					});
				}

				statisticsService.generateReporting(filter, $scope.language.key, year).then(function (res) {
					$scope.inProgress = false;
				}).catch(function (err) {
					$scope.inProgress = false;
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			} else {

				var filter = angular.copy($scope.filter);
				filter.begin = {
					date: $scope.customFilter.begin.date.getTime()
				};
				var dat = new Date($scope.customFilter.end.date);
				dat.setDate(dat.getDate() + 1);
				filter.end = {
					date: dat.getTime()
				};

				if ($scope.filter.userIDs != null) {
					filter.userIDs = $scope.filter.userIDs.map(function (user) {
						return user.id;
					});
				}

				statisticsService.generateReporting(filter, $scope.language.key, null).then(function (res) { $scope.inProgress = false; }).catch(function (err) {
					$scope.inProgress = false;
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}

		};

		$scope.searchStatisticsCustomYear = function () {
			if (validateYearFormat($scope.customPeriods.filter)) {
				$scope.year.value = 'custom';
				$mdSelect.hide();
			} else {
				$scope.year.value = now.getFullYear();
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		$scope.searchStatisticsCustomYearBetween = function (begin) {
			if (begin && validateYearFormat($scope.customPeriods.period.begin.year)) {
				$scope.customFilter.begin.year = 'custom';
				$mdSelect.hide();
			} else if (!begin && validateYearFormat($scope.customPeriods.period.end.year)) {
				$scope.customFilter.end.year = 'custom';
				$mdSelect.hide();
			} else {
				if (begin) {
					$scope.customFilter.begin.year = now.getFullYear();
				} else {
					$scope.customFilter.end.year = now.getFullYear();
				}
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		$scope.groupContainsActionsDone = function (group) {
			for (var i = 0; i < group.msgs.length; i++) {
				if (group.msgs[i].action && group.msgs[i].action.actionDone) {
					return true;
				}
			}

			return false;
		};

		function validateYearFormat(year) {
			if (year >= (now.getFullYear() - 100) && year <= (now.getFullYear() + 100)) {
				return true;
			}

			return false;
		}

		function init() {
			languageService.getLanguages().then(function (response) {
				$scope.languages = response.data;
				for (var i = 0; i < $scope.languages.length; i++) {
					var language = $scope.languages[i];
					if (language.preferred) {
						$scope.language.key = language.key;
						break;
					}
				}

				findActions();
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});

			$scope.getUsersByGroups();

			findGroups();
			initMonthAndYears();
		}

		function findActions() {
			//get all actions
			SettingsMessageService.findAllAction($scope.language.key).then(function (actions) {
				$scope.actions = actions.data;
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

		function findGroups() {
			//get all groups
			groupService.findGroups().then(function (response) {
				$scope.groups = response.data;
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

		//Init range years and months
		function initMonthAndYears() {
			for (var i = 0; i < 12; i++) {
				$scope.monthNames.push({
					value: i,
					name: $filter('translate')('GENERAL.MONTH_NAMES.' + i)
				});
			}
		}

		function iniStatsMonthValues() {
			for (var i = 0; i < $scope.stats.length; i++) {
				for (var j = 0; j < $scope.stats[i].users.length; j++) {
					var actionsIndexex = {};
					if ($scope.stats[i].statsJSON == undefined) {
						$scope.stats[i].statsJSON = [];
					}
					for (var k = 0; k < $scope.stats[i].users[j].statistics.length; k++) {
						for (var l = 0; l < $scope.stats[i].users[j].statistics[k].nbrByMonth.length; l++) {
							if (actionsIndexex[$scope.stats[i].users[j].statistics[k].action.id] != undefined) {
								$scope.stats[i].statsJSON[actionsIndexex[$scope.stats[i].users[j].statistics[k].action.id]].months[$scope.stats[i].users[j].statistics[k].nbrByMonth[l].month] = $scope.stats[i].users[j].statistics[k].nbrByMonth[l].number;
							} else {
								var action = $scope.stats[i].users[j].statistics[k].action;
								var statJSON = {
									actionName: $scope.stats[i].users[j].user.fullName + ' - ' + action.libelle,
									months: {}
								};

								statJSON.months[$scope.stats[i].users[j].statistics[k].nbrByMonth[l].month] = $scope.stats[i].users[j].statistics[k].nbrByMonth[l].number;
								$scope.stats[i].statsJSON.push(statJSON);
								actionsIndexex[action.id] = $scope.stats[i].statsJSON.length - 1;
							}
						}
					}
				}
			}
		}

		function iniStatsCustomPeriod() {
			for (var i = 0; i < $scope.stats.length; i++) {
				for (var j = 0; j < $scope.stats[i].users.length; j++) {
					if ($scope.stats[i].statsJSON == undefined) {
						$scope.stats[i].statsJSON = [];
					}
					for (var k = 0; k < $scope.stats[i].users[j].statistics.length; k++) {
						var action = $scope.stats[i].users[j].statistics[k].action;
						var statJSON = {
							actionName: $scope.stats[i].users[j].user.fullName + ' - ' + action.libelle,
							value: $scope.stats[i].users[j].statistics[k].nbrAverage
						};

						$scope.stats[i].statsJSON.push(statJSON);
					}
				}
			}

		}

		function initStatsAccrued() {
			for (var i = 0; i < $scope.stats.length; i++) {
				for (var j = 0; j < $scope.stats[i].statsJSON.length; j++) {
					$scope.stats[i].statsJSON[j].monthsAccrued = {};
					var previous = null;
					for (var k = 0; k < 12; k++) {
						if ($scope.stats[i].statsJSON[j].months[k] != undefined) {
							if (previous == null) {
								$scope.stats[i].statsJSON[j].monthsAccrued[k] = $scope.stats[i].statsJSON[j].months[k];
							} else {
								$scope.stats[i].statsJSON[j].monthsAccrued[k] = previous + $scope.stats[i].statsJSON[j].months[k];
							}

							previous = $scope.stats[i].statsJSON[j].monthsAccrued[k];
						} else {
							if (previous != null) {
								$scope.stats[i].statsJSON[j].monthsAccrued[k] = previous;
							}
						}
					}
				}
			}
		}

		function initStatsMessages() {
			$scope.messagesArray = [];
			for (var i = 0; i < $scope.stats.length; i++) {
				for (var j = 0; j < $scope.stats[i].users.length; j++) {
					var msgElt = {
						user: $scope.stats[i].users[j].user,
						msgs: []
					};
					for (var k = 0; k < $scope.stats[i].users[j].messages.length; k++) {
						msgElt.msgs.push($scope.stats[i].users[j].messages[k]);
					}
					$scope.messagesArray.push(msgElt);
				}
			}
			console.log($scope.messagesArray);
		}

		function initYears() {
			$scope.year.value = now.getFullYear();

			for (var i = -3; i <= 3; i++) {
				$scope.yearValues.push($scope.year.value + i);
			}
		}

		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		init();
		initYears();

		$scope.usersSelected = function (users, usersSelected) {
			if (angular.isArray(usersSelected)) {
				var userIds = usersSelected.map(function (item) {
					return item.id;
				});
				var res = [];
				angular.forEach(users, function (item) {
					if (userIds.lastIndexOf(item.id) === -1) {
						res.push(item);
					}
				});
				return res;
			} else {
				return users;
			}
		};

		$scope.addField = function (chip, userIds) {
			// $scope.companyFields = $filter('fieldsSelected', fields)
			if (chip == null || chip.id == null) {
				userIds.splice(userIds.length - 1, 1);
			}
		};
	}
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('repartitionStatisticsController', repartitionStatisticsController);

  /** @ngInject */
  function repartitionStatisticsController($scope, $translate, modelService, statisticsService, companyService, STORAGE_PREFIX, STATISTICS_NATIONALITIES, $filter, $rootScope, toastr, $mdDialog, $mdSelect, $window) {
    $scope.typesRepartition = [{
        value: 'CONTACT_MODEL',
        name: $filter('translate')('STATISTICS.REPARTITION.TYPES_REPARTITION.USER')
      },
      {
        value: 'COMPANY_MODEL',
        name: $filter('translate')('STATISTICS.REPARTITION.TYPES_REPARTITION.COMPANY')
      }
    ];

    //Si les trads sont chargées après le controller: les trads n'apparaissent pas
    $rootScope.$on('$translateChangeSuccess', function () {
      $scope.typesRepartition[0].name = $translate.instant('STATISTICS.REPARTITION.TYPES_REPARTITION.USER');
      $scope.typesRepartition[1].name = $translate.instant('STATISTICS.REPARTITION.TYPES_REPARTITION.COMPANY');
    });

    $scope.userValues = {
      typeRepartition: null,
      typeCompany: null,
      field: null,
      typeCompanyContact: null
    };

    $scope.data = {
      typesCompany: [],
      fields: [],
      statistics: [],
      statisticsSubTypes: []
    };

    $scope.chart = {
      data: [],
      labels: [],
      dataSubTypes: {
        companies: [],
        contacts: []
      },
      labelsSubTypes: [],
      options: {
        legend: {
          display: true,
          position: 'right',
          labels: {
            generateLabels: function (chart) {
              var data = chart.data;
              if (data.labels.length && data.datasets.length) {
                return data.labels.map(function (label, i) {
                  var meta = chart.getDatasetMeta(0);
                  var ds = data.datasets[0];
                  var arc = meta.data[i];
                  var custom = arc && arc.custom || {};
                  var getValueAtIndexOrDefault = Chart.helpers.getValueAtIndexOrDefault;
                  var arcOpts = chart.options.elements.arc;
                  var fill = custom.backgroundColor ? custom.backgroundColor : getValueAtIndexOrDefault(ds.backgroundColor, i, arcOpts.backgroundColor);
                  var stroke = custom.borderColor ? custom.borderColor : getValueAtIndexOrDefault(ds.borderColor, i, arcOpts.borderColor);
                  var bw = custom.borderWidth ? custom.borderWidth : getValueAtIndexOrDefault(ds.borderWidth, i, arcOpts.borderWidth);

                  // We get the value of the current label
                  var value = chart.config.data.datasets[arc._datasetIndex].data[arc._index];

                  return {
                    // Instead of `text: label,`
                    // We add the value to the string
                    text: label + " : " + value,
                    fillStyle: fill,
                    strokeStyle: stroke,
                    lineWidth: bw,
                    hidden: isNaN(ds.data[i]) || meta.data[i].hidden,
                    index: i
                  };
                });
              } else {
                return [];
              }
            }
          }
        }
      }
    };

    $scope.displayChartSubTypes = false;
    var lang;

    if (localStorage.getItem(STORAGE_PREFIX + 'language')) {
      lang = localStorage.getItem(STORAGE_PREFIX + 'language');

      if (!lang) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      }
    } else {
      toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
    }

    $scope.checkTypeRepartition = function () {
      $scope.userValues.typeCompany = null;
      $scope.userValues.field = null;
      emptyChart();
      getCompanyTypes();

      switch ($scope.userValues.typeRepartition) {
        case 'CONTACT_MODEL':
          {
            $scope.displayChartSubTypes = false;
            getFields($scope.userValues.typeRepartition);
            break;
          }

        case 'COMPANY_MODEL':
          {
            $scope.displayChartSubTypes = true;
            getStatisticsSubTypes();
            initTitlesSubTypesCharts();
            break;
          }

      }
    };

    $scope.checkTypeCompany = function () {
      $scope.userValues.field = null;
      $scope.displayChartSubTypes = false;
      emptyChart();

      getFields($scope.userValues.typeRepartition);
    };

    $scope.checkField = function () {
      getStatistics($scope.userValues.typeRepartition);
    };

    function getCompanyTypes() {
      if ($scope.data.typesCompany.length > 0) {
        return;
      } else if ($rootScope.companiesMenus && $rootScope.companiesMenus.length > 0) {
        $scope.data.typesCompany = $rootScope.companiesMenus;
      } else {
        modelService.getSubTypes('./api/rest/model/COMPANY_MODEL', lang, null).then(function (response) {
          //TYPE DE SOCIETE
          $scope.data.typesCompany = response.data;
        }).catch(function (err) {
          console.log(err);
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }
    }

    function getFields(type) {
      switch (type) {
        case 'COMPANY_MODEL':
          {
            modelService.listSelectFieldsFromSubType($scope.userValues.typeCompany, lang).then(function (res) {
              if (res.data) {
                if (res.data.length === 0) {
                  toastr.error($filter('translate')('STATISTICS.REPARTITION.TOAST.NO_SELECT_FIELD_COMPANY'));
                }
                $scope.data.fields = res.data;
              }
            }).catch(function (err) {
              console.log(err);
              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
            break;
          }
        case 'CONTACT_MODEL':
          {
            modelService.listSelectFieldsFromType($scope.userValues.typeRepartition, lang).then(function (res) {
              if (res.data) {
                if (res.data.length === 0) {
                  toastr.error($filter('translate')('STATISTICS.REPARTITION.TOAST.NO_SELECT_FIELD_CONTACT'));
                }

                $scope.data.fields = res.data;
              }
            }).catch(function (err) {
              console.log(err);
              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
            break;
          }
      }
    }

    function getStatistics(type) {
      switch (type) {
        case 'COMPANY_MODEL':
          {
            statisticsService.getStatisticRepartitionCompany($scope.userValues.typeCompany, $scope.userValues.field, lang).then(function (res) {
              if (res.data) {
                $scope.data.statistics = res.data;
                if (res.data.length === 0) {
                  toastr.error($filter('translate')('STATISTICS.REPARTITION.TOAST.NO_DATA_TO_DISPLAY'));
                }
              } else {
                $scope.data.statistics = [];
                toastr.error($filter('translate')('STATISTICS.REPARTITION.TOAST.NO_DATA_TO_DISPLAY'));
              }
              initChart();
            }).catch(function (err) {
              console.log(err);
              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
            break;
          }
        case 'CONTACT_MODEL':
          {
            if($scope.userValues.field == null) {
              return;
            }

            statisticsService.getStatisticRepartitionContact($scope.userValues.field, lang, $scope.userValues.typeCompanyContact).then(function (res) {
              if (res.data) {
                $scope.data.statistics = res.data;
                if (res.data.length === 0) {
                  toastr.error($filter('translate')('STATISTICS.REPARTITION.TOAST.NO_DATA_TO_DISPLAY'));
                }
              } else {
                $scope.data.statistics = [];
                toastr.error($filter('translate')('STATISTICS.REPARTITION.TOAST.NO_DATA_TO_DISPLAY'));
              }
              initChart();
            }).catch(function (err) {
              console.log(err);
              toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
            break;
          }
      }
    }

    function getStatisticsSubTypes() {
      if ($scope.data.statisticsSubTypes.length === 0) {
        statisticsService.getStatisticsByCompanyTypes(lang).then(function (res) {
          console.log(res.data);
          if (res.data) {
            $scope.data.statisticsSubTypes = res.data;
            iniChartSubTypes();
          }
        }).catch(function (err) {
          console.log(err);
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }
    }

    function initChart() {
      emptyChart();

      if ($scope.data.statistics && $scope.data.statistics.length > 0) {
        for (var i = 0; i < $scope.data.statistics.length; i++) {
          $scope.chart.labels.push($scope.data.statistics[i].valueStat);
          $scope.chart.data.push($scope.data.statistics[i].number);
        }
      }
    }

    function iniChartSubTypes() {
      for (var i = 0; i < $scope.data.statisticsSubTypes.length; i++) {
        $scope.chart.labelsSubTypes.push($scope.data.statisticsSubTypes[i].companyType);
        $scope.chart.dataSubTypes.companies.push($scope.data.statisticsSubTypes[i].nbrCompanies);
        $scope.chart.dataSubTypes.contacts.push($scope.data.statisticsSubTypes[i].nbrContacts);
      }

      console.log($scope.chart.dataSubTypes);
    }

    function emptyChart() {
      $scope.chart.data = [];
      $scope.chart.labels = [];
    }

    function initTitlesSubTypesCharts() {
      $scope.chart.optionsContacts = angular.copy($scope.chart.options);
      $scope.chart.optionsContacts.title = {
        display: true,
        text: $filter('translate')('STATISTICS.REPARTITION.TITLE_CONTACTS_CHART'),
        fontSize: 22
      };
      $scope.chart.optionsCompanies = angular.copy($scope.chart.options);
      $scope.chart.optionsCompanies.title = {
        display: true,
        text: $filter('translate')('STATISTICS.REPARTITION.TITLE_COMPANIES_CHART'),
        fontSize: 22
      };
    }
  }
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.controller('editStatisticsController', editStatisticsController);

	/** @ngInject */
	function editStatisticsController($scope, $translate, statisticsService, companyService, $filter, $state, $rootScope, toastr, $mdDialog, $mdSelect, userService) {
		//Constants
		var now = new Date();

		var emptystatNationality = {
			nationality: null,
			nbrLeavings: null,
			nbrArrivals: null,
			nbrNights: null
		};
		var emptyStats = {
			companyID: null,
			statsNationality: [
				emptystatNationality
			]
		};
		$scope.nationalities = [];
		$scope.monthNames = [];
		$scope.yearValues = [];
		var associationIds = [];
		$scope.customYear = null;
		$scope.overwriteMode = false;
		$scope.selectedCompanyID = null;
		$scope.selectCompany = {
			id: null
		};
		$scope.isAdmin = false;
		$scope.companies = [];
		$scope.statistics = angular.copy(emptyStats);
		$scope.selectedPeriod = {
			month: now.getMonth(),
			year: now.getFullYear(),
			companyID: null
		};
		$scope.filterSelectTextCompany = {
			value: ''
		};
		var isAssociation = false;

		var getCompanies = function () {
			if (!isAssociation) {
				companyService.findForStatistics($translate.preferredLanguage(), null, $scope.filterSelectTextCompany.value).then(function (res) {
					if (res.data) {
						$scope.companies = res.data;
					}
				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('STATISTICS.DISPLAY.ERROR_GET_COMPANIES'));
				});
			} else {
				companyService.findForStatistics($translate.preferredLanguage(), associationIds, $scope.filterSelectTextCompany.value).then(function (res) {
					if (res.data) {
						$scope.companies = res.data;
					}
				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('STATISTICS.DISPLAY.ERROR_GET_COMPANIES'));
				});
			}
		};

		$scope.getCompanies = getCompanies();

		$scope.$watch('filterSelectTextCompany.value', function () {
			getCompanies();
		});

		var validateYearFormat = function (year) {
			if (year >= 1900 && year <= 2100) {
				return true;
			}
			return false;
		};

		var checkCorrectNbrRooms = function () {
			if ($scope.statistics.nbrOccupedRooms != null && $scope.statistics.nbrRooms != null) {
				if ($scope.statistics.nbrOccupedRooms > $scope.statistics.nbrRooms) {
					return false;
				}
			}

			return true;
		};

		$scope.removeNationalityAlreadyUsed = function () {
			$scope.nationalities = angular.copy($scope.nationalitiesCopy);

			for (var i = 0; i < $scope.statistics.statsNationality.length; i++) {
				for (var y = 0; y < $scope.nationalities.length; y++) {
					if ($scope.statistics.statsNationality[i].nationality != null && $scope.nationalities[y].id === $scope.statistics.statsNationality[i].nationality.id) {
						$scope.nationalities[y].alreadyHere = true;
						break;
					}
				}
			}
		};

		var initMonthAndYears = function () {
			$rootScope.$on('$translateChangeSuccess', function () {
				initMonthAndYears();
			});

			$scope.monthNames = [];

			for (var i = 0; i < 12; i++) {
				$scope.monthNames.push({
					value: i,
					name: $filter('translate')('GENERAL.MONTH_NAMES.' + i)
				});
			}

			var yearNow = now.getFullYear();

			for (var j = -3; j <= 3; j++) {
				$scope.yearValues.push(yearNow + j);
			}
		};

		$scope.getStatistics = function () {
			var period = angular.copy($scope.selectedPeriod);

			if (period.year === 'custom') {
				if (validateYearFormat($scope.customYear)) {
					period.year = angular.copy($scope.customYear);
				} else {
					toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_DATE'));
					return;
				}
			}

			if ($scope.selectedCompanyID != null) {
				period.companyID = $scope.selectedCompanyID;
			} else if ($scope.selectCompany.id != null) {
				period.companyID = $scope.selectCompany.id;
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.ERROR_SELECT_COMPANY'));
				return;
			}

			statisticsService.getNationalities($translate.preferredLanguage()).then(function (response) {
				$scope.nationalities = response.data;
				$scope.nationalitiesCopy = angular.copy($scope.nationalities);
				statisticsService.get(period).then(function (res) {
					if (res.data) {
						$scope.statistics = res.data;
						if ($scope.statistics.statsNationality == null || $scope.statistics.statsNationality.length === 0) {
							$scope.addNationality();
						}
						$scope.removeNationalityAlreadyUsed();
						$scope.overwriteMode = true;
					} else {
						$scope.statistics = angular.copy(emptyStats);
						$scope.removeNationalityAlreadyUsed();
						$scope.overwriteMode = false;
					}
				}).catch(function (err) {
					toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.ERROR_STATISTICS'));
					console.log(err);
				});
			}).catch(function () {

			});

		};

		initMonthAndYears();
		//$scope.getStatistics();

		//For iput select year
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.searchStatisticsCustomYear = function () {
			if (validateYearFormat($scope.customYear)) {
				$scope.selectedPeriod.year = 'custom';
				$mdSelect.hide();
				$scope.getStatistics();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}

		};

		$scope.save = function () {
			if (!checkCorrectNbrRooms()) {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.ERROR_NBR_ROOMS'));
				return;
			}

			if (!!$scope.overwriteMode) {
				$scope.content = {
					message: $filter('translate')('STATISTICS.EDIT.POP_UP.MESSAGE'),
					title: $filter('translate')('STATISTICS.EDIT.POP_UP.TITLE')
				};
				$mdDialog.show({
					templateUrl: 'app/main/popup/confirm.html',
					clickOutsideToClose: true,
					scope: $scope,
					preserveScope: true
				}).then(function () {}).catch(function () {});
			} else {
				$scope.confirmAction();
			}
		};

		$scope.confirmAction = function () {
			var dto = angular.copy($scope.statistics);

			if (!$scope.overwriteMode) {
				if ($scope.selectedPeriod.year === 'custom') {
					if (validateYearFormat($scope.customYear)) {
						dto.year = angular.copy($scope.customYear);
					} else {
						toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_DATE'));
						return;
					}
				} else {
					dto.year = angular.copy($scope.selectedPeriod.year);
				}
				dto.month = angular.copy($scope.selectedPeriod.month);
			}

			if ($scope.selectedCompanyID != null) {
				dto.companyID = $scope.selectedCompanyID;
			} else if ($scope.selectCompany.id != null) {
				dto.companyID = $scope.selectCompany.id;
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.ERROR_SELECT_COMPANY'));
				return;
			}

			for (var i = 0; i < dto.statsNationality.length; i++) {
				if (!dto.statsNationality[i].nationality) {
					dto.statsNationality.splice(i, 1);
				}
			}

			statisticsService.save(dto, $translate.preferredLanguage()).then(function (res) {
				if (res.data) {
					$scope.statistics = res.data;
					if ($scope.statistics.statsNationality == null || $scope.statistics.statsNationality.length === 0) {
						$scope.addNationality();
					}
					toastr.success($filter('translate')('STATISTICS.EDIT.TOAST.SUCCESS_UPDATE'));
					if ($scope.overwriteMode) {
						$scope.hidePopup();
					}
				} else {
					toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.ERROR_RELOAD'));
				}
			}).catch(function (err) {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.ERROR_UPDATE'));
			});
		};

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

		$scope.addNationality = function () {
			$scope.removeNationalityAlreadyUsed();
			$scope.statistics.statsNationality.push(angular.copy(emptystatNationality));
		};

		$scope.removeNationality = function (index) {
			$scope.statistics.statsNationality.splice(index, 1);
			$scope.removeNationalityAlreadyUsed();
		};

		//On check ici car on a besoin de fonctions définies ci-dessus
		console.log($rootScope.user);
		if (!$rootScope.user) {
			var wait = $scope.$on('rooScopeUser:ready', function () {
				if (!$rootScope.user.admin && $rootScope.user.company && $rootScope.user.company.id) {
					$scope.selectedCompanyID = $rootScope.user.company.id;
					$scope.getStatistics();
					wait();
				} else if (!$rootScope.user.admin && $rootScope.user.associationIds != null && $rootScope.user.associationIds.length > 0) {
					associationIds = $rootScope.user.associationIds;
					$scope.selectedCompanyID = null;
					$scope.isAdmin = true;
					isAssociation = true;
					getCompanies();
				} else if ($rootScope.user.admin) {
					$scope.selectedCompanyID = null;
					$scope.isAdmin = true;
					isAssociation = false;
					getCompanies();
				}
				// else {
				// 	$state.go('app.statistics.display');
				// }
			});
		} else {
			if ($rootScope.user.company && $rootScope.user.company.id) {
				$scope.selectedCompanyID = $rootScope.user.company.id;
				$scope.getStatistics();
			} else if (!$rootScope.user.admin && $rootScope.user.associationIds != null && $rootScope.user.associationIds.length > 0) {
				associationIds = $rootScope.user.associationIds;
				$scope.selectedCompanyID = null;
				$scope.isAdmin = true;
				isAssociation = true;
				getCompanies();
			} else if ($rootScope.user.admin) {
				$scope.selectedCompanyID = null;
				$scope.isAdmin = true;
				isAssociation = false;
				getCompanies();
			}
			//  else {
			// 	$state.go('app.statistics.display');
			// }
		}
	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.controller('displayStatisticsController', displayStatisticsController);

	/** @ngInject */
	function displayStatisticsController($scope, userService, $translate, statisticsService, modelService, companyService, STORAGE_PREFIX, STATISTICS_NATIONALITIES, $filter, $rootScope, toastr, $mdDialog, $mdSelect, $window) {
		//Useful variables
		var now = new Date();
		var langage = localStorage[STORAGE_PREFIX + 'language'];

		$scope.filter = {
			begin: {
				year: now.getFullYear(),
				month: now.getMonth()
			},
			end: {
				year: now.getFullYear(),
				month: now.getMonth()
			},
			category: null,
			region: null,
			companyID: null,
			nationality: null,
			order: {
				name: null,
				inverse: false
			},
			onlyAverage: false,
			specificFieldsArray: [],
			associationsIDs: null
		};
		$scope.nationalities = {};
		$scope.companies = [];
		$scope.specificFieldsValue = {};
		$scope.loaded = false;
		$scope.byCompany = null;
		$scope.loading = {
			filter: false,
			compare: false
		};

		//order name = 's.company.customer.name'
		$scope.monthNames = [];
		$scope.yearValues = [];
		$scope.customYear = {
			filter: {
				begin: null,
				end: null
			},
			compare: {
				firstPeriod: {
					begin: null,
					end: null
				},
				secondPeriod: {
					begin: null,
					end: null
				}
			}
		};
		$scope.statisticsArray = [];
		$scope.statisticsNatArray = [];
		$scope.statisticsCompare = [];
		$scope.specificFields = [];
		$scope.filterMode = true;
		var filedTypes = [
			'CATEGORY',
			'REGION'
		];
		$scope.filterSelectTextCompany = {value: ''};

		var getCompanies = function () {
			companyService.findForStatistics($translate.preferredLanguage(), null, $scope.filterSelectTextCompany.value).then(function (res) {
				if (res.data) {
					$scope.companies = res.data;
				}
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('STATISTICS.DISPLAY.ERROR_GET_COMPANIES'));
			});
		};

		getCompanies();

		$scope.$watch('filterSelectTextCompany.value', function() {
			getCompanies();
		});
		
		/*if (!$rootScope.user) {
			var listener = $scope.$on('rooScopeUser:ready', function () {
				companyService.findForStatistics($translate.preferredLanguage(), $rootScope.user.associationIds).then(function (res) {
					if (res.data) {
						$scope.companies = res.data;
					}
				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_COMPANIES'));
				});

				listener();
			});
		} else {
			companyService.findForStatistics($translate.preferredLanguage(), $rootScope.user.associationIds).then(function (res) {
				if (res.data) {
					$scope.companies = res.data;
				}
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_COMPANIES'));
			});
		}*/

		modelService.findSpecificsByMultipleTypes('./api/rest/model/COMPANY_MODEL', $translate.preferredLanguage(), filedTypes).then(function (res) {
			console.log(res.data);
			$scope.specificFields = res.data;
		}).catch(function (err) {
			console.log(err);
		});

		//Helper
		var validateYearFormat = function (year) {
			if (year >= (now.getFullYear() - 100) && year <= (now.getFullYear() + 100)) {
				return true;
			}

			return false;
		};

		//Init range years and months
		var initMonthAndYears = function () {
			for (var i = 0; i < 12; i++) {
				$scope.monthNames.push({
					value: i,
					name: $filter('translate')('GENERAL.MONTH_NAMES.' + i)
				});
			}

			var yearNow = now.getFullYear();

			for (var j = -3; j <= 3; j++) {
				$scope.yearValues.push(yearNow + j);
			}
		};

		initMonthAndYears();

		//For iput select year
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.searchStatisticsCustomYear = function (begin) {
			var customYear;
			var period;

			if (begin) {
				customYear = $scope.customYear.filter.begin;
				period = $scope.filter.begin;
			} else {
				customYear = $scope.customYear.filter.end;
				period = $scope.filter.end;
			}
			if (validateYearFormat(customYear)) {
				period.year = 'custom';
				$mdSelect.hide();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}

		};

		$scope.searchStatisticsCompareCustomYear = function (firstPeriod, begin) {
			var customYear;
			var period;

			if (firstPeriod) {
				if (begin) {
					customYear = $scope.customYear.compare.firstPeriod.begin;
					period = $scope.filterFirstPeriod.begin;
				} else {
					customYear = $scope.customYear.compare.firstPeriod.end;
					period = $scope.filterFirstPeriod.end;
				}
			} else {
				if (begin) {
					customYear = $scope.customYear.compare.secondPeriod.begin;
					period = $scope.filterSecondPeriod.begin;
				} else {
					customYear = $scope.customYear.compare.secondPeriod.end;
					period = $scope.filterSecondPeriod.end;
				}
			}

			if (validateYearFormat(customYear)) {
				period.year = 'custom';
				$mdSelect.hide();
			} else {
				period.year = now.getFullYear();
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}

		};

		var getFilter = function (filter) {
			if ($scope.filter.begin.year === 'custom') {
				filter.begin.year = angular.copy($scope.customYearBegin);
			}

			if ($scope.filter.end.year === 'custom') {
				filter.end.year = angular.copy($scope.customYearEnd);
			}

			if (new Date(filter.begin.year, filter.begin.month, 1) > new Date(filter.end.year, filter.end.month, 1)) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INVALID_PERIOD'));
				return null;
			}

			filter.specificFieldsArray = [];
			console.log($scope.specificFieldsValue);
			angular.forEach($scope.specificFieldsValue, function (value, key) {
				if (value) {
					filter.specificFieldsArray.push({
						id: key,
						idValue: value
					});
				}
			});

			return filter;
		};

		$scope.switchMode = function () {
			$scope.filterMode = !$scope.filterMode;
		};

		$scope.getStatsCompanies = function () {
			$scope.byCompany = null;
			var filter = getFilter($scope.filter);

			if (filter === null) {
				return;
			}
			$scope.loaded = false;
			$scope.loading.filter = true;
			statisticsService.filter(filter, $translate.preferredLanguage()).then(function (res) {
				if (res.data) {
					$scope.statisticsArray = res.data;
					$scope.loaded = true;
				}
				$scope.loading.filter = false;
				$scope.byCompany = true;
			}).catch(function (err) {
				$scope.loaded = true;
				$scope.loading.filter = false;
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_RESULTS'));
				console.log(err);
			});
		};

		$scope.downloadCompanies = function () {
			var filter = getFilter($scope.filter);

			if (filter === null) {
				return;
			}

			statisticsService.generateCompanies(filter, $translate.preferredLanguage()).then(function (res) {
				console.log(res);
			}).catch(function (err) {
				console.log(err);
			});
		};

		$scope.exportOccupationStats = function () {
			var filterFirstPeriod = getFilter($scope.filterFirstPeriod);
			var filterSecondPeriod = getFilter($scope.filterSecondPeriod);

			if (filterFirstPeriod === null || filterSecondPeriod === null) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INCORRECT_CRITERIAS_SEARCH'));
				return;
			}

			statisticsService.exportOccupationStats([filterFirstPeriod, filterSecondPeriod], $translate.preferredLanguage()).then(function (res) {
				if (res.data != null) {
					console.log(res.data);
				}
			}).catch(function (err) {
				console.log(err);
			});
		};

		$scope.downloadNationalities = function () {
			var filter = getFilter($scope.filter);

			if (filter === null) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INCORRECT_CRITERIAS_SEARCH'));
				return;
			}

			// statisticsService.download(filter).then(function (res) {

			// }).catch(function (err) {
			//   toastr.error('Erreur lors de la génération du document');
			//   console.log(err);
			// });
			statisticsService.generateNationalities(filter).then(function (res) {
				console.log(res);
			}).catch(function (err) {
				console.log(err);
			});
		};

		$scope.getStatsNationalities = function () {
			$scope.byCompany = null;
			var filter = getFilter($scope.filter);

			if (filter === null) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INCORRECT_CRITERIAS_SEARCH'));
				return;
			}

			$scope.loading.filter = true;

			statisticsService.getStatsNationalities(filter).then(function (res) {
				if (res.data != null) {
					$scope.statisticsNatArray = res.data;
				}
				$scope.loading.filter = false;
				$scope.byCompany = false;
			}).catch(function (err) {
				console.log(err);
				$scope.loading.filter = false;
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_STATS_NATIONALITIES'));
			});
		};

		initRights();

		$scope.getStatsCompareCompanies = function () {
			var filterFirstPeriod = getFilter($scope.filterFirstPeriod);
			var filterSecondPeriod = getFilter($scope.filterSecondPeriod);

			if (filterFirstPeriod === null || filterSecondPeriod === null) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INCORRECT_CRITERIAS_SEARCH'));
				return;
			}

			$scope.loading.compare = true;

			statisticsService.compare([filterFirstPeriod, filterSecondPeriod], $translate.preferredLanguage()).then(function (res) {
				if (res.data != null) {
					$scope.statisticsCompare = res.data;
					console.log($scope.statisticsCompare);
					initStatsCompare();
					//$scope.statisticsCompare[0] = $filter('orderBy')($scope.statisticsCompare[0], 'companyID');
					//$scope.statisticsCompare[1] = $filter('orderBy')($scope.statisticsCompare[1], 'companyID');
				}
				$scope.loading.compare = false;
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_RESULTS'));
			});
		};

		function initStatsCompare() {
			$scope.statisticsCompare[0] = $filter('orderBy')($scope.statisticsCompare[0], 'company');
			$scope.statisticsCompare[1] = $filter('orderBy')($scope.statisticsCompare[1], 'company');
			
			for (var i = 0; i < $scope.statisticsCompare[0].length; i++) {
				var stat1 = $scope.statisticsCompare[0][i].statistics[0];
				var stat2 = $scope.statisticsCompare[1][i].statistics[0];

				stat1.evoNbrArrivals = Math.round((stat2.nbrArrivals != null && stat1.nbrArrivals != null && stat1.nbrArrivals !== 0) ? (((stat2.nbrArrivals - stat1.nbrArrivals) * 100) / stat1.nbrArrivals) : 0);
				stat1.evoNbrDepartures = Math.round((stat2.nbrDepartures != null && stat1.nbrDepartures != null && stat1.nbrDepartures !== 0) ? (((stat2.nbrDepartures - stat1.nbrDepartures) * 100) / stat1.nbrDepartures) : 0);
				stat1.evoNbrRooms = Math.round((stat2.nbrRooms != null && stat1.nbrRooms != null && stat1.nbrRooms !== 0) ? (((stat2.nbrRooms - stat1.nbrRooms) * 100) / stat1.nbrRooms) : 0);
				stat1.evoIncomeOnMonth = Math.round((stat2.incomeOnMonth != null && stat1.incomeOnMonth != null && stat1.incomeOnMonth !== 0) ? (((stat2.incomeOnMonth - stat1.incomeOnMonth) * 100) / stat1.incomeOnMonth) : 0);
				stat1.evoAverageDurationStay = Math.round((stat2.averageDurationStay != null && stat1.averageDurationStay != null && stat1.averageDurationStay !== 0) ? (((stat2.averageDurationStay - stat1.averageDurationStay) * 100) / stat1.averageDurationStay) : 0);
				stat1.occupationRate = Math.round((stat1.nbrOccupedRooms != null && stat1.nbrRooms != null && stat1.nbrRooms !== 0) ? ((stat1.nbrOccupedRooms / stat1.nbrRooms) * 100) : 0);
				stat2.occupationRate = Math.round((stat2.nbrOccupedRooms != null && stat2.nbrRooms != null && stat2.nbrRooms !== 0) ? ((stat2.nbrOccupedRooms / stat2.nbrRooms) * 100) : 0);
				stat1.evoOccupationRate = Math.round((stat2.occupationRate != null && stat1.occupationRate != null && stat1.occupationRate !== 0) ? (((stat2.occupationRate - stat1.occupationRate) * 100) / stat1.occupationRate) : 0);
				stat1.evoNbrEmployeesFullTime = Math.round((stat2.nbrEmployeesFullTime != null && stat1.nbrEmployeesFullTime != null && stat1.nbrEmployeesFullTime !== 0) ? (((stat2.nbrEmployeesFullTime - stat1.nbrEmployeesFullTime) * 100) / stat1.nbrEmployeesFullTime) : 0);
				stat1.evoNbrEmployeesPartTime = Math.round((stat2.nbrEmployeesPartTime != null && stat1.nbrEmployeesPartTime != null && stat1.nbrEmployeesPartTime !== 0) ? (((stat2.nbrEmployeesPartTime - stat1.nbrEmployeesPartTime) * 100) / stat1.nbrEmployeesPartTime) : 0);
			}

			console.log($scope.statisticsCompare);
		}

		function initRights() {
			if (!$rootScope.user) {
				var listener = $scope.$on('rooScopeUser:ready', function () {
					if (userService.isUserAdmin()) {

					} else if (userService.isUserLinkedToAssociations()) {
						$scope.filter.associationsIDs = angular.copy($rootScope.user.associationIds);
					} else if ($rootScope.user.company && $rootScope.user.company.id) {
						$scope.oneCompanyMode = true;
						$scope.filter.companyID = $rootScope.user.company.id;
					}

					$scope.filterFirstPeriod = angular.copy($scope.filter);
					$scope.filterFirstPeriod.onlyAverage = true;
					$scope.filterSecondPeriod = angular.copy($scope.filterFirstPeriod);


					listener();
				});
			} else {
				if (userService.isUserAdmin()) {

				} else if (userService.isUserLinkedToAssociations()) {
					$scope.filter.associationsIDs = angular.copy($rootScope.user.associationIds);
				} else if ($rootScope.user.company && $rootScope.user.company.id) {
					$scope.oneCompanyMode = true;
					$scope.filter.companyID = $rootScope.user.company.id;
				}

				$scope.filterFirstPeriod = angular.copy($scope.filter);
				$scope.filterFirstPeriod.onlyAverage = true;
				$scope.filterSecondPeriod = angular.copy($scope.filterFirstPeriod);

			}

		}

		// window.mdSelectOnKeyDownOverride = function (event) {
		// 	event.stopPropagation();
		// };
	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.controller('automaticStatisticsController', automaticStatisticsController);

	/** @ngInject */
	function automaticStatisticsController($scope, statisticsService, modelService, companyService, STORAGE_PREFIX, STATISTICS_NATIONALITIES, $filter, $rootScope, toastr, $mdDialog, $mdSelect, $window) {
		$scope.statistics = [];
		$scope.yearValues = [];
		$scope.typesCompany = [];
		$scope.customYear = null;
		$scope.chart = null;
		$scope.year = null;
		$scope.filter = {
			typeID: null,
			year: null
		};
		var now = new Date();
		var lang;

		//For iput select year
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		var validateYearFormat = function (year) {
			if (year >= (now.getFullYear() - 100) && year <= (now.getFullYear() + 100)) {
				return true;
			}

			return false;
		};

		function initYears() {
			$scope.year = now.getFullYear();

			for (var i = -3; i <= 3; i++) {
				$scope.yearValues.push($scope.year + i);
			}
		}

		function initChartData() {
			initEmptyChart();
			for (var i = 0; i < $scope.statistics.length; i++) {
				$scope.chart.labels.push($filter('translate')('GENERAL.MONTH_NAMES.' + ($scope.statistics[i].month - 1)));
				$scope.chart.data[0].push($scope.statistics[i].nbrActiveCompanies);
				$scope.chart.data[1].push($scope.statistics[i].nbrActiveUsers);
			}
		}

		$scope.searchStatisticsCustomYear = function () {
			if (validateYearFormat($scope.customYear)) {
				$scope.year = 'custom';
				$scope.getStatistics();
				$mdSelect.hide();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		$scope.getStatistics = function () {
			var year;

			if ($scope.year === 'custom') {
				year = angular.copy($scope.customYear);
			} else if ($scope.year === 'all') {
				year = null;
			} else {
				year = angular.copy($scope.year);
			}

			$scope.filter.year = year;

			$scope.statistics = [];

			statisticsService.getStatisticsAutomatic($scope.filter).then(function (res) {
				console.log(res.data);
				if (res.data) {
					$scope.statistics = res.data;
					initChartData();
				} else {
					toastr.error($filter('translate')('STATISTICS.AUTOMATIC.TOAST.NO_GET'));
				}
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('STATISTICS.AUTOMATIC.TOAST.ERROR_GET'));
			});
		};

		function getCompanyTypes() {
			if ($rootScope.companiesMenus && $rootScope.companiesMenus.length > 0) {
				$scope.typesCompany = $rootScope.companiesMenus;
				console.log($scope.typesCompany);
			} else {
				modelService.getSubTypes('./api/rest/model/COMPANY_MODEL', lang, null).then(function (response) {
					//TYPE DE SOCIETE
					$scope.typesCompany = response.data;
				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}
		}

		function initEmptyChart() {
			$scope.chart = {
				data: [
					[],
					[]
				],
				labels: [],
				series: [$filter('translate')('STATISTICS.AUTOMATIC.TABLE.NBR_COMPANIES_ACTIVE'), $filter('translate')('STATISTICS.AUTOMATIC.TABLE.NBR_USERS_ACTIVE')],
				options: {
					scales: {
						yAxes: [{
								id: 'y-axis-1',
								type: 'linear',
								display: true,
								position: 'left'
							},
							{
								id: 'y-axis-2',
								type: 'linear',
								display: true,
								position: 'right'
							}
						]
					}
				},
				datasetOverride: [{
					yAxisID: 'y-axis-1'
				}, {
					yAxisID: 'y-axis-2'
				}]
			};
		}

		function init() {
			initEmptyChart();

			if (localStorage.getItem(STORAGE_PREFIX + 'language')) {
				lang = localStorage.getItem(STORAGE_PREFIX + 'language');

				if (!lang) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}
			} else {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			}

			initYears();
			$scope.getStatistics();
			getCompanyTypes();
		}

		init();
	}
})();

(function () {
    'use strict';

    angular.module('app.front').controller('SitesController', SitesController);

    function SitesController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, toastr, SitesManagementService, languageService, URL) {

        $scope.$mdDialog = $mdDialog;

        $scope.sites = [];
        $scope.site = {};

        $scope.languages = [];

        $scope.search = {};

        languageService.getLanguages().then(function (response) {
            $scope.languages = response.data;
        }).catch(function (error) {
            console.log(error);
        });

        SitesManagementService.findAll('sites').then(function (response) {
            $scope.sites = response.data;

            angular.forEach($scope.sites, function (itemSite, indexSite) {

                itemSite.languagesTmp = angular.copy(itemSite.languages);

                var _defaultLanguageFound = false;

                angular.forEach(itemSite.languagesTmp, function (itemLang, indexLang) {
                    if (itemSite.defaultLanguage && !_defaultLanguageFound && itemLang.key == itemSite.defaultLanguage.key) {
                        _defaultLanguageFound = true;
                        itemLang.defaultLanguage = true;
                    }
                    itemLang.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + itemLang.key);
                });

                if (itemSite.defaultLanguage && !_defaultLanguageFound) {
                    itemSite.defaultLanguage.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + itemSite.defaultLanguage.key);
                    itemSite.defaultLanguage.defaultLanguage = true;
                    itemSite.languagesTmp.push(angular.copy(itemSite.defaultLanguage));
                }

            });

        }).catch(function (error) {
            console.log(error);
        });

        $scope._dialogFn = function (site) {

            $scope.site = {};
            $scope.siteRS = {};
            if (site) {
                $scope.site = angular.copy(site);
                SitesManagementService.findById($scope.site.id).then(function (response) {
                    $scope.site.css = response.data.css;
                    $scope.site.footer = response.data.footer;
                }).catch(function () {

                });

                // Logo
                if ($scope.site.logo != null) {
                    $scope.site.src = URL.alternatedocroots + '/' + $scope.site.logo;
                }

                // Logo
                if ($scope.site.logoRS != null) {
                    $scope.siteRS.src = URL.alternatedocroots + '/' + $scope.site.logoRS;
                }

                SitesManagementService.findPagesBySiteID($scope.site.id).then(function (response) {
                    $scope.pages = response.data;
                }).catch(function (error) {
                    console.log(error);
                });

            }

            $timeout(function () {
                $scope.$mdDialog.show({
                    templateUrl: 'app/main/sites_management/sites/site.dialog.html',
                    preserveScope: true,
                    clickOutsideToClose: true,
                    scope: $scope,
                }).then(function (resp) {
                }).catch(function (err) {
                });
            });

        };

        $scope._save = function (_form) {

            _form.$setSubmitted();
            if (_form.$valid) {

                var fmData = new FormData();
                fmData.append('dto', angular.toJson($scope.site));
                var input = document.getElementById('site_logo');
                if (input != null && input.files != null && input.files.length > 0) {
                    fmData.append('file', input.files[0]);
                }

                var inputRS = document.querySelector('#site_logo_facebook');
                if (inputRS != null && inputRS.files != null && inputRS.files.length > 0) {
                    fmData.append('fileRS', inputRS.files[0]);
                }

                SitesManagementService.saveFd('site', fmData).then(function (response) {

                    response.data.languagesTmp = angular.copy(response.data.languages);

                    var _defaultLanguageFound = false;

                    angular.forEach(response.data.languagesTmp, function (itemLang, indexLang) {
                        if (response.data.defaultLanguage && !_defaultLanguageFound && itemLang.key == response.data.defaultLanguage.key) {
                            _defaultLanguageFound = true;
                            itemLang.defaultLanguage = true;
                        }
                        itemLang.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + itemLang.key);
                    });

                    if (response.data.defaultLanguage && !_defaultLanguageFound) {
                        response.data.defaultLanguage.libelle = $filter('translate')('SETTINGS.DATABASE.LANGUAGES.' + response.data.defaultLanguage.key);
                        response.data.defaultLanguage.defaultLanguage = true;
                        response.data.languagesTmp.push(angular.copy(response.data.defaultLanguage));
                    }


                    if ($scope.site.id) {
                        var index = $scope.sites.map(function (mapper) { return mapper.id; }).indexOf($scope.site.id);
                        if (index > -1) {
                            $scope.sites[index] = response.data;
                        }
                    } else {
                        $scope.sites.push(response.data);
                    }

                    _form.$setPristine();
                    _form.$setUntouched();
                    $mdDialog.cancel();
                }).catch(function (error) {
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                });

            }
        };

        $scope._delete = function () {
            SitesManagementService.delete('site', $scope.site.id).then(function (response) {
                var index = $scope.sites.map(function (mapper) { return mapper.id; }).indexOf($scope.site.id);
                if (index > -1) {
                    $scope.sites.splice(index, 1);
                }
                $mdDialog.cancel();
            }).catch(function (error) {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
            });
        };

    }

})();
(function () {
  'use strict';

  angular.module('app.front').controller('SiteMenuController', SiteMenuController);

  function SiteMenuController($scope, $rootScope, SitesManagementService, toastr, languageService, $filter) {
    $scope.sites = [];
    $scope.siteID = null;
    $scope.siteMenu = {};
    $scope.languages = [];
    $scope.language = {};
    $scope.pages = [];
    var emptyItem = {
      sideMenuID: null,
      level: 0,
      title: null,
      pageID: null,
      subItems: [],
      menuItemParentID: null
    };

    init();

    function init() {
      SitesManagementService.findAll('sites').then(function (res) {
        if (res.data) {
          $scope.sites = res.data;
        }
      }).catch(function (err) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });

      languageService.getLanguages().then(function (response) {
        $scope.languages = response.data;
        for (var i = 0; i < $scope.languages.length; i++) {
          var language = $scope.languages[i];
          if (language.preferred) {
            $scope.language.key = language.key;
            break;
          }
        }
      }).catch(function (error) {

      });
    }

    $scope.getSiteMenu = function () {
      SitesManagementService.findSiteMenuBySiteID($scope.siteID, $scope.language.key).then(function (res) {
        if (res.data) {
          $scope.siteMenu = res.data;
        }
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.getSitePages = function () {
      SitesManagementService.findPagesBySiteID($scope.siteID).then(function (res) {
        if (res.data) {
          $scope.pages = res.data;
        }
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.addItem = function (level, menuItemParentID) {
      var newItem = angular.copy(emptyItem);

      newItem.sideMenuID = $scope.siteMenu.id;
      newItem.level = level;
      newItem.menuItemParentID = menuItemParentID;

      SitesManagementService.saveSiteMenuItem(newItem, $scope.language.key).then(function (res) {
        if (level === 0) {
          $scope.siteMenu.items.push(res.data);
        } else if (level === 1) {
          for (var i = 0; i < $scope.siteMenu.items.length; i++) {
            if ($scope.siteMenu.items[i].id === menuItemParentID) {
              if (!$scope.siteMenu.items[i].subItems) {
                $scope.siteMenu.items[i].subItems = [];
              }

              $scope.siteMenu.items[i].subItems.push(res.data);
              break;
            }
          }
        } else if (level === 2) {
          for (var i = 0; i < $scope.siteMenu.items.length; i++) {
            for (var y = 0; y < $scope.siteMenu.items[i].subItems.length; y++) {
              if ($scope.siteMenu.items[i].subItems[y].id === menuItemParentID) {
                if (!$scope.siteMenu.items[i].subItems[y].subItems) {
                  $scope.siteMenu.items[i].subItems[y].subItems = [];
                }

                $scope.siteMenu.items[i].subItems[y].subItems.push(res.data);
              }
            }
          }
        }
        //$scope.getSiteMenu();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.saveItem = function (item) {
      SitesManagementService.saveSiteMenuItem(item, $scope.language.key).then(function (res) { }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.deleteItem = function (item) {
      if (item.id == null) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      }
      SitesManagementService.deleteSiteMenuItem(item.id).then(function (res) {
        $scope.getSiteMenu();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.downItem = function (item, indexItem, indexSubItem, indexSubSubItem) {
      var dto = angular.copy(item);
      dto.sideMenuID = $scope.siteMenu.id;
      SitesManagementService.downSiteMenuItem(dto).then(function (res) {
        reOrder(false, indexItem, indexSubItem, indexSubSubItem);
      }).catch(function (err) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        console.log(err);
      });
    };

    $scope.upItem = function (item, indexItem, indexSubItem, indexSubSubItem) {
      var dto = angular.copy(item);
      dto.sideMenuID = $scope.siteMenu.id;
      SitesManagementService.upSiteMenuItem(dto).then(function (res) {
        reOrder(true, indexItem, indexSubItem, indexSubSubItem);
      }).catch(function (err) {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        console.log(err);
      });
    };

    $scope.directUrlCheckboxChanged = function (item) {
      if (item.directUrl) {
        item.pageID = null;
      } else {
        item.url = null;
      }
    };

    function reOrder(up, indexItem, indexSubItem, indexSubSubItem) {
      var toMove;
      var toExchange;
      var indexAdd;

      if (up) {
        indexAdd = -1;
      } else {
        indexAdd = 1;
      }

      toMove = $filter('filter')($scope.siteMenu.items, {
        index: indexItem
      })[0];

      if (indexSubItem == null && indexSubSubItem == null) {
        toExchange = $filter('filter')($scope.siteMenu.items, {
          index: indexItem + indexAdd
        })[0];
      }

      if (indexSubItem != null) {
        if (indexSubSubItem == null) {
          toExchange = $filter('filter')(toMove.subItems, {
            index: indexSubItem + indexAdd
          })[0];
        }
        toMove = $filter('filter')(toMove.subItems, {
          index: indexSubItem
        })[0];
      }

      if (indexSubSubItem != null) {
        toExchange = $filter('filter')(toMove.subItems, {
          index: indexSubSubItem + indexAdd
        })[0];
        toMove = $filter('filter')(toMove.subItems, {
          index: indexSubSubItem
        })[0];
      }

      if (up) {
        toMove.index -= 1;
        toExchange.index += 1;
      } else {
        toExchange.index -= 1;
        toMove.index += 1;
      }

    }
  }
})();

(function () {
    'use strict';

    angular.module('app.front').controller('PagesController', PagesController);

    function PagesController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SitesManagementService) {

        $scope.pages = [];

        $scope.sites = [];
        $scope.blocs = [];

        $scope.search = {};

        // Sites
        SitesManagementService.findAll('sites').then(function(response){
            $scope.sites = response.data;
        }).catch(function(error){
            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });

        // Blocs
        SitesManagementService.findAll('blocs').then(function(response){
            $scope.blocs = response.data;
        }).catch(function(error){
            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });

        //Pages
        SitesManagementService.findAll('pages').then(function (response) {
            $scope.pages = response.data;
        }).catch(function (error) {
            console.log(error);
        });

        $scope._pageDetailsFn = function(id) {
            $state.go("app.pages.page", { id : id });
        };

    }
    
})();
(function () {
    'use strict';

    angular.module('app.front').controller('BlocsController', BlocsController);

    function BlocsController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, SitesManagementService) {

        $scope.blocs = [];

        $scope.types = SitesManagementService.getBlocTypes();

        $scope.search = {};

        SitesManagementService.findAll('blocs').then(function (response) {
            $scope.blocs = response.data;
        }).catch(function (error) {
            console.log(error);
        });

        $scope._blocDetailsFn = function(id) {
            $state.go("app.blocs.bloc", { id : id });
        };

    }
    
})();
(function () {
    'use strict';
  
    angular.module('app.front').service('ResearchPageCreationService', ResearchPageCreationService);
  
      function ResearchPageCreationService($q, $http){

        var service = {};
        
        service.fixeFields = function(){
            return $q(function(resolve, reject){
                $http({
                   url: './api/rest/ResearchPageCreationResources/fixeFields',
                    method: 'GET',
                    params: { '_v': new Date().getTime() }
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            });
        };

        service.findFilter = function(modelType, subTypeId, lang){
            return $q(function(resolve, reject){
                $http({
                    url: './api/rest/ResearchPageCreationResources/findFilter/',
                    method: 'GET',
                    params: { 
                        '_v': new Date().getTime(),
                        'modelType' : modelType, 
                        'subTypeId' : subTypeId, 
                        'lang': lang
                    }
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            });
        };

        service.findSort = function(modelType, subTypeId, lang){
            return $q(function(resolve, reject){
                $http({
                    url: './api/rest/ResearchPageCreationResources/findSort/',
                    method: 'GET',
                    params: { 
                        '_v': new Date().getTime(),
                        'modelType' : modelType, 
                        'subTypeId' : subTypeId, 
                        'lang': lang
                    }
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            });
        };

        service.find = function(modelType, subTypeId, config, lang){
            return $q(function(resolve, reject){
                $http({
                    url: './api/rest/ResearchPageCreationResources/',
                    method: 'GET',
                    params: { 
                        '_v': new Date().getTime(),  
                        'modelType' : modelType, 
                        'subTypeId' : subTypeId, 
                        'config' : config, 
                        'lang': lang 
                    }
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            });
        };

        service.save = function(resConfig){
            return $q(function(resolve, reject){
                $http({
                    url: './api/rest/ResearchPageCreationResources',
                    method: 'POST',
                    params: { '_v': new Date().getTime()},
                    data : resConfig
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            });
        };

        service.delete = function(resConfig){
            return $q(function(resolve, reject){
                $http({
                    url: './api/rest/ResearchPageCreationResources/' + resConfig.data.id,
                    method: 'DELETE',
                    params: { '_v': new Date().getTime(), 'config' : resConfig.config },
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            });
        };

        service.upField = function(resConfig) {
            return $q(function(resolve, reject) {
                $http({
                    url : './api/rest/ResearchPageCreationResources/upField/' + resConfig.data.id,
                    method: 'POST',
                    params: { '_v': new Date().getTime(), 'config' : resConfig.config }
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            })
        };

        service.downField = function(resConfig) {
            return $q(function(resolve, reject) {
                $http({
                    url : './api/rest/ResearchPageCreationResources/downField/' + resConfig.data.id,
                    method: 'POST',
                    params: { '_v': new Date().getTime(), 'config' : resConfig.config }
                }).then(function(response){
                    resolve(response);
                }).catch(function(response){
                    reject(response);
                });
            })
        };
    
        return service;

    }
  
})();
  
(function () {
	'use strict';

	angular.module('app.front').controller('ResearchPageCreationController', ResearchPageCreationController);

	function ResearchPageCreationController($rootScope, DISPLAY_MODELS_ICONS, STORAGE_PREFIX, $scope, $timeout, $filter, $state, $translate, toastr, modelService,
		ResearchPageCreationService, inscriptionFormService) {

		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.fields = [];
		$scope.filters = [];
		$scope.sorts = [];

		$scope.category = {};
		$scope.fieldsAvalaible = [];
		$scope.displaysModels = [];
		$scope.fieldToAdd = {};
		$scope.DISPLAY_MODELS_ICONS = DISPLAY_MODELS_ICONS;
		var dataReady = false;

		$scope.companyModelType = 'COMPANY_MODEL';
		$scope.contactModelType = 'CONTACT_MODEL';
		$scope.registrationModelType = 'INSCRIPTION_MODEL';
		$scope.logisticModelType = 'LOGISTIC_MODEL';

		$scope.modelType = $state.params.modelType;

		$scope.baseUrl = './api/rest/model/' + $state.params.modelType;

		$scope.newFieldToFilter = {};
		$scope.newFieldToSort = {};

		$scope.fieldsAndFiltersReady = {
			filters: false,
			sorts: false,
			fields: false
		};

		// Utils

		function removeUsedFields(_fields, _fieldsConf) {
			var _fieldsResult = [];
			if (_fields !== [] && _fieldsConf !== []) {
				var deleteIndex = [];
				_fieldsResult = angular.copy(_fields);
				angular.forEach(_fieldsResult, function (field, index) {
					angular.forEach(_fieldsConf, function (fieldConf) {
						if (field.id && fieldConf.fieldModelDto && fieldConf.fieldModelDto.id) {
							if (field.id === fieldConf.fieldModelDto.id) {
								deleteIndex.push(angular.copy(index));
							}
						}
						if (field.data && field.data.name && fieldConf.fixeFieldDto && fieldConf.fixeFieldDto.data && fieldConf.fixeFieldDto.data.name) {
							if (field.data.name === fieldConf.fixeFieldDto.data.name) {
								deleteIndex.push(angular.copy(index));
							}
						}
					});
				});
				var i = deleteIndex.length;
				while (i--) {
					_fieldsResult.splice(deleteIndex[i], 1);
				}
			}
			return _fieldsResult;
		};

		// Liste des champs

		if ($state.params.modelType == "COMPANY_MODEL") {
			modelService.listFieldsBySubType($state.params.modelType, $state.params.subTypeId, $translate.preferredLanguage()).then(function (resp) {
				// Liste des champs de modèle de company
				$scope.fields = $filter('filter')(resp.data, function (item) {
					return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT';
				});
				// For filter
				$scope.filterFields = angular.copy($scope.fields);
				// For sort
				$scope.sortFields = $filter('filter')(resp.data, function (item) {
					return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' &&
						item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT';
				});
				// For wiew
				$scope.columnFields = $filter('filter')(resp.data, function (item) {
					return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' &&
						item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT' && item.typeChamps !== 'LONG_TEXT';
				});
				// Ajout champ fixe actif/inactif
				$scope.columnFields.push({
					index: $scope.columnFields.lenght + 1,
					libelle: angular.copy($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_STATUS')),
					data: 'FIXE_FIELD_STATUS',
				});
				// Liste des champs fixe (Activé/Désactivé, List de contact, champs de l'entité disposition, etc ...) pour le filtre sur les companies
				ResearchPageCreationService.fixeFields().then(function (resp) {
					angular.forEach(resp.data, function (item, index) {
						if (item.name != 'FIXE_FIELD_CREATION_DATE' && item.name != 'FIXE_FIELD_MODIFICATION_DATE' &&
							item.name != 'FIXE_FIELD_CREATION_DATE_CONTACT' && item.name != 'FIXE_FIELD_MODIFICATION_DATE_CONTACT' &&
							item.name != 'FIXE_FIELD_REGISTRATION_SUBCATEGORY' &&
							item.name != 'FIXE_FIELD_LOGISTIC_STATUS' &&
							item.name != 'FIXE_FIELD_REGISTRATION_STATUS') {
							var _fixeFieldLibelle = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.' + item.name;
							var _fixeField = {
								index: $scope.fields.length + 1,
								libelle: angular.copy($filter('translate')(_fixeFieldLibelle)),
								data: angular.copy(item),
							};
							$scope.filterFields.push(_fixeField);
						}
					});
					// Liste des champs de modèle de contact
					modelService.listFieldsByType($scope.contactModelType, $translate.preferredLanguage()).then(function (resp) {
						$scope.contactFields = $filter('filter')(resp.data, function (item) {
							return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
						});
						angular.forEach($scope.contactFields, function (item, index) {
							$scope.filterFields.push(angular.copy(item));
						});
						// All xhr async process end
						$scope.fieldsAndFiltersReady.fields = true;
						if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.filters) {
							$scope.fieldsForFiltersFiltered = removeUsedFields($scope.filterFields, $scope.filters);
						}
						if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.sorts) {
							$scope.fieldsForSortsFiltered = removeUsedFields($scope.sortFields, $scope.sorts);
						}
						if (dataReady) {
							filterFieldsFn();
						} else {
							dataReady = true;
						}
					}).catch(function (error) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
						console.log(error);
					});
				}).catch(function (error) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(error);
				});
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(error);
			});
		} else if ($state.params.modelType == "INSCRIPTION_MODEL") {
			modelService.listFieldsByType($scope.registrationModelType, $translate.preferredLanguage()).then(function (resp) {
				$scope.fields = $filter('filter')(resp.data, function (item) {
					return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT';
				});
				$scope.filterFields = angular.copy($scope.fields);
				$scope.sortFields = $filter('filter')(resp.data, function (item) {
					return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' &&
						item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT';
				});
				$scope.columnFields = $filter('filter')(resp.data, function (item) {
					return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' &&
						item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT' && item.typeChamps !== 'LONG_TEXT';
				});
				modelService.listFieldsByType($scope.logisticModelType, $translate.preferredLanguage()).then(function (resp) {
					angular.forEach(resp.data, function (item, index) {
						if (item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT') {
							$scope.filterFields.push(angular.copy(item));
						}
						if (item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' &&
							item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT') {
							$scope.sortFields.push(angular.copy(item));
						}
						if (item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' &&
							item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT' && item.typeChamps !== 'LONG_TEXT') {
							$scope.columnFields.push(angular.copy(item));
						}
					});
					modelService.listFieldsByType($scope.companyModelType, $translate.preferredLanguage()).then(function (resp) {
						angular.forEach(resp.data, function (item, index) {
							if (item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT') {
								$scope.filterFields.push(angular.copy(item));
							}
							if (item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' &&
								item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT') {
								$scope.sortFields.push(angular.copy(item));
							}
							if (item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' &&
								item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT' && item.typeChamps !== 'LONG_TEXT') {
								$scope.columnFields.push(angular.copy(item));
							}
						});
						modelService.listFieldsByType($scope.contactModelType, $translate.preferredLanguage()).then(function (resp) {
							angular.forEach(resp.data, function (item, index) {
								if (item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT') {
									$scope.filterFields.push(angular.copy(item));
								}
								if (item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' &&
									item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT') {
									$scope.sortFields.push(angular.copy(item));
								}
								if (item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'OBJECT' &&
									item.typeChamps !== 'URL' && item.typeChamps !== 'MULTIPLE_SELECT' && item.typeChamps !== 'LONG_TEXT') {
									$scope.columnFields.push(angular.copy(item));
								}
							});
							// Registration Form Sub-Category
							var _fixeFieldRegistrationSubCat = {
								id: -1,
								index: $scope.fields.length + 1,
								libelle: $filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_REGISTRATION_SUBCATEGORY'),
								data: {
									name: "FIXE_FIELD_REGISTRATION_SUBCATEGORY",
									type: "MULTIPLE_SELECT",
									clazz: "InscriptionSubCategory"
								},
								fixField: true,
								fixFieldKey: "FIXE_FIELD_REGISTRATION_SUBCATEGORY"
							};
							$scope.filterFields.push(_fixeFieldRegistrationSubCat);
							// $scope.sortFields.push(_fixeFieldRegistrationSubCat);
							$scope.columnFields.push(_fixeFieldRegistrationSubCat);
							// Logistic status
							var _fixeFieldLogistiqueStatus = {
								id: -2,
								index: $scope.fields.length + 2,
								libelle: $filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_LOGISTIC_STATUS'),
								data: {
									name: "FIXE_FIELD_LOGISTIC_STATUS",
									type: "MULTIPLE_SELECT",
									clazz: "LogisticalStatus"
								},
								fixField: true,
								fixFieldKey: "FIXE_FIELD_LOGISTIC_STATUS"
							};
							$scope.filterFields.push(_fixeFieldLogistiqueStatus);
							// $scope.sortFields.push(_fixeFieldLogistiqueStatus);
							$scope.columnFields.push(_fixeFieldLogistiqueStatus);
							// Registration Status
							var _fixeFieldRegistrationStatus = {
								id: -3,
								index: $scope.fields.length + 3,
								libelle: $filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_REGISTRATION_STATUS'),
								data: {
									name: "FIXE_FIELD_REGISTRATION_STATUS",
									type: "MULTIPLE_SELECT",
									clazz: "InscriptionStatus"
								},
								fixField: true,
								fixFieldKey: "FIXE_FIELD_REGISTRATION_STATUS"
							};
							$scope.filterFields.push(_fixeFieldRegistrationStatus);
							// $scope.sortFields.push(_fixeFieldRegistrationStatus);
							$scope.columnFields.push(_fixeFieldRegistrationStatus);

							// Events
							var _fixeFieldEventName = {
								id: -4,
								index: $scope.fields.length + 4,
								libelle: $filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_EVENT'),
								data: {
									name: "FIXE_FIELD_EVENT",
									type: "MULTIPLE_SELECT",
									clazz: "Event"
								},
								fixField: true,
								fixFieldKey: "FIXE_FIELD_EVENT"
							};
							$scope.filterFields.push(_fixeFieldEventName);
							// $scope.sortFields.push(_fixeFieldEventName);
							$scope.columnFields.push(_fixeFieldEventName);

							// Company types
							var _fixeFieldCompanySubTypes = {
								id: -5,
								index: $scope.fields.length + 5,
								libelle: $filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_COMPANY_SUBTYPES'),
								data: {
									name: "FIXE_FIELD_COMPANY_SUBTYPES",
									type: "MULTIPLE_SELECT",
									clazz: "Company"
								},
								fixField: true,
								fixFieldKey: "FIXE_FIELD_COMPANY_SUBTYPES"
							};
							$scope.filterFields.push(_fixeFieldCompanySubTypes);
							// $scope.sortFields.push(_fixeFieldEventName);
							$scope.columnFields.push(_fixeFieldCompanySubTypes);


							// All xhr async process end
							$scope.fieldsAndFiltersReady.fields = true;
							if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.filters) {
								$scope.fieldsForFiltersFiltered = removeUsedFields($scope.filterFields, $scope.filters);
							}
							if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.sorts) {
								$scope.fieldsForSortsFiltered = removeUsedFields($scope.sortFields, $scope.sorts);
							}
							if (dataReady) {
								filterFieldsFn();
							} else {
								dataReady = true;
							}
						}).catch(function (error) {
							toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
							console.log(error);
						});
					}).catch(function (error) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
						console.log(error);
					});
				}).catch(function (error) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					console.log(error);
				});
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(error);
			});
			/*inscriptionFormService.listAllFields($translate.preferredLanguage(), true).then(function (resp) {
			//modelService.listFieldsByType($state.params.modelType, $translate.preferredLanguage()).then(function (resp) {
			  $scope.fields = $filter('filter')(resp.data, function (item) {
			      return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
			  });
			  // for filter
			  $scope.filterFields = angular.copy($scope.fields);
			  // For sort
			  $scope.sortFields = $filter('filter')(resp.data, function (item) {
			    return item.typeChamps !== 'MULTIPLE_SELECT';
			  });
			  // For wiew
			  $scope.columnFields = $filter('filter')(resp.data, function (item) {
			    return item.typeChamps !== 'LONG_TEXT' && item.typeChamps !== 'MULTIPLE_SELECT';
			  });
			  $scope.fieldsAndFiltersReady.fields = true;
			  if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.filters) {
			    $scope.fieldsForFiltersFiltered = removeUsedFields($scope.filterFields, $scope.filters);
			  }
			  if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.sorts) {
			    $scope.fieldsForSortsFiltered = removeUsedFields($scope.sortFields, $scope.sorts);
			  }
			  if (dataReady) {
			    filterFieldsFn();
			  } else {
			    dataReady = true;
			  }
			}).catch(function (error) {
			  toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			  console.log(error);
			});*/
		}

		// List des filtres
		$scope.listFilters = function () {
			ResearchPageCreationService.find($state.params.modelType, $state.params.subTypeId, 'FILTER', $translate.preferredLanguage()).then(function (resp) {
				$scope.filters = resp.data;
				angular.forEach($scope.filters, function (item, index) {
					if (item.baseType == "FIXE_FIELD") {
						var _fixeFieldLibelle = 'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.' + item.fixeFieldDto.data.name;
						item.fixeFieldDto.libelle = angular.copy(_fixeFieldLibelle);
					}
				});
				$scope.newFieldToFilter = {};
				$scope.fieldsAndFiltersReady.filters = true;
				if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.filters) {
					$scope.fieldsForFiltersFiltered = removeUsedFields($scope.filterFields, $scope.filters);
				}
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};
		$scope.listFilters();

		// List des tris
		$scope.listSorting = function () {
			ResearchPageCreationService.find($state.params.modelType, $state.params.subTypeId, 'SORT', $translate.preferredLanguage()).then(function (resp) {
				$scope.sorts = resp.data;
				$scope.newFieldToSort = {};
				$scope.fieldsAndFiltersReady.sorts = true;
				if ($scope.fieldsAndFiltersReady.fields && $scope.fieldsAndFiltersReady.sorts) {
					$scope.fieldsForSortsFiltered = removeUsedFields($scope.sortFields, $scope.sorts);
				}
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};
		$scope.listSorting();

		// Ajouter un champs aux filtres/tris
		$scope.save = function (resConfig) {
			resConfig.data = {};
			resConfig.data.modelType = $scope.modelType;

			// Sub type
			if ($scope.modelType == 'COMPANY_MODEL') {
				resConfig.data.modelSubTypeDto = {
					id: $state.params.subTypeId
				};
			}

			if (resConfig.config == 'FILTER') {
				// Field type
				if ($scope.newFieldToFilter.data.modelType) {
					resConfig.data.baseType = 'MODEL_FIELD';
					resConfig.data.fieldModelDto = $scope.newFieldToFilter.data;
				} else {
					resConfig.data.baseType = 'FIXE_FIELD';
					resConfig.data.fixeFieldDto = $scope.newFieldToFilter.data;
				}
				// Index
				resConfig.data.index = $scope.filters.length + 1;
				// Default size : 25%
				resConfig.data.size = 25;

			} else if (resConfig.config == 'SORT') {
				// Field type
				if ($scope.newFieldToSort.data.modelType) {
					resConfig.data.baseType = 'MODEL_FIELD';
					resConfig.data.fieldModelDto = $scope.newFieldToSort.data;
				} else {
					resConfig.data.baseType = 'FIXE_FIELD';
					resConfig.data.fixeFieldDto = $scope.newFieldToSort.data;
				}
				// Index
				resConfig.data.index = $scope.sorts.length + 1;
			}

			ResearchPageCreationService.save(resConfig).then(function (resp) {
				if (resConfig.config == 'FILTER') {
					$scope.listFilters();
				} else if (resConfig.config == 'SORT') {
					$scope.listSorting();
				}
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		// Supprimer un config
		$scope.delete = function (resConfig) {
			ResearchPageCreationService.delete(resConfig).then(function (resp) {
				if (resConfig.config == 'FILTER') {
					$scope.listFilters();
					$scope.fieldsForFiltersFiltered = removeUsedFields($scope.fields, $scope.filters);
				} else if (resConfig.config == 'SORT') {
					$scope.listSorting();
					$scope.fieldsForSortsFiltered = removeUsedFields($scope.sortFields, $scope.sorts);
				}
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		// Monter un champ
		$scope.upFieldFilterOrSort = function (resConfig) {
			ResearchPageCreationService.upField(resConfig).then(function (resp) {
				if (resConfig.config == 'FILTER') {
					$scope.listFilters();
				} else if (resConfig.config == 'SORT') {
					$scope.listSorting();
				}
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		// Descendre un champ
		$scope.downFieldFilterOrSort = function (resConfig) {
			ResearchPageCreationService.downField(resConfig).then(function (resp) {
				if (resConfig.config == 'FILTER') {
					$scope.listFilters();
				} else if (resConfig.config == 'SORT') {
					$scope.listSorting();
				}
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		/* COLUMNS CONFIGURATION */
		$scope.refreshColumnsDrawTokens = function () {
			modelService.listColumnsDrawTokens($scope.baseUrl, $state.params.subTypeId, $translate.preferredLanguage()).then(function (response) {
				$scope.columns = response.data;
			}).catch(function (response) {

			});
		};
		$scope.refreshColumnsDrawTokens();

		$scope.addToColumn = function (column) {
			if (column.selectedField != null) {
				var dto = {};
				if (column.selectedField.fixField) {
					dto = {
						columnIndex: column.columnIndex,
						fixField: true,
						fixFieldKey: column.selectedField.fixFieldKey
					};
				} else {
					dto = {
						columnIndex: column.columnIndex,
						fixField: false,
						field: angular.copy(column.selectedField),
					};
				}
				modelService.addFieldToColumnDrawToken($scope.baseUrl, $state.params.subTypeId, dto).then(function (response) {
					column.selectedField = {};
					$scope.refreshColumnsDrawTokens();
				}).catch(function (response) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}
		};

		$scope.removeFromColumn = function (id) {
			modelService.deleteColumnDrawToken($scope.baseUrl, id).then(function () {
				$scope.refreshColumnsDrawTokens();
			}).catch(function () {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.upField = function (data) {
			modelService.upFieldColumnDrawToken($scope.baseUrl, data).then(function () {
				$scope.refreshColumnsDrawTokens();
			}).catch(function () {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.downField = function (data) {
			modelService.downFieldColumnDrawToken($scope.baseUrl, data).then(function () {
				$scope.refreshColumnsDrawTokens();
			}).catch(function () {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		init();

		$scope.addField = function () {
			if (!$scope.fieldToAdd.field) {
				toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_SELECT_FIELD'));
				return;
			}
			var dto = {
				subTypeID: $state.params.subTypeId,
				fieldModel: angular.copy($scope.fieldToAdd.field)
			};
			$scope.fieldToAdd = {};
			modelService.postDisplay(dto, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
				init();
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_ADD'));
				init();
			});
		};

		$scope.removeField = function (field) {
			if (!field || !field.id || !field.subTypeID) {
				toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
				return;
			}
			modelService.removeDisplay(field.subTypeID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
				console.log($scope.category.fields);
				if (res.data) {
					$scope.displaysModels = res.data;
				}
				filterFieldsFn();
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_DELETE'));
			});
		};

		$scope.goUp = function (field) {
			if (!field || !field.id || !field.subTypeID) {
				toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
				return;
			}
			modelService.upDisplay(field.subTypeID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
				console.log($scope.category.fields);
				if (res.data) {
					$scope.displaysModels = res.data;
				}
				filterFieldsFn();
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_MOVE'));
			});
		};

		$scope.goDown = function (field) {
			if (!field || !field.id || !field.subTypeID) {
				toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
				return;
			}
			modelService.downDisplay(field.subTypeID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
				console.log($scope.category.fields);
				if (res.data) {
					$scope.displaysModels = res.data;
				}
				filterFieldsFn();
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_MOVE'));
			});
		};

		$scope.setIcon = function (field) {
			if (!field || !field.id) {
				toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
				return;
			}
			modelService.setIconDisplay(field).then(function (res) {}).catch(function (err) {
				toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_ICON'));
			});
		};

		function getDisplays() {
			modelService.getDisplays($state.params.subTypeId, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
				if (res.data) {
					$scope.displaysModels = res.data;
				}
				if (dataReady) {
					filterFieldsFn();
				} else {
					dataReady = true;
				}
				console.log(res.data);
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_GET'));
			});
		}

		function filterFieldsFn() {
			$scope.fieldsAvalaible = [];
			console.log($scope.fields);
			if ($scope.fields) {
				for (var i = 0; i < $scope.fields.length; i++) {
					if (!$scope.fields[i].data || $scope.fields[i].data.substring(0, 4) !== 'FIXE') {
						$scope.fields[i].alreadyHere = false;
						for (var j = 0; j < $scope.displaysModels.length; j++) {
							if ($scope.fields[i].id === $scope.displaysModels[j].fieldModel.id) {
								$scope.fields[i].alreadyHere = true;
							}
						}
						if (!$scope.fields[i].alreadyHere) {
							$scope.fieldsAvalaible.push(angular.copy($scope.fields[i]));
						}
					}
				}
			} else {
				toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_NO_FIELD'));
			}
			dataReady = false;
		}

		function init() {
			getDisplays();
		}

	}

})();

(function () {
  'use strict';

  angular.module('app.front').service('SettingsMessageService', ['$q', '$http', function ($q, $http) {
    var baseUrl = './api/rest/message';
    return {
      saveAction: function (action, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+'/action',
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: action
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findAllAction: function (lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+'/action/findAll',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      deleteAction: function (actionId) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+'/action/'+actionId,
            method: 'DELETE',
            params: {
              '_v': new Date().getTime(),
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      upAction: function (id, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/action/up/'+id,
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      downAction: function (id, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/action/down/' + id,
            method: 'PUT',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
    };
  }]);

})();

(function () {
  'use strict';

  angular.module('app.front').controller('MessageSettingsController', MessageSettingsController);

  function MessageSettingsController($rootScope, $scope, $timeout, toastr, SettingsMessageService, languageService, $filter) {
    $scope.language = {};
    $scope.languages = [];
    $scope.action = {};
    $scope.actions = [];
    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }
      $scope.$watch('language.key', function () {
        $scope.showForm = false;
        // $scope.findAllArticles($scope.language.key);
        $scope.findAllAction();
      });
    }).catch(function (error) {

    });

    $scope.findAllAction = function () {
      SettingsMessageService.findAllAction($scope.language.key).then(function (actions) {
        $scope.actions = actions.data;
      }).catch(function (data) {

      });
    };

    $scope.saveAction = function (action, form) {
      SettingsMessageService.saveAction(action, $scope.language.key).then(function (data) {
        $scope.findAllAction();
        $scope.action = {};
        if (form) {
          form.$setUntouched();
          form.$setPristine();
        }
      }).catch(function (data) {

      });
    };

    $scope.upAction = function(id){
      SettingsMessageService.upAction(id, $scope.language.key).then(function(response){
        $scope.actions = response.data;
      }).catch(function(){

      });
    };

    $scope.downAction = function(id){
      SettingsMessageService.downAction(id, $scope.language.key).then(function (response) {
        $scope.actions = response.data;
      }).catch(function () {

      });
    };


    $scope.removeAction = function (action) {
      var content = {
        title: $filter('translate')('SETTINGS.MESSAGE.CREATION_ACTION.DELETE_ACTION'),
        message: $filter('translate')('SETTINGS.MESSAGE.CREATION_ACTION.CONFIRM_DELETE_ACTION')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        // $rootScope.$broadcast('HandDrawTokenList');
        SettingsMessageService.deleteAction(action.id).then(function (response) {
          $scope.findAllAction();
        }).catch(function (response) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }).catch(function () {

      });

    };
  }
})();

(function () {
  'use strict';

	angular.module('app.front').service('languageService', languageService);

	function languageService($q, $http){
		var service = {};

		service.getLanguages = function(){
			return $q(function(resolve, reject){
				$http({
					url: './api/rest/language/all',
					method: 'GET',
					params: {'_v': new Date().getTime(), 'activated': true}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('databaseContactsController', databaseContactsController);

	function databaseContactsController($rootScope, $scope, $timeout, toastr, modelService, languageService) {
		$scope.modelType = 'CONTACT_MODEL';
		$scope.baseUrl = './api/rest/model/' + $scope.modelType;

		$scope.helpModelTitle = 'Aide sur la gestion des champs des modèles de contact';
		$scope.helpModelContent = 'Dans cette partie il faut renseigner les champs qui seront demandés lors de la création d\'un nouveau modèle de dossier.' + ' L\'objectif est de définir un modèle représentant au mieux les contacts et leurs attributs.';
		$scope.drawTokenTitle = 'Affichage des contacts de dossier (à traduire)';
		$scope.helpDrawTokenTitle = 'Aide sur la gestion de l\'affichage des modèles de dossier';
		$scope.helpDrawTokenContent = 'Cette partie permet de gérer l\'affichage d\'un modèle de contact dans les listes de selection des contacts.';
		$scope.language = {};
		$scope.categories = [];

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.initCategories();
			});
		}).catch(function (error) {

		});
		
		$scope.$on('refreshCategories', function () {
			$scope.initCategories();
		});

		$scope.initCategories = function () {
			modelService.getCategories($scope.baseUrl, $scope.language.key).then(function (response) {
				$scope.categories = response.data;
				$scope.$broadcast('categoriesLoaded');
			}).catch(function (response) {
				toastr.error('Impossible de lister les catégories !');
			});
		};




	}
})();
(function () {
	'use strict';

	angular.module('app.front').controller('databaseCompaniesTypesController', databaseCompaniesTypesController);

	function databaseCompaniesTypesController($scope, toastr, languageService, modelService) {
		$scope.language = {};
		$scope.types = [];
		$scope.modelType = 'COMPANY_MODEL';
		$scope.baseUrl = './api/rest/model/' + $scope.modelType;

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.initSubTypes();
			});
		}).catch(function (error) {

		});

		$scope.initSubTypes = function () {
			modelService.getSubTypes($scope.baseUrl, $scope.language.key, null, true).then(function (response) {
				$scope.types = response.data;
			}).catch(function () {
				toastr.error('Impossible de lister les types !');
			});
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('databaseCompaniesController', databaseCompaniesController);

	function databaseCompaniesController($rootScope, $scope, $timeout, $filter, toastr, modelService, languageService){
		$scope.modelType = 'COMPANY_MODEL';
		$scope.baseUrl = './api/rest/model/' + $scope.modelType;

		$scope.modelTitle = 'Gestion des modèles de dossier';
		$scope.helpModelTitle = 'Aide sur la gestion des champs des modèles de dossier';
		$scope.helpModelContent = 'Dans cette partie il faut renseigner les champs qui seront demandés lors de la création d\'un nouveau modèle de dossier.'+ ' L\'objectif est de définir un modèle représentant au mieux les dossiers et leurs attributs.';
		$scope.drawTokenTitle = 'Affichage des modèles de dossier  (à traduire)';
		$scope.helpDrawTokenTitle = 'Aide sur la gestion de l\'affichage des modèles de dossier';
		$scope.helpDrawTokenContent = 'Cette partie permet de gérer l\'affichage d\'un modèle de dossier dans les listes de selection des dossiers.';
		$scope.language = {};
		$scope.categories = [];

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.initCategories();
			});
		}).catch(function (error) {

		});

		$scope.$on('refreshCategories', function(){
			$scope.initCategories();
		});


		$scope.initCategories = function(){
			modelService.getCategories($scope.baseUrl, $scope.language.key).then(function(response){
				$scope.categories = response.data;
				$scope.$broadcast('categoriesLoaded');
			}).catch(function(response){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};




	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('databaseController', databaseController);

	function databaseController($rootScope, $scope, languageService){
		
	}
})();
(function () {
  'use strict';
  angular.module('app.front').controller('databaseContactsSettingsController', databaseContactsSettingsController);

  function databaseContactsSettingsController($scope, $translate, $filter, toastr, STORAGE_PREFIX, DISPLAY_MODELS_ICONS, modelService, ResearchPageCreationService) {
    $scope.modelType = 'CONTACT_MODEL';
    $scope.baseUrl = './api/rest/model/' + $scope.modelType;

    window.mdSelectOnKeyDownOverride = function (event) {
      event.stopPropagation();
    };

    // Liste des champs       
    modelService.listFieldsByType($scope.modelType, $translate.preferredLanguage()).then(function (resp) {
      $scope.fields = $filter('filter')(resp.data, function (item) {
        return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
      });
      $scope.columnFields = angular.copy($scope.fields);
      
      // Ajout champ fixe actif/inactif
      $scope.columnFields.push({
        index: $scope.columnFields.lenght + 1,
        libelle: angular.copy($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_STATUS')),
        data: 'FIXE_FIELD_STATUS',
      });

      if (dataReady) {
        filterFields();
      } else {
        dataReady = true;
      }

    }).catch(function (error) {
      toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      console.log(error);
    });

    /* COLUMNS CONFIGURATION */
    $scope.refreshColumnsDrawTokens = function () {
      modelService.listColumnsDrawTokens($scope.baseUrl, null, $translate.preferredLanguage()).then(function (response) {
        $scope.columns = response.data;
      }).catch(function (response) {

      });
    };
    $scope.refreshColumnsDrawTokens();

    $scope.addToColumn = function (column) {
      if (column.selectedField != null) {
        var dto = {
          columnIndex: column.columnIndex,
          field: angular.copy(column.selectedField),
        };
        modelService.addFieldToColumnDrawToken($scope.baseUrl, null, dto).then(function (response) {
          column.selectedField = {};
          $scope.refreshColumnsDrawTokens();
        }).catch(function (response) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }
    };

    $scope.removeFromColumn = function (id) {
      modelService.deleteColumnDrawToken($scope.baseUrl, id).then(function () {
        $scope.refreshColumnsDrawTokens();
      }).catch(function () {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.upField = function (id) {
      modelService.upFieldColumnDrawToken($scope.baseUrl, id).then(function () {
        $scope.refreshColumnsDrawTokens();
      }).catch(function () {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.downField = function (id) {
      modelService.downFieldColumnDrawToken($scope.baseUrl, id).then(function () {
        $scope.refreshColumnsDrawTokens();
      }).catch(function () {
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.category = {};
    $scope.fieldsAvalaible = [];
    $scope.fields = [];
    $scope.displaysModels = [];
    $scope.fieldToAdd = null;
    $scope.DISPLAY_MODELS_ICONS = DISPLAY_MODELS_ICONS;
    var dataReady = false;

    init();

    $scope.addField = function () {
      if (!$scope.fieldToAdd) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_SELECT_FIELD'));
        return;
      }
      var dto = {
        subTypeID: null,
        fieldModel: angular.copy($scope.fieldToAdd)
      };
      $scope.fieldToAdd = null;
      modelService.postDisplay(dto, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        init();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_ADD'));
        init();
      });
    };

    $scope.removeField = function (field) {
      if (!field || !field.id) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
        return;
      }

      modelService.removeDisplay(field.subTypeID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        console.log($scope.category.fields);
        if (res.data) {
          $scope.displaysModels = res.data;
        }

        filterFields();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_DELETE'));
      });
    };

    $scope.goUp = function (field) {
      if (!field || !field.id) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
        return;
      }

      modelService.upDisplay(null, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        console.log($scope.category.fields);
        if (res.data) {
          $scope.displaysModels = res.data;
        }

        filterFields();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_MOVE'));
      });
    };

    $scope.goDown = function (field) {
      if (!field || !field.id) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
        return;
      }

      modelService.downDisplay(null, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        console.log($scope.category.fields);
        if (res.data) {
          $scope.displaysModels = res.data;
        }

        filterFields();
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_MOVE'));
      });
    };

    $scope.setIcon = function (field) {
      if (!field || !field.id) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_WITH_THIS_FIELD'));
        return;
      }

      modelService.setIconDisplay(field).then(function (res) {

      }).catch(function (err) {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_ICON'));
      });
    };

    function getDisplays() {
      modelService.getDisplays(null, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
        if (res.data) {
          $scope.displaysModels = res.data;
        }

        if (dataReady) {
          filterFields();
        } else {
          dataReady = true;
        }
        console.log(res.data);
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_GET'));
      });
    }

    function filterFields() {
      $scope.fieldsAvalaible = [];
      console.log($scope.fields);
      if ($scope.fields) {
        for (var i = 0; i < $scope.fields.length; i++) {
          if (!$scope.fields[i].data || $scope.fields[i].data.substring(0, 4) !== 'FIXE') {
            $scope.fields[i].alreadyHere = false;
            for (var j = 0; j < $scope.displaysModels.length; j++) {
              if ($scope.fields[i].id === $scope.displaysModels[j].fieldModel.id) {
                $scope.fields[i].alreadyHere = true;
              }
            }
            if (!$scope.fields[i].alreadyHere) {
              $scope.fieldsAvalaible.push(angular.copy($scope.fields[i]));
            }
          }
        }
      } else {
        toastr.error($filter('translate')('SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.ERROR_NO_FIELD'));
      }

      dataReady = false;
    }

    function init() {
      getDisplays();
    }

  }
})();

(function(){
	'use strict';

	angular.module('app.front').controller('companiesSettingsController', companiesSettingsController);

	function companiesSettingsController($rootScope, $scope, $translate, $stateParams, $filter, toastr, modelService){
		$scope.modelType = 'COMPANY_MODEL';
		$scope.baseUrl = './api/rest/model/' + $scope.modelType;

		$scope.companyEmail = [];
		modelService.listFieldsByType($scope.modelType, $translate.preferredLanguage()).then(function(response){
			$scope.fields = response.data;
			$scope.fields.forEach(function(item, index){
				if(item.typeChamps == 'EMAIL'){
					$scope.companyEmail.push(item);
				}
			});
		}).catch(function(response){
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		modelService.getCategoriesOnly($scope.baseUrl, $translate.preferredLanguage()).then(function (response) {
			$scope.categories = response.data;
		}).catch(function (response) {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		modelService.listSpecifics($scope.baseUrl, $translate.preferredLanguage()).then(function(response){
			$scope.specifics = response.data;
		}).catch(function(){
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		$scope.translate = function(specific){
			return $filter('translate')('SETTINGS.DATABASE.COMPANIES.' + specific.type);
		};

		$scope.saveLink = function(){
			modelService.saveSpecifics($scope.baseUrl, $scope.specifics).then(function(response){
				toastr.success($filter('translate')('SETTINGS.DATABASE.COMPANIES.SUCCESS_SAVE_SETTINGS'));
			}).catch(function(response){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('MembersController', MembersController);

	function MembersController($scope, $translate, RequestForProposalService,
		$filter, $rootScope, toastr, $mdDialog, $mdSelect, $window, $state) {

			var now = new Date();

			$scope.members = [];
			$scope.filterModes = [{
				key: 'DAY',
				value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.DAY')
			},
			//{ key : 'WEEK', value : $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.WEEK') },
			{
				key: 'MONTH',
				value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.MONTH')
			},
			{
				key: 'YEAR',
				value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.YEAR')
			},
			{
				key: 'PERIOD',
				value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.PERIOD')
			}
		];

		$scope.filter = {
			// mode: 'DAY',
			// begin: {
			// 	year: now.getFullYear(),
			// 	month: now.getMonth(),
			// 	date: now
			// },
			// end: {
			// 	year: now.getFullYear(),
			// 	month: now.getMonth(),
			// 	date: now
			// },
			rfpID: null,
			// secondPeriod: {
			// 	checked:false,
			// 	mode: 'DAY',
			// 	begin: {
			// 		year: now.getFullYear(),
			// 		month: now.getMonth(),
			// 		date: now
			// 	},
			// 	end: {
			// 		year: now.getFullYear(),
			// 		month: now.getMonth(),
			// 		date: now
			// 	}
			// }
		};

		$scope.getMembers = function(){
			RequestForProposalService.getMembers($scope.filter).then(function(res){
				$scope.members = res.data;
			}).catch(function(err){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			})
		}
		$scope.getMembers();

		$scope.goToDetails = function(member){
			$state.go('app.rfp.members.details',{
				id: member.id
			})
		}
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('RequestForProposalCompanyController', RequestForProposalCompanyController);

	function RequestForProposalCompanyController($scope, userService, $translate, $q, RequestForProposalService, modelService, companyService, BlogService,
		$filter, $rootScope, toastr, $mdDialog, $mdSelect, $window, STORAGE_PREFIX, SitesManagementService, $timeout) {

		$scope.userService = userService;
		//Useful variables
		var now = new Date();
		var langage = localStorage[STORAGE_PREFIX + 'language'];
		var timeoutCanceler = $q.defer();

		$scope.array = [];
		$scope.wins = 0;
		$scope.lost = 0;
		$scope.participants = 0;

		$scope.filterModes = [{
				key: 'DAY',
				value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.DAY')
			},
			{ key : 'WEEK', value : $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.WEEK') },
			{
				key: 'MONTH',
				value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.MONTH')
			},
			{
				key: 'YEAR',
				value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.YEAR')
			},
			{
				key: 'PERIOD',
				value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.PERIOD')
			}
		];

		$scope.filter = {
			mode: 'DAY',
			begin: {
				year: now.getFullYear(),
				month: now.getMonth(),
				date: now
			},
			end: {
				year: now.getFullYear(),
				month: now.getMonth(),
				date: now
			},
			companyID: null

		};


		$scope.companies = [];

		$scope.loading = {
			filter: false
		};

		$scope.monthNames = [];
		$scope.yearValues = [];
		$scope.customYear = {
			filter: {
				begin: null,
				end: null
			}
		};
		$scope.array = [];
		$scope.filterSelectTextCompany = {
			value: ''
		};

		var getCompanies = function () {
			if (timeoutCanceler != null) {
				timeoutCanceler.resolve();
			}
			timeoutCanceler = $q.defer();
			companyService.filterByString($scope.filterSelectTextCompany.value, 1, $translate.preferredLanguage(), timeoutCanceler, null).then(function (res) {
				if (res.data) {
					$scope.companies = res.data;
				}
			}).catch(function (err) {
				console.log(err);
				// toastr.error($filter('translate')('PACKAGES.ADD.ERROR_GET_COMPANIES'));
			});
		};

		$scope.$watch('filterSelectTextCompany.value', function () {
			getCompanies();
		});



		//Helper
		var validateYearFormat = function (year) {
			if (year >= (now.getFullYear() - 100) && year <= (now.getFullYear() + 100)) {
				return true;
			}
			return false;
		};

		//Init range years and months
		var initMonthAndYears = function () {
			for (var i = 0; i < 12; i++) {
				$scope.monthNames.push({
					value: i,
					name: $filter('translate')('GENERAL.MONTH_NAMES.' + i)
				});
			}
			var yearNow = now.getFullYear();
			for (var j = -3; j <= 3; j++) {
				$scope.yearValues.push(yearNow + j);
			}
		};

		initMonthAndYears();

		//For iput select year
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.searchStatisticsCustomYear = function (begin) {
			var customYear;
			var period;
			if (begin) {
				customYear = $scope.customYear.filter.begin;
				period = $scope.filter.begin;
			} else {
				customYear = $scope.customYear.filter.end;
				period = $scope.filter.end;
			}
			if (validateYearFormat(customYear)) {
				period.year = 'custom';
				$mdSelect.hide();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		$scope.searchStatisticsCustomYearSecond = function (begin) {
			var customYear;
			var period;
			if (begin) {
				customYear = $scope.customYear.filterSecond.begin;
				period = $scope.filter.secondPeriod.begin;
			} else {
				customYear = $scope.customYear.filterSecond.end;
				period = $scope.filter.secondPeriod.end;
			}
			if (validateYearFormat(customYear)) {
				period.year = 'custom';
				$mdSelect.hide();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		var getFilter = function (filter) {

			if ($scope.filter.mode == 'PERIOD') {
				if (new Date(filter.begin.year, filter.begin.month, 1) > new Date(filter.end.year, filter.end.month, 1)) {
					toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INVALID_PERIOD'));
					return null;
				}
			}

			return filter;
		};

		$scope.createFilterToSend = function(){
			var filter = angular.copy(getFilter($scope.filter));
			if ($scope.filter.mode == 'DAY') {
				var _dateStart = angular.copy(filter.begin.date);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = angular.copy(filter.begin.date);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'MONTH') {
				var _dateStart = new Date(filter.begin.year, filter.begin.month, 1);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = new Date(filter.begin.year, filter.begin.month + 1, 0);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'YEAR') {
				var _dateStart = new Date(filter.begin.year, 0, 1);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = new Date(filter.begin.year, 12, 0);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'PERIOD') {
				var _dateStart = angular.copy(filter.begin.date);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = angular.copy(filter.end.date);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			}


			return filter;
		}

		$scope.getRFPCompanies = function () {
			if(!$scope.filter.companyID) {
				toastr.error($filter('translate')('GENERAL.FIELDS_REQUIRED'));
				return;
			}
			var filter = $scope.createFilterToSend();

			if (filter === null) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_RESULTS'));
				return;
			}

			$scope.loading.filter = true;
			RequestForProposalService.getRFPCompany(filter, $translate.preferredLanguage()).then(function (res) {

				$scope.array = res.data.rfp;
				$scope.wins = res.data.wins;
				$scope.lost = res.data.lost;
				$scope.participants = res.data.participants; //participants Win only
				$scope.loading.filter = false;


			}).catch(function (err) {
				$scope.loading.filter = false;
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_RESULTS'));
				console.log(err);
			});
		};


	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('RequestForProposalDetailsController', RequestForProposalDetailsController);

	function RequestForProposalDetailsController($rootScope,$window, $scope, $timeout, $filter, $state, $translate, toastr, $location, $stateParams,
			RequestForProposalService) {
			$scope.loading = false;
		RequestForProposalService.findRequestForProposalById($stateParams.id,
		$translate.preferredLanguage()).then(function (response) {
			$scope.rfp = response.data;

		}).catch(function (error) {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		$scope.findAllCompanies = function(){
			RequestForProposalService.getAllCompanies($translate.preferredLanguage()).then(function(data){
				$scope.companiesToCheck = data;
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			})
		}

		$scope.findAllCompanies();


		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.setFinish = function(rfp){
			$scope.loading = true;
			RequestForProposalService.setFinish(rfp.id).then(function (response) {

				rfp.status = response.data;
				$scope.loading = false;
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE'));
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$scope.loading = false;
			});
		}
		$scope.valid = function(){
			if(!$scope.rfp.companiesWhoWon){
				$scope.rfp.companiesWhoWon = [];
			}
			if(!$scope.rfp.companiesWhoLost){
				$scope.rfp.companiesWhoLost = [];
			}

			var obj = {};
			obj.won = $scope.rfp.companiesWhoWon;
			obj.lost = $scope.rfp.companiesWhoLost;

			RequestForProposalService.valid($scope.rfp.id,obj).then(function(res){
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE'));
			}).catch(function(err){
				console.log(err)
				if(err.status==400){
					toastr.error($filter('translate')('REQUEST_FOR_PROPOSAL.ERROR_COMPANIES'));
				}else{
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				}

			})
		}

		$scope.setInProgress = function(rfp){
			$scope.loading = true;
			RequestForProposalService.setInProgress(rfp.id).then(function (response) {

				rfp.status = response.data;
				rfp.companiesWhoWon = [];
				rfp.companiesWhoLost = [];
				$scope.loading = false;
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE'));
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$scope.loading = false;
			});
		}


		$scope.download = function(id){
			$window.open(RequestForProposalService.downloadCC(id));
		}

	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('addPackagesController', addPackagesController);

	function addPackagesController($scope, $translate, companyService, $filter, $state, $stateParams, $q, packagesService, languageService, DocumentService,
		modelService, $mdDialog, toastr, userService) {
		$scope.userService = userService;
		$scope.language = {};
		$scope.languages = [];
		$scope.companies = [];
		$scope.updateMode = false;
		$scope.modelType = 'COMPANY_MODEL';
		$scope.filterSelectTextCompany = {
			value: ''
		};
		var baseUrl = './api/rest/model/' + $scope.modelType;
		var timeoutCanceler = $q.defer();

		// md-select input search
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		modelService.findSpecificByType(baseUrl, $translate.preferredLanguage(), 'REGION').then(function (response) {
			$scope.regions = response.data.listFieldsDTO;
		}).catch(function () {

		});

		modelService.findSpecificByType(baseUrl, $translate.preferredLanguage(), 'TOURISM').then(function (response) {
			$scope.tourisms = response.data.listFieldsDTO;
		}).catch(function () {

		});

		var getPackage = function (id) {
			packagesService.findById(id, $scope.language.key).then(function (res) {
				if (res.data) {
					$scope.package = res.data;
					$scope.updateMode = true;
				} else {
					toastr.error($filter('translate')('PACKAGES.ADD.TOAST.PACKAGE_NOT_FOUND'));
					$state.go('app.packages');
				}
			}).catch(function (err) {
				toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_GET_PACKAGE'));
			});
		};
		$scope.photos = [];

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}

			if ($stateParams.id) {
				getPackage($stateParams.id);
			}
		}).catch(function (error) {

		});

		var getCompanies = function () {
			if (timeoutCanceler != null) {
				timeoutCanceler.resolve();
			}
			timeoutCanceler = $q.defer();
			companyService.filterByString($scope.filterSelectTextCompany.value, 1, $translate.preferredLanguage(), timeoutCanceler, null).then(function (res) {
				if (res.data) {
					$scope.companies = res.data;
				}
			}).catch(function (err) {
				console.log(err);
				// toastr.error($filter('translate')('PACKAGES.ADD.ERROR_GET_COMPANIES'));
			});
		};

		$scope.$watch('filterSelectTextCompany.value', function () {
			getCompanies();
		});

		getCompanies();

		var addPhoto = function (fd, i, last) {
			var index = angular.copy(i);
			DocumentService.save(fd).then(function (res) {
				$scope.$emit('photoUploaded' + (index + 1));
				if (last) {
					$state.go('app.packages');
				}

			}).catch(function (err) {
				toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_ADD_PHOTO'));
				$scope.$emit('photoUploaded' + (index + 1));
			});
		};

		$scope.add = function () {
			var photos = [];

			for (var i = 0; i < $scope.photos.length; i++) {
				if ($scope.photos[i] != null && $scope.photos[i].uploadFile != null) {
					var photo = $scope.photos[i].uploadFile;
					photos.push(photo);
				}
			}

			packagesService.save($scope.package, $scope.language.key).then(function (res) {
				if (res.data && res.data.id) {
					//On upload les photos l'une après l'autre car le faire en parallèle cause une erreur côté back
					var fds = [];

					for (var i = 0; i < photos.length; i++) {
						var formData = new FormData();
						formData.append('file', photos[i], photos[i].name);
						formData.append('dto', angular.toJson({
							packagesID: res.data.id
						}));

						fds.push(formData);
					}

					var index = 0;

					if (fds.length > 0) {
						for (var i = 0; i < fds.length; i++) {
							if (i === 0) {
								if (fds.length === 1) {
									addPhoto(fds[i], i, true);
								} else {
									addPhoto(fds[i], i, false);
								}

								index++;
							} else {
								$scope.$on('photoUploaded' + i, function () {
									if (index === fds.length - 1) {
										addPhoto(fds[index], index, true);
									} else {
										addPhoto(fds[index], index, false);
									}

									index++;
								});
							}
						}
					} else {
						$state.go('app.packages');
					}
				} else {
					toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_ADD_PHOTOS'));
				}

			}).catch(function (err) {
				toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_SAVE_PACKAGE'));
				console.log(err);
			});
		};

		$scope.deletePhoto = function (index) {
			$scope.photos.splice(parseInt(index), 1);
		};

		$scope.displayPopUpDeletePhoto = function (photo, index) {
			$scope.photoToDelete = angular.copy(photo);
			$scope.indexToDelete = index;
			$mdDialog.show({
				templateUrl: 'app/main/packages/popup/deletePhoto.popup.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

		$scope.deletePhotoPermanentely = function () {
			DocumentService.deleteFile($scope.photoToDelete.id).then(function (res) {
				$scope.package.documents.splice($scope.indexToDelete, 1);
				toastr.success($filter('translate')('PACKAGES.ADD.TOAST.SUCCESS_DELETE_PHOTO'));
				$scope.hidePopup();
			}).catch(function (err) {
				toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_DELETE_PHOTO'));
			});
		};

		$scope.langageChanged = function () {
			if ($scope.updateMode) {
				if ($stateParams.id) {
					getPackage($stateParams.id);
				}
			}
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('MissingInfosToolModalController', MissingInfosToolModalController);

    function MissingInfosToolModalController($rootScope, $scope, $mdDialog, $q, $state, $filter, $translate, datas, 
        toastr, modelService, MissingInfosToolService ,MODELS_TYPES){
        
        $scope.MODELS_TYPES = MODELS_TYPES;
        $scope.form = null;
        $scope.companyFields = [];
        $scope.contactFields = [];
        $scope.datas = datas;

        $scope.loading = true;
        $q.all([
            modelService.listFieldsBySubType( MODELS_TYPES.COMPANY_MODEL, $scope.datas.modelSubtypeId, $translate.preferredLanguage()),
            modelService.listFieldsByType(MODELS_TYPES.CONTACT_MODEL, $translate.preferredLanguage())
        ]).then(function(resp) {
            $scope.companyFields = $filter('filter')(resp[0].data, function (item) {
                return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT';
            });
            $scope.contactFields = $filter('filter')(resp[1].data, function (item) {
                return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT';
            });
            $scope.loading = false;
        }).catch(function(err) {
            console.log(err);
            $scope.cancelPopup();
        }).finally(function () {
        });

        // md-select input search
        window.mdSelectOnKeyDownOverride = function (event) {
            event.stopPropagation();
        };

        $scope.cancelPopup = function(){
			$mdDialog.cancel();
        };

        $scope.onModelTypeSelected = function() {
            delete $scope.datas.fieldId;
        };

        $scope.lookForMissingInfos = function (form) {
            form.$setSubmitted();
            if (form.$valid) {
                $scope.loading = true;
                MissingInfosToolService.lookForMissingInfos(
                    $scope.datas.modelType, $scope.datas.modelSubtypeId,  $scope.datas.fieldId, $translate.preferredLanguage()
                ).then(function (resp) {
                    $scope.loading = false;
                    $mdDialog.hide(resp.data);
                }).catch(function (err) {
                    $scope.loading = false;
                    console.log(err)
                });
            }
        };
		
	}

})();
(function(){
	'use strict';

	angular.module('app.front').controller('updateMessageController', updateMessageController);

	function updateMessageController($rootScope, $scope, $mdDialog, $state, $filter, message, companyId, contactId, from, toastr, userService, SettingsMessageService, MessageService, STORAGE_PREFIX, MODELS_TYPES){
		$scope.message = {
			actionForm: null,
			receiverForm: null
		};
		$scope.filter = {
			sender: null,
			action: null
		};
		$scope.modelTypes = MODELS_TYPES;
		if (message != null){
			$scope.message = angular.copy(message);
		}

		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		//	MESSAGES
		$scope.findAllUsers = function (init) {
			userService.findAllUsers().then(function (users) {
				$scope.users = users.data;
				if (init){
					if ($scope.message.id != null) {
						if ($scope.message.receiver != null) {
							var receiverID = angular.copy($scope.message.receiver.id);
							angular.forEach($scope.users, function (user) {
								if (user.id === receiverID) {
									$scope.message.receiverForm = angular.toJson(user);
								}
							});
						} else {
							$scope.message.receiverForm = 'null';
						}
						if ($scope.message.action != null) {
							var actionID = angular.copy($scope.message.action.actionID);
							angular.forEach($scope.actions, function (action) {
								if (action.id === actionID) {
									$scope.message.actionForm = angular.toJson(action);
								}
							});
						} else {
							$scope.message.actionForm = null;
						}
					} else {
						for (var i = 0; i < $scope.users.length; i++) {
							if ($scope.users[i].id === $rootScope.user.id) {
								$scope.message.receiverForm = angular.toJson($scope.users[i]);
								break;
							}
						}

					}
				}
			}).catch(function (data) {

			});
		};

		$scope.findAllUsers(true);

		$scope.findAllActions = function () {
			SettingsMessageService.findAllAction(localStorage[STORAGE_PREFIX + 'language']).then(function (actions) {
				$scope.actions = actions.data;
			}).catch(function (data) {

			});
		};

		$scope.findAllActions();

		$scope.cancelFormMessage = function () {
			$scope.message = {
				actionForm: null,
				receiverForm: null
			};
			$mdDialog.hide();
		};
		$scope.saveMessage = function () {
			if ($scope.message.actionForm != null) {
				$scope.message.dateAction = moment($scope.message.startDateForm).set('hours', $scope.message.startTime.split(':')[0]).set('minutes', $scope.message.startTime.split(':')[1]).toDate().getTime();
				if (!$scope.message.actionDone) {
					$scope.message.actionDone = false;
				}
				$scope.message.action = angular.fromJson($scope.message.actionForm);
			}

			if ($scope.message.receiverForm != null && $scope.message.receiverForm != 'null') {
				$scope.message.receiver = angular.fromJson($scope.message.receiverForm);
				$scope.message.receiverID = angular.fromJson($scope.message.receiverForm).id;
			} else {
				$scope.message.receiverID = null;
			}
			$scope.message.companyId = companyId;
			$scope.message.contactId = contactId;
			if (from != null && from.searchCompanies && from.pagination != null){
				var dto = {
					message: $scope.message,
					modelPaginationDto: from.pagination
				};
				MessageService.bulk(dto, $scope.message.modelType, $state.params.subType).then(function (data) {
					$mdDialog.hide();
					toastr.success($filter('translate')('MESSAGE.BULK.SUCCESS'));
				}).catch(function (data) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}else{
				MessageService.saveMessage($scope.message).then(function (data) {
					$mdDialog.hide();
					toastr.success($filter('translate')('MESSAGE.CREATION.SUCCESS'));
				}).catch(function (data) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}
		};


		$scope.getDate = function (date) {
			return moment(date).toDate();
		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};

		
	}

})();
(function () {
	'use strict';

	angular.module('mailing_preview.app', [])
		.config(config);


	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		$stateProvider.state('mailing_preview.app', {
          	url: '/mailing/preview/:id/:lang',
          	views: {
				'content@mailing_preview': {
					templateUrl: 'app/main/mailing_preview/app/mailing_preview.html',
					controller: 'MailingPreviewController as vm'
				}
			}
      	});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/mailing_preview');

  	}
})();

(function () {
  'use strict';

  angular
    .module('mailing_preview.app')
    .controller('MailingPreviewToolbarController', MailingPreviewToolbarController);

  /** @ngInject */
  function MailingPreviewToolbarController($rootScope, $scope, $state, $window, $timeout, $mdSidenav, $mdDialog, $cookies, msNavigationService,
    $filter, $interval, $element, $translate, $stateParams) {
   
  }

})();

(function () {
    'use strict';
  
    angular
      .module('mailing_preview.app')
      .controller('MailingPreviewNavigationController', MailingPreviewNavigationController);
  
    /** @ngInject */
    function MailingPreviewNavigationController($rootScope, $scope, $state, $window, $timeout, $mdSidenav, $mdDialog, $cookies, msNavigationService,
      $filter, $interval, $element, $translate, $stateParams) {
     
    }
  
  })();
  
(function () {
	'use strict';

	angular.module('mailing_preview.app').controller('MailingPreviewController', MailingPreviewController);

	function MailingPreviewController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, 
		MailingService, $sce, $interpolate, $compile, $stateParams) {

		$scope.localWidth = 1440;
		$scope.localHeight = 900;

		if ($stateParams.id && $stateParams.lang) {
			MailingService.mailingPreview($stateParams.id, $stateParams.lang).then(function (res) {
				var parser = new DOMParser();
				var parsedDocument = parser.parseFromString(res.data, 'text/html');
				var newHTML = parsedDocument.documentElement.outerHTML;
				var doc = document.getElementById('preview_frame_container').contentWindow.document;
				doc.open();
				doc.write(newHTML);
				doc.close();
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(err);
			});
		}

		$scope.previewResponsiveFn = function(_width, _height) {
			$scope.localWidth = _width;
			$scope.localHeight =_height;
		};

	}

})();

(function () {
    'use strict';

    angular.module('app.front').controller('MailingTriggersController', MailingTriggersController);

    function MailingTriggersController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, MailingService) {

        $scope.triggers = [];
        $scope.pages = [];

        $scope.search = {};

        // Pages
        /*MailingService.findAll('pages', null).then(function(response){
            $scope.pages = response.data;
        }).catch(function(error){
            toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });*/

        //Triggers
        MailingService.findAll('triggers', $translate.preferredLanguage()).then(function (response) {
            $scope.triggers = response.data;
        }).catch(function (error) {
            console.log(error);
        });

        $scope._triggerDetailsFn = function(id) {
            $state.go("app.mailing_triggers.trigger", { id : id });
        };

    }
    
})();
(function(){
	'use strict';

	angular.module('app.front').service('MailingTagsService', MailingTagsService);

	function MailingTagsService($http, $q){
		var service = {};

		service.list = function(lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/mailing-tag',
					method: 'GET',
					params: {'_v': new Date().getTime(), 'lang': lang},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.save = function(dto, lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/mailing-tag',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.update = function (dto, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/mailing-tag',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		service.remove = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/mailing-tag/'+id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.up = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/mailing-tag/up/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.down = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/mailing-tag/down/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};
		return service;
	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('MailingTagsController', MailingTagsController);

	function MailingTagsController($rootScope, $scope, $timeout, $translate, $filter, MailingTagsService, languageService) {

		$scope.language = {};
		$scope.newTag = {};

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.refresh($scope.language.key);
			});
		}).catch(function (error) {
            console.log(error);
		});

		$scope.refresh = function(lang){
			MailingTagsService.list(lang).then(function(response){
				$scope.tags = response.data;
			}).catch(function(error){
                console.log(error);
			});
		};

		$scope.add = function(form){
			MailingTagsService.save($scope.newTag, $scope.language.key).then(function(){
				$scope.newTag = {};
				$scope.refresh($scope.language.key);
				form.$setPristine();
				form.$setUntouched();
			}).catch(function(error){
                console.log(error);
			});
		};

		$scope.up = function(id){
			MailingTagsService.up(id).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(error){
                console.log(error);
			});
		};

		$scope.down = function(id){
			MailingTagsService.down(id).then(function () {
				$scope.refresh($scope.language.key);
			}).catch(function (error) {
                console.log(error);
			});
		};

		$scope.edit = function(tag){
			$scope.tagToEdit = angular.copy(tag);
			tag.editionMode = true;
		};

		$scope.update = function(tag){
			tag.editionMode = false;
			MailingTagsService.update($scope.tagToEdit, $scope.language.key).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(error){
                console.log(error);
			});
		};

		$scope.cancel = function(tag){
			tag.editionMode = false;
		};

		$scope.remove = function(id){
			var content = {
				title: $filter('translate')('MAILING.TAGS.DELETE.TITLE'),
				message: $filter('translate')('MAILING.TAGS.DELETE.MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				MailingTagsService.remove(id).then(function(){
					$scope.refresh($scope.language.key);
				}).catch(function(error){
                    console.log(error);
				});
			}).catch(function(error){
                console.log(error);
			});
		};

	}
})();
(function () {
	'use strict';

	angular.module('app.front').controller('MailingPagesController', MailingPagesController);

	function MailingPagesController($rootScope, $scope, $mdDialog, $filter, $state, $translate, toastr, languageService, MailingService) {

		$scope.pages = [];
		$scope.blocs = [];
		$scope.languages = [];
		$scope.search = {};
		$scope.page = {
			htmlHeader: "<head>\n\n</head>",
			pageBlocs: []
		};

		// Blocs
		/*MailingService.findAll('blocs', null).then(function(response){
		    $scope.blocs = response.data;
		}).catch(function(error){
		    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});*/

		// LANGUAGES
		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
		}).catch(function (error) {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		//Pages
		$scope.findAll = function () {

			MailingService.findAll('pages', $translate.preferredLanguage()).then(function (response) {
				$scope.pages = response.data;
			}).catch(function (error) {
				console.log(error);
			});
		};

		$scope.findAll();

		$scope._pageDetailsFn = function (id) {
			var url = $state.href("app.mailing_pages.page", {
				id: id
			});
			window.open(url, '_blank');
		};

		// preview
		$scope.previewMail = function (id, keyLanguage) {
			MailingService.find('page', id, keyLanguage).then(function (response) {
				$scope.page = response.data;
				var url = $state.href('mailing_preview.app', {
					id: $scope.page.id,
					lang: $scope.page.language.key
				});
				window.open(url, '_blank');
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});

		};

		$scope.showDuplicate = function (page) {
			if (page) {
				$scope.pageToDuplicate = angular.copy(page);
			} else {
				$scope.pageToDuplicate = {
					mail: null,
					name: null,
					password: null
				};
			}

			$mdDialog.show({
				templateUrl: 'app/main/mailing/pages/page/duplicate.dialog.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope
			}).then(function () {}).catch(function () {});
		};

		$scope.duplicate = function () {
			MailingService.save('page/duplicate', $scope.pageToDuplicate, null).then(function (response) {
				$mdDialog.hide();
				$scope.findAll();
			}).catch(function (err) {

			});
		};

	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('MailingHistoryController', MailingHistoryController);

	function MailingHistoryController($rootScope, $scope, $timeout, DISPLAY_MODELS_ICONS, MAILING_HISTORY_TYPES, $filter, toastr, MailingService,$translate) {
		$scope.allLoaded = false;
		$scope.filter = {
			outputs: 20,
			page: 0,
			types: []
		};
		$scope.history = [];
		$scope.companyFields = [];
		$scope.contactFields = [];
		$scope.MAILING_HISTORY_TYPES = MAILING_HISTORY_TYPES;

		$scope.iconsDisplay = {};
		angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
			$scope.iconsDisplay[elt.name] = elt.value;
		});

		$scope.getHistory = function (reset) {
			if (reset) {
                $scope.filter.page = 0;
                $scope.allLoaded = false;
					 $scope.history = [];
					 $scope.companyFields = [];
					 $scope.contactFields = [];
			}

			MailingService.getHistory($scope.filter,$translate.preferredLanguage()).then(function (res) {
				$scope.history = $scope.history.concat(res.data);
				console.log($scope.history);
				/*$scope.history.forEach(function(item, index){
					if(item.company !== null && item.company.valuedFields !== null && item.company.valuedFields !== undefined){
						item.company.valuedFields.forEach(function(value, i){
							if(value.typeChamps != '' || value.typeChamps == 'STRING' || value.typeChamps == 'URL' || value.typeChamps == 'LIST_SELECT'){
								$scope.companyFields.push(value);
							}
						});
					} else if(item.contact !== null && item.contact.valuedFields !== null && item.contact.valuedFields !== undefined){
						item.contact.valuedFields.forEach(function(value, i){
							if(value.typeChamps != '' || value.typeChamps == 'EMAIL' || value.typeChamps == 'STRING'){
								$scope.contactFields.push(value);
							}
						});
					}
				});*/

				$scope.filter.page++;
				if (res.data.length < $scope.filter.outputs) {
					$scope.allLoaded = true;
				}
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		function init() {
			$scope.getHistory(false);
		}

		init();
	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('MailingExpeditorsController', MailingExpeditorsController);

	function MailingExpeditorsController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, MailingService, $mdDialog) {
		$scope.expeditors = [];
		$scope.expeditor = {};

		init();

		$scope.showPopUpAddExpeditor = function (expeditor) {
			if (expeditor) {
				$scope.expeditor = angular.copy(expeditor);
			} else {
				$scope.expeditor = {
					mail: null,
					name: null,
					password: null
				};
			}

			$mdDialog.show({
				templateUrl: 'app/main/mailing/expeditors/popup/addExpeditor.dialog.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope
			}).then(function () {}).catch(function () {});
		};

		$scope.showPopUpDelete = function (expeditor) {
			var content = {
				title: $filter('translate')('MAILING.EXPEDITORS.DELETE_POPUP.TITLE'),
				message: $filter('translate')('MAILING.EXPEDITORS.DELETE_POPUP.CONTENT')
			};

			$rootScope.openConfirmPopup(content).then(function () {
				MailingService.deleteExpeditor(expeditor.id).then(function (data) {
					var found = false;

					for (var i = 0; i < $scope.expeditors.length; i++) {
						var exp = $scope.expeditors[i];

						if (exp.id === expeditor.id) {
							$scope.expeditors.splice(i, 1);
							found = true;
							break;
						}
					}

					if (!found) {
						init();
					}
				}).catch(function (data) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(function () {

			});
		};

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

		$scope.addExpeditor = function () {
			var update;

			if ($scope.expeditor.id) {
				update = true;
			} else {
				update = false;
			}

			MailingService.addExpeditor($scope.expeditor).then(function (res) {
				delete $scope.expeditor.password;

				if (update) {
					var found = false;

					for (var i = 0; i < $scope.expeditors.length; i++) {
						var exp = $scope.expeditors[i];

						if (exp.id === $scope.expeditor.id) {
							$scope.expeditors[i] = angular.copy($scope.expeditor);
							found = true;
							break;
						}
					}

					if (!found) {
						init();
					}
				} else {
					var expeditor;

					expeditor = angular.copy($scope.expeditor);
					expeditor.id = res.data;
					$scope.expeditors.push(expeditor);
					$scope.expeditors = $filter('orderBy')($scope.expeditors, 'name');
				}

				$scope.hidePopup();
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(err);
			});
		};

		function init() {
			MailingService.getExpeditors().then(function (res) {
				$scope.expeditors = res.data;
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(err);
			});
		}

	}

})();

(function () {
    'use strict';

    angular.module('app.front').controller('MailingBlocsController', MailingBlocsController);

    function MailingBlocsController($rootScope, $scope, $timeout, $filter, $state, $translate, toastr, MailingService) {

        $scope.blocs = [];

        $scope.types = MailingService.getBlocTypes();

        $scope.search = {};

        MailingService.findAll('blocs', null).then(function (response) {
            $scope.blocs = response.data;
        }).catch(function (error) {
            console.log(error);
        });

        $scope._blocDetailsFn = function(id) {
            $state.go("app.mailing_blocs.bloc", { id : id });
        };

    }
    
})();
(function(){
	'use strict';

	angular.module('app.front').controller('MailingModalController', MailingModalController);

    function MailingModalController($rootScope, $scope, $mdDialog, $state, $filter, $translate, data, toastr, modelService, 
        MailingService, languageService, MODELS_TYPES){
        
        $scope.MODELS_TYPES = MODELS_TYPES;
        $scope.initDataInProgress = false;

        if (data != null && data.modelType != null){

            $scope.initDataInProgress = true;

            $scope.dto = {};
            $scope.dto.modelType = angular.copy(data.modelType);
            $scope.dto.filter = angular.copy(data.filter);
            $scope.dto.mailingType = angular.copy(data.mailingType);

            if(data.modelSubTypeId) {
                 $scope.dto.modelSubTypeId = angular.copy(data.modelSubTypeId);
            };

            if(data.contactId) {
                $scope.dto.contactId = angular.copy(data.contactId);
            };

            MailingService.findAllPageLite($translate.preferredLanguage()).then(function (resp) {
                $scope.pages = resp.data;
                languageService.getLanguages().then(function (resp) {
                    $scope.languages = resp.data;                 
                    modelService.listFieldsByType(
                        MODELS_TYPES.CONTACT_MODEL, 
                        $translate.preferredLanguage()
                    ).then(function (resp) {
                        /*$scope.fields = $filter('filter')(resp.data, function (item) {
                            return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
                        });*/
                        $scope.emailFields = $filter('filter')(resp.data, function (item) {
                            return item.typeChamps == 'EMAIL';
                        });

                        if($scope.dto.modelSubTypeId) {
                            modelService.listFieldsBySubType(
                                MODELS_TYPES.COMPANY_MODEL,
                                $scope.dto.modelSubTypeId,
                                $translate.preferredLanguage()
                            ).then(function (resp) {
                                /*$scope.fields =  $scope.fields.concat($filter('filter')(resp.data, function (item) {
                                    return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
                                }));*/
                                $scope.emailFields = $scope.emailFields.concat($filter('filter')(resp.data, function (item) {
                                    return item.typeChamps == 'EMAIL';
                                }));
                                $scope.initDataInProgress = false;
                            }).catch(function (err) {
                                $scope.initDataInProgress = false;
                                console.log(err)
                            });
                        } else {
                             $scope.initDataInProgress = false;
                        }
                    }).catch(function (err) {
                        $scope.initDataInProgress = false;
                        console.log(err);
                    });
                }).catch(function (error) {
                    $scope.initDataInProgress = false;
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                });
            }).catch(function (error) {
                $scope.initDataInProgress = false;
                console.log(error);
            });
		}

        // md-select input search
        window.mdSelectOnKeyDownOverride = function (event) {
            event.stopPropagation();
        };

        $scope.hidePopup = function(){
			$mdDialog.cancel();
        };
        
        $scope._getCleanKey = function (key) {
            var _cleanKey = angular.copy(key);
            return _cleanKey.replace(/[{()}]/g, '');
        };

        $scope.$watch("dto.page.language", function(newValue, oldValue, scope){
            if($scope.dto.page && newValue && newValue.id && oldValue && oldValue.id && newValue.id != oldValue.id) {
                $scope.dto.page.language = angular.copy(newValue);
            };
        });

        $scope.doAMailing = function (_form) {
            _form.$setSubmitted();
            if (_form.$valid) {
                $scope.inProgress = true;
                MailingService.doAMailing( $scope.dto).then(function (response) {
                    $scope.inProgress = false;
                    toastr.success($filter('translate')('MAILING.DO_MAILING.SUCCESS'));
                    $scope.hidePopup();
                }).catch(function (error) {
                    $scope.inProgress = false;
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                    console.log(error);
                });
            }
        };
		
	}

})();
(function () {
    'use strict';
  
    angular.module('app.front').service('InscriptionsAdminService', InscriptionsAdminService);
  
    function InscriptionsAdminService($q, $http, $filter) {
        
        var BASE_URL_INSCRIPTION = './api/rest/inscription';
        var service = {};

        service.findInscriptions = function (pagination, lang) {
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_INSCRIPTION + '/list',
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang
                    },
                    data: pagination
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        // EXPORT
        service.export = function(dto, password, lang){
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_INSCRIPTION  +'/export-excel',
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang,
                        'password': password
                    },
                    responseType: 'arraybuffer',
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.deleteExport = function(id){
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_INSCRIPTION + '/export/'+id,
                    method: 'DELETE',
                    params: {
                        '_v': new Date().getTime(),
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.saveExport = function(dto){
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_INSCRIPTION + '/export',
                    method: 'POST',
                    params: {
                        '_v': new Date().getTime(),
                    },
                    data: dto
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };

        service.findExports = function(lang){
            return $q(function (resolve, reject) {
                $http({
                    url: BASE_URL_INSCRIPTION + '/export',
                    method: 'GET',
                    params: {
                        '_v': new Date().getTime(),
                        'lang': lang
                    }
                }).then(function (response) {
                    resolve(response);
                }).catch(function (response) {
                    reject(response);
                });
            });
        };
  
        return service;
  
    }
  
  })();
  
(function () {
	'use strict';

	angular.module('app.front').controller('InscriptionsAdminController', InscriptionsAdminController);

	function InscriptionsAdminController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, $element, toastr, MODELS_TYPES,
		modelService, InscriptionsAdminService, researchEngineFilterService, researchEngineSortService, logisticService, URL, DISPLAY_MODELS_ICONS, userService, companyService) {

		$scope.URL = URL;
		$scope.modelType = 'INSCRIPTION_MODEL';

		$scope.iconsDisplay = {};
		angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
			$scope.iconsDisplay[elt.name] = elt.value;
		});

		$scope.allLoaded = false;
		$scope.loaded = true;
		$scope._inscriptions = [];

		$scope.pagination = {
			modelFiltersDto: researchEngineFilterService.getFilter(),
			modelSortsDto: researchEngineSortService.getSort(),
			start: 0,
			outputs: 100
		};


		function _onInitFn() {
			$scope.loaded = false;
			InscriptionsAdminService.findInscriptions($scope.pagination, $translate.preferredLanguage()).then(function (response) {
				$scope._inscriptions = $scope._inscriptions.concat(response.data);
				if (response.data.length < $scope.pagination.outputs) {
					$scope.allLoaded = true;
				} else {
					$scope.pagination.start += 1;
				}
				$scope.loaded = true;
			}).catch(function (err) {
				console.log(err);
			});
		}
		_onInitFn();

		$scope._findInscriptionsFn = function () {
			$scope.loaded = false;
			InscriptionsAdminService.findInscriptions($scope.pagination, $translate.preferredLanguage()).then(function (response) {
				$scope._inscriptions = $scope._inscriptions.concat(response.data);
				if (response.data.length < $scope.pagination.outputs) {
					$scope.allLoaded = true;
				} else {
					$scope.pagination.start += 1;
				}
				$scope.loaded = true;
			}).catch(function (response) {
				console.log(response);
			});
		};

		$scope._filterInscritpionFn = function (filter) {
			$scope.pagination.modelFiltersDto = filter;
			$scope.pagination.start = 0;
			$scope.allLoaded = false;
			$scope._inscriptions = [];
			$scope._findInscriptionsFn();
		};

		$scope._sortInscriptionFn = function (sort) {
			$scope.pagination.modelSortsDto = sort;
			$scope.pagination.start = 0;
			$scope.allLoaded = false;
			$scope._inscriptions = [];
			$scope._findInscriptionsFn();
		};

		$scope.filterModel = function (model, index) {
			return $filter('showColumn')(model, index);
		};

		$scope._goToInscriptionsAdminSettings = function () {
			$state.go('app.inscriptions_admin.settings', {
				modelType: 'INSCRIPTION_MODEL'
			});
		};

		$scope._inscriptionDetails = function (inscription) {
			$state.go('app.companies.details.contact', {
				subType: inscription.company.subTypesIds[0],
				id: inscription.company.id,
				contactId: inscription.contact.id,
				inscriptionId: inscription.infos.id
			});
		};

		$scope.logisticDetails = function (inscription) {
			$state.go('app.companies.details.contact.logistic', {
				subType: inscription.company.subTypesIds[0],
				id: inscription.company.id,
				contactId: inscription.contact.id,
				logisticId: inscription.logistic.id
			});
		};

		/*
		 * Mailing
		 */
		$scope._mailingDialogOpenFn = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/mailing/mailing_modal.html',
				clickOutsideToClose: false,
				controller: 'MailingModalController',
				locals: {
					data: {
						modelType: 'INSCRIPTION_MODEL',
						modelSubTypeId: null,
						filter: $scope.pagination.modelFiltersDto
					}
				}
			}).then(function () {

			}).catch(function () {

			});
		};

		/* EXPORT */
		$scope._exportParams = {
			companyFields: [],
			inscriptionFields: [],
			transportFields: [],
			contactFields: [],
			logisticFields: [],
			option: ''
		};
		$scope.search = {
			company: '',
			contact: '',
			inscription: '',
			transport: '',
			logistic: ''
		};

		$scope.refreshExports = function () {
			InscriptionsAdminService.findExports($translate.preferredLanguage()).then(function (response) {
				$scope.exports = response.data;
			}).catch(function () {

			});
		};

		$scope.refreshExports();


		$scope.saveExport = function () {
			var dto = {
				name: $scope._exportParams._name,
				option: $scope._exportParams._option,
				fields: [],
				transportFields: []
			};
			if ($scope._exportParams.id != null) {
				dto.id = $scope._exportParams.id;
			}
			angular.forEach($scope._exportParams.transportFields, function (item) {
				dto.transportFields.push(item.key);
			});
			dto.fields = dto.fields.concat($scope._exportParams.inscriptionFields);
			dto.fields = dto.fields.concat($scope._exportParams.logisticFields);
			dto.fields = dto.fields.concat($scope._exportParams.companyFields);
			dto.fields = dto.fields.concat($scope._exportParams.contactFields);
			if ((dto.fields.length > 0 || dto.transportFields.length > 0) && dto.name != null && dto.name.trim().length > 0) {
				InscriptionsAdminService.saveExport(dto).then(function (response) {
					if (response.data != null) {
						$scope._exportParams.id = parseInt(response.data);
					}
					InscriptionsAdminService.findExports($translate.preferredLanguage()).then(function (response) {
						$scope.exports = response.data;
						for (var i = 0; i < $scope.exports.length; i++) {
							if ($scope.exports[i].id === $scope._exportParams.id) {
								$scope._exportParams = $scope.exports[i];
								$scope.exportChanged();
								break;
							}
						}
					}).catch(function () {

					});
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SAVE'));
				}).catch(function () {

				});
			} else {
				if (dto.fields.length === 0 && dto.transportFields.length === 0) {
					toastr.error($filter('translate')('COMPANIES.EXPORT.ERROR_FIELDS'));
				} else if (dto.name == null || dto.name.trim().length === 0) {
					toastr.error($filter('translate')('COMPANIES.EXPORT.ERROR_NAME'));
				}
			}
		};

		$scope.openDeleteExport = function () {
			var content = {
				title: $filter('translate')('COMPANIES.EXPORT.DELETE_TITLE'),
				message: $filter('translate')('COMPANIES.EXPORT.DELETE_MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				$scope.deleteExport();
			}).catch(function () {

			});
		};

		$scope.deleteExport = function () {
			if ($scope._exportParams.id != null) {
				companyService.deleteExport($scope._exportParams.id).then(function (response) {
					for (var i = 0; i < $scope.exports.length; i++) {
						if ($scope.exports[i].id === $scope._exportParams.id) {
							$scope.exports.splice(i, 1);
							$scope._exportParams = {
								companyFields: [],
								contactFields: [],
								inscriptionFields: [],
								transportFields: [],
								logisticFields: [],
								option: null
							};
							toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_DELETE'));
							break;
						}
					}
				}).catch(function () {

				});
			}
		};

		$scope.addField = function (chip, fields) {
			if (chip == null || chip.id == null) {
				fields.splice(fields.length - 1, 1);
			}
		};

		$scope.addTransportField = function (chip, fields) {
			if (chip == null || chip.key == null) {
				fields.splice(fields.length - 1, 1);
			}
		};

		$scope.launchExport = function () {
			$scope.exportInProgress = true;
			var dto = {
				fields: [],
				transportFields: [],
				modelPagination: $scope.pagination,
				option: $scope._exportParams._option
			};
			angular.forEach($scope._exportParams.transportFields, function (item) {
				dto.transportFields.push(item.key);
			});
			dto.fields = dto.fields.concat($scope._exportParams.inscriptionFields);
			dto.fields = dto.fields.concat($scope._exportParams.logisticFields);
			dto.fields = dto.fields.concat($scope._exportParams.companyFields);
			dto.fields = dto.fields.concat($scope._exportParams.contactFields);
			InscriptionsAdminService.export(dto, $scope._exportParams.password, $translate.preferredLanguage()).then(function (response) {
				var byteArray = new Uint8Array(response.data);
				var a = window.document.createElement('a');
				a.href = window.URL.createObjectURL(new Blob([byteArray], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				}));
				a.download = 'export.xlsx';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				$scope.exportInProgress = false;
			}).catch(function (error) {
				if (error.status === 403) {
					toastr.error($filter('translate')('COMPANIES.EXPORT.BAD_PASSWORD'));
				}
				$scope.exportInProgress = false;
			});
		};

		function findTransportField(field) {
			for (var i = 0; i < $scope.transportFields.length; i++) {
				if ($scope.transportFields[i].key === field) {
					return angular.copy($scope.transportFields[i]);
				}
			}
			return null;
		}

		$scope.exportChanged = function () {
			$scope._exportParams = angular.copy($scope._exportParams);
			if ($scope._exportParams != null) {
				if ($scope._exportParams.fields != null) {
					$scope._exportParams.companyFields = [];
					$scope._exportParams.contactFields = [];
					$scope._exportParams.inscriptionFields = [];
					$scope._exportParams.logisticFields = [];

					for (var i = 0; i < $scope._exportParams.fields.length; i++) {
						var field = angular.copy($scope._exportParams.fields[i]);
						$scope._exportParams._name = angular.copy($scope._exportParams.name);
						$scope._exportParams._option = angular.copy($scope._exportParams.option);
						if (field.modelType === 'COMPANY_MODEL') {
							$scope._exportParams.companyFields.push(field);
						} else if (field.modelType === 'CONTACT_MODEL') {
							$scope._exportParams.contactFields.push(field);
						} else if (field.modelType === 'INSCRIPTION_MODEL') {
							$scope._exportParams.inscriptionFields.push(field);
						} else if (field.modelType === 'LOGISTIC_MODEL') {
							$scope._exportParams.logisticFields.push(field);
						}
					}
					var transportFields = angular.copy($scope._exportParams.transportFields);
					$scope._exportParams.transportFields = [];
					if (transportFields.length > 0) {
						for (var j = 0; j < transportFields.length; j++) {
							var transportField = transportFields[j];
							if (transportField != null && transportField !== '') {
								var transportFound = findTransportField(transportField);
								if (transportFound != null) {
									$scope._exportParams.transportFields.push(transportFound);
								}
							}
						}
					}
				} else {
					$scope._exportParams = {
						companyFields: [],
						contactFields: [],
						inscriptionFields: [],
						logisticFields: [],
						option: ''
					};
				}
			} else {
				$scope._exportParams = {
					companyFields: [],
					contactFields: [],
					inscriptionFields: [],
					transportFields: [],
					logisticFields: [],
					option: ''
				};
			}

		};

		$scope.fieldsSelected = function (fields, selectedFields, isTransport) {
			var res = [];
			if (angular.isArray(selectedFields)) {
				if (!isTransport) {
					var fieldIds = selectedFields.map(function (item) {
						return item.id;
					});
					angular.forEach(fields, function (item) {
						if (fieldIds.lastIndexOf(item.id) === -1) {
							res.push(item);
						}
					});
				} else {
					var fieldKeys = selectedFields.map(function (item) {
						return item.key;
					});
					angular.forEach(fields, function (item) {
						if (fieldKeys.lastIndexOf(item.key) === -1) {
							res.push(item);
						}
					});
				}
				return res;
			} else {
				return fields;
			}
		};

		modelService.listExportableField('./api/rest/model/COMPANY_MODEL', null, $translate.preferredLanguage()).then(function (response) {
			$scope.companyFields = response.data;
		}).catch(function () {

		});

		modelService.listExportableField('./api/rest/model/CONTACT_MODEL', null, $translate.preferredLanguage()).then(function (response) {
			$scope.contactFields = response.data;
		}).catch(function () {

		});

		modelService.listExportableField('./api/rest/model/INSCRIPTION_MODEL', null, $translate.preferredLanguage()).then(function (response) {
			$scope.inscriptionFields = response.data;
		}).catch(function () {

		});

		modelService.listExportableField('./api/rest/model/LOGISTIC_MODEL', null, $translate.preferredLanguage()).then(function (response) {
			$scope.logisticFields = response.data;
		}).catch(function () {

		});

		logisticService.getTransportFields().then(function (response) {
			$scope.transportFields = response.data;
		}).catch(function () {

		});

		$scope.translate = function (key) {
			return $filter('translate')(key);
		};

	}



})();

(function () {
	'use strict';

	angular.module('app.front').service('companyService', companyService);

	function companyService($http, $q, $filter, $rootScope) {

		/** Constantes */

		var BASE_URL_COMPANY = './api/rest/company/';
		var PUBLIC_URL_COMPANY = './api/public/sitegen/companies/';
		var BASE_URL_STATS = './api/rest/statistics/';
		var FIRST_CATEGORY_INDEX = 1;

		/** Variables */
		var service = {};

		var selectedModel = null;
		var selectedModelId = null;
		var categories = null;
		var listFields = null;
		var modelFilters = null;
		var actualFilter = null;

		// GET ALL

		service.findByTypeId = function (subtypeId, filter, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'list/' + subtypeId,
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					data: filter
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findPage = function (lang, page, subTypeId) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'findPage',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
						'page': page,
						'subTypeId': subTypeId
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findPageSearchTxt = function (lang, page, subTypeId, searchTxt) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'findPage/searchTxt',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
						'page': page,
						'subTypeId': subTypeId,
						'searchTxt': searchTxt
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findAll = function (lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'findAll',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.filterByString = function (string, subTypeId, lang, timeoutCanceler, idToRetrieve) {
			var subType = null;
			if (subTypeId != null) {
				subType = subTypeId;
			}
			var toRetrieve = null;
			if (idToRetrieve != null) {
				toRetrieve = idToRetrieve;
			}
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'search',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'q': string,
						'lang': lang,
						'subTypeId': subType,
						'idToRetrieve': toRetrieve
					},
					timeout: timeoutCanceler.promise
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};



		/** Details */

		service.getSelectedModel = function (modelId, subTypeId, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + modelId,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'subTypeId': subTypeId,
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					categories = null;
					selectedModel = response.data;
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.getSelectedModelDisplay = function (modelId, subTypeId, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'display/' + modelId,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'subTypeId': subTypeId,
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					categories = null;
					selectedModel = response.data;
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.getCategories = function (lang, modelId) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'categories/',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'id': modelId,
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					if (modelId != null) {
						categories = service.buildModel(response.data, selectedModel);
						resolve(categories);
					} else {
						resolve(response.data);
					}
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.getCategoriesBySubType = function (lang, modelId, subTypeId, hideManagerFields) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'categoriesBySubType/',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'id': modelId,
						'subTypeId': subTypeId,
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					if (modelId != null) {
						categories = service.buildModel(response.data, selectedModel, hideManagerFields);
						resolve(categories);
					} else {
						resolve(response.data);
					}
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.buildModel = function (categories, contact, hideManagerFields) {
			var firstCategory = findFirstCategory(categories);
			if (firstCategory) {
				for (var i = 0; i < firstCategory.values.length; i++) {
					var field = firstCategory.values[i];
					if (field.fixField) {
						if ((field.selectableObject == null || field.selectableObject.length < 1)) {
							field.value = contact[field.keyJava];
						} else {
							if (field.typeChamps === 'OBJECT') {
								field.value = setSelectedObject(field, contact);
							} else {
								field.value = setSelectedMultipleObject(field, contact);
							}
						}
					}
				}
			}
			angular.forEach(categories, function (category, key) {
				for (var i = 0; i < category.values.length; i++) {
					var field = category.values[i];
					field.hidden = (!!hideManagerFields && !field.visibleByManager && contact.manager != null && contact.manager.id === $rootScope.user.id);
					if (field.typeChamps === 'LIST_SELECT') {
						field.value = setSelectedList(field);
					} else if (field.typeChamps === 'DATE') {
						field.dateTime = null;
						if (field.value != null && field.value !== '') {
							field.dateTime = $filter('stringToDate')(field.value);
						}
					} else if (field.typeChamps === 'BOOLEAN') {
						field.value = 'true' === field.value;
					}
				}
				angular.forEach(category.subCategories, function (category, key) {
					for (var i = 0; i < category.values.length; i++) {
						var field = category.values[i];
						field.hidden = (!!hideManagerFields && !field.visibleByManager && contact.manager != null && contact.manager.id === $rootScope.user.id);
						if (field.typeChamps === 'LIST_SELECT') {
							field.value = setSelectedList(field);
						} else if (field.typeChamps === 'DATE') {
							field.dateTime = null;
							if (field.value != null && field.value !== '') {
								field.dateTime = $filter('stringToDate')(field.value);
							}
						} else if (field.typeChamps === 'BOOLEAN') {
							field.value = 'true' === field.value;
						}
					}
				});
			});
			return categories;
		};

		service.addModel = function (categories, newModel, subTypes, lang) {
			return $q(function (resolve, reject) {
				var fmData = new FormData();
				var internalSaveModel = function (_category) {
					if (angular.isArray(_category.subCategories) && _category.subCategories.length > 0) {
						angular.forEach(_category.subCategories, function (_subCategories) {
							internalSaveModel(_subCategories);
						});
					}
					angular.forEach(_category.values, function (item) {
						if (!item.fixField) {
							var valuedField = {
								idBaseField: item.id,
								id: item.idValue
							};
							if (item.typeChamps === 'BOOLEAN') {
								valuedField.value = '' + item.value;
							} else if (item.typeChamps === 'DATE') {
								if (item.dateTime != null) {
									valuedField.value = $filter('date')(item.dateTime, 'dd/MM/yyyy');
								}
							} else if (item.typeChamps === 'LIST_SELECT') {
								valuedField.listFieldId = item.value.id;
							} else if (item.typeChamps === 'MULTIPLE_SELECT') {
								valuedField.values = [];
								angular.forEach(item.values, function (objectSelected) {
									valuedField.values.push({
										id: objectSelected.id,
										libelle: objectSelected.libelle
									});
								});
							} else if (item.typeChamps === 'FILE' || item.typeChamps === 'IMAGE') {
								var input = document.getElementById('genericField_file_' + item.id + '_' + item.index);
								var file = null;
								if (input != null) {
									file = input.files[0];
								}
								fmData.append('file_' + valuedField.idBaseField, file);
							} else if (item.typeChamps === 'NUMBER' || item.typeChamps === 'INTEGER') {
								if ('null' === item.value) {
									valuedField.value = '';
								} else {
									valuedField.value = item.value;
								}
							} else {
								valuedField.value = item.value;
							}
							newModel.valuedFields.push(valuedField);
						} else {
							newModel[item.keyJava] = item.value;
						}
					});
				};
				newModel.valuedFields = [];

				angular.forEach(categories, function (_category) {
					internalSaveModel(_category);
				});

				fmData.append('modelDTO', angular.toJson(newModel));
				$http({
					url: BASE_URL_COMPANY,
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': undefined,
						'authorization': []
					},
					transformRequest: angular.identity,
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.deleteModel = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateTypes = function (dto) {
			return $q(function (resolve, reject) {

				$http({
					url: BASE_URL_COMPANY + 'types',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateAssociations = function (dto) {
			return $q(function (resolve, reject) {

				$http({
					url: BASE_URL_COMPANY + 'associations',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateSites = function (dto) {
			return $q(function (resolve, reject) {

				$http({
					url: BASE_URL_COMPANY + 'sites',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateTags = function (dto) {
			return $q(function (resolve, reject) {

				$http({
					url: BASE_URL_COMPANY + 'tags',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateCountries = function (dto) {
			return $q(function (resolve, reject) {

				$http({
					url: BASE_URL_COMPANY + 'countries',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateRegions = function (dto) {
			return $q(function (resolve, reject) {

				$http({
					url: BASE_URL_COMPANY + 'regions',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8',
						'authorization': []
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		service.updateField = function (id, dto) {
			return $q(function (resolve, reject) {
				if (!dto.fixField) {
					var fmData = new FormData();
					var valuedField = {
						idBaseField: dto.id,
						id: dto.idValue
					};
					if (dto.typeChamps === 'BOOLEAN') {
						valuedField.value = '' + dto.value;
					} else if (dto.typeChamps === 'DATE') {
						if (dto.dateTime != null) {
							valuedField.value = $filter('date')(dto.dateTime, 'dd/MM/yyyy');
						}
					} else if (dto.typeChamps === 'LIST_SELECT') {
						if (!!dto.value) {
							valuedField.listFieldId = dto.value.id;
						}
					} else if (dto.typeChamps === 'MULTIPLE_SELECT') {
						valuedField.values = [];
						angular.forEach(dto.values, function (objectSelected) {
							valuedField.values.push({
								id: objectSelected.id,
								libelle: objectSelected.libelle
							});
						});
					} else if (dto.typeChamps === 'FILE' || dto.typeChamps === 'IMAGE') {
						valuedField.description = dto.description;
						var input = document.getElementById('genericField_file_' + dto.id + '_' + dto.index);
						var file = null;
						if (input != null) {
							file = input.files[0];

							if (file != null) {
								fmData.append('file', file);
							}

						}

					} else if (dto.typeChamps === 'NUMBER' || dto.typeChamps === 'INTEGER') {
						if ('null' === dto.value) {
							valuedField.value = '';
						} else {
							valuedField.value = dto.value;
						}
					} else {
						valuedField.value = dto.value;
					}
					fmData.append('modelDTO', angular.toJson(valuedField));
					$http({
						url: BASE_URL_COMPANY + id + '/field',
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': undefined,
							'authorization': []
						},
						data: fmData
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				}
			});
		};

		service.bulkUpdate = function (fmData, typeId) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'field/' + typeId,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': undefined,
						'authorization': []
					},
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.downloadValuedFile = function (fieldId) {
			var url = BASE_URL_COMPANY + 'download/' + fieldId + '/' + selectedModel.id;
			return url;
		};

		service.setActivated = function (id, activated) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + id + '/activate',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'active': activated
					},
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.setChecked = function (id, checked) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + id + '/checked',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'checked': checked
					},
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.setPrincipal = function (contactId) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'principal/' + contactId,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findAll = function (lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'findAll',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findForStatistics = function (lang, associationIDs, searchTxt) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'statistics',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
						'associationIDs': associationIDs,
						'searchTxt': searchTxt
					},
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		function findFirstCategory(categories) {
			var found = false;
			var index = 0;
			while (!found && index < categories.length) {
				var category = categories[index];
				if (category.index === FIRST_CATEGORY_INDEX) {
					return category;
				}
				index++;
			}
		}

		function setSelectedList(field) {
			var valueReturned = null;
			if (field.listFieldId != null) {
				for (var k = 0; k < field.listFieldsDTO.length; k++) {
					if (field.listFieldId === field.listFieldsDTO[k].id) {
						valueReturned = field.listFieldsDTO[k];
					}
				}
			}
			return valueReturned;
		}

		function setSelectedObject(field, data) {
			var valueReturned = null;
			if (data[field.keyJava]) {
				for (var k = 0; k < field.selectableObject.length; k++) {
					if (data[field.keyJava].id == field.selectableObject[k].id) {
						valueReturned = field.selectableObject[k];
					}
				}
			}
			return valueReturned;
		}

		function setSelectedMultipleObject(field, data) {
			var values = [];
			if (data[field.keyJava]) {
				for (var l = 0; l < data[field.keyJava].length; l++) {
					for (var k = 0; k < field.selectableObject.length; k++) {
						if (data[field.keyJava][l].id === field.selectableObject[k].id) {
							values.push(field.selectableObject[k]);
						}
					}
				}
			}
			return values;
		}

		// Company Disposition

		service.saveCompanyDisposition = function (companyId, dispositionDto) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + companyId + '/disposition/save/',
					method: 'POST',
					params: {
						'_v': new Date().getTime()
					},
					data: dispositionDto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.deleteCompanyDisposition = function (dispositionId) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'disposition/delete/' + dispositionId,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		// EXPORT
		service.export = function (dto, typeId, password, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + typeId + '/export',
					method: 'POST',
					responseType: 'arraybuffer',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
						'password': password
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.deleteExport = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'export/' + id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime(),
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.saveExport = function (dto) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'export',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findExports = function (lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'export',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		/* PUBLIC METHODS */
		service.filters = function (keyword, filters, page, max, siteId, typeId, lang, sortId) {
			return $q(function (resolve, reject) {
				$http({
					url: PUBLIC_URL_COMPANY + 'filter',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'keyword': keyword.value,
						'page': page,
						'max': max,
						'siteId': siteId,
						'lang': lang,
						'typeId': typeId,
						'fieldSortId': sortId
					},
					data: filters
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findByIdPublic = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: PUBLIC_URL_COMPANY + id,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findDispositionsById = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: PUBLIC_URL_COMPANY + id + '/dispositions',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findStatsClickByCompanyIDAndDates = function (postDTO) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_STATS + 'clicks',
					method: 'POST',
					params: {
						'_v': new Date().getTime()
					},
					data: postDTO
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.count = function (subTypeId) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'count',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'subTypeId': subTypeId
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.listStatus = function () {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'status',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateStatus = function (model) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'status',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						id: model.id,
						value: model.status
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findCompanies = function (searchName, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: BASE_URL_COMPANY + 'findBySearch',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
						'name': searchName
					},
					headers: {
						'Content-Type': 'application/json; charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}

		return service;

	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('companyController', companyController);

	function companyController($rootScope, DISPLAY_MODELS_ICONS, $scope, $state, $translate, $filter, $mdDialog, toastr, companyService, modelService, contactService,
		userService, SettingsMessageService, STORAGE_PREFIX, MessageService, MODELS_TYPES, DuplicationToolService, inscriptionService) {

		$scope.userService = userService;
		userService.getCurrent($translate.preferredLanguage(), false).then(function (response) {
			$scope.showSettings = userService.containsRole('COMPANY_SETTINGS');
		}).catch(function () {

		});
		$scope.iconsDisplay = {};
		angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
			$scope.iconsDisplay[elt.name] = elt.value;
		});

		$scope.$mdDialog = $mdDialog;
		$scope.logsShowed = false;
		$scope.statsClicksShowed = false;

		$scope.newDisposition = {};
		$scope.users = [];
		$scope.actions = [];
		$scope.inscriptions = [];
		$scope.message = {
			actionForm: null,
			receiverForm: null
		};
		$scope.filter = {
			sender: null,
			action: null
		};
		$scope.messages = [];
		$scope.typeAction = {
			ALL: 'ALL',
			TO_DO: 'TO_DO',
			DONE: 'DONE'
		};
		$scope.showForm = false;
		var subTypeId = $state.params.subType;
		var id = $state.params.id;

		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		if (subTypeId != null && id != null) {
			$scope.subTypeId = parseInt(subTypeId);
			$scope.modelType = 'COMPANY_MODEL';
			var baseUrl = './api/rest/model/' + $scope.modelType;

			companyService.getSelectedModelDisplay(id, subTypeId, $translate.preferredLanguage()).then(function (response) {
				$scope.company = response.data;
				$scope.refreshContacts();
				companyService.getCategoriesBySubType($translate.preferredLanguage(), $state.params.id, $scope.subTypeId, true).then(function (data) {
					$scope.categories = data;
				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});

			}).catch(function (response) {

			});

			inscriptionService.listByCompany(id, $translate.preferredLanguage()).then(function (response) {
				$scope.inscriptions = response.data;
				var _inscriptionFound = false;
				angular.forEach($scope.inscriptions, function (item, key) {
					$scope.inscriptions[key].categories = inscriptionService.buildModel(angular.copy(item.categories));

					// Target inscription from isncriptions list
					if (!_inscriptionFound && $state.params.inscriptionId && item.id === $state.params.inscriptionId) {
						item._showDetails = true;
						_inscriptionFound = true;
					}
				});
			}).catch(function () {

			});

			$scope.refreshContacts = function () {
				contactService.listContactsDisplay(id, $translate.preferredLanguage()).then(function (response) {
					$scope.contacts = response.data;
					putContactFavFirst();
				}).catch(function (response) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			};

			$scope.showMoreContacts = function () {
				contactService.listContactsHidden(id, $translate.preferredLanguage()).then(function (response) {
					$scope.hiddenContact = true;
					$scope.contacts = $scope.contacts.concat(response.data);
				}).catch(function (response) {

				});
			};


			$scope.hideMoreContacts = function () {
				contactService.listContactsHidden(id, $translate.preferredLanguage()).then(function (response) {
					$scope.hiddenContact = false;
					$scope.contacts = $scope.contacts.filter(function (el) {
						return $filter("filter")(response.data, {
							id: el.id
						}).length == 0;
					})
				}).catch(function (response) {

				});
			};

			modelService.getSubTypes(baseUrl, $translate.preferredLanguage(), true).then(function (response) {
				$scope.subTypes = response.data;
			}).catch(function () {

			});
		} else {
			$state.go('app.home');
		}



		/* LIVE UPDATE */
		$scope.$on('modelUpdated', function (event, args) {


			$scope.$broadcast('showLoader', { id: args.model.id });
			companyService.updateField(id, args.model).then(function (response) {
				companyService.getSelectedModelDisplay(id, subTypeId, $translate.preferredLanguage()).then(function (res) {
					$scope.company = res.data;
					for (var i = 0; i < $scope.company.valuedFields.length; i++) {
						var element = $scope.company.valuedFields[i];

						if (element.idBaseField == args.model.id) {
							$scope.$broadcast('inputImageUpdate', { id: args.model.id, src: element.fileLocation });
							break;
						}

					}

					putContactFavFirst();
				}).catch(function (response) {
					console.log("error")
				});
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		});

		$scope.$on('subTypeUpdated', function (event, args) {
			companyService.updateTypes($scope.company).then(function (response) {

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		});

		$scope.$on('associationUpdated', function (event, args) {
			companyService.updateAssociations($scope.company).then(function (response) {

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		});

		$scope.$on('siteUpdated', function (event, args) {
			companyService.updateSites($scope.company).then(function (response) {

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		});

		$scope.$on('tagsUpdated', function (event, args) {
			companyService.updateTags($scope.company).then(function (response) {

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		});

		$scope.$on('countriesUpdated', function (event, args) {
			companyService.updateCountries($scope.company).then(function (response) {

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		});

		$scope.$on('regionsUpdated', function (event, args) {
			companyService.updateRegions($scope.company).then(function (response) {

			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		});

		$scope.setActivated = function (id, activate) {
			companyService.setActivated(id, activate).then(function () { }).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.$on('activatedUpdated', function (event, args) {
			$scope.setActivated(id, args.model.activate);
		});

		$scope.$on('checkedUpdated', function (event, args) {
			companyService.setChecked(id, args.model.checked).then(function () { }).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		});

		$scope.$on('statusUpdated', function (event, args) {
			companyService.updateStatus(args.model).then(function () {

			}).catch(function () {

			});
		});
		/* LIVE UPDATE */

		$scope.showDeleteCompany = function () {
			var content = {
				title: $filter('translate')('COMPANIES.DELETE'),
				message: $filter('translate')('COMPANIES.CONFIRM_DELETE')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				companyService.deleteModel($scope.company.id).then(function (response) {
					$state.go('app.companies', {
						subType: subTypeId
					});
				}).catch(function () {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(function () {

			});
		};

		/* DISPOSITION */

		$scope.openDispositionDialogFn = function (_disposition) {

			$scope.newDisposition = {};

			if (_disposition) {
				$scope.newDisposition = angular.copy(_disposition);
			}

			$scope.$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/popup/disposition.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});

		};

		$scope.saveCompanyDisposition = function () {
			companyService.saveCompanyDisposition($scope.company.id, $scope.newDisposition).then(function (response) {
				if ($scope.newDisposition.id) {
					var index = $scope.company.dispositions.map(function (_disposition) {
						return _disposition.id;
					}).indexOf($scope.newDisposition.id);
					if (index > -1) {
						$scope.company.dispositions[index] = response.data;
					}
				} else {
					$scope.company.dispositions.push(response.data);
				}
				$mdDialog.cancel();
			}).catch(function (error) {
				console.log(error);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.deleteCompanyDisposition = function (_dispositionId) {
			companyService.deleteCompanyDisposition(_dispositionId).then(function (response) {
				var index = $scope.company.dispositions.map(function (_disposition) {
					return _disposition.id;
				}).indexOf(_dispositionId);
				if (index > -1) {
					$scope.company.dispositions.splice(index, 1);
				}
				$mdDialog.cancel();
			}).catch(function (error) {
				console.log(error);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		/* CONTACTS */

		$scope.$on('refreshContacts', function () {
			$scope.refreshContacts();
		});

		$scope.openAddContact = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/contacts/popup/add_contact.html',
				clickOutsideToClose: true,
				controller: 'addContactCtrl',
				locals: {
					companyId: id
				}
			}).then(function () {
				$scope.refreshContacts();
			}).catch(function () {

			});
		};

		$scope.detailsContact = function (id) {
			$state.go('app.companies.details.contact', {
				contactId: id
			});
		};

		$scope.setContactActivated = function (id, activate) {
			contactService.setActivated(id, activate).then(function (response) {

			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};


		//	MESSAGES

		$scope.findAllMessages = function () {
			switch ($scope.filter.action) {
				case null:
					delete $scope.filter.actionToDo;
					$scope.filter.actionExist = false;
					break;
				case $scope.typeAction.ALL:
					delete $scope.filter.actionToDo;
					$scope.filter.actionExist = true;
					break;
				case $scope.typeAction.DONE:
					$scope.filter.actionToDo = false;
					break;
				case $scope.typeAction.TO_DO:
					$scope.filter.actionToDo = true;
					break;
				default:
					break;
			}
			$scope.filter.addressee = [];
			angular.forEach($scope.filter.receiverForm, function (item, key) {
				$scope.filter.addressee.push(angular.fromJson(item));
			});
			$scope.filter.companyId = id;
			MessageService.findAllMessage($scope.filter, localStorage[STORAGE_PREFIX + 'language']).then(function (messages) {
				$scope.messages = messages.data;
			}).catch(function (data) {

			});
		};
		$scope.findAllMessages();

		$scope.getDate = function (date) {
			return moment(date).toDate();
		};


		$scope.confirmAction = function (action) {
			var content = {
				title: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL_TITLE') : $filter('translate')('MESSAGE.ACTION_CONFIRM_TITLE'),
				message: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL') : $filter('translate')('MESSAGE.ACTION_CONFIRM')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				action.actionDone = !action.actionDone;
				MessageService.confirmAction(action).then(function (data) { }).catch(function (data) { });
			}).catch(function () {

			});
		};

		$scope.showPopUpMessage = function () {
			var message = {
				actionForm: null,
				receiverForm: null
			};

			for (var i = 0; i < $scope.users.length; i++) {
				if ($scope.users[i].id === $rootScope.user.id) {
					$scope.message.receiverForm = angular.toJson($scope.users[i]);
					break;
				}
			}

			var now = new Date();
			message.startDateForm = now;
			message.startTime = (now.getHours() < 10 ? '0' + now.getHours() : now.getHours()) + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());


			$mdDialog.show({
				templateUrl: 'app/main/message/popup/update_message.html',
				clickOutsideToClose: true,
				controller: 'updateMessageController',
				locals: {
					companyId: id,
					contactId: null,
					message: message,
					from: null,
					scope: $scope
				}
			}).then(function () {
				$scope.findAllMessages();
			}).catch(function () {

			});
		};

		$scope.updateMessage = function (message) {
			var messageToUpdate = angular.copy(message);
			// $scope.message.receiverForm = angular.copy(angular.toJson(msg.receiver).toString());
			// console.log($scope.message);
			if (message.action != null) {
				var actionID = angular.copy(message.action.actionID);
				angular.forEach($scope.actions, function (action) {
					if (action.id === actionID) {
						messageToUpdate.actionForm = angular.toJson(action);
					}
				});
			} else {
				messageToUpdate.actionForm = null;
			}


			if (message.action != null && message.action.dateAction != null) {
				var date = new Date(message.action.dateAction);

				messageToUpdate.startDateForm = date;
				messageToUpdate.startTime = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
			} else {
				var now = new Date();
				messageToUpdate.startDateForm = now;
				messageToUpdate.startTime = (now.getHours() < 10 ? '0' + now.getHours() : now.getHours()) + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());
			}
			$mdDialog.show({
				templateUrl: 'app/main/message/popup/update_message.html',
				clickOutsideToClose: true,
				controller: 'updateMessageController',
				locals: {
					companyId: id,
					contactId: null,
					message: messageToUpdate,
					from: null
				}

			}).then(function () {
				$scope.findAllMessages();
			}).catch(function () {

			});
		};


		$scope.showLogs = function () {
			$scope.statsClicksShowed = false;
			$scope.logsShowed = !$scope.logsShowed;
		};

		$scope.showStatsClicks = function () {
			$scope.logsShowed = false;
			$scope.statsClicksShowed = !$scope.statsClicksShowed;
		};

		function putContactFavFirst() {
			if ($scope.contacts.length > 0 && $scope.company && $scope.company.favouriteId) {
				for (var i = 0; i < $scope.contacts.length; i++) {
					var contact = angular.copy($scope.contacts[i]);
					if (contact.id === $scope.company.favouriteId) {
						$scope.contacts.splice(i, 1);
						$scope.contacts.unshift(contact);
					}
				}
			}
		}

		// Outils de duplication
		$scope._lookForThisCompanyDuplicates = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/duplication_tool/duplication_tool_modal.html',
				clickOutsideToClose: true,
				controller: 'DuplicationToolModalController',
				locals: {
					dtToolData: {
						_modelType: MODELS_TYPES.COMPANY_MODEL,
						_modelSubTypeId: parseInt($scope.subTypeId),
						_companyId: id
					}
				}
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope._lookForContactDuplicates = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/duplication_tool/duplication_tool_modal.html',
				clickOutsideToClose: true,
				controller: 'DuplicationToolModalController',
				locals: {
					dtToolData: {
						_modelType: MODELS_TYPES.CONTACT_MODEL,
						_modelSubTypeId: parseInt($scope.subTypeId),
						_companyId: id
					}
				}
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope._contactDuplicatesAutoMergeFn = function () {
			$scope._mdProgressLinear = true;
			DuplicationToolService._autoMergeDuplicatesModel(MODELS_TYPES.CONTACT_MODEL, null, id).then(function (response) {
				if (!JSON.parse(response.data)) {
					toastr.error($filter('translate')('DUPLICATION_TOOL.ANY_OCCURENCE_FOUND'));
				} else {
					$scope.refreshContacts();
					toastr.success($filter('translate')('DUPLICATION_TOOL.MERGE.MERGE_ACTION_SUCCESS'));
				}
				$scope._mdProgressLinear = false;
			}).catch(function (error) {
				console.log(error);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$scope._mdProgressLinear = false;
			});
		};

		$scope.checkMyProfileOnline = function () {
			window.open(" https://visit-lebanon.org/leisure/provider?param1=" + id, "blank");
		};

		/* Subscription */

		$scope.setStatusStyle = function (status) {
			if (status != null && status.color != null) {
				return {
					'background-color': status.color,
					'color': 'white',
					'font-weight': 600
				};
			} else {
				return {
					'font-weight': 600
				};
			}
		};

	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('companiesController', companiesController);

	function companiesController($rootScope, statisticsService, $scope, $state, $translate, $mdDialog, $timeout, $filter, toastr, companyService, modelService, researchEngineFilterService, researchEngineSortService, MODELS_TYPES, DuplicationToolService) {

		$scope.newCompany = {
			subTypesIds: []
		};

		$scope.modelTypes = MODELS_TYPES;
		$scope.bulkUpdating = false;
		$scope.allLoaded = false;
		$scope.loaded = true;
		$scope.loadingStatsRepartition = false;
		$scope.companies = [];
		$scope.categories = [];
		$scope.fieldsStats = [];
		$scope.showIfAllowed = false;
		//show inactives or not
		$scope.hideAll = true;
		$scope.maxNumberPage = 1;
		$scope.pagination = {
			modelFiltersDto: researchEngineFilterService.getFilter(),
			modelSortsDto: researchEngineSortService.getSort(),
			start: 0,
			outputs: 100
		};
		$scope.loading = false;


		var subTypeId = $state.params.subType;

		function init() {
			if (subTypeId != null) {
				$scope.subTypeId = parseInt(subTypeId);
				$scope.modelType = 'COMPANY_MODEL';
				var baseUrl = './api/rest/model/' + $scope.modelType;

				modelService.getSubType(baseUrl, $translate.preferredLanguage(), $scope.subTypeId).then(function (response) {
					$scope.subTypeObj = response.data;
				}).catch(function (err) {
					console.log(err);
				});

				if ($rootScope.user) {
					$scope.hideAll = !$rootScope.user.seeInactiveContact;
				}

				//changeActiveFilter();
				$scope.pagination.modelFiltersDto.hideInactivated = $scope.hideAll;

				$scope.loaded = false;
				companyService.findByTypeId($scope.subTypeId, $scope.pagination, $translate.preferredLanguage()).then(function (response) {
					$scope.companies = response.data;
					if ($scope.subTypes) {
						getSubTypesNames();
					}
					if (response.data.length > 0) {
						$scope.maxNumberPage = parseInt(response.data[0].nbrResults / $scope.pagination.outputs) + 1;
					}

					$scope.loaded = true;
				}).catch(function (err) {
					console.log(err);
				});

				modelService.getSubTypes(baseUrl, $translate.preferredLanguage(), true).then(function (response) {
					$scope.subTypes = response.data;
					if ($scope.companies) {
						getSubTypesNames();
					}
				}).catch(function (err) {
					console.log(err);
				});

				modelService.listExportableField(baseUrl, $scope.subTypeId, $translate.preferredLanguage()).then(function (response) {
					$scope.companyFields = response.data;
				}).catch(function () {

				});

				modelService.listExportableField('./api/rest/model/CONTACT_MODEL', null, $translate.preferredLanguage()).then(function (response) {
					$scope.contactFields = response.data;
				}).catch(function () {

				});

				$rootScope.user.rights.find(function (right) {
					if (right.name == "DUPLICATION_TOOL") {
						return $scope.showIfAllowed = true;
					}
				});

			} else {
				$state.go('app.home');
			}
		}

		init();

		companyService.getCategories($translate.preferredLanguage()).then(function (data) {
			$scope.categories = data;
		}).catch(function (err) {
			console.log(err);
		});

		$scope.showCompanyDialog = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/popup/add_company.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.showBulkUpdateDialog = function () {
			$scope.bulkUpdateDTO = {};
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/popup/bulk_update.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.showBulkMessageDialog = function () {
			var message = {
				actionForm: null,
				receiverForm: null
			};
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/popup/bulk_message.html',
				clickOutsideToClose: true,
				controller: 'updateMessageController',
				locals: {
					companyId: null,
					contactId: null,
					message: message,
					from: {
						searchCompanies: true,
						pagination: $scope.pagination
					}
				}
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.refreshFields = function () {
			var baseUrl = './api/rest/model/' + $scope.bulkUpdateDTO.modelType;
			modelService.listModifiableField(baseUrl, $scope.subTypeId, $translate.preferredLanguage()).then(function (response) {
				$scope.fields = response.data;
			}).catch(function () {

			});
		};

		$scope.bulkUpdate = function () {
			$scope.bulkUpdating = true;
			if ($scope.bulkUpdateDTO.field != null) {
				var fmData = new FormData();
				var valuedFieldsModel = angular.copy($scope.bulkUpdateDTO.field);
				valuedFieldsModel.idBaseField = valuedFieldsModel.id;

				fmData.append('paginationDTO', angular.toJson($scope.pagination));
				if (valuedFieldsModel.typeChamps === 'BOOLEAN') {
					valuedFieldsModel.value = '' + valuedFieldsModel.value;
				} else if (valuedFieldsModel.typeChamps === 'DATE') {
					if (valuedFieldsModel.dateTime != null) {
						valuedFieldsModel.value = $filter('date')(valuedFieldsModel.dateTime, 'dd/MM/yyyy');
					}
				} else if (valuedFieldsModel.typeChamps === 'LIST_SELECT') {
					if (valuedFieldsModel.fixedFieldSqlKey != null) {
						valuedFieldsModel.value = valuedFieldsModel.value.id;
					} else {
						if (!!valuedFieldsModel.value) {
							valuedFieldsModel.value = '' + valuedFieldsModel.value.id;
						}
					}
				} else if (valuedFieldsModel.typeChamps === 'MULTIPLE_SELECT') {
					valuedFieldsModel.values = [];
					angular.forEach($scope.bulkUpdateDTO.field.values, function (objectSelected) {
						valuedFieldsModel.values.push({
							id: objectSelected.id,
							libelle: objectSelected.libelle
						});
					});
				} else if (valuedFieldsModel.typeChamps === 'FILE' || valuedFieldsModel.typeChamps === 'IMAGE') {
					var input = document.getElementById('genericField_file_' + valuedFieldsModel.id + '_' + valuedFieldsModel.index);
					var file = null;
					if (input != null) {
						file = input.files[0];
					}
					if ($scope.companies.length > 0) {
						if (valuedFieldsModel.modelType === 'CONTACT_MODEL') {
							valuedFieldsModel.value = '' + $scope.companies[0].nbContacts;
						} else {
							valuedFieldsModel.value = '' + $scope.companies[0].nbrResults;
						}
					} else {
						valuedFieldsModel.value = '0';
					}
					if(file!=null){
						fmData.append('file', file);
					}
				} else if (valuedFieldsModel.typeChamps === 'NUMBER' || valuedFieldsModel.typeChamps === 'INTEGER') {
					if ('null' === valuedFieldsModel.value) {
						valuedFieldsModel.value = '';
					}
				}
				fmData.append('modelDTO', angular.toJson(valuedFieldsModel));
				companyService.bulkUpdate(fmData, $scope.subTypeId).then(function () {
					$scope.bulkUpdating = false;
					$scope.filterCompanies($scope.pagination.modelFiltersDto);
					toastr.success($filter('translate')('COMPANIES.BULK_UPDATE_SUCCESS'));
					$mdDialog.hide();
				}).catch(function (error) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					$scope.bulkUpdating = false;
				});
			}
		};

		$scope.getCompanies = function () {
			$scope.allLoaded = false;
			$scope.companies = [];
			$scope.loaded = false;
			$scope.pagination.modelFiltersDto.hideInactivated = $scope.hideAll;
			companyService.findByTypeId($scope.subTypeId, $scope.pagination, $translate.preferredLanguage()).then(function (response) {
				$scope.companies = response.data;
				getSubTypesNames();
				$scope.loaded = true;
			}).catch(function (response) {
				console.log(response);
			});
		};

		$scope.filterCompanies = function (filter) {
			$scope.pagination.modelFiltersDto = filter;
			$scope.pagination.start = 0;
			$scope.allLoaded = false;
			$scope.companies = [];
			$scope.getCompanies();
			$scope.getStatisticsBySubTypeID();
		};

		$scope.sortCompanies = function (sort) {
			$scope.pagination.modelSortsDto = sort;
			$scope.pagination.start = 0;
			$scope.allLoaded = false;
			$scope.companies = [];
			$scope.getCompanies();
		};

		$scope.saveCompany = function () {
			companyService.addModel($scope.categories, $scope.newCompany, $scope.subTypes, $translate.preferredLanguage()).then(function (response) {
				$scope.hidePopup();
				$timeout(function () {
					$state.go('app.companies.details', {
						id: response.data
					});
				});
			}).catch(function (response) {
				if (response.error === 'notype') {
					toastr.error($filter('translate')('COMPANIES.TYPE_REQUIRED'));
				}
			});
		};

		$scope.details = function (company) {
			$state.go('app.companies.details', {
				id: company.id
			});
		};

		$scope.hidePopup = function () {
			$mdDialog.cancel();
		};

		$scope.detailsContact = function (companyId, contactId) {
			$state.go('app.companies.details.contact', {
				id: companyId,
				contactId: contactId
			});
		};

		$scope.filterModel = function (model, index) {
			return $filter('showColumn')(model, index);
		};

		function getSubTypesNames() {
			if ($scope.companies.length > 0) {
				for (var i = 0; i < $scope.companies.length; i++) {
					if (!$scope.companies[i].subTypesNames) {
						$scope.companies[i].subTypesNames = [];
						for (var j = 0; j < $scope.companies[i].subTypesIds.length; j++) {
							for (var k = 0; k < $scope.subTypes.length; k++) {
								if ($scope.companies[i].subTypesIds[j] === $scope.subTypes[k].id) {
									$scope.companies[i].subTypesNames.push($scope.subTypes[k].name);
								}
							}
						}
					}
				}
			}
		}

		$scope.switchActives = function () {
			$scope.hideAll = !$scope.hideAll;

			$scope.companies = [];
			$scope.pagination.start = 0;

			$scope.getCompanies();
		};

		$scope.getStatisticsBySubTypeID = function () {
			$scope.loadingStatsRepartition = true;
			statisticsService.getStratisticsFilteredBySubTypeId(subTypeId, $translate.preferredLanguage(), $scope.pagination).then(function (res) {
				if (res.data) {
					$scope.fieldsStats = res.data;
					$scope.loadingStatsRepartition = false;
				}
			}).catch(function (err) {
				$scope.loadingStatsRepartition = false;
				console.log(err);
			});
		};

		function changeActiveFilter() {
			if ($scope.hideAll) {
				if ($scope.pagination.modelFiltersDto.filters.length > 0) {
					if (!$scope.pagination.modelFiltersDto.filters[0].fieldFilters) {
						$scope.pagination.modelFiltersDto.filters[0].fieldFilters = [];
					}
					$scope.pagination.modelFiltersDto.filters[0].fieldFilters.push({
						fieldFilterBaseType: 'FIXE_FIELD',
						modelType: 'COMPANY_MODEL',
						activated: true,
						fixeFieldFilterKeyLang: "FIXE_FIELD_STATUS",
						typeChamps: "BOOLEAN",
						criteria: true,
						notDisplayed: true
					});
				} else {
					$scope.pagination.modelFiltersDto.filters.push({
						fieldFilters: []
					});
					$scope.pagination.modelFiltersDto.filters[0].fieldFilters.push({
						fieldFilterBaseType: 'FIXE_FIELD',
						modelType: 'COMPANY_MODEL',
						activated: true,
						fixeFieldFilterKeyLang: "FIXE_FIELD_STATUS",
						typeChamps: "BOOLEAN",
						criteria: true,
						notDisplayed: true
					});
				}
			} else {
				for (var i = 0; i < $scope.pagination.modelFiltersDto.filters.length; i++) {
					if ($scope.pagination.modelFiltersDto.filters[i].fieldFilters) {
						for (var j = 0; j < $scope.pagination.modelFiltersDto.filters[i].fieldFilters.length; j++) {
							if ($scope.pagination.modelFiltersDto.filters[i].fieldFilters[j].notDisplayed) {
								$scope.pagination.modelFiltersDto.filters[i].fieldFilters.splice(j, 1);
							}
						}
					}
				}
			}
		}

		/*
		 * Mailing
		 */
		$scope._mailingDialogOpenFn = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/mailing/mailing_modal.html',
				clickOutsideToClose: false,
				controller: 'MailingModalController',
				locals: {
					data: {
						modelType: MODELS_TYPES.COMPANY_MODEL,
						modelSubTypeId: subTypeId,
						filter: $scope.pagination.modelFiltersDto
					}
				}
			}).then(function () {

			}).catch(function () {

			});
		};


		/* EXPORT */
		$scope._exportParams = {
			companyFields: [],
			contactFields: [],
			option: ''
		};
		$scope.search = {
			company: '',
			contact: ''
		};
		$scope.exportInProgress = false;

		companyService.findExports($translate.preferredLanguage()).then(function (response) {
			$scope.exports = response.data;
		}).catch(function () {

		});

		$scope.saveExport = function () {

			var dto = {
				name: $scope._exportParams._name,
				option: $scope._exportParams._option,
				fields: []
			};
			if ($scope._exportParams.id != null) {
				dto.id = $scope._exportParams.id;
			}
			dto.fields = dto.fields.concat($scope._exportParams.companyFields);
			dto.fields = dto.fields.concat($scope._exportParams.contactFields);
			if (dto.fields.length > 0 && dto.name != null && dto.name.trim().length > 0) {
				companyService.saveExport(dto).then(function (response) {
					if (response.data != null) {
						$scope._exportParams.id = parseInt(response.data);
					}
					companyService.findExports($translate.preferredLanguage()).then(function (response) {
						$scope.exports = response.data;
						for (var i = 0; i < $scope.exports.length; i++) {
							if ($scope.exports[i].id === $scope._exportParams.id) {
								$scope._exportParams = $scope.exports[i];
								$scope.exportChanged();
								break;
							}
						}
					}).catch(function () {

					});
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_SAVE'));
				}).catch(function () {

				});
			} else {
				if (dto.fields.length === 0) {
					toastr.error($filter('translate')('COMPANIES.EXPORT.ERROR_FIELDS'));
				} else if (dto.name == null || dto.name.trim().length === 0) {
					toastr.error($filter('translate')('COMPANIES.EXPORT.ERROR_NAME'));
				}
			}
		};

		$scope.openDeleteExport = function () {
			var content = {
				title: $filter('translate')('COMPANIES.EXPORT.DELETE_TITLE'),
				message: $filter('translate')('COMPANIES.EXPORT.DELETE_MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				$scope.deleteExport();
			}).catch(function () {

			});
		};

		$scope.deleteExport = function () {
			if ($scope._exportParams.id != null) {
				companyService.deleteExport($scope._exportParams.id).then(function (response) {
					for (var i = 0; i < $scope.exports.length; i++) {
						if ($scope.exports[i].id === $scope._exportParams.id) {
							$scope.exports.splice(i, 1);
							$scope._exportParams = {
								companyFields: [],
								contactFields: [],
								option: ''
							};
							break;
						}
					}
				}).catch(function () {

				});
			}
		};

		$scope.addField = function (chip, fields) {
			// $scope.companyFields = $filter('fieldsSelected', fields)
			if (chip == null || chip.id == null) {
				fields.splice(fields.length - 1, 1);
			}
		};

		$scope.launchExport = function () {
			$scope.exportInProgress = true;
			var dto = {
				fields: [],
				modelPagination: $scope.pagination,
				option: $scope._exportParams._option
			};
			dto.fields = dto.fields.concat($scope._exportParams.companyFields);
			dto.fields = dto.fields.concat($scope._exportParams.contactFields);
			companyService.export(dto, $scope.subTypeId, $scope._exportParams.password, $translate.preferredLanguage()).then(function (response) {
				var byteArray = new Uint8Array(response.data);
				var a = window.document.createElement('a');
				a.href = window.URL.createObjectURL(new Blob([byteArray], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				}));
				a.download = 'export.xlsx';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				$scope.exportInProgress = false;
			}).catch(function (error) {
				if (error.status === 403) {
					toastr.error($filter('translate')('COMPANIES.EXPORT.BAD_PASSWORD'));
				}
				$scope.exportInProgress = false;
			});
		};

		$scope.exportChanged = function () {
			$scope._exportParams = angular.copy($scope._exportParams);
			if ($scope._exportParams != null) {
				if ($scope._exportParams.fields != null) {
					$scope._exportParams.companyFields = [];
					$scope._exportParams.contactFields = [];
					for (var i = 0; i < $scope._exportParams.fields.length; i++) {
						var field = angular.copy($scope._exportParams.fields[i]);
						$scope._exportParams._name = angular.copy($scope._exportParams.name);
						$scope._exportParams._option = angular.copy($scope._exportParams.option);
						if (field.modelType === 'COMPANY_MODEL') {
							$scope._exportParams.companyFields.push(field);
						} else if (field.modelType === 'CONTACT_MODEL') {
							$scope._exportParams.contactFields.push(field);
						}
					}
				} else {
					$scope._exportParams = {
						companyFields: [],
						contactFields: [],
						option: ''
					};
				}
			} else {
				$scope._exportParams = {
					companyFields: [],
					contactFields: [],
					option: ''
				};
			}
		};

		$scope.fieldsSelected = function (fields, selectedFields) {
			var res = [];
			if (angular.isArray(selectedFields)) {
				var fieldIds = selectedFields.map(function (item) {
					return item.id;
				});
				angular.forEach(fields, function (item) {
					if (fieldIds.lastIndexOf(item.id) === -1) {
						res.push(item);
					}
				});
				return res;
			} else {
				return fields;
			}
		};

		// Auto merge tool
		$scope._companiesDuplicatesAutoMergeStepFn = function () {
			console.log('in companies duplicate auto merge STEP');
			DuplicationToolService._autoMergeDuplicatesModelStep(MODELS_TYPES.COMPANY_MODEL, subTypeId, null, $scope.pagination, $translate.preferredLanguage()).then(function (response) {
				// if (!response.data.total || (response.data.total && response.data.total.length === 0) ||
				// (response.data.total && response.data.total.length > 0 && response.data.total[0] <= 1)) {
				$scope._mdProgressLinear = false;
				$scope.filterCompanies($scope.pagination.modelFiltersDto);
				toastr.success($filter('translate')('COMPANIES.AUTO_MERGE_SUCCESS'));
				$scope.loading = false;
				$scope.hidePopup();
				// } else {
				// 	$scope.previousIdsCompared = response.data.previousIdsCompared;
				// 	$scope.determinateValue = (($scope.determinateValueSup - response.data.total[0]) * 100) / $scope.determinateValueSup;
				// 	$scope._companiesDuplicatesAutoMergeStepFn();
				// }
			}).catch(function (error) {
				console.log(error);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$scope._mdProgressLinear = false;
			});

		};

		$scope._openAutoMergeDialog = function () {
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/popup/confirm_duplicates_removal.html',
				preserveScope: true,
				scope: $scope,
				clickOutsideToClose: true
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope._companiesDuplicatesAutoMergeFn = function () {
			console.log('in companies duplicate auto merge');
			$scope.loading = true;
			$scope._mdProgressLinear = true;
			$scope.previousIdsCompared = [];
			$scope.determinateValue = 0;

			companyService.count(subTypeId).then(function (response) {
				$scope.determinateValueSup = parseInt(response.data);
			}, function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});

			$scope._companiesDuplicatesAutoMergeStepFn();
		}



		// Empty field tool
		$scope.lookForMissingInfos = function () {
			$mdDialog.show({
				templateUrl: 'app/main/missing_infos_tool/missing_infos_tool_modal/missing_infos_tool_modal.html',
				clickOutsideToClose: false,
				controller: 'MissingInfosToolModalController',
				locals: {
					datas: {
						modelSubtypeId: $scope.subTypeId
					}
				}
			}).then(function (data) {
				$scope.companies = data;
			}).catch(function () {

			});
		};

		$scope.loadDuplicationTool = function () {
			$scope.pagination.modelFiltersDto.hideInactivated = $scope.hideAll;
			$mdDialog.show({
				templateUrl: 'app/main/globe_network/companies/duplication_tool/duplication_tool_modal.html',
				clickOutsideToClose: true,
				controller: 'DuplicationToolModalController',
				locals: {
					dtToolData: {
						_modelType: MODELS_TYPES.COMPANY_MODEL,
						_modelPaginationDto: $scope.pagination,
						_modelSubTypeId: $scope.subTypeId
					}
				}
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};

	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('SubGalleryController', SubGalleryController);

	function SubGalleryController($rootScope, GalleryService, $scope, $translate, $timeout, $location, toastr, FestivalService, languageService, $filter, $mdDialog, DocumentService, $sce, $state, userService) {
		$scope.subGallery = {};
		$scope.languages = [];
		$scope.language = {};
		$scope.loaded = false;
		$scope.updateMode = false;
		$scope.updatingPhotos = false;
		$scope.photos = [];
		var uuidGallery;
		var uuid;

		$scope.getSubGallery = function (uuid, lang) {
			GalleryService.getSub(uuid, lang).then(function (res) {
				$scope.subGallery = res.data;
				$scope.loaded = true;
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.deletePhoto = function (index) {
			$scope.photos.splice(parseInt(index), 1);
		};

		$scope.displayPopUpDeletePhoto = function (photo, index, sub) {
			$scope.photoToDelete = angular.copy(photo);
			$scope.indexToDelete = index;
			$scope.subGalleryEdit = sub;
			$mdDialog.show({
				templateUrl: 'app/main/packages/popup/deletePhoto.popup.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.deletePhotoPermanentely = function () {
			DocumentService.deleteFile($scope.photoToDelete.id).then(function (res) {
				$scope.subGalleryEdit.pictures.splice($scope.indexToDelete, 1);
				toastr.success($filter('translate')('PACKAGES.ADD.TOAST.SUCCESS_DELETE_PHOTO'));
				$scope.hidePopup();
			}).catch(function (err) {
				toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_DELETE_PHOTO'));
			});
		};

		$scope.update = function () {
			$scope.updatingPhotos = true;
			var photos = [];

			for (var i = 0; i < $scope.photos.length; i++) {
				console.log($scope.photos[i]);
				if ($scope.photos[i] != null && $scope.photos[i].uploadFile != null && $scope.photos[i].uploadFile.name != null) {
					var photo = $scope.photos[i].uploadFile;
					photos.push(photo);
				}
			}

			GalleryService.saveSub($scope.subGallery, uuidGallery, $scope.language.key).then(function (res) {
				if (res.data && res.data.id) {
					uuid = res.data.uuid;
					//On upload les photos l'une après l'autre car le faire en parallèle cause une erreur côté back
					var fds = [];

					for (var i = 0; i < photos.length; i++) {
						var formData = new FormData();
						formData.append('file', photos[i], photos[i].name);
						formData.append('dto', angular.toJson({
							subGalleryId: res.data.id
						}));

						fds.push(formData);
					}

					console.log(fds);

					var index = 0;

					if (fds.length > 0) {
						for (var i = 0; i < fds.length; i++) {
							if (i === 0) {
								if (fds.length === 1) {
									addPhoto(fds[i], i, true);
								} else {
									addPhoto(fds[i], i, false);
								}

								index++;
							} else {
								$scope.$on('photoUploaded' + i, function () {
									if (index === fds.length - 1) {
										addPhoto(fds[index], index, true);
									} else {
										addPhoto(fds[index], index, false);
									}

									index++;
								});
							}
						}
					} else {
						$scope.updatingPhotos = false;
					}
				} else {
					$scope.updatingPhotos = false;
				}
			});
		};

		$scope.goBack = function () {
			$state.go('app.gallery.details', {
				uuid: uuidGallery
			});
		};

		function addPhoto(fd, i, last) {
			if (fd) {
				var index = angular.copy(i);
				DocumentService.save(fd).then(function (res) {
					$scope.$emit('photoUploaded' + (index + 1));
					if (last) {
						$scope.photos = [];
						$state.go('.', {
							uuidSub: uuid
						}, {
							notify: false
						});
						$scope.getSubGallery(uuid, $scope.language.key);
						$scope.updatingPhotos = false;
					}

				}).catch(function (err) {
					toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_ADD_PHOTO'));
					$scope.$emit('photoUploaded' + (index + 1));
				});
			}
		}

		function init() {
			if (!$state.params.uuid) {
				$state.go('app.gallery');
			}

			uuidGallery = $state.params.uuid;

			if ($state.params.uuidSub) {
				$scope.updateMode = true;
			}

			languageService.getLanguages().then(function (response) {
				$scope.languages = response.data;
				for (var i = 0; i < $scope.languages.length; i++) {
					var language = $scope.languages[i];
					if (language.preferred) {
						$scope.language.key = language.key;
						break;
					}
				}

				if (!$state.params.uuidSub) {
					$scope.loaded = true;
					return;
				}

				$scope.$watch('language.key', function () {
					$scope.getSubGallery($state.params.uuidSub, $scope.language.key);
				});
			}).catch(function (error) {

			});
		}

		init();
	}
})();

(function () {
	'use strict';

	angular.module('app.front').controller('DetailsGalleryController', DetailsGalleryController);

	function DetailsGalleryController($rootScope, GalleryService, $scope, $translate, $timeout, $location, toastr, FestivalService, languageService, $filter, $mdDialog, DocumentService, $sce, $state, userService) {
		$scope.gallery = {};
		$scope.languages = [];
		$scope.language = {};
		$scope.loaded = false;

		$scope.getGallery = function (uuid, lang) {
			GalleryService.get(uuid, lang).then(function (res) {
				$scope.gallery = res.data;
				$scope.loaded = true;
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.upate = function () {
			GalleryService.save($scope.gallery, $scope.language.key).then(function (res) {
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_CREATE'));
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.deletePhoto = function (index) {
			$scope.photos.splice(parseInt(index), 1);
		};

		$scope.goAddSubGallery = function (sub) {
			if (!sub) {
				$state.go('app.gallery.details.sub');
			} else {
				$state.go('app.gallery.details.sub', {uuidSub: sub.uuid});
			}

			// $mdDialog.show({
			// 	templateUrl: 'app/main/gallery/details/addSubGallery.popup.html',
			// 	preserveScope: true,
			// 	scope: $scope,
			// 	clickOutsideToClose: true
			// }).then(function () {

			// }).catch(function () {

			// });
		};

		$scope.showPopUpRemove = function (subGallery, index) {
			$scope.subGallery = subGallery;
			$scope.index = index;

			$mdDialog.show({
				templateUrl: 'app/main/gallery/details/removeSubGallery.popup.html',
				preserveScope: true,
				scope: $scope,
				clickOutsideToClose: true
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.displayPopUpDeletePhoto = function (photo, index, sub) {
			$scope.photoToDelete = angular.copy(photo);
			$scope.indexToDelete = index;
			$scope.subGalleryEdit = sub;
			$mdDialog.show({
				templateUrl: 'app/main/packages/popup/deletePhoto.popup.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope,
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.downSub = function(sub) {
			GalleryService.downSubGallery(sub.uuid).then(function(res) {
				for (var i = 0; i < $scope.gallery.subGalleries.length; i++) {
					if ($scope.gallery.subGalleries[i].index === sub.index + 1) {
						$scope.gallery.subGalleries[i].index += -1;
					}
				}

				sub.index++;
			}).catch(function(err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.upSub = function(sub) {
			GalleryService.upSubGallery(sub.uuid).then(function(res) {
				for (var i = 0; i < $scope.gallery.subGalleries.length; i++) {
					if ($scope.gallery.subGalleries[i].index === sub.index - 1) {

						$scope.gallery.subGalleries[i].index++;
					}
				}

				sub.index += -1;
			}).catch(function(err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.removeSubGallery = function() {
			GalleryService.removeSub($scope.subGallery.id).then(function(res) {
				var index = angular.copy($scope.subGallery.index);
				for (var i = 0; i < $scope.gallery.subGalleries.length; i++) {
					if ($scope.gallery.subGalleries[i].id === $scope.subGallery.id) {
						$scope.gallery.subGalleries.splice(i, 1);
						break;
					}
				}

				for (var i = 0; i < $scope.gallery.subGalleries.length; i++) {
					if ($scope.gallery.subGalleries[i].index > index) {
						$scope.gallery.subGalleries[i].index += -1;
					}
				}

				$scope.hidePopup();
			}).catch(function(err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.deletePhotoPermanentely = function () {
			DocumentService.deleteFile($scope.photoToDelete.id).then(function (res) {
				$scope.subGalleryEdit.pictures.splice($scope.indexToDelete, 1);
				toastr.success($filter('translate')('PACKAGES.ADD.TOAST.SUCCESS_DELETE_PHOTO'));
				$scope.hidePopup();
			}).catch(function (err) {
				toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_DELETE_PHOTO'));
			});
		};

		$scope.addSubGallery = function () {
			var photos = [];

			for (var i = 0; i < $scope.photos.length; i++) {
				console.log($scope.photos[i]);
				if ($scope.photos[i] != null && $scope.photos[i].uploadFile != null) {
					var photo = $scope.photos[i].uploadFile;
					photos.push(photo);
				}
			}

			GalleryService.saveSub($scope.subGallery, $scope.gallery.id, $scope.language.key).then(function (res) {
				if (res.data && res.data.id) {
					//On upload les photos l'une après l'autre car le faire en parallèle cause une erreur côté back
					var fds = [];

					for (var i = 0; i < photos.length; i++) {
						var formData = new FormData();
						formData.append('file', photos[i], photos[i].name);
						formData.append('dto', angular.toJson({
							subGalleryId: res.data.id
						}));

						fds.push(formData);
					}

					var index = 0;

					if (fds.length > 0) {
						for (var i = 0; i < fds.length; i++) {
							if (i === 0) {
								if (fds.length === 1) {
									addPhoto(fds[i], i, true);
								} else {
									addPhoto(fds[i], i, false);
								}

								index++;
							} else {
								$scope.$on('photoUploaded' + i, function () {
									if (index === fds.length - 1) {
										addPhoto(fds[index], index, true);
									} else {
										addPhoto(fds[index], index, false);
									}

									index++;
								});
							}
						}
					}
				}
			});
		};

		$scope.goBack = function() {
			$state.go('app.gallery');
		};

		function addPhoto(fd, i, last) {
			var index = angular.copy(i);
			DocumentService.save(fd).then(function (res) {
				$scope.$emit('photoUploaded' + (index + 1));
				if (last) {
					console.log('finish');
				}

			}).catch(function (err) {
				toastr.error($filter('translate')('PACKAGES.ADD.TOAST.ERROR_ADD_PHOTO'));
				$scope.$emit('photoUploaded' + (index + 1));
			});
		}

		function init() {
			if (!$state.params.uuid) {
				$state.go('app.gallery');
			}

			languageService.getLanguages().then(function (response) {
				$scope.languages = response.data;
				for (var i = 0; i < $scope.languages.length; i++) {
					var language = $scope.languages[i];
					if (language.preferred) {
						$scope.language.key = language.key;
						break;
					}
				}
				$scope.$watch('language.key', function () {
					$scope.getGallery($state.params.uuid, $scope.language.key);
				});
			}).catch(function (error) {

			});
		}

		init();
	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('addEventController', addEventController);

	function addEventController($scope, $filter, $mdDialog, event, toastr, eventService, SitesManagementService) {
		if (event != null){
			if (event.start != null){
				event.start = new Date(event.start);
			}
			if (event.end != null){
				event.end = new Date(event.end);
			}
		}
		$scope.event = angular.copy(event);

		SitesManagementService.findAll('sites').then(function (response) {
			$scope.sites = response.data;
		}).catch(function(){

		});

		$scope.save = function(){
			var event = angular.copy($scope.event);
			event.start = event.start.getTime();
			if (event.end != null){
				event.end = event.end.getTime();
			}
			var fmData = new FormData();
			fmData.append('event', angular.toJson(event));
			var input = document.getElementById('add_event_dropify');
			if (input != null && input.files != null && input.files.length > 0) {
				fmData.append('file', input.files[0]);
			}
			eventService.save(fmData).then(function (response) {
				$mdDialog.hide();
			}).catch(function () {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});

		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};

	}
})();

(function(){
	'use strict';

	angular.module('app.front').service('logisticalStatusService', logisticalStatusService);

	function logisticalStatusService($http, $q){
		var service = {};

		service.list = function(lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/logistical-status',
					method: 'GET',
					params: {'_v': new Date().getTime(), 'lang': lang},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.save = function(dto, lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistical-status',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.update = function (dto, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistical-status',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		service.remove = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistical-status/'+id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.up = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistical-status/up/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.down = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistical-status/down/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};




		return service;
	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('logisticalStatusController', logisticalStatusController);

	function logisticalStatusController($rootScope, $scope, $translate, $filter, logisticalStatusService, languageService) {

		$scope.language = {};
		$scope.newStatus = {};

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.refresh($scope.language.key);
			});
		}).catch(function (error) {

		});


		$scope.refresh = function(lang){
			logisticalStatusService.list(lang).then(function(response){
				$scope.statuses = response.data;
			}).catch(function(response){

			});
		};

		$scope.add = function(form){
			logisticalStatusService.save($scope.newStatus, $scope.language.key).then(function(){
				$scope.newStatus = {};
				$scope.refresh($scope.language.key);
				form.$setPristine();
			}).catch(function(){

			});
		};

		$scope.up = function(id){
			logisticalStatusService.up(id).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){

			});
		};

		$scope.down = function(id){
			logisticalStatusService.down(id).then(function () {
				$scope.refresh($scope.language.key);
			}).catch(function () {

			});
		};

		$scope.edit = function(status){
			$scope.statusToEdit = angular.copy(status);
			status.editionMode = true;
		};

		$scope.update = function(status){
			status.editionMode = false;
			logisticalStatusService.update($scope.statusToEdit, $scope.language.key).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){

			});
		};

		$scope.cancel = function(status){
			status.editionMode = false;
		};

		$scope.remove = function(id){
			var content = {
				title: $filter('translate')('LOGISTICAL_STATUS.DELETE.TITLE'),
				message: $filter('translate')('LOGISTICAL_STATUS.DELETE.MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				logisticalStatusService.remove(id).then(function(){
					$scope.refresh($scope.language.key);
				}).catch(function(){

				});
			}).catch(function(){

			});
		};

	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('logisticalModelController', logisticalModelController);

	function logisticalModelController($scope, $filter, $state, toastr, languageService, modelService){
		$scope.modelType = 'LOGISTIC_MODEL';
		$scope.baseUrl = './api/rest/model/' + $scope.modelType;
		$scope.eventId = $state.params.id;

		$scope.modelTitle = 'Gestion des modèles de dossier';
		$scope.helpModelTitle = 'Aide sur la gestion des champs des modèles de dossier';
		$scope.helpModelContent = 'Dans cette partie il faut renseigner les champs qui seront demandés lors de la création d\'un nouveau modèle de dossier.' + ' L\'objectif est de définir un modèle représentant au mieux les dossiers et leurs attributs.';
		$scope.drawTokenTitle = 'Affichage des modèles de dossier  (à traduire)';
		$scope.helpDrawTokenTitle = 'Aide sur la gestion de l\'affichage des modèles de dossier';
		$scope.helpDrawTokenContent = 'Cette partie permet de gérer l\'affichage d\'un modèle de dossier dans les listes de selection des dossiers.';
		$scope.language = {};
		$scope.categories = [];

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.initCategories();
			});
		}).catch(function (error) {

		});

		$scope.$on('refreshCategories', function () {
			$scope.initCategories();
		});


		$scope.initCategories = function () {
			modelService.getCategories($scope.baseUrl, $scope.language.key, $scope.eventId).then(function (response) {
				$scope.$broadcast('categoriesLoaded');
				$scope.categories = response.data;
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

	}
})();

(function () {
	'use strict';

	angular.module('app.front').service('logisticService', logisticService);

	function logisticService($http, $q, $filter, $rootScope) {
		var service = {};

		service.buildModel = function (categories, item, hideManagerFields) {
			angular.forEach(categories, function (category, key) {
				for (var i = 0; i < category.values.length; i++) {
					var field = category.values[i];
					field.hidden = (!!hideManagerFields && !field.visibleByManager && item.inscription != null && item.inscription.managerId != null
						&& item.inscription.managerId === $rootScope.user.id);
					if (field.typeChamps === 'LIST_SELECT') {
						field.value = setSelectedList(field);
					} else if (field.typeChamps === 'DATE') {
						if (field.value != null && field.value !== '') {
							field.dateTime = $filter('stringToDate')(field.value);
						}
					} else if (field.typeChamps === 'BOOLEAN') {
						field.value = 'true' === field.value;
					}
				}
				angular.forEach(category.subCategories, function (category, key) {
					for (var i = 0; i < category.values.length; i++) {
						var field = category.values[i];
						field.hidden = (!!hideManagerFields && !field.visibleByManager && item.inscription != null && item.inscription.managerId != null
							&& item.inscription.managerId === $rootScope.user.id);
						if (field.typeChamps === 'LIST_SELECT') {
							field.value = setSelectedList(field);
						} else if (field.typeChamps === 'DATE') {
							if (field.value != null && field.value !== '') {
								field.dateTime = $filter('stringToDate')(field.value);
							}
						} else if (field.typeChamps === 'BOOLEAN') {
							field.value = 'true' === field.value;
						}
					}
				});
			});
			return categories;
		};

		service.get = function (id, lang, hideManagerFields) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/rest/logistic/' + id,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					}
				}).then(function (response) {
					response.data.categories = service.buildModel(angular.copy(response.data.categories), response.data, hideManagerFields);
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateStatus = function (id, statusId) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/rest/logistic/' + id + '/status/' + statusId,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.downloadValuedFile = function (fieldId, modelId) {
			var url = '/api/rest/logistic/download/' + fieldId + '/' + modelId;
			return url;
		};

		service.updateField = function (id, dto) {
			return $q(function (resolve, reject) {
				if (!dto.fixField) {
					var fmData = new FormData();
					var valuedField = {
						idBaseField: dto.id,
						id: dto.idValue
					};
					if (dto.typeChamps === 'BOOLEAN') {
						valuedField.value = '' + dto.value;
					} else if (dto.typeChamps === 'DATE') {
						if (dto.dateTime != null) {
							valuedField.value = $filter('date')(dto.dateTime, 'dd/MM/yyyy');
						}
					} else if (dto.typeChamps === 'LIST_SELECT') {
						if (!!dto.value) {
							valuedField.listFieldId = dto.value.id;
						}
					} else if (dto.typeChamps === 'MULTIPLE_SELECT') {
						valuedField.values = [];
						angular.forEach(dto.values, function (objectSelected) {
							valuedField.values.push({
								id: objectSelected.id,
								libelle: objectSelected.libelle
							});
						});
					} else if (dto.typeChamps === 'FILE' || dto.typeChamps === 'IMAGE') {
						var input = document.getElementById('genericField_file_' + dto.id + '_' + dto.index);
						var file = null;
						if (input != null) {
							file = input.files[0];
						}
						fmData.append('file', file);
					} else if (dto.typeChamps === 'NUMBER' || dto.typeChamps === 'INTEGER') {
						if ('null' === dto.value) {
							valuedField.value = '';
						} else {
							valuedField.value = dto.value;
						}
					} else {
						valuedField.value = dto.value;
					}
					fmData.append('modelDTO', angular.toJson(valuedField));
					$http({
						url: '/api/rest/logistic/' + id + '/field',
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': undefined,
							'authorization': []
						},
						data: fmData
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				}
			});
		};

		service.addTransport = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistic/' + id + '/transport',
					method: 'POST',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8',
						'authorization': []
					},
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateTransport = function (id, dto) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistic/' + id + '/transport',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8',
						'authorization': []
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.removeTransport = function (id, planId) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistic/' + id + '/transport/' + planId,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.uploadTicket = function (id, planId, fmData) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistic/' + id + '/transport/' + planId + '/ticket',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': undefined,
						'authorization': []
					},
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.downloadTicket = function (id, planId) {
			return '/api/rest/logistic/' + id + '/transport/' + planId + '/ticket';
		};



		service.removeTicket = function (id, planId) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistic/' + id + '/transport/' + planId + '/ticket',
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.getTransportFields = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/logistic/transport/fields',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8',
						'authorization': []
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		/* HELPERS */

		function setSelectedList(field) {
			var valueReturned = null;
			if (field.listFieldId) {
				for (var k = 0; k < field.listFieldsDTO.length; k++) {
					if (field.listFieldId === field.listFieldsDTO[k].id) {
						valueReturned = field.listFieldsDTO[k];
					}
				}
			}
			return valueReturned;
		}

		return service;
	}
})();
(function(){
	'use strict';

	angular.module('app.front').service('inscriptionSubCategoryService', inscriptionSubCategoryService);

	function inscriptionSubCategoryService($http, $q){
		var service = {};

		service.list = function(lang){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/inscription-subcategory',
					method: 'GET',
					params: {'_v': new Date().getTime(), 'lang': lang},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.save = function(dto, lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-subcategory',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.update = function (dto, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-subcategory',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		service.remove = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-subcategory/'+id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.up = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-subcategory/up/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.down = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-subcategory/down/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};




		return service;
	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('inscriptionSubCategoriesController', inscriptionSubCategoriesController);

	function inscriptionSubCategoriesController($rootScope, $scope, $timeout, $translate, $filter, inscriptionSubCategoryService, languageService) {
		$scope.language = {};
		$scope.newSubCategory = {};

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.refresh($scope.language.key);
			});
		}).catch(function (error) {

		});


		$scope.refresh = function(lang){
			inscriptionSubCategoryService.list(lang).then(function(response){
				$scope.subcategories = response.data;
			}).catch(function(response){

			});
		};

		$scope.add = function(form){
			inscriptionSubCategoryService.save($scope.newSubCategory, $scope.language.key).then(function(){
				$scope.newSubCategory = {};
				$scope.refresh($scope.language.key);
				form.$setPristine();
			}).catch(function(){

			});
		};

		$scope.up = function(id){
			inscriptionSubCategoryService.up(id).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){

			});
		};

		$scope.down = function(id){
			inscriptionSubCategoryService.down(id).then(function () {
				$scope.refresh($scope.language.key);
			}).catch(function () {

			});
		};

		$scope.edit = function(status){
			$scope.subCategoryToEdit = angular.copy(status);
			status.editionMode = true;
		};

		$scope.update = function(status){
			status.editionMode = false;
			inscriptionSubCategoryService.update($scope.subCategoryToEdit, $scope.language.key).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){

			});
		};

		$scope.cancel = function(status){
			status.editionMode = false;
		};

		$scope.remove = function(id){
			var content = {
				title: $filter('translate')('INSCRIPTION_SUB_CATEGORY.DELETE.TITLE'),
				message: $filter('translate')('INSCRIPTION_SUB_CATEGORY.DELETE.MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				inscriptionSubCategoryService.remove(id).then(function(){
					$scope.refresh($scope.language.key);
				}).catch(function(){

				});
			}).catch(function(){

			});
		};

	}
})();
(function () {
	'use strict';

	angular.module('app.front').service('inscriptionStatusService', inscriptionStatusService);

	function inscriptionStatusService($http, $q) {
		var service = {};

		service.list = function (lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-status',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.save = function (dto, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-status',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.update = function (dto, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-status',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		service.remove = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-status/' + id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.up = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-status/up/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.down = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription-status/down/' + id,
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};




		return service;
	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('inscriptionStatusController', inscriptionStatusController);

	function inscriptionStatusController($rootScope, $scope, $timeout, $translate, $filter, inscriptionStatusService, languageService) {
		$scope.language = {};
		$scope.newStatus = {};

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.refresh($scope.language.key);
			});
		}).catch(function (error) {

		});


		$scope.refresh = function(lang){
			inscriptionStatusService.list(lang).then(function(response){
				$scope.statuses = response.data;
			}).catch(function(response){

			});
		};

		$scope.add = function(form){
			inscriptionStatusService.save($scope.newStatus, $scope.language.key).then(function(){
				$scope.newStatus = {};
				$scope.refresh($scope.language.key);
				form.$setPristine();
			}).catch(function(){

			});
		};

		$scope.up = function(id){
			inscriptionStatusService.up(id).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){

			});
		};

		$scope.down = function(id){
			inscriptionStatusService.down(id).then(function () {
				$scope.refresh($scope.language.key);
			}).catch(function () {

			});
		};

		$scope.edit = function(status){
			$scope.statusToEdit = angular.copy(status);
			status.editionMode = true;
		};

		$scope.update = function(status){
			status.editionMode = false;
			inscriptionStatusService.update($scope.statusToEdit, $scope.language.key).then(function(){
				$scope.refresh($scope.language.key);
			}).catch(function(){

			});
		};

		$scope.cancel = function(status){
			status.editionMode = false;
		};

		$scope.remove = function(id){
			var content = {
				title: $filter('translate')('INSCRIPTION_STATUS.DELETE.TITLE'),
				message: $filter('translate')('INSCRIPTION_STATUS.DELETE.MESSAGE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				inscriptionStatusService.remove(id).then(function(){
					$scope.refresh($scope.language.key);
				}).catch(function(){

				});
			}).catch(function(){

			});
		};

	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('inscriptionModelController', inscriptionModelController);

	function inscriptionModelController($scope, $filter, $state, toastr, languageService, modelService){
		$scope.modelType = 'INSCRIPTION_MODEL';
		$scope.baseUrl = './api/rest/model/' + $scope.modelType;
		$scope.eventId = $state.params.id;

		$scope.modelTitle = 'Gestion des modèles de dossier';
		$scope.helpModelTitle = 'Aide sur la gestion des champs des modèles de dossier';
		$scope.helpModelContent = 'Dans cette partie il faut renseigner les champs qui seront demandés lors de la création d\'un nouveau modèle de dossier.' + ' L\'objectif est de définir un modèle représentant au mieux les dossiers et leurs attributs.';
		$scope.drawTokenTitle = 'Affichage des modèles de dossier  (à traduire)';
		$scope.helpDrawTokenTitle = 'Aide sur la gestion de l\'affichage des modèles de dossier';
		$scope.helpDrawTokenContent = 'Cette partie permet de gérer l\'affichage d\'un modèle de dossier dans les listes de selection des dossiers.';
		$scope.language = {};
		$scope.categories = [];

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.initCategories();
			});
		}).catch(function (error) {

		});

		$scope.$on('refreshCategories', function () {
			$scope.initCategories();
		});


		$scope.initCategories = function () {
			modelService.getCategories($scope.baseUrl, $scope.language.key, $scope.eventId).then(function (response) {
				$scope.$broadcast('categoriesLoaded');
				$scope.categories = response.data;
			}).catch(function (response) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

	}
})();

(function () {
	'use strict';

	angular.module('app.front').service('inscriptionService', inscriptionService);

	function inscriptionService($http, $q, $rootScope, $filter) {
		var service = {};

		service.buildModel = function (categories, model, hideManagerFields) {
			angular.forEach(categories, function (category, key) {
				for (var i = 0; i < category.values.length; i++) {
					var field = category.values[i];
					field.hidden = (!!hideManagerFields && !field.visibleByManager && model.managerId != null
						&& model.managerId === $rootScope.user.id);
					if (field.typeChamps === 'LIST_SELECT') {
						field.value = setSelectedList(field);
					} else if (field.typeChamps === 'DATE') {
						if (field.value != null && field.value !== '') {
							field.dateTime = $filter('stringToDate')(field.value);
						}
					} else if (field.typeChamps === 'BOOLEAN') {
						field.value = 'true' === field.value;
					}
				}
				angular.forEach(category.subCategories, function (category, key) {
					for (var i = 0; i < category.values.length; i++) {
						var field = category.values[i];
						field.hidden = (!!hideManagerFields && !field.visibleByManager && model.managerId != null
							&& model.managerId === $rootScope.user.id);
						if (field.typeChamps === 'LIST_SELECT') {
							field.value = setSelectedList(field);
						} else if (field.typeChamps === 'DATE') {
							if (field.value != null && field.value !== '') {
								field.dateTime = $filter('stringToDate')(field.value);
							}
						} else if (field.typeChamps === 'BOOLEAN') {
							field.value = 'true' === field.value;
						}
					}
				});
			});
			return categories;
		};


		service.updateField = function (id, dto) {
			return $q(function (resolve, reject) {
				if (!dto.fixField) {
					var fmData = new FormData();
					var valuedField = {
						idBaseField: dto.id,
						id: dto.idValue
					};
					if (dto.typeChamps === 'BOOLEAN') {
						valuedField.value = '' + dto.value;
					} else if (dto.typeChamps === 'DATE') {
						if (dto.dateTime != null) {
							valuedField.value = $filter('date')(dto.dateTime, 'dd/MM/yyyy');
						}
					} else if (dto.typeChamps === 'LIST_SELECT') {
						if (!!dto.value) {
							valuedField.listFieldId = dto.value.id;
						}
					} else if (dto.typeChamps === 'MULTIPLE_SELECT') {
						valuedField.values = [];
						angular.forEach(dto.values, function (objectSelected) {
							valuedField.values.push({
								id: objectSelected.id,
								libelle: objectSelected.libelle
							});
						});
					} else if (dto.typeChamps === 'FILE' || dto.typeChamps === 'IMAGE') {
						var input = document.getElementById('genericField_file_' + dto.id + '_' + dto.index);
						var file = null;
						if (input != null) {
							file = input.files[0];
						}
						fmData.append('file', file);
					} else if (dto.typeChamps === 'NUMBER' || dto.typeChamps === 'INTEGER') {
						if ('null' === dto.value) {
							valuedField.value = '';
						} else {
							valuedField.value = dto.value;
						}
					} else {
						valuedField.value = dto.value;
					}
					fmData.append('modelDTO', angular.toJson(valuedField));
					$http({
						url: '/api/rest/inscription/' + id + '/field',
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': undefined,
							'authorization': []
						},
						data: fmData
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				}
			});
		};

		service.save = function (contactId, eventId) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription',
					method: 'POST',
					headers: { 'Content-Type': 'application/json;charset=utf-8' },
					params: { '_v': new Date().getTime(), 'contactId': contactId, 'eventId': eventId }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.list = function (contactId, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription/contact/' + contactId,
					method: 'GET',
					headers: { 'Content-Type': 'application/json;charset=utf-8' },
					params: { '_v': new Date().getTime(), 'lang': lang }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.deleteResgistration = function (inscriptionId) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription/' + inscriptionId,
					method: 'DELETE',
					headers: { 'Content-Type': 'application/json;charset=utf-8' },
					params: { '_v': new Date().getTime() }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.listByCompany = function (companyID, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription/company/' + companyID,
					method: 'GET',
					headers: { 'Content-Type': 'application/json;charset=utf-8' },
					params: { '_v': new Date().getTime(), 'lang': lang }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.downloadValuedFile = function (fieldId, modelId) {
			var url = '/api/rest/inscription/download/' + fieldId + '/' + modelId;
			return url;
		};

		service.updateInscriptionStatus = function (id, statusId) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription/' + id + '/inscription-status/' + statusId,
					method: 'PUT',
					headers: { 'Content-Type': 'application/json;charset=utf-8' },
					params: { '_v': new Date().getTime() }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateSubCategory = function (id, subCategoryId) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription/' + id + '/sub-category/' + subCategoryId,
					method: 'PUT',
					headers: { 'Content-Type': 'application/json;charset=utf-8' },
					params: { '_v': new Date().getTime() }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.updateLogisticalStatus = function (id, logisticalStatusId) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/inscription/' + id + '/logistical-inscription/' + logisticalStatusId,
					method: 'PUT',
					headers: { 'Content-Type': 'application/json;charset=utf-8' },
					params: { '_v': new Date().getTime() }
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		/* PUBLIC */
		service.savePublic = function (formId, inscriptionNumber, pageNumber, fmData, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/sitegen/inscription/' + formId,
					method: 'POST',
					headers: { 'Content-Type': undefined },
					params: { '_v': new Date().getTime(), 'lang': lang, 'inscriptionNumber': inscriptionNumber, 'page': pageNumber },
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		/* HELPERS */

		function setSelectedList(field) {
			var valueReturned = null;
			if (field.listFieldId) {
				for (var k = 0; k < field.listFieldsDTO.length; k++) {
					if (field.listFieldId === field.listFieldsDTO[k].id) {
						valueReturned = field.listFieldsDTO[k];
					}
				}
			}
			return valueReturned;
		}

		return service;
	}
})();

(function () {

	'use strict';

	angular
		.module('app.error-404', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider) {
		// State
		$stateProvider.state('app.error-404', {
			url: '/error-404',
			views: {
				'main@': {
					templateUrl: 'app/core/layouts/content-only.html',
					controller: 'MainController as vm'
				},
				'content@app.error-404': {
					templateUrl: 'app/main/errors/404/error-404.html',
					controller: 'Error404Controller as vm'
				}
			},
			bodyClass: 'error-404'
		});

	}
})();

(function() {
    'use strict';

    angular
        .module('app.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller() {
        // Data

        // Methods

        //////////
    }
})();

(function () {

	'use strict';

	angular
		.module('app.error-401', [])
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider) {

		$translatePartialLoaderProvider.addPart('app/main/errors');
		// State
		$stateProvider.state('app.error-401', {
			url: '/error-401',
			views: {
				'main@': {
					templateUrl: 'app/core/layouts/content-only.html',
					controller: 'MainController as vm'
				},
				'content@app.error-401': {
					templateUrl: 'app/main/errors/401/error-401.html',
					controller: 'Error401Controller as vm'
				}
			},
			bodyClass: 'error-401'
		});

	}
})();

(function () {
	'use strict';

	angular
		.module('app.error-401')
		.controller('Error401Controller', Error401Controller);

	/** @ngInject */
	function Error401Controller() {
		// Data

		// Methods

		//////////
	}
})();

(function () {
    'use strict';

    angular.module('app.front').controller('MergeToolController', MergeToolController);

    function MergeToolController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, $element, $sce, toastr, MODELS_TYPES, modelService, DuplicationToolService) {

        $scope.inProgress = false;
        $scope._modelType = null;
        $scope._modelSubTypeId = null;
        $scope._modelsToMerge = null;

        $scope.unsafe = function(content) {
			return $sce.trustAsHtml(content);
        };

        $scope._getDuplicatesModelsInfos = function(_modelType, _modelSubTypeId, _modelsToMergeIds) {
            $scope.inProgress = true;
            DuplicationToolService._getDuplicatesModelsInfos($translate.preferredLanguage(), _modelType, _modelSubTypeId, _modelsToMergeIds).then(function (response) {
                $scope._modelsToMerge = response.data;
                $scope.inProgress = false;
            }).catch(function (response) {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));                
                $scope.inProgress = false;
                $state.go('app.duplication_tool');
            });
        };

        /*if($state.params._modelType && $state.params._modelsToMerge && $state.params._modelsToMerge.length > 0) {
            $scope._modelType = $state.params._modelType;
            $scope._modelSubTypeId = parseInt($state.params._modelSubTypeId, 10);
            $scope._modelsToMerge = $state.params._modelsToMerge;
            $scope._getDuplicatesModelsInfos($scope._modelType, $scope._modelSubTypeId, $scope._modelsToMerge);
        } else {
            $state.go('app.duplication_tool');
        }*/
        if($state.params._modelType && $state.params._modelsToMerge && $state.params._modelsToMerge.length > 0) {
            $scope._modelType = $state.params._modelType;
            $scope._modelSubTypeId = parseInt($state.params._modelSubTypeId, 10);
            $scope._modelsToMerge = [];
            angular.forEach($state.params._modelsToMerge.split(','), function(item, index) {
                $scope._modelsToMerge.push(parseInt(item, 10))
            })
            $scope._getDuplicatesModelsInfos($scope._modelType, $scope._modelSubTypeId, $scope._modelsToMerge);
        } else {
            $state.go('app.duplication_tool');
        }

        $scope._removeFalsePositiveColumnFn = function(_modelToRemove) {

            var content = {
				title: $filter('translate')('DUPLICATION_TOOL.MERGE.FALSE_POSITIVE_COLUMN_TITLE'),
				message: $filter('translate')('DUPLICATION_TOOL.MERGE.FALSE_POSITIVE_COLUMN_DIALOG_CONFIRM')
            };
            
			$rootScope.openConfirmPopup(content).then(function () {

                var _modelToRemoveCopy = angular.copy(_modelToRemove);

                var _modelIndex = $scope._modelsToMerge.models.map(function (_thisModel) {
                    return _thisModel.modelId;
                }).indexOf(_modelToRemove.modelId);

                if (_modelIndex > -1) {
                    $scope._modelsToMerge.models.splice(_modelIndex, 1);
                    angular.forEach($scope._modelsToMerge.categories, function(_thisCatItem, _thisCatIndex) {
                        angular.forEach(_thisCatItem.values, function(_thisFieldItem, _thisFieldIndex) {
                            angular.forEach(_thisFieldItem.values, function(_thisModelItem, _thisModelIndex) {
                                var _found = false;
                                if(!_found && _thisModelItem.modelInfos.modelId == _modelToRemoveCopy.modelId) {
                                    _thisFieldItem.values.splice(_thisModelIndex, 1);
                                    _found = true;
                                }
                            });
                        });
                    });
                }
                
			}).catch(function (error) {
                console.log(error);
			});
           
        };

        $scope._defaultColumnSelectedFn = function(_modelToSelect) {

            angular.forEach($scope._modelsToMerge.categories, function(_thisCatItem, _thisCatIndex) {
                angular.forEach(_thisCatItem.values, function(_thisFieldItem, _thisFieldIndex) {
                    angular.forEach(_thisFieldItem.values, function(_thisValueItem, _thisValueIndex) {
                        if(_thisValueItem.modelInfos.modelId == _modelToSelect.modelId) {
                            _thisValueItem.selected = true;
                            $scope._modelFieldSelectedFn(_thisCatItem, _thisFieldItem, _thisValueItem);
                        }
                    });                   
                });
            });

            angular.forEach($scope._modelsToMerge.models, function(_item, index) {
                if(_item.modelId != _modelToSelect.modelId) {
                    _item._defaultColumnSelected = false;
                }
            });
            _modelToSelect._defaultColumnSelected = true;

        };

        $scope._modelFieldSelectedFn = function(_category, _field, _value) {
            if(_field.fixeField) {
                _field.modelSelectedId = angular.copy(_value.idValue);
            } else {
                _field.modelSelectedId = angular.copy(_value.modelInfos.modelId);
            }
            _field.noModelSelected = false;
            angular.forEach(_field.values, function(_valueItem, _valueIndex) {
                if (_field.typeChamps == 'MULTIPLE_SELECT') {
                    if(_value.selected) {
                        angular.forEach(_valueItem.values, function(_thisValueItem, _thisValueIndex) {
                            if (_valueItem.modelInfos.modelId == _value.modelInfos.modelId) {
                                _thisValueItem.selected = true;
                            }
                        });
                    } else {
                        angular.forEach(_valueItem.values, function(_thisValueItem, _thisValueIndex) {
                            if (_valueItem.modelInfos.modelId == _value.modelInfos.modelId) {
                                _thisValueItem.selected = false;
                            }
                        });
                    }
                } else {
                    if (_valueItem.modelInfos.modelId != _value.modelInfos.modelId) {
                        _valueItem.selected = false;
                    }
                }
            });
        };

        $scope.onMultipleSelectValueClick = function(_value, _valuedField, _field, _category) {
            _value.selected = !_value.selected ;
            var unselectedCount = 0;
            if(!_value.selected) {
                angular.forEach(_valuedField.values, function(_thisValueItem, _thisValueIndex) {
                    if (!_thisValueItem.selected) {
                        unselectedCount = unselectedCount + 1;
                    }
                });
                if(unselectedCount === _valuedField.values.length) {
                    _valuedField.selected = false;
                    $scope._modelFieldSelectedFn(_category, _field, _valuedField);
                }
            } else {
                if(!_valuedField.selected) {
                    _valuedField.selected = true;
                    _field.noModelSelected = false;
                }
            }
        }

        $scope._mergeModelsFn = function() {
            $scope.inProgress = true;
            var _isValidOperation = true;
            angular.forEach($scope._modelsToMerge.categories, function(_thisCatItem, _thisCatIndex) {
                angular.forEach(_thisCatItem.values, function(_thisFieldItem, _thisFieldIndex) {
                    var _found = false;
                    angular.forEach(_thisFieldItem.values, function(_thisModelItem, _thisModelIndex) {                      
                        if(!_found && _thisModelItem.selected) {
                            _found = true;
                        }
                    });
                    if(!_found) {
                        $scope._modelsToMerge.categories[_thisCatIndex].values[_thisFieldIndex].noModelSelected = true;
                        _isValidOperation = false;
                    }
                });
            });
            if(_isValidOperation) {
                DuplicationToolService._mergeDuplicatesModels($translate.preferredLanguage(),  $scope._modelType, $scope._modelSubTypeId, 
                    $scope._modelsToMerge).then(function (response) {
                    toastr.success($filter('translate')('DUPLICATION_TOOL.MERGE.MERGE_ACTION_SUCCESS'));           
                    $scope.inProgress = false;
                    if($scope._modelType == MODELS_TYPES.COMPANY_MODEL) {
                        $state.go('app.duplication_tool', {
                            _modelType: MODELS_TYPES.CONTACT_MODEL,
                            _modelSubTypeId: $scope._modelSubTypeId,
                            _companyId: response.data.id
                        });
                    } else if($scope._modelType == MODELS_TYPES.CONTACT_MODEL) {
                        $state.go('app.companies.details', {
                            subType: response.data.subTypeId,
                            id: response.data.id
                        });
                    }
                }).catch(function (response) {
                    $scope.inProgress = false;
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                });
            } else {
                $scope.inProgress = false;
                toastr.error($filter('translate')('DUPLICATION_TOOL.MERGE.MERGE_ACTION_NO_MODEL_SELECTED_ERROR'));
            }
        };

    }
    
})();
(function () {
    'use strict';

    angular.module('app.front').controller('JunkBoxController', JunkBoxController);

    function JunkBoxController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, $element, toastr, MODELS_TYPES, 
            modelService, DuplicationToolService) {

        $scope.models = [];
        $scope.loaded = false;
        $scope.modelsSelected = { 
            all : false
        };

        $scope.onLoadJunkBox = function() {
            $scope.loaded = true;
            DuplicationToolService._junkBoxFindAll($translate.preferredLanguage()).then(function (response) {
                $scope.models = $filter('orderBy')(response.data, '-updateDate');
                $scope.loaded = false;
            }).catch(function (response) {
                toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                $scope.loaded = false;
            });
        };
        $scope.onLoadJunkBox();

        $scope.onSelectAll = function() {
            if($scope.modelsSelected.all) {
                angular.forEach($scope.models, function(item, index) {
                    item.selected = true;
                });
            } else {
                angular.forEach($scope.models, function(item, index) {
                    item.selected = false;
                });
            }   
        };

        $scope.onDetailsJunkBox = function(_model) {
            $state.go("app.junk_box.details", { id : _model.id });
        };

        $scope.onDeleteJunkBoxSelection = function() {      
            var hasSelected = false;
            for(var i = 0; i < $scope.models.length; i++) {
                if($scope.models[i].selected) {
                    hasSelected = true;
                    break;
                }
            }
            if(hasSelected) {
                var content = {
                    title: $filter('translate')('JUNK_BOX.ACTIONS.REMOVE_SELECTION_CONFIRMATION_TITLE'),
                    message: $filter('translate')('JUNK_BOX.ACTIONS.REMOVE_SELECTION_CONFIRMATION_MSG')
                };
                $rootScope.openConfirmPopup(content).then(function () {
                    angular.forEach($scope.models, function(item, index) {
                        if(item.selected) {
                            item.actionInProgress = true;
                            try {
                                DuplicationToolService._junkBoxDelete(item.id).then(function (response) {
                                    var _index = $scope.models.map(function (_item) {
                                        return _item.id;
                                    }).indexOf(item.id);
                                    if (index > -1) {
                                        $scope.models.splice(_index, 1);
                                    }
                                    item.actionInProgress = false;
                                }).catch(function (response) {
                                    item.actionInProgress = false;
                                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                                });
                            } catch(error) {
                                console.log(error);
                            }
                        }
                    });
                }).catch(function (error) {
                    console.log(error);
                });
            } else {
                toastr.error($filter('translate')('JUNK_BOX.ACTIONS.NO_SELECTION'));
            }
        };

        $scope.onDeleteJunkBox= function(model) {
            model.actionInProgress = true;
            var content = {
				title: $filter('translate')('JUNK_BOX.ACTIONS.REMOVE_CONFIRMATION_TITLE'),
				message: $filter('translate')('JUNK_BOX.ACTIONS.REMOVE_CONFIRMATION_MSG')
            };
			$rootScope.openConfirmPopup(content).then(function () {
                DuplicationToolService._junkBoxDelete(model.id).then(function (response) {
                    var index = $scope.models.map(function (item) {
                        return item.id;
                    }).indexOf(model.id);
                    if (index > -1) {
                        $scope.models.splice(index, 1);
                    }
                }).catch(function (response) {
                    model.actionInProgress = false;
                    toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
                });
			}).catch(function (error) {
                model.actionInProgress = false;
                console.log(error);
			});
        };
        
    }
    
})();
(function () {
  'use strict';

  angular.module('app.front').controller('TagsController', TagsController);

  function TagsController($rootScope, $scope, $timeout, $location, $window, $anchorScroll, toastr, BlogService, languageService, $filter, $mdDialog, DocumentService, $sce, $state) {
    $scope.language = {};
    $scope.tag = {};
    $scope.tags = [];
    $scope.loaded = true;

    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }
      $scope.$watch('language.key', function () {
        $scope.findAllTags($scope.language.key);
      });
    }).catch(function (error) {

    });


    $scope.hidePopup = function () {

      $mdDialog.hide();
      $scope.tag = {};
    };


    $scope.showFormTag = function () {
      $mdDialog.show({
        templateUrl: 'app/main/blog/popup/add_tag.html',
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
      }).catch(function () {

      });
    };

    $scope.up = function (id) {
      BlogService.up(id).then(function () {
        $scope.findAllTags($scope.language.key);
      }).catch(function (error) {
        console.log(error);
      });
    };

    $scope.down = function (id) {
      BlogService.down(id).then(function () {
        $scope.findAllTags($scope.language.key);
      }).catch(function (error) {
        console.log(error);
      });
    };



    //  // FIND ALL
    $scope.findAllTags = function (lang) {
      $scope.loaded = false;
      BlogService.findAllTags(lang).then(function (tags) {
        $scope.tags = tags.data;

        $scope.loaded = true;
      }).catch(function (data) {
        console.log(data)
      });
    };




    //DELETE TAG
    $scope.removeTag = function (tag) {
      var content = {
        title: $filter('translate')('BLOG.DELETE_TAG'),
        message: $filter('translate')('BLOG.DELETE_TAG_MESSAGE')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        BlogService.removeTag(tag.id).then(function (data) {
          $scope.findAllTags($scope.language.key);
        }).catch(function (data) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }).catch(function () {

      });
    };


    $scope.saveTag = function () {
		 $scope.onSave = true;
      BlogService.saveTag($scope.tag, $scope.language.key).then(function (data) {

        $scope.hidePopup();
		  $scope.findAllTags($scope.language.key);
		  $scope.onSave = false;
      }).catch(function(err){
			$scope.onSave = false;
		})
    }

    $scope.showUpdateTag = function (tag) {
      $scope.tag = angular.copy(tag);
      $mdDialog.show({
        templateUrl: 'app/main/blog/popup/add_tag.html',
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
      }).catch(function () {

      });
    }

  }
})();

(function () {
  'use strict';

  angular.module('app.front').controller('RegionsController', RegionsController);

  function RegionsController($scope, languageService, statisticsService) {
    $scope.language = {};
    $scope.regions = [];
    $scope.loaded = false;

    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }
      $scope.$watch('language.key', function () {
        $scope.findAllRegions($scope.language.key);
      });
    }).catch(function (error) {

    });

    // FIND ALL
    $scope.findAllRegions = function (lang) {
      $scope.loaded = false;
      statisticsService.getRegions(lang).then(function (res) {
        $scope.regions = res.data;
        $scope.loaded = true;
      }).catch(function (data) {
        console.log(data)
        $scope.loaded = true;
      });

    };

  }
})();

(function () {
	'use strict';

	angular.module('app.front').controller('CountriesController', CountriesController);

  function CountriesController($rootScope, $scope, $timeout, $location, $window, $anchorScroll, toastr, languageService, statisticsService, $filter,$mdDialog,$sce,$state) {
	 	$scope.language = {};
	  $scope.countries = [];
	  $scope.loaded = false;

    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }
      $scope.$watch('language.key', function () {
         $scope.findAllCountries($scope.language.key);
      });
    }).catch(function (error) {

    });

   // FIND ALL
    $scope.findAllCountries = function (lang) {
		$scope.loaded=false;
      statisticsService.getNationalities(lang).then(function (res) {
		  $scope.countries = res.data;
		  $scope.loaded=true;
      }).catch(function (data) {
			console.log(data)
			$scope.loaded=true;
		});

    };

  }
})();

(function () {
	'use strict';

	angular.module('app.front').service('BannersService', ['$q', '$http', function ($q, $http) {
		var baseUrl = './api/rest/banners';
		var publicBaseUrl = './api/public/sitegen';
		return {
			findAllBanners: function (lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/findAll',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			saveBanner: function (banner, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/save',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: banner
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			removeBanner: function (bannerId) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/' + bannerId,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findById: function (id, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/'+id,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			setActive: function(id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/active/' + id,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			setPublish: function(id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/publish/' + id,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			filterByString: function(value,lang){
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/filterByString',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'value': value
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}
		};
	}]);

})();

(function () {
	'use strict';

	angular.module('app.front').controller('BannersController', BannersController);

  function BannersController($rootScope,$translate, $scope, $timeout,
	statisticsService, $location, $window, toastr, BannersService, languageService, $filter, $mdDialog, DocumentService, $sce, $state) {
		$scope.language = {};
		$scope.banners = [];

		$scope.loaded = true;


	  languageService.getLanguages().then(function (response) {
		  $scope.languages = response.data;
		  for (var i = 0; i < $scope.languages.length; i++) {
			 var language = $scope.languages[i];
			 if (language.preferred) {
				$scope.language.key = language.key;
				break;
			 }
		  }
		  $scope.$watch('language.key', function () {
			 $scope.findAllBanners($scope.language.key);
		  });
		}).catch(function (error) {

		});

		$scope.findAllBanners = function (lang) {
			$scope.loaded = false;
			BannersService.findAllBanners(lang).then(function (res) {
				$scope.banners = res.data;
				$scope.loaded = true;
			}).catch(function (err) {
				console.log(err)
				$scope.loaded = true;
			});
		}

		$scope.goToAddPage = function () {

		  $state.go('app.banners.edit',{'lang':$scope.language.key});
		};


		//DELETE BANNER
		$scope.removeBanner = function (banner) {
			var content = {
			  title: $filter('translate')('BANNER.DELETE'),
			  message: $filter('translate')('BANNER.CONFIRM_DELETE')
			};
			$rootScope.openConfirmPopup(content).then(function () {
			  BannersService.removeBanner(banner.id).then(function (data) {
					 $scope.findAllBanners($scope.language.key);
			  }).catch(function (data) {
				 toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			  });
			}).catch(function () {

			});
		 };



		 // DELETE PHOTO

		 $scope.setActive = function(banner){
			BannersService.setActive(banner.id).then(function(res){

			}).catch(function (err) {
				banner.active = !banner.active;
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			 });
		 }

		 $scope.setPublish = function(banner){
			BannersService.setPublish(banner.id).then(function(res){

			}).catch(function (err) {
				banner.publish = !banner.publish;
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			 });
		 }

		 $scope.goToURL = function(banner){
			window.open(banner.url, '_blank');
		 }

		$scope.updateBanner = function (banner) {

			$state.go('app.banners.edit',{id:banner.id,lang:$scope.language.key});

		};


	}

	angular.module('app.front').controller('addBannerCtrl', addBannerCtrl);


	function addBannerCtrl($scope, statisticsService, toastr, BannersService, $filter, $mdDialog, DocumentService,$state,$translate) {
	  $scope.language = {};
	  $scope.banner = {};
	  $scope.photos = [];

	//   $scope.tags = [];
	//   $scope.countries = [];
	//   $scope.search = {
	// 	 tag:'',
	// 	 country:''
	//   };
	  $scope.loading = false;


	  window.mdSelectOnKeyDownOverride = function (event) {
		 event.stopPropagation();
	};
	//   $scope.findAllTags = function (lang) {

	// 	 BlogService.findAllTags(lang).then(function (tags) {
	// 		 $scope.tags = tags.data;

	// 	 }).catch(function (err) {
	// 		 console.log(err)
	// 	 });
	//   };


	//   $scope.findAllCountries = function (lang) {

	// 	 statisticsService.getNationalities(lang).then(function (countries) {
	// 		$scope.countries = countries.data;

	// 	 }).catch(function (data) {
	// 		 console.log(data)
	// 	 });
	//  };

	 function init(){
		 if ($state.params) {
			 if($state.params.lang){
				$scope.language.key = $state.params.lang;
				// $scope.findAllTags($scope.language.key);
				// $scope.findAllCountries($scope.language.key);
			 }
			 if($state.params.id){
				BannersService.findById($state.params.id,$state.params.lang).then(function(res){
				  $scope.banner = res.data;
				  console.log($scope.banner)
				  if($scope.banner.startDate){
					$scope.banner.startDateForm = moment($scope.banner.startDate).toDate();
				  }
				  if($scope.banner.endDate){
					$scope.banner.endDateForm = moment($scope.banner.endDate).toDate();
				  }


				})
			 }
		  }
	  }

	 $scope.hidePopup = function () {
	  $mdDialog.hide();
	};

	// $scope.fieldsSelected = function(fields, selectedFields){
	// 	 var res = [];

	// 	 if($scope.article && !$scope.article.tags){
	// 		 $scope.article.tags = [];
	// 	 }
	// 	 if($scope.article && !$scope.article.countries){
	// 		 $scope.article.countries = [];
	// 	 }
	// 	 if (angular.isArray(selectedFields)){
	// 		 var fieldIds = selectedFields.map(function(item){
	// 			 return item.id;
	// 		 });
	// 		 angular.forEach(fields, function(item){
	// 			 if (fieldIds.lastIndexOf(item.id) === -1){
	// 				 res.push(item);
	// 			 }
	// 		 });
	// 		 return res;
	// 	 }else{
	// 		 return fields;
	// 	 }
	// };

	$scope.addNewPhoto = function(){
		if($scope.photos.length==0){
			$scope.photos.push({});
		}
		console.log($scope.photos.length)
	}
	$scope.cancelAdd = function () {
	  $state.go('app.banners');
	};

	$scope.saveBanner = function () {
	 $scope.loading = true;
	  var photos = [];

	  if ($scope.photos.length>0) {

			var photo = $scope.photos[0].uploadFile;
			photos.push(photo);

	  }

	  $scope.banner.startDate = $scope.banner.startDateForm.getTime();
	  $scope.banner.endDate = $scope.banner.endDateForm.getTime();
	  BannersService.saveBanner($scope.banner, $scope.language.key).then(function (data) {
		 var fds = [];
		console.log(data);
		 for (var i = 0; i < photos.length; i++) {
			var formData = new FormData();
			formData.append('file', photos[i]);
			formData.append('dto', angular.toJson({
			  bannerId: data.data
			}));

			fds.push(formData);
		 }

		 var index = 0;

		 if (fds.length > 0) {
			for (var i = 0; i < fds.length; i++) {
			  if (i === 0) {
				 if(i === fds.length - 1){
					$scope.addPhoto(fds[i], i, true);
				 }else{
					$scope.addPhoto(fds[i], i);
				 }
				 index++;
			  } else {
				 $scope.$on('photoUploaded' + i, function () {
					if (index === fds.length - 1) {
					  $scope.addPhoto(fds[index], index, true);
					} else {
					  $scope.addPhoto(fds[index], index, false);
					}

					index++;
				 });
			  }
			}
		 }else{
			 $scope.loading = false;
			 $state.go('app.banners');
		 }


	  }).catch(function (data) {
		 $scope.loading = false;
		 toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
	  });
	};

	$scope.addPhoto = function (fd, i, last) {
	  var index = angular.copy(i);
	  DocumentService.save(fd).then(function (res) {
		 $scope.$emit('photoUploaded' + (index + 1));
		 if (last) {
			 $scope.loading = false;
			$state.go('app.banners');
		 }
	  }).catch(function (err) {
		 toastr.error($filter("translate")("BLOG.ERROR_ADD_PHOTO"));
		 $scope.$emit('photoUploaded' + (index + 1));
		 if (last) {
			 $scope.loading = false;
			$state.go('app.banners');
		 }
	  });
	};





  $scope.addField = function (chip, fields) {
	if (chip == null || chip.id == null) {
	  fields.splice(fields.length - 1, 1);
	}
 };

 $scope.deletePhoto = function (index) {
	$scope.photos.splice(index, 1);
 };


 $scope.displayPopUpDeletePhoto = function (photo) {
	$scope.photoToDelete = angular.copy(photo);
	$mdDialog.show({
	  templateUrl: 'app/main/blog/popup/deletePhoto.popup.html',
	  preserveScope: true,
	  clickOutsideToClose: true,
	  scope: $scope
	}).then(function () {

	}).catch(function () {

	});
 };


 $scope.deletePhotoPermanentely = function () {
	DocumentService.deleteFile($scope.photoToDelete.id).then(function (res) {
	  $scope.banner.img = null;
	  toastr.success($filter("translate")("BANNER.CONFIRM_MESSAGE_PHOTO"));
	  $scope.hidePopup();
	}).catch(function (err) {
	  toastr.error($filter("translate")("BANNER.ERROR_MESSAGE_PHOTO"));
	});
 };
	 init();

	}

})();

(function () {
  'use strict';

  angular.module('app.front').controller('usersLogsController', usersLogsController);

  function usersLogsController($scope, LOGS_ENTITY_CONCERNED, LOGS_ACTIONS, adminService, $rootScope, $filter, packagesService, languageService, $mdDialog, $state, toastr) {
    var filter = {
      page: 0,
      output: 100
    };
    $scope.logs = [];
    $scope.allLoaded = false;
    $scope.ENTITY_CONCERNED = LOGS_ENTITY_CONCERNED;
    $scope.ACTIONS = LOGS_ACTIONS;

    $scope.getLogs = function () {
      adminService.get(filter).then(function (res) {
        if (res.data) {
          $scope.logs = $scope.logs.concat(res.data);
        }
        if (res.data.length < 100) {
          $scope.allLoaded = true;
        } else {
          filter.page++;
        }
        console.log(res.data);
      }).catch(function (err) {
        console.log(err);
        toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
      });
    };

    $scope.getLogs();


  }
})();

(function(){
	'use strict';

	angular.module('app.front').controller('messagesLogsController', messagesLogsController);

	function messagesLogsController($scope, $translate, $mdDialog, MessageService){
		$scope.page = 0;
		var MAX = 50;
		$scope.infiniteScrollPrevent = false;
		$scope.messages = [];

		$scope.loadMore = function(){
			if (!$scope.infiniteScrollPrevent){
				$scope.infiniteScrollPrevent = true;
				MessageService.findAllPaginated($scope.page, MAX, $translate.preferredLanguage()).then(function(response){
					if (response.data.length > 0){
						$scope.messages = $scope.messages.concat(response.data);
						$scope.infiniteScrollPrevent = false;
					}else{
						$scope.infiniteScrollPrevent = true;
					}
					$scope.page++;
				}).catch(function(){
	
				});
			}
		};
		$scope.loadMore();

		$scope.seeMessage = function(message){
			$scope.message = message;
			$mdDialog.show({
				templateUrl: 'app/main/admin/messagesLogs/message.html',
				clickOutsideToClose: true,
				scope: $scope,
				preserveScope: true
			}).then(function(){
				
			}).catch(function(){
		
			});
		};

		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};
	}
})();
(function () {
	'use strict';

	angular.module('app.front').controller('usersController', usersController);

	function usersController($rootScope, $scope,$translate,DTOptionsBuilder, $filter, $mdDialog, userService) {
		//Fonction init() en bas de la page!!
		$scope.showAllUsers = true;
		$scope.users = [];
		$scope.loaded = false;

		$translate(['TABLE.EMPTY', 'TABLE.INFO', 'TABLE.INFO_EMPTY',
		'TABLE.INFO_FILTERED', 'TABLE.LENGTH_MENU', 'TABLE.LOADING',
		'TABLE.PROCESSING', 'TABLE.SEARCH', 'TABLE.ZERO_RECORDS',
		'TABLE.FIRST', 'TABLE.LAST', 'TABLE.NEXT', 'TABLE.PREVIOUS']).then((translation) => {

			$scope.dtOptions = DTOptionsBuilder.newOptions()
				.withLanguage({
					"sEmptyTable": translation['TABLE.EMPTY'], //"Aucune donnée disponible"
					"sInfo": translation['TABLE.INFO'],//" _START_ sur _END_ d'un total de _TOTAL_ données"
					"sInfoEmpty": translation['TABLE.INFO_EMPTY'],//" 0 sur 0 of 0 entries",
					"sInfoFiltered": translation['TABLE.INFO_FILTERED'],//"(filtered from _MAX_ total entries)",
					"sInfoPostFix": "",
					"sInfoThousands": ",",
					"sLengthMenu": translation['TABLE.LENGTH_MENU'],//"Show _MENU_ entries"
					"sLoadingRecords": translation['TABLE.LOADING'],//"Loading...",
					"sProcessing": translation['TABLE.PROCESSING'],//"Processing...",
					"sSearch": translation['TABLE.SEARCH'],//"Search:",
					"sZeroRecords": translation['TABLE.ZERO_RECORDS'],//"No matching records found",
					"oPaginate": {
						"sFirst": translation['TABLE.FIRST'],//"First",
						"sLast": translation['TABLE.LAST'],//"Last",
						"sNext": translation['TABLE.NEXT'], //"Next",
						"sPrevious": translation['TABLE.PREVIOUS'],//"Previous"
					},
					"oAria": {
						"sSortAscending": ": activate to sort column ascending",
						"sSortDescending": ": activate to sort column descending"
					}

				});

		});

		$scope.refreshUsers = function () {
			if ($scope.showAllUsers) {
				userService.findAllUsers().then(function (response) {
					$scope.users = response.data;
					$scope.loaded = true;
				}).catch(function (response) {
					$scope.loaded = true;
				});
			} else {
				userService.findActive().then(function (response) {
					$scope.users = response.data;
					$scope.loaded = true;
				}).catch(function (response) {
					$scope.loaded = true;
				});
			}

		};

		$scope.openAddUser = function () {
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/users/popup/add_user.html',
				controller: 'addUserController',
				clickOutsideToClose: true,
				locals: {
					company: null
				}
			}).then(function () {
				$scope.refreshUsers();
			}).catch(function () {

			});
		};

		$scope.details = function (user) {
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/users/popup/edit_user.html',
				controller: 'editUserController',
				clickOutsideToClose: true,
				locals: {
					user: user
				}
			}).then(function () {
				$scope.refreshUsers();
			}).catch(function () {

			});
		};

		$scope.switchActives = function () {
			$scope.showAllUsers = !$scope.showAllUsers;

			$scope.refreshUsers();
		};

		$scope.init = function () {
			if ($rootScope.user) {
				$scope.showAllUsers = !!$rootScope.user.seeInactiveContact;
			}

			$scope.refreshUsers();
		};

		$scope.init();
	}
})();

(function () {
	'use strict';

	/**
	 * Main module of the Fuse
	 */
	angular
		.module('fuse', [

			// Core
			'app.core',

			// Navigation
			'app.navigation',

			// Toolbar
			'app.toolbar',

			// Quick Panel
			'app.quick-panel',

			// 404
			'app.error-404',

			// 401
			'app.error-401',

			// Front
			'app.front',

			// Login
			'app.login',

			'chart.js',

			'infinite-scroll',

			'ngQuill',

			'vcRecaptcha',

			'mailing_preview.app',
		]);
})();

(function () {
	'use strict';

	angular.module('fuse').service('userService', userService);

	function userService($q, $http, msNavigationService, $rootScope) {
		var USER_CONNECTED = null;
		var USER = null;
		var USER_ROLES = null;

		var USER_IS_ADMIN = false;
		var USER_LINKED_TO_ASSOCIATIONS = false;
		var CAN_USER_EDIT_STATS = false;
		var USER_HAS_NON_READ_MSG = false;
		var USER_IS_MEMBER = false;

		var getUserRoles = function () {
			return $q(function (resolve, reject) {
				if (USER_ROLES == null || USER_ROLES.length === 0) {
					$http({
						url: '/api/rest/permissions/find',
						method: 'GET',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						USER_ROLES = response.map(function (role) {
							return role.name;
						});
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				} else {
					resolve(USER_ROLES);
				}
			});
		};

		var checkPermission = function (permissionsTOcheck) {
			var _found = false;
			var self = this;
			return $q(function (resolve, reject) {
				self.getUserRoles().then(function (response) {
					angular.forEach(permissionsTOcheck, function (item, _index) {
						if (response.data.indexOf(item) > -1) {
							_found = true;
							return;
						}
					});
					resolve(_found);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var isConnected = function () {
			return $q(function (resolve, reject) {
				if (USER_CONNECTED == null) {
					$http({
						url: '/api/public/unsecured/isConnected',
						method: 'GET',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						USER_CONNECTED = response;
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				} else {
					resolve(USER_CONNECTED);
				}
			});
		};

		var login = function (loginDTO, associationId) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/login',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'rememberMe': true,
						'associationId': associationId
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					},
					data: loginDTO
				}).then(function (response) {
					USER_CONNECTED = response;
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var logout = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/logout',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					USER_CONNECTED = null;
					USER_ROLES = null;
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var getCurrent = function (lang, reset) {
			return $q(function (resolve, reject) {
				if (reset || USER == null) {
					$http({
						url: '/api/rest/user',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						if (response != null && response.data != null) {
							$rootScope.user = response.data;
							USER = response.data;
							USER_ROLES = $rootScope.user.rights.map(function (right) {
								return right.name;
							});
							if ($rootScope.user.admin) {
								USER_IS_ADMIN = true;
								CAN_USER_EDIT_STATS = true;
							} else if ($rootScope.user.associationIds && $rootScope.user.associationIds.length > 0) {
								USER_LINKED_TO_ASSOCIATIONS = true;
							} else if ($rootScope.user.company != null) {
								USER_IS_MEMBER = true;
							}

							if ($rootScope.user.company && $rootScope.user.company.id) {
								CAN_USER_EDIT_STATS = true;
							}

							if ($rootScope.user.msgNonRead) {
								USER_HAS_NON_READ_MSG = true;
							} else {
								USER_HAS_NON_READ_MSG = false;
							}

							$rootScope.$broadcast('rooScopeUser:ready');
							resolve(response.data);
						} else {
							reject(response);
						}
					}).catch(function (response) {
						reject(response);
					});
				} else {
					resolve(USER);
				}
			});
		};

		var containsRole = function (role) {
			if (USER_ROLES != null) {
				return USER_ROLES.lastIndexOf('ADMINISTRATEUR') > -1 || USER_ROLES.lastIndexOf(role) > -1;
			}
			return false;
		};

		var containsAtLeastOneRole = function (roles) {
			if (roles.lastIndexOf('ADMINISTRATEUR') === -1) {
				roles.push('ADMINISTRATEUR');
			}
			var ok = false;
			for (var i = 0; i < roles.length; i++) {
				if (USER_ROLES != null && USER_ROLES.lastIndexOf(roles[i]) > -1) {
					ok = true;
					break;
				}
			}
			return ok;
		};


		var isUserAdmin = function () {
			return USER_IS_ADMIN;
		};

		var isUserLinkedToAssociations = function () {
			return USER_LINKED_TO_ASSOCIATIONS;
		};

		var isMember = function () {
			return USER_IS_MEMBER;
		}

		var canUserEditStats = function () {
			return CAN_USER_EDIT_STATS;
		};

		var isUserHasNonReadMsg = function () {
			return USER_HAS_NON_READ_MSG;
		};

		var getAccounts = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/accounts',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		// update password after forgot password
		var updatePassword = function (token, password) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/updatePassword',
					method: 'PUT',
					params: {
						'_v': new Date().getTime(),
						'key': token,
						'password': password
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var updateAccount = function (accountDTO) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/account',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					},
					data: accountDTO
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var forgotPassword = function (email) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/forgotPassword',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'email': email
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var findAllUsers = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/findall',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var findByGroups = function (groupIDs) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/byGroups',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'groupIDs': groupIDs
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var findActive = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user/find/active',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var addUser = function (fmData, fromAssociation) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'fromAssociation': fromAssociation
					},
					headers: {
						'Content-Type': undefined
					},
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		var updateUser = function (fmData) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/user',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': undefined
					},
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		return {
			getUserRoles: getUserRoles,
			checkPermission: checkPermission,
			isConnected: isConnected,
			login: login,
			logout: logout,
			getCurrent: getCurrent,
			getAccounts: getAccounts,
			updatePassword: updatePassword,
			updateAccount: updateAccount,
			forgotPassword: forgotPassword,
			findAllUsers: findAllUsers,
			addUser: addUser,
			updateUser: updateUser,
			findActive: findActive,
			isUserAdmin: isUserAdmin,
			isUserLinkedToAssociations: isUserLinkedToAssociations,
			canUserEditStats: canUserEditStats,
			isUserHasNonReadMsg: isUserHasNonReadMsg,
			findByGroups: findByGroups,
			isMember: isMember,
			containsRole: containsRole,
			containsAtLeastOneRole: containsAtLeastOneRole
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').controller('groupsController', groupsController);

	function groupsController($rootScope, $scope, $mdDialog,$translate,DTOptionsBuilder, $filter, toastr, groupService){

		$translate(['TABLE.EMPTY', 'TABLE.INFO', 'TABLE.INFO_EMPTY',
			'TABLE.INFO_FILTERED', 'TABLE.LENGTH_MENU', 'TABLE.LOADING',
			'TABLE.PROCESSING', 'TABLE.SEARCH', 'TABLE.ZERO_RECORDS',
			'TABLE.FIRST', 'TABLE.LAST', 'TABLE.NEXT', 'TABLE.PREVIOUS']).then((translation) => {

				$scope.dtOptions = DTOptionsBuilder.newOptions()
					.withLanguage({
						"sEmptyTable": translation['TABLE.EMPTY'], //"Aucune donnée disponible"
						"sInfo": translation['TABLE.INFO'],//" _START_ sur _END_ d'un total de _TOTAL_ données"
						"sInfoEmpty": translation['TABLE.INFO_EMPTY'],//" 0 sur 0 of 0 entries",
						"sInfoFiltered": translation['TABLE.INFO_FILTERED'],//"(filtered from _MAX_ total entries)",
						"sInfoPostFix": "",
						"sInfoThousands": ",",
						"sLengthMenu": translation['TABLE.LENGTH_MENU'],//"Show _MENU_ entries"
						"sLoadingRecords": translation['TABLE.LOADING'],//"Loading...",
						"sProcessing": translation['TABLE.PROCESSING'],//"Processing...",
						"sSearch": translation['TABLE.SEARCH'],//"Search:",
						"sZeroRecords": translation['TABLE.ZERO_RECORDS'],//"No matching records found",
						"oPaginate": {
							"sFirst": translation['TABLE.FIRST'],//"First",
							"sLast": translation['TABLE.LAST'],//"Last",
							"sNext": translation['TABLE.NEXT'], //"Next",
							"sPrevious": translation['TABLE.PREVIOUS'],//"Previous"
						},
						"oAria": {
							"sSortAscending": ": activate to sort column ascending",
							"sSortDescending": ": activate to sort column descending"
						}

					});

			});
		$scope.refreshGroups = function(){
			$scope.loaded = false;
			groupService.findGroups().then(function(response){
				$scope.groups = response.data;
				$scope.loaded = true;
			}).catch(function(response){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$scope.loaded = true;
			});
		};

		$scope.refreshGroups();

		$scope.details = function(group){
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/groups/popup/edit_group.html',
				controller: 'editGroupController',
				clickOutsideToClose: true,
				locals: {
					group: group
				}
			}).then(function(){
				$scope.refreshGroups();
			}).catch(function(){

			});
		};

		$scope.openAddGroup = function(){
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/groups/popup/add_group.html',
				controller: 'addGroupController',
				clickOutsideToClose: true
			}).then(function(){
				$scope.refreshGroups();
			}).catch(function(){

			});
		};

		$scope.openRemoveGroup = function(group){
			var content = {
				title: $filter('translate')('GROUPS.DELETE'),
				message: $filter('translate')('GROUPS.CONFIRM_DELETE')
			};
			$rootScope.openConfirmPopup(content).then(function(){
				groupService.deleteGroup(group.id).then(function(){
					$scope.refreshGroups();
				}).catch(function(){
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(function(){

			});
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').service('groupService', groupService);

	function groupService($http, $q){

		var service = {};

		service.addGroup = function(dto){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/group',
					method: 'POST',
					params: {
						'_v': new Date().getTime()
					},
					data: dto
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.updateGroup = function (dto) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/group',
					method: 'PUT',
					params: {
						'_v': new Date().getTime()
					},
					data: dto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};
		service.deleteGroup = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/group/removeGroup/' + id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findGroups = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/group/find',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		return service;

	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('associationsController', associationsController);

	function associationsController($rootScope, $scope, $filter,$translate,DTOptionsBuilder, $mdDialog, $state, toastr, URL, associationService){

		$translate(['TABLE.EMPTY', 'TABLE.INFO', 'TABLE.INFO_EMPTY',
		'TABLE.INFO_FILTERED', 'TABLE.LENGTH_MENU', 'TABLE.LOADING',
		'TABLE.PROCESSING', 'TABLE.SEARCH', 'TABLE.ZERO_RECORDS',
		'TABLE.FIRST', 'TABLE.LAST', 'TABLE.NEXT', 'TABLE.PREVIOUS']).then((translation) => {

			$scope.dtOptions = DTOptionsBuilder.newOptions()
				.withLanguage({
					"sEmptyTable": translation['TABLE.EMPTY'], //"Aucune donnée disponible"
					"sInfo": translation['TABLE.INFO'],//" _START_ sur _END_ d'un total de _TOTAL_ données"
					"sInfoEmpty": translation['TABLE.INFO_EMPTY'],//" 0 sur 0 of 0 entries",
					"sInfoFiltered": translation['TABLE.INFO_FILTERED'],//"(filtered from _MAX_ total entries)",
					"sInfoPostFix": "",
					"sInfoThousands": ",",
					"sLengthMenu": translation['TABLE.LENGTH_MENU'],//"Show _MENU_ entries"
					"sLoadingRecords": translation['TABLE.LOADING'],//"Loading...",
					"sProcessing": translation['TABLE.PROCESSING'],//"Processing...",
					"sSearch": translation['TABLE.SEARCH'],//"Search:",
					"sZeroRecords": translation['TABLE.ZERO_RECORDS'],//"No matching records found",
					"oPaginate": {
						"sFirst": translation['TABLE.FIRST'],//"First",
						"sLast": translation['TABLE.LAST'],//"Last",
						"sNext": translation['TABLE.NEXT'], //"Next",
						"sPrevious": translation['TABLE.PREVIOUS'],//"Previous"
					},
					"oAria": {
						"sSortAscending": ": activate to sort column ascending",
						"sSortDescending": ": activate to sort column descending"
					}

				});

		});
		$scope.alternatedocroots = URL.alternatedocroots;

		$scope.refreshAssociations = function(){
			$scope.loaded = false;
			associationService.findAll().then(function(response){
				$scope.associations = response.data;
				$scope.loaded = true;
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$scope.loaded = true;
			});
		};

		$scope.refreshAssociations();

		$scope.openAddAssociation = function(){
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/associations/popup/add_association.html',
				controller: 'addAssociationController',
				clickOutsideToClose: true
			}).then(function(){
				$scope.refreshAssociations();
			}).catch(function(){

			});
		};

		$scope.details = function(association){
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/associations/popup/edit_association.html',
				controller: 'editAssociationController',
				clickOutsideToClose: true,
				locals: {
					association: association
				}
			}).then(function(){
				$scope.refreshAssociations();
			}).catch(function(){

			});
		};

		$scope.detailsCompany = function(association){
			$state.go('app.association', {id: association.id});
		};

		$scope.openRemoveAssociation = function (association) {
			var content = {
				title: $filter('translate')('ASSOCIATIONS.DELETE'),
				message: $filter('translate')('ASSOCIATIONS.CONFIRM_DELETE')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				associationService.delete(association.id).then(function () {
					$scope.refreshAssociations();
				}).catch(function () {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(function () {

			});
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').service('associationService', associationService);

	function associationService($q, $http){
		var service = {};

		service.save = function(fmData){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/association',
					method: 'POST',
					headers: {
						'Content-Type': undefined
					},
					params: {
						'_v': new Date().getTime()
					},
					data: fmData
				}).then(function(response){
					resolve(response);
				}).catch(function(response){
					reject(response);
				});
			});
		};

		service.update = function (fmData) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/association',
					method: 'PUT',
					headers: {
						'Content-Type': undefined
					},
					params: {
						'_v': new Date().getTime()
					},
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.delete = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/association/' + id,
					method: 'DELETE',
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findAll = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/association',
					method: 'GET',
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findById = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/association/' + id,
					method: 'GET',
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findByIdPublic = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/public/unsecured/association/' + id,
					method: 'GET',
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					params: {
						'_v': new Date().getTime(), 
						'lang': lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		return service;
	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('associationController', associationController);

	function associationController($scope, $state, $filter, $translate, $mdDialog, toastr, associationService){
		$scope.refreshAssociation = function(){
			associationService.findById($state.params.id, $translate.preferredLanguage()).then(function(response){
				$scope.association = response.data;
			}).catch(function(){
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.refreshAssociation();

		$scope.addManager = function(company){
			$mdDialog.show({
				templateUrl: 'app/main/access_rights/users/popup/add_user.html',
				controller: 'addUserController',
				clickOutsideToClose: true,
				locals: {
					company: company
				}
			}).then(function(){
				$scope.refreshAssociation();
			}).catch(function(){

			});
		};
	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router',
                'datatables', 'datatables.columnfilter',
                'toastr',
                'ui-rangeSlider',
                'thatisuday.ng-image-gallery'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;        

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);
            
            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function(){
	'use strict';

	angular.module('app.front').service('touristAttractionService', touristAttractionService);

	function touristAttractionService($q, $http){
		var service = {};

		var url = '/api/rest/touristAttraction';
		var publicUrl = '/api/public/sitegen/touristAttraction';

		service.save = function (fmData, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: url + '/save',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': undefined
					},
					data: fmData
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.get = function (lang) {
			return $q(function (resolve, reject) {
				$http({
					url: url,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findById = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: url + '/findById/' + id,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.delete = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: url + '/delete/' + id,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.deletePhoto = function(id, photoId){
			return $q(function (resolve, reject) {
				$http({
					url: url + '/delete/' + id + '/photo/'+photoId,
					method: 'DELETE',
					params: {
						'_v': new Date().getTime()
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.publicGet = function (page, max, filter, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: publicUrl + '/filter',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
						'page': page,
						'max': max
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					},
					data: filter
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.findByIdPublic = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: publicUrl + '/' + id,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang,
					},
					headers: {
						'Content-Type': 'application/json;charset=UTF-8'
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		return service;
	}
})();
(function(){
	'use strict';

	angular.module('app.front').controller('touristAttractionsController', touristAttractionsController);

	function touristAttractionsController($scope, $state, $mdDialog, $filter, toastr, languageService, touristAttractionService){
		$scope.regions = {};
		$scope.typesTourism = {};
		$scope.language = {};
		$scope.languages = [];
		var updateMode = false;
		$scope.loaded = true;

		$scope.tourist = {};
		$scope.tourists = [];

		$scope.limitNbrTypes = 3;

		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
		}).catch(function (error) {

		});

		$scope.initTourists = function () {
			$scope.loaded = false;
			touristAttractionService.get($scope.language.key).then(function (res) {
				if (res.data) {
					$scope.tourists = res.data;
				}
				$scope.loaded = true;
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(err);
			});
		};

		$scope.initTourists();

		$scope.goAdd = function (update) {
			$state.go('app.touristAttractions.add');
		};

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

		$scope.update = function (tourist) {
			if (tourist.id) {
				$state.go('app.touristAttractions.update', {
					id: tourist.id
				});
			} else {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			}
		};

		$scope.showPopUpDelete = function (tourist, index) {
			$scope.touristToDelete = angular.copy(tourist);
			$scope.indexToDelete = index;

			$mdDialog.show({
				templateUrl: 'app/main/popup/confirm.html',
				clickOutsideToClose: true,
				controller: 'confirmPopupController',
				locals: {
					content: {
						title: $filter('translate')('TOURIST.POPUP_DELETE.TITLE'),
						message: $filter('translate')('TOURIST.POPUP_DELETE.MESSAGE')
					}
				}
			}).then(function () {
				$scope.remove();
			}).catch(function () { });
		};

		$scope.remove = function () {
			touristAttractionService.delete($scope.touristToDelete.id).then(function (res) {
				toastr.success($filter('translate')('TOURIST.SUCCESS_DELETE'));
				$scope.tourists.splice($scope.indexToDelete, 1);
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(err);
			});
		};
	}
})();
(function () {
  'use strict';

  angular.module('fuse').service('statisticsService', statisticsService);

  function statisticsService($q, $http, msNavigationService, $rootScope, $window) {
    var service = {};
    var url = '/api/rest/statistics';
    var publicUrl = './api/public/sitegen';

    service.save = function (statisticsDTO, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url,
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: statisticsDTO
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.get = function (periodDTO) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/findByCompanyIdAndPeriod',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: periodDTO
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.filter = function (filter, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/filter',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.compare = function (filters, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/compare',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filters
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.exportOccupationStats = function (filters, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/export',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filters
        }).then(function (response) {
          $window.location.href = url + '/download/?location=' + response.data;
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStatsNationalities = function (filter) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/nationalities',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getNationalities = function (lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/nationalities',
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getRegions = function (lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/regions',
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.generateCompanies = function (filter, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/generateCompanies',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          $window.location.href = url + '/download/?location=' + response.data;
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.generateNationalities = function (filter, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/generateNationalities',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          $window.location.href = url + '/download/?location=' + response.data;
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStatisticsAutomatic = function (filter) {
      var urlAuto = url + '/automaticStatistics';

      return $q(function (resolve, reject) {
        $http({
          url: urlAuto,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime()
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStatisticRepartitionCompany = function (subTypeId, fieldId, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/repartition/company/' + subTypeId + '/' + fieldId,
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStatisticRepartitionContact = function (fieldId, lang, companyType) {
      var customURL = url + '/repartition/contact/' + fieldId + '/';

      if (companyType) {
        customURL += companyType;
      }

      return $q(function (resolve, reject) {
        $http({
          url: customURL,
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStatisticsByCompanyTypes = function (lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/repartition/byCompanyTypes',
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStatisticReporting = function (filter, lang, year) {
      var urlPost = url + '/reporting/';

      if (year !== null) {
        urlPost += year;
      }

      return $q(function (resolve, reject) {
        $http({
          url: urlPost,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.generateReporting = function (filter, lang, year) {
      var urlPost = url + '/generateReporting/';

      if (year !== null) {
        urlPost += year;
      }

      return $q(function (resolve, reject) {
        $http({
          url: urlPost,
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          $window.location.href = url + '/download/?location=' + encodeURIComponent(response.data);
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.addStatClick = function (postDTO) {
      return $q(function (resolve, reject) {
        $http({
          url: publicUrl + '/companies/statClick',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime()
          },
          data: postDTO
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStratisticsBySubTypeId = function (subTypeId, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/repartition/' + subTypeId,
          method: 'GET',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getStratisticsFilteredBySubTypeId = function (subTypeId, lang, filter) {
      return $q(function (resolve, reject) {
        $http({
          url: url + '/repartition/filtered/' + subTypeId,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=utf-8'
          },
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('statisticsController', statisticsController);

  /** @ngInject */
  function statisticsController($scope, statisticsService, $filter, $rootScope, toastr, $mdDialog) {
    
  }
})();

(function () {
	'use strict';

	angular.module('app.front').service('StatisticCompanyService', StatisticCompanyService);

	function StatisticCompanyService($q, $http, $filter, $location, toastr) {

		var service = {};

		service.getStatisticCompany = function (filter, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/statisticCompany/getStatisticCompany',
					method: 'POST',
					params: { '_v': new Date().getTime(), 'lang' : lang },
					data : filter
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};

		service.export = function(filter,lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/statisticCompany/export',
					method: 'POST',
					responseType: 'arraybuffer',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					data: filter
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}
		return service;

	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('StatisticCompanyController', StatisticCompanyController);

	function StatisticCompanyController($scope, userService, $translate, $q, StatisticCompanyService, modelService, companyService, BlogService,
		$filter, $rootScope, toastr, $mdDialog, $mdSelect, $window, STORAGE_PREFIX, SitesManagementService, $timeout) {

		$scope.userService = userService;
		//Useful variables
		var now = new Date();
		var langage = localStorage[STORAGE_PREFIX + 'language'];
		var timeoutCanceler = $q.defer();

		$scope.filterModes = [{
			key: 'DAY',
			value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.DAY')
		},
		{ key: 'WEEK', value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.WEEK') },
		{
			key: 'MONTH',
			value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.MONTH')
		},
		{
			key: 'YEAR',
			value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.YEAR')
		},
		{
			key: 'PERIOD',
			value: $filter('translate')('STATISTIC_COMPANY.FILTER_MODE.PERIOD')
		}
		];

		$scope.filter = {
			mode: 'DAY',
			begin: {
				year: now.getFullYear(),
				month: now.getMonth(),
				date: now
			},
			end: {
				year: now.getFullYear(),
				month: now.getMonth(),
				date: now
			},
			companyID: null,
			tagID: null,
			countryID: null,
			by: "COMPANY",
			activity: null,
			associationsIDs: null,
			secondPeriod: {
				checked: false,
				mode: 'DAY',
				begin: {
					year: now.getFullYear(),
					month: now.getMonth(),
					date: now
				},
				end: {
					year: now.getFullYear(),
					month: now.getMonth(),
					date: now
				}
			}
		};

		$scope.filterSelectTextTag = {
			value: ''
		};
		$scope.filterSelectTextCountry = {
			value: ''
		};
		$scope.filterSelectTextRegion = {
			value: ''
		};

		$scope.countriesTags = [];
		$scope.regionsTags = [];
		$scope.tagsCategory = [];



		$scope.companies = [];
		$scope.activities = [];
		$scope.loading = {
			filter: false,
			export: false
		};

		$scope.monthNames = [];
		$scope.yearValues = [];
		$scope.customYear = {
			filter: {
				begin: null,
				end: null
			}
		};
		$scope.statisticsArray = [];
		$scope.filterSelectTextCompany = {
			value: ''
		};

		$scope.typeSearchChanged = function () {

			if ($scope.filter.by == 'TAGS') {
				$scope.filterSelectTextCompany.value = "";
				$scope.filter.companyID = null;
			} else if ($scope.filter.by == 'COMPANY') {
				$scope.filterSelectTextTag.value = "";
				$scope.filterSelectTextCountry.value = "";
				$scope.filterSelectTextRegion.value = "";
				$scope.filter.tagID = null;
				$scope.filter.countryID = null;
			}
		}

		$timeout(function () {
			$scope.$watch('filter.mode', function (newVal, oldVal) {
				if (newVal) {
					if (newVal === 'DAY') {

					} else if (newVal === 'WEEK') {

					} else if (newVal === 'MONTH') {

					} else if (newVal === 'YEAR') {

					} else if (newVal === 'PERIOD') {

					}
				}
			});
		});

		$scope.getTagsCategory = function () {
			if ($scope.filterSelectTextTag.value != "") {
				BlogService.filterByString($scope.filterSelectTextTag.value, $translate.preferredLanguage(), 'TAGS').then(function (res) {
					if (res.data) {
						$scope.tagsCategory = res.data;
					}
				}).catch(function (err) {
					console.log(err);

				});
			} else {
				$scope.tagsCategory = [];
			}

		}

		$scope.getTagsCountry = function () {
			if ($scope.filterSelectTextCountry.value != "") {
				BlogService.filterByString($scope.filterSelectTextCountry.value, $translate.preferredLanguage(), 'COUNTRIES').then(function (res) {
					if (res.data) {
						$scope.countriesTags = res.data;
					}
				}).catch(function (err) {
					console.log(err);
				});
			} else {
				$scope.countriesTags = [];
			}

		}

		$scope.getTagsRegion = function () {
			if ($scope.filterSelectTextRegion.value != "") {
				BlogService.filterByString($scope.filterSelectTextRegion.value, $translate.preferredLanguage(), 'REGIONS').then(function (res) {
					if (res.data) {
						$scope.regionsTags = res.data;
					}
				}).catch(function (err) {
					console.log(err);
				});
			} else {
				$scope.regionsTags = [];
			}

		}

		$scope.$watch('filterSelectTextTag.value', function () {
			$scope.getTagsCategory();
		});

		$scope.$watch('filterSelectTextCountry.value', function () {
			$scope.getTagsCountry();
		});

		$scope.$watch('filterSelectTextRegion.value', function () {
			$scope.getTagsRegion();
		});
		var getCompanies = function () {
			if (timeoutCanceler != null) {
				timeoutCanceler.resolve();
			}
			timeoutCanceler = $q.defer();
			companyService.filterByString($scope.filterSelectTextCompany.value, 1, $translate.preferredLanguage(), timeoutCanceler, null).then(function (res) {
				if (res.data) {
					$scope.companies = res.data;
				}
			}).catch(function (err) {
				console.log(err);
				// toastr.error($filter('translate')('PACKAGES.ADD.ERROR_GET_COMPANIES'));
			});
		};

		$scope.$watch('filterSelectTextCompany.value', function () {
			getCompanies();
		});

		/*if (!$rootScope.user) {
			var listener = $scope.$on('rooScopeUser:ready', function () {
				companyService.findForStatistics($translate.preferredLanguage(), $rootScope.user.associationIds).then(function (res) {
					if (res.data) {
						$scope.companies = res.data;
					}
				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_COMPANIES'));
				});
				listener();
			});
		} else {
			companyService.findForStatistics($translate.preferredLanguage(), $rootScope.user.associationIds).then(function (res) {
				if (res.data) {
					$scope.companies = res.data;
				}
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_COMPANIES'));
			});
		}*/

		modelService.listLinkedField($translate.preferredLanguage()).then(function (response) {
			var _activities = response.data.filter(function (item) {
				return (item.type === "COMPANY_TYPE");
			});
			angular.forEach(_activities[0].fieldModel.listFieldsDTO, function (item, index) {
				$scope.activities.push({
					id: _activities[0].fieldModel.id,
					idValue: item.id,
					libelle: item.value
				});
			});
		}).catch(function (error) {
			console.log(error);
		});

		SitesManagementService.findAll('sites').then(function (response) {
			$scope.sites = response.data;
		}).catch(function (error) {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		//Helper
		var validateYearFormat = function (year) {
			if (year >= (now.getFullYear() - 100) && year <= (now.getFullYear() + 100)) {
				return true;
			}
			return false;
		};

		//Init range years and months
		var initMonthAndYears = function () {
			for (var i = 0; i < 12; i++) {
				$scope.monthNames.push({
					value: i,
					name: $filter('translate')('GENERAL.MONTH_NAMES.' + i)
				});
			}
			var yearNow = now.getFullYear();
			for (var j = -3; j <= 3; j++) {
				$scope.yearValues.push(yearNow + j);
			}
		};

		initMonthAndYears();

		//For iput select year
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.searchStatisticsCustomYear = function (begin) {
			var customYear;
			var period;
			if (begin) {
				customYear = $scope.customYear.filter.begin;
				period = $scope.filter.begin;
			} else {
				customYear = $scope.customYear.filter.end;
				period = $scope.filter.end;
			}
			if (validateYearFormat(customYear)) {
				period.year = 'custom';
				$mdSelect.hide();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		$scope.searchStatisticsCustomYearSecond = function (begin) {
			var customYear;
			var period;
			if (begin) {
				customYear = $scope.customYear.filterSecond.begin;
				period = $scope.filter.secondPeriod.begin;
			} else {
				customYear = $scope.customYear.filterSecond.end;
				period = $scope.filter.secondPeriod.end;
			}
			if (validateYearFormat(customYear)) {
				period.year = 'custom';
				$mdSelect.hide();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		var getFilter = function (filter) {

			if ($scope.filter.mode == 'PERIOD') {
				if (new Date(filter.begin.year, filter.begin.month, 1) > new Date(filter.end.year, filter.end.month, 1)) {
					toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INVALID_PERIOD'));
					return null;
				}
			}
			if ($scope.filter.secondPeriod.mode == 'PERIOD') {
				if (new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month, 1) > new Date(filter.secondPeriod.end.year, filter.secondPeriod.end.month, 1)) {
					toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INVALID_PERIOD'));
					return null;
				}
			}
			return filter;
		};

		$scope.createFilterToSend = function () {
			var filter = angular.copy(getFilter($scope.filter));
			if ($scope.filter.mode == 'DAY') {
				var _dateStart = angular.copy(filter.begin.date);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = angular.copy(filter.begin.date);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'MONTH') {
				var _dateStart = new Date(filter.begin.year, filter.begin.month, 1);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = new Date(filter.begin.year, filter.begin.month + 1, 0);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'YEAR') {
				var _dateStart = new Date(filter.begin.year, 0, 1);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = new Date(filter.begin.year, 12, 0);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'PERIOD') {
				var _dateStart = angular.copy(filter.begin.date);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = angular.copy(filter.end.date);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			}

			//filter second period
			if ($scope.filter.secondPeriod.checked) {
				if ($scope.filter.secondPeriod.mode == 'DAY') {
					var _dateStart = angular.copy(filter.secondPeriod.begin.date);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = angular.copy(filter.secondPeriod.begin.date);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'MONTH') {
					var _dateStart = new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month, 1);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month + 1, 0);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'YEAR') {
					var _dateStart = new Date(filter.secondPeriod.begin.year, 0, 1);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = new Date(filter.secondPeriod.begin.year, 12, 0);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'PERIOD') {
					var _dateStart = angular.copy(filter.secondPeriod.begin.date);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = angular.copy(filter.secondPeriod.end.date);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				}
			}
			return filter;
		}

		$scope.getStatsCompanies = function () {
			var filter = $scope.createFilterToSend();

			if (filter === null) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_RESULTS'));
				return;
			}

			$scope.loading.filter = true;
			StatisticCompanyService.getStatisticCompany(filter, $translate.preferredLanguage()).then(function (res) {

				if (res.data) {
					if (filter.secondPeriod.checked) {
						$scope.isForTwoPeriods = true;
					} else {
						$scope.isForTwoPeriods = false;
					}
					$scope.statisticsArray = res.data.statistiques;
					$scope.totalViews = res.data.totalViews;
					$scope.totalShowns = res.data.totalShowns;
					$scope.totalQuoteRequest = res.data.totalQuoteRequest;
					$scope.totalClicksEmail = res.data.totalClicksEmail;
					$scope.totalClicksPhone = res.data.totalClicksPhone;
					$scope.totalQuoteRequestAccepted = res.data.totalQuoteRequestAccepted;

					$scope.totalViews2 = res.data.totalViews2;
					$scope.totalShowns2 = res.data.totalShowns2;
					$scope.totalQuoteRequest2 = res.data.totalQuoteRequest2;
					$scope.totalClicksEmail2 = res.data.totalClicksEmail2;
					$scope.totalClicksPhone2 = res.data.totalClicksPhone2;
					$scope.totalQuoteRequestAccepted2 = res.data.totalQuoteRequestAccepted2;
				}
				$scope.loading.filter = false;


			}).catch(function (err) {
				$scope.loading.filter = false;
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_RESULTS'));
				console.log(err);
			});
		};

		$scope.export = function () {
			var filter = $scope.createFilterToSend();

			if (filter === null) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOASTR.ERROR_GET_RESULTS'));
				return;
			}
			$scope.loading.export = true;
			StatisticCompanyService.export(filter, $translate.preferredLanguage()).then(function (response) {
				var byteArray = new Uint8Array(response.data);
				var a = window.document.createElement('a');
				a.href = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
				a.download = 'export_statistics_company.xlsx';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				$scope.loading.export = false;
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$scope.loading.export = false;
			});
		}

		function initRights() {
			if (!$rootScope.user) {
				var listener = $scope.$on('rooScopeUser:ready', function () {
					if (userService.isUserAdmin()) {

					} else if (userService.isUserLinkedToAssociations()) {
						$scope.filter.associationsIDs = angular.copy($rootScope.user.associationIds);
					}
					$scope.getStatsCompanies();
					listener();
				});
			} else {
				if (userService.isUserAdmin()) {

				} else if (userService.isUserLinkedToAssociations()) {
					$scope.filter.associationsIDs = angular.copy($rootScope.user.associationIds);
				}
				$scope.getStatsCompanies();
			}
		}
		initRights();

	}

})();

(function () {
	'use strict';

	angular.module('app.front').service('StatisticBannersService', StatisticBannersService);

	function StatisticBannersService($q, $http, $filter, $location, toastr) {

		var service = {};

		service.getStatisticBanners = function (filter, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/statisticBanners/getStatisticBanners',
					method: 'POST',
					params: { '_v': new Date().getTime(), 'lang' : lang },
					data : filter
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};

		service.export = function(filter,lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/statisticBanners/export',
					method: 'POST',
					responseType: 'arraybuffer',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					data: filter
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}

		return service;

	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('StatisticBannersController', StatisticBannersController);

	function StatisticBannersController($scope, userService, $translate, $q, StatisticBannersService, modelService, BannersService,
		$filter, $rootScope, toastr, $mdDialog, $mdSelect, $window, STORAGE_PREFIX, SitesManagementService, $timeout) {

		$scope.userService = userService;
		//Useful variables
		var now = new Date();
		var langage = localStorage[STORAGE_PREFIX + 'language'];
		$scope.arrayResults = [];

		$scope.filterModes = [{
				key: 'DAY',
				value: $filter('translate')('STATISTIC_BANNERS.FILTER_MODE.DAY')
			},
			{
				key : 'WEEK',
				value : $filter('translate')('STATISTIC_BANNERS.FILTER_MODE.WEEK') 
			},
			{
				key: 'MONTH',
				value: $filter('translate')('STATISTIC_BANNERS.FILTER_MODE.MONTH')
			},
			{
				key: 'YEAR',
				value: $filter('translate')('STATISTIC_BANNERS.FILTER_MODE.YEAR')
			},
			{
				key: 'PERIOD',
				value: $filter('translate')('STATISTIC_BANNERS.FILTER_MODE.PERIOD')
			}
		];

		$scope.filter = {
			mode: 'DAY',
			begin: {
				year: now.getFullYear(),
				month: now.getMonth(),
				date: now
			},
			end: {
				year: now.getFullYear(),
				month: now.getMonth(),
				date: now
			},
			bannerID: null,
			secondPeriod: {
				checked:false,
				mode: 'DAY',
				begin: {
					year: now.getFullYear(),
					month: now.getMonth(),
					date: now
				},
				end: {
					year: now.getFullYear(),
					month: now.getMonth(),
					date: now
				}
			}
		};
		$scope.banners = [];
		$scope.loading = {
			filter: false,
			export: false
		};

		$scope.monthNames = [];
		$scope.yearValues = [];
		$scope.customYear = {
			filter: {
				begin: null,
				end: null
			},
			filterSecond:{
				begin:null,
				end:null
			}
		};
		$scope.statisticsArray = [];
		$scope.filterSelectTextBanner = {
			value: ''
		};

		$timeout(function () {
			$scope.$watch('filter.mode', function (newVal, oldVal) {
				if (newVal) {
					if (newVal === 'DAY') {

					} else if (newVal === 'WEEK') {

					} else if (newVal === 'MONTH') {

					} else if (newVal === 'YEAR') {

					} else if (newVal === 'PERIOD') {

					}
				}
			});
		});


		$scope.getBanners = function () {
			if($scope.filterSelectTextBanner.value!=""){
				BannersService.filterByString($scope.filterSelectTextBanner.value, $translate.preferredLanguage()).then(function (res) {
					if (res.data) {
						$scope.banners = res.data;
					}
				}).catch(function (err) {
					console.log(err);

				});
			}else{
				$scope.banners = [];
			}

		};

		$scope.$watch('filterSelectTextBanner.value', function () {
			$scope.getBanners();
		});


		//Helper
		var validateYearFormat = function (year) {
			if (year >= (now.getFullYear() - 100) && year <= (now.getFullYear() + 100)) {
				return true;
			}
			return false;
		};

		//Init range years and months
		var initMonthAndYears = function () {
			for (var i = 0; i < 12; i++) {
				$scope.monthNames.push({
					value: i,
					name: $filter('translate')('GENERAL.MONTH_NAMES.' + i)
				});
			}
			var yearNow = now.getFullYear();
			for (var j = -3; j <= 3; j++) {
				$scope.yearValues.push(yearNow + j);
			}
		};

		initMonthAndYears();

		//For iput select year
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.searchStatisticsCustomYear = function (begin) {
			var customYear;
			var period;
			if (begin) {
				customYear = $scope.customYear.filter.begin;
				period = $scope.filter.begin;
			} else {
				customYear = $scope.customYear.filter.end;
				period = $scope.filter.end;
			}
			if (validateYearFormat(customYear)) {
				period.year = 'custom';
				$mdSelect.hide();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		$scope.searchStatisticsCustomYearSecond = function (begin) {
			var customYear;
			var period;
			if (begin) {
				customYear = $scope.customYear.filterSecond.begin;
				period = $scope.filter.secondPeriod.begin;
			} else {
				customYear = $scope.customYear.filterSecond.end;
				period = $scope.filter.secondPeriod.end;
			}
			if (validateYearFormat(customYear)) {
				period.year = 'custom';
				$mdSelect.hide();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		var getFilter = function (filter) {

			if ($scope.filter.mode == 'PERIOD') {
				if (new Date(filter.begin.year, filter.begin.month, 1) > new Date(filter.end.year, filter.end.month, 1)) {
					toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INVALID_PERIOD'));
					return null;
				}
			}

			if ($scope.filter.secondPeriod.mode == 'PERIOD') {
				if (new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month, 1) > new Date(filter.secondPeriod.end.year, filter.secondPeriod.end.month, 1)) {
					toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INVALID_PERIOD'));
					return null;
				}
			}
			return filter;
		};

		$scope.getStatsBanners = function () {
			var filter = angular.copy(getFilter($scope.filter));

			//filter first period
			if ($scope.filter.mode == 'DAY') {
				var _dateStart = angular.copy(filter.begin.date);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = angular.copy(filter.begin.date);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'MONTH') {
				var _dateStart = new Date(filter.begin.year, filter.begin.month, 1);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = new Date(filter.begin.year, filter.begin.month + 1, 0);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'YEAR') {
				var _dateStart = new Date(filter.begin.year, 0, 1);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = new Date(filter.begin.year, 12, 0);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'PERIOD') {
				var _dateStart = angular.copy(filter.begin.date);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = angular.copy(filter.end.date);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			}


			//filter second period
			if($scope.filter.secondPeriod.checked){
				if ($scope.filter.secondPeriod.mode == 'DAY') {
					var _dateStart = angular.copy(filter.secondPeriod.begin.date);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = angular.copy(filter.secondPeriod.begin.date);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'MONTH') {
					var _dateStart = new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month, 1);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month + 1, 0);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'YEAR') {
					var _dateStart = new Date(filter.secondPeriod.begin.year, 0, 1);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = new Date(filter.secondPeriod.begin.year, 12, 0);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'PERIOD') {
					var _dateStart = angular.copy(filter.secondPeriod.begin.date);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = angular.copy(filter.secondPeriod.end.date);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				}
			}



			if (filter === null) {
				return;
			}
			$scope.loading.filter = true;



			StatisticBannersService.getStatisticBanners(filter, $translate.preferredLanguage()).then(function (res) {

				if(filter.secondPeriod.checked){
					$scope.isForTwoPeriods = true;
				}else{
					$scope.isForTwoPeriods = false;
				}
				$scope.arrayResults = res.data;
				$scope.loading.filter = false;

			}).catch(function (err) {
				$scope.loading.filter = false;
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_RESULTS'));
				console.log(err);
			});
		};

		$scope.export = function(){

			var filter = angular.copy(getFilter($scope.filter));

			//filter first period
			if ($scope.filter.mode == 'DAY') {
				var _dateStart = angular.copy(filter.begin.date);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = angular.copy(filter.begin.date);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'MONTH') {
				var _dateStart = new Date(filter.begin.year, filter.begin.month, 1);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = new Date(filter.begin.year, filter.begin.month + 1, 0);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'YEAR') {
				var _dateStart = new Date(filter.begin.year, 0, 1);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = new Date(filter.begin.year, 12, 0);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'PERIOD') {
				var _dateStart = angular.copy(filter.begin.date);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = angular.copy(filter.end.date);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			}


			//filter second period
			if($scope.filter.secondPeriod.checked){
				if ($scope.filter.secondPeriod.mode == 'DAY') {
					var _dateStart = angular.copy(filter.secondPeriod.begin.date);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = angular.copy(filter.secondPeriod.begin.date);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'MONTH') {
					var _dateStart = new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month, 1);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month + 1, 0);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'YEAR') {
					var _dateStart = new Date(filter.secondPeriod.begin.year, 0, 1);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = new Date(filter.secondPeriod.begin.year, 12, 0);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'PERIOD') {
					var _dateStart = angular.copy(filter.secondPeriod.begin.date);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = angular.copy(filter.secondPeriod.end.date);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				}
			}

			if (filter === null) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOASTR.ERROR_GET_RESULTS'));
				return;
			}
			$scope.loading.export = true;
			StatisticBannersService.export(filter, $translate.preferredLanguage()).then(function (response) {
				var byteArray = new Uint8Array(response.data);
				var a = window.document.createElement('a');
				a.href = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
				a.download = 'export_statistics_banner.xlsx';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				$scope.loading.export = false;
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$scope.loading.export = false;
			});
		}

	}

})();

(function () {
	'use strict';

	angular.module('app.front').service('StatisticArticlesService', StatisticArticlesService);

	function StatisticArticlesService($q, $http, $filter, $location, toastr) {

		var service = {};

		service.getStatisticArticles = function (filter, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/statisticArticles/getStatisticArticles',
					method: 'POST',
					params: { '_v': new Date().getTime(), 'lang' : lang },
					data : filter
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};


		service.export = function(filter,lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/statisticArticles/export',
					method: 'POST',
					responseType: 'arraybuffer',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					data: filter
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}
		return service;

	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('StatisticArticlesController', StatisticArticlesController);

	function StatisticArticlesController($scope, userService, $translate, $q, StatisticArticlesService, modelService, BlogService,
		$filter, $rootScope, toastr, $mdDialog, $mdSelect, $window, STORAGE_PREFIX, SitesManagementService, $timeout) {

		$scope.userService = userService;
		//Useful variables
		var now = new Date();
		var langage = localStorage[STORAGE_PREFIX + 'language'];
		$scope.arrayResults = [];
		$scope.filterModes = [{
			key: 'DAY',
			value: $filter('translate')('STATISTIC_ARTICLES.FILTER_MODE.DAY')
		},
		{
			key: 'WEEK',
			value: $filter('translate')('STATISTIC_ARTICLES.FILTER_MODE.WEEK')
		},
		{
			key: 'MONTH',
			value: $filter('translate')('STATISTIC_ARTICLES.FILTER_MODE.MONTH')
		},
		{
			key: 'YEAR',
			value: $filter('translate')('STATISTIC_ARTICLES.FILTER_MODE.YEAR')
		},
		{
			key: 'PERIOD',
			value: $filter('translate')('STATISTIC_ARTICLES.FILTER_MODE.PERIOD')
		}
		];

		$scope.filter = {
			mode: 'DAY',
			begin: {
				year: now.getFullYear(),
				month: now.getMonth(),
				date: now
			},
			end: {
				year: now.getFullYear(),
				month: now.getMonth(),
				date: now
			},
			articleID: null,
			tagID: null,
			countryID: null,
			by: "ARTICLE",
			secondPeriod: {
				checked: false,
				mode: 'DAY',
				begin: {
					year: now.getFullYear(),
					month: now.getMonth(),
					date: now
				},
				end: {
					year: now.getFullYear(),
					month: now.getMonth(),
					date: now
				}
			}
		};
		$scope.articles = [];
		$scope.loading = {
			filter: false,
			export: false
		};

		$scope.monthNames = [];
		$scope.yearValues = [];
		$scope.customYear = {
			filter: {
				begin: null,
				end: null
			},
			filterSecond: {
				begin: null,
				end: null
			}
		};
		$scope.statisticsArray = [];
		$scope.filterSelectTextArticle = {
			value: ''
		};
		$scope.filterSelectTextTag = {
			value: ''
		};
		$scope.filterSelectTextCountry = {
			value: ''
		};
		$scope.filterSelectTextRegion = {
			value: ''
		};

		$scope.countriesTags = [];
		$scope.regionsTags = [];
		$scope.tagsCategory = [];

		$timeout(function () {
			$scope.$watch('filter.mode', function (newVal, oldVal) {
				if (newVal) {
					if (newVal === 'DAY') {

					} else if (newVal === 'WEEK') {

					} else if (newVal === 'MONTH') {

					} else if (newVal === 'YEAR') {

					} else if (newVal === 'PERIOD') {

					}
				}
			});
		});

		$scope.typeSearchChanged = function () {

			if ($scope.filter.by == 'CATEGORY') {
				$scope.filterSelectTextArticle.value = "";
				$scope.filterSelectTextCountry.value = "";
				$scope.filterSelectTextRegion.value = "";
				$scope.filter.articleID = null;
				$scope.filter.countryID = null;
				$scope.filter.regionID = null;
			} else if ($scope.filter.by == 'ARTICLE') {
				$scope.filterSelectTextTag.value = "";
				$scope.filterSelectTextCountry.value = "";
				$scope.filterSelectTextRegion.value = "";
				$scope.filter.tagID = null;
				$scope.filter.countryID = null;
				$scope.filter.regionID = null;
			} else if ($scope.filter.by == 'COUNTRY') {
				$scope.filterSelectTextArticle.value = "";
				$scope.filterSelectTextTag.value = "";
				$scope.filterSelectTextRegion.value = "";
				$scope.filter.articleID = null;
				$scope.filter.regionID = null;
				$scope.filter.tagID = null;
			} else if ($scope.filter.by == 'REGION') {
				$scope.filterSelectTextArticle.value = "";
				$scope.filterSelectTextCountry.value = "";
				$scope.filterSelectTextTag.value = "";
				$scope.filter.articleID = null;
				$scope.filter.countryID = null;
				$scope.filter.tagID = null;
			}
		}

		$scope.getArticles = function () {
			if ($scope.filterSelectTextArticle.value != "") {
				BlogService.filterByString($scope.filterSelectTextArticle.value, $translate.preferredLanguage(), 'ARTICLES').then(function (res) {
					if (res.data) {
						$scope.articles = res.data;
					}
				}).catch(function (err) {
					console.log(err);

				});
			} else {
				$scope.articles = [];
			}

		};

		$scope.getTagsCategory = function () {
			if ($scope.filterSelectTextTag.value != "") {
				BlogService.filterByString($scope.filterSelectTextTag.value, $translate.preferredLanguage(), 'TAGS').then(function (res) {
					if (res.data) {
						$scope.tagsCategory = res.data;
					}
				}).catch(function (err) {
					console.log(err);

				});
			} else {
				$scope.tagsCategory = [];
			}

		}

		$scope.getTagsCountry = function () {
			if ($scope.filterSelectTextCountry.value != "") {
				BlogService.filterByString($scope.filterSelectTextCountry.value, $translate.preferredLanguage(), 'COUNTRIES').then(function (res) {
					if (res.data) {
						$scope.countriesTags = res.data;
					}
				}).catch(function (err) {
					console.log(err);
				});
			} else {
				$scope.countriesTags = [];
			}

		}

		$scope.getTagsRegion = function () {
			if ($scope.filterSelectTextRegion.value != "") {
				BlogService.filterByString($scope.filterSelectTextRegion.value, $translate.preferredLanguage(), 'REGIONS').then(function (res) {
					if (res.data) {
						$scope.regionsTags = res.data;
					}
				}).catch(function (err) {
					console.log(err);
				});
			} else {
				$scope.regionsTags = [];
			}

		}

		$scope.$watch('filterSelectTextArticle.value', function () {
			$scope.getArticles();
		});

		$scope.$watch('filterSelectTextTag.value', function () {
			$scope.getTagsCategory();
		});

		$scope.$watch('filterSelectTextCountry.value', function () {
			$scope.getTagsCountry();
		});

		$scope.$watch('filterSelectTextRegion.value', function () {
			$scope.getTagsRegion();
		});


		//Helper
		var validateYearFormat = function (year) {
			if (year >= (now.getFullYear() - 100) && year <= (now.getFullYear() + 100)) {
				return true;
			}
			return false;
		};

		//Init range years and months
		var initMonthAndYears = function () {
			for (var i = 0; i < 12; i++) {
				$scope.monthNames.push({
					value: i,
					name: $filter('translate')('GENERAL.MONTH_NAMES.' + i)
				});
			}
			var yearNow = now.getFullYear();
			for (var j = -3; j <= 3; j++) {
				$scope.yearValues.push(yearNow + j);
			}
		};

		initMonthAndYears();

		//For iput select year
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		$scope.searchStatisticsCustomYear = function (begin) {
			var customYear;
			var period;
			if (begin) {
				customYear = $scope.customYear.filter.begin;
				period = $scope.filter.begin;
			} else {
				customYear = $scope.customYear.filter.end;
				period = $scope.filter.end;
			}
			if (validateYearFormat(customYear)) {
				period.year = 'custom';
				$mdSelect.hide();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		$scope.searchStatisticsCustomYearSecond = function (begin) {
			var customYear;
			var period;
			if (begin) {
				customYear = $scope.customYear.filterSecond.begin;
				period = $scope.filter.secondPeriod.begin;
			} else {
				customYear = $scope.customYear.filterSecond.end;
				period = $scope.filter.secondPeriod.end;
			}
			if (validateYearFormat(customYear)) {
				period.year = 'custom';
				$mdSelect.hide();
			} else {
				toastr.error($filter('translate')('STATISTICS.EDIT.TOAST.INVALID_YEAR'));
			}
		};

		var getFilter = function (filter) {

			if ($scope.filter.mode == 'PERIOD') {
				if (new Date(filter.begin.year, filter.begin.month, 1) > new Date(filter.end.year, filter.end.month, 1)) {
					toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INVALID_PERIOD'));
					return null;
				}
			}

			if ($scope.filter.secondPeriod.mode == 'PERIOD') {
				if (new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month, 1) > new Date(filter.secondPeriod.end.year, filter.secondPeriod.end.month, 1)) {
					toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.INVALID_PERIOD'));
					return null;
				}
			}
			return filter;
		};

		$scope.getStatsArticles = function () {
			var filter = angular.copy(getFilter($scope.filter));

			//filter first period
			if ($scope.filter.mode == 'DAY') {
				var _dateStart = angular.copy(filter.begin.date);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = angular.copy(filter.begin.date);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'MONTH') {
				var _dateStart = new Date(filter.begin.year, filter.begin.month, 1);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = new Date(filter.begin.year, filter.begin.month + 1, 0);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'YEAR') {
				var _dateStart = new Date(filter.begin.year, 0, 1);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = new Date(filter.begin.year, 12, 0);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'PERIOD') {
				var _dateStart = angular.copy(filter.begin.date);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = angular.copy(filter.end.date);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			}


			//filter second period
			if ($scope.filter.secondPeriod.checked) {
				if ($scope.filter.secondPeriod.mode == 'DAY') {
					var _dateStart = angular.copy(filter.secondPeriod.begin.date);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = angular.copy(filter.secondPeriod.begin.date);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'MONTH') {
					var _dateStart = new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month, 1);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month + 1, 0);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'YEAR') {
					var _dateStart = new Date(filter.secondPeriod.begin.year, 0, 1);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = new Date(filter.secondPeriod.begin.year, 12, 0);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'PERIOD') {
					var _dateStart = angular.copy(filter.secondPeriod.begin.date);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = angular.copy(filter.secondPeriod.end.date);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				}
			}



			if (filter === null) {
				return;
			}
			$scope.loading.filter = true;



			StatisticArticlesService.getStatisticArticles(filter, $translate.preferredLanguage()).then(function (res) {

				if (filter.secondPeriod.checked) {
					$scope.isForTwoPeriods = true;
				} else {
					$scope.isForTwoPeriods = false;
				}
				$scope.arrayResults = res.data.articles;
				$scope.totalShown = res.data.totalShown;
				$scope.totalShown2 = res.data.totalShown2;
				$scope.totalRead = res.data.totalRead;
				$scope.totalRead2 = res.data.totalRead2;
				$scope.totalShownInFavoriteBloc = res.data.totalShownInFavoriteBloc;
				$scope.totalShownInFavoriteBloc2 = res.data.totalShownInFavoriteBloc2;
				$scope.totalReadInFavoriteBloc = res.data.totalReadInFavoriteBloc;
				$scope.totalReadInFavoriteBloc2 = res.data.totalReadInFavoriteBloc2;
				$scope.totalShownInSpecialFolder = res.data.totalShownInSpecialFolder;
				$scope.totalShownInSpecialFolder2 = res.data.totalShownInSpecialFolder2;
				$scope.totalReadInSpecialFolder = res.data.totalReadInSpecialFolder;
				$scope.totalReadInSpecialFolder2 = res.data.totalReadInSpecialFolder2;


				$scope.loading.filter = false;

			}).catch(function (err) {
				$scope.loading.filter = false;
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOAST.ERROR_GET_RESULTS'));
				console.log(err);
			});
		};

		$scope.getStatsArticles();

		$scope.export = function () {
			var filter = angular.copy(getFilter($scope.filter));

			//filter first period
			if ($scope.filter.mode == 'DAY') {
				var _dateStart = angular.copy(filter.begin.date);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = angular.copy(filter.begin.date);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'MONTH') {
				var _dateStart = new Date(filter.begin.year, filter.begin.month, 1);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = new Date(filter.begin.year, filter.begin.month + 1, 0);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'YEAR') {
				var _dateStart = new Date(filter.begin.year, 0, 1);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = new Date(filter.begin.year, 12, 0);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			} else if ($scope.filter.mode == 'PERIOD') {
				var _dateStart = angular.copy(filter.begin.date);
				_dateStart.setHours(0, 0, 0);
				var _dateEnd = angular.copy(filter.end.date);
				_dateEnd.setHours(23, 59, 59);
				filter.begin.date = _dateStart.getTime();
				filter.end.date = _dateEnd.getTime();
			}


			//filter second period
			if ($scope.filter.secondPeriod.checked) {
				if ($scope.filter.secondPeriod.mode == 'DAY') {
					var _dateStart = angular.copy(filter.secondPeriod.begin.date);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = angular.copy(filter.secondPeriod.begin.date);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'MONTH') {
					var _dateStart = new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month, 1);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = new Date(filter.secondPeriod.begin.year, filter.secondPeriod.begin.month + 1, 0);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'YEAR') {
					var _dateStart = new Date(filter.secondPeriod.begin.year, 0, 1);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = new Date(filter.secondPeriod.begin.year, 12, 0);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				} else if ($scope.filter.secondPeriod.mode == 'PERIOD') {
					var _dateStart = angular.copy(filter.secondPeriod.begin.date);
					_dateStart.setHours(0, 0, 0);
					var _dateEnd = angular.copy(filter.secondPeriod.end.date);
					_dateEnd.setHours(23, 59, 59);
					filter.secondPeriod.begin.date = _dateStart.getTime();
					filter.secondPeriod.end.date = _dateEnd.getTime();
				}
			}






			if (filter === null) {
				toastr.error($filter('translate')('STATISTICS.DISPLAY.TOASTR.ERROR_GET_RESULTS'));
				return;
			}
			$scope.loading.export = true;

			StatisticArticlesService.export(filter, $translate.preferredLanguage()).then(function (response) {
				var byteArray = new Uint8Array(response.data);
				var a = window.document.createElement('a');
				a.href = window.URL.createObjectURL(new Blob([byteArray], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
				a.download = 'export_statistics_articles.xlsx';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				$scope.loading.export = false;
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$scope.loading.export = false;
			});
		}

	}

})();

(function () {
  'use strict';

  angular.module('app.front').service('SitesManagementService', SitesManagementService);

  function SitesManagementService($q, $http, $filter) {

    var service = {};

    var blocTypes = [
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.BLOG', value: 'BLOG' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.PACKAGE', value: 'PACKAGE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.HTML', value: 'HTML' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.SEARCH_COMPANY', value: 'SEARCH_COMPANY' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.SEARCH_PACKAGE', value: 'SEARCH_PACKAGE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.CAROUSEL', value: 'CAROUSEL' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.CAROUSEL_PURE', value: 'CAROUSEL_PURE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.COMPANY', value: 'COMPANY' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.SEARCH_TOURIST_ATTRACTIONS', value: 'SEARCH_TOURIST_ATTRACTIONS' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.TOURIST_ATTRACTION', value: 'TOURIST_ATTRACTION' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.ARTICLE', value: 'ARTICLE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.FESTIVALS', value: 'FESTIVALS' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.FESTIVAL', value: 'FESTIVAL' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.GALLERIES', value: 'GALLERIES' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.GALLERY', value: 'GALLERY' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.CONTACT', value: 'CONTACT' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.TABLE', value: 'TABLE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.EVENT_INSCRIPTION', value: 'EVENT_INSCRIPTION' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.FAVORITE', value: 'FAVORITE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.BLOG_PURE', value: 'BLOG_PURE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.ARTICLE_PURE', value: 'ARTICLE_PURE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.ARTICLE_100', value: 'ARTICLE_100' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.ARTICLE_50', value: 'ARTICLE_50' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.ARTICLE_33', value: 'ARTICLE_33' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.ARTICLE_25', value: 'ARTICLE_25' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.SEARCH_COMPANY_WITH_STATUS', value: 'SEARCH_COMPANY_WITH_STATUS' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.YOUTUBE', value: 'YOUTUBE' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.GOOGLE_MAPS', value: 'GOOGLE_MAPS' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.COMPANY_WITH_STATUS', value: 'COMPANY_WITH_STATUS' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.COMPANY_SELECTION', value: 'COMPANY_SELECTION' },
		{ translation: 'SITES_MANAGEMENT.BLOCS.TYPES.BANNER', value: 'BANNER' },
		{ translation: 'SITES_MANAGEMENT.BLOCS.TYPES.BANNER_CAROUSEL', value: 'BANNER_CAROUSEL' },
      { translation: 'SITES_MANAGEMENT.BLOCS.TYPES.NEWSLETTER', value: 'NEWSLETTER' }
    ];

    service.getBlocTypes = function () {
      return blocTypes;
    };

    service.findAll = function (path) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/' + path,
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.find = function (path, id) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/' + path + '/' + id,
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findById = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/site/' + id,
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.saveFd = function (path, fmData) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/fd/' + path,
          method: 'POST',
          headers: {
            'Content-Type': undefined
          },
          params: {
            '_v': new Date().getTime()
          },
          data: fmData
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.save = function (path, dto) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/' + path,
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.delete = function (path, id) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/' + path + '/' + id,
          method: 'DELETE',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findPage = function (pageId, langKey) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/page/' + pageId + '/' + langKey,
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findPagesBySiteID = function (siteID) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/page/bySiteID/' + siteID,
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findSiteMenuBySiteID = function (siteID, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/siteMenu/' + siteID,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findSiteMenuBySiteURL = function (url, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/siteMenuByURL/' + url,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.saveSiteMenuItem = function (dto, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/siteMenuItem',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.deleteSiteMenuItem = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/siteMenuItem/' + id,
          method: 'DELETE',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.upSiteMenuItem = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/siteMenuItem/up',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.downSiteMenuItem = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/sites-management/siteMenuItem/down',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.moveBloc = function (pageID, blocIndex, up) {
      var url = './api/rest/sites-management/page/' + pageID + '/' + blocIndex + '/';

      if (up) {
        url += 'up';
      } else {
        url += 'down';
      }

      return $q(function (resolve, reject) {
        $http({
          url: url,
          method: 'PUT',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return service;

  }

})();

(function () {
	'use strict';

	angular.module('app.front').service('similarCompaniesService', SimilarCompaniesService);

	function SimilarCompaniesService($http, $q) {
		var service = {};

		service.findForSimilarities = function (modelSubTypeId, fieldId, maxOccurrence) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/rest/similar-companies/look-for-similarities',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						subTypeId: modelSubTypeId,
						fieldId: fieldId,
						maxOccurrence: maxOccurrence
					},
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			})
		}

		return service;
	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('SimilarCompaniesController', SimilarCompaniesController);

	function SimilarCompaniesController($scope, $translate, $filter, $state, MODELS_TYPES, modelService, similarCompaniesService) {
		$scope.MODEL_BASE_URL = './api/rest/model/';
		$scope.MODELS_TYPES = MODELS_TYPES;

		$scope.similarConfig = {};
		$scope._searchSubType = '';
		$scope._searchField = '';
		$scope.fields = [];

		$scope.progress = {
			lookForSimilarities: false
		};

		// md-select input search

		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		modelService.getSubTypes(
			$scope.MODEL_BASE_URL + $scope.MODELS_TYPES.COMPANY_MODEL,
			$translate.preferredLanguage(),
			true
		).then(function (resp) {
			$scope.modelSubTypes = resp.data;
		}).catch(function (err) {

		});

		$scope.listFields = function (subTypeParam) {
			if (subTypeParam != null && subTypeParam !== -1) {
				modelService.listFieldsBySubType(
					'COMPANY_MODEL',
					subTypeParam,
					$translate.preferredLanguage()
				).then(function (resp) {
					$scope.fields = $filter('filter')(resp.data, function (item) {
						return item.typeChamps === 'STRING';
					});
				}).catch(function (err) {
					console.log(err)
				});
			} else {
				modelService.listFieldsByType(
					'COMPANY_MODEL',
					$translate.preferredLanguage()
				).then(function (resp) {
					$scope.fields = $filter('filter')(resp.data, function (item) {
						return item.typeChamps === 'STRING';
					});
				}).catch(function (err) {
					console.log(err)
				});
			}
		};

		$scope.lookForSimilarities = function () {
			$scope.progress.lookForSimilarities = true;
			similarCompaniesService.findForSimilarities($scope.similarConfig.modelSubTypeId, $scope.similarConfig.fieldId, $scope.similarConfig.maxOccurrence).then(function (res) {
				$scope.similarities = res.data;
				$scope.progress.lookForSimilarities = false;
			}).catch(function () {
				$scope.progress.lookForSimilarities = false;
			});
		};

		$scope.removeDuplicatesFn = function (_modelsToMerge) {
			/*$state.go("app.merge_tool", {
			    '_modelType' :  $scope.duplicationToolDto.modelType,
			    '_modelSubTypeId' : $scope.duplicationToolDto.modelSubTypeId,
			    '_modelsToMerge' : _modelsToMerge
			});*/
			$state.goNewTab("app.merge_tool", {
				'_modelType': 'COMPANY_MODEL',
				'_modelSubTypeId': $scope.similarConfig.modelSubTypeId,
				'_modelsToMerge': _modelsToMerge
			});
		};
	}

})();

(function () {
	'use strict';

	angular.module('app.front').service('RequestForProposalService', RequestForProposalService);

	function RequestForProposalService($q, $http, $filter, $location, toastr) {

		var service = {};

		service.findRequestForProposal = function (filter, lang, page, outputs) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/requestForProposal/findRequestForProposal',
					method: 'POST',
					params: { '_v': new Date().getTime(), 'lang' : lang, 'page' : page, 'outputs' : outputs },
					data : filter
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};

		service.getAllCompanies = function(lang){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/requestForProposal/getAllCompanies',
					method: 'GET',
					params: { '_v': new Date().getTime(), 'lang' : lang }
				}).then(function (response) {
					resolve(response.data);
				}).catch(function (error) {
					reject(error);
				});
			});
		}

		service.findRequestForProposalById = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/requestForProposal/findRequestForProposalById/' + id,
					method: 'GET',
					params: { '_v': new Date().getTime(), 'lang' : lang }
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};

		service.setFinish = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/requestForProposal/setFinish/' + id,
					method: 'POST',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};

		service.setInProgress = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/requestForProposal/setInProgress/' + id,
					method: 'POST',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};



		service.valid = function (id,data) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/requestForProposal/valid/' + id,
					method: 'POST',
					params: {
						'_v': new Date().getTime()
					},
					data:data
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};
		service.getMembers = function (filter) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/requestForProposal/getMembers',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
						// 'rfp':filter.rfpID
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};

		service.getRFPCompany = function (filter,lang) {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/requestForProposal/getForCompany',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					data: filter
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};

		service.findMemberById = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/requestForProposal/getMember/'+id,
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		}

		service.filterUserByString = function(value){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/requestForProposal/getMembersByString',
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'value':value
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		}

		service.downloadCC= function(id){
			return '/api/public/sitegen/downloadCC/'+id;
		}
		return service;

	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('RequestForProposalController', RequestForProposalController);

	function RequestForProposalController($rootScope, $scope, $q, $filter, $state, $translate, toastr, RequestForProposalService,
		companyService, modelService, SitesManagementService) {

		var timeoutCanceler = $q.defer();
		$scope.page = 0;
		$scope.outputs = 100;
		$scope.loaded = true;
		$scope.allLoaded = false;
		$scope.requestForProposals = [];
		$scope.filter = {
			by:'COMPANY',
			companyID: null,
			userID: null,
			activity: null
		}
		$scope.companies = [];
		$scope.users = [];
		$scope.activities = [];
		$scope.filterSelectTextCompany = {
			value: ''
		};

		$scope.filterSelectTextUser = {
			value:''
		}

		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		var getCompanies = function () {
			if (timeoutCanceler != null) {
				timeoutCanceler.resolve();
			}
			timeoutCanceler = $q.defer();
			companyService.filterByString($scope.filterSelectTextCompany.value, 1, $translate.preferredLanguage(), timeoutCanceler, null).then(function (res) {
				if (res.data) {
					$scope.companies = res.data;
				}
			}).catch(function (err) {
				console.log(err);
				// toastr.error($filter('translate')('PACKAGES.ADD.ERROR_GET_COMPANIES'));
			});
		};

		var getUsers = function () {
			RequestForProposalService.filterUserByString($scope.filterSelectTextUser.value).then(function (res) {
				if (res.data) {
					$scope.users = res.data;
				}
			}).catch(function (err) {
				console.log(err);
				// toastr.error($filter('translate')('PACKAGES.ADD.ERROR_GET_COMPANIES'));
			});
		};

		$scope.$watch('filterSelectTextCompany.value', function () {
			getCompanies();
		});

		$scope.$watch('filterSelectTextUser.value', function () {
			getUsers();
		});

		getCompanies();
		getUsers();

		SitesManagementService.findAll('sites').then(function (response) {
			$scope.sites = response.data;
		}).catch(function (error) {
			toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
		});

		modelService.listLinkedField($translate.preferredLanguage()).then(function (response) {
			var _activities = response.data.filter(function (item) {
				return (item.type === "COMPANY_TYPE");
			});
			angular.forEach(_activities[0].fieldModel.listFieldsDTO, function (item, index) {
				$scope.activities.push({
					id: _activities[0].fieldModel.id,
					idValue: item.id,
					libelle: item.value
				});
			});
		}).catch(function (error) {
			console.log(error);
		});

		$scope._onLoadRfp = function () {
			$scope.loaded = false;
			RequestForProposalService.findRequestForProposal($scope.filter, $translate.preferredLanguage(),
				$scope.page, $scope.outputs).then(function (response) {
				$scope.requestForProposals = $scope.requestForProposals.concat(response.data);
				if (response.data.length < $scope.outputs) {
					$scope.allLoaded = true;
				} else {
					$scope.page += 1;
				}
				$scope.loaded = true;
			}).catch(function (error) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				$scope.loaded = true;
			});
		}
		$scope._onLoadRfp();

		$scope.onGetRfp = function () {
			$scope.page = 0;
			$scope.requestForProposals = [];
			$scope._onLoadRfp();
		};

		$scope.details = function (rfp) {
			$state.go('app.rfp.details', {
				id: rfp.id
			});
		};

		$scope.goToMembers = function(){
			$state.go('app.rfp.members');
		}

		$scope.changeVue = function() {
			$state.go('app.rfp.company');
		}


	}

})();

(function(){
	'use strict';

	angular.module('fuse').controller('confirmPopupController', confirmPopupController);

	function confirmPopupController($scope, $mdDialog, content){
		$scope.content = content;

		$scope.confirmAction = function(){
			$mdDialog.hide();
		};
		
		$scope.hidePopup = function(){
			$mdDialog.cancel();
		};
	}

})();
(function () {
  'use strict';

  angular.module('app.front').service('packagesService', packagesService);

  function packagesService($q, $http) {
    var service = {};
    var url = '/api/rest/packages/';
    var publicUrl = '/api/public/sitegen/packages/';

    service.save = function (dto, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + 'save',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.get = function (filter, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + 'get',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findById = function (id, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: url + 'findById/' + id,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.delete = function(id) {
      return $q(function (resolve, reject) {
        $http({
          url: url + 'delete/' + id,
          method: 'DELETE',
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.publicGet = function(page, max, filter, siteId, lang){
      return $q(function (resolve, reject) {
        $http({
          url: publicUrl + 'filter',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang': lang,
            'page': page,
            'max': max,
            'siteId': siteId
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findByIdPublic = function (id, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: publicUrl + id,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang,
          },
          headers: {
            'Content-Type': 'application/json;charset=UTF-8'
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return service;
  }
})();

(function () {
  'use strict';

  angular.module('app.front').controller('packagesController', packagesController);

  function packagesController($scope, $rootScope, $filter, packagesService, languageService, $mdDialog, $state, toastr) {
    $scope.regions = {};
    $scope.typesTourism = {};
    $scope.language = {};
    $scope.languages = [];
    var updateMode = false;
    $scope.loaded = true;
    $scope.filter = {
      region: null,
      typeTourisme: null,
      order: {
        name: null,
        inverse: false
      }
    };
    $scope.package = {};
    $scope.packages = [];

    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }
    }).catch(function (error) {

    });

    $scope.initPackages = function () {
      $scope.loaded = false;
      packagesService.get($scope.filter, $scope.language.key).then(function (res) {
        if (res.data) {
          $scope.packages = res.data;
        }
        $scope.loaded = true;
      }).catch(function (err) {
        toastr.error($filter('translate')('PACKAGES.ERROR_GET_PACKAGES'));
        console.log(err);
      });
    };

    $scope.initPackages();

    $scope.goAdd = function (update) {
      $state.go('app.packages.add');
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.update = function (pack) {
      if (pack.id) {
        $state.go('app.packages.update', {
          id: pack.id
        });
      } else {
        toastr.error($filter('translate')('PACKAGES.ERROR_UPDATE_PACKAGE'));
      }
    };

    $scope.showPopUpDelete = function (pack, index) {
      $scope.packageToDelete = angular.copy(pack);
      $scope.indexToDelete = index;

      $mdDialog.show({
        templateUrl: 'app/main/popup/confirm.html',
        clickOutsideToClose: true,
        controller: 'confirmPopupController',
        locals: {
          content: {
            title: $filter('translate')('PACKAGES.POPUP_DELETE.TITLE'),
            message: $filter('translate')('PACKAGES.POPUP_DELETE.MESSAGE')
          }
        }
      }).then(function () {
        $scope.remove();
      }).catch(function () {});
    };

    $scope.remove = function () {
      packagesService.delete($scope.packageToDelete.id).then(function (res) {
        toastr.success($filter('translate')('PACKAGES.SUCCESS_DELETE'));
        $scope.packages.splice($scope.indexToDelete, 1);
      }).catch(function (err) {
        toastr.error($filter('translate')('PACKAGES.ERROR_DELETE'));
        console.log(err);
      });
    };

  }
})();

(function () {
	'use strict';

	angular.module('app.front').service('NotationsService', ['$q', '$http', function ($q, $http) {
		var baseUrl = './api/rest/notation';
		return {
			getAll: function () {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl,
						method: 'GET',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			setValidate: function (id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/setValid/'+id,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
		};

	}])
})();

(function () {
	'use strict';

	angular.module('app.front').controller('NotationsController', NotationsController);

	function NotationsController($rootScope, NotationsService, $scope, $translate, $location, toastr, $filter, $mdDialog, $state) {
		$scope.loaded = false;
		$scope.notations = [];
		$scope.notationToShow = {};

		$scope.refresh = function () {
			NotationsService.getAll().then(function (res) {
				$scope.notations = res.data;
				$scope.loaded = true;
			}).catch(function (err) {
				$scope.loaded = true;
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};
		$scope.refresh();

		$scope.showComment = function(notation){
			$scope.notationToShow = notation;
			$mdDialog.show({
				templateUrl: 'app/main/notations/popup/comment.popup.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope
			}).then(function () {

			}).catch(function () {

			});
		}

		$scope.hidePopup = function(){
			$mdDialog.hide();
		}

		$scope.setValidate = function(data) {
			NotationsService.setValidate(data.id).then(function (res) {
				$scope.loaded = false;
				data.validate = !data.validate;
				$scope.refresh();
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

	}
})();

(function () {
	'use strict';

	angular.module('app.front').service('modelService', ['$q', '$http', function ($q, $http) {

		var fieldTypes = null;

		return {
			getFieldTypes: function () {
				return $q(function (resolve, reject) {
					if (fieldTypes != null) {
						resolve(fieldTypes);
					} else {
						$http({
							url: './api/rest/model/types',
							method: 'GET',
							params: {
								'_v': new Date().getTime()
							}
						}).then(function (response) {
							fieldTypes = response.data;
							resolve(fieldTypes);
						}).catch(function (error) {
							reject(error);
						});
					}
				});
			},

			getFieldSubTypes: function (_modelType) {
				return $q(function (resolve, reject) {
					$http({
						url: './api/rest/model/subTypes',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'modelType': _modelType
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (error) {
						reject(error);
					});
				});
			},

			listSelectFieldsFromSubType: function (subTypeId, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: './api/rest/model/' + subTypeId + '/selectFieldsSubType',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			listSelectFieldsFromType: function (type, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: './api/rest/model/' + type + '/selectFieldsType',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getCategories: function (baseUrl, lang, eventId) {
				var event = null;
				if (eventId != null) {
					event = eventId;
				}
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/category',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'eventId': event
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getCategoriesOnly: function (baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/only/category',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getCategoriesOnlyBySubType: function (baseUrl, subTypeId, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/only/category/subtype/' + subTypeId,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			saveCategory: function (category, baseUrl, lang, eventId) {
				var event = null;
				if (eventId != null) {
					event = eventId;
				}
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/category',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'eventId': event
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: category,
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			updateCategory: function (category, baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/category',
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: category,
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			removeCategory: function (categoryId, baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/category/' + categoryId,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime(),
							lang: lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			listRequiredFields: function (baseUrl, lang, subTypeId) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/required',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'subTypeId': subTypeId
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			listLinkableField: function (baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/common',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			listExportableField: function (baseUrl, subTypeId, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/exportable',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'subTypeId': subTypeId
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			listModifiableField: function (baseUrl, subTypeId, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/modifiable',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'subTypeId': subTypeId
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			listLinkedField: function (lang) {
				return $q(function (resolve, reject) {
					$http({
						url: '/api/public/sitegen/fields/linked',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			listAllFieldsByCategory: function (modelType, categoryId, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: './api/rest/model/' + modelType + '/field/category/' + categoryId,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			listFieldsByType: function (modelType, lang, eventId) {
				var event = null;
				if (eventId != null) {
					event = eventId;
				}
				return $q(function (resolve, reject) {
					$http({
						url: './api/rest/model/' + modelType + '/field/all',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'eventId': event
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			listFieldsBySubType: function (modelType, subTypeId, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: './api/rest/model/' + modelType + '/field/subtype/' + subTypeId,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			listAllFields: function (lang) {
				return $q(function (resolve, reject) {
					$http({
						url: './api/rest/model/field/all',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getPattern: function (baseUrl, lang, subTypeId) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/drawTokens',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							lang: lang,
							'subTypeId': subTypeId
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			savePattern: function (pattern, baseUrl, subTypeId) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/drawTokens',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'subTypeId': subTypeId
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: pattern
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getCategory: function (subTypeId, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: 'api/rest/model/category/' + subTypeId,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getDisplays: function (subTypeId, lang) {
				var url;
				if (subTypeId == null) {
					url = 'api/rest/model/display/';
				} else {
					url = 'api/rest/model/display/' + subTypeId;
				}
				return $q(function (resolve, reject) {
					$http({
						url: url,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getMultipleDisplays: function (subTypeIds, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: 'api/rest/model/display/multiple',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'ids': subTypeIds
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},


			postDisplay: function (dto, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: 'api/rest/model/display',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: dto,
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			removeDisplay: function (subTypeId, id, lang) {
				var url;

				if (subTypeId == null) {
					url = 'api/rest/model/display/contact/' + id;
				} else {
					url = 'api/rest/model/display/' + subTypeId + '/' + id;
				}

				return $q(function (resolve, reject) {
					$http({
						url: url,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			upDisplay: function (subTypeId, id, lang) {
				var url;

				if (subTypeId == null) {
					url = 'api/rest/model/display/up/contact/' + id;
				} else {
					url = 'api/rest/model/display/up/' + subTypeId + '/' + id;
				}
				return $q(function (resolve, reject) {
					$http({
						url: url,
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			downDisplay: function (subTypeId, id, lang) {
				var url;

				if (subTypeId == null) {
					url = 'api/rest/model/display/down/contact/' + id;
				} else {
					url = 'api/rest/model/display/down/' + subTypeId + '/' + id;
				}

				return $q(function (resolve, reject) {
					$http({
						url: url,
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			setIconDisplay: function (dto) {
				return $q(function (resolve, reject) {
					$http({
						url: 'api/rest/model/display/updateIcon',
						method: 'POST',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: dto
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			upCategory: function (categoryId, baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/category/up/' + categoryId,
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			downCategory: function (categoryId, baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/category/down/' + categoryId,
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			saveField: function (field, baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: field,
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			updateField: function (field, baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/' + field.id,
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: field,
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			moveField: function (field, baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/move',
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: field,
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			activateField: function (fieldId, baseUrl, activated) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/activate/' + fieldId,
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'activated': activated
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},


			upField: function (fieldId, baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/up/' + fieldId,
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			downField: function (fieldId, baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/down/' + fieldId,
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			removeField: function (fieldId, baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/' + fieldId,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			saveSubType: function (dto, baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/subtype',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: dto
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			updateSubType: function (dto, baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/subtype',
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: dto
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getSubType: function (baseUrl, lang, id) {
				return $q(function (resolve, reject) {
					var params = {
						'_v': new Date().getTime(),
						'lang': lang
					};
					$http({
						url: baseUrl + '/subtype/' + id,
						method: 'GET',
						params: params,
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getSubTypes: function (baseUrl, lang, isActivated) {
				return $q(function (resolve, reject) {
					var params = {
						'_v': new Date().getTime(),
						'lang': lang
					};
					if (isActivated != null) {
						params.activated = isActivated;
					}

					$http({
						url: baseUrl + '/subtype',
						method: 'GET',
						params: params,
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			upSubType: function (subTypeId, baseUrl) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/subtype/up/' + subTypeId,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			downSubType: function (subTypeId, baseUrl) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/subtype/down/' + subTypeId,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			removeSubType: function (subTypeId, baseUrl) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/subtype/' + subTypeId,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			listSpecifics: function (baseUrl, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/specific',
						method: 'GET',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			findSpecificByType: function (baseUrl, lang, specificType) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/specific/' + specificType,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			findSpecificsByMultipleTypes: function (baseUrl, lang, specificTypes) {
				console.log(specificTypes);
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/specific/multiple',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: specificTypes
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			findSpecificByTypePublic: function (lang, specificType) {
				return $q(function (resolve, reject) {
					$http({
						url: '/api/public/sitegen/fields/specific/' + specificType,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			saveSpecifics: function (baseUrl, dto) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/field/specific',
						method: 'POST',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: dto
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			listColumnsDrawTokens: function (baseUrl, subTypeId, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/column/drawTokens',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'subTypeId': subTypeId
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			addFieldToColumnDrawToken: function (baseUrl, subTypeId, dto) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/column/drawTokens',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'subTypeId': subTypeId
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: dto
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			deleteColumnDrawToken: function (baseUrl, id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/column/drawTokens/' + id,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			upFieldColumnDrawToken: function (baseUrl, id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/column/drawTokens/up/' + id,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			downFieldColumnDrawToken: function (baseUrl, id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/column/drawTokens/down/' + id,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}




		};
	}]);

})();

(function(){
	'use strict';

	angular.module('app.front').filter('onlyRequired', function(){
		return function (items, required){
			var filtered = [];
			for (var i = 0; i < items.length; i++){
				if (!!required && items[i].required || !required){
					filtered.push(items[i]);
				}
			}
			return filtered;
		};
	});

	angular.module('app.front').filter('simpleTypeRequiredFilter', function(){
		return function(items){
			var filtered = [];
			angular.forEach(items, function(item){
				if (item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' && item.typeChamps !== 'MULTIPLE_SELECT' &&
				item.typeChamps !== 'BOOLEAN'){
					filtered.push(item);
				}
			});
			return filtered;
		};
	});

	angular.module('app.front').filter('typeFieldLinkFilter', function () {
		return function (items) {
			var filtered = [];
			angular.forEach(items, function (item) {
				if (item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE' &&
					item.typeChamps !== 'BOOLEAN') {
					filtered.push(item);
				}
			});
			return filtered;
		};
	});
})();
(function () {
	'use strict';

	angular.module('app.front').directive('modelBuilder', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
		return {
			restrict: 'E',
			scope: {
				modelType: '=modelType',
				baseUrl: '=baseUrl',
				categories: '=categories',
				parentId: '=parentId',
				level: '=level',
				language: '=language',
				helpModelTitle: '=helpModelTitle',
				helpModelContent: '=helpModelContent',
				eventId: '=eventId'
			},
			templateUrl: 'app/main/models/model.html',
			controller: 'modelCtrl',
			link: function (element, attrs) {
				return function (scope, element, attrs) {
					function compile() {
						var content;
						content = element.contents().remove();
						var directive = $compile(content);
						element.append(directive(scope, function ($compile) {
							return $compile;
						}));
					}
					scope.$watch('categories', function () {
						compile();
					});
				};
			}
		};
	}]);

	angular.module('app.front').directive('modelType', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
		return {
			restrict: 'E',
			scope: {
				baseUrl: '=baseUrl',
				thisModel: '=thisModel',
				types: '=types',
				language: '=language',
			},
			templateUrl: 'app/main/models/type.html',
			controller: 'modelCtrl',
			link: function (element, attrs) {
				return function (scope, element, attrs) {
					function compile() {
						var content;
						content = element.contents().remove();
						var directive = $compile(content);
						element.append(directive(scope, function ($compile) {
							return $compile;
						}));
					}
					scope.$watch('types', function () {
						compile();
					});
				};
			}
		};
	}]);

	angular.module('app.front').directive('drawTokenBuilder', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
		return {
			restrict: 'E',
			scope: {
				baseUrl: '=baseUrl',
				modelType: '=modelType',
				drawTokenTitle: '=drawTokenTitle',
				helpDrawTokenTitle: '=helpDrawTokenTitle',
				helpDrawTokenContent: '=helpDrawTokenContent',
				language: '=language',
				subTypeId: '=subTypeId'
			},
			templateUrl: 'app/main/models/draw_token.html',
			controller: 'drawTokenCtrl',
			link: function (element, attrs) {

				return function (scope, element, attrs) {
					function compile() {
						var content;
						content = element.contents().remove();
						var directive = $compile(content);
						element.append(directive(scope, function ($compile) {
							return $compile;
						}));
					}
					compile();

					scope.simpleTypeRequiredFilter = function (field) {
						return field.typeChamps !== 'USERS' && field.typeChamps !== 'MULTIPLE_SELECTION';
					};

				};
			}
		};
	}]);

	angular.module('app.front').directive('simpleModelBuilder', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
		return {
			restrict: 'E',
			scope: {
				modelName: '=modelName',
				modelType: '=modelType',
				modelTitle: '=modelTitle',
				baseUrl: '=baseUrl',
				fields: '=fields',
				enumType: '@enumType',
				helpModelTitle: '=helpModelTitle'
			},
			templateUrl: 'app/main/models/simple_model.html',
			controller: 'simpleModelCtrl',
			compile: function (element, attrs) {
				var content, directive;
				content = element.contents().remove();
				return function (scope, element, attrs) {
					var directive = $compile(content);
					element.append(directive(scope, function ($compile) {
						return $compile;
					}));
				};
			}
		};
	}]);

	angular.module('app.front').directive('helpModelBuilder', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
		return {
			restrict: 'E',
			scope: {
				helpModelTitle: '=helpModelTitle',
				helpModelContent: '=helpModelContent'
			},
			templateUrl: 'app/main/models/help_model.html'
		};
	}]);

	angular.module('app.front').directive('helpDrawTokenBuilder', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
		return {
			restrict: 'E',
			scope: {
				helpDrawTokenTitle: '=helpDrawTokenTitle',
				helpDrawTokenContent: '=helpDrawTokenContent'
			},
			templateUrl: 'app/main/models/help_draw_token.html'
		};
	}]);

	angular.module('app.front').directive('nooInfosCategory', ['$compile', '$http', '$filter', function ($compile, $http, $filter) {
		return {
			restrict: 'E',
			templateUrl: 'app/main/models/infos_category.html',
			scope: {
				category: '=ngModel',
				level: '=level',
				edition: '=edition',
				formName: '=formName',
				subType: '=subType',
				modelType: '=modelType',
				parent: '=?parent',
				abstractModel: '=model'
			},
			compile: function (element, attrs) {
				var content, directive;
				content = element.contents().remove();
				return function (scope, element, attrs) {
					scope.nextLevel = scope.level + 1;
					directive || (directive = $compile(content));
					element.append(directive(scope, function ($compile) {
						return $compile;
					}));
				};
			}
		};
	}]);

	angular.module('app.front').directive('nooInput', function ($compile, $timeout, $parse, $filter, $window, URL, companyService, contactService, inscriptionService, logisticService) {

		var linker = function (scope, element, attrs) {
			if (scope.edition && (scope.model.typeChamps === 'FILE' || scope.model.typeChamps === 'IMAGE')) {
				$timeout(function () {
					var input = element[0].querySelector('#genericField_file_' + scope.model.id + '_' + scope.model.index);
					angular.element(input).on('change', function () {
						if (input.files != null) {
							if (scope.modelType === 'INSCRIPTION_MODEL') {
								scope.$emit('inscriptionUpdated', { model: scope.model, inscription: scope.abstractModel });
							} else {
								scope.$emit('modelUpdated', { model: scope.model });
							}
						}
					});

				});
			}

			if (scope.model.typeChamps === 'IMAGE') {
				if (scope.model.location != null && scope.model.location !== '') {
					scope.model.src = URL.alternatedocroots + '/' + scope.model.location;
				} else {
					scope.model.src = '';
				}
			}
			scope.download = function () {
				if (scope.modelType === 'COMPANY_MODEL') {
					$window.location.href = companyService.downloadValuedFile(scope.model.id);
				}
				if (scope.modelType === 'CONTACT_MODEL') {
					$window.location.href = contactService.downloadValuedFile(scope.model.id);
				}
				if (scope.modelType === 'INSCRIPTION_MODEL') {
					$window.location.href = inscriptionService.downloadValuedFile(scope.model.id, scope.abstractModel.id);
				}
				if (scope.modelType === 'LOGISTIC_MODEL') {
					$window.location.href = logisticService.downloadValuedFile(scope.model.id, scope.abstractModel.id);
				}
			};
			if (scope.edition) {
				scope.$watch('model', function (newModel, oldModel) {
					if (newModel.value !== oldModel.value || newModel.values !== oldModel.values || newModel.dateTime != null) {
						/* LIVE UPDATE */
						if (scope.modelType === 'INSCRIPTION_MODEL') {
							scope.$emit('inscriptionUpdated', { model: scope.model, inscription: scope.abstractModel });
						} else {
							scope.$emit('modelUpdated', { model: scope.model });
						}
					}
				}, true);
			}
		};



		return {
			restrict: 'E',
			replace: true,
			link: linker,
			templateUrl: 'app/main/models/input.html',
			scope: {
				content: '@',
				index: '@',
				model: '=ngModel',
				edition: '=edition',
				formName: '=',
				init: '&initFn',
				subType: '=subType',
				bigDisplayArea: '=',
				modelType: '=modelType',
				abstractModel: '=model'
			}
		};
	});

	angular.module('app.front').directive('nooInfosModel', ['$compile', '$filter', 'toastr', function ($compile, $filter, toastr) {
		return {
			restrict: 'E',
			templateUrl: 'app/main/models/infos_model.html',
			scope: {
				categories: '=ngModel',
				edition: '=edition',
				formName: '=formName',
				subType: '=subType',
				modelType: '=modelType',
				subTypes: '=subTypes',
				model: '=model',
				showSettings: '=showSettings',
			},
			controller: 'infosModelCtrl',
			compile: function (element, attrs) {
				var content, directive;
				content = element.contents().remove();
				return function (scope, element, attrs) {

					directive || (directive = $compile(content));
					element.append(directive(scope, function ($compile) {
						return $compile;
					}));
				};
			}
		};
	}]);
})();

(function () {
	'use strict';

	angular.module('app.front').controller('modelCtrl',
		function ($rootScope, $scope, $q, $state, $filter, $timeout, $mdDialog, toastr, modelService) {
			$scope.loaded = false;
			$scope.types = [];
			$scope.loading = false;


			$scope.$on('categoriesLoaded', function () {
				$scope.loaded = true;
				if ($scope.modelType === 'COMPANY_MODEL') {
					modelService.getSubTypes($scope.baseUrl, $scope.language.key, null).then(function (response) {
						//TYPE DE SOCIETE
						$scope.types = response.data;
					}).catch(function () {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});


				}
			});




			$scope.newType = {};

			window.mdSelectOnKeyDownOverride = function (event) {
				event.stopPropagation();
			};

			$scope.newCategory = {
				size: 100
			};
			modelService.getFieldTypes().then(function (data) {
				$scope.enumTypes = data;
			}).catch(function (error) {
				$scope.enumTypes = [];
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});


			$scope.refreshRequiredFields = function (withPattern) {
				modelService.listRequiredFields($scope.baseUrl, $scope.language.key).then(function (response) {
					$rootScope.$broadcast('ChampsListRequired', response.data);
					if (withPattern) {
						modelService.getPattern($scope.baseUrl, $scope.language.key).then(function (response) {
							$rootScope.$broadcast('DrawTokenList', response.data);
						}).catch(function (response) {
							toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
						});
					}
				}).catch(function (response) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			};

			$scope.saveCategory = function (form) {
				if (!!$scope.newCategory.name && $scope.newCategory.name !== '') {
					$scope.newCategory.index = $scope.categories.length + 1;
					if (!angular.isUndefined($scope.parentId)) {
						$scope.newCategory.parentId = $scope.parentId;
					}
					modelService.saveCategory($scope.newCategory, $scope.baseUrl, $scope.language.key, $scope.eventId).then(function (response) {
						toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_ADD_CAT'));
						$scope.newCategory.id = response.data;
						$scope.newCategory.fields = [];
						$scope.categories.push(angular.copy($scope.newCategory));
						$scope.newCategory = {
							size: 100
						};
						form.$setUntouched();
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};

			$scope.updateCategory = function (category) {
				if (!!category.name && category.name !== '') {
					modelService.updateCategory(category, $scope.baseUrl, $scope.language.key).then(function (response) {
						toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE_CAT'));
						category.active = false;
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};

			$scope.removeCategory = function (index, category) {
				var content = {
					title: $filter('translate')('SETTINGS.DATABASE.MODELS.DELETE_CAT'),
					message: $filter('translate')('SETTINGS.DATABASE.MODELS.CONFIRM_DELETE_CAT')
				};
				$rootScope.openConfirmPopup(content).then(function () {
					$rootScope.$broadcast('HandDrawTokenList');
					modelService.removeCategory(category.id, $scope.baseUrl, $scope.language.key).then(function (response) {
						toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_DELETE_CAT'));
						$scope.categories = response.data;
						$scope.refreshRequiredFields(true);
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}).catch(function () {

				});
			};

			$scope.upCategory = function (category) {
				if (category.index > 1) {
					modelService.upCategory(category.id, $scope.baseUrl, $scope.language.key).then(function (response) {
						$scope.categories = response.data;
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};

			$scope.downCategory = function (category) {
				if (category.index !== $scope.categories.length) {
					modelService.downCategory(category.id, $scope.baseUrl, $scope.language.key).then(function (response) {
						$scope.categories = response.data;
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};

			$scope.addItemToFieldListType = function (item, list) {
				list.push({
					value: angular.copy(item.value),
					color: angular.copy(item.color),
					index: list.length + 1
				});
			};

			$scope.removeItemFromFieldListType = function (item, list) {
				var initialIndex = 1;
				for (var i = 0; i < list.length; i++) {
					if (list[i].index === item.index) {
						list.splice(i, 1);
						break;
					}
				}
				angular.forEach(list, function (item, thisIndex) {
					item.index = initialIndex;
					initialIndex++;
				});
			};

			$scope.upFieldListTypeItem = function (item, list) {
				var isDone;
				angular.forEach(list, function (_item) {
					if (!isDone && _item.index === item.index - 1) {
						item.index = angular.copy(_item.index);
						_item.index = angular.copy(_item.index + 1);
						isDone = true;
					}
				});
			};

			$scope.downFieldListTypeItem = function (item, list) {
				var isDone;
				angular.forEach(list, function (_item) {
					if (!isDone && _item.index === item.index + 1) {
						_item.index = angular.copy(item.index);
						item.index = angular.copy(item.index + 1);
						isDone = true;
					}
				});
			};

			$scope.saveChamps = function (category, form) {
				if (category.newChamps.libelle && category.newChamps.libelle !== '') {
					category.newChamps.index = category.fields.length + 1;
					modelService.saveField(category.newChamps, $scope.baseUrl, $scope.language.key).then(function (response) {
						toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_ADD_FIELD'));
						if (category.newChamps.typeChamps === 'MULTIPLE_SELECT' || category.newChamps.typeChamps === 'LIST_SELECT') {
							category.newChamps.id = response.data.id;

							for (var i = 0; i < category.newChamps.listFieldsDTO.length; i++) {
								for (var j = 0; j < response.data.listFieldsDTO.length; j++) {
									if (response.data.listFieldsDTO[j].index === category.newChamps.listFieldsDTO[i].index) {
										category.newChamps.listFieldsDTO[i].id = response.data.listFieldsDTO[j].id;
										break;
									}
								}
							}
						} else {
							category.newChamps.id = response.data;
						}

						category.newChamps.activated = true;
						category.fields.push(angular.copy(category.newChamps));
						if (category.newChamps.required) {
							$scope.refreshRequiredFields(false);
						}
						category.newChamps = {
							idCategory: category.id,
							typeChamps: 'STRING',
							listFieldsDTO: [],
							modelType: $scope.modelType,
							size: 100
						};
						if (!angular.isUndefined($scope.enumSubTypes)) {
							if ($scope.enumSubTypes.length !== 0) {
								category.newChamps.fieldSubType = $scope.enumSubTypes[0].type;
							}
						}
						form.$setUntouched();
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};

			$scope.enabledFieldUpdating = function (champs) {
				$scope.champsTmp = angular.copy(champs);
				champs.active = true;
			};

			$scope.cancelFieldUpdating = function (id, champsList) {
				var _found = false;
				angular.forEach(champsList, function (item, index) {
					if (!_found && item.id === id) {
						champsList[index] = angular.copy($scope.champsTmp);
						_found = true;
					}
				});
			};

			$scope.updateChamps = function (champs) {
				$rootScope.$broadcast('HandDrawTokenList');
				if (champs.libelle && champs.libelle !== '' && champs.id) {
					modelService.updateField(champs, $scope.baseUrl, $scope.language.key).then(function (response) {
						if (champs.typeChamps === 'MULTIPLE_SELECT' || champs.typeChamps === 'LIST_SELECT') {
							for (var i = 0; i < champs.listFieldsDTO.length; i++) {
								for (var j = 0; j < response.data.listFieldsDTO.length; j++) {
									if (response.data.listFieldsDTO[j].index === champs.listFieldsDTO[i].index) {
										champs.listFieldsDTO[i].id = response.data.listFieldsDTO[j].id;
										break;
									}
								}
							}
						}
						toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE_FIELD'));
						champs.active = false;
						$scope.refreshRequiredFields(true);
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};

			$scope.upChamps = function (category, champs) {
				if (champs.index > 1) {
					modelService.upField(champs.id, $scope.baseUrl, $scope.language.key).then(function (response) {
						category.fields = response.data;
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};

			$scope.downChamps = function (category, champs) {
				if (champs.index < category.fields.length) {
					modelService.downField(champs.id, $scope.baseUrl, $scope.language.key).then(function (response) {
						category.fields = response.data;
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};

			$scope.openMoveChamps = function (category, champs) {
				$mdDialog.show({
					templateUrl: 'app/main/models/move_field.html',
					controller: 'moveFieldController',
					clickOutsideToClose: true,
					locals: {
						category: category,
						champs: champs,
						properties: {
							baseUrl: $scope.baseUrl,
							lang: $scope.language.key
						}
					}
				}).then(function () {
					$scope.$emit('refreshCategories');
				}).catch(function () {

				});
			};

			$scope.removeChamps = function (category, champs) {
				var content = {
					title: $filter('translate')('SETTINGS.DATABASE.MODELS.DELETE_FIELD'),
					message: $filter('translate')('SETTINGS.DATABASE.MODELS.CONFIRM_DELETE_FIELD')
				};
				$rootScope.openConfirmPopup(content).then(function () {
					$rootScope.$broadcast('HandDrawTokenList');
					modelService.removeField(champs.id, $scope.baseUrl, $scope.language.key).then(function (response) {
						category.fields = response.data;
						$scope.refreshRequiredFields(true);
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}).catch(function () {

				});

			};

			$scope.activateChamps = function (champsId, activated) {
				modelService.activateField(champsId, $scope.baseUrl, activated).then(function (response) {

				}).catch(function (response) {

				});
			};


			$scope.saveType = function () {
				$scope.newType.index = $scope.types.length + 1;
				modelService.saveSubType($scope.newType, $scope.baseUrl, $scope.language.key).then(function (response) {
					$scope.newType.id = response.data;
					$scope.types.push(angular.copy($scope.newType));
					$scope.newType = {};
					$scope.$emit('refreshCompanyTypes');
				}).catch(function (response) {

				});
			};

			$scope.updateType = function (type) {
				modelService.updateSubType(type, $scope.baseUrl, $scope.language.key).then(function (response) {
					type.active = false;
					$scope.$emit('refreshCompanyTypes');
				}).catch(function (response) {

				});
			};

			$scope.upType = function (type, index) {
				if (index >= 1) {
					$scope.loading = true;
					modelService.upSubType(type.id, $scope.baseUrl, $scope.language.key).then(function (response) {
						$scope.types = response.data;
						$scope.$emit('refreshCompanyTypes');
						$scope.loading = false;
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
						$scope.loading = false;
					});
				}
			};

			$scope.downType = function (type, last) {
				if (!last) {
					$scope.loading = true;
					modelService.downSubType(type.id, $scope.baseUrl, $scope.language.key).then(function (response) {
						$scope.types = response.data;
						$scope.$emit('refreshCompanyTypes');
						$scope.loading = false;
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
						$scope.loading = false;
					});
				}
			};

			$scope.removeType = function (index, type) {
				var content = {
					title: $filter('translate')('SETTINGS.DATABASE.TYPES.DELETE'),
					message: $filter('translate')('SETTINGS.DATABASE.TYPES.CONFIRM_DELETE')
				};
				$rootScope.openConfirmPopup(content).then(function () {
					modelService.removeSubType(type.id, $scope.baseUrl).then(function (response) {
						$scope.types.splice(index, 1);
						toastr.success($filter('translate')('SETTINGS.DATABASE.TYPES.SUCCESS_DELETE'));
						$scope.$emit('refreshCompanyTypes');
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}).catch(function () {

				});
			};

			$scope.filterConfig = function (subType) {
				$state.go("app.database.types.research_page_creation", {
					modelType: $scope.thisModel,
					subTypeId: subType.id
				});
			};

		});

	angular.module('app.front').controller('simpleModelCtrl',
		function ($rootScope, $scope, $http, $state, $filter, $timeout, toastr, modelService) {

			$scope.newField = {};
			$scope.showHelp = false;

			$scope.saveField = function () {
				if ($scope.newField.libelle && $scope.newField.libelle !== '') {
					$scope.newField.index = $scope.fields.length + 1;
					$scope.newField.fieldSubType = $scope.enumType;
					modelService.saveField($scope.newField, $scope.baseUrl).then(function (response) {
						toastr.success($scope.modelName + ' créé!');
						if ($scope.newField.typeChamps === 'MULTIPLE_SELECT' || $scope.newField.typeChamps === 'LIST_SELECT') {
							$scope.newField.id = response.data.id;

							for (var i = 0; i < $scope.newField.listFieldsDTO.length; i++) {
								for (var j = 0; j < response.data.listFieldsDTO.length; j++) {
									if (response.data.listFieldsDTO[j].index === $scope.newField.listFieldsDTO[i].index) {
										$scope.newField.listFieldsDTO[i].id = response.data.listFieldsDTO[j].id;
										break;
									}
								}
							}
						} else {
							$scope.newField.id = response.data;
						}
						$scope.fields.push(angular.copy($scope.newField));
						$scope.newField = {};
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};

			$scope.updateField = function (field) {
				if (field.libelle && field.libelle !== '' && field.id) {
					modelService.updateField(field.id, $scope.baseUrl).then(function (response) {
						toastr.success($scope.modelName + ' modifié!');
						if (field.typeChamps === 'MULTIPLE_SELECT' || field.typeChamps === 'LIST_SELECT') {
							for (var i = 0; i < field.listFieldsDTO.length; i++) {
								for (var j = 0; j < response.data.listFieldsDTO.length; j++) {
									if (response.data.listFieldsDTO[j].index === field.listFieldsDTO[i].index) {
										field.listFieldsDTO[i].id = response.data.listFieldsDTO[j].id;
										break;
									}
								}
							}
						}
						field.active = false;
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};

			$scope.upField = function (field) {
				if (field.index > 1) {
					modelService.upField(field.id, $scope.baseUrl).then(function (response) {
						$scope.fields = response.data;
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};

			$scope.downField = function (field) {
				if (field.index < $scope.fields.length) {
					modelService.downField(field.id, $scope.baseUrl).then(function (response) {
						$scope.fields = response.data;
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};

			$scope.removeField = function (field) {
				modelService.removeField(field.id, $scope.baseUrl).then(function (response) {
					$scope.fields = response.data;
				}).catch(function (response) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			};
		});

	angular.module('app.front').controller('drawTokenCtrl',
		function ($rootScope, $scope, $http, $state, $filter, $timeout, toastr, modelService, $translate, BlogService, statisticsService) {

			$scope.handUser = true;
			$scope.updateRequireToken = true;
			$scope.tokensModified = false;
			$scope.champsListRequired = [];
			$scope.drawTokenList = [];

			$rootScope.$on('HandDrawTokenList', function (event, data) {
				$scope.handUser = false;
				$scope.updateRequireToken = false;
			});

			$rootScope.$on('ChampsListRequired', function (event, data) {
				$scope.champsListRequired = data;
			});

			$rootScope.$on('DrawTokenList', function (event, data) {
				$scope.drawTokenList = data;
			});

			$scope.initDrawToken = function () {
				if ($scope.language != null && $scope.language.key != null) {
					if ($scope.subTypeId != null) {
						modelService.listFieldsBySubType($scope.modelType, $scope.subTypeId, $scope.language.key).then(function (response) {
							$scope.champsListRequired = response.data;
						}).catch(function (response) {
							toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
						});
					} else {
						modelService.listRequiredFields($scope.baseUrl, $scope.language.key).then(function (response) {
							$scope.champsListRequired = response.data;
						}).catch(function (response) {
							toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
						});
					}


					modelService.getPattern($scope.baseUrl, $scope.language.key, $scope.subTypeId).then(function (response) {
						$scope.drawTokenList = response.data;
					}).catch(function (response) {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					});
				}
			};
			$scope.$watch('language.key', function () {
				$scope.initDrawToken();
			});


			$scope.addPatternToken = function () {
				$scope.tokensModified = true;
				$scope.drawTokenList.push({
					prefix: '',
					suffix: '',
					index: $scope.drawTokenList.length
				});
			};

			$scope.calculatedPattern = function () {
				if (!$scope.drawTokenList || $scope.drawTokenList.length < 1) {
					return 'AUCUN';
				}
				var pattern = '';
				var sortedList = $filter('orderBy')($scope.drawTokenList, 'index', false);
				for (var i = 0; i < sortedList.length; i++) {
					var field = sortedList[i].field != null && sortedList[i].field ? sortedList[i].field.libelle : '';
					pattern = pattern + sortedList[i].prefix + field + sortedList[i].suffix;
				}
				return pattern;
			};

			$scope.changeElement = function () {
				if ($scope.handUser && $scope.updateRequireToken) {
					$scope.tokensModified = true;
				}
				$scope.updateRequireToken = true;
				$scope.handUser = true;
			};

			$scope.saveDrawTokens = function () {
				modelService.savePattern($scope.drawTokenList, $scope.baseUrl, $scope.subTypeId).then(function (response) {
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_ADD_PATTERN'));
					$scope.tokensModified = false;
				}).catch(function (response) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			};

			$scope.cancelModifTokens = function () {
				modelService.getPattern($scope.baseUrl, $scope.language.key, $scope.subTypeId).then(function (response) {
					$scope.drawTokenList = response.data;
					$scope.tokensModified = false;
				}).catch(function (response) {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			};

			$scope.deleteToken = function (index) {
				$scope.tokensModified = true;
				$scope.drawTokenList = $filter('orderBy')($scope.drawTokenList, 'index');
				$scope.drawTokenList.splice(index, 1);
				angular.forEach($scope.drawTokenList, function (drawToken, key) {
					if (drawToken.index > index) {
						drawToken.index--;
					}
				});
			};

		});

	angular.module('app.front').controller('infosModelCtrl',
		function ($rootScope, $scope, $http, $state, $filter, $timeout, $translate, $mdDialog, toastr, modelService, associationService, inscriptionStatusService, inscriptionSubCategoryService, logisticalStatusService, SitesManagementService, BlogService, statisticsService, companyService) {
			$scope.tags = [];
			$scope.countries = [];
			$scope.regions = [];
			$scope.search = {
				tag: '',
				country: ''
			};
			var initSubTypes = function () {
				//Présélectionner le type de société dans lequel on est (création d'une société)
				if ($scope.model != null && angular.isArray($scope.subTypes) && !$scope.edition) {
					for (var i = 0; i < $scope.subTypes.length; i++) {
						if ($scope.subTypes[i].id === $scope.subType) {
							$scope.model['type_' + $scope.subTypes[i].id] = true;
							$scope.model.subTypesIds.push($scope.subTypes[i].id);
							break;
						}
					}
				}

				//Présélectionner les types d'une société (modification d'une société)
				if ($scope.edition && $scope.model != null && angular.isArray($scope.model.subTypesIds) && angular.isArray($scope.subTypes)) {
					for (var j = 0; j < $scope.subTypes.length; j++) {
						if ($scope.model.subTypesIds.lastIndexOf($scope.subTypes[j].id) > -1) {
							$scope.model['type_' + $scope.subTypes[j].id] = true;
						}
					}
				}
			};


			$scope.findAllTags = function (lang) {

				BlogService.findAllTags(lang).then(function (tags) {
					$scope.tags = tags.data;

				}).catch(function (data) {
					console.log(data)
				});
			};



			$scope.findAllCountries = function (lang) {

				statisticsService.getNationalities(lang).then(function (countries) {
					$scope.countries = countries.data;

				}).catch(function (data) {
					console.log(data)
				});
			};

			$scope.findAllRegions = function (lang) {

				statisticsService.getRegions(lang).then(function (regions) {
					$scope.regions = regions.data;

				}).catch(function (data) {
					console.log(data)
				});
			};

			$scope.fieldsSelected = function (fields, selectedFields) {
				var res = [];
				if ($scope.model && !$scope.model.tags) {
					$scope.model.tags = [];
				}
				if ($scope.model && !$scope.model.countries) {
					$scope.model.countries = [];
				}
				if ($scope.model && !$scope.model.regions) {
					$scope.model.regions = [];
				}
				if (angular.isArray(selectedFields)) {
					var fieldIds = selectedFields.map(function (item) {
						return item.id;
					});
					angular.forEach(fields, function (item) {
						if (fieldIds.lastIndexOf(item.id) === -1) {
							res.push(item);
						}
					});
					return res;
				} else {
					return fields;
				}
			};

			$scope.addField = function (chip, fields, type) {
				if (chip == null || chip.id == null) {
					fields.splice(fields.length - 1, 1);
				} else {
					if (type == "TAGS") {
						$scope.updateTags();
					} else if (type == 'COUNTRIES') {
						$scope.updateCountries();
					} else {
						$scope.updateRegions();
					}

				}
			};

			var checkRequired = function (categories) {
				if (categories) {
					for (var i = 0; i < categories.length; i++) {
						if (!categories[i].required) {
							var required = false;

							for (var j = 0; j < categories[i].subCategories.length; j++) {
								if (categories[i].subCategories[j].required) {
									required = true;
								}
							}

							if (required) {
								categories[i].required = true;
							}
						}
					}
				}
			};

			$scope.firstLevel = 0;
			$scope.status = [];
			var categoriesUnfiltered = null;

			var hideFields = function (categories) {
				if (categories != null && $scope.model != null) {
					for (var i = 0; i < categories.length; i++) {
						var category = categories[i];
						if (angular.isArray(category.subCategories)) {
							hideFields(category.subCategories);
						}
						var required = false;

						for (var j = 0; j < category.values.length; j++) {
							var hide = true;

							if (category.values[j].required) {
								required = true;
							}

							if (category.values[j].subTypesIds == null || category.values[j].subTypesIds.length < 1 || $scope.model.subTypesIds == null) {
								hide = false;
							} else {
								for (var k = 0; k < category.values[j].subTypesIds.length; k++) {
									if ($scope.model.subTypesIds.lastIndexOf(category.values[j].subTypesIds[k]) > -1) {
										hide = false;
										break;
									}
								}
							}
							category.values[j].hide = hide;
						}

						if (required) {
							category.required = true;
						} else {
							category.required = false;
						}
					}
				}

				checkRequired(categories);
			};

			var filterCategory = function (category) {
				if (!angular.isUndefined(category.subCategories)) {
					angular.forEach(category.subCategories, function (subCategory) {
						filterCategory(subCategory);
					});
				}
				if (category.values.length === 0) {
					if (angular.isArray(category.subCategories) && category.subCategories.length > 0) {
						var allIsEmpty = true;
						angular.forEach(category.subCategories, function (subCategory) {
							if (allIsEmpty && subCategory.values.length !== 0) {
								allIsEmpty = false;
							}
						});
						if (allIsEmpty) {
							category.isEmpty = true;
						}
					} else {
						category.isEmpty = true;
					}
				} else {
					var allIsHided = true;
					for (var i = 0; i < category.values.length; i++) {
						if (!category.values[i].hide && !category.values[i].hidden) {
							allIsHided = false;
						}
					}
					category.isEmpty = allIsHided;
				}
			};
			$scope.updateSubTypes = function (type, fromInput) {
				if ($scope.model['type_' + type.id]) {
					$scope.model.subTypesIds.push(type.id);
					if (fromInput && $scope.edition) {
						/* LIVE UPDATE */
						$scope.$emit('subTypeUpdated', {
							model: $scope.model
						});
					}
				} else {
					if ($scope.model.subTypesIds.length === 1) {
						$scope.model['type_' + type.id] = true;
						if (fromInput) {
							toastr.error($filter('translate')('COMPANIES.TYPE_REQUIRED'));
						}
					} else {
						var index = $scope.model.subTypesIds.lastIndexOf(type.id);
						if (index > -1) {
							$scope.model.subTypesIds.splice(index, 1);
							if (fromInput && $scope.edition) {
								/* LIVE UPDATE */
								$scope.$emit('subTypeUpdated', {
									model: $scope.model
								});
							}
						}
					}
				}
			};

			$scope.updateAssociation = function () {
				$scope.$emit('associationUpdated', {
					model: $scope.model
				});
			};

			$scope.updateSite = function () {
				$scope.$emit('siteUpdated', {
					model: $scope.model
				});
			};

			$scope.updateTags = function () {


				$scope.$emit('tagsUpdated', {
					model: $scope.model
				});
			}

			$scope.updateCountries = function () {


				$scope.$emit('countriesUpdated', {
					model: $scope.model
				});
			}

			$scope.updateRegions = function () {


				$scope.$emit('regionsUpdated', {
					model: $scope.model
				});
			}

			$scope.updateActive = function () {
				/* LIVE UPDATE */
				$scope.$emit('activatedUpdated', {
					model: $scope.model
				});
			};

			$scope.updateChecked = function () {
				/* LIVE UPDATE */
				$scope.$emit('checkedUpdated', {
					model: $scope.model
				});
			};

			$scope.updateSubCategory = function () {
				/* LIVE UPDATE */
				$scope.$emit('subCategoryUpdated', {
					model: $scope.model
				});
			};

			$scope.updateLogisticStatus = function () {
				/* LIVE UPDATE */
				$scope.$emit('logisticalStatusUpdated', {
					model: $scope.model
				});
			};

			$scope.updateInscriptionStatus = function () {
				/* LIVE UPDATE */
				$scope.$emit('inscriptionStatusUpdated', {
					model: $scope.model
				});
			};

			$scope.updateStatus = function () {
				/* LIVE UPDATE */
				$scope.$emit('statusUpdated', {
					model: $scope.model
				});
			};

			if ($scope.subType != null && $scope.model != null) {
				$scope.updateSubTypes({
					id: $scope.subType
				});
			}

			$scope.$watch('categories', function (newCategories) {
				if (!angular.isUndefined(newCategories)) {
					hideFields(newCategories);
					if (!angular.isUndefined($scope.categories.subCategories)) {
						angular.forEach($scope.categories.subCategories, function (subCategory) {
							filterCategory(subCategory);
						});
					}
					angular.forEach($scope.categories, function (category) {
						filterCategory(category);
					});
				}
			});

			$scope.$on('refreshCategoriesDirective', function (event, data) {
				$scope.categories = angular.copy(data);
				hideFields($scope.categories);
				if (!angular.isUndefined($scope.categories.subCategories)) {
					angular.forEach($scope.categories.subCategories, function (subCategory) {
						filterCategory(subCategory);
					});
				}
				angular.forEach($scope.categories, function (category) {
					filterCategory(category);
				});
			});

			$scope.$watchGroup(['model', 'subTypes'], function () {
				initSubTypes();
				hideFields($scope.categories);
			});

			$scope.$watchCollection('model.subTypesIds', function () {
				hideFields($scope.categories);
			});

			if ($scope.modelType === 'COMPANY_MODEL') {
				associationService.findAll().then(function (response) {
					$scope.associations = response.data;
				}).catch(function () {

				});
				SitesManagementService.findAll('sites').then(function (response) {
					$scope.sites = response.data;
				}).catch(function () {

				});

				$scope.findAllTags($translate.preferredLanguage());
				$scope.findAllCountries($translate.preferredLanguage());
				$scope.findAllRegions($translate.preferredLanguage());


				companyService.listStatus().then(function (response) {
					$scope.status = response.data;
				}).catch(function () {

				});
			}

			if ($scope.modelType === 'INSCRIPTION_MODEL') {
				inscriptionStatusService.list($translate.preferredLanguage()).then(function (response) {
					$scope.inscriptionStatuses = response.data;
				}).catch(function () {

				});

				inscriptionSubCategoryService.list($translate.preferredLanguage()).then(function (response) {
					$scope.subCategories = response.data;
				}).catch(function () {

				});

				logisticalStatusService.list($translate.preferredLanguage()).then(function (response) {
					$scope.logistics = response.data;
				}).catch(function () {

				});
			}
		});

	angular.module('app.front').controller('moveFieldController', function ($rootScope, $scope, $mdDialog, $filter, category, champs, properties, toastr, modelService) {

		$scope.currentCategory = angular.copy(category);
		$scope.champs = angular.copy(champs);

		modelService.getCategoriesOnly(properties.baseUrl, properties.lang).then(function (response) {
			$scope.categories = response.data;
		}).catch(function (response) {

		});

		$scope.update = function () {
			modelService.moveField($scope.champs, properties.baseUrl, properties.lang).then(function (response) {
				toastr.success($filter('translate')('SETTINGS.DATABASE.MODELS.MOVE_FIELD_SUCCESS'));
				var update = {
					oldCategoryId: champs.categoryId,
					newCategoryId: $scope.champs.categoryId
				};
				$mdDialog.hide(update);
			}).catch(function () {

			});
		};

		$scope.hidePopup = function () {
			$mdDialog.cancel();
		};

	});
})();

(function () {
  'use strict';

  angular.module('app.front').controller('fieldsModelsController',
    function ($rootScope, $scope, $http, $state, $filter, $timeout, $mdDialog, toastr, modelService, STORAGE_PREFIX, DISPLAY_MODELS_ICONS) {
      $scope.category = {};
      $scope.fieldsAvalaible = [];
      $scope.fields = [];
      $scope.displaysModels = [];
      $scope.fieldToAdd = null;
      $scope.DISPLAY_MODELS_ICONS = DISPLAY_MODELS_ICONS;
      var dataReady = false;

      init();

      $scope.addField = function () {
        if (!$scope.fieldToAdd) {
          toastr.error('Vous devez sélectionner un champ à ajouter');
          return;
        }
        var dto = {
          categoryID: $state.params.categoryId,
          fieldModel: angular.copy($scope.fieldToAdd)
        };
        $scope.fieldToAdd = null;
        modelService.postDisplay(dto, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
          init();
        }).catch(function (err) {
          console.log(err);
          toastr.error('Erreur lors de l\'ajout du champs d\'affichage');
        });
      };

      $scope.removeField = function(field) {
        if (!field || !field.id || !field.categoryID) {
          toastr.error('Erreur avec ce champ, veuillez recharger la page SVP');
          return;
        }

        modelService.removeDisplay(field.categoryID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function(res) {
          console.log($scope.category.fields);
          if (res.data) {
            $scope.displaysModels = res.data;
          }

          filterFields();
        }).catch(function(err) {
          console.log(err);
          toastr.error('Erreur lors de la suppression du champs d\'affichage');
        });
      };

      $scope.goUp = function (field) {
        if (!field || !field.id || !field.categoryID) {
          toastr.error('Erreur avec ce champ, veuillez recharger la page SVP');
          return;
        }

        modelService.upDisplay(field.categoryID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function(res) {
          console.log($scope.category.fields);
          if (res.data) {
            $scope.displaysModels = res.data;
          }

          filterFields();
        }).catch(function(err) {
          console.log(err);
          toastr.error('Erreur lors de la suppression du champs d\'affichage');
        });
      };

      $scope.goDown = function (field) {
        if (!field || !field.id || !field.categoryID) {
          toastr.error('Erreur avec ce champ, veuillez recharger la page SVP');
          return;
        }

        modelService.downDisplay(field.categoryID, field.id, localStorage[STORAGE_PREFIX + 'language']).then(function(res) {
          console.log($scope.category.fields);
          if (res.data) {
            $scope.displaysModels = res.data;
          }

          filterFields();
        }).catch(function(err) {
          console.log(err);
          toastr.error('Erreur lors de la suppression du champs d\'affichage');
        });
      };

      $scope.setIcon = function(field) {
        if (!field || !field.id) {
          toastr.error('Erreur avec ce champ, veuillez recharger la page SVP');
          return;
        }

        modelService.setIconDisplay(field).then(function(res) {

        }).catch(function(err) {
          toastr.error('Erreur lors du changement de l\'icône associée');
        });
      };

      function getCategory() {
        if ($state.params.categoryId) {
          modelService.getCategory($state.params.categoryId, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
            if (res.data) {
              $scope.category = res.data;
              $scope.fields = [];

              for (var i = 0; i < $scope.category.fields.length; i++) {
                $scope.fields.push($scope.category.fields[i]);
              }

              for (var i = 0; i < $scope.category.subCategories.length; i++) {
                for (var y = 0; y < $scope.category.subCategories[i].fields.length; y++) {
                  $scope.fields.push($scope.category.subCategories[i].fields[y]);
                }
              }
            }

            if (dataReady) {
              filterFields();
            } else {
              dataReady = true;
            }
            console.log(res.data);
          }).catch(function (err) {
            console.log(err);
            toastr.error('Erreur lors de la récupération de la catgorie');
          });
        } else {
          $state.go('app.database.contactsSettings');
        }

      }

      function getDisplays() {
        modelService.getDisplays($state.params.categoryId, localStorage[STORAGE_PREFIX + 'language']).then(function (res) {
          if (res.data) {
            $scope.displaysModels = res.data;
          }

          if (dataReady) {
            filterFields();
          } else {
            dataReady = true;
          }
          console.log(res.data);
        }).catch(function (err) {
          console.log(err);
          toastr.error('Erreur lors de la récupération de la catgorie');
        });
      }

      function filterFields() {
        $scope.fieldsAvalaible = [];
        if ($scope.fields) {
          for (var i = 0; i < $scope.fields.length; i++) {
            $scope.fields[i].alreadyHere = false;
            for (var j = 0; j < $scope.displaysModels.length; j++) {
              if ($scope.fields[i].id === $scope.displaysModels[j].fieldModel.id) {
                $scope.fields[i].alreadyHere = true;
              }
            }
            if (!$scope.fields[i].alreadyHere) {
              $scope.fieldsAvalaible.push(angular.copy($scope.fields[i]));
            }
          }

          console.log($scope.fieldsAvalaible);
        } else {
          toastr.error('Aucun champ n\'est disponible sur ce modèle');
        }

        dataReady = false;
      }

      function init() {
        getCategory();
        getDisplays();
      }
    });
})();

(function () {
	'use strict';

	angular.module('app.front').service('NewsletterService', ['$q', '$http', function ($q, $http) {
		var baseUrl = './api/rest/newsletter';
		return {
			getAll: function () {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl,
						method: 'GET',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}, export: function () {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + "/export",
						method: 'POST',
						responseType: 'arraybuffer',
						params: {
							'_v': new Date().getTime()
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			delete: function (id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime(),
							id: id
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}
		};

	}])
})();

(function () {
	'use strict';

	angular.module('app.front').controller('NewsletterController', NewsletterController);

	function NewsletterController($rootScope, NewsletterService, $scope, $translate, $timeout, $location, toastr, languageService, $filter, $mdDialog, $state) {
		$scope.loaded = false;
		$scope.newsletters = [];
		$scope.exportInProgress = false;


		$scope.refresh = function () {
			NewsletterService.getAll().then(function (res) {
				$scope.newsletters = res.data;
				$scope.loaded = true;
			}).catch(function (err) {
				$scope.loaded = true;
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};
		$scope.refresh();

		$scope.export = function () {
			$scope.exportInProgress = true;
			NewsletterService.export().then(function (res) {
				var byteArray = new Uint8Array(res.data);
				var a = window.document.createElement('a');
				a.href = window.URL.createObjectURL(new Blob([byteArray], {
					type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				}));
				a.download = 'exportNewsletter.xlsx';
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
				$scope.exportInProgress = false;
			}).catch(function (err) {
				$scope.exportInProgress = false;
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			})
		}

		$scope.deleteItem = function (id) {
			var content = {
				title: $filter('translate')('NEWSLETTER.DELETE_POPUP'),
				message: $filter('translate')('NEWSLETTER.DELETE_POPUP_CONFIRM')
			};
			$rootScope.openConfirmPopup(content).then(() => {
				NewsletterService.delete(id).then(() => {
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_DELETE'));
					$scope.refresh();
				}).catch(() => {
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(() => {

			});
		};
	}
})();

(function () {
    'use strict';
  
    angular.module('app.front').service('MissingInfosToolService', MissingInfosToolService);
  
    function MissingInfosToolService($q, $http) {
  
      var service = {};

      service.lookForMissingInfos = function(modelType, modelSubtypeId, fieldId, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: './api/rest/missing-infos-tool',
            method: 'GET',
            params: { '_v': new Date().getTime(), 'modelType': modelType, 
              'modelSubtypeId': modelSubtypeId, 'fieldId': fieldId, 'lang': lang }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      };
  
      return service;
  
    }
  
  })();
  
(function () {
  'use strict';

  angular.module('app.front').service('MessageService', ['$q', '$http', function ($q, $http) {
    var baseUrl = './api/rest/message';
    return {
      saveMessage: function (message) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl,
            method: 'POST',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: message
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findAllMessage: function (messageFilter,lang, page, max) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+"/findAll",
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang' : lang,
              'page': page,
              'max': max
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: messageFilter
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      confirmAction: function (action) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + "/confirm",
            method: 'POST',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: action
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findMessageByDay : function (dateStart, dateEnd, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + "/day",
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang' : lang,
              'dateStart' : dateStart,
              'dateEnd' : dateEnd
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findMessageNotDone : function (sorting, lang, actionPast) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + "/notDone",
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang,
              'sorting': sorting,
              'output': 10,
              'actionPast': actionPast
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      notificationAction : function (listOlderMessages,lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + "/poll",
            method: "POST",
            params: {'_v': new Date().getTime(), 'lang': lang},
            data : listOlderMessages
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            console.log("#### RESPONSE #####");
            console.log(response);
            if(response.data != null){
              reject(response);
            }
          });
        });
      },
      notifySenderActionsDone : function (lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + "/notifySenderActionsDone",
            method: "GET",
            params: {'_v': new Date().getTime(), 'lang': lang}
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            if(response.data != null){
              reject(response);
            }
          });
        });
      },
      findAllPaginated : function (page, max, lang){
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl ,
            method: 'GET',
            params: { '_v': new Date().getTime(), 'lang': lang, 'page': page, 'max': max },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            if (response.data != null) {
              reject(response);
            }
          });
        });
      },
      bulk : function (dto, modelType, subTypeId){
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl + '/bulk',
            method: 'POST',
            params: { '_v': new Date().getTime(), 'modelType': modelType, 'subTypeId': subTypeId },
            data: dto
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            if (response.data != null) {
              reject(response);
            }
          });
        });
      }
    };
  }]);

})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('MessageController', MessageController);

  /** @ngInject */
  function MessageController($scope, $translate, userService, DISPLAY_MODELS_ICONS, SettingsMessageService, msNavigationService, STORAGE_PREFIX, MessageService, $filter, $rootScope, $mdDialog) {
    $scope.users = [];
    $scope.actions = [];
    $scope.page = 0;
    $scope.max = 20;
    $scope.message = {
      actionForm: null,
      receiverForm: null
    };
    $scope.filter = {
      sender: null,
      action: null
    };
    $scope.infiniteScrollPrevent = false;
    $scope.messages = [];

    $scope.typeAction = {
      ALL: "ALL",
      TO_DO: "TO_DO",
      DONE: "DONE"
    };
    $scope.showForm = false;

    $scope.iconsDisplay = {};
    angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
      $scope.iconsDisplay[elt.name] = elt.value;
    });

    $scope.findAllUsers = function () {
      userService.findAllUsers().then(function (users) {
        $scope.users = users.data;
      }).catch(function (data) {

      });
    };

    $scope.findAllUsers();

	 window.mdSelectOnKeyDownOverride = function (event) {
		event.stopPropagation();
	};

    $scope.findAllActions = function () {
      SettingsMessageService.findAllAction(localStorage[STORAGE_PREFIX + 'language']).then(function (actions) {
        $scope.actions = actions.data;
      }).catch(function (data) {

      });
    };

    $scope.findAllActions();


    $scope.saveMessage = function () {
      if ($scope.message.actionForm != null) {
        $scope.message.dateAction = moment($scope.message.startDateForm).set('hours', $scope.message.startTime.split(':')[0]).set('minutes', $scope.message.startTime.split(':')[1]).toDate().getTime();
        if (!$scope.message.actionDone) {
          $scope.message.actionDone = false;
        }
        $scope.message.action = angular.fromJson($scope.message.actionForm);
      }

      if ($scope.message.receiverForm != null && $scope.message.receiverForm != "null") {
        $scope.message.receiver = angular.fromJson($scope.message.receiverForm);
        $scope.message.receiverID = angular.fromJson($scope.message.receiverForm).id;
      } else {
        $scope.message.receiverID = null;
      }

      MessageService.saveMessage($scope.message).then(function (data) {
        $scope.findAllMessages(true);
        $scope.cancelFormMessage();
        $mdDialog.hide();
      }).catch(function (data) {

      });
    };

    $scope.findAllMessages = function (reset) {
      if (!$scope.infiniteScrollPrevent){
        
        $scope.infiniteScrollPrevent = true;
        if (reset){
          $scope.messages = [];
          $scope.page = 0;
        }
        switch ($scope.filter.action) {
          case null:
            delete $scope.filter.actionToDo;
            $scope.filter.actionExist = false;
            break;
          case $scope.typeAction.ALL:
            delete $scope.filter.actionToDo;
            $scope.filter.actionExist = true;
            break;
          case $scope.typeAction.DONE:
            $scope.filter.actionToDo = false;
            break;
          case $scope.typeAction.TO_DO:
            $scope.filter.actionToDo = true;
            break;
          default:
            break;
        }
        $scope.filter.addressee = [];
        angular.forEach($scope.filter.receiverForm, function (item, key) {
          $scope.filter.addressee.push(angular.fromJson(item));
        });
        
        MessageService.findAllMessage($scope.filter, $translate.preferredLanguage(), $scope.page, $scope.max).then(function (messages) {
          if (messages.data != null && messages.data.length > 0){
            $scope.messages = $scope.messages.concat(messages.data);
            $scope.infiniteScrollPrevent = false;
          }
          $scope.page++;
          //Delete badge
          if (userService.isUserHasNonReadMsg()) {
            msNavigationService.saveItem('message', {
              title: 'Message',
              state: 'app.message',
              translate: 'MESSAGE.TITLE',
              weight: 2,
              badge: null,
              hidden : function() {
                  return !userService.isUserAdmin();
              }
            });
          }
        }).catch(function (data) {
  
        });
      }
    };
    $scope.findAllMessages(true);

    $scope.cancelFormMessage = function () {
      $scope.message = {
        actionForm: null,
        receiverForm: null
      };
      $mdDialog.hide();
    };

    $scope.confirmAction = function (action) {
      var content = {
        title: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL_TITLE') : $filter('translate')('MESSAGE.ACTION_CONFIRM_TITLE'),
        message: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL') : $filter('translate')('MESSAGE.ACTION_CONFIRM')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        action.actionDone = !action.actionDone;
        MessageService.confirmAction(action).then(function (data) {}).catch(function (data) {});
      }).catch(function () {

      });
    };

    $scope.showPopUpMessage = function () {
      $scope.message = {
        actionForm: null,
        receiverForm: null
      };

      for (var i = 0; i < $scope.users.length; i++) {
        if ($scope.users[i].id === $rootScope.user.id) {
          $scope.message.receiverForm = angular.toJson($scope.users[i]);
          break;
        }
      }

      var now = new Date();
      $scope.message.startDateForm = now;
      $scope.message.startTime = (now.getHours() < 10 ? '0' + now.getHours() : now.getHours()) + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());

      $mdDialog.show({
        templateUrl: 'app/main/message/popup/update_message.html',
        preserveScope: true,
        clickOutsideToClose: true,
        scope: $scope,
      }).then(function () {

      }).catch(function () {

      });
    };

    $scope.updateMessage = function (message) {
      $scope.message = angular.copy(message);
      if (message.action != null) {
        var actionID = angular.copy(message.action.actionID);
        angular.forEach($scope.actions, function (action) {
          if (action.id === actionID) {
            $scope.message.actionForm = angular.toJson(action);
          }
        });
      } else {
        $scope.message.actionForm = null;
      }

      if (message.receiver != null) {
        var receiverID = angular.copy(message.receiver.id);
        angular.forEach($scope.users, function (user) {
          if (user.id === receiverID) {
            $scope.message.receiverForm = angular.toJson(user);
          }
        });
      } else {
        $scope.message.receiverForm = 'null';
      }

      if (message.action != null && message.action.dateAction != null) {
        var date = new Date(message.action.dateAction);

        $scope.message.startDateForm = date;
        $scope.message.startTime = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      } else {
        var now = new Date();
        $scope.message.startDateForm = now;
        $scope.message.startTime = (now.getHours() < 10 ? '0' + now.getHours() : now.getHours()) + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());
      }

      $mdDialog.show({
        templateUrl: 'app/main/message/popup/update_message.html',
        preserveScope: true,
        clickOutsideToClose: true,
        scope: $scope,
      }).then(function () {

      }).catch(function () {

      });
    };
  }
})();

(function () {
  'use strict';

  angular.module('app.front').service('DocumentService', DocumentService);

  function DocumentService($q, $http) {
    var baseUrl = "/api/rest/document/";
    var save = function (fd) {
      return $q(function (resolve, reject) {
        $http({
          url: baseUrl+"save",
          method: "POST",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": undefined
          },
          transformRequest: angular.identity,
          data: fd
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var deleteFile = function (fileId) {
      return $q(function (resolve, reject) {
        $http({
          url: baseUrl+"delete/"+fileId,
          method: "DELETE",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });

    };

    var remove = function (id) {
      return $q(function (resolve, reject) {
        $http({
          url: baseUrl+"disable/" + id,
          method: "PUT",
          params: {
            '_v': new Date().getTime()
          },
          headers: {
            "Content-Type": "application/json; charset=UTF-8"
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });

      });
    };

    var getDownloadLink = function (documentId) {
      return baseUrl+'download/' + documentId;
    };


    return {
      save: save,
      remove: remove,
      deleteFile: deleteFile,
      getDownloadLink: getDownloadLink
    }
  }
})();

(function () {
  'use strict';

  angular.module('app.front').service('databaseFoldersService', ['$q', '$http', function ($q, $http) {
    var baseUrl = './api/rest/folder';
    return {
      saveFolder: function (folder, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl,
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: folder
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },

      findRoots : function (lang, parentFolderId) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang,
              'idParent' : parentFolderId
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findById : function (lang, idFolder) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+'/'+idFolder,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      deleteFolder : function (idFolder) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+'/'+idFolder,
            method: 'DELETE',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findDocumentsFolder : function (idFolder) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+'/documents',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'folderId' : idFolder
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });

      }
    };
  }]);

})();

(function () {
	'use strict';

	angular.module('app.front').controller('databaseFoldersController', databaseFoldersController);

	function databaseFoldersController($rootScope, $scope, $timeout,$location, toastr, databaseFoldersService, languageService,$filter,$mdDialog,DocumentService) {
		$scope.language = {};
		$scope.folders = [];
		$scope.files = [];
		$scope.newFolder = {};
		$scope.selectedFolder = null;
    $scope.showForm = false;
    $scope.document = {};
    $scope.error = {};
    $scope.folderUpdate = false;
    $scope.thread = [];

    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          $scope.findFolders($scope.language.key);
          $scope.findDocuments($scope.newFolder.idParent);
          break;
        }
      }
      $scope.$watch('language.key', function () {
        $scope.findFolders($scope.language.key, $scope.newFolder.idParent);
      });
    }).catch(function (error) {

    });

    $scope.showFolderForm = function () {
      $scope.showForm = !$scope.showForm;
    };

    $scope.createFolder = function () {
      databaseFoldersService.saveFolder($scope.newFolder,$scope.language.key).then(function (data) {
        $scope.showForm = !$scope.showForm;
        delete $scope.newFolder.name;
        $scope.findFolders($scope.language.key,$scope.newFolder.idParent);
        $scope.findDocuments($scope.newFolder.idParent);
      }).catch(function (data) {

      });
    };


    $scope.goToFolder = function (folder,fromThread) {
      if(!$scope.thread.includes(folder)){
        $scope.thread.push(folder);
      }
      var lengthThread = angular.copy($scope.thread).length-1;
      if(fromThread){
        for (var i = lengthThread; i > 0; i--) {
          if ($scope.thread[i] != folder) {
            $scope.thread.pop();
          }
        }
      }
      $scope.newFolder.idParent = folder.id;
      $scope.document.folderId = $scope.newFolder.idParent;
      $scope.findFolders($scope.language.key,folder.id);
      $scope.findDocuments($scope.newFolder.idParent);
    };


    $scope.returnParent = function () {
      databaseFoldersService.findById($scope.language.key, $scope.newFolder.idParent).then(function (folder) {
        $scope.thread.pop();
        $scope.newFolder.idParent = folder.data != null ? folder.data.idParent : null;
        $scope.document.folderId = $scope.newFolder.idParent;
        $scope.findFolders($scope.language.key, $scope.newFolder.idParent);
        $scope.findDocuments($scope.newFolder.idParent);
      }).catch(function (data) {
        delete $scope.newFolder.idParent;
      });
    };



    $scope.openAddFile = function () {
      $scope.documentPopup = $mdDialog.show({
        templateUrl: 'app/main/media/popup/document_popup.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
      });
    };

    $scope.saveDocument = function () {
      var input = document.getElementById('document_input_file');
      var file = null;
      $scope.error.file = false;
      if (input != null) {
        file = input.files[0];
        if (file == null) {
          $scope.error.file = true;
        }
      } else {
        $scope.error.file = true;
      }

      if (!$scope.error.file) {
        var fd = new FormData();
        fd.append('file', file);
        fd.append('dto', angular.toJson($scope.document));
        DocumentService.save(fd).then(function (response) {
          $scope.findFolders($scope.language.key, $scope.newFolder.idParent);
          $scope.findDocuments($scope.newFolder.idParent);
          $scope.hidePopup();
        }).catch(function (response) {
          if (response.status === 404) {
            toastr.error('Dossier parent introuvable, veuillez actualiser la page');
          }
        });
      }
    };


    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.isPicture = function (filename) {
      return (/\.(gif|jpg|jpeg|tiff|png)$/i).test(filename);
    };

    $scope.getUrl = function () {
      return $location.protocol()+"://"+$location.host()+($location.port() ? ':'+$location.port(): '');
    };

    // FIND ALL
    $scope.findFolders = function (lang, parentFolderId) {
      if(!parentFolderId){
        $scope.thread = [];
        $scope.newFolder = {};
      }
      databaseFoldersService.findRoots(lang, parentFolderId).then(function (folders) {
        $scope.folders = folders.data;
      }).catch(function (data) {

      })
    };

    $scope.findDocuments = function (folderId) {
      databaseFoldersService.findDocumentsFolder(folderId).then(function (documents) {
        $scope.files = documents.data;
      }).catch(function (data) {
      });
    };


    //DELETE

    $scope.deleteFile = function (file) {
      var content = {
        title: $filter('translate')('FOLDERS.DELETE_FILE'),
        message: $filter('translate')('FOLDERS.CONFIRM_DELETE_FILE')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        DocumentService.deleteFile(file.id).then(function (data) {
          $scope.findFolders($scope.language.key, $scope.newFolder.idParent);
          $scope.findDocuments($scope.newFolder.idParent);
        }).catch(function (data) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }).catch(function () {

      });
    };


    $scope.deleteFolder = function (folder) {
      var content = {
        title: $filter('translate')('FOLDERS.DELETE'),
        message: $filter('translate')('FOLDERS.CONFIRM_DELETE')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        databaseFoldersService.deleteFolder(folder.id).then(function (data) {
          $scope.findFolders($scope.language.key, $scope.newFolder.idParent);
          $scope.findDocuments($scope.newFolder.idParent);
        }).catch(function (data) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }).catch(function () {

      });
    };



    //UPDATE FOLDER
    $scope.updateFolder = function (folder) {
      $scope.folderNameCopy = {name: angular.copy(folder.name)};
      folder.update = !folder.update;
      //folder.update = $scope.folderUpdate;
      for (var i = 0; i < $scope.folders.length; i++) {
        if ($scope.folders[i].id !== folder.id) {
          $scope.folders[i].update = false;
        } else {
          $scope.folders[i].update = true;
        }
      }
    };

    $scope.saveUpdateFolder = function (folder) {
      var updateFolder = {
        id : folder.id,
        name : angular.copy($scope.folderNameCopy.name),
        idParent: folder.idParent
      };
      databaseFoldersService.saveFolder(updateFolder,$scope.language.key).then(function (data) {
        $scope.folderUpdate = !$scope.folderUpdate;
        $scope.findFolders($scope.language.key,updateFolder.idParent);
        $scope.findDocuments(updateFolder.idParent);
      }).catch(function (data) {

      });
    };

	}
})();

(function ()
{
    'use strict';

    angular
        .module('mailing_preview.app')
        .controller('MailingPreviewMainController', MailingPreviewMainController);

    /** @ngInject */
    function MailingPreviewMainController($scope, $rootScope)
    {
        // Data

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
        
    }
})();
(function () {
  'use strict';

  angular.module('app.front').service('MailingService', MailingService);

  function MailingService($q, $http, $filter) {

    var service = {};

    var blocTypes = [
      { translation: 'MAILING.BLOCS.TYPES.HTML', value: 'HTML' },
      { translation: 'MAILING.BLOCS.TYPES.TEST', value: 'TEST' }
    ];

    service.getBlocTypes = function () {
      return blocTypes;
    };

    service.findAll = function (path, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/' + path,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang' : lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.find = function (path, id, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/' + path + '/' + id,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang' : lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.save = function (path, dto, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/' + path,
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang' : lang
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.delete = function (path, id) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/' + path + '/' + id,
          method: 'DELETE',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.moveBloc = function(pageID, blocIndex, up, lang) {
      var url = './api/rest/mailing/page/' + pageID + '/' + blocIndex + '/';
      if (up) {
        url += 'up';
      } else {
        url += 'down';
      }
      return $q(function (resolve, reject) {
        $http({
          url: url,
          method: 'PUT',
          params: {
            '_v': new Date().getTime(),
            'lang' : lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.findAllPageLite = function () {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/pages/lite',
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.doAMailing = function (dto) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/doAMailing',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          data: dto
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.exportToHtmlFile = function(pageId, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/page/exportToHtml/' + pageId,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.mailingPreview = function(pageId, lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/public/unsecured/mailing/preview/' + pageId,
          method: 'GET',
          params: {
            '_v': new Date().getTime(),
            'lang': lang
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getHistory = function(filter,lang) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/history',
          method: 'POST',
          params: {
            '_v': new Date().getTime(),
            'lang' : lang
          },
          data: filter
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.getExpeditors = function() {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/expeditors',
          method: 'GET',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.addExpeditor = function(expeditor) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/expeditor',
          method: 'POST',
          params: {
            '_v': new Date().getTime()
          },
          data: expeditor
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    service.deleteExpeditor = function(id) {
      return $q(function (resolve, reject) {
        $http({
          url: './api/rest/mailing/expeditor/' + id,
          method: 'DELETE',
          params: {
            '_v': new Date().getTime()
          }
        }).then(function (response) {
          resolve(response);
        }).catch(function (response) {
          reject(response);
        });
      });
    };

    return service;

  }

})();

(function() {
    'use strict';

    angular
        .module('app.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider) {
        // State
        $stateProvider.state('login', {
            url: '/login?associationId',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@login': {
                    templateUrl: 'app/main/login/login.html',
                    controller: 'LoginController as vm'
                }
            },
            // bodyClass: 'login-v2',
            params: {
                successUpdatePwd: null
            }
        }).state('activateAccount', {
            url: '/activateAccount',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@activateAccount': {
                    templateUrl: 'app/main/login/activate_account.html',
                    controller: 'ActivateAccountController as vm'
                }
            }
        }).state('forgotPassword', {
            url: '/forgotPassword',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@forgotPassword': {
                    templateUrl: 'app/main/login/forgot_password.html',
                    controller: 'ForgotPasswordController as vm'
                }
            }
        })
        .state('updatePassword', {
            url: '/updatePassword',
            views: {
                'main@': {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller: 'MainController as vm'
                },
                'content@updatePassword': {
                    templateUrl: 'app/main/login/update_password.html',
                    controller: 'UpdatePasswordController as vm'
                }
            }
        });
    }

})();

(function () {
	'use strict';

	angular
		.module('app.login')
		.controller('UpdatePasswordController', UpdatePasswordController);

	/** @ngInject */
	function UpdatePasswordController($scope, $state, $location, toastr, userService) {
		// Data
		var key = $location.search().key;
		$scope.loginDTO = {};
		
		$scope.sendUpdatePassword = function () {
			userService.updatePassword(key, $scope.loginDTO.password).then(function (response) {
				toastr.success('Password has been successfully reset. You can now login');
			}).catch(function (response) {
				if (response.status === 401) {
					toastr.error('Link to change your password is expired.', 'Invalid link');
				}
			});
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('app.login')
		.controller('LoginController', LoginController);

	/** @ngInject */
	function LoginController($rootScope, $translate, $scope, $state, $stateParams, $window, toastr, URL, userService, associationService) {
		// Data
		$scope.loginError = false;
		$scope.loginDTO = {};
		$scope.alternatedocroots = URL.alternatedocroots;

		if ($stateParams.successUpdatePwd) {
			toastr.success('Compte activé, vous pouvez vous connecter !', 'Activation réussie');
		}

		if ($stateParams.associationId != null) {
			associationService.findByIdPublic($stateParams.associationId, $translate.preferredLanguage()).then(function (response) {
				$scope.association = response.data;
			}).catch(function () {

			});
		}

		$scope.login = function () {
			$scope.loginError = false;
			var associationId = null;
			if ($stateParams.associationId != null) {
				associationId = $stateParams.associationId;
			}
			userService.login($scope.loginDTO, associationId).then(function (response) {
				//$scope.$emit('getCurrentUser');
				$scope.$emit('getLateActions');
				//$scope.$emit('notifySenderActionsDone');
				$scope.$emit('refreshCompanyTypes');
				if (response.data) {
					// $window.location.href = '/home';
					userService.getCurrent($translate.preferredLanguage(), true).then(function (data) {
						$rootScope.user = data;
						$scope.$emit('onInitNotifs');
						var isAMember = userService.isUserAdmin() || userService.isUserLinkedToAssociations();
						var roleNames = $rootScope.user.rights.map(function (role) {
							return role.name;
						});
						if (!isAMember) {
							if ($rootScope.user.company && $rootScope.user.company.id && $rootScope.user.company.subTypes &&
								$rootScope.user.company.subTypes.length > 0) {
								if (roleNames.lastIndexOf('DATABASE') === -1) {
									$state.go('app.empty');
								} else {
									$state.go('app.companies.details', {
										subType: $rootScope.user.company.subTypes[0].id,
										id: $rootScope.user.company.id
									});
								}
							} else {
								if (roleNames.lastIndexOf('AGENDA') === -1) {
									$state.go('app.empty');
								} else {
									$state.go('app.home');
								}
							}
						} else {
							if (roleNames.lastIndexOf('AGENDA') === -1) {
								$state.go('app.empty');
							} else {
								$state.go('app.home');
							}
						}
					}).catch(function (error) {
						console.log(error)
					});
				} else {
					$scope.loginError = true;
				}
			}).catch(function (response) {
				$scope.loginError = true;
			});
		};
	}
})();

(function () {
	'use strict';

	angular
		.module('app.login')
		.controller('ForgotPasswordController', ForgotPasswordController);

	/** @ngInject */
	function ForgotPasswordController($scope, $state, $location, toastr, userService) {
		// Data
		$scope.loginDTO = {};
		$scope.sendForgotPassword = function(){
			userService.forgotPassword($scope.loginDTO.email).then(function(response){
				toastr.success('Please go to your mailbox, a link to reset your password has been sent.');
			}).catch(function(res){

			});
		};
	}
})();

(function() {
	'use strict';

	angular
		.module('app.login')
		.controller('ActivateAccountController', ActivateAccountController);

	/** @ngInject */
	function ActivateAccountController($scope, $state, $location, toastr, userService) {
		// Data
		var key = $location.search().key;
		$scope.passwordDTO = {};
		userService.logout().then(function() {
			$scope.$emit('stopNotifs');
		}).catch(function() {

		});

		$scope.updatePassword = function() {
			userService.updatePassword(key, $scope.passwordDTO.newPassword).then(function(response) {
				$state.go('login', { successUpdatePwd: true });
			}).catch(function(response) {
				if (response.status === 401) {
					toastr.error('Le lien pour créer un mot de passe est expiré, veuillez faire une demande d\'oubli de mot de passe.', 'Lien expiré');
				}
				if (response.status === 409) {
					console.log(response);
				}
			});
		};
	}
})();

(function () {
  'use strict';

  angular
    .module('app.front')
    .controller('HomeController', HomeController);

  /** @ngInject */
  function HomeController($scope, STORAGE_PREFIX, DISPLAY_MODELS_ICONS, MessageService, $rootScope, $filter,$mdDialog,SettingsMessageService,userService) {
    $scope.iconsDisplay = {};
    angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
      $scope.iconsDisplay[elt.name] = elt.value;
    });
    $scope.actionsMessage = [];
    $scope.users = [];
	 $scope.months = [];
    $scope.date = {
      year: moment().get('y'),
      month: moment().format("MMM"),
      day: moment().date()
    };
    $scope.daysInMonth = 0;
    $scope.getYear = function (n) {
      return moment().get('year') + n;
    };
    $scope.hoursInDay = [8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19];
    $scope.actions = [];
    moment().locale(localStorage[STORAGE_PREFIX + 'language']);
    $scope.monthBeginSunday = false;

    $scope.getMonth = function () {

		$scope.months = ["Jan","Fév","Mars","Avr","Mai","Juin","Juil","Août","Sep","Oct","Nov","Déc"];
    };

    $scope.getMonth();

    $scope.findAllActions = function () {
      SettingsMessageService.findAllAction(localStorage[STORAGE_PREFIX + 'language']).then(function (actions) {
        $scope.actions = actions.data;
      }).catch(function (data) {

      });
    };
    $scope.findAllActions();

    $scope.findAllUsers = function () {
      userService.findAllUsers().then(function (users) {
        $scope.users = users.data;
      }).catch(function (data) {

      });
    };

    $scope.findAllUsers();

    $scope.findMessageByDay = function (startDate, endDate) {
      MessageService.findMessageByDay(startDate, endDate, localStorage[STORAGE_PREFIX + 'language']).then(function (messages) {
        $scope.actionsMessage = messages.data;
      }).catch(function (err) {
        console.log(err);
      });
    };

    $scope.displayDays = function (typeDay) {
      $scope.daysWeek = [];
      if (typeDay == 'year') {
			$scope.monthSelected = true;
        var startDate = moment("01/01/" + $scope.date.year, "DD/MM/YYYY").set({
          'h': 0,
          "m": 0,
          "ms": 0
        }).toDate().getTime();
        var endDate = moment("31/12/" + $scope.date.year, "DD/MM/YYYY").set({
          'h': 23,
          "m": 59
        }).toDate().getTime();
        $scope.findMessageByDay(startDate, endDate);
        delete $scope.date.month;
        delete $scope.date.day;
        delete $scope.date.sort;
      } else if (typeDay == 'month') {
			$scope.daysSelected = true;
      $scope.monthSelected = false;
      $scope.weekSelected = false;
        $scope.daysInMonth = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").daysInMonth();
        var startDate = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").startOf('month').set({
          'h': 0,
          "m": 0,
          "ms": 0
        }).toDate().getTime();
        var endDate = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").endOf('month').set({
          'h': 23,
          "m": 59,
          "ms": 0
		  }).toDate().getTime();
		  $scope.monthClicked = startDate;
        $scope.findMessageByDay(startDate, endDate);
        delete $scope.date.day;
        delete $scope.date.sort;
      } else {
			$scope.daysSelected = false;
      $scope.monthSelected = false;
      $scope.weekSelected = false;
        if ($scope.date.year && $scope.date.month) {
          delete $scope.date.sort;
          $scope.daysInMonth = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").daysInMonth();
          if ($scope.date.day && $scope.date.day > $scope.daysInMonth) {
            $scope.actionsMessage = [];
            delete $scope.date.day;
          } else {
            if ($scope.date.year && $scope.date.month && $scope.date.day) {
              var currentDate = moment($scope.date.year + '-' + $scope.date.month + "-" + $scope.date.day, "YYYY-MMM-DD");
              var startDate = currentDate.set({
                'h': 0,
                "m": 0,
                "ms": 0
              }).toDate().getTime();
              var endDate = currentDate.set({
                'h': 23,
                "m": 59
				  }).toDate().getTime();
				  $scope.dayClicked = startDate;
              $scope.findMessageByDay(startDate, endDate);
            }
          }
        }
      }

    };
    $scope.displayDays();

    $scope.displayCircle = function (day) {
      if ($scope.date.year && $scope.date.month) {
        if (moment($scope.date.year + '-' + $scope.date.month + '-' + day, "YYYY-MMM-DD").day() == 0) {
          return true;
        }
        else if (day == 0){
          return true;
        }
      }
      return false;
    };



    $scope.filterMessageByHour = function (hour) {
      return function (message) {
        return moment(message.action.dateAction).get('h') == hour;
      }
    };

    $scope.filterMessageUnder = function (hour) {
      return function (message) {
        return moment(message.action.dateAction).get('h') < hour;
      }
    };

    $scope.filterMessageOver = function (hour) {
      return function (message) {
        return moment(message.action.dateAction).get('h') > hour;
      }
    };


    $scope.filterMessageByMonth = function (month) {
      return function (message) {
        return moment(message.action.dateAction).format("MMM") == month;
      }
    };


    $scope.filterMessageByDaysInMonth = function (date) {
      return function (message) {
        return moment(message.action.dateAction).date() == date;
      }
    };





    $scope.confirmAction = function ($event,action) {
      $event.stopPropagation();
      var content = {
        title: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL_TITLE') : $filter('translate')('MESSAGE.ACTION_CONFIRM_TITLE'),
        message: action.actionDone ? $filter('translate')('MESSAGE.ACTION_CANCEL') : $filter('translate')('MESSAGE.ACTION_CONFIRM')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        action.actionDone = !action.actionDone;
        MessageService.confirmAction(action).then(function (data) {}).catch(function (data) {});
      }).catch(function () {

      });
    };

    $scope.getDateMonthCalendar = function (indexWeek, indexDay) {
      var date = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").startOf('month').add(indexWeek * 7, 'days');
      date = date.day(indexDay);
      if(date >= moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM")){
			if (indexWeek == 0) {
				if (date.date() > 7 && beginWithSunday != '') {
				  return "";
				}
			} else if (indexWeek == 4) {
				if (date.date() < 7) {
				  return "";
				}
			}
			return date.date();
		} else{
			return "";
		}
    };
    var beginWithSunday = $scope.getDateMonthCalendar(0,0);



    $scope.startOfMonthSunday = function () {
      if ($scope.date.year && $scope.date.month) {
        var date = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").startOf('month').day();
        if (date == 0) {
          return true;
        }
      }
      return false;
    };

    $scope.getTimeOfDay = function(day){
      return moment($scope.date.year + '-' + $scope.date.month + '-' + day, "YYYY-MMM-DD").toDate().getTime();
    }

    $scope.selectWeek = function (day) {
      delete $scope.date.day;
      $scope.weekSelected = true;
      $scope.daysSelected = false;
      $scope.monthSelected = false;
      var date = moment($scope.date.year + '-' + $scope.date.month + '-' + day, "YYYY-MMM-DD").startOf('week');
      var startDate = moment($scope.date.year + '-' + $scope.date.month + '-' + day, "YYYY-MMM-DD").startOf('week').set({
        'h': 0,
        "m": 0,
        "ms": 0
      }).toDate().getTime();
      var endDate = moment($scope.date.year + '-' + $scope.date.month + '-' + day, "YYYY-MMM-DD").endOf('week').set({
        'h': 23,
        "m": 59,
        "ms": 0
		}).toDate().getTime();
		$scope.circleClickedStartDate = startDate + 86400000;
		$scope.circleClickedEndDate = endDate + 86400000;
      $scope.findMessageByDay(startDate, endDate);
      $scope.daysWeek = [];
      for (var i = 0; i < 7; i++) {
        var dateWeek = date.add(1, 'days').date();
        $scope.daysWeek.push({
          date: dateWeek,
          inCurrentMonth: date.month() == moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").month()
        });
      }
    };

    $scope.setDate = function (date) {
      if (date.inCurrentMonth) {
        $scope.date.day = date.date;
      } else {
        var nextDate = moment($scope.date.year + '-' + $scope.date.month, "YYYY-MMM").add(1, 'month').format("MMM");
        $scope.date.month = nextDate;
        $scope.date.day = date.date;
      }
    };

    $scope.sortMessage = function (sorting) {
      delete $scope.date.year;
      delete $scope.date.month;
      delete $scope.date.day;
      $scope.date.sort = sorting;
      MessageService.findMessageNotDone(sorting, localStorage[STORAGE_PREFIX + 'language'], false).then(function (messages) {
        $scope.actionsMessage = messages.data;
      }).catch(function (err) {
        console.log(err);
      });
    };

    $scope.saveMessage = function () {
      if ($scope.message.actionForm != null) {
        $scope.message.dateAction = moment($scope.message.startDateForm).set('hours', $scope.message.startTime.split(':')[0]).set('minutes', $scope.message.startTime.split(':')[1]).toDate().getTime();
        if (!$scope.message.actionDone) {
          $scope.message.actionDone = false;
        }
        $scope.message.action = angular.fromJson($scope.message.actionForm);
      }

      if ($scope.message.receiverForm != null && $scope.message.receiverForm != "null") {
        $scope.message.receiver = angular.fromJson($scope.message.receiverForm);
        $scope.message.receiverID = angular.fromJson($scope.message.receiverForm).id;
      } else {
        $scope.message.receiverID = null;
      }

      MessageService.saveMessage($scope.message).then(function (data) {
        $mdDialog.hide();
        $scope.displayDays();
      }).catch(function (data) {

      });
    };

    $scope.cancelFormMessage = function () {
      $scope.message = {
        actionForm: null,
        receiverForm: null
      };
      $mdDialog.hide();
    };

    $scope.updateMessage = function (message) {
      $scope.message = angular.copy(message);
      if (message.action != null) {
        var actionID = angular.copy(message.action.actionID);
        angular.forEach($scope.actions, function (action) {
          if (action.id === actionID) {
            $scope.message.actionForm = angular.toJson(action);
          }
        });
      } else {
        $scope.message.actionForm = null;
      }

      if (message.receiver != null) {
        var receiverID = angular.copy(message.receiver.id);
        angular.forEach($scope.users, function (user) {
          if (user.id === receiverID) {
            $scope.message.receiverForm = angular.toJson(user);
          }
        });
      } else {
        $scope.message.receiverForm = 'null';
      }

      if (message.action != null && message.action.dateAction != null) {
        var date = new Date(message.action.dateAction);

        $scope.message.startDateForm = date;
        $scope.message.startTime = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':' + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes());
      } else {
        var now = new Date();
        $scope.message.startDateForm = now;
        $scope.message.startTime = (now.getHours() < 10 ? '0' + now.getHours() : now.getHours()) + ':' + (now.getMinutes() < 10 ? '0' + now.getMinutes() : now.getMinutes());
      }

      $mdDialog.show({
        templateUrl: 'app/main/message/popup/update_message.html',
        preserveScope: true,
        clickOutsideToClose: true,
        scope: $scope,
      }).then(function () {

      }).catch(function () {

      });
    };

  }
})();

(function () {
	'use strict';

	angular.module('app.front').controller('EmptyController', EmptyController);

	function EmptyController() {

	}
})();

(function () {
	'use strict';

	angular.module('app.front').service('GalleryService', ['$q', '$http', function ($q, $http) {
		var baseUrl = './api/rest/gallery';
		var publicUrl = './api/public/sitegen';

		return {
			save: function (gallery, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl,
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: gallery
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			saveSub: function (subGallery, galleryID, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/' + galleryID + '/sub',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: subGallery
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getAll: function (lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/all',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			get: function (uuid, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/' + uuid,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			upSubGallery: function (uuid) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/upSubGallery/' + uuid,
						method: 'GET',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			downSubGallery: function (uuid) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/downSubGallery/' + uuid,
						method: 'GET',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getSub: function (uuid, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/sub/' + uuid,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getMutliplePublic: function (uuids, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: publicUrl + '/gallery',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: uuids
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getPublic: function (uuid, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: publicUrl + '/gallery/' + uuid,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			remove: function (id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/' + id,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			removeSub: function (id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/sub/' + id,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},

			getDownloadLink: function (documentName) {
				return publicUrl + '/download/' + documentName;
			}
		};
	}]);

})();

(function () {
	'use strict';

	angular.module('app.front').controller('GalleryController', GalleryController);

	function GalleryController($rootScope, GalleryService, $scope, $translate, $timeout, $location, toastr, FestivalService, languageService, $filter, $mdDialog, DocumentService, $sce, $state, userService) {
		$scope.galleries = [];
		$scope.gallery = {};
		$scope.languages = [];
		$scope.language = {};
		$scope.loaded = false;
		$scope.updateMode = false;

		$scope.showPopUAdd = function (gallery, index) {
			if (!gallery) {
				$scope.gallery = {};
				$scope.updateMode = false;
			} else {
				$scope.gallery = angular.copy(gallery);
				$scope.index = index;
				$scope.updateMode = true;
			}

			$mdDialog.show({
				templateUrl: 'app/main/gallery/addGallery.popup.html',
				preserveScope: true,
				scope: $scope,
				clickOutsideToClose: true
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.showPopUpRemove = function (gallery, index) {
			$scope.gallery = gallery;
			$scope.index = index;

			$mdDialog.show({
				templateUrl: 'app/main/gallery/removeGallery.popup.html',
				preserveScope: true,
				scope: $scope,
				clickOutsideToClose: true
			}).then(function () {

			}).catch(function () {

			});
		};

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

		$scope.addGallery = function () {
			GalleryService.save($scope.gallery, $scope.language.key).then(function (res) {
				if (!$scope.updateMode) {
					$scope.galleries.unshift(angular.copy(res.data));
				} else {
					$scope.galleries[$scope.index] = angular.copy(res.data);
				}

				$scope.hidePopup();
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.removeGallery = function () {
			GalleryService.remove($scope.gallery.id).then(function (res) {
				$scope.galleries.splice($scope.index, 1);
				$scope.hidePopup();
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.getGalleries = function (lang) {
			$scope.galleries = [];
			GalleryService.getAll(lang).then(function (res) {
				$scope.galleries = res.data;
				$scope.loaded = true;
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.goDetails = function (gallery) {
			console.log(gallery);
			$state.go('app.gallery.details', {
				uuid: gallery.uuid
			});
		};

		function init() {
			//$scope.getGalleries();

			languageService.getLanguages().then(function (response) {
				$scope.languages = response.data;
				for (var i = 0; i < $scope.languages.length; i++) {
					var language = $scope.languages[i];
					if (language.preferred) {
						$scope.language.key = language.key;
						break;
					}
				}
				$scope.$watch('language.key', function () {
					$scope.getGalleries($scope.language.key);
				});
			}).catch(function (error) {

			});
		}

		init();
	}
})();

(function () {
  'use strict';

  angular.module('app.front').service('FestivalService', ['$q', '$http', function ($q, $http) {
    var baseUrl = './api/rest/festival';
    var publicUrl = './api/public/sitegen';
    return {
      saveFestival: function (festival, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl,
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: festival
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findFestivals: function (lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      removeFestival: function (id) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl+"/"+id,
            method: 'DELETE',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      publicGet: function(page, max, lang){
        return $q(function (resolve, reject) {
          $http({
            url: publicUrl + '/festivals',
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'page': page,
              'max': max, 
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      },
      findByIdPublic : function(id, lang){
        return $q(function (resolve, reject) {
          $http({
            url: publicUrl + '/festivals/' + id,
            method: 'GET',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            }
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      }
    };
  }]);

})();

(function () {
	'use strict';

	angular.module('app.front').controller('FestivalController', FestivalController);

	function FestivalController($rootScope, $scope, $timeout,$location, toastr, FestivalService, languageService,$filter,$mdDialog,DocumentService,$sce,$state, userService, $anchorScroll) {
    $scope.userService = userService;
		$scope.language = {};
    $scope.festival = {
      publish : false
    };
    $scope.festivals = [];
    $scope.showForm = false;
    $scope.timeNotMatch = false;
    $scope.loaded = true;
    $scope.photos = [];
    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }
      $scope.$watch('language.key', function () {
        $scope.findFestivals($scope.language.key);
      });
    }).catch(function (error) {

    });

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.unsafe = function(content) {
      return $sce.trustAsHtml(content);
    };

    $scope.showFormFestival = function () {
      $scope.showForm = true;
    };

    $scope.cancelFestivalForm = function () {
      $scope.festival = {
        publish: false
      };
      $scope.showForm = false;
      $scope.photos = [];
    };


    // FIND ALL


    $scope.findFestivals = function (lang) {
      $scope.loaded = false;
      FestivalService.findFestivals(lang).then(function (festivals) {
        $scope.festivals = festivals.data;
        if($scope.festival.id){
          for(var i = 0; i < festivals.data.length; i++){
            if($scope.festival.id == festivals.data[i].id){
              $scope.festival = angular.copy(festivals.data[i]);
            }
          }
          $scope.festival.startDateForm = moment($scope.festival.dateStart).toDate();
          $scope.festival.endDateForm = moment($scope.festival.dateEnd).toDate();
          $scope.festival.startTime = moment($scope.festival.dateStart).format('HH:mm');
          $scope.festival.endTime = moment($scope.festival.dateEnd).format('HH:mm');
        }
        $scope.loaded = true;
      }).catch(function (data) {

      });
    };


    // SAVE FESTIVAL

    $scope.saveFestival = function () {


      var photos = [];

      for (var i = 0; i < $scope.photos.length; i++) {
        if ($scope.photos[i] != null && $scope.photos[i].uploadFile != null) {
          var photo = $scope.photos[i].uploadFile;
          photos.push(photo);
        }
      }

      if ($scope.festival.startDateForm != null && $scope.festival.startTime != null){
        $scope.festival.dateStart = moment($scope.festival.startDateForm).set('hours', $scope.festival.startTime.split(':')[0]).set('minutes', $scope.festival.startTime.split(':')[1]).toDate().getTime();
      }else if ($scope.festival.startDateForm != null){
        $scope.festival.dateStart = moment($scope.festival.startDateForm).toDate().getTime();
      }
      if ($scope.festival.endDateForm != null && $scope.festival.endTime != null){
        $scope.festival.dateEnd = moment($scope.festival.endDateForm).set('hours', $scope.festival.endTime.split(':')[0]).set('minutes', $scope.festival.endTime.split(':')[1]).toDate().getTime();
      }else if ($scope.festival.endDateForm != null){
        $scope.festival.dateEnd = moment($scope.festival.endDateForm).toDate().getTime();
      }
      if ($scope.festival.dateStart > $scope.festival.dateEnd) {
        $scope.timeNotMatch = true;
      } else {
        FestivalService.saveFestival($scope.festival, $scope.language.key).then(function (data) {



          //On upload les photos l'une après l'autre car le faire en parallèle cause une erreur côté back
          var fds = [];

          for (var i = 0; i < photos.length; i++) {
            var formData = new FormData();
            formData.append('file', photos[i]);
            formData.append('dto', angular.toJson({
              festivalId: data.data
            }));

            fds.push(formData);
          }

          var index = 0;

          if (fds.length > 0) {
            for (var i = 0; i < fds.length; i++) {
              if (i === 0) {
                if(i === fds.length - 1){
                  $scope.addPhoto(fds[i], i, true);
                }else{
                  $scope.addPhoto(fds[i], i);
                }
                index++;
              } else {
                $scope.$on('photoUploaded' + i, function () {
                  if (index === fds.length - 1) {
                    $scope.addPhoto(fds[index], index, true);
                  } else {
                    $scope.addPhoto(fds[index], index, false);
                  }

                  index++;
                });
              }
            }
          } else {
            $state.go('app.festival');
          }

          $scope.cancelFestivalForm();
          $scope.findFestivals($scope.language.key);
        }).catch(function (data) {
          console.log(data);
        });
      }
    };

    $scope.addPhoto = function (fd, i, last) {
      var index = angular.copy(i);
      DocumentService.save(fd).then(function (res) {
        $scope.$emit('photoUploaded' + (index + 1));
        if (last) {
          $scope.findFestivals($scope.language.key);
          $state.go('app.festival');
        }
      }).catch(function (err) {
        toastr.error($filter('translate')('FESTIVAL.ERROR_ADD_PHOTO'));
        $scope.$emit('photoUploaded' + (index + 1));
        if (last) {
          $state.go('app.festival');
        }
      });
    };


  //  UPDATE FESTIVAL

    $scope.updateFestival = function (festival) {
      $location.hash('formFestival');
      $anchorScroll();
      $scope.showForm = true;
      $scope.festival = angular.copy(festival);
      if ($scope.festival.dateStart != null){
        $scope.festival.startDateForm = moment($scope.festival.dateStart).toDate();
        $scope.festival.startTime = moment($scope.festival.dateStart).format('HH:mm');
      }
      if ($scope.festival.dateEnd != null){
        $scope.festival.endDateForm = moment($scope.festival.dateEnd).toDate();
        $scope.festival.endTime = moment($scope.festival.dateEnd).format('HH:mm');
      }
    };



    //  REMOVE FESTIVAL
    $scope.removeFestival = function (festival) {
      var content = {
        title: $filter('translate')('FESTIVAL.DELETE'),
        message: $filter('translate')('FESTIVAL.CONFIRM_DELETE')
      };
      $rootScope.openConfirmPopup(content).then(function () {
        FestivalService.removeFestival(festival.id).then(function (data) {
          $scope.findFestivals($scope.language.key);
          $scope.cancelFestivalForm();
        }).catch(function (data) {
          toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
        });
      }).catch(function () {

      });
    };




    //  DELETE PHOTO

    $scope.deletePhoto = function (index) {
      $scope.photos.splice(index, 1);
    };


    $scope.displayPopUpDeletePhoto = function (photo, index) {
      $scope.photoToDelete = angular.copy(photo);
      $scope.indexToDelete = index;
      $mdDialog.show({
        templateUrl: 'app/main/festival/popup/deletePhoto.popup.html',
        preserveScope: true,
        clickOutsideToClose: true,
        scope: $scope
      }).then(function () {

      }).catch(function () {

      });
    };


    $scope.deletePhotoPermanentely = function () {
      DocumentService.deleteFile($scope.photoToDelete.id).then(function (res) {
        $scope.festival.photos.splice($scope.indexToDelete, 1);
        toastr.success($filter('translate')('FESTIVAL.CONFIRM_MESSAGE_PHOTO'));
        $scope.findFestivals($scope.language.key);
        $scope.hidePopup();
      }).catch(function (err) {
        toastr.error($filter('translate')('FESTIVAL.ERROR_MESSAGE_PHOTO'));
      });
    };


  }
})();

(function () {
	'use strict';

	angular.module('app.front').controller('eventsController', eventsController);

	function eventsController($rootScope, $scope, $mdDialog, $filter, $state, toastr, eventService, URL) {

		$scope.URL = URL;
		$scope.currentUser = {
			eventIds: []
		};

		$scope.refresh = function () {
			eventService.findAll().then(function (response) {
				$scope.events = response.data;
			}).catch(function () {

			});
		};
		$scope.refresh();

		if ($rootScope.user != null) {
			$scope.currentUser = angular.copy($rootScope.user);
		} else {
			$scope.$on('rooScopeUser:ready', function () {
				$scope.currentUser = angular.copy($rootScope.user);
			});
		}

		$scope.goAdd = function () {
			$mdDialog.show({
				templateUrl: 'app/main/events/popup/add_event.html',
				controller: 'addEventController',
				clickOutsideToClose: true,
				locals: {
					event: {}
				}
			}).then(function () {
				$scope.refresh();
			}).catch(function () {

			});
		};

		$scope.update = function (event) {
			$mdDialog.show({
				templateUrl: 'app/main/events/popup/add_event.html',
				controller: 'addEventController',
				clickOutsideToClose: true,
				locals: {
					event: event
				}
			}).then(function () {
				$scope.refresh();
			}).catch(function () {

			});

		};

		$scope.showPopUpDelete = function (event, index) {
			$scope.eventToDelete = angular.copy(event);
			$scope.indexToDelete = index;

			$mdDialog.show({
				templateUrl: 'app/main/popup/confirm.html',
				clickOutsideToClose: true,
				controller: 'confirmPopupController',
				locals: {
					content: {
						title: $filter('translate')('EVENT.POPUP_DELETE.TITLE'),
						message: $filter('translate')('EVENT.POPUP_DELETE.MESSAGE')
					}
				}
			}).then(function () {
				$scope.remove();
			}).catch(function () { });
		};

		$scope.remove = function () {
			eventService.delete($scope.eventToDelete.id).then(function (res) {
				toastr.success($filter('translate')('EVENT.SUCCESS_DELETE'));
				var indexToRemove = null;
				for (var i = 0; i < $scope.events.length; i++) {
					if ($scope.events[i].id === $scope.eventToDelete.id) {
						indexToRemove = i;
						break;
					}
				}
				if (indexToRemove != null) {
					$scope.events.splice(indexToRemove, 1);
				}
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				console.log(err);
			});
		};

		$scope.goToInscriptionStatus = function () {
			$state.go('app.events.inscriptionStatus');
		};

		$scope.goToLogisticalStatus = function () {
			$state.go('app.events.logisticalStatus');
		};

		$scope.seeInscriptionForms = function (event) {
			$state.go('app.events.inscriptionForms', {
				id: event.id
			});
		};

		$scope.goToSubCategories = function () {
			$state.go('app.events.inscriptionSubCategories');
		};

		$scope.seeInscriptionFields = function (event) {
			$state.go('app.events.inscriptionModel', {
				id: event.id
			});
		};

		$scope.seeLogisticalFields = function (event) {
			$state.go('app.events.logisticalModel', {
				id: event.id
			});
		};
	}
})();

(function(){
	'use strict';

	angular.module('app.front').service('eventService', eventService);

	function eventService($http, $q){
		var service = {};

		

		service.save = function(fmData){
			return $q(function(resolve, reject){
				$http({
					url: '/api/rest/event',
					method: 'POST',
					headers: {'Content-Type': undefined},
					data: fmData,
					params: {'_v': new Date().getTime()}
				}).then(function(response){
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service.delete = function(id){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/event/' + id,
					method: 'DELETE',
					headers: {
						'Content-Type': undefined
					},
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};


		service.findAll = function(){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/event',
					method: 'GET',
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});

		};

		service.listNotSubscribed = function(contactId){
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/event/contact/'+contactId,
					method: 'GET',
					headers: {
						'Content-Type': 'application/json;charset=utf-8'
					},
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		return service;
	}
})();
(function () {
	'use strict';

	angular.module('app.front').service('DuplicationToolService', DuplicationToolService);

	function DuplicationToolService($q, $http, $filter) {

		var service = {};
		var FIRST_CATEGORY_INDEX = 1;

		service.lookForDuplicates = function (dToolDto, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/rest/duplication-tool/lookForDuplicates',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
					data: dToolDto
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service._getDuplicatesModelsInfos = function (_lang, _modelType, _modelSubTypeId, _modelsToMergeIds) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/rest/duplication-tool/getDuplicatesModelsInfos',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': _lang,
						'modelType': _modelType,
						'modelSubTypeId': _modelSubTypeId
					},
					data: {
						duplicateIds: _modelsToMergeIds
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service._mergeDuplicatesModels = function (_lang, _modelType, _modelSubTypeId, _modelsToMerge) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/rest/duplication-tool/mergeDuplicatesModels',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'lang': _lang,
						'modelType': _modelType,
						'modelSubTypeId': _modelSubTypeId
					},
					data: _modelsToMerge
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service._autoMergeDuplicatesModel = function (_modelType, _modelSubTypeId, _companyId) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/rest/duplication-tool/autoMergeDuplicatesModel',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'modelType': _modelType,
						'modelSubTypeId': _modelSubTypeId,
						"companyId": _companyId
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service._autoMergeDuplicatesModelStep = function (_modelType, _modelSubTypeId, _companyId, pagination, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/rest/duplication-tool/autoMergeDuplicatesModelStep',
					method: 'POST',
					params: {
						'_v': new Date().getTime(),
						'modelType': _modelType,
						'modelSubTypeId': _modelSubTypeId,
						"companyId": _companyId,
						'lang': lang
					},
					data: pagination
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service._junkBoxFindAll = function (_lang) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/rest/duplication-tool/junkBox',
					method: "GET",
					params: {
						'_v': new Date().getTime(),
						'lang': _lang
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service._junkBoxDelete = function (id) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/rest/duplication-tool/junkBox/' + id,
					method: "DELETE",
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		service._junkBoxDetails = function (id, lang) {
			return $q(function (resolve, reject) {
				$http({
					url: './api/rest/duplication-tool/junkBox/' + id,
					method: 'GET',
					params: {
						'_v': new Date().getTime(),
						'lang': lang
					},
				}).then(function (response) {
					response.data.categories = service.buildModel(response.data.categories, response.data.categories.model);
					resolve(response);
				}).catch(function (error) {
					reject(error);
				});
			});
		};

		function findFirstCategory(categories) {
			var found = false;
			var index = 0;
			while (!found && index < categories.length) {
				var category = categories[index];
				if (category.index === FIRST_CATEGORY_INDEX) {
					return category;
				}
				index++;
			}
		}

		function setSelectedList(field) {
			var valueReturned = null;
			if (field.listFieldId != null) {
				for (var k = 0; k < field.listFieldsDTO.length; k++) {
					if (field.listFieldId === field.listFieldsDTO[k].id) {
						valueReturned = field.listFieldsDTO[k];
					}
				}
			}
			return valueReturned;
		}

		function setSelectedObject(field, data) {
			var valueReturned = null;
			if (data[field.keyJava]) {
				for (var k = 0; k < field.selectableObject.length; k++) {
					if (data[field.keyJava].id == field.selectableObject[k].id) {
						valueReturned = field.selectableObject[k];
					}
				}
			}
			return valueReturned;
		}

		function setSelectedMultipleObject(field, data) {
			var values = [];
			if (data[field.keyJava]) {
				for (var l = 0; l < data[field.keyJava].length; l++) {
					for (var k = 0; k < field.selectableObject.length; k++) {
						if (data[field.keyJava][l].id === field.selectableObject[k].id) {
							values.push(field.selectableObject[k]);
						}
					}
				}
			}
			return values;
		}

		service.buildModel = function (categories, contact) {
			var firstCategory = findFirstCategory(categories);
			if (firstCategory) {
				for (var i = 0; i < firstCategory.values.length; i++) {
					var field = firstCategory.values[i];
					if (field.fixField) {
						if ((field.selectableObject == null || field.selectableObject.length < 1)) {
							field.value = contact[field.keyJava];
						} else {
							if (field.typeChamps === 'OBJECT') {
								field.value = setSelectedObject(field, contact);
							} else {
								field.value = setSelectedMultipleObject(field, contact);
							}
						}
					}
				}
			}
			angular.forEach(categories, function (category, key) {
				for (var i = 0; i < category.values.length; i++) {
					var field = category.values[i];
					///field.fieldEditable = false;
					if (field.typeChamps === 'LIST_SELECT') {
						field.value = setSelectedList(field);
					} else if (field.typeChamps === 'DATE') {
						field.dateTime = null;
						if (field.value != null && field.value !== '') {
							field.dateTime = $filter('stringToDate')(field.value);
						}
					} else if (field.typeChamps === 'BOOLEAN') {
						field.value = 'true' === field.value;
					}
				}
				angular.forEach(category.subCategories, function (category, key) {
					for (var i = 0; i < category.values.length; i++) {
						var field = category.values[i];
						//field.fieldEditable = false;
						if (field.typeChamps === 'LIST_SELECT') {
							field.value = setSelectedList(field);
						} else if (field.typeChamps === 'DATE') {
							field.dateTime = null;
							if (field.value != null && field.value !== '') {
								field.dateTime = $filter('stringToDate')(field.value);
							}
						} else if (field.typeChamps === 'BOOLEAN') {
							field.value = 'true' === field.value;
						}
					}
				});
			});
			return categories;
		};

		return service;

	}

})();

(function () {
	'use strict';

	angular.module('app.front').controller('DuplicationToolController', DuplicationToolController);

	function DuplicationToolController($rootScope, $scope, $q, $filter, $state, $translate, $mdDialog, $element, toastr, MODELS_TYPES, modelService,
		DuplicationToolService, companyService) {

		// Constantes

		$scope.MODEL_BASE_URL = './api/rest/model/';
		$scope.MODELS_TYPES = MODELS_TYPES;

		$scope.search = {
			company: ''
		};

		// Variables

		$scope.progress = {
			inProgress: {
				value: false
			},
			initDataInProgress: {
				value: false
			},
			fieldsListInProgress: {
				value: false
			}
		}

		var timeoutCanceler = $q.defer();

		$scope._companyPage = 0;
		$scope._companies = [];
		$scope._allFieldsCompany = [];

		$scope.duplicationToolDto = {};
		$scope.duplicationToolForm = {};
		$scope.duplicatesEntityDto = {};

		// Handle params

		if ($state.params._modelType) {
			$scope.progress.initDataInProgress.value = true;
			$scope.duplicationToolDto.modelType = $state.params._modelType;
		}

		if ($state.params._modelSubTypeId) {
			$scope.duplicationToolDto.modelSubTypeId = parseInt($state.params._modelSubTypeId, 10);
		}

		if ($state.params._companyId) {
			$scope.duplicationToolDto.companyId = parseInt($state.params._companyId, 10);
		}

		if ($state.params._fields) {
			$scope.duplicationToolDto.fields = angular.copy($state.params._fields);
		}

		if ($state.params._modelPaginationDto) {
			$scope.duplicationToolDto.modelPaginationDto = angular.copy($state.params._modelPaginationDto);
		}

		/**
		 *
		 */

		// md-select input search

		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		/**
		 *
		 */

		// Init

		modelService.getSubTypes(
			$scope.MODEL_BASE_URL + $scope.MODELS_TYPES.COMPANY_MODEL,
			$translate.preferredLanguage(),
			true
		).then(function (resp) {
			$scope.modelSubTypes = resp.data;
			if ($scope.duplicationToolDto.modelType) {
				if ($scope.duplicationToolDto.modelType == $scope.MODELS_TYPES.CONTACT_MODEL) {
					$scope.listFields($scope.duplicationToolDto.modelType, null, $scope.progress.initDataInProgress);
					$scope.cancelSearch();
					companyService.filterByString($scope.search.company, null, $translate.preferredLanguage(), timeoutCanceler, $scope.duplicationToolDto.companyId).then(function (res) {
						if (res.data) {
							$scope._companies = res.data;
						}
					}).catch(function (err) {
						console.log(err);
						$scope.progress.initDataInProgress.value = false;
					});
				} else if ($scope.duplicationToolDto.modelType == $scope.MODELS_TYPES.COMPANY_MODEL) {
					if ($scope.duplicationToolDto.modelSubTypeId) {
						$scope.listFields($scope.duplicationToolDto.modelType, $scope.duplicationToolDto.modelSubTypeId, $scope.progress.initDataInProgress);
						$scope.cancelSearch();
						companyService.filterByString($scope.search.company, $scope.duplicationToolDto.modelSubTypeId, $translate.preferredLanguage(), timeoutCanceler, $scope.duplicationToolDto.companyId).then(function (res) {
							if (res.data) {
								$scope._companies = res.data;
							}
						}).catch(function (err) {
							console.log(err);
							$scope.progress.initDataInProgress.value = false;
						});
					} else {
						$scope.listFields($scope.duplicationToolDto.modelType, null, $scope.progress.initDataInProgress);
					}
				}
			}
		}).catch(function (err) {
			$scope.progress.initDataInProgress.value = false;
			console.log(err)
		});

		/**
		 * Utils
		 */

		$scope.listFields = function (typeParam, subTypeParam, progressChecker) {
			if (subTypeParam) {
				modelService.listFieldsBySubType(
					typeParam,
					subTypeParam,
					$translate.preferredLanguage()
				).then(function (resp) {
					$scope.fields = $filter('filter')(resp.data, function (item) {
						return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
					});
					progressChecker.value = false;
				}).catch(function (err) {
					progressChecker.value = false;
					console.log(err)
				});
			} else {
				modelService.listFieldsByType(
					typeParam,
					$translate.preferredLanguage()
				).then(function (resp) {
					$scope.fields = $filter('filter')(resp.data, function (item) {
						return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
					});
					if (typeParam === $scope.MODELS_TYPES.COMPANY_MODEL) {
						$scope._allFieldsCompany = angular.copy($scope.fields)
					}
					progressChecker.value = false;
				}).catch(function (err) {
					progressChecker.value = false;
					console.log(err);
				});
			}
		};

		$scope.cancelSearch = function () {
			if (timeoutCanceler != null) {
				timeoutCanceler.resolve();
			}
			timeoutCanceler = $q.defer();
		};

		$scope.searchCompany = function () {
			$scope.cancelSearch();
			companyService.filterByString($scope.search.company, $scope.duplicationToolDto.modelSubTypeId, $translate.preferredLanguage(), timeoutCanceler, $scope.duplicationToolDto.companyId).then(function (res) {
				if (res.data) {
					$scope._companies = res.data;
				}
			}).catch(function (err) {
				console.log(err);
			});
		};


		/**
		 *
		 */

		// Model type select handle

		$scope.modelTypeSelectedFn = function () {
			if ($scope.duplicationToolDto && $scope.duplicationToolDto.modelType) {
				delete $scope.duplicationToolDto.modelSubTypeId;
				delete $scope.duplicationToolDto.companyId;
				delete $scope.duplicationToolDto.contactId;
				delete $scope.duplicationToolDto.fieldCategoryId;
				delete $scope.duplicationToolDto.fields;
				delete $scope.duplicationToolDto.modelPaginationDto;
				delete $scope.duplicatesEntityDto.dto;
				if ($scope.duplicationToolDto.modelType === $scope.MODELS_TYPES.CONTACT_MODEL) {
					$scope.progress.fieldsListInProgress.value = true;
					$scope.cancelSearch();
					companyService.filterByString($scope.search.company, null, $translate.preferredLanguage(), timeoutCanceler, null).then(function (res) {
						if (res.data) {
							$scope._companies = res.data;
						}
						$scope.listFields($scope.duplicationToolDto.modelType, null, $scope.progress.fieldsListInProgress);
					}).catch(function (err) {
						console.log(err);
						$scope.progress.fieldsListInProgress.value = false;
					});

				} else if ($scope.duplicationToolDto.modelType === $scope.MODELS_TYPES.COMPANY_MODEL) {
					// No process
					// Company model fields are loaded when company subtype is selected
				} else {
					// No process
				}
			}
		};


		// Model subtype select handle

		$scope.modelSubTypeSelectedFn = function () {
			if ($scope.duplicationToolDto.modelType && $scope.duplicationToolDto && $scope.duplicationToolDto.modelSubTypeId) {
				delete $scope.duplicationToolDto.contactId;
				delete $scope.duplicationToolDto.companyId;
				delete $scope.duplicationToolDto.modelPaginationDto;
				delete $scope.duplicationToolDto.fields;
				if ($scope.duplicationToolDto.modelType == MODELS_TYPES.COMPANY_MODEL) {
					$scope.progress.fieldsListInProgress.value = true;
					if ($scope.duplicationToolDto.modelSubTypeId === -1) {
						if ($scope._allFieldsCompany && $scope._allFieldsCompany.length > 0) {
							$scope.fields = angular.copy($scope._allFieldsCompany);
							$scope.progress.fieldsListInProgress.value = false;
						} else {
							$scope.listFields($scope.duplicationToolDto.modelType, null, $scope.progress.fieldsListInProgress);
						}
					} else {
						$scope.listFields($scope.duplicationToolDto.modelType, $scope.duplicationToolDto.modelSubTypeId, $scope.progress.fieldsListInProgress);
					}
				} else if ($scope.duplicationToolDto.modelType == MODELS_TYPES.CONTACT_MODEL) {
					if (!$scope._companies || ($scope._companies && $scope._companies.length === 0)) {
						$scope.progress.fieldsListInProgress.value = true;
						$scope.cancelSearch();
						companyService.filterByString($scope.search.company, $scope.duplicationToolDto.modelSubTypeId, $translate.preferredLanguage(), timeoutCanceler, $scope.duplicationToolDto.companyId).then(function (res) {
							if (res.data) {
								$scope._companies = res.data;
							}
						}).catch(function (err) {
							console.log(err);
							$scope.progress.fieldsListInProgress.value = false;
						});
					}
				}
			}
		};


		// Submit

		$scope.lookForDuplicatesFn = function () {
			$scope.duplicationToolForm.form.$setSubmitted();
			if ($scope.duplicationToolForm.form.$valid) {
				// if ($scope.duplicationToolDto.modelPaginationDto != null) {
				// 	delete $scope.duplicationToolDto.modelSubTypeId;
				// }
				$scope.progress.inProgress.value = true;
				DuplicationToolService.lookForDuplicates(
					$scope.duplicationToolDto,
					$translate.preferredLanguage()
				).then(function (resp) {
					$scope.duplicatesEntityDto.dto = resp.data;
					$scope.progress.inProgress.value = false;
				}).catch(function (err) {
					$scope.progress.inProgress.value = false;
					console.log(err)
				});
			}
		};

		// Remove duplicate

		$scope.removeDuplicatesFn = function (_modelsToMerge) {
			/*$state.go("app.merge_tool", {
			    '_modelType' :  $scope.duplicationToolDto.modelType,
			    '_modelSubTypeId' : $scope.duplicationToolDto.modelSubTypeId,
			    '_modelsToMerge' : _modelsToMerge
			});*/
			$state.goNewTab("app.merge_tool", {
				'_modelType': $scope.duplicationToolDto.modelType,
				'_modelSubTypeId': $scope.duplicationToolDto.modelSubTypeId,
				'_modelsToMerge': _modelsToMerge
			});
		};

	}

})();

(function () {
    'use strict';
  
    angular.module('app.front').service('DataImportService', DataImportService);
  
    function DataImportService($q, $http, $filter) {
  
      var service = {};

      service.columnsMatching = function (fd) {
          return $q(function (resolve, reject) {
            $http({
                url: "/api/rest/dataimport/columnsMatching",
                method: "POST",
                params: {
                    '_v': new Date().getTime()
                },
                headers: {
                    "Content-Type": undefined
                },
                transformRequest: angular.identity,
                data: fd
            }).then(function (response) {
                resolve(response);
            }).catch(function (response) {
                reject(response);
            });
          });
      };

      service.updatingData = function (fd) {
        return $q(function (resolve, reject) {
          $http({
              url: "/api/rest/dataimport/updatingData",
              method: "POST",
              params: {
                '_v': new Date().getTime()
              },
              headers: {
                "Content-Type": undefined
              },
              transformRequest: angular.identity,
              data: fd
          }).then(function (response) {
              resolve(response);
          }).catch(function (response) {
              reject(response);
          });
        });
      };

      service.importData = function (fd, overwriteData) {
        return $q(function (resolve, reject) {
          $http({
              url: "/api/rest/dataimport/importData",
              method: "POST",
              params: {
                  '_v': new Date().getTime(),
                  'overwriteData': overwriteData
              },
              headers: {
                  "Content-Type": undefined
              },
              transformRequest: angular.identity,
              data: fd
          }).then(function (response) {
              resolve(response);
          }).catch(function (response) {
              reject(response);
          });
        });
      };

      service.importResultData = function (data, lang) {
        return $q(function (resolve, reject) {
          $http({
              url: "/api/rest/dataimport/importResultData",
              method: "POST",
              params: {
                '_v': new Date().getTime(),
                'lang' : lang
              },
              data: JSON.stringify(data)
          }).then(function (response) {
              resolve(response);
          }).catch(function (response) {
              reject(response);
          });
        });
      };    
  
      return service;
  
    }
  
  })();
  
(function () {
	'use strict';

	angular.module('app.front').controller('DataImportController', DataImportController);

	function DataImportController($rootScope, $scope, $timeout, $filter, $state, $translate, $mdDialog, $element, toastr, MODELS_TYPES,
		modelService, DataImportService, languageService) {

		$scope.MODEL_BASE_URL = './api/rest/model/';
		$scope.MODELS_TYPES = MODELS_TYPES
		//$scope.MODELS_TYPES.MEMBER = 'MEMBER';
		/*$scope.MEMBER_FIELDS = [{
		    value : "LOGIN"
		},{
		    value : "PASSWORD"
		}];*/
		$scope.error = {};
		$scope.inProgress = false;
		$scope._sheets = [];
		$scope.dataImportForm = {
			fileForm: null,
			matchingForm: null,
			duplicateModelsform: null,
			updatingDataForm: null
		};
		$scope._dataImportResults = [];
		$scope._importMode = {
			value: null
		};
		$scope.overwriteData = {
			value: false
		};

		$scope.languages = [];
		$scope.language = {};

		// Utils

		// md-select input search
		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};

		// Reset all forms
		$scope._resetFormFn = function (_form) {
			if (_form) {
				try {
					_form.$setPristine();
					_form.$setUntouched();
				} catch (error) {
					console.error(error);
				}
			};
		}
		$scope._resetFormsFn = function () {
			$scope._resetFormFn($scope.dataImportForm.fileForm);
			$scope._resetFormFn($scope.dataImportForm.matchingForm);
			$scope._resetFormFn($scope.dataImportForm.duplicateModelsform);
			$scope._resetFormFn($scope.dataImportForm.updatingDataForm);
		};

		// Language
		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
		}).catch(function (error) {
			console.log(error);
		});

		// Init company model subtype
		modelService.getSubTypes(
			$scope.MODEL_BASE_URL + $scope.MODELS_TYPES.COMPANY_MODEL,
			$translate.preferredLanguage(),
			true
		).then(function (resp) {
			$scope.modelSubTypes = resp.data;
		}).catch(function (err) {
			console.log(err)
		});

		// Collect file column
		$scope.onColumnsMatching = function () {
			$scope.dataImportForm.fileForm.$setSubmitted();
			if ($scope.dataImportForm.fileForm.$valid) {
				$scope.inProgress = true;
				$scope._dataImportResults = [];
				var input = document.getElementById('data_import_input_file');
				var file = null;
				$scope.error.file = false;
				if (input != null) {
					file = input.files[0];
					if (file == null) {
						$scope.error.file = true;
					}
				} else {
					$scope.error.file = true;
				}
				if (!$scope.error.file) {
					$scope._importMode.value = "MATCHING_COLUMN";
					var fd = new FormData();
					fd.append('file', file);
					fd.append('lang', $translate.preferredLanguage());
					DataImportService.columnsMatching(fd).then(function (response) {
						$scope._sheets = response.data;
						$scope.inProgress = false;
						$scope._resetFormsFn();
					}).catch(function (response) {
						toastr.error('An error occured during processing the application');
						$scope.inProgress = false;
					});
				} else {
					$scope.inProgress = false;
				}
			}
		};

		// Updating
		$scope.onUpdatingData = function () {
			$scope.dataImportForm.fileForm.$setSubmitted();
			if ($scope.dataImportForm.fileForm.$valid) {
				$scope.inProgress = true;
				$scope._dataImportResults = [];
				var input = document.getElementById('data_import_input_file');
				var file = null;
				$scope.error.file = false;
				if (input != null) {
					file = input.files[0];
					if (file == null) {
						$scope.error.file = true;
					}
				} else {
					$scope.error.file = true;
				}
				if (!$scope.error.file) {
					$scope._importMode.value = "UPDATING_DATA";
					$scope.inProgress = false;
				} else {
					$scope.inProgress = false;
				}
			}
		};

		$scope.onUpdatingDataSubmit = function () {
			$scope.dataImportForm.fileForm.$setSubmitted();
			$scope.dataImportForm.updatingDataForm.$setSubmitted();
			if ($scope.dataImportForm.fileForm.$valid && $scope.dataImportForm.updatingDataForm.$valid) {
				$scope.inProgress = true;
				$scope._dataImportResults = [];
				var input = document.getElementById('data_import_input_file');
				var file = null;
				$scope.error.file = false;
				if (input != null) {
					file = input.files[0];
					if (file == null) {
						$scope.error.file = true;
					}
				} else {
					$scope.error.file = true;
				}
				if (!$scope.error.file) {
					$scope._resetFormsFn();
					var fd = new FormData();
					fd.append('file', file);
					fd.append('lang', $scope.language.key);
					DataImportService.updatingData(fd).then(function (response) {
						$scope._dataImportResults = [{
							test: 'test'
						}];
						$scope.inProgress = false;
						$scope._resetFormsFn();
					}).catch(function (response) {
						toastr.error('An error occured during processing the application');
						$scope.inProgress = false;
					});
				} else {
					$scope.inProgress = false;
				}
			}
		};

		// Model type select handle
		$scope.modelTypeSelectedFn = function (_column) {
			delete _column.fieldId;
			delete _column.modelSubTypeId;
			if (_column.modelType === $scope.MODELS_TYPES.CONTACT_MODEL) {
				$scope.inProgress = true;
				modelService.listFieldsByType(
					$scope.MODELS_TYPES.CONTACT_MODEL,
					$translate.preferredLanguage()
				).then(function (resp) {
					_column.fields = $filter('filter')(resp.data, function (item) {
						return item.typeChamps !== 'RICH_TEXT'
							//&& item.typeChamps !== 'LIST_SELECT'
							//&& item.typeChamps !== 'MULTIPLE_SELECT'
							&&
							item.typeChamps !== 'OBJECT' &&
							item.typeChamps !== 'IMAGE' &&
							item.typeChamps !== 'FILE';
					});
					$scope.inProgress = false;
				}).catch(function (err) {
					$scope.inProgress = false;
					console.log(err);
				});
			}
		};

		// Model subtype select handle
		$scope.modelSubTypeSelectedFn = function (_column) {
			$scope.inProgress = true;
			delete _column.fieldId;
			modelService.listFieldsBySubType(
				$scope.MODELS_TYPES.COMPANY_MODEL,
				_column.modelSubTypeId,
				$translate.preferredLanguage()
			).then(function (resp) {
				_column.fields = $filter('filter')(resp.data, function (item) {
					return item.typeChamps !== 'RICH_TEXT' && item.typeChamps !== 'OBJECT' && item.typeChamps !== 'IMAGE' && item.typeChamps !== 'FILE';
				});
				$scope.inProgress = false;
			}).catch(function (err) {
				$scope.inProgress = false;
				console.log(err)
			});
		};

		// Import data
		$scope.importDataFn = function () {
			$scope.errorImport = null;
			$scope.inProgress = true;
			var _atLeastOneFieldHasBeenSelected = false;
			for (var i = 0; i < $scope._sheets.length; i++) {
				for (var j = 0; j < $scope._sheets[i].columns.length; j++) {
					if ($scope._sheets[i].columns[j].modelType) {
						_atLeastOneFieldHasBeenSelected = true;
						break;
					}
				}
				if (_atLeastOneFieldHasBeenSelected == true) {
					break;
				}
			}
			if (!_atLeastOneFieldHasBeenSelected) {
				toastr.error('At least one field is required !!!');
			}
			var input = document.getElementById('data_import_input_file');
			var file = null;
			$scope.error.file = false;
			if (input != null) {
				file = input.files[0];
				if (file == null) {
					$scope.error.file = true;
				}
			} else {
				$scope.error.file = true;
			}
			if (!$scope.error.file && _atLeastOneFieldHasBeenSelected) {
				var fd = new FormData();
				fd.append('file', file);
				fd.append('dto', angular.toJson($scope._sheets));
				fd.append('lang', $translate.preferredLanguage());
				DataImportService.importData(fd, $scope.overwriteData.value).then(function (response) {
					$scope._sheets = [];
					$scope._dataImportResults = response.data;
					$scope.inProgress = false;
					toastr.success($filter('translate')('DATA_IMPORT.IMPORT_SUCCESS'));
					$scope._resetFormsFn();
				}).catch(function (response) {
					if(response.status === 409 && response.data){
						$scope.errorImportRows = response.data.row;
						$scope.errorImportColumns = response.data.column;
						$scope.errorImport = true;
					}
					toastr.error('An error occured during processing the application');
					$scope.inProgress = false;
				});
			} else {
				$scope.inProgress = false;
			}
		};

		// Checked row is a duplicate

		$scope._rowIsADuplicateFn = function (_row, _rows) {
			if (_row.modelType === 'COMPANY_MODEL') {
				angular.forEach(_rows, function (item, index) {
					if (item.modelType === 'CONTACT_MODEL') {
						if (_row.isADuplicate) {
							item.companyIsADuplicate = true;
						} else {
							item.isADuplicate = false;
							item.companyIsADuplicate = false;
						}
					}
				});
			}
		};

		// Select field to update if duplicate
		$scope._modelFieldSelectedFn = function (_sheet, _row, _field, _handelValue, _unhandleValue) {
			if (_handelValue.selected) {
				_unhandleValue.selected = false;
				_field.noModelSelected = false;
			} else {
				_field.noModelSelected = true;
			}
		};

		// New model from file OR Maj
		$scope.submitImportDataResult = function () {
			$scope.inProgress = true;
			var _isValidOperation = true;
			for (var i = 0; i < $scope._dataImportResults.length; i++) {
				for (var j = 0; j < $scope._dataImportResults[i].rows.length; j++) {
					for (var k = 0; k < $scope._dataImportResults[i].rows[j].length; k++) {
						if ($scope._dataImportResults[i].rows[j][k].isADuplicate) {
							for (var l = 0; l < $scope._dataImportResults[i].rows[j][k].valuedFields.length; l++) {
								if ($scope._dataImportResults[i].rows[j][k].valuedFields[l].noModelSelected) {
									_isValidOperation = false;
									break;
								}
							}
						}
						if (!_isValidOperation) break;
					}
					if (!_isValidOperation) break;
				}
				if (!_isValidOperation) break;
			}
			if (_isValidOperation) {
				DataImportService.importResultData($scope._dataImportResults, $translate.preferredLanguage()).then(function (response) {
					$scope._sheets = [];
					$scope._dataImportResults = [];
					$scope.inProgress = false;
					toastr.success($filter('translate')('DATA_IMPORT.IMPORT_SUCCESS'));
					$scope._resetFormsFn();
				}).catch(function (response) {
					toastr.error('An error occured during processing the application');
					$scope.inProgress = false;
				});
			} else {
				$scope.inProgress = false;
				toastr.error($filter('translate')('DATA_IMPORT.DUPLICATE_NO_FIELD_VALUE_SELECTED_ERROR'));
			}
		};

		$scope.overwriteDataChanged = function () {
			if ($scope.overwriteData.value) {
				$scope._sheets.forEach(function (sheet, i) {
					$scope._sheets[i].columns.forEach(function (column, j) {
						$scope._sheets[i].columns[j].lookForDuplicate = false;
					});
				});
			}
		};

	}

})();

(function () {
  'use strict';

  angular.module('app.front').service('CalendarExternService', ['$q', '$http', function ($q, $http) {
    var baseUrl = './api/rest/eventExtern';
    return {
      saveEvent: function (event, lang) {
        return $q(function (resolve, reject) {
          $http({
            url: baseUrl,
            method: 'POST',
            params: {
              '_v': new Date().getTime(),
              'lang': lang
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: event
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      }
    };
  }]);

})();

(function () {
	'use strict';

	angular.module('app.front').controller('CalendarExternController', CalendarExternController);

	function CalendarExternController($rootScope, $scope, $timeout,$location, toastr, CalendarExternService, languageService,$filter,$mdDialog,DocumentService,$sce, uiCalendarConfig) {
    $scope.languages = [];
    $scope.language = {};
    $scope.events = [];
  $scope.event = {};
	  $scope.calendarUiConfig = {
      calendar: {
        lang: 'fr',
        eventLimit: true,
        header: '',
        handleWindowResize: false,
        aspectRatio: 1,
        dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
        dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
        slotLabelFormat:'HH:mm',
        allDaySlot:false,
        viewRender: function (view) {
          $scope.calendarView = view;
          $scope.calendar = $scope.calendarView.calendar;
          $scope.currentMonthShort = $scope.calendar.getDate().format('MMM');
          $scope.currentMonthKey = "month-" + $scope.calendar.getDate().format('M');
        },
        columnFormat: {
          month: 'ddd',
          week: 'ddd D',
          day: 'ddd M'
        },
        timeFormat: 'H:mm',
        // eventClick: eventDetail,
        selectable: false,
        selectHelper: true,
        // select: select,
        eventRender: function (event, element, view) {
          return (!event.ranges) || ((event.ranges[0].week === 1) || (event.ranges[0].week === "1") || (moment(event.start).week() % 2 === moment().week() % 2));
        },
        defaultView: 'agendaWeek'
      }
    };

    languageService.getLanguages().then(function (response) {
      $scope.languages = response.data;
      for (var i = 0; i < $scope.languages.length; i++) {
        var language = $scope.languages[i];
        if (language.preferred) {
          $scope.language.key = language.key;
          break;
        }
      }
      $scope.$watch('language.key', function () {
        // $scope.findFolders($scope.language.key, $scope.newFolder.idParent);
      });
    }).catch(function (error) {

    });

    $scope.changeView = function (view) {
      if (view == 'today') {
        $scope.calendar.today();
      } else {
        $scope.calendar.changeView(view);
      }
      var viewType = uiCalendarConfig.calendars.myCalendar.fullCalendar('getView');
    };


    /**
     * Go to next on current view (week, month etc.)
     */
    $scope.next = function() {
      $scope.calendarView.calendar.next();
      uiCalendarConfig.calendars.myCalendar.fullCalendar('removeEvents');
      var viewType = uiCalendarConfig.calendars.myCalendar.fullCalendar('getView');
      // vm.findAllDisponibilities(viewType);
    };

    /**
     * Go to previous on current view (week, month etc.)
     */
    $scope.prev = function() {
      $scope.calendarView.calendar.prev();
      uiCalendarConfig.calendars.myCalendar.fullCalendar('removeEvents');
      var viewType = uiCalendarConfig.calendars.myCalendar.fullCalendar('getView');
      // vm.findAllDisponibilities(viewType);
    };

    $scope.addEvent = function () {
      $scope.eventPopup = $mdDialog.show({
        templateUrl: 'app/main/calendarExtern/popup/addEvent.html',
        parent: angular.element(document.body),
        clickOutsideToClose: true,
        scope: $scope,
        preserveScope: true
      }).then(function () {
      }).catch(function () {
      });
    };

    $scope.hidePopup = function () {
      $mdDialog.hide();
    };

    $scope.saveEvent = function () {
      console.log($scope.event);
      $scope.event.dateStart = moment($scope.event.startDateForm).set('hours', $scope.event.startTime.split(":")[0]).set('minutes', $scope.event.startTime.split(":")[1]).toDate().getTime();
      $scope.event.dateEnd = moment($scope.event.endDateForm).set('hours', $scope.event.endTime.split(":")[0]).set('minutes', $scope.event.endTime.split(":")[1]).toDate().getTime();

      CalendarExternService.saveEvent($scope.event,$scope.language.key).then(function (data) {
        $scope.hidePopup();
      }).catch(function (data) {

      });
    };
  }
})();

(function () {
	'use strict';

	angular.module('app.front').service('BlogService', ['$q', '$http', function ($q, $http) {
		var baseUrl = './api/rest/blog';
		var publicBaseUrl = './api/public/sitegen';
		return {
			saveArticle: function (article, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/article',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: article
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			saveTag: function (tag, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/tag',
						method: 'POST',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						},
						data: tag
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findAllArticles: function (lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/article/findAll',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findAllTags: function (lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/tag/findAllTags',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			removeArticle: function (articleId) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/' + articleId,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			removeTag: function (tagID) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/tag/' + tagID,
						method: 'DELETE',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findXLast: function (x, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: publicBaseUrl + '/articles/last',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'last': x
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findRemains: function (x, page, max, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: publicBaseUrl + '/articles',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'last': x,
							'page': page,
							'max': max
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			findById: function (id, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: publicBaseUrl + '/articles/' + id,
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			setActive: function (articleId) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/article/active/' + articleId,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			setFavorite: function (articleId) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/article/coup-coeur/' + articleId,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}, up: function (tagsID) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/tag/up-tag/' + tagsID,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}, down: function (tagsID) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/tag/down-tag/' + tagsID,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}, addCompanyToBlog: function (articleId, companyId, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/addCompany/' + articleId + '/' + companyId,
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}, deleteCompanyFromBlog: function (articleId, companyId, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/deleteCompany/' + articleId + '/' + companyId,
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}, upCompany: function (articleId, companyId, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/upCompany/' + articleId + '/' + companyId,
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}, downCompany: function (articleId, companyId, lang) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/downCompany/' + articleId + '/' + companyId,
						method: 'PUT',
						params: {
							'_v': new Date().getTime(),
							'lang': lang
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			},
			filterByString: function (value, lang, type) { //type = TAGS,COUNTRIES, REGIONS or ARTICLES
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/filterByString',
						method: 'GET',
						params: {
							'_v': new Date().getTime(),
							'lang': lang,
							'value': value,
							'type': type
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}, setMiniature: function (id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/setMiniature/' + id,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}, upPhoto: function (id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/up-photo/' + id,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}, downPhoto: function (id) {
				return $q(function (resolve, reject) {
					$http({
						url: baseUrl + '/down-photo/' + id,
						method: 'PUT',
						params: {
							'_v': new Date().getTime()
						},
						headers: {
							'Content-Type': 'application/json;charset=UTF-8'
						}
					}).then(function (response) {
						resolve(response);
					}).catch(function (response) {
						reject(response);
					});
				});
			}
		};
	}]);

})();

(function () {
	'use strict';

	angular.module('app.front').controller('BlogController', BlogController);

	function BlogController($rootScope, $translate, $scope, $timeout, companyService, statisticsService, $location, $window, $anchorScroll, toastr, BlogService, languageService, $filter, $mdDialog, DocumentService, $sce, $state) {
		$scope.language = {};
		$scope.showForm = false;
		$scope.articles = [];

		$scope.loaded = true;


		languageService.getLanguages().then(function (response) {
			$scope.languages = response.data;
			for (var i = 0; i < $scope.languages.length; i++) {
				var language = $scope.languages[i];
				if (language.preferred) {
					$scope.language.key = language.key;
					break;
				}
			}
			$scope.$watch('language.key', function () {
				$scope.findAllArticles($scope.language.key);
			});
		}).catch(function (error) {

		});


		$scope.hidePopup = function () {
			$mdDialog.hide();
		};




		$scope.showFormBlog = function () {
			console.log($scope.language.key)
			$state.go('app.blog.edit', { 'lang': $scope.language.key });
		};


		//UPDATE ARTICLE
		$scope.updateArticle = function (article) {

			$state.go('app.blog.edit', { id: article.id, lang: $scope.language.key });

		};

		$scope.unsafe = function (content) {
			return $sce.trustAsHtml(content);
		};


		// FIND ALL
		$scope.findAllArticles = function (lang) {
			$scope.loaded = false;
			BlogService.findAllArticles(lang).then(function (articles) {
				$scope.articles = articles.data;
				if ($scope.article.id) {
					for (var i = 0; i < articles.data.length; i++) {
						if (articles.data[i].id == $scope.article.id) {
							$scope.article = angular.copy(articles.data[i]);
							$scope.article.startDateForm = moment($scope.article.dateStart).toDate();
						}
					}
				}
				$scope.loaded = true;
			}).catch(function (data) {
				$scope.loaded = true;
			});
		};



		//DELETE ARTICLE
		$scope.removeArticle = function (article) {
			var content = {
				title: $filter('translate')('BLOG.DELETE'),
				message: $filter('translate')('BLOG.CONFIRM_DELETE')
			};
			$rootScope.openConfirmPopup(content).then(function () {
				BlogService.removeArticle(article.id).then(function (data) {

					$scope.article = {};
					$scope.photos = [];
					$scope.showForm = false;
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_DELETE'));
					$scope.findAllArticles($scope.language.key);
				}).catch(function (err) {
					console.log(err)
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}).catch(function (err) {
				console.log(err)
			});
		};



		// DELETE PHOTO

		$scope.setActive = function (article) {
			BlogService.setActive(article.id).then().catch(function (data) {
				article.active = !article.active;
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

		$scope.setFavorite = function (article) {
			BlogService.setFavorite(article.id).then().catch(function (data) {
				article.coupCoeur = !article.coupCoeur;
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

	}

	angular.module('app.front').controller('addBlogCtrl', addBlogController);


	function addBlogController($scope, statisticsService, toastr, BlogService, companyService, $filter, $mdDialog, DocumentService, $state, $translate) {
		$scope.language = {};
		$scope.article = {
			'companiesIds': [],
			'companies': []
		};
		$scope.photos = [];

		$scope.companiesTmp = [];
		$scope.tags = [];
		$scope.countries = [];
		$scope.search = {
			tag: '',
			country: '',
			region: '',
			companies: []
		};
		$scope.loading = false;
		$scope._newCompany = {};

		$scope._searchCompany = '';

		window.mdSelectOnKeyDownOverride = function (event) {
			event.stopPropagation();
		};
		$scope.findAllTags = function (lang) {

			BlogService.findAllTags(lang).then(function (tags) {
				$scope.tags = tags.data;

			}).catch(function (err) {
				console.log(err)
			});
		};


		$scope.$watch('_searchCompany', function () {
			$scope.searchCompanyChange();
		});

		$scope.onEditorCreated = function (editor) {

			var txtArea = document.createElement('textarea');
			txtArea.style.cssText = "width: 100%;margin: 0px;background: rgb(29, 29, 29);box-sizing: border-box;color: rgb(204, 204, 204);font-size: 15px;outline: none;padding: 20px;line-height: 24px;font-family: Consolas, Menlo, Monaco, &quot;Courier New&quot;, monospace;position: absolute;top: 0;bottom: 0;border: none;display:none";

			var editorHTML = document.getElementById("editor_blog");
			console.log({ editor: editorHTML })

			var quill = editor;

			var htmlEditor = quill.addContainer('ql-custom');

			htmlEditor.appendChild(txtArea);


			quill.on('text-change', (delta, oldDelta, source) => {
				var html = editorHTML.children[0].children[2].children[0].innerHTML;
				txtArea.value = html;
			})

			setTimeout(function () {
				var customButton = document.querySelector('.ql-showHtml');

				customButton.addEventListener('click', function () {
					if (txtArea.style.display === '') {
						var html = txtArea.value
						quill.pasteHTML(html)
					}

					txtArea.style.display = txtArea.style.display === 'none' ? '' : 'none'
				})

			}, 1000);
		}





		$scope.addCompany = function () {
			if ($scope.article.id == null) {
				if ($scope.article.companiesIds.indexOf($scope._newCompany.id) > -1) {
					toastr.error($filter('translate')('BLOG.COMPANY.ALREADY'));
				} else {
					$scope.companiesTmp.push($scope._newCompany);
					$scope.article.companiesIds.push($scope._newCompany.id);
				}
				$scope._newCompany = {};
				$scope._searchCompany = '';
				$scope.search.companies = [];
			} else {
				BlogService.addCompanyToBlog($scope.article.id, $scope._newCompany.id, $translate.preferredLanguage()).then(function (res) {
					$scope.article.companies = res.data;
					$scope._newCompany = {};
					$scope._searchCompany = '';
					$scope.search.companies = [];
				}).catch(function (err) {
					console.log(err);
					if (err.status == 406) {
						toastr.error($filter('translate')('BLOG.COMPANY.ALREADY'));
					} else {
						toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
					}

				})
			}
		}
		$scope.deleteCompany = function (company) {

			if ($scope.article.id == null) {
				var index = 0;
				$scope.companiesTmp.forEach(function (element) {
					if (element.id == company.id) {
						$scope.companiesTmp.splice(index, 1);
					} else {
						index++;
					}
				});
				$scope.article.companiesIds.splice($scope.article.companiesIds.indexOf(company.id), 1);
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE'));
			} else {
				BlogService.deleteCompanyFromBlog($scope.article.id, company.id, $translate.preferredLanguage()).then(function (res) {
					$scope.article.companies = res.data;
					toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE'));
				}).catch(function (err) {
					console.log(err);
					toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
				});
			}
		}

		$scope.up = function (companyId) {
			BlogService.upCompany($scope.article.id, companyId, $translate.preferredLanguage()).then(function (res) {
				$scope.article.companies = res.data;
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE'));
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

		$scope.down = function (companyId) {
			BlogService.downCompany($scope.article.id, companyId, $translate.preferredLanguage()).then(function (res) {
				$scope.article.companies = res.data;
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE'));
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

		$scope.searchCompanyChange = function () {
			if ($scope._searchCompany == '') {
				$scope.search.companies = [];
			}
			companyService.findCompanies($scope._searchCompany, $translate.preferredLanguage()).then(function (res) {
				if (res.data && res.data.length == 0) {
					$scope._newCompany = {};
				}
				$scope.search.companies = res.data;
			}).catch(function (err) {
				console.log(err);
			})
		}
		$scope.findAllCountries = function (lang) {

			statisticsService.getNationalities(lang).then(function (countries) {
				$scope.countries = countries.data;

			}).catch(function (data) {
				console.log(data)
			});
		};

		$scope.findAllRegions = function (lang) {

			statisticsService.getRegions(lang).then(function (regions) {
				$scope.regions = regions.data;

			}).catch(function (data) {
				console.log(data)
			});
		};


		function init() {
			if ($state.params) {
				if ($state.params.lang) {
					$scope.language.key = $state.params.lang;
					$scope.findAllTags($scope.language.key);
					$scope.findAllCountries($scope.language.key);
					$scope.findAllRegions($scope.language.key);
				}
				if ($state.params.id) {
					BlogService.findById($state.params.id, $state.params.lang).then(function (res) {
						$scope.article = res.data;
						$scope.article.startDateForm = moment($scope.article.dateStart).toDate();
					})
				}
			}
		}

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};

		$scope.fieldsSelected = function (fields, selectedFields) {
			var res = [];

			if ($scope.article && !$scope.article.tags) {
				$scope.article.tags = [];
			}
			if ($scope.article && !$scope.article.countries) {
				$scope.article.countries = [];
			}
			if ($scope.article && !$scope.article.regions) {
				$scope.article.regions = [];
			}
			if (angular.isArray(selectedFields)) {
				var fieldIds = selectedFields.map(function (item) {
					return item.id;
				});
				angular.forEach(fields, function (item) {
					if (fieldIds.lastIndexOf(item.id) === -1) {
						res.push(item);
					}
				});
				return res;
			} else {
				return fields;
			}
		};

		$scope.cancelArticleForm = function () {
			$state.go('app.blog');
		};

		$scope.saveArticle = function () {
			$scope.loading = true;
			var photos = [];

			for (var i = 0; i < $scope.photos.length; i++) {
				if ($scope.photos[i] != null && $scope.photos[i].uploadFile != null) {
					var photo = $scope.photos[i].uploadFile;
					photos.push(photo);
				}
			}

			$scope.article.dateStart = $scope.article.startDateForm.getTime();
			BlogService.saveArticle($scope.article, $scope.language.key).then(function (data) {
				var fds = [];

				for (var i = 0; i < photos.length; i++) {
					var formData = new FormData();
					formData.append('file', photos[i]);
					formData.append('dto', angular.toJson({
						articleId: data.data
					}));

					fds.push(formData);
				}

				var index = 0;

				if (fds.length > 0) {
					for (var i = 0; i < fds.length; i++) {
						if (i === 0) {
							if (i === fds.length - 1) {
								$scope.addPhoto(fds[i], i, true);
							} else {
								$scope.addPhoto(fds[i], i);
							}
							index++;
						} else {
							$scope.$on('photoUploaded' + i, function () {
								if (index === fds.length - 1) {
									$scope.addPhoto(fds[index], index, true);
								} else {
									$scope.addPhoto(fds[index], index, false);
								}

								index++;
							});
						}
					}
				} else {
					$scope.loading = false;
					$state.go('app.blog');
				}


			}).catch(function (data) {
				$scope.loading = false;
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		};

		$scope.addPhoto = function (fd, i, last) {
			var index = angular.copy(i);
			DocumentService.save(fd).then(function (res) {
				$scope.$emit('photoUploaded' + (index + 1));
				if (last) {
					$scope.loading = false;
					$state.go('app.blog');
				}
			}).catch(function (err) {
				toastr.error($filter("translate")("BLOG.ERROR_ADD_PHOTO"));
				$scope.$emit('photoUploaded' + (index + 1));
				if (last) {
					$scope.loading = false;
					$state.go('app.blog');
				}
			});
		};





		$scope.addField = function (chip, fields) {
			if (chip == null || chip.id == null) {
				fields.splice(fields.length - 1, 1);
			}
		};

		$scope.deletePhoto = function (index) {
			$scope.photos.splice(index, 1);
		};

		$scope.setMiniature = function (photo, blog) {
			BlogService.setMiniature(photo.id).then(function (res) {
				blog.photos = res.data;
			}).catch(function (err) {
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			})
		}

		$scope.displayPopUpDeletePhoto = function (photo, index) {
			$scope.photoToDelete = angular.copy(photo);
			$scope.indexToDelete = index;
			$mdDialog.show({
				templateUrl: 'app/main/blog/popup/deletePhoto.popup.html',
				preserveScope: true,
				clickOutsideToClose: true,
				scope: $scope
			}).then(function () {

			}).catch(function () {

			});
		};


		$scope.deletePhotoPermanentely = function () {
			DocumentService.deleteFile($scope.photoToDelete.id).then(function (res) {
				$scope.article.photos.splice($scope.indexToDelete, 1);
				toastr.success($filter("translate")("BLOG.CONFIRM_MESSAGE_PHOTO"));
				$scope.hidePopup();
			}).catch(function (err) {
				toastr.error($filter("translate")("BLOG.ERROR_MESSAGE_PHOTO"));
			});
		};
		init();


		$scope.upPhoto = function (photo) {
			BlogService.upPhoto(photo.id).then(function (res) {
				$scope.article.photos = res.data;
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE'));
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

		$scope.downPhoto = function (photo) {
			BlogService.downPhoto(photo.id).then(function (res) {
				$scope.article.photos = res.data;
				toastr.success($filter('translate')('GENERAL.TOASTR.SUCCESS_UPDATE'));
			}).catch(function (err) {
				console.log(err);
				toastr.error($filter('translate')('GENERAL.TOASTR.ERROR'));
			});
		}

	}
})();

(function () {
    'use strict';
  
    angular.module('app.front').service('adminService', adminService);
  
    function adminService($q, $http) {
      var service = {};
      var url = '/api/rest/logs/';
  
      service.get = function (filter) {
        return $q(function (resolve, reject) {
          $http({
            url: url,
            method: 'POST',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: filter
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      };

      service.getByCompanyID = function(companyID, filter) {
        return $q(function (resolve, reject) {
          $http({
            url: url + companyID,
            method: 'POST',
            params: {
              '_v': new Date().getTime()
            },
            headers: {
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: filter
          }).then(function (response) {
            resolve(response);
          }).catch(function (response) {
            reject(response);
          });
        });
      };
  
      return service;
    }
  })();
  
(function () {
	'use strict';

	angular.module('app.front').service('roleService', roleService);

	function roleService($q, $http) {

		var service = {};

		service.find = function () {
			return $q(function (resolve, reject) {
				$http({
					url: '/api/rest/role/find',
					method: 'GET',
					params: {
						'_v': new Date().getTime()
					}
				}).then(function (response) {
					resolve(response);
				}).catch(function (response) {
					reject(response);
				});
			});
		};

		return service;
	}

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $scope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, STORAGE_PREFIX, msNavigationService)
    {
        var vm = this;

        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            fr: {
                'title'      : 'French',
                'translation': 'TOOLBAR.FRENCH',
                'code'       : 'fr',
                'flag'       : 'fr'
            }
        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];
            // vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

            if (localStorage[STORAGE_PREFIX + 'language'] == null){
                localStorage[STORAGE_PREFIX + 'language'] = $translate.preferredLanguage();
                vm.selectedLanguage = vm.languages[localStorage[STORAGE_PREFIX + 'language']];
            }else{
                vm.selectedLanguage = vm.languages[localStorage[STORAGE_PREFIX + 'language']];
            }
        }


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        /**
         * Logout Function
         */
        function logout()
        {
            // Do logout here..
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            $scope.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */

            // Change the language
            localStorage[STORAGE_PREFIX + 'language'] = lang.code;
            $translate.preferredLanguage(lang.code);
            $scope.$emit('refreshCompanyTypes', { langKey: lang.code});
            $state.reload();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/main/home');
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope, STORAGE_PREFIX, $translate, $state)
    {
        var vm = this;

        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        vm.languages = {
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            },
            fr: {
                'title'      : 'French',
                'translation': 'TOOLBAR.FRENCH',
                'code'       : 'fr',
                'flag'       : 'fr'
            }
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        // Methods
        vm.changeLanguage = changeLanguage;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });

        init();

        /**
         * Initialize
         */
        function init()
        {
            // vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];
            vm.userStatus = vm.userStatusOptions[0];

            if (localStorage[STORAGE_PREFIX + 'language'] == null){
                localStorage[STORAGE_PREFIX + 'language'] = $translate.preferredLanguage();
                vm.selectedLanguage = vm.languages[localStorage[STORAGE_PREFIX + 'language']];
            }else{
                vm.selectedLanguage = vm.languages[localStorage[STORAGE_PREFIX + 'language']];
                $translate.use(vm.selectedLanguage.code).catch(function(){
                    console.log('error');
                });
            }
        }

        function changeLanguage(lang)
        {
            $scope.selectedLanguage = lang;
            localStorage[STORAGE_PREFIX + 'language'] = lang.code;
            $translate.preferredLanguage(lang.code);
            $translate.use(lang.code);
            $scope.$emit('refreshCompanyTypes', { langKey: lang.code});
            $state.reload();
        }
    }

})();
(function () {
	'use strict';

	angular
		.module('fuse')
		.controller('MainController', MainController)
		.config(function ($mdThemingProvider) {

			// Green
			$mdThemingProvider.definePalette('lebanonPalette', {
				'50': '0DA4B4',
				'100': '0DA4B4',
				'200': '0DA4B4',
				'300': '0DA4B4',
				'400': '0DA4B4',
				'500': '0DA4B4',
				'600': '0DA4B4',
				'700': '0DA4B4',
				'800': '0DA4B4',
				'900': '0DA4B4',
				'A100': '0DA4B4',
				'A200': '0DA4B4',
				'A400': '0DA4B4',
				'A700': '0DA4B4',
				'contrastDefaultColor': 'light',
			});

			$mdThemingProvider.theme('default')
				.primaryPalette('lebanonPalette', {
					'default': '500',
					'hue-1': '500',
					'hue-2': '600',
					'hue-3': '800'
				})
				.accentPalette('grey', {
					'default': '400',
					'hue-1': '300',
					'hue-2': '600',
					'hue-3': '800'
				})
				.warnPalette('red');

		});

	/** @ngInject */
	function MainController($scope, $rootScope, msNavigationService, userService, $translate) {
		// Remove the splash screen
		$scope.$on('$viewContentAnimationEnded', function (event) {
			if (event.targetScope.$id === $scope.$id) {
				$rootScope.$broadcast('msSplashScreen::remove');
			}
		});


		/* MENU */

		// EX MENU
		/*msNavigationService.saveItem('menu1', {
			group: true,
			title: 'Menu1',
			icon: 'icon-cog',
			state: 'app.home',
			stateParams: {
			    'param1': 1
			},
			translate: 'MENU.TITLE',
			weight: 8
        });*/

		//TOOLBOX
		msNavigationService.saveItem('toolbox', {
			icon: 'icon-wallet-travel',
			group: true,
			title: 'Toolbox',
			translate: 'GENERAL.TOOLBOX',
			weight: 1,
			hidden: function () {
				return !userService.containsAtLeastOneRole(['AGENDA', 'MESSAGE', 'FOLDERS']);
			}
		});

		// AGENDA
		msNavigationService.saveItem('toolbox.home', {
			title: 'Agenda',
			state: 'app.home',
			translate: 'AGENDA.TITLE_PAGE',
			weight: 1,
			hidden: function () {
				return !userService.containsRole('AGENDA');
			}
		});

		// MESSAGE : Voir index controller
		$rootScope.$broadcast('rooScopeUser:ready');

		// FOLDERS
		msNavigationService.saveItem('toolbox.folder', {
			title: 'Dossiers',
			state: 'app.folders',
			translate: 'MENU.FOLDERS',
			weight: 2,
			hidden: function () {
				return !userService.containsRole('FOLDERS');
			}
		});

		// DATABASE
		// Voir globe network module pour les sous menu
		msNavigationService.saveItem('database', {
			group: true,
			title: 'Database',
			icon: 'icon-cog',
			translate: 'MENU.DATABASE',
			weight: 2,
			hidden: function () {
				return !userService.containsRole('DATABASE') && !userService.isMember()
			}
		});


		/*msNavigationService.saveItem('database.rfp', {
		    title: 'rfp',
		    state: 'app.rfp',
		    translate: 'REQUEST_FOR_PROPOSAL.LIST_TITLE',
		    weight: 9999,
		    hidden : function() {
		        return !(userService.isUserAdmin() || userService.isUserLinkedToAssociations());
		    }
		});*/

		msNavigationService.saveItem('events', {
			group: false,
			collapsable: true,
			icon: 'icon-calendar',
			title: 'Events',
			// state: 'app.events',
			translate: 'MENU.SITES_MANAGEMENT.EVENT',
			weight: 3,
			hidden: function () {
				return !userService.containsAtLeastOneRole(['EVENTS', 'REGISTRATIONS']);
			}
		});

		msNavigationService.saveItem('events.events', {
			title: 'Events',
			state: 'app.events',
			translate: 'MENU.SITES_MANAGEMENT.EVENT',
			weight: 201,
			hidden: function () {
				return !userService.containsRole('EVENTS');
			}
		});

		// Insriptions menu
		msNavigationService.saveItem('events.inscriptions_admin', {
			title: 'Inscriptions',
			state: 'app.inscriptions_admin',
			weight: 202,
			translate: 'INSCRIPTION_ADMIN.MENU_TITLE',
			hidden: function () {
				return !userService.containsRole('REGISTRATIONS');
			}
		});



		// COMMUNICATION
		msNavigationService.saveItem('mailing', {
			title: 'Communication',
			group: false,
			collapsable: true,
			icon: 'icon-bullhorn',
			translate: 'MENU.MAILING.TITLE',
			weight: 4,
			hidden: function () {
				return !userService.containsAtLeastOneRole(['EMAILS', 'COMMUNICATION_BLOCS', 'EMAILS_TRIGGER', 'TAGS', 'HISTORY']);
			}
		});
		msNavigationService.saveItem('mailing.pages', {
			title: 'Pages',
			state: 'app.mailing_pages',
			translate: 'MENU.MAILING.PAGES',
			weight: $translate.preferredLanguage() == 'en' ? 103 : 104,
			hidden: function () {
				return !userService.containsRole('EMAILS');
			}
		});
		msNavigationService.saveItem('mailing.blocs', {
			title: 'Blocs',
			state: 'app.mailing_blocs',
			translate: 'MENU.MAILING.BLOCS',
			weight: 102,
			hidden: function () {
				return !userService.containsRole('COMMUNICATION_BLOCS');
			}
		});
		msNavigationService.saveItem('mailing.triggers', {
			title: 'Triggers',
			state: 'app.mailing_triggers',
			translate: 'MENU.MAILING.TRIGGERS',
			weight: $translate.preferredLanguage() == 'en' ? 106 : 103,
			hidden: function () {
				return !userService.containsRole('EMAILS_TRIGGER');
			}
		});
		// msNavigationService.saveItem('mailing.expeditors', {
		//     title: 'Expeditors',
		//     state: 'app.mailing_expeditors',
		//     translate: 'MENU.MAILING.EXPEDITORS',
		//     weight: 106,
		//     hidden : function() {
		//         return !userService.isUserAdmin();
		//     }
		// });
		msNavigationService.saveItem('mailing.tags', {
			title: 'Tags',
			state: 'app.mailing_tags',
			weight: $translate.preferredLanguage() == 'en' ? 105 : 106,
			hidden: function () {
				return !userService.containsRole('TAGS');
			}
		});
		msNavigationService.saveItem('mailing.history', {
			title: 'History',
			state: 'app.mailing_history',
			translate: 'MENU.MAILING.HISTORY',
			weight: $translate.preferredLanguage() == 'en' ? 104 : 105,
			hidden: function () {
				return !userService.containsRole('HISTORY');
			}
		});

		// WEBSITE MANAGEMENT
		msNavigationService.saveItem('sites-management', {
			title: 'Site management',
			group: false,
			collapsable: true,
			icon: 'icon-desktop-mac',
			translate: 'MENU.SITES_MANAGEMENT.TITLE',
			weight: 5,
			hidden: function () {
				return !userService.containsAtLeastOneRole(['MENUS', 'WEBSITES', 'PAGES', 'WEBSITE_BLOCS', 'FIELD_LINKS', 'BLOG', 'FESTIVALS', 'PACKAGES', 'TOURIST_ATTRACTION', 'GALLERIES', 'QUOTES_REQUEST']);
			}
		});
		msNavigationService.saveItem('sites-management-assoc', {
			title: 'Site management',
			group: true,
			icon: 'icon-desktop-mac',
			translate: 'MENU.SITES_MANAGEMENT.TITLE',
			weight: 5,
			hidden: function () {
				// return userService.isUserAdmin() || userService.isMember();
				return true;
			}
		});
		msNavigationService.saveItem('sites-management.banners', {
			title: 'Banners',
			state: 'app.banners',
			translate: 'MENU.SITES_MANAGEMENT.BANNERS',
			weight: $translate.preferredLanguage() == 'en' ? 109 : 110,
			hidden: function () {
				return !userService.containsRole('BLOG');
			}
		});
		msNavigationService.saveItem('sites-management.blocs', {
			title: 'Blocs',
			state: 'app.blocs',
			translate: 'MENU.SITES_MANAGEMENT.BLOCS',
			weight: $translate.preferredLanguage() == 'en' ? 110 : 111,
			hidden: function () {
				return !userService.containsRole('WEBSITE_BLOCS');
			}
		});
		msNavigationService.saveItem('sites-management.blog', {
			title: 'Blog',
			state: 'app.blog',
			translate: 'MENU.SITES_MANAGEMENT.BLOG',
			weight: $translate.preferredLanguage() == 'en' ? 111 : 112,
			hidden: function () {
				return !userService.containsRole('BLOG');
			}
		});

		msNavigationService.saveItem('sites-management.countries', {
			title: 'Countries',
			state: 'app.countries',
			translate: 'MENU.SITES_MANAGEMENT.COUNTRIES',
			weight: $translate.preferredLanguage() == 'en' ? 112 : 122,
			hidden: function () {
				return !userService.containsRole('BLOG');
			}
		});

		msNavigationService.saveItem('sites-management.festival', {
			title: 'Festival',
			state: 'app.festival',
			translate: 'MENU.SITES_MANAGEMENT.FESTIVAL',
			weight: $translate.preferredLanguage() == 'en' ? 113 : 114,
			hidden: function () {
				return !userService.containsRole('FESTIVALS');
			}
		});
		msNavigationService.saveItem('sites-management.companies-settings', {
			title: 'Agenda',
			state: 'app.database.settings',
			translate: 'MENU.SITES_MANAGEMENT.FIELD_LINKS',
			weight: $translate.preferredLanguage() == 'en' ? 114 : 116,
			hidden: function () {
				return !userService.containsRole('FIELD_LINKS');
			}
		});

		msNavigationService.saveItem('sites-management.gallery', {
			title: 'Gallery',
			state: 'app.gallery',
			translate: 'MENU.SITES_MANAGEMENT.GALLERY',
			weight: 115,
			hidden: function () {
				return !userService.containsRole('GALLERIES');
			}
		});

		msNavigationService.saveItem('sites-management.siteMenu', {
			title: 'Menus',
			state: 'app.siteMenu',
			translate: 'MENU.SITES_MANAGEMENT.MENUS',
			weight: $translate.preferredLanguage() == 'en' ? 116 : 117,
			hidden: function () {
				return !userService.containsRole('MENUS');
			}
		});

		msNavigationService.saveItem('sites-management.newsletter', {
			title: 'Newsletter',
			state: 'app.newsletter',
			translate: 'MENU.SITES_MANAGEMENT.NEWSLETTER',
			weight: $translate.preferredLanguage() == 'en' ? 117 : 118,
			// hidden: function () {
			// 	return !userService.containsRole('GALLERIES');
			// }
		});

		msNavigationService.saveItem('sites-management.notations', {
			title: 'Notations',
			state: 'app.notations',
			translate: 'MENU.SITES_MANAGEMENT.NOTATIONS',
			weight: $translate.preferredLanguage() == 'en' ? 118 : 119,
			hidden: function () {
				return false;
			}
		});

		msNavigationService.saveItem('sites-management.packages', {
			title: 'Packages',
			state: 'app.packages',
			translate: 'MENU.SITES_MANAGEMENT.PACKAGES',
			weight: $translate.preferredLanguage() == 'en' ? 119 : 120,
			hidden: function () {
				return !userService.containsRole('PACKAGES');
			}
		});
		msNavigationService.saveItem('sites-management.pages', {
			title: 'Pages',
			state: 'app.pages',
			translate: 'MENU.SITES_MANAGEMENT.PAGES',
			weight: $translate.preferredLanguage() == 'en' ? 120 : 121,
			hidden: function () {
				return !userService.containsRole('PAGES');
			}
		});

		msNavigationService.saveItem('sites-management.regions', {
			title: 'Regions',
			state: 'app.regions',
			translate: 'MENU.SITES_MANAGEMENT.REGIONS',
			weight: $translate.preferredLanguage() == 'en' ? 121 : 123,
			hidden: function () {
				return !userService.containsRole('BLOG');
			}
		});

		// demande de devis
		msNavigationService.saveItem('sites-management.rfp', {
			title: 'rfp',
			state: 'app.rfp',
			translate: 'REQUEST_FOR_PROPOSAL.LIST_TITLE',
			weight: $translate.preferredLanguage() == 'en' ? 122 : 113,
			hidden: function () {
				return !userService.containsRole('QUOTES_REQUEST');
			}
		});



		msNavigationService.saveItem('sites-management.tags', {
			title: 'Tags',
			state: 'app.tags',
			translate: 'MENU.SITES_MANAGEMENT.TAGS',
			weight: $translate.preferredLanguage() == 'en' ? 123 : 125,
			hidden: function () {
				return !userService.containsRole('BLOG');
			}
		});


		msNavigationService.saveItem('sites-management.touristAttractions', {
			title: 'Tourist Attractions',
			state: 'app.touristAttractions',
			translate: 'MENU.SITES_MANAGEMENT.TOURIST',
			weight: $translate.preferredLanguage() == 'en' ? 124 : 109,
			hidden: function () {
				return !userService.containsRole('TOURIST_ATTRACTION');
			}
		});

		msNavigationService.saveItem('sites-management.sites', {
			title: 'Webites',
			state: 'app.sites',
			translate: 'MENU.SITES_MANAGEMENT.SITES',
			weight: $translate.preferredLanguage() == 'en' ? 125 : 124,
			hidden: function () {
				return !userService.containsRole('WEBSITES');
			}
		});








		msNavigationService.saveItem('sites-management-assoc.packages', {
			title: 'Packages',
			state: 'app.packages',
			translate: 'MENU.SITES_MANAGEMENT.PACKAGES',
			weight: 108
		});







		// STATISTICS

		msNavigationService.saveItem('statistics', {

			group: false,
			collapsable: true,
			title: 'Statistics',
			icon: 'icon-trending-up',
			translate: 'MENU.STATISTICS.TITLE',
			weight: 6,
			hidden: function () {
				return !userService.containsAtLeastOneRole(['COMPLETE_OCCUPATION_STATISTICS', 'OCCUPATION_STATISTICS', 'REPARTITION', 'MONTHLY_STATISTICS', 'COMMERCIAL_REPORTING', 'COMPANY_STATISTICS']);
			}
		});

		msNavigationService.saveItem('statistics.statistics-edit', {
			title: 'Renseigner des statistiques',
			translate: 'MENU.STATISTICS.FILL_IN',
			weight: $translate.preferredLanguage() == 'en' ? 75 : 72,
			state: 'app.statistics.edit',
			hidden: function () {
				return !userService.containsRole('COMPLETE_OCCUPATION_STATISTICS');
			}
		});

		msNavigationService.saveItem('statistics.display', {
			title: 'Afficher des statistiques',
			translate: 'MENU.STATISTICS.DISPLAY',
			weight: $translate.preferredLanguage() == 'en' ? 77 : 71,
			state: 'app.statistics.display',
			hidden: function () {
				return !userService.containsRole('OCCUPATION_STATISTICS');
			}
		});
		msNavigationService.saveItem('statistics.repartition', {
			title: 'Repartition',
			translate: 'MENU.STATISTICS.REPARTITION',
			weight: $translate.preferredLanguage() == 'en' ? 78 : 73,
			state: 'app.statistics.repartition',
			hidden: function () {
				return !userService.containsRole('REPARTITION');
			}
		});
		msNavigationService.saveItem('statistics.automatic', {
			title: 'Statistiques mensuelles automatiques',
			translate: 'MENU.STATISTICS.AUTOMATIC',
			weight: $translate.preferredLanguage() == 'en' ? 76 : 78,
			state: 'app.statistics.automatic',
			hidden: function () {
				return !userService.containsRole('MONTHLY_STATISTICS');
			}
		});
		msNavigationService.saveItem('statistics.reporting', {
			title: 'Commercial reporting',
			translate: 'MENU.STATISTICS.REPORTING',
			weight: $translate.preferredLanguage() == 'en' ? 73 : 74,
			state: 'app.statistics.reporting',
			hidden: function () {
				return !userService.containsRole('COMMERCIAL_REPORTING');
			}
		});

		// demande de devis
		msNavigationService.saveItem('statistics.company', {
			title: 'Company Statistics',
			state: 'app.statistic_company',
			translate: 'STATISTIC_COMPANY.TITLE',
			weight: $translate.preferredLanguage() == 'en' ? 74 : 77,
			hidden: function () {
				return !userService.containsRole('COMPANY_STATISTICS');
			}
		});

		msNavigationService.saveItem('statistics.articles', {
			title: 'Articles Statistics',
			state: 'app.statistic_articles',
			translate: 'STATISTIC_ARTICLES.TITLE',
			weight: $translate.preferredLanguage() == 'en' ? 71 : 75,
			hidden: function () {
				return !userService.containsRole('COMPANY_STATISTICS');

			}
		});

		msNavigationService.saveItem('statistics.banners', {
			title: 'Banners Statistics',
			state: 'app.statistic_banners',
			translate: 'STATISTIC_BANNERS.TITLE',
			weight: $translate.preferredLanguage() == 'en' ? 72 : 76,
			hidden: function () {
				return !userService.containsRole('COMPANY_STATISTICS');
			}
		});

		// ACCESS & AUTHORIZATION MENU
		// msNavigationService.saveItem('access_rights-associations', {
		// 	title: 'Accès',
		// 	state: 'app.associations',
		// 	weight: 2,
		// 	translate: 'MENU.ACCESS.ASSOCIATIONS',
		//     hidden: function () {
		//       return !userService.isUserLinkedToAssociations();
		//     }
		// });

		msNavigationService.saveItem('access_rights', {
			title: 'Access and authorizations',
			group: false,
			collapsable: true,
			icon: 'icon-key',
			weight: 7,
			translate: 'MENU.ACCESS.TITLE',
			hidden: function () {
				return !userService.containsAtLeastOneRole(['ASSOCIATIONS', 'USERS', 'GROUPS'])
			}
		});
		// msNavigationService.saveItem('access_rights_assoc', {
		// 	title: 'Access and authorizations',
		// 	group: true,
		// 	icon: 'icon-key',
		// 	weight: 7,
		// 	translate: 'MENU.ACCESS.TITLE',
		// 	hidden: function () {
		// 		return !userService.containsAtLeastOneRole(['ASSOCIATIONS', 'USERS', 'GROUPS']);
		// 	}
		// });

		msNavigationService.saveItem('access_rights.associations', {
			title: 'Accès',
			state: 'app.associations',
			weight: 81,
			translate: 'MENU.ACCESS.ASSOCIATIONS',
			hidden: function () {
				return !userService.containsRole('ASSOCIATIONS');
			}
		});
		// msNavigationService.saveItem('access_rights_assoc.access_rights_assoc', {
		// 	title: 'Accès',
		// 	state: 'app.associations',
		// 	weight: 81,
		// 	translate: 'MENU.ACCESS.ASSOCIATIONS',
		// 	hidden: function () {
		// 		return !userService.containsRole('ASSOCIATIONS');
		// 	}
		// });
		msNavigationService.saveItem('access_rights.users', {
			title: 'Accès',
			state: 'app.users',
			weight: 83,
			translate: 'MENU.ACCESS.USERS',
			hidden: function () {
				return !userService.containsRole('USERS');
			}
		});
		msNavigationService.saveItem('access_rights.groups', {
			title: 'Accès',
			state: 'app.groups',
			weight: 82,
			translate: 'MENU.ACCESS.GROUPS',
			hidden: function () {
				return !userService.containsRole('GROUPS');
			}
		});

		// SETTINGS
		msNavigationService.saveItem('settings', {
			group: false,
			collapsable: true,
			title: 'Paramètres',
			icon: 'icon-cog',
			translate: 'MENU.SETTINGS.TITLE',
			weight: 8,
			hidden: function () {
				return !userService.containsAtLeastOneRole(['COMPANIES_FIELDS', 'COMPANIES_TYPES', 'CONTACTS_FIELDS', 'CONTACTS_SETTINGS', 'MESSAGE_ACTIONS', 'REGISTRATION_SETTINGS', 'USERS_LOGS', 'MESSAGES_LOGS', 'DUPLICATION_TOOL', 'JUNK_BOX', 'DATA_IMPORT'])
			}
		});
		msNavigationService.saveItem('settings.companies-model', {
			title: 'ezgezgzegze',
			state: 'app.database.companies',
			translate: 'MENU.SETTINGS.COMPANIES_MODEL',
			weight: $translate.preferredLanguage() == 'en' ? 91 : 100,
			hidden: function () {
				return !userService.containsRole('COMPANIES_FIELDS');
			}
		});
		msNavigationService.saveItem('settings.companies-types', {
			title: 'ezgezgzegz',
			state: 'app.database.types',
			translate: 'MENU.SETTINGS.COMPANIES_TYPES',
			weight: $translate.preferredLanguage() == 'en' ? 93 : 102,
			hidden: function () {
				return !userService.containsRole('COMPANIES_TYPES');
			}
		});

		msNavigationService.saveItem('settings.similar_companies', {
			title: 'Similar companies',
			state: 'app.similar_companies',
			translate: 'MENU.SETTINGS.SIMILAR_COMPANIES',
			weight: $translate.preferredLanguage() == 'en' ? 92 : 101,
			hidden: function () {
				return !userService.containsRole('SIMILAR_COMPANIES');
			}
		});


		msNavigationService.saveItem('settings.contacts-model', {
			title: 'ezgezgezg',
			state: 'app.database.contacts',
			translate: 'MENU.SETTINGS.CONTACTS_MODEL',
			weight: $translate.preferredLanguage() == 'en' ? 94 : 91,
			hidden: function () {
				return !userService.containsRole('CONTACTS_FIELDS');
			}
		});
		msNavigationService.saveItem('settings.contacts-settings', {
			title: 'Contacts Settings',
			state: 'app.database.contactsSettings',
			translate: 'MENU.SETTINGS.CONTACTS_SETTINGS',
			weight: $translate.preferredLanguage() == 'en' ? 95 : 92,
			hidden: function () {
				return !userService.containsRole('CONTACTS_SETTINGS');
			}
		});
		msNavigationService.saveItem('settings.registrations-settings', {
			title: 'Registrations Settings',
			state: 'app.database.registrationSettings',
			translate: 'MENU.SETTINGS.REGISTRATION_SETTINGS',
			weight: $translate.preferredLanguage() == 'en' ? 101 : 94,
			hidden: function () {
				return !userService.containsRole('REGISTRATION_SETTINGS');
			}
		});
		msNavigationService.saveItem('settings.messagesettings', {
			title: 'Messages',
			state: 'app.settingsmessage',
			translate: 'MENU.SETTINGS.MESSAGE',
			weight: $translate.preferredLanguage() == 'en' ? 100 : 98,
			hidden: function () {
				return !userService.containsRole('MESSAGE_ACTIONS');
			}
		});
		msNavigationService.saveItem('settings.usersLogs', {
			title: 'Users logs',
			state: 'app.usersLogs',
			translate: 'MENU.SETTINGS.USERS_LOGS',
			weight: $translate.preferredLanguage() == 'en' ? 102 : 97,
			hidden: function () {
				return !userService.containsRole('USERS_LOGS');
			}
		});
		msNavigationService.saveItem('settings.messagesLogs', {
			title: 'Messages Logs',
			state: 'app.messagesLogs',
			translate: 'MENU.SETTINGS.MESSAGES_LOGS',
			weight: $translate.preferredLanguage() == 'en' ? 99 : 96,
			hidden: function () {
				return !userService.containsRole('MESSAGES_LOGS');
			}
		});
		msNavigationService.saveItem('settings.duplication_tool', {
			title: 'Duplication tool',
			state: 'app.duplication_tool',
			translate: 'MENU.SETTINGS.DUPLICATION_TOOL',
			weight: $translate.preferredLanguage() == 'en' ? 97 : 99,
			hidden: function () {
				return !userService.containsRole('DUPLICATION_TOOL');
			}
		});
		msNavigationService.saveItem('settings.junk_box', {
			title: 'Junk Box',
			state: 'app.junk_box',
			translate: 'MENU.SETTINGS.JUNK_BOX',
			weight: $translate.preferredLanguage() == 'en' ? 98 : 95,
			hidden: function () {
				return !userService.containsRole('JUNK_BOX');
			}
		});
		msNavigationService.saveItem('settings.data_import', {
			title: 'Data import',
			state: 'app.data_import',
			translate: 'MENU.SETTINGS.DATA_IMPORT',
			weight: $translate.preferredLanguage() == 'en' ? 96 : 93,
			hidden: function () {
				return !userService.containsRole('DATA_IMPORT');
			}
		});





	}
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig, fuseTheming)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider, $compileProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        $compileProvider.debugInfoEnabled(false);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
	if (typeof exports == "object" && typeof module == "object") // CommonJS
	  mod(require("../../lib/codemirror"));
	else if (typeof define == "function" && define.amd) // AMD
	  define(["../../lib/codemirror"], mod);
	else // Plain browser env
	  mod(CodeMirror);
 })(function(CodeMirror) {
 "use strict";

 var htmlConfig = {
	autoSelfClosers: {'area': true, 'base': true, 'br': true, 'col': true, 'command': true,
							'embed': true, 'frame': true, 'hr': true, 'img': true, 'input': true,
							'keygen': true, 'link': true, 'meta': true, 'param': true, 'source': true,
							'track': true, 'wbr': true, 'menuitem': true},
	implicitlyClosed: {'dd': true, 'li': true, 'optgroup': true, 'option': true, 'p': true,
							 'rp': true, 'rt': true, 'tbody': true, 'td': true, 'tfoot': true,
							 'th': true, 'tr': true},
	contextGrabbers: {
	  'dd': {'dd': true, 'dt': true},
	  'dt': {'dd': true, 'dt': true},
	  'li': {'li': true},
	  'option': {'option': true, 'optgroup': true},
	  'optgroup': {'optgroup': true},
	  'p': {'address': true, 'article': true, 'aside': true, 'blockquote': true, 'dir': true,
			  'div': true, 'dl': true, 'fieldset': true, 'footer': true, 'form': true,
			  'h1': true, 'h2': true, 'h3': true, 'h4': true, 'h5': true, 'h6': true,
			  'header': true, 'hgroup': true, 'hr': true, 'menu': true, 'nav': true, 'ol': true,
			  'p': true, 'pre': true, 'section': true, 'table': true, 'ul': true},
	  'rp': {'rp': true, 'rt': true},
	  'rt': {'rp': true, 'rt': true},
	  'tbody': {'tbody': true, 'tfoot': true},
	  'td': {'td': true, 'th': true},
	  'tfoot': {'tbody': true},
	  'th': {'td': true, 'th': true},
	  'thead': {'tbody': true, 'tfoot': true},
	  'tr': {'tr': true}
	},
	doNotIndent: {"pre": true},
	allowUnquoted: true,
	allowMissing: true,
	caseFold: true
 }

 var xmlConfig = {
	autoSelfClosers: {},
	implicitlyClosed: {},
	contextGrabbers: {},
	doNotIndent: {},
	allowUnquoted: false,
	allowMissing: false,
	allowMissingTagName: false,
	caseFold: false
 }

 CodeMirror.defineMode("xml", function(editorConf, config_) {
	var indentUnit = editorConf.indentUnit
	var config = {}
	var defaults = config_.htmlMode ? htmlConfig : xmlConfig
	for (var prop in defaults) config[prop] = defaults[prop]
	for (var prop in config_) config[prop] = config_[prop]

	// Return variables for tokenizers
	var type, setStyle;

	function inText(stream, state) {
	  function chain(parser) {
		 state.tokenize = parser;
		 return parser(stream, state);
	  }

	  var ch = stream.next();
	  if (ch == "<") {
		 if (stream.eat("!")) {
			if (stream.eat("[")) {
			  if (stream.match("CDATA[")) return chain(inBlock("atom", "]]>"));
			  else return null;
			} else if (stream.match("--")) {
			  return chain(inBlock("comment", "-->"));
			} else if (stream.match("DOCTYPE", true, true)) {
			  stream.eatWhile(/[\w\._\-]/);
			  return chain(doctype(1));
			} else {
			  return null;
			}
		 } else if (stream.eat("?")) {
			stream.eatWhile(/[\w\._\-]/);
			state.tokenize = inBlock("meta", "?>");
			return "meta";
		 } else {
			type = stream.eat("/") ? "closeTag" : "openTag";
			state.tokenize = inTag;
			return "tag bracket";
		 }
	  } else if (ch == "&") {
		 var ok;
		 if (stream.eat("#")) {
			if (stream.eat("x")) {
			  ok = stream.eatWhile(/[a-fA-F\d]/) && stream.eat(";");
			} else {
			  ok = stream.eatWhile(/[\d]/) && stream.eat(";");
			}
		 } else {
			ok = stream.eatWhile(/[\w\.\-:]/) && stream.eat(";");
		 }
		 return ok ? "atom" : "error";
	  } else {
		 stream.eatWhile(/[^&<]/);
		 return null;
	  }
	}
	inText.isInText = true;

	function inTag(stream, state) {
	  var ch = stream.next();
	  if (ch == ">" || (ch == "/" && stream.eat(">"))) {
		 state.tokenize = inText;
		 type = ch == ">" ? "endTag" : "selfcloseTag";
		 return "tag bracket";
	  } else if (ch == "=") {
		 type = "equals";
		 return null;
	  } else if (ch == "<") {
		 state.tokenize = inText;
		 state.state = baseState;
		 state.tagName = state.tagStart = null;
		 var next = state.tokenize(stream, state);
		 return next ? next + " tag error" : "tag error";
	  } else if (/[\'\"]/.test(ch)) {
		 state.tokenize = inAttribute(ch);
		 state.stringStartCol = stream.column();
		 return state.tokenize(stream, state);
	  } else {
		 stream.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/);
		 return "word";
	  }
	}

	function inAttribute(quote) {
	  var closure = function(stream, state) {
		 while (!stream.eol()) {
			if (stream.next() == quote) {
			  state.tokenize = inTag;
			  break;
			}
		 }
		 return "string";
	  };
	  closure.isInAttribute = true;
	  return closure;
	}

	function inBlock(style, terminator) {
	  return function(stream, state) {
		 while (!stream.eol()) {
			if (stream.match(terminator)) {
			  state.tokenize = inText;
			  break;
			}
			stream.next();
		 }
		 return style;
	  }
	}

	function doctype(depth) {
	  return function(stream, state) {
		 var ch;
		 while ((ch = stream.next()) != null) {
			if (ch == "<") {
			  state.tokenize = doctype(depth + 1);
			  return state.tokenize(stream, state);
			} else if (ch == ">") {
			  if (depth == 1) {
				 state.tokenize = inText;
				 break;
			  } else {
				 state.tokenize = doctype(depth - 1);
				 return state.tokenize(stream, state);
			  }
			}
		 }
		 return "meta";
	  };
	}

	function Context(state, tagName, startOfLine) {
	  this.prev = state.context;
	  this.tagName = tagName;
	  this.indent = state.indented;
	  this.startOfLine = startOfLine;
	  if (config.doNotIndent.hasOwnProperty(tagName) || (state.context && state.context.noIndent))
		 this.noIndent = true;
	}
	function popContext(state) {
	  if (state.context) state.context = state.context.prev;
	}
	function maybePopContext(state, nextTagName) {
	  var parentTagName;
	  while (true) {
		 if (!state.context) {
			return;
		 }
		 parentTagName = state.context.tagName;
		 if (!config.contextGrabbers.hasOwnProperty(parentTagName) ||
			  !config.contextGrabbers[parentTagName].hasOwnProperty(nextTagName)) {
			return;
		 }
		 popContext(state);
	  }
	}

	function baseState(type, stream, state) {
	  if (type == "openTag") {
		 state.tagStart = stream.column();
		 return tagNameState;
	  } else if (type == "closeTag") {
		 return closeTagNameState;
	  } else {
		 return baseState;
	  }
	}
	function tagNameState(type, stream, state) {
	  if (type == "word") {
		 state.tagName = stream.current();
		 setStyle = "tag";
		 return attrState;
	  } else if (config.allowMissingTagName && type == "endTag") {
		 setStyle = "tag bracket";
		 return attrState(type, stream, state);
	  } else {
		 setStyle = "error";
		 return tagNameState;
	  }
	}
	function closeTagNameState(type, stream, state) {
	  if (type == "word") {
		 var tagName = stream.current();
		 if (state.context && state.context.tagName != tagName &&
			  config.implicitlyClosed.hasOwnProperty(state.context.tagName))
			popContext(state);
		 if ((state.context && state.context.tagName == tagName) || config.matchClosing === false) {
			setStyle = "tag";
			return closeState;
		 } else {
			setStyle = "tag error";
			return closeStateErr;
		 }
	  } else if (config.allowMissingTagName && type == "endTag") {
		 setStyle = "tag bracket";
		 return closeState(type, stream, state);
	  } else {
		 setStyle = "error";
		 return closeStateErr;
	  }
	}

	function closeState(type, _stream, state) {
	  if (type != "endTag") {
		 setStyle = "error";
		 return closeState;
	  }
	  popContext(state);
	  return baseState;
	}
	function closeStateErr(type, stream, state) {
	  setStyle = "error";
	  return closeState(type, stream, state);
	}

	function attrState(type, _stream, state) {
	  if (type == "word") {
		 setStyle = "attribute";
		 return attrEqState;
	  } else if (type == "endTag" || type == "selfcloseTag") {
		 var tagName = state.tagName, tagStart = state.tagStart;
		 state.tagName = state.tagStart = null;
		 if (type == "selfcloseTag" ||
			  config.autoSelfClosers.hasOwnProperty(tagName)) {
			maybePopContext(state, tagName);
		 } else {
			maybePopContext(state, tagName);
			state.context = new Context(state, tagName, tagStart == state.indented);
		 }
		 return baseState;
	  }
	  setStyle = "error";
	  return attrState;
	}
	function attrEqState(type, stream, state) {
	  if (type == "equals") return attrValueState;
	  if (!config.allowMissing) setStyle = "error";
	  return attrState(type, stream, state);
	}
	function attrValueState(type, stream, state) {
	  if (type == "string") return attrContinuedState;
	  if (type == "word" && config.allowUnquoted) {setStyle = "string"; return attrState;}
	  setStyle = "error";
	  return attrState(type, stream, state);
	}
	function attrContinuedState(type, stream, state) {
	  if (type == "string") return attrContinuedState;
	  return attrState(type, stream, state);
	}

	return {
	  startState: function(baseIndent) {
		 var state = {tokenize: inText,
						  state: baseState,
						  indented: baseIndent || 0,
						  tagName: null, tagStart: null,
						  context: null}
		 if (baseIndent != null) state.baseIndent = baseIndent
		 return state
	  },

	  token: function(stream, state) {
		 if (!state.tagName && stream.sol())
			state.indented = stream.indentation();

		 if (stream.eatSpace()) return null;
		 type = null;
		 var style = state.tokenize(stream, state);
		 if ((style || type) && style != "comment") {
			setStyle = null;
			state.state = state.state(type || style, stream, state);
			if (setStyle)
			  style = setStyle == "error" ? style + " error" : setStyle;
		 }
		 return style;
	  },

	  indent: function(state, textAfter, fullLine) {
		 var context = state.context;
		 // Indent multi-line strings (e.g. css).
		 if (state.tokenize.isInAttribute) {
			if (state.tagStart == state.indented)
			  return state.stringStartCol + 1;
			else
			  return state.indented + indentUnit;
		 }
		 if (context && context.noIndent) return CodeMirror.Pass;
		 if (state.tokenize != inTag && state.tokenize != inText)
			return fullLine ? fullLine.match(/^(\s*)/)[0].length : 0;
		 // Indent the starts of attribute names.
		 if (state.tagName) {
			if (config.multilineTagIndentPastTag !== false)
			  return state.tagStart + state.tagName.length + 2;
			else
			  return state.tagStart + indentUnit * (config.multilineTagIndentFactor || 1);
		 }
		 if (config.alignCDATA && /<!\[CDATA\[/.test(textAfter)) return 0;
		 var tagAfter = textAfter && /^<(\/)?([\w_:\.-]*)/.exec(textAfter);
		 if (tagAfter && tagAfter[1]) { // Closing tag spotted
			while (context) {
			  if (context.tagName == tagAfter[2]) {
				 context = context.prev;
				 break;
			  } else if (config.implicitlyClosed.hasOwnProperty(context.tagName)) {
				 context = context.prev;
			  } else {
				 break;
			  }
			}
		 } else if (tagAfter) { // Opening tag spotted
			while (context) {
			  var grabbers = config.contextGrabbers[context.tagName];
			  if (grabbers && grabbers.hasOwnProperty(tagAfter[2]))
				 context = context.prev;
			  else
				 break;
			}
		 }
		 while (context && context.prev && !context.startOfLine)
			context = context.prev;
		 if (context) return context.indent + indentUnit;
		 else return state.baseIndent || 0;
	  },

	  electricInput: /<\/[\s\w:]+>$/,
	  blockCommentStart: "<!--",
	  blockCommentEnd: "-->",

	  configuration: config.htmlMode ? "html" : "xml",
	  helperType: config.htmlMode ? "html" : "xml",

	  skipAttribute: function(state) {
		 if (state.state == attrValueState)
			state.state = attrState
	  },

	  xmlCurrentTag: function(state) {
		 return state.tagName ? {name: state.tagName, close: state.type == "closeTag"} : null
	  },

	  xmlCurrentContext: function(state) {
		 var context = []
		 for (var cx = state.context; cx; cx = cx.prev)
			if (cx.tagName) context.push(cx.tagName)
		 return context.reverse()
	  }
	};
 });

 CodeMirror.defineMIME("text/xml", "xml");
 CodeMirror.defineMIME("application/xml", "xml");
 if (!CodeMirror.mimeModes.hasOwnProperty("text/html"))
	CodeMirror.defineMIME("text/html", {name: "xml", htmlMode: true});

 });

/* globals define, angular */
(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(['quill'], factory)
  } else if (typeof module !== 'undefined' && typeof exports === 'object') {
    module.exports = factory(require('quill'))
  } else {
    root.Requester = factory(root.Quill)
  }
}(this, function (Quill) {
  'use strict'

  var app
  // declare ngQuill module
  app = angular.module('ngQuill', [])

  app.provider('ngQuillConfig', function () {
    var config = {
      modules: {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          ['blockquote', 'code-block'],

          [{ 'header': 1 }, { 'header': 2 }],               // custom button values
          [{ 'list': 'ordered' }, { 'list': 'bullet' }],
          [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
          [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
          [{ 'direction': 'rtl' }],                         // text direction

          [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
          [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

          [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
          [{ 'font': [] }],
          [{ 'align': [] }],

          ['clean'],                                         // remove formatting button

          ['link', 'image', 'video']                         // link and image, video
        ]
      },
      theme: 'snow',
      placeholder: 'Insert text here ...',
      readOnly: false,
      bounds: document.body
    }

    this.set = function (customConf) {
      customConf = customConf || {}

      if (customConf.modules) {
        config.modules = customConf.modules
      }
      if (customConf.theme) {
        config.theme = customConf.theme
      }
      if (customConf.placeholder !== null && customConf.placeholder !== undefined) {
        config.placeholder = customConf.placeholder.trim()
      }
      if (customConf.bounds) {
        config.bounds = customConf.bounds
      }
      if (customConf.readOnly) {
        config.readOnly = customConf.readOnly
      }
      if (customConf.formats) {
        config.formats = customConf.formats
      }
    }

    this.$get = function () {
      return config
    }
  })

  app.component('ngQuillEditor', {
    bindings: {
      'modules': '<modules',
      'theme': '@?',
      'readOnly': '<?',
      'formats': '<?',
      'placeholder': '@?',
      'bounds': '<?',
      'scrollingContainer': '<?',
      'strict': '<?',
      'onEditorCreated': '&?',
      'onContentChanged': '&?',
      'onSelectionChanged': '&?',
      'ngModel': '<',
      'maxLength': '<',
      'minLength': '<',
      'customOptions': '<?'
    },
    require: {
      ngModelCtrl: 'ngModel'
    },
    transclude: {
      'toolbar': '?ngQuillToolbar'
    },
    template: '<div class="ng-hide" ng-show="$ctrl.ready"><ng-transclude ng-transclude-slot="toolbar"></ng-transclude></div>',
    controller: ['$scope', '$element', '$timeout', '$transclude', 'ngQuillConfig', function ($scope, $element, $timeout, $transclude, ngQuillConfig) {
      var config = {}
      var content
      var editorElem
      var modelChanged = false
      var editorChanged = false
      var editor
      var placeholder = ngQuillConfig.placeholder

      this.validate = function (text) {
        if (this.maxLength) {
          if (text.length > this.maxLength + 1) {
            this.ngModelCtrl.$setValidity('maxlength', false)
          } else {
            this.ngModelCtrl.$setValidity('maxlength', true)
          }
        }

        if (this.minLength > 1) {
          // validate only if text.length > 1
          if (text.length <= this.minLength && text.length > 1) {
            this.ngModelCtrl.$setValidity('minlength', false)
          } else {
            this.ngModelCtrl.$setValidity('minlength', true)
          }
        }
      }

      this.$onChanges = function (changes) {
        if (changes.ngModel && changes.ngModel.currentValue !== changes.ngModel.previousValue) {
          content = changes.ngModel.currentValue

          if (editor && !editorChanged) {
            modelChanged = true
            if (content) {
              editor.setContents(editor.clipboard.convert(content))
            } else {
              editor.setText('')
            }
          }
          editorChanged = false
        }

        if (editor && changes.readOnly) {
          editor.enable(!changes.readOnly.currentValue)
        }
      }

      this.$onInit = function () {
        if (this.placeholder !== null && this.placeholder !== undefined) {
          placeholder = this.placeholder.trim()
        }

        config = {
          theme: this.theme || ngQuillConfig.theme,
          readOnly: this.readOnly || ngQuillConfig.readOnly,
          modules: this.modules || ngQuillConfig.modules,
          formats: this.formats || ngQuillConfig.formats,
          placeholder: placeholder,
          bounds: this.bounds || ngQuillConfig.bounds,
          strict: this.strict,
          scrollingContainer: this.scrollingContainer
        }
      }

      this.$postLink = function () {
        // create quill instance after dom is rendered
        $timeout(function () {
          this._initEditor(editorElem)
        }.bind(this), 0)
      }

      this._initEditor = function (editorElem) {
        var $editorElem = angular.element('<div></div>')
        var container = $element.children()

        editorElem = $editorElem[0]

        if (config.bounds === 'self') {
          config.bounds = editorElem
        }

        // set toolbar to custom one
        if ($transclude.isSlotFilled('toolbar')) {
          config.modules.toolbar = container.find('ng-quill-toolbar').children()[0]
        }

        container.append($editorElem);

        if (this.customOptions) {
          this.customOptions.forEach(function (customOption) {
            var newCustomOption = Quill.import(customOption.import);
            newCustomOption.whitelist = customOption.whitelist;
            if (customOption.toRegister) {
              newCustomOption[customOption.toRegister.key] = customOption.toRegister.value;
            }
            Quill.register(newCustomOption, true);
          })
        }

        editor = new Quill(editorElem, config)

        this.ready = true

        // mark model as touched if editor lost focus
        editor.on('selection-change', function (range, oldRange, source) {
          if (this.onSelectionChanged) {
            this.onSelectionChanged({
              editor: editor,
              oldRange: oldRange,
              range: range,
              source: source
            })
          }

          if (range) {
            return
          }
          $scope.$applyAsync(function () {
            this.ngModelCtrl.$setTouched()
          }.bind(this))
        }.bind(this))

        // update model if text changes
        editor.on('text-change', function (delta, oldDelta, source) {
          var html = editorElem.children[0].innerHTML
          var text = editor.getText()
          var emptyModelTag = ['<' + editor.root.firstChild.localName + '>', '</' + editor.root.firstChild.localName + '>']

          if (html === emptyModelTag[0] + '<br>' + emptyModelTag[1]) {
              html = null
          }
          this.validate(text)

          if (!modelChanged) {
            $scope.$applyAsync(function () {
              editorChanged = true

              this.ngModelCtrl.$setViewValue(html)

              if (this.onContentChanged) {
                this.onContentChanged({
                  editor: editor,
                  html: html,
                  text: text,
                  delta: delta,
                  oldDelta: oldDelta,
                  source: source
                })
              }
            }.bind(this))
          }
          modelChanged = false
        }.bind(this))

        // set initial content
        if (content) {
          modelChanged = true

          var contents = editor.clipboard.convert(content)
          editor.setContents(contents)
          editor.history.clear()
        }

        // provide event to get informed when editor is created -> pass editor object.
        if (this.onEditorCreated) {
          this.onEditorCreated({editor: editor})
        }
      }
    }]
  })

  return app.name;
}));



// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
  if (typeof exports == "object" && typeof module == "object") // CommonJS
    mod(require("../../lib/codemirror"));
  else if (typeof define == "function" && define.amd) // AMD
    define(["../../lib/codemirror"], mod);
  else // Plain browser env
    mod(CodeMirror);
})(function(CodeMirror) {
"use strict";

CodeMirror.defineMode("javascript", function(config, parserConfig) {
  var indentUnit = config.indentUnit;
  var statementIndent = parserConfig.statementIndent;
  var jsonldMode = parserConfig.jsonld;
  var jsonMode = parserConfig.json || jsonldMode;
  var isTS = parserConfig.typescript;
  var wordRE = parserConfig.wordCharacters || /[\w$\xa1-\uffff]/;

  // Tokenizer

  var keywords = function(){
    function kw(type) {return {type: type, style: "keyword"};}
    var A = kw("keyword a"), B = kw("keyword b"), C = kw("keyword c"), D = kw("keyword d");
    var operator = kw("operator"), atom = {type: "atom", style: "atom"};

    return {
      "if": kw("if"), "while": A, "with": A, "else": B, "do": B, "try": B, "finally": B,
      "return": D, "break": D, "continue": D, "new": kw("new"), "delete": C, "void": C, "throw": C,
      "debugger": kw("debugger"), "var": kw("var"), "const": kw("var"), "let": kw("var"),
      "function": kw("function"), "catch": kw("catch"),
      "for": kw("for"), "switch": kw("switch"), "case": kw("case"), "default": kw("default"),
      "in": operator, "typeof": operator, "instanceof": operator,
      "true": atom, "false": atom, "null": atom, "undefined": atom, "NaN": atom, "Infinity": atom,
      "this": kw("this"), "class": kw("class"), "super": kw("atom"),
      "yield": C, "export": kw("export"), "import": kw("import"), "extends": C,
      "await": C
    };
  }();

  var isOperatorChar = /[+\-*&%=<>!?|~^@]/;
  var isJsonldKeyword = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;

  function readRegexp(stream) {
    var escaped = false, next, inSet = false;
    while ((next = stream.next()) != null) {
      if (!escaped) {
        if (next == "/" && !inSet) return;
        if (next == "[") inSet = true;
        else if (inSet && next == "]") inSet = false;
      }
      escaped = !escaped && next == "\\";
    }
  }

  // Used as scratch variables to communicate multiple values without
  // consing up tons of objects.
  var type, content;
  function ret(tp, style, cont) {
    type = tp; content = cont;
    return style;
  }
  function tokenBase(stream, state) {
    var ch = stream.next();
    if (ch == '"' || ch == "'") {
      state.tokenize = tokenString(ch);
      return state.tokenize(stream, state);
    } else if (ch == "." && stream.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) {
      return ret("number", "number");
    } else if (ch == "." && stream.match("..")) {
      return ret("spread", "meta");
    } else if (/[\[\]{}\(\),;\:\.]/.test(ch)) {
      return ret(ch);
    } else if (ch == "=" && stream.eat(">")) {
      return ret("=>", "operator");
    } else if (ch == "0" && stream.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) {
      return ret("number", "number");
    } else if (/\d/.test(ch)) {
      stream.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/);
      return ret("number", "number");
    } else if (ch == "/") {
      if (stream.eat("*")) {
        state.tokenize = tokenComment;
        return tokenComment(stream, state);
      } else if (stream.eat("/")) {
        stream.skipToEnd();
        return ret("comment", "comment");
      } else if (expressionAllowed(stream, state, 1)) {
        readRegexp(stream);
        stream.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/);
        return ret("regexp", "string-2");
      } else {
        stream.eat("=");
        return ret("operator", "operator", stream.current());
      }
    } else if (ch == "`") {
      state.tokenize = tokenQuasi;
      return tokenQuasi(stream, state);
    } else if (ch == "#") {
      stream.skipToEnd();
      return ret("error", "error");
    } else if (ch == "<" && stream.match("!--") || ch == "-" && stream.match("->")) {
      stream.skipToEnd()
      return ret("comment", "comment")
    } else if (isOperatorChar.test(ch)) {
      if (ch != ">" || !state.lexical || state.lexical.type != ">") {
        if (stream.eat("=")) {
          if (ch == "!" || ch == "=") stream.eat("=")
        } else if (/[<>*+\-]/.test(ch)) {
          stream.eat(ch)
          if (ch == ">") stream.eat(ch)
        }
      }
      return ret("operator", "operator", stream.current());
    } else if (wordRE.test(ch)) {
      stream.eatWhile(wordRE);
      var word = stream.current()
      if (state.lastType != ".") {
        if (keywords.propertyIsEnumerable(word)) {
          var kw = keywords[word]
          return ret(kw.type, kw.style, word)
        }
        if (word == "async" && stream.match(/^(\s|\/\*.*?\*\/)*[\[\(\w]/, false))
          return ret("async", "keyword", word)
      }
      return ret("variable", "variable", word)
    }
  }

  function tokenString(quote) {
    return function(stream, state) {
      var escaped = false, next;
      if (jsonldMode && stream.peek() == "@" && stream.match(isJsonldKeyword)){
        state.tokenize = tokenBase;
        return ret("jsonld-keyword", "meta");
      }
      while ((next = stream.next()) != null) {
        if (next == quote && !escaped) break;
        escaped = !escaped && next == "\\";
      }
      if (!escaped) state.tokenize = tokenBase;
      return ret("string", "string");
    };
  }

  function tokenComment(stream, state) {
    var maybeEnd = false, ch;
    while (ch = stream.next()) {
      if (ch == "/" && maybeEnd) {
        state.tokenize = tokenBase;
        break;
      }
      maybeEnd = (ch == "*");
    }
    return ret("comment", "comment");
  }

  function tokenQuasi(stream, state) {
    var escaped = false, next;
    while ((next = stream.next()) != null) {
      if (!escaped && (next == "`" || next == "$" && stream.eat("{"))) {
        state.tokenize = tokenBase;
        break;
      }
      escaped = !escaped && next == "\\";
    }
    return ret("quasi", "string-2", stream.current());
  }

  var brackets = "([{}])";
  // This is a crude lookahead trick to try and notice that we're
  // parsing the argument patterns for a fat-arrow function before we
  // actually hit the arrow token. It only works if the arrow is on
  // the same line as the arguments and there's no strange noise
  // (comments) in between. Fallback is to only notice when we hit the
  // arrow, and not declare the arguments as locals for the arrow
  // body.
  function findFatArrow(stream, state) {
    if (state.fatArrowAt) state.fatArrowAt = null;
    var arrow = stream.string.indexOf("=>", stream.start);
    if (arrow < 0) return;

    if (isTS) { // Try to skip TypeScript return type declarations after the arguments
      var m = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(stream.string.slice(stream.start, arrow))
      if (m) arrow = m.index
    }

    var depth = 0, sawSomething = false;
    for (var pos = arrow - 1; pos >= 0; --pos) {
      var ch = stream.string.charAt(pos);
      var bracket = brackets.indexOf(ch);
      if (bracket >= 0 && bracket < 3) {
        if (!depth) { ++pos; break; }
        if (--depth == 0) { if (ch == "(") sawSomething = true; break; }
      } else if (bracket >= 3 && bracket < 6) {
        ++depth;
      } else if (wordRE.test(ch)) {
        sawSomething = true;
      } else if (/["'\/`]/.test(ch)) {
        for (;; --pos) {
          if (pos == 0) return
          var next = stream.string.charAt(pos - 1)
          if (next == ch && stream.string.charAt(pos - 2) != "\\") { pos--; break }
        }
      } else if (sawSomething && !depth) {
        ++pos;
        break;
      }
    }
    if (sawSomething && !depth) state.fatArrowAt = pos;
  }

  // Parser

  var atomicTypes = {"atom": true, "number": true, "variable": true, "string": true, "regexp": true, "this": true, "jsonld-keyword": true};

  function JSLexical(indented, column, type, align, prev, info) {
    this.indented = indented;
    this.column = column;
    this.type = type;
    this.prev = prev;
    this.info = info;
    if (align != null) this.align = align;
  }

  function inScope(state, varname) {
    for (var v = state.localVars; v; v = v.next)
      if (v.name == varname) return true;
    for (var cx = state.context; cx; cx = cx.prev) {
      for (var v = cx.vars; v; v = v.next)
        if (v.name == varname) return true;
    }
  }

  function parseJS(state, style, type, content, stream) {
    var cc = state.cc;
    // Communicate our context to the combinators.
    // (Less wasteful than consing up a hundred closures on every call.)
    cx.state = state; cx.stream = stream; cx.marked = null, cx.cc = cc; cx.style = style;

    if (!state.lexical.hasOwnProperty("align"))
      state.lexical.align = true;

    while(true) {
      var combinator = cc.length ? cc.pop() : jsonMode ? expression : statement;
      if (combinator(type, content)) {
        while(cc.length && cc[cc.length - 1].lex)
          cc.pop()();
        if (cx.marked) return cx.marked;
        if (type == "variable" && inScope(state, content)) return "variable-2";
        return style;
      }
    }
  }

  // Combinator utils

  var cx = {state: null, column: null, marked: null, cc: null};
  function pass() {
    for (var i = arguments.length - 1; i >= 0; i--) cx.cc.push(arguments[i]);
  }
  function cont() {
    pass.apply(null, arguments);
    return true;
  }
  function inList(name, list) {
    for (var v = list; v; v = v.next) if (v.name == name) return true
    return false;
  }
  function register(varname) {
    var state = cx.state;
    cx.marked = "def";
    if (state.context) {
      if (state.lexical.info == "var" && state.context && state.context.block) {
        // FIXME function decls are also not block scoped
        var newContext = registerVarScoped(varname, state.context)
        if (newContext != null) {
          state.context = newContext
          return
        }
      } else if (!inList(varname, state.localVars)) {
        state.localVars = new Var(varname, state.localVars)
        return
      }
    }
    // Fall through means this is global
    if (parserConfig.globalVars && !inList(varname, state.globalVars))
      state.globalVars = new Var(varname, state.globalVars)
  }
  function registerVarScoped(varname, context) {
    if (!context) {
      return null
    } else if (context.block) {
      var inner = registerVarScoped(varname, context.prev)
      if (!inner) return null
      if (inner == context.prev) return context
      return new Context(inner, context.vars, true)
    } else if (inList(varname, context.vars)) {
      return context
    } else {
      return new Context(context.prev, new Var(varname, context.vars), false)
    }
  }

  function isModifier(name) {
    return name == "public" || name == "private" || name == "protected" || name == "abstract" || name == "readonly"
  }

  // Combinators

  function Context(prev, vars, block) { this.prev = prev; this.vars = vars; this.block = block }
  function Var(name, next) { this.name = name; this.next = next }

  var defaultVars = new Var("this", new Var("arguments", null))
  function pushcontext() {
    cx.state.context = new Context(cx.state.context, cx.state.localVars, false)
    cx.state.localVars = defaultVars
  }
  function pushblockcontext() {
    cx.state.context = new Context(cx.state.context, cx.state.localVars, true)
    cx.state.localVars = null
  }
  function popcontext() {
    cx.state.localVars = cx.state.context.vars
    cx.state.context = cx.state.context.prev
  }
  popcontext.lex = true
  function pushlex(type, info) {
    var result = function() {
      var state = cx.state, indent = state.indented;
      if (state.lexical.type == "stat") indent = state.lexical.indented;
      else for (var outer = state.lexical; outer && outer.type == ")" && outer.align; outer = outer.prev)
        indent = outer.indented;
      state.lexical = new JSLexical(indent, cx.stream.column(), type, null, state.lexical, info);
    };
    result.lex = true;
    return result;
  }
  function poplex() {
    var state = cx.state;
    if (state.lexical.prev) {
      if (state.lexical.type == ")")
        state.indented = state.lexical.indented;
      state.lexical = state.lexical.prev;
    }
  }
  poplex.lex = true;

  function expect(wanted) {
    function exp(type) {
      if (type == wanted) return cont();
      else if (wanted == ";" || type == "}" || type == ")" || type == "]") return pass();
      else return cont(exp);
    };
    return exp;
  }

  function statement(type, value) {
    if (type == "var") return cont(pushlex("vardef", value), vardef, expect(";"), poplex);
    if (type == "keyword a") return cont(pushlex("form"), parenExpr, statement, poplex);
    if (type == "keyword b") return cont(pushlex("form"), statement, poplex);
    if (type == "keyword d") return cx.stream.match(/^\s*$/, false) ? cont() : cont(pushlex("stat"), maybeexpression, expect(";"), poplex);
    if (type == "debugger") return cont(expect(";"));
    if (type == "{") return cont(pushlex("}"), pushblockcontext, block, poplex, popcontext);
    if (type == ";") return cont();
    if (type == "if") {
      if (cx.state.lexical.info == "else" && cx.state.cc[cx.state.cc.length - 1] == poplex)
        cx.state.cc.pop()();
      return cont(pushlex("form"), parenExpr, statement, poplex, maybeelse);
    }
    if (type == "function") return cont(functiondef);
    if (type == "for") return cont(pushlex("form"), forspec, statement, poplex);
    if (type == "class" || (isTS && value == "interface")) {
      cx.marked = "keyword"
      return cont(pushlex("form", type == "class" ? type : value), className, poplex)
    }
    if (type == "variable") {
      if (isTS && value == "declare") {
        cx.marked = "keyword"
        return cont(statement)
      } else if (isTS && (value == "module" || value == "enum" || value == "type") && cx.stream.match(/^\s*\w/, false)) {
        cx.marked = "keyword"
        if (value == "enum") return cont(enumdef);
        else if (value == "type") return cont(typename, expect("operator"), typeexpr, expect(";"));
        else return cont(pushlex("form"), pattern, expect("{"), pushlex("}"), block, poplex, poplex)
      } else if (isTS && value == "namespace") {
        cx.marked = "keyword"
        return cont(pushlex("form"), expression, statement, poplex)
      } else if (isTS && value == "abstract") {
        cx.marked = "keyword"
        return cont(statement)
      } else {
        return cont(pushlex("stat"), maybelabel);
      }
    }
    if (type == "switch") return cont(pushlex("form"), parenExpr, expect("{"), pushlex("}", "switch"), pushblockcontext,
                                      block, poplex, poplex, popcontext);
    if (type == "case") return cont(expression, expect(":"));
    if (type == "default") return cont(expect(":"));
    if (type == "catch") return cont(pushlex("form"), pushcontext, maybeCatchBinding, statement, poplex, popcontext);
    if (type == "export") return cont(pushlex("stat"), afterExport, poplex);
    if (type == "import") return cont(pushlex("stat"), afterImport, poplex);
    if (type == "async") return cont(statement)
    if (value == "@") return cont(expression, statement)
    return pass(pushlex("stat"), expression, expect(";"), poplex);
  }
  function maybeCatchBinding(type) {
    if (type == "(") return cont(funarg, expect(")"))
  }
  function expression(type, value) {
    return expressionInner(type, value, false);
  }
  function expressionNoComma(type, value) {
    return expressionInner(type, value, true);
  }
  function parenExpr(type) {
    if (type != "(") return pass()
    return cont(pushlex(")"), expression, expect(")"), poplex)
  }
  function expressionInner(type, value, noComma) {
    if (cx.state.fatArrowAt == cx.stream.start) {
      var body = noComma ? arrowBodyNoComma : arrowBody;
      if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, expect("=>"), body, popcontext);
      else if (type == "variable") return pass(pushcontext, pattern, expect("=>"), body, popcontext);
    }

    var maybeop = noComma ? maybeoperatorNoComma : maybeoperatorComma;
    if (atomicTypes.hasOwnProperty(type)) return cont(maybeop);
    if (type == "function") return cont(functiondef, maybeop);
    if (type == "class" || (isTS && value == "interface")) { cx.marked = "keyword"; return cont(pushlex("form"), classExpression, poplex); }
    if (type == "keyword c" || type == "async") return cont(noComma ? expressionNoComma : expression);
    if (type == "(") return cont(pushlex(")"), maybeexpression, expect(")"), poplex, maybeop);
    if (type == "operator" || type == "spread") return cont(noComma ? expressionNoComma : expression);
    if (type == "[") return cont(pushlex("]"), arrayLiteral, poplex, maybeop);
    if (type == "{") return contCommasep(objprop, "}", null, maybeop);
    if (type == "quasi") return pass(quasi, maybeop);
    if (type == "new") return cont(maybeTarget(noComma));
    if (type == "import") return cont(expression);
    return cont();
  }
  function maybeexpression(type) {
    if (type.match(/[;\}\)\],]/)) return pass();
    return pass(expression);
  }

  function maybeoperatorComma(type, value) {
    if (type == ",") return cont(maybeexpression);
    return maybeoperatorNoComma(type, value, false);
  }
  function maybeoperatorNoComma(type, value, noComma) {
    var me = noComma == false ? maybeoperatorComma : maybeoperatorNoComma;
    var expr = noComma == false ? expression : expressionNoComma;
    if (type == "=>") return cont(pushcontext, noComma ? arrowBodyNoComma : arrowBody, popcontext);
    if (type == "operator") {
      if (/\+\+|--/.test(value) || isTS && value == "!") return cont(me);
      if (isTS && value == "<" && cx.stream.match(/^([^>]|<.*?>)*>\s*\(/, false))
        return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, me);
      if (value == "?") return cont(expression, expect(":"), expr);
      return cont(expr);
    }
    if (type == "quasi") { return pass(quasi, me); }
    if (type == ";") return;
    if (type == "(") return contCommasep(expressionNoComma, ")", "call", me);
    if (type == ".") return cont(property, me);
    if (type == "[") return cont(pushlex("]"), maybeexpression, expect("]"), poplex, me);
    if (isTS && value == "as") { cx.marked = "keyword"; return cont(typeexpr, me) }
    if (type == "regexp") {
      cx.state.lastType = cx.marked = "operator"
      cx.stream.backUp(cx.stream.pos - cx.stream.start - 1)
      return cont(expr)
    }
  }
  function quasi(type, value) {
    if (type != "quasi") return pass();
    if (value.slice(value.length - 2) != "${") return cont(quasi);
    return cont(expression, continueQuasi);
  }
  function continueQuasi(type) {
    if (type == "}") {
      cx.marked = "string-2";
      cx.state.tokenize = tokenQuasi;
      return cont(quasi);
    }
  }
  function arrowBody(type) {
    findFatArrow(cx.stream, cx.state);
    return pass(type == "{" ? statement : expression);
  }
  function arrowBodyNoComma(type) {
    findFatArrow(cx.stream, cx.state);
    return pass(type == "{" ? statement : expressionNoComma);
  }
  function maybeTarget(noComma) {
    return function(type) {
      if (type == ".") return cont(noComma ? targetNoComma : target);
      else if (type == "variable" && isTS) return cont(maybeTypeArgs, noComma ? maybeoperatorNoComma : maybeoperatorComma)
      else return pass(noComma ? expressionNoComma : expression);
    };
  }
  function target(_, value) {
    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorComma); }
  }
  function targetNoComma(_, value) {
    if (value == "target") { cx.marked = "keyword"; return cont(maybeoperatorNoComma); }
  }
  function maybelabel(type) {
    if (type == ":") return cont(poplex, statement);
    return pass(maybeoperatorComma, expect(";"), poplex);
  }
  function property(type) {
    if (type == "variable") {cx.marked = "property"; return cont();}
  }
  function objprop(type, value) {
    if (type == "async") {
      cx.marked = "property";
      return cont(objprop);
    } else if (type == "variable" || cx.style == "keyword") {
      cx.marked = "property";
      if (value == "get" || value == "set") return cont(getterSetter);
      var m // Work around fat-arrow-detection complication for detecting typescript typed arrow params
      if (isTS && cx.state.fatArrowAt == cx.stream.start && (m = cx.stream.match(/^\s*:\s*/, false)))
        cx.state.fatArrowAt = cx.stream.pos + m[0].length
      return cont(afterprop);
    } else if (type == "number" || type == "string") {
      cx.marked = jsonldMode ? "property" : (cx.style + " property");
      return cont(afterprop);
    } else if (type == "jsonld-keyword") {
      return cont(afterprop);
    } else if (isTS && isModifier(value)) {
      cx.marked = "keyword"
      return cont(objprop)
    } else if (type == "[") {
      return cont(expression, maybetype, expect("]"), afterprop);
    } else if (type == "spread") {
      return cont(expressionNoComma, afterprop);
    } else if (value == "*") {
      cx.marked = "keyword";
      return cont(objprop);
    } else if (type == ":") {
      return pass(afterprop)
    }
  }
  function getterSetter(type) {
    if (type != "variable") return pass(afterprop);
    cx.marked = "property";
    return cont(functiondef);
  }
  function afterprop(type) {
    if (type == ":") return cont(expressionNoComma);
    if (type == "(") return pass(functiondef);
  }
  function commasep(what, end, sep) {
    function proceed(type, value) {
      if (sep ? sep.indexOf(type) > -1 : type == ",") {
        var lex = cx.state.lexical;
        if (lex.info == "call") lex.pos = (lex.pos || 0) + 1;
        return cont(function(type, value) {
          if (type == end || value == end) return pass()
          return pass(what)
        }, proceed);
      }
      if (type == end || value == end) return cont();
      if (sep && sep.indexOf(";") > -1) return pass(what)
      return cont(expect(end));
    }
    return function(type, value) {
      if (type == end || value == end) return cont();
      return pass(what, proceed);
    };
  }
  function contCommasep(what, end, info) {
    for (var i = 3; i < arguments.length; i++)
      cx.cc.push(arguments[i]);
    return cont(pushlex(end, info), commasep(what, end), poplex);
  }
  function block(type) {
    if (type == "}") return cont();
    return pass(statement, block);
  }
  function maybetype(type, value) {
    if (isTS) {
      if (type == ":") return cont(typeexpr);
      if (value == "?") return cont(maybetype);
    }
  }
  function maybetypeOrIn(type, value) {
    if (isTS && (type == ":" || value == "in")) return cont(typeexpr)
  }
  function mayberettype(type) {
    if (isTS && type == ":") {
      if (cx.stream.match(/^\s*\w+\s+is\b/, false)) return cont(expression, isKW, typeexpr)
      else return cont(typeexpr)
    }
  }
  function isKW(_, value) {
    if (value == "is") {
      cx.marked = "keyword"
      return cont()
    }
  }
  function typeexpr(type, value) {
    if (value == "keyof" || value == "typeof" || value == "infer") {
      cx.marked = "keyword"
      return cont(value == "typeof" ? expressionNoComma : typeexpr)
    }
    if (type == "variable" || value == "void") {
      cx.marked = "type"
      return cont(afterType)
    }
    if (value == "|" || value == "&") return cont(typeexpr)
    if (type == "string" || type == "number" || type == "atom") return cont(afterType);
    if (type == "[") return cont(pushlex("]"), commasep(typeexpr, "]", ","), poplex, afterType)
    if (type == "{") return cont(pushlex("}"), commasep(typeprop, "}", ",;"), poplex, afterType)
    if (type == "(") return cont(commasep(typearg, ")"), maybeReturnType, afterType)
    if (type == "<") return cont(commasep(typeexpr, ">"), typeexpr)
  }
  function maybeReturnType(type) {
    if (type == "=>") return cont(typeexpr)
  }
  function typeprop(type, value) {
    if (type == "variable" || cx.style == "keyword") {
      cx.marked = "property"
      return cont(typeprop)
    } else if (value == "?" || type == "number" || type == "string") {
      return cont(typeprop)
    } else if (type == ":") {
      return cont(typeexpr)
    } else if (type == "[") {
      return cont(expect("variable"), maybetypeOrIn, expect("]"), typeprop)
    } else if (type == "(") {
      return pass(functiondecl, typeprop)
    }
  }
  function typearg(type, value) {
    if (type == "variable" && cx.stream.match(/^\s*[?:]/, false) || value == "?") return cont(typearg)
    if (type == ":") return cont(typeexpr)
    if (type == "spread") return cont(typearg)
    return pass(typeexpr)
  }
  function afterType(type, value) {
    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
    if (value == "|" || type == "." || value == "&") return cont(typeexpr)
    if (type == "[") return cont(typeexpr, expect("]"), afterType)
    if (value == "extends" || value == "implements") { cx.marked = "keyword"; return cont(typeexpr) }
    if (value == "?") return cont(typeexpr, expect(":"), typeexpr)
  }
  function maybeTypeArgs(_, value) {
    if (value == "<") return cont(pushlex(">"), commasep(typeexpr, ">"), poplex, afterType)
  }
  function typeparam() {
    return pass(typeexpr, maybeTypeDefault)
  }
  function maybeTypeDefault(_, value) {
    if (value == "=") return cont(typeexpr)
  }
  function vardef(_, value) {
    if (value == "enum") {cx.marked = "keyword"; return cont(enumdef)}
    return pass(pattern, maybetype, maybeAssign, vardefCont);
  }
  function pattern(type, value) {
    if (isTS && isModifier(value)) { cx.marked = "keyword"; return cont(pattern) }
    if (type == "variable") { register(value); return cont(); }
    if (type == "spread") return cont(pattern);
    if (type == "[") return contCommasep(eltpattern, "]");
    if (type == "{") return contCommasep(proppattern, "}");
  }
  function proppattern(type, value) {
    if (type == "variable" && !cx.stream.match(/^\s*:/, false)) {
      register(value);
      return cont(maybeAssign);
    }
    if (type == "variable") cx.marked = "property";
    if (type == "spread") return cont(pattern);
    if (type == "}") return pass();
    if (type == "[") return cont(expression, expect(']'), expect(':'), proppattern);
    return cont(expect(":"), pattern, maybeAssign);
  }
  function eltpattern() {
    return pass(pattern, maybeAssign)
  }
  function maybeAssign(_type, value) {
    if (value == "=") return cont(expressionNoComma);
  }
  function vardefCont(type) {
    if (type == ",") return cont(vardef);
  }
  function maybeelse(type, value) {
    if (type == "keyword b" && value == "else") return cont(pushlex("form", "else"), statement, poplex);
  }
  function forspec(type, value) {
    if (value == "await") return cont(forspec);
    if (type == "(") return cont(pushlex(")"), forspec1, poplex);
  }
  function forspec1(type) {
    if (type == "var") return cont(vardef, forspec2);
    if (type == "variable") return cont(forspec2);
    return pass(forspec2)
  }
  function forspec2(type, value) {
    if (type == ")") return cont()
    if (type == ";") return cont(forspec2)
    if (value == "in" || value == "of") { cx.marked = "keyword"; return cont(expression, forspec2) }
    return pass(expression, forspec2)
  }
  function functiondef(type, value) {
    if (value == "*") {cx.marked = "keyword"; return cont(functiondef);}
    if (type == "variable") {register(value); return cont(functiondef);}
    if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, statement, popcontext);
    if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondef)
  }
  function functiondecl(type, value) {
    if (value == "*") {cx.marked = "keyword"; return cont(functiondecl);}
    if (type == "variable") {register(value); return cont(functiondecl);}
    if (type == "(") return cont(pushcontext, pushlex(")"), commasep(funarg, ")"), poplex, mayberettype, popcontext);
    if (isTS && value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, functiondecl)
  }
  function typename(type, value) {
    if (type == "keyword" || type == "variable") {
      cx.marked = "type"
      return cont(typename)
    } else if (value == "<") {
      return cont(pushlex(">"), commasep(typeparam, ">"), poplex)
    }
  }
  function funarg(type, value) {
    if (value == "@") cont(expression, funarg)
    if (type == "spread") return cont(funarg);
    if (isTS && isModifier(value)) { cx.marked = "keyword"; return cont(funarg); }
    if (isTS && type == "this") return cont(maybetype, maybeAssign)
    return pass(pattern, maybetype, maybeAssign);
  }
  function classExpression(type, value) {
    // Class expressions may have an optional name.
    if (type == "variable") return className(type, value);
    return classNameAfter(type, value);
  }
  function className(type, value) {
    if (type == "variable") {register(value); return cont(classNameAfter);}
  }
  function classNameAfter(type, value) {
    if (value == "<") return cont(pushlex(">"), commasep(typeparam, ">"), poplex, classNameAfter)
    if (value == "extends" || value == "implements" || (isTS && type == ",")) {
      if (value == "implements") cx.marked = "keyword";
      return cont(isTS ? typeexpr : expression, classNameAfter);
    }
    if (type == "{") return cont(pushlex("}"), classBody, poplex);
  }
  function classBody(type, value) {
    if (type == "async" ||
        (type == "variable" &&
         (value == "static" || value == "get" || value == "set" || (isTS && isModifier(value))) &&
         cx.stream.match(/^\s+[\w$\xa1-\uffff]/, false))) {
      cx.marked = "keyword";
      return cont(classBody);
    }
    if (type == "variable" || cx.style == "keyword") {
      cx.marked = "property";
      return cont(isTS ? classfield : functiondef, classBody);
    }
    if (type == "number" || type == "string") return cont(isTS ? classfield : functiondef, classBody);
    if (type == "[")
      return cont(expression, maybetype, expect("]"), isTS ? classfield : functiondef, classBody)
    if (value == "*") {
      cx.marked = "keyword";
      return cont(classBody);
    }
    if (isTS && type == "(") return pass(functiondecl, classBody)
    if (type == ";" || type == ",") return cont(classBody);
    if (type == "}") return cont();
    if (value == "@") return cont(expression, classBody)
  }
  function classfield(type, value) {
    if (value == "?") return cont(classfield)
    if (type == ":") return cont(typeexpr, maybeAssign)
    if (value == "=") return cont(expressionNoComma)
    var context = cx.state.lexical.prev, isInterface = context && context.info == "interface"
    return pass(isInterface ? functiondecl : functiondef)
  }
  function afterExport(type, value) {
    if (value == "*") { cx.marked = "keyword"; return cont(maybeFrom, expect(";")); }
    if (value == "default") { cx.marked = "keyword"; return cont(expression, expect(";")); }
    if (type == "{") return cont(commasep(exportField, "}"), maybeFrom, expect(";"));
    return pass(statement);
  }
  function exportField(type, value) {
    if (value == "as") { cx.marked = "keyword"; return cont(expect("variable")); }
    if (type == "variable") return pass(expressionNoComma, exportField);
  }
  function afterImport(type) {
    if (type == "string") return cont();
    if (type == "(") return pass(expression);
    return pass(importSpec, maybeMoreImports, maybeFrom);
  }
  function importSpec(type, value) {
    if (type == "{") return contCommasep(importSpec, "}");
    if (type == "variable") register(value);
    if (value == "*") cx.marked = "keyword";
    return cont(maybeAs);
  }
  function maybeMoreImports(type) {
    if (type == ",") return cont(importSpec, maybeMoreImports)
  }
  function maybeAs(_type, value) {
    if (value == "as") { cx.marked = "keyword"; return cont(importSpec); }
  }
  function maybeFrom(_type, value) {
    if (value == "from") { cx.marked = "keyword"; return cont(expression); }
  }
  function arrayLiteral(type) {
    if (type == "]") return cont();
    return pass(commasep(expressionNoComma, "]"));
  }
  function enumdef() {
    return pass(pushlex("form"), pattern, expect("{"), pushlex("}"), commasep(enummember, "}"), poplex, poplex)
  }
  function enummember() {
    return pass(pattern, maybeAssign);
  }

  function isContinuedStatement(state, textAfter) {
    return state.lastType == "operator" || state.lastType == "," ||
      isOperatorChar.test(textAfter.charAt(0)) ||
      /[,.]/.test(textAfter.charAt(0));
  }

  function expressionAllowed(stream, state, backUp) {
    return state.tokenize == tokenBase &&
      /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(state.lastType) ||
      (state.lastType == "quasi" && /\{\s*$/.test(stream.string.slice(0, stream.pos - (backUp || 0))))
  }

  // Interface

  return {
    startState: function(basecolumn) {
      var state = {
        tokenize: tokenBase,
        lastType: "sof",
        cc: [],
        lexical: new JSLexical((basecolumn || 0) - indentUnit, 0, "block", false),
        localVars: parserConfig.localVars,
        context: parserConfig.localVars && new Context(null, null, false),
        indented: basecolumn || 0
      };
      if (parserConfig.globalVars && typeof parserConfig.globalVars == "object")
        state.globalVars = parserConfig.globalVars;
      return state;
    },

    token: function(stream, state) {
      if (stream.sol()) {
        if (!state.lexical.hasOwnProperty("align"))
          state.lexical.align = false;
        state.indented = stream.indentation();
        findFatArrow(stream, state);
      }
      if (state.tokenize != tokenComment && stream.eatSpace()) return null;
      var style = state.tokenize(stream, state);
      if (type == "comment") return style;
      state.lastType = type == "operator" && (content == "++" || content == "--") ? "incdec" : type;
      return parseJS(state, style, type, content, stream);
    },

    indent: function(state, textAfter) {
      if (state.tokenize == tokenComment) return CodeMirror.Pass;
      if (state.tokenize != tokenBase) return 0;
      var firstChar = textAfter && textAfter.charAt(0), lexical = state.lexical, top
      // Kludge to prevent 'maybelse' from blocking lexical scope pops
      if (!/^\s*else\b/.test(textAfter)) for (var i = state.cc.length - 1; i >= 0; --i) {
        var c = state.cc[i];
        if (c == poplex) lexical = lexical.prev;
        else if (c != maybeelse) break;
      }
      while ((lexical.type == "stat" || lexical.type == "form") &&
             (firstChar == "}" || ((top = state.cc[state.cc.length - 1]) &&
                                   (top == maybeoperatorComma || top == maybeoperatorNoComma) &&
                                   !/^[,\.=+\-*:?[\(]/.test(textAfter))))
        lexical = lexical.prev;
      if (statementIndent && lexical.type == ")" && lexical.prev.type == "stat")
        lexical = lexical.prev;
      var type = lexical.type, closing = firstChar == type;

      if (type == "vardef") return lexical.indented + (state.lastType == "operator" || state.lastType == "," ? lexical.info.length + 1 : 0);
      else if (type == "form" && firstChar == "{") return lexical.indented;
      else if (type == "form") return lexical.indented + indentUnit;
      else if (type == "stat")
        return lexical.indented + (isContinuedStatement(state, textAfter) ? statementIndent || indentUnit : 0);
      else if (lexical.info == "switch" && !closing && parserConfig.doubleIndentSwitch != false)
        return lexical.indented + (/^(?:case|default)\b/.test(textAfter) ? indentUnit : 2 * indentUnit);
      else if (lexical.align) return lexical.column + (closing ? 0 : 1);
      else return lexical.indented + (closing ? 0 : indentUnit);
    },

    electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
    blockCommentStart: jsonMode ? null : "/*",
    blockCommentEnd: jsonMode ? null : "*/",
    blockCommentContinue: jsonMode ? null : " * ",
    lineComment: jsonMode ? null : "//",
    fold: "brace",
    closeBrackets: "()[]{}''\"\"``",

    helperType: jsonMode ? "json" : "javascript",
    jsonldMode: jsonldMode,
    jsonMode: jsonMode,

    expressionAllowed: expressionAllowed,

    skipExpression: function(state) {
      var top = state.cc[state.cc.length - 1]
      if (top == expression || top == expressionNoComma) state.cc.pop()
    }
  };
});

CodeMirror.registerHelper("wordChars", "javascript", /[\w$]/);

CodeMirror.defineMIME("text/javascript", "javascript");
CodeMirror.defineMIME("text/ecmascript", "javascript");
CodeMirror.defineMIME("application/javascript", "javascript");
CodeMirror.defineMIME("application/x-javascript", "javascript");
CodeMirror.defineMIME("application/ecmascript", "javascript");
CodeMirror.defineMIME("application/json", {name: "javascript", json: true});
CodeMirror.defineMIME("application/x-json", {name: "javascript", json: true});
CodeMirror.defineMIME("application/ld+json", {name: "javascript", jsonld: true});
CodeMirror.defineMIME("text/typescript", { name: "javascript", typescript: true });
CodeMirror.defineMIME("application/typescript", { name: "javascript", typescript: true });

});

(function () {
	'use strict';

	angular
		.module('fuse')
		.run(runBlock);

	/** @ngInject */
	function runBlock($rootScope, $translate, $timeout, $state, $window, userService) {

		var returnLogin = function () {
			$rootScope.skipSomeAsync = true;
			$window.location.href = './login';
		};

		var returnAccessDenied = function () {
			$rootScope.skipSomeAsync = true;
			$window.location.href = './error-401';
		};

		var continueNavigation = function (toState, toParams) {
			var params = angular.copy(toParams);
			$rootScope.skipSomeAsync = true;
			$state.go(toState.name, params);
		};

		// Activate loading indicator
		$rootScope.skipSomeAsync = false;
		var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
			$rootScope.loadingProgress = true;
			if ($rootScope.skipSomeAsync) {
				return;
			}
			// active manual routing
			event.preventDefault();
			if (toState.name === 'login') {
				userService.getCurrent($translate.preferredLanguage(), false).then(function (data) {
					if (data != null) {
						$rootScope.skipSomeAsync = true;
						$window.location.href = './home';
					} else {
						continueNavigation(toState, toParams);
					}
				}).catch(function () {
					continueNavigation(toState, toParams);
				});
			} else if (toState.name === 'app.home') {
				userService.getCurrent($translate.preferredLanguage(), false).then(function (data) {
					if (data != null) {
						if (!angular.isUndefined(toState.data) && !angular.isUndefined(toState.data.permissions) && toState.data.permissions.length > 0 && !userService.containsAtLeastOneRole(toState.data.permissions)) {
							$rootScope.skipSomeAsync = true;
							$window.location.href = './empty';
						} else {
							continueNavigation(toState, toParams);
						}
					}
				}).catch(function () {
					returnLogin();
				});
			} else if (toState.name === 'app.empty') {
				userService.getCurrent($translate.preferredLanguage(), false).then(function (data) {
					if (data != null) {
						continueNavigation(toState, toParams);
					} else {
						returnLogin();
					}
				}).catch(function () {
					returnLogin();
				});
			} else if (toState.name === 'app.error-404' || toState.name === 'app.error-401' || toState.name === 'activateAccount' || toState.name === 'forgotPassword' || toState.name === 'updatePassword') {
				continueNavigation(toState, toParams);
			} else {
				$state.previous = {
					'fromState': fromState,
					'fromParams': fromParams
				};
				userService.getCurrent($translate.preferredLanguage(), false).then(function (data) {
					var canContinue = true;
					var exception = (toState.name === 'app.companies.details' || toState.name === 'app.companies.details.contact'
						|| toState.name === 'app.companies.details.contact.logistic') && userService.isMember();
					if (data != null) {
						if (!angular.isUndefined(toState.data) && !exception) {
							if (!angular.isUndefined(toState.data.permissions) && toState.data.permissions.length > 0) {
								if (!userService.containsAtLeastOneRole(toState.data.permissions)) {
									canContinue = false;
									returnAccessDenied();
								}
							}
							if (!angular.isUndefined(toState.data.checkUserCompanySubTypes) && toState.data.checkUserCompanySubTypes) {
								var subTypeId = -1;
								if (toParams.subType != null && !isNaN(toParams.subType)) {
									subTypeId = parseInt(toParams.subType);
								}
								if (!data.allCompanySubTypes && data.subTypeIds.lastIndexOf(subTypeId) === -1) {
									canContinue = false;
									returnAccessDenied();
								}
							}
							if (!angular.isUndefined(toState.data.checkUserEvents) && toState.data.checkUserEvents) {
								var eventId = -1;
								if (toParams.id != null && !isNaN(toParams.id)) {
									eventId = parseInt(toParams.id);
								}
								if (!data.allEvents && data.eventIds.lastIndexOf(eventId) === -1) {
									canContinue = false;
									returnAccessDenied();
								}
							}
						}
						if (canContinue) {
							continueNavigation(toState, toParams);
						}
					} else {
						returnLogin();
					}
				}).catch(function () {
					returnLogin();
				});
			}
			$rootScope.skipSomeAsync = false;
		});

		// De-activate loading indicator
		var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function () {
			$timeout(function () {
				$rootScope.loadingProgress = false;
			});
		});


		// Store state in the root scope for easy access
		$rootScope.state = $state;

		// Cleanup
		$rootScope.$on('$destroy', function () {
			stateChangeStartEvent();
			stateChangeSuccessEvent();
		});

		$rootScope.$on('$translatePartialLoaderStructureChanged', function () {
			$translate.refresh();
		});
	}
})();

(function () {
	'use strict';

	angular
		.module('fuse')
		.config(routeConfig);

	/** @ngInject */
	function routeConfig($stateProvider, $urlRouterProvider, $locationProvider, $httpProvider) {
		$locationProvider.html5Mode(true);

		$urlRouterProvider.otherwise(function ($injector, $scope, $translate) {
			var state = $injector.get('$state');
			var userService = $injector.get('userService');
			var window_ = $injector.get('$window');
			userService.getCurrent('en', false).then(function (data) {
				var roleNames = data.rights.map(function (role) {
					return role.name;
				});
				if (data != null) {
					if (roleNames.lastIndexOf('AGENDA') === -1) {
						state.go('app.empty');
					} else {
						state.go('app.home');
					}
				}
			}).catch(function (error) {
				if (angular.isUndefined(error) || error == null || error.status === 404 || error.status === 401) {
					state.go('login');
				}
			});
		});

		/**
		 * Layout Style Switcher
		 *
		 * This code is here for demonstration purposes.
		 * If you don't need to switch between the layout
		 * styles like in the demo, you can set one manually by
		 * typing the template urls into the `State definitions`
		 * area and remove this code
		 */
		// Inject $cookies
		var $cookies;

		angular.injector(['ngCookies']).invoke([
			'$cookies',
			function (_$cookies) {
				$cookies = _$cookies;
			}
		]);

		// Get active layout
		var layoutStyle = 'verticalNavigation';

		var layouts = {
			verticalNavigation: {
				main: 'app/navigation/vertical-navigation.html',
				toolbar: 'app/toolbar/layouts/vertical-navigation/toolbar.html',
				navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
			},
			verticalNavigationFullwidthToolbar: {
				main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
				toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
				navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
			},
			verticalNavigationFullwidthToolbar2: {
				main: 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
				toolbar: 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
				navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
			},
			horizontalNavigation: {
				main: 'app/core/layouts/horizontal-navigation.html',
				toolbar: 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
				navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
			},
			contentOnly: {
				main: 'app/core/layouts/content-only.html',
				toolbar: '',
				navigation: ''
			},
			contentWithToolbar: {
				main: 'app/core/layouts/content-with-toolbar.html',
				toolbar: 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
				navigation: ''
			},
			siteGenNavigation: {
				main: 'app/main/sitegen/navigation/horizontal-navigation.html',
				toolbar: 'app/main/sitegen/toolbar/layouts/horizontal-navigation/toolbar.html',
				navigation: 'app/main/sitegen/navigation/layouts/horizontal-navigation/navigation.html'
			}
		};
		// END - Layout Style Switcher

		// State definitions
		$stateProvider
			.state('app', {
				abstract: true,
				views: {
					'main@': {
						templateUrl: layouts[layoutStyle].main,
						controller: 'MainController as vm'
					},
					'toolbar@app': {
						templateUrl: layouts[layoutStyle].toolbar,
						controller: 'ToolbarController as vm'
					},
					'navigation@app': {
						templateUrl: layouts[layoutStyle].navigation,
						controller: 'NavigationController as vm'
					},
					'quickPanel@app': {
						templateUrl: 'app/quick-panel/quick-panel.html',
						controller: 'QuickPanelController as vm'
					}
				}
			})
			.state('sitegen', {
				abstract: true,
				views: {
					'main@': {
						templateUrl: layouts['siteGenNavigation'].main,
						controller: 'SiteGenMainController as vm'
					},
					'toolbar@sitegen': {
						templateUrl: layouts['siteGenNavigation'].toolbar,
						controller: 'SiteGenToolbarController as vm'
					},
					'navigation@sitegen': {
						templateUrl: layouts['siteGenNavigation'].navigation,
						controller: 'SiteGenNavigationController as vm'
					},
					'quickPanel@sitegen': {
						templateUrl: 'app/quick-panel/quick-panel.html',
						controller: 'QuickPanelController as vm'
					}
				}
			})
			.state('mailing_preview', {
				abstract: true,
				views: {
					'main@': {
						templateUrl: layouts['contentOnly'].main,
						controller: 'MailingPreviewMainController as vm'
					},
					'toolbar@mailing_preview': {
						templateUrl: layouts['contentOnly'].toolbar,
						controller: 'MailingPreviewToolbarController as vm'
					},
					'navigation@mailing_preview': {
						templateUrl: layouts['contentOnly'].navigation,
						controller: 'MailingPreviewNavigationController as vm'
					},
					'quickPanel@mailing_preview': {
						templateUrl: 'app/quick-panel/quick-panel.html',
						controller: 'QuickPanelController as vm'
					}
				}
			});

		$httpProvider.interceptors.push(function ($q, $injector, PUBLIC_PAGES) {
			return {
				'responseError': function (response) {
					// same as above
					if (response.status === 401) {
						var state = $injector.get('$state');
						if (PUBLIC_PAGES.lastIndexOf(state.current.name) === -1 && !state.current.abstract) {
							state.go('login');
						}
					}
					return $q.reject(response);
				}
			};
		});
	}

})();

(function () {
	'use strict';

	angular.module('fuse').filter('showAllUsers', function () {
		return function (items, showAllUsers) {
			var filtered = [];
			if (items != null && angular.isArray(items)) {
				for (var i = 0; i < items.length; i++) {
					var item = items[i];
					if (showAllUsers) {
						filtered.push(item);
					} else {
						if (item.activated) {
							filtered.push(item);
						}
					}
				}
			}
			return filtered;
		};
	});

	angular.module('fuse').filter('stringToDate', function () {
		return function (item) {
			if (item != null && item.length > 0) {
				var parts = item.split('/');
				if (parts.length === 3) {
					var day = parseInt(parts[0]);
					var month = parseInt(parts[1]) - 1;
					var year = parseInt(parts[2]);
					return new Date(year, month, day);
				}
			}
			return null;
		};
	});

	//   angular.module('fuse').filter('unique', function ($filter) {
	//     return function (items, property) {
	//       var result = [];

	//       if (items) {
	//         for (var i = 0; i < items.length; i++) {
	//           //console.log($filter('filter')(result, {[property]: items[i][property]}));
	//           if ($filter('filter')(result, {
	//               [property]: items[i][property]
	//             }).length === 0) {
	//             result.push(items[i]);
	//           }
	//         }
	//       }

	//       return result;
	//     };
	//   });

	angular.module('fuse').filter('filterText', function () {
		return function (items, searchString) {
			if (!searchString) {
				return items;
			} else {
				var filtered = [];

				for (var i = 0; i < items.length; i++) {
					if (items[i].name) {
						if (items[i].name.toLocaleLowerCase().includes(searchString.toLocaleLowerCase())) {
							filtered.push(items[i]);
						}
					} else if (items[i].libelle) {
						if (items[i].libelle.toLocaleLowerCase().includes(searchString.toLocaleLowerCase())) {
							filtered.push(items[i]);
						}
					} else if (items[i].value) {
						if (items[i].value.toLocaleLowerCase().includes(searchString.toLocaleLowerCase())) {
							filtered.push(items[i]);
						}
					} else if (items[i].fullName) {
						if (items[i].fullName.toLocaleLowerCase().includes(searchString.toLocaleLowerCase())) {
							filtered.push(items[i]);
						}
					} else {
						// console.log(items[i]);
						// filtered = items;
						// break;
					}

				}

				return filtered;
			}
		};
	});

	angular.module('fuse').filter('showColumn', function ($filter) {
		return function (item, index) {
			var result = '';
			if (angular.isArray(item.columns)) {
				var columnByIndex = item.columns.filter(function (column) {
					return column.columnIndex === index;
				});
				if (columnByIndex[0].fields.length > 0) {
					angular.forEach(columnByIndex[0].fields, function (field, index) {
						if (!field.fixField) {
							for (var i = 0; i < item.valuedFields.length; i++) {
								if (item.valuedFields[i] != null && item.valuedFields[i].idBaseField === field.field.id) {
									if (item.valuedFields[i].value != null && item.valuedFields[i].value !== '') {

										if (result.length > 0) {
											result += ' - ';
										}
										if (field.field.typeChamps === 'DATE') {
											result += $filter('translate')('GENERAL.DATE_FORMAT', {
												date: $filter('stringToDate')(item.valuedFields[i].value)
											});
										} else if (field.field.typeChamps === 'URL') {
											result += '<a href="' + item.valuedFields[i].value + '" target="_blank">' + item.valuedFields[i].value + '</a>';
										} else if (field.field.typeChamps === 'EMAIL') {
											result += '<a href="mailto:' + item.valuedFields[i].value + '">' + item.valuedFields[i].value + '</a>';
										} else if (field.field.typeChamps === 'LIST_SELECT' && field.field.listFieldsDTO != null && field.field.listFieldsDTO.length > 0) {
											var color = '';
											for (var j = 0; j < field.field.listFieldsDTO.length; j++) {
												if (field.field.listFieldsDTO[j].value === item.valuedFields[i].value && field.field.listFieldsDTO[j].color != null) {
													color = angular.copy(field.field.listFieldsDTO[j].color);

													break;
												}
											}
											result += '<span style="color:' + color + ';">' + item.valuedFields[i].value + '</span>';
										} else {
											result += item.valuedFields[i].value;
										}
									}
									break;
								}
							}
						} else {
							if (field.fixFieldKey) {
								if (field.fixFieldKey === 'FIXE_FIELD_REGISTRATION_SUBCATEGORY') {
									if (item.subCategory && item.subCategory.name) {
										result += item.subCategory.name;
									}
								} else if (field.fixFieldKey === 'FIXE_FIELD_LOGISTIC_STATUS') {
									if (item.logisticStatus && item.logisticStatus.name) {
										result += item.logisticStatus.name;
									}
								} else if (field.fixFieldKey === 'FIXE_FIELD_REGISTRATION_STATUS') {
									if (item.registrationStatus && item.registrationStatus.name) {
										result += item.registrationStatus.name;
									}
								}
							}
						}
					});
				}
			}
			return result;
		};
	});

	angular.module('fuse').filter('getClicks', function () {
		return function (clicks, type) {
			for (var i = 0; i < clicks.length; i++) {
				if (clicks[i].type === type) {
					return clicks[i].nbr;
				}
			}
		};
	});

	angular.module('fuse').filter('nlEllipsis', function () {
		return function (htmlText, limit) {
			if (!htmlText) {
				return htmlText;
			}
			var arrayString = htmlText.split(/<(?:.|\n)*?>/gm);
			var arrayTags = htmlText.match(/<(?:.|\n)*?>/gm);
			var regExpClosing = new RegExp('^<\/');
			var regExpBR = new RegExp('^<br');
			var result = '';

			var charCount = 0;
			var closingTagsCount = 0;
			var openingTagsCount = 0;

			for (var i = 0; i < arrayString.length; i++) {
				for (var j = 0; j < arrayString[i].length; j++) {
					if (charCount < limit) {
						result += arrayString[i][j];
					} else {
						//we don't want to cut a word at the end: we delete "orphant chars"
						var k = result.length;

						while (k--) {
							if (result[k] === ' ') {
								result = result.substring(0, k);
								break;
							}
						}
						result += '...';
						//check if last tag was opening or closing tag
						if (closingTagsCount !== openingTagsCount) {
							var counterTags = 0;

							while (closingTagsCount < openingTagsCount) {
								if (arrayTags.length > i + counterTags) {
									if (!regExpBR.test(arrayTags[i + counterTags]) && arrayTags[i + counterTags] != null) {
										result += arrayTags[i + counterTags];
										if (regExpClosing.test(arrayTags[i + counterTags])) {
											closingTagsCount++;
										} else {
											openingTagsCount++;
										}
									}

									counterTags++;
								} else {
									break;
								}
							}
						}

						return result;
					}

					charCount++;
				}
				if (arrayTags && arrayTags.length > 0 && arrayTags[i] != null) {
					result += arrayTags[i];
				} else {
					if (charCount >= limit) {
						result += '...';
					}

					return result;
				}

				if (arrayTags[i] != null && regExpClosing.test(arrayTags[i])) {
					closingTagsCount++;
				} else if (arrayTags[i] != null && !regExpBR.test(arrayTags[i])) {
					openingTagsCount++;
				}
			}

			result += '...';
			return result;
		};
	});

	angular.module('app.front').filter('filterTranslate', function ($filter) {
		return function (items, text) {
			var res = [];
			if (angular.isArray(items) && text != null) {
				var regExp = new RegExp('^.*' + text + '.*$', 'i');
				return $filter('filter')(items, function (value, index, array) {
					var translate = $filter('translate')(value.translateKey);
					return regExp.test(translate);
				});
			} else {
				return items;
			}
		};
	});

})();

(function () {
	'use strict';

	angular.module('fuse').directive('dropifyDirective', function ($timeout, $q, URL) {
		return {
			restrict: 'E',
			replace: true,
			scope: {
				filesave: '=',
				filesavename: '=',
				initfile: '=ngModel',
				required: '=?required'
			},
			template: '<input type="file" data-default-file="{{initfile.src}}" data-show-loader="false"  data-max-file-size-preview="1G" data-show-remove="false" ng-required="{{!!required}}"/>',
			link: function (scope, element, attributes) {

				function getBase64(file) {
					return $q(function (resolve, reject) {
						var reader = new FileReader();
						reader.readAsDataURL(file);
						reader.onload = function () {
							resolve(reader.result);
						};
						reader.onerror = function (error) {
							reject(error);
						};
					});
				}

				$timeout(function () {
					var $this = $(element);

					var dropify = $this.dropify({
						// defaultFile: scope.initfile.src,
						messages: {
							'default': 'Glisser-déposer une image ici ou cliquer',
							'replace': 'Glisser-déposer une image ici ou cliquer pour remplacer',
							'remove': 'Supprimer',
							'error': 'Oups, une erreur est survenue'
						}
					});
					var loader = document.createElement('div');
					$(loader).addClass('dropify-loader');
					$(loader).addClass('hidden');
					$(element).parents().get(0).children[0].after(loader)
					$this.bind('change', function (changeEvent) {
						//$rootScope.$broadcast('changePicture');
						scope.$apply(function () {
							scope.filesave = changeEvent.target.files[0];

						});
					});
					scope.$on('inputImageUpdate',(event, args)=> {
						var loader = $(element).parents().get(0).getElementsByClassName('dropify-loader')[0];
						$(loader).addClass('hidden');
					})
					scope.$on('showLoader',(event, args)=> {

						if(scope.initfile.id==args.id){
							var loader = $(element).parents().get(0).getElementsByClassName('dropify-loader')[0];
							$(loader).removeClass('hidden');
						}
					})
				});
			}
		};
	}).directive('forceSelectFocus', function () {
		return {
			restrict: 'A',
			require: ['^^mdSelect', '^ngModel'],
			link: function (scope, element, controller) {
				scope.$watch(function () {
					var foundElement = element;
					while (!foundElement.hasClass('md-select-menu-container')) {
						foundElement = foundElement.parent();
					}
					return foundElement.hasClass('md-active');
				}, function (newVal) {
					if (newVal) {
						console.log(controller[1]);
						element.focus();
					}
				})
			}
		}
	}).directive('ngEnter', function () {
		return function (scope, element, attrs) {
			element.bind("keydown keypress", function (event) {
				if (event.which === 13) {
					scope.$apply(function () {
						scope.$eval(attrs.ngEnter);
					});

					event.preventDefault();
				}
			});
		};
	}).directive('httpSrc', ['$http', function ($http) {
		return {
			// do not share scope with sibling img tags and parent
			// (prevent show same images on img tag)
			scope: {
				httpSrc: '@',
				hasProfilePicture: '=',
				isArticle: '=',
				isInstitution: '=',
				noCache: '='
			},
			link: function ($scope, elem, attrs) {
				function revokeObjectURL() {
					if ($scope.objectURL) {
						URL.revokeObjectURL($scope.objectURL);
					}
				}

				$scope.$watch('objectURL', function (objectURL) {
					elem.attr('src', objectURL);
				});

				$scope.$on('$destroy', function () {
					revokeObjectURL();
				});

				function refreshPhoto(url) {
					revokeObjectURL();
					if ($scope.hasProfilePicture) {
						if (url && url.indexOf('data:') === 0) {
							$scope.objectURL = url;
						} else if (url) {
							$http.get(url, {
									responseType: 'arraybuffer',
									cache: (attrs.noCache ? false : true),
									headers: {
										'accept': 'image/webp,image/*,*/*;q=0.8'
									}
								})
								.then(function (response) {
									var blob = new Blob(
										[response.data], {
											type: response.headers('Content-Type')
										}
									);
									$scope.objectURL = URL.createObjectURL(blob);
								}).catch(function (error) {
									//console.log(error);
								});
						}
					} else {
						if ($scope.isArticle) {
							$scope.objectURL = 'assets/images/article/noArticlePhoto.png';
						} else if ($scope.isInstitution) {
							$scope.objectURL = 'assets/icons/rendus/profil/clinique.png';
						} else {
							$scope.objectURL = 'assets/icons/rendus/popup/pop-up-avatar-icone@3x.png';
						}
					}
				};

				$scope.$on('refreshPhoto', function () {
					refreshPhoto(attrs.httpSrc);
				});

				attrs.$observe('httpSrc', function (url) {
					refreshPhoto(url);
				});
			}
		};
	}]).directive('stringToNumber', function () {
		return {
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				ngModel.$parsers.push(function (value) {
					return '' + value;
				});
				ngModel.$formatters.push(function (value) {
					return parseFloat(value);
				});
			}
		};
	}).directive('stringToBoolean', function () {
		return {
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				ngModel.$parsers.push(function (value) {
					return '' + value;
				});
				ngModel.$formatters.push(function (value) {
					return value == "true";
				});
			}
		};
	});

	angular.module('fuse').directive('nooInputEvent', function ($timeout) {

		var linker = function (scope, element, attrs) {
			var initializing = true;
			if (scope.model.typeChamps === 'IMAGE') {
				if (scope.model.location != null && scope.model.location !== '') {
					scope.model.src = URL.alternatedocroots + '/' + scope.model.location;
				} else {
					scope.model.src = '';
				}
			}

			scope.$watch('model', function (newModel, oldModel) {
				if (initializing) {
					$timeout(function () {
						initializing = false;
					});
				} else {
					scope.watch({
						field: scope.field
					});
				}
			}, true);
		};



		return {
			restrict: 'E',
			replace: true,
			link: linker,
			templateUrl: 'app/main/sites_management/blocs/bloc/event/input.html',
			scope: {
				watch: '&watch',
				field: '=field',
				content: '@',
				index: '@',
				model: '=ngModel',
				required: '=ngRequired',
				formName: '=',
				init: '&initFn',
				subType: '=subType',
				modelType: '=modelType'
			}
		};
	}).directive('fileInputChanged', function () {
		return {
			restrict: 'A',
			scope: {
				plan: '=plan',
				call: '&call'
			},
			link: function (scope, element) {
				element.on('change', function () {
					scope.call({
						plan: scope.plan
					});
					element.value = '';
				});
				element.on('$destroy', function () {
					element.off();
				});

			}
		};
	}).directive('codeMirror', function () {
		return {
		  link: function (scope, elm, attrs) {
			//console.log(scope._pageBloc.html)
			 var cm_opt = { lineNumbers:true, mode: "htmlmixed",theme:"3024-day"};
			 var editor = CodeMirror.fromTextArea(elm[0], cm_opt);
			 editor.setValue(scope._pageBloc.html);
			 editor.setMode("htmlmixed")
			 //editor.options.value = scope._pageBloc.html;
			 console.log(editor)
			 editor.on('change', function(e) {
					scope._pageBloc.html = editor.getValue();
			 });
		  }
		}
	 });

	angular.module('fuse').directive('nlResponsiveTable', function ($timeout) {
		return {
			scope: {
				nlTableData: '='
			},
			restrict: 'A',
			link: function (scope, element) {
				scope.$watch('nlTableData', function(){
					console.log('arrayData');
					$timeout(function() {
						element[0].classList.add('nl-Table-responsive');
						var labels = Array.from(element[0].querySelectorAll('th')).map(function (th) {
							if(th.querySelector('.nl-responsive-table--text') !== null) {
								return th.querySelector('.nl-responsive-table--text').innerText;
							} else {
								return th.innerText;
							}
						});
						element[0].querySelectorAll('td').forEach(function (td, i) {
							td.setAttribute('data-label', labels[i % labels.length]);
						});
					}, 1000);
				}, true);
			}
		}
	});

	angular.module("fuse").directive('permissions', ['userService', '$translate', function (userService, $translate) {
		return {
			restrict: 'A',
			scope: {
				permissions: '='
			},
			link: function (scope, elt, attrs) {
				userService.getCurrent($translate.preferredLanguage(), false).then(function (data) {
					if (userService.containsAtLeastOneRole(scope.permissions)) {
						elt.show();
					} else {
						elt.hide();
					}
				}).catch(function (res) {

				});
			}
		};
	}]);



})();

(function () {
	'use strict';

	angular
		.module('fuse')
		.controller('IndexController', IndexController);

	/** @ngInject */
	function IndexController($rootScope, $mdSidenav, $scope, $log, $location, $mdDialog, $q, $sce, $translate, $window, $state, fuseTheming, userService, modelService, msNavigationService, MessageService, STORAGE_PREFIX, $timeout, DISPLAY_MODELS_ICONS) {
		$scope.pollCalled = false;
		$scope.getCurrentUser = function (reset) {
			userService.getCurrent($translate.preferredLanguage(), reset).then(function (data) {
				$rootScope.user = data;
				if (!$scope.pollCalled) {
					$scope.loadNotifs([]);
				}
				$scope.pollCalled = true;
			}).catch(function (response) {

			});
		};

		$scope.toggleSidenavMain = function (sidenavId) {
			$mdSidenav(sidenavId).toggle();
		};

		var sidenavIsAnimated = false; // prevent double clicking on backdrop that re toggle the sideNav
		$scope.toggleSidenavRight = function () {
			$timeout(function () {
				if (!sidenavIsAnimated) {
					sidenavIsAnimated = true;
					var eltmp = document.getElementById("nl-js--FixedRightBar");
					if (eltmp.classList.contains('nl-js--FixedRightBar__active')) {
						eltmp.classList.remove('nl-js--FixedRightBar__active');
						setTimeout(function () {
							eltmp.style.display = 'none';
							sidenavIsAnimated = false;
						}, 300);
					} else {
						eltmp.style.display = 'block';
						setTimeout(function () {
							eltmp.classList.add('nl-js--FixedRightBar__active');
							sidenavIsAnimated = false;
						}, 0);
					}
				}
			}, 0);
		};

		$scope.iconsDisplay = {};
		angular.forEach(DISPLAY_MODELS_ICONS, function (elt) {
			$scope.iconsDisplay[elt.name] = elt.value;
		});
		$rootScope.css = '';

		$scope.trustAsHtml = function (string) {
			return $sce.trustAsHtml(string);
		};

		if ($location.path().lastIndexOf('/crm/') === -1) {
			$scope.getCurrentUser(false);
		}

		$rootScope.openConfirmPopup = function (content) {
			return $q(function (resolve, reject) {
				$mdDialog.show({
					templateUrl: 'app/main/popup/confirm.html',
					clickOutsideToClose: true,
					controller: 'confirmPopupController',
					locals: {
						content: content
					}
				}).then(function () {
					resolve();
				}).catch(function () {
					reject();
				});
			});
		};

		$rootScope.logout = function () {
			userService.logout().then(function () {
				//$state.go('login');
				$window.location.href = '/login';
			}).catch(function () {
				//$state.go('login');
				$window.location.href = '/login';
			});
		};

		$scope.$on('getCurrentUser', function () {
			$scope.getCurrentUser(true);
		});

		$scope.$on('getLateActions', function (event) {
			var sorting = 'asc';
			MessageService.findMessageNotDone(sorting, localStorage[STORAGE_PREFIX + 'language'], true).then(function (messages) {
				if (messages) {
					$scope.actionsNotDone = messages.data;
					console.log($scope.actionsNotDone);
					if ($scope.actionsNotDone.length > 0) {
						$mdDialog.show({
							templateUrl: 'app/main/home/popup/lateActions.html',
							preserveScope: true,
							clickOutsideToClose: true,
							scope: $scope
						}).then(function () {
							$scope.$emit('notifySenderActionsDone');
						}).catch(function () {

						});
					} else {
						$scope.$emit('notifySenderActionsDone');
					}
				} else {
					$scope.$emit('notifySenderActionsDone');
				}
			}).catch(function (err) {
				console.log(err);
			});
		});

		$scope.$on('notifySenderActionsDone', function (event) {
			MessageService.notifySenderActionsDone(localStorage[STORAGE_PREFIX + 'language']).then(function (messages) {
				if (messages) {
					$scope.senderActionsDone = messages.data;
					console.log($scope.senderActionsDone);
					if ($scope.senderActionsDone.length > 0) {
						$mdDialog.show({
							templateUrl: 'app/main/home/popup/senderActionsDone.html',
							preserveScope: true,
							clickOutsideToClose: true,
							scope: $scope
						}).then(function () {

						}).catch(function (err) {
							//console.log(err);
						});
					}
				}
			}).catch(function (err) {
				console.log(err);
			});
		});

		$scope.getDate = function (date) {
			if (date != null) {
				return moment(date).toDate();
			} else {
				return null;
			}
		};

		$scope.hidePopup = function () {
			$mdDialog.hide();
		};


		$scope.loadNotifs = function (listOlderMessages) {
			if ($rootScope.user) {

				var http = $window.location.protocol;
				var protocol = 'ws://';
				if (http === 'https:') {
					protocol = 'wss://';
				}
				var domain = $window.location.host;
				var ws = new WebSocket(protocol + domain + '/socket/websocket/'
					+ $rootScope.user.id + '/' + $translate.preferredLanguage());
				// var ws = new WebSocket('ws://localhost:8080/Summeet/websocket/'
				// 	+ $rootScope.user.id + '/' + $translate.preferredLanguage());
				ws.onopen = function (event) {
				};

				ws.onclose = function (event) {
				};

				ws.onerror = function (event) {
				};

				ws.onmessage = function (event) {
					$scope.actionsToDo = angular.fromJson(event.data);
					$mdDialog.show({
						templateUrl: 'app/main/home/popup/actionsToDo.html',
						preserveScope: true,
						clickOutsideToClose: true,
						scope: $scope
					}).then(function () { }).catch(function (err) {

					});
				}
			}
		};

		$scope.initBeautify = function (bloc,index) {

			$timeout(function () {
				if(index==null){
					index = bloc.id ? bloc.id : -1;
				}
				bloc.html = html_beautify(bloc.html);
				var element = document.getElementById('html'+index);
				var cm = CodeMirror.fromTextArea(element,{
					lineNumbers: true,
					mode: "htmlmixed",
					theme: "eclipse",
					smartIndent: true
				 })
				 cm.on("change",(instance,change)=>{
					//console.log(instance.getValue())
					bloc.html = instance.getValue();
				 })
				// CodeMirror(document.getElementsByTagName('textarea')[0],{
				// 	value:bloc.html,
				// 	mode:'htmlmixed'
				// })
			});

		};

		$scope.$on('onInitNotifs', function () {
			$scope.loadNotifs([]);
			$scope.pollCalled = true;
		});

		$scope.$on('rooScopeUser:ready', function () {
			var badge = null;
			if (userService.isUserHasNonReadMsg()) {
				badge = {
					content: '!',
					color: 'red'
				};
			} else {
				badge = null;
			}



			msNavigationService.saveItem('toolbox.message', {
				title: 'Message',
				state: 'app.message',
				translate: 'MESSAGE.TITLE',
				weight: 3,
				badge: badge,
				hidden: function () {
					return !userService.containsRole('MESSAGE');
				}
			});
		});

	}
})();

(function () {
  'use strict';

  angular
    .module('fuse')
    .constant({
      STATISTICS_NATIONALITIES: [{
          name: 'France',
          code: 'FR'
        },
        {
          name: 'Royaume-Uni',
          code: 'EN'
        }
      ],
      STORAGE_PREFIX: 'GlobeNetwork_',
      URL: {
        alternatedocroots: './alternatedocroots'
      },
      PUBLIC_PAGES: ['login', 'forgotPassword', 'activateAccount', 'updatePassword'],
      LOGS_ENTITY_CONCERNED: {
        COMPANY: 'ADMIN.USERSLOGS.ENTITIES.COMPANY',
        CONTACT: 'ADMIN.USERSLOGS.ENTITIES.CONTACT'
      },
      LOGS_ACTIONS: {
        UPDATE: 'ADMIN.USERSLOGS.ACTIONS.UPDATE',
        CREATE: 'ADMIN.USERSLOGS.ACTIONS.CREATE',
        DELETE: 'ADMIN.USERSLOGS.ACTIONS.DELETE',
        COPY: 'ADMIN.USERSLOGS.ACTIONS.COPY',
        ARCHIVE: 'ADMIN.USERSLOGS.ACTIONS.ARCHIVE',
        CHECK: 'ADMIN.USERSLOGS.ACTIONS.CHECK',
        UPDATE_TYPE: 'ADMIN.USERSLOGS.ACTIONS.UPDATE_TYPE',
        UPDATE_ASSOCIATION: 'ADMIN.USERSLOGS.ACTIONS.UPDATE_ASSOCIATION',
        UPDATE_FIELD: 'ADMIN.USERSLOGS.ACTIONS.UPDATE_FIELD',
        ADD_FIELD: 'ADMIN.USERSLOGS.ACTIONS.ADD_FIELD',
        DELETE_DISPOSITION: 'ADMIN.USERSLOGS.ACTIONS.DELETE_DISPOSITION',
        ADD_DISPOSITION: 'ADMIN.USERSLOGS.ACTIONS.ADD_DISPOSITION',
        UPDATE_DISPOSITION: 'ADMIN.USERSLOGS.ACTIONS.UPDATE_DISPOSITION',
        LOGIN: 'ADMIN.USERSLOGS.ACTIONS.LOGIN',
        LOGOUT: 'ADMIN.USERSLOGS.ACTIONS.LOGOUT'
      },
      DISPLAY_MODELS_ICONS: [
        { name: 'PHONE', value: 'icon-phone'},
        { name: 'CELLPHONE', value: 'icon-cellphone'},
        { name: 'MAIL', value: 'icon-email'},
        { name: 'WEB', value: 'icon-web'}
      ],
      MODELS_TYPES: {
        COMPANY_MODEL: 'COMPANY_MODEL',
        CONTACT_MODEL: 'CONTACT_MODEL',

      },
      TYPES_INSCRIPTION_FIELD: [
        'HEADER', 'FIELD', 'EXPLANATION'
      ],
      MODEL_TYPES: [
        'COMPANY_MODEL', 'CONTACT_MODEL', 'INSCRIPTION_MODEL', 'LOGISTIC_MODEL'
      ],
      MAILING_HISTORY_TYPES: [
        'COMPANY_VIEW', 'CONTACT_VIEW', 'INSCRIPTION_VIEW'
      ]

    });


})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    function config($translateProvider, $translatePartialLoaderProvider, ngQuillConfigProvider, STORAGE_PREFIX, $mdDateLocaleProvider, $provide)
    {
        // Put your common app configurations here

        // angular-translate configuration

        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json',
            loadFailureHandler: 'ErrorTranslationHandler'
		  });
		  localStorage[STORAGE_PREFIX + 'language'] = 'fr';

        if (localStorage[STORAGE_PREFIX + 'language'] == null){
            $translateProvider.preferredLanguage('fr');
            $translateProvider.use('fr');
        }else{
            $translateProvider.preferredLanguage(localStorage[STORAGE_PREFIX + 'language']);
            $translateProvider.use(localStorage[STORAGE_PREFIX + 'language']);
        }
        $translateProvider.fallbackLanguage('fr');
        $translateProvider.useSanitizeValueStrategy('sanitize');
        $translateProvider.useSanitizeValueStrategy('sanitizeParameters');

        $translatePartialLoaderProvider.addPart('app/main/home');


        var FontAttributor = Quill.import('attributors/class/font');
        FontAttributor.whitelist = [
        'roboto'
        ];
        Quill.register(FontAttributor, true);
        ngQuillConfigProvider.set({
            bounds: 'self',
            placeholder: '',
            modules: {
                toolbar: [
                    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                    ['blockquote', 'code-block'],

                    [{ 'header': 1 }, { 'header': 2 }],               // custom button values
                    [{ 'list': 'ordered' }, { 'list': 'bullet' }],
                    [{ 'script': 'sub' }, { 'script': 'super' }],      // superscript/subscript
                    [{ 'indent': '-1' }, { 'indent': '+1' }],          // outdent/indent
                    [{ 'direction': 'rtl' }],                         // text direction

                    [{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
                    [{ 'header': [1, 2, 3, 4, 5, 6, false] }],

                    [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                    [{ 'align': [] }],

                    ['clean'],                                         // remove formatting button

						  ['link', 'image','video'],                         // link and image, video

						  ['showHtml']
                  ]
            }
		  });

			// Example of a French localization.
			$mdDateLocaleProvider.months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre','décembre'];
			$mdDateLocaleProvider.shortMonths = ['jan', 'fév', 'mar', 'avr', 'mai', 'juin', 'juil', 'août','sep','oct','nov','déc'];
			$mdDateLocaleProvider.days = ['dimanche', 'lundi', 'mardi', 'mercredi','jeudi','vendredi','samedi'];
			$mdDateLocaleProvider.shortDays = ['Di', 'Lu', 'Ma', 'Me','Je','Ve','Sa'];

			// Can change week display to start on Monday.
			$mdDateLocaleProvider.firstDayOfWeek = 1;

        $mdDateLocaleProvider.formatDate = function(date) {
            return date ? moment(date).format('DD/MM/YYYY') : "";
        };

        $mdDateLocaleProvider.parseDate = function(dateString) {
            var m = moment(dateString, 'DD/MM/YYYY', true);
            return m.isValid() ? m.toDate() : new Date(NaN);
        };

        $provide.decorator('$state', ['$delegate', '$window', function ($delegate, $window) {
            var extended = {
                goNewTab: function (stateName, params) {
                    $window.open($delegate.href(stateName, params, { absolute: true }), '_blank');
                }
            };
            angular.extend($delegate, extended);
            return $delegate;
        }]);

    }

})();

(function () {
	'use strict';

	angular
		.module('fuse')
		.factory('ErrorTranslationHandler', ErrorTranslationHandler);

	/** @ngInject */
	function ErrorTranslationHandler($q) {
		return function (part, lang, response) {
            console.log('The "' + part + '/' + lang + '" part was not loaded.');
            console.log(response);
			return $q.when({});
		};
	}

})();

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
	if (typeof exports == "object" && typeof module == "object") // CommonJS
	  mod(require("../../lib/codemirror"), require("../xml/xml"), require("../javascript/javascript"), require("../css/css"));
	else if (typeof define == "function" && define.amd) // AMD
	  define(["../../lib/codemirror", "../xml/xml", "../javascript/javascript", "../css/css"], mod);
	else // Plain browser env
	  mod(CodeMirror);
 })(function(CodeMirror) {
	"use strict";

	var defaultTags = {
	  script: [
		 ["lang", /(javascript|babel)/i, "javascript"],
		 ["type", /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i, "javascript"],
		 ["type", /./, "text/plain"],
		 [null, null, "javascript"]
	  ],
	  style:  [
		 ["lang", /^css$/i, "css"],
		 ["type", /^(text\/)?(x-)?(stylesheet|css)$/i, "css"],
		 ["type", /./, "text/plain"],
		 [null, null, "css"]
	  ]
	};

	function maybeBackup(stream, pat, style) {
	  var cur = stream.current(), close = cur.search(pat);
	  if (close > -1) {
		 stream.backUp(cur.length - close);
	  } else if (cur.match(/<\/?$/)) {
		 stream.backUp(cur.length);
		 if (!stream.match(pat, false)) stream.match(cur);
	  }
	  return style;
	}

	var attrRegexpCache = {};
	function getAttrRegexp(attr) {
	  var regexp = attrRegexpCache[attr];
	  if (regexp) return regexp;
	  return attrRegexpCache[attr] = new RegExp("\\s+" + attr + "\\s*=\\s*('|\")?([^'\"]+)('|\")?\\s*");
	}

	function getAttrValue(text, attr) {
	  var match = text.match(getAttrRegexp(attr))
	  return match ? /^\s*(.*?)\s*$/.exec(match[2])[1] : ""
	}

	function getTagRegexp(tagName, anchored) {
	  return new RegExp((anchored ? "^" : "") + "<\/\s*" + tagName + "\s*>", "i");
	}

	function addTags(from, to) {
	  for (var tag in from) {
		 var dest = to[tag] || (to[tag] = []);
		 var source = from[tag];
		 for (var i = source.length - 1; i >= 0; i--)
			dest.unshift(source[i])
	  }
	}

	function findMatchingMode(tagInfo, tagText) {
	  for (var i = 0; i < tagInfo.length; i++) {
		 var spec = tagInfo[i];
		 if (!spec[0] || spec[1].test(getAttrValue(tagText, spec[0]))) return spec[2];
	  }
	}

	CodeMirror.defineMode("htmlmixed", function (config, parserConfig) {
	  var htmlMode = CodeMirror.getMode(config, {
		 name: "xml",
		 htmlMode: true,
		 multilineTagIndentFactor: parserConfig.multilineTagIndentFactor,
		 multilineTagIndentPastTag: parserConfig.multilineTagIndentPastTag
	  });

	  var tags = {};
	  var configTags = parserConfig && parserConfig.tags, configScript = parserConfig && parserConfig.scriptTypes;
	  addTags(defaultTags, tags);
	  if (configTags) addTags(configTags, tags);
	  if (configScript) for (var i = configScript.length - 1; i >= 0; i--)
		 tags.script.unshift(["type", configScript[i].matches, configScript[i].mode])

	  function html(stream, state) {
		 var style = htmlMode.token(stream, state.htmlState), tag = /\btag\b/.test(style), tagName
		 if (tag && !/[<>\s\/]/.test(stream.current()) &&
			  (tagName = state.htmlState.tagName && state.htmlState.tagName.toLowerCase()) &&
			  tags.hasOwnProperty(tagName)) {
			state.inTag = tagName + " "
		 } else if (state.inTag && tag && />$/.test(stream.current())) {
			var inTag = /^([\S]+) (.*)/.exec(state.inTag)
			state.inTag = null
			var modeSpec = stream.current() == ">" && findMatchingMode(tags[inTag[1]], inTag[2])
			var mode = CodeMirror.getMode(config, modeSpec)
			var endTagA = getTagRegexp(inTag[1], true), endTag = getTagRegexp(inTag[1], false);
			state.token = function (stream, state) {
			  if (stream.match(endTagA, false)) {
				 state.token = html;
				 state.localState = state.localMode = null;
				 return null;
			  }
			  return maybeBackup(stream, endTag, state.localMode.token(stream, state.localState));
			};
			state.localMode = mode;
			state.localState = CodeMirror.startState(mode, htmlMode.indent(state.htmlState, "", ""));
		 } else if (state.inTag) {
			state.inTag += stream.current()
			if (stream.eol()) state.inTag += " "
		 }
		 return style;
	  };

	  return {
		 startState: function () {
			var state = CodeMirror.startState(htmlMode);
			return {token: html, inTag: null, localMode: null, localState: null, htmlState: state};
		 },

		 copyState: function (state) {
			var local;
			if (state.localState) {
			  local = CodeMirror.copyState(state.localMode, state.localState);
			}
			return {token: state.token, inTag: state.inTag,
					  localMode: state.localMode, localState: local,
					  htmlState: CodeMirror.copyState(htmlMode, state.htmlState)};
		 },

		 token: function (stream, state) {
			return state.token(stream, state);
		 },

		 indent: function (state, textAfter, line) {
			if (!state.localMode || /^\s*<\//.test(textAfter))
			  return htmlMode.indent(state.htmlState, textAfter, line);
			else if (state.localMode.indent)
			  return state.localMode.indent(state.localState, textAfter, line);
			else
			  return CodeMirror.Pass;
		 },

		 innerMode: function (state) {
			return {state: state.localState || state.htmlState, mode: state.localMode || htmlMode};
		 }
	  };
	}, "xml", "javascript", "css");

	CodeMirror.defineMIME("text/html", "htmlmixed");
 });

// CodeMirror, copyright (c) by Marijn Haverbeke and others
// Distributed under an MIT license: https://codemirror.net/LICENSE

(function(mod) {
	if (typeof exports == "object" && typeof module == "object") // CommonJS
	  mod(require("../../lib/codemirror"));
	else if (typeof define == "function" && define.amd) // AMD
	  define(["../../lib/codemirror"], mod);
	else // Plain browser env
	  mod(CodeMirror);
 })(function(CodeMirror) {
 "use strict";

 CodeMirror.defineMode("css", function(config, parserConfig) {
	var inline = parserConfig.inline
	if (!parserConfig.propertyKeywords) parserConfig = CodeMirror.resolveMode("text/css");

	var indentUnit = config.indentUnit,
		 tokenHooks = parserConfig.tokenHooks,
		 documentTypes = parserConfig.documentTypes || {},
		 mediaTypes = parserConfig.mediaTypes || {},
		 mediaFeatures = parserConfig.mediaFeatures || {},
		 mediaValueKeywords = parserConfig.mediaValueKeywords || {},
		 propertyKeywords = parserConfig.propertyKeywords || {},
		 nonStandardPropertyKeywords = parserConfig.nonStandardPropertyKeywords || {},
		 fontProperties = parserConfig.fontProperties || {},
		 counterDescriptors = parserConfig.counterDescriptors || {},
		 colorKeywords = parserConfig.colorKeywords || {},
		 valueKeywords = parserConfig.valueKeywords || {},
		 allowNested = parserConfig.allowNested,
		 lineComment = parserConfig.lineComment,
		 supportsAtComponent = parserConfig.supportsAtComponent === true;

	var type, override;
	function ret(style, tp) { type = tp; return style; }

	// Tokenizers

	function tokenBase(stream, state) {
	  var ch = stream.next();
	  if (tokenHooks[ch]) {
		 var result = tokenHooks[ch](stream, state);
		 if (result !== false) return result;
	  }
	  if (ch == "@") {
		 stream.eatWhile(/[\w\\\-]/);
		 return ret("def", stream.current());
	  } else if (ch == "=" || (ch == "~" || ch == "|") && stream.eat("=")) {
		 return ret(null, "compare");
	  } else if (ch == "\"" || ch == "'") {
		 state.tokenize = tokenString(ch);
		 return state.tokenize(stream, state);
	  } else if (ch == "#") {
		 stream.eatWhile(/[\w\\\-]/);
		 return ret("atom", "hash");
	  } else if (ch == "!") {
		 stream.match(/^\s*\w*/);
		 return ret("keyword", "important");
	  } else if (/\d/.test(ch) || ch == "." && stream.eat(/\d/)) {
		 stream.eatWhile(/[\w.%]/);
		 return ret("number", "unit");
	  } else if (ch === "-") {
		 if (/[\d.]/.test(stream.peek())) {
			stream.eatWhile(/[\w.%]/);
			return ret("number", "unit");
		 } else if (stream.match(/^-[\w\\\-]*/)) {
			stream.eatWhile(/[\w\\\-]/);
			if (stream.match(/^\s*:/, false))
			  return ret("variable-2", "variable-definition");
			return ret("variable-2", "variable");
		 } else if (stream.match(/^\w+-/)) {
			return ret("meta", "meta");
		 }
	  } else if (/[,+>*\/]/.test(ch)) {
		 return ret(null, "select-op");
	  } else if (ch == "." && stream.match(/^-?[_a-z][_a-z0-9-]*/i)) {
		 return ret("qualifier", "qualifier");
	  } else if (/[:;{}\[\]\(\)]/.test(ch)) {
		 return ret(null, ch);
	  } else if (stream.match(/[\w-.]+(?=\()/)) {
		 if (/^(url(-prefix)?|domain|regexp)$/.test(stream.current().toLowerCase())) {
			state.tokenize = tokenParenthesized;
		 }
		 return ret("variable callee", "variable");
	  } else if (/[\w\\\-]/.test(ch)) {
		 stream.eatWhile(/[\w\\\-]/);
		 return ret("property", "word");
	  } else {
		 return ret(null, null);
	  }
	}

	function tokenString(quote) {
	  return function(stream, state) {
		 var escaped = false, ch;
		 while ((ch = stream.next()) != null) {
			if (ch == quote && !escaped) {
			  if (quote == ")") stream.backUp(1);
			  break;
			}
			escaped = !escaped && ch == "\\";
		 }
		 if (ch == quote || !escaped && quote != ")") state.tokenize = null;
		 return ret("string", "string");
	  };
	}

	function tokenParenthesized(stream, state) {
	  stream.next(); // Must be '('
	  if (!stream.match(/\s*[\"\')]/, false))
		 state.tokenize = tokenString(")");
	  else
		 state.tokenize = null;
	  return ret(null, "(");
	}

	// Context management

	function Context(type, indent, prev) {
	  this.type = type;
	  this.indent = indent;
	  this.prev = prev;
	}

	function pushContext(state, stream, type, indent) {
	  state.context = new Context(type, stream.indentation() + (indent === false ? 0 : indentUnit), state.context);
	  return type;
	}

	function popContext(state) {
	  if (state.context.prev)
		 state.context = state.context.prev;
	  return state.context.type;
	}

	function pass(type, stream, state) {
	  return states[state.context.type](type, stream, state);
	}
	function popAndPass(type, stream, state, n) {
	  for (var i = n || 1; i > 0; i--)
		 state.context = state.context.prev;
	  return pass(type, stream, state);
	}

	// Parser

	function wordAsValue(stream) {
	  var word = stream.current().toLowerCase();
	  if (valueKeywords.hasOwnProperty(word))
		 override = "atom";
	  else if (colorKeywords.hasOwnProperty(word))
		 override = "keyword";
	  else
		 override = "variable";
	}

	var states = {};

	states.top = function(type, stream, state) {
	  if (type == "{") {
		 return pushContext(state, stream, "block");
	  } else if (type == "}" && state.context.prev) {
		 return popContext(state);
	  } else if (supportsAtComponent && /@component/i.test(type)) {
		 return pushContext(state, stream, "atComponentBlock");
	  } else if (/^@(-moz-)?document$/i.test(type)) {
		 return pushContext(state, stream, "documentTypes");
	  } else if (/^@(media|supports|(-moz-)?document|import)$/i.test(type)) {
		 return pushContext(state, stream, "atBlock");
	  } else if (/^@(font-face|counter-style)/i.test(type)) {
		 state.stateArg = type;
		 return "restricted_atBlock_before";
	  } else if (/^@(-(moz|ms|o|webkit)-)?keyframes$/i.test(type)) {
		 return "keyframes";
	  } else if (type && type.charAt(0) == "@") {
		 return pushContext(state, stream, "at");
	  } else if (type == "hash") {
		 override = "builtin";
	  } else if (type == "word") {
		 override = "tag";
	  } else if (type == "variable-definition") {
		 return "maybeprop";
	  } else if (type == "interpolation") {
		 return pushContext(state, stream, "interpolation");
	  } else if (type == ":") {
		 return "pseudo";
	  } else if (allowNested && type == "(") {
		 return pushContext(state, stream, "parens");
	  }
	  return state.context.type;
	};

	states.block = function(type, stream, state) {
	  if (type == "word") {
		 var word = stream.current().toLowerCase();
		 if (propertyKeywords.hasOwnProperty(word)) {
			override = "property";
			return "maybeprop";
		 } else if (nonStandardPropertyKeywords.hasOwnProperty(word)) {
			override = "string-2";
			return "maybeprop";
		 } else if (allowNested) {
			override = stream.match(/^\s*:(?:\s|$)/, false) ? "property" : "tag";
			return "block";
		 } else {
			override += " error";
			return "maybeprop";
		 }
	  } else if (type == "meta") {
		 return "block";
	  } else if (!allowNested && (type == "hash" || type == "qualifier")) {
		 override = "error";
		 return "block";
	  } else {
		 return states.top(type, stream, state);
	  }
	};

	states.maybeprop = function(type, stream, state) {
	  if (type == ":") return pushContext(state, stream, "prop");
	  return pass(type, stream, state);
	};

	states.prop = function(type, stream, state) {
	  if (type == ";") return popContext(state);
	  if (type == "{" && allowNested) return pushContext(state, stream, "propBlock");
	  if (type == "}" || type == "{") return popAndPass(type, stream, state);
	  if (type == "(") return pushContext(state, stream, "parens");

	  if (type == "hash" && !/^#([0-9a-fA-f]{3,4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/.test(stream.current())) {
		 override += " error";
	  } else if (type == "word") {
		 wordAsValue(stream);
	  } else if (type == "interpolation") {
		 return pushContext(state, stream, "interpolation");
	  }
	  return "prop";
	};

	states.propBlock = function(type, _stream, state) {
	  if (type == "}") return popContext(state);
	  if (type == "word") { override = "property"; return "maybeprop"; }
	  return state.context.type;
	};

	states.parens = function(type, stream, state) {
	  if (type == "{" || type == "}") return popAndPass(type, stream, state);
	  if (type == ")") return popContext(state);
	  if (type == "(") return pushContext(state, stream, "parens");
	  if (type == "interpolation") return pushContext(state, stream, "interpolation");
	  if (type == "word") wordAsValue(stream);
	  return "parens";
	};

	states.pseudo = function(type, stream, state) {
	  if (type == "meta") return "pseudo";

	  if (type == "word") {
		 override = "variable-3";
		 return state.context.type;
	  }
	  return pass(type, stream, state);
	};

	states.documentTypes = function(type, stream, state) {
	  if (type == "word" && documentTypes.hasOwnProperty(stream.current())) {
		 override = "tag";
		 return state.context.type;
	  } else {
		 return states.atBlock(type, stream, state);
	  }
	};

	states.atBlock = function(type, stream, state) {
	  if (type == "(") return pushContext(state, stream, "atBlock_parens");
	  if (type == "}" || type == ";") return popAndPass(type, stream, state);
	  if (type == "{") return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top");

	  if (type == "interpolation") return pushContext(state, stream, "interpolation");

	  if (type == "word") {
		 var word = stream.current().toLowerCase();
		 if (word == "only" || word == "not" || word == "and" || word == "or")
			override = "keyword";
		 else if (mediaTypes.hasOwnProperty(word))
			override = "attribute";
		 else if (mediaFeatures.hasOwnProperty(word))
			override = "property";
		 else if (mediaValueKeywords.hasOwnProperty(word))
			override = "keyword";
		 else if (propertyKeywords.hasOwnProperty(word))
			override = "property";
		 else if (nonStandardPropertyKeywords.hasOwnProperty(word))
			override = "string-2";
		 else if (valueKeywords.hasOwnProperty(word))
			override = "atom";
		 else if (colorKeywords.hasOwnProperty(word))
			override = "keyword";
		 else
			override = "error";
	  }
	  return state.context.type;
	};

	states.atComponentBlock = function(type, stream, state) {
	  if (type == "}")
		 return popAndPass(type, stream, state);
	  if (type == "{")
		 return popContext(state) && pushContext(state, stream, allowNested ? "block" : "top", false);
	  if (type == "word")
		 override = "error";
	  return state.context.type;
	};

	states.atBlock_parens = function(type, stream, state) {
	  if (type == ")") return popContext(state);
	  if (type == "{" || type == "}") return popAndPass(type, stream, state, 2);
	  return states.atBlock(type, stream, state);
	};

	states.restricted_atBlock_before = function(type, stream, state) {
	  if (type == "{")
		 return pushContext(state, stream, "restricted_atBlock");
	  if (type == "word" && state.stateArg == "@counter-style") {
		 override = "variable";
		 return "restricted_atBlock_before";
	  }
	  return pass(type, stream, state);
	};

	states.restricted_atBlock = function(type, stream, state) {
	  if (type == "}") {
		 state.stateArg = null;
		 return popContext(state);
	  }
	  if (type == "word") {
		 if ((state.stateArg == "@font-face" && !fontProperties.hasOwnProperty(stream.current().toLowerCase())) ||
			  (state.stateArg == "@counter-style" && !counterDescriptors.hasOwnProperty(stream.current().toLowerCase())))
			override = "error";
		 else
			override = "property";
		 return "maybeprop";
	  }
	  return "restricted_atBlock";
	};

	states.keyframes = function(type, stream, state) {
	  if (type == "word") { override = "variable"; return "keyframes"; }
	  if (type == "{") return pushContext(state, stream, "top");
	  return pass(type, stream, state);
	};

	states.at = function(type, stream, state) {
	  if (type == ";") return popContext(state);
	  if (type == "{" || type == "}") return popAndPass(type, stream, state);
	  if (type == "word") override = "tag";
	  else if (type == "hash") override = "builtin";
	  return "at";
	};

	states.interpolation = function(type, stream, state) {
	  if (type == "}") return popContext(state);
	  if (type == "{" || type == ";") return popAndPass(type, stream, state);
	  if (type == "word") override = "variable";
	  else if (type != "variable" && type != "(" && type != ")") override = "error";
	  return "interpolation";
	};

	return {
	  startState: function(base) {
		 return {tokenize: null,
					state: inline ? "block" : "top",
					stateArg: null,
					context: new Context(inline ? "block" : "top", base || 0, null)};
	  },

	  token: function(stream, state) {
		 if (!state.tokenize && stream.eatSpace()) return null;
		 var style = (state.tokenize || tokenBase)(stream, state);
		 if (style && typeof style == "object") {
			type = style[1];
			style = style[0];
		 }
		 override = style;
		 if (type != "comment")
			state.state = states[state.state](type, stream, state);
		 return override;
	  },

	  indent: function(state, textAfter) {
		 var cx = state.context, ch = textAfter && textAfter.charAt(0);
		 var indent = cx.indent;
		 if (cx.type == "prop" && (ch == "}" || ch == ")")) cx = cx.prev;
		 if (cx.prev) {
			if (ch == "}" && (cx.type == "block" || cx.type == "top" ||
									cx.type == "interpolation" || cx.type == "restricted_atBlock")) {
			  // Resume indentation from parent context.
			  cx = cx.prev;
			  indent = cx.indent;
			} else if (ch == ")" && (cx.type == "parens" || cx.type == "atBlock_parens") ||
				 ch == "{" && (cx.type == "at" || cx.type == "atBlock")) {
			  // Dedent relative to current context.
			  indent = Math.max(0, cx.indent - indentUnit);
			}
		 }
		 return indent;
	  },

	  electricChars: "}",
	  blockCommentStart: "/*",
	  blockCommentEnd: "*/",
	  blockCommentContinue: " * ",
	  lineComment: lineComment,
	  fold: "brace"
	};
 });

	function keySet(array) {
	  var keys = {};
	  for (var i = 0; i < array.length; ++i) {
		 keys[array[i].toLowerCase()] = true;
	  }
	  return keys;
	}

	var documentTypes_ = [
	  "domain", "regexp", "url", "url-prefix"
	], documentTypes = keySet(documentTypes_);

	var mediaTypes_ = [
	  "all", "aural", "braille", "handheld", "print", "projection", "screen",
	  "tty", "tv", "embossed"
	], mediaTypes = keySet(mediaTypes_);

	var mediaFeatures_ = [
	  "width", "min-width", "max-width", "height", "min-height", "max-height",
	  "device-width", "min-device-width", "max-device-width", "device-height",
	  "min-device-height", "max-device-height", "aspect-ratio",
	  "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio",
	  "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color",
	  "max-color", "color-index", "min-color-index", "max-color-index",
	  "monochrome", "min-monochrome", "max-monochrome", "resolution",
	  "min-resolution", "max-resolution", "scan", "grid", "orientation",
	  "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio",
	  "pointer", "any-pointer", "hover", "any-hover"
	], mediaFeatures = keySet(mediaFeatures_);

	var mediaValueKeywords_ = [
	  "landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover",
	  "interlace", "progressive"
	], mediaValueKeywords = keySet(mediaValueKeywords_);

	var propertyKeywords_ = [
	  "align-content", "align-items", "align-self", "alignment-adjust",
	  "alignment-baseline", "anchor-point", "animation", "animation-delay",
	  "animation-direction", "animation-duration", "animation-fill-mode",
	  "animation-iteration-count", "animation-name", "animation-play-state",
	  "animation-timing-function", "appearance", "azimuth", "backface-visibility",
	  "background", "background-attachment", "background-blend-mode", "background-clip",
	  "background-color", "background-image", "background-origin", "background-position",
	  "background-repeat", "background-size", "baseline-shift", "binding",
	  "bleed", "bookmark-label", "bookmark-level", "bookmark-state",
	  "bookmark-target", "border", "border-bottom", "border-bottom-color",
	  "border-bottom-left-radius", "border-bottom-right-radius",
	  "border-bottom-style", "border-bottom-width", "border-collapse",
	  "border-color", "border-image", "border-image-outset",
	  "border-image-repeat", "border-image-slice", "border-image-source",
	  "border-image-width", "border-left", "border-left-color",
	  "border-left-style", "border-left-width", "border-radius", "border-right",
	  "border-right-color", "border-right-style", "border-right-width",
	  "border-spacing", "border-style", "border-top", "border-top-color",
	  "border-top-left-radius", "border-top-right-radius", "border-top-style",
	  "border-top-width", "border-width", "bottom", "box-decoration-break",
	  "box-shadow", "box-sizing", "break-after", "break-before", "break-inside",
	  "caption-side", "caret-color", "clear", "clip", "color", "color-profile", "column-count",
	  "column-fill", "column-gap", "column-rule", "column-rule-color",
	  "column-rule-style", "column-rule-width", "column-span", "column-width",
	  "columns", "content", "counter-increment", "counter-reset", "crop", "cue",
	  "cue-after", "cue-before", "cursor", "direction", "display",
	  "dominant-baseline", "drop-initial-after-adjust",
	  "drop-initial-after-align", "drop-initial-before-adjust",
	  "drop-initial-before-align", "drop-initial-size", "drop-initial-value",
	  "elevation", "empty-cells", "fit", "fit-position", "flex", "flex-basis",
	  "flex-direction", "flex-flow", "flex-grow", "flex-shrink", "flex-wrap",
	  "float", "float-offset", "flow-from", "flow-into", "font", "font-feature-settings",
	  "font-family", "font-kerning", "font-language-override", "font-size", "font-size-adjust",
	  "font-stretch", "font-style", "font-synthesis", "font-variant",
	  "font-variant-alternates", "font-variant-caps", "font-variant-east-asian",
	  "font-variant-ligatures", "font-variant-numeric", "font-variant-position",
	  "font-weight", "grid", "grid-area", "grid-auto-columns", "grid-auto-flow",
	  "grid-auto-rows", "grid-column", "grid-column-end", "grid-column-gap",
	  "grid-column-start", "grid-gap", "grid-row", "grid-row-end", "grid-row-gap",
	  "grid-row-start", "grid-template", "grid-template-areas", "grid-template-columns",
	  "grid-template-rows", "hanging-punctuation", "height", "hyphens",
	  "icon", "image-orientation", "image-rendering", "image-resolution",
	  "inline-box-align", "justify-content", "justify-items", "justify-self", "left", "letter-spacing",
	  "line-break", "line-height", "line-stacking", "line-stacking-ruby",
	  "line-stacking-shift", "line-stacking-strategy", "list-style",
	  "list-style-image", "list-style-position", "list-style-type", "margin",
	  "margin-bottom", "margin-left", "margin-right", "margin-top",
	  "marks", "marquee-direction", "marquee-loop",
	  "marquee-play-count", "marquee-speed", "marquee-style", "max-height",
	  "max-width", "min-height", "min-width", "mix-blend-mode", "move-to", "nav-down", "nav-index",
	  "nav-left", "nav-right", "nav-up", "object-fit", "object-position",
	  "opacity", "order", "orphans", "outline",
	  "outline-color", "outline-offset", "outline-style", "outline-width",
	  "overflow", "overflow-style", "overflow-wrap", "overflow-x", "overflow-y",
	  "padding", "padding-bottom", "padding-left", "padding-right", "padding-top",
	  "page", "page-break-after", "page-break-before", "page-break-inside",
	  "page-policy", "pause", "pause-after", "pause-before", "perspective",
	  "perspective-origin", "pitch", "pitch-range", "place-content", "place-items", "place-self", "play-during", "position",
	  "presentation-level", "punctuation-trim", "quotes", "region-break-after",
	  "region-break-before", "region-break-inside", "region-fragment",
	  "rendering-intent", "resize", "rest", "rest-after", "rest-before", "richness",
	  "right", "rotation", "rotation-point", "ruby-align", "ruby-overhang",
	  "ruby-position", "ruby-span", "shape-image-threshold", "shape-inside", "shape-margin",
	  "shape-outside", "size", "speak", "speak-as", "speak-header",
	  "speak-numeral", "speak-punctuation", "speech-rate", "stress", "string-set",
	  "tab-size", "table-layout", "target", "target-name", "target-new",
	  "target-position", "text-align", "text-align-last", "text-decoration",
	  "text-decoration-color", "text-decoration-line", "text-decoration-skip",
	  "text-decoration-style", "text-emphasis", "text-emphasis-color",
	  "text-emphasis-position", "text-emphasis-style", "text-height",
	  "text-indent", "text-justify", "text-outline", "text-overflow", "text-shadow",
	  "text-size-adjust", "text-space-collapse", "text-transform", "text-underline-position",
	  "text-wrap", "top", "transform", "transform-origin", "transform-style",
	  "transition", "transition-delay", "transition-duration",
	  "transition-property", "transition-timing-function", "unicode-bidi",
	  "user-select", "vertical-align", "visibility", "voice-balance", "voice-duration",
	  "voice-family", "voice-pitch", "voice-range", "voice-rate", "voice-stress",
	  "voice-volume", "volume", "white-space", "widows", "width", "will-change", "word-break",
	  "word-spacing", "word-wrap", "z-index",
	  // SVG-specific
	  "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color",
	  "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events",
	  "color-interpolation", "color-interpolation-filters",
	  "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering",
	  "marker", "marker-end", "marker-mid", "marker-start", "shape-rendering", "stroke",
	  "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin",
	  "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering",
	  "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal",
	  "glyph-orientation-vertical", "text-anchor", "writing-mode"
	], propertyKeywords = keySet(propertyKeywords_);

	var nonStandardPropertyKeywords_ = [
	  "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color",
	  "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color",
	  "scrollbar-3d-light-color", "scrollbar-track-color", "shape-inside",
	  "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button",
	  "searchfield-results-decoration", "zoom"
	], nonStandardPropertyKeywords = keySet(nonStandardPropertyKeywords_);

	var fontProperties_ = [
	  "font-family", "src", "unicode-range", "font-variant", "font-feature-settings",
	  "font-stretch", "font-weight", "font-style"
	], fontProperties = keySet(fontProperties_);

	var counterDescriptors_ = [
	  "additive-symbols", "fallback", "negative", "pad", "prefix", "range",
	  "speak-as", "suffix", "symbols", "system"
	], counterDescriptors = keySet(counterDescriptors_);

	var colorKeywords_ = [
	  "aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige",
	  "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown",
	  "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue",
	  "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod",
	  "darkgray", "darkgreen", "darkkhaki", "darkmagenta", "darkolivegreen",
	  "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen",
	  "darkslateblue", "darkslategray", "darkturquoise", "darkviolet",
	  "deeppink", "deepskyblue", "dimgray", "dodgerblue", "firebrick",
	  "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite",
	  "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew",
	  "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender",
	  "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral",
	  "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightpink",
	  "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray",
	  "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta",
	  "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple",
	  "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise",
	  "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin",
	  "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered",
	  "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred",
	  "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue",
	  "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown",
	  "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue",
	  "slateblue", "slategray", "snow", "springgreen", "steelblue", "tan",
	  "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white",
	  "whitesmoke", "yellow", "yellowgreen"
	], colorKeywords = keySet(colorKeywords_);

	var valueKeywords_ = [
	  "above", "absolute", "activeborder", "additive", "activecaption", "afar",
	  "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate",
	  "always", "amharic", "amharic-abegede", "antialiased", "appworkspace",
	  "arabic-indic", "armenian", "asterisks", "attr", "auto", "auto-flow", "avoid", "avoid-column", "avoid-page",
	  "avoid-region", "background", "backwards", "baseline", "below", "bidi-override", "binary",
	  "bengali", "blink", "block", "block-axis", "bold", "bolder", "border", "border-box",
	  "both", "bottom", "break", "break-all", "break-word", "bullets", "button", "button-bevel",
	  "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian",
	  "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret",
	  "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch",
	  "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote",
	  "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse",
	  "compact", "condensed", "contain", "content", "contents",
	  "content-box", "context-menu", "continuous", "copy", "counter", "counters", "cover", "crop",
	  "cross", "crosshair", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal",
	  "decimal-leading-zero", "default", "default-button", "dense", "destination-atop",
	  "destination-in", "destination-out", "destination-over", "devanagari", "difference",
	  "disc", "discard", "disclosure-closed", "disclosure-open", "document",
	  "dot-dash", "dot-dot-dash",
	  "dotted", "double", "down", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out",
	  "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede",
	  "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er",
	  "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er",
	  "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et",
	  "ethiopic-halehame-gez", "ethiopic-halehame-om-et",
	  "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et",
	  "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig",
	  "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed",
	  "extra-expanded", "fantasy", "fast", "fill", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes",
	  "forwards", "from", "geometricPrecision", "georgian", "graytext", "grid", "groove",
	  "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew",
	  "help", "hidden", "hide", "higher", "highlight", "highlighttext",
	  "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "icon", "ignore",
	  "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite",
	  "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis",
	  "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert",
	  "italic", "japanese-formal", "japanese-informal", "justify", "kannada",
	  "katakana", "katakana-iroha", "keep-all", "khmer",
	  "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal",
	  "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten",
	  "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem",
	  "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian",
	  "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian",
	  "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "match", "matrix", "matrix3d",
	  "media-controls-background", "media-current-time-display",
	  "media-fullscreen-button", "media-mute-button", "media-play-button",
	  "media-return-to-realtime-button", "media-rewind-button",
	  "media-seek-back-button", "media-seek-forward-button", "media-slider",
	  "media-sliderthumb", "media-time-remaining-display", "media-volume-slider",
	  "media-volume-slider-container", "media-volume-sliderthumb", "medium",
	  "menu", "menulist", "menulist-button", "menulist-text",
	  "menulist-textfield", "menutext", "message-box", "middle", "min-intrinsic",
	  "mix", "mongolian", "monospace", "move", "multiple", "multiply", "myanmar", "n-resize",
	  "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop",
	  "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap",
	  "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "opacity", "open-quote",
	  "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset",
	  "outside", "outside-shape", "overlay", "overline", "padding", "padding-box",
	  "painted", "page", "paused", "persian", "perspective", "plus-darker", "plus-lighter",
	  "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d",
	  "progress", "push-button", "radial-gradient", "radio", "read-only",
	  "read-write", "read-write-plaintext-only", "rectangle", "region",
	  "relative", "repeat", "repeating-linear-gradient",
	  "repeating-radial-gradient", "repeat-x", "repeat-y", "reset", "reverse",
	  "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY",
	  "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running",
	  "s-resize", "sans-serif", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen",
	  "scroll", "scrollbar", "scroll-position", "se-resize", "searchfield",
	  "searchfield-cancel-button", "searchfield-decoration",
	  "searchfield-results-button", "searchfield-results-decoration", "self-start", "self-end",
	  "semi-condensed", "semi-expanded", "separate", "serif", "show", "sidama",
	  "simp-chinese-formal", "simp-chinese-informal", "single",
	  "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal",
	  "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow",
	  "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali",
	  "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "space-evenly", "spell-out", "square",
	  "square-button", "start", "static", "status-bar", "stretch", "stroke", "sub",
	  "subpixel-antialiased", "super", "sw-resize", "symbolic", "symbols", "system-ui", "table",
	  "table-caption", "table-cell", "table-column", "table-column-group",
	  "table-footer-group", "table-header-group", "table-row", "table-row-group",
	  "tamil",
	  "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai",
	  "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight",
	  "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er",
	  "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top",
	  "trad-chinese-formal", "trad-chinese-informal", "transform",
	  "translate", "translate3d", "translateX", "translateY", "translateZ",
	  "transparent", "ultra-condensed", "ultra-expanded", "underline", "unset", "up",
	  "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal",
	  "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url",
	  "var", "vertical", "vertical-text", "visible", "visibleFill", "visiblePainted",
	  "visibleStroke", "visual", "w-resize", "wait", "wave", "wider",
	  "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor",
	  "xx-large", "xx-small"
	], valueKeywords = keySet(valueKeywords_);

	var allWords = documentTypes_.concat(mediaTypes_).concat(mediaFeatures_).concat(mediaValueKeywords_)
	  .concat(propertyKeywords_).concat(nonStandardPropertyKeywords_).concat(colorKeywords_)
	  .concat(valueKeywords_);
	CodeMirror.registerHelper("hintWords", "css", allWords);

	function tokenCComment(stream, state) {
	  var maybeEnd = false, ch;
	  while ((ch = stream.next()) != null) {
		 if (maybeEnd && ch == "/") {
			state.tokenize = null;
			break;
		 }
		 maybeEnd = (ch == "*");
	  }
	  return ["comment", "comment"];
	}

	CodeMirror.defineMIME("text/css", {
	  documentTypes: documentTypes,
	  mediaTypes: mediaTypes,
	  mediaFeatures: mediaFeatures,
	  mediaValueKeywords: mediaValueKeywords,
	  propertyKeywords: propertyKeywords,
	  nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	  fontProperties: fontProperties,
	  counterDescriptors: counterDescriptors,
	  colorKeywords: colorKeywords,
	  valueKeywords: valueKeywords,
	  tokenHooks: {
		 "/": function(stream, state) {
			if (!stream.eat("*")) return false;
			state.tokenize = tokenCComment;
			return tokenCComment(stream, state);
		 }
	  },
	  name: "css"
	});

	CodeMirror.defineMIME("text/x-scss", {
	  mediaTypes: mediaTypes,
	  mediaFeatures: mediaFeatures,
	  mediaValueKeywords: mediaValueKeywords,
	  propertyKeywords: propertyKeywords,
	  nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	  colorKeywords: colorKeywords,
	  valueKeywords: valueKeywords,
	  fontProperties: fontProperties,
	  allowNested: true,
	  lineComment: "//",
	  tokenHooks: {
		 "/": function(stream, state) {
			if (stream.eat("/")) {
			  stream.skipToEnd();
			  return ["comment", "comment"];
			} else if (stream.eat("*")) {
			  state.tokenize = tokenCComment;
			  return tokenCComment(stream, state);
			} else {
			  return ["operator", "operator"];
			}
		 },
		 ":": function(stream) {
			if (stream.match(/\s*\{/, false))
			  return [null, null]
			return false;
		 },
		 "$": function(stream) {
			stream.match(/^[\w-]+/);
			if (stream.match(/^\s*:/, false))
			  return ["variable-2", "variable-definition"];
			return ["variable-2", "variable"];
		 },
		 "#": function(stream) {
			if (!stream.eat("{")) return false;
			return [null, "interpolation"];
		 }
	  },
	  name: "css",
	  helperType: "scss"
	});

	CodeMirror.defineMIME("text/x-less", {
	  mediaTypes: mediaTypes,
	  mediaFeatures: mediaFeatures,
	  mediaValueKeywords: mediaValueKeywords,
	  propertyKeywords: propertyKeywords,
	  nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	  colorKeywords: colorKeywords,
	  valueKeywords: valueKeywords,
	  fontProperties: fontProperties,
	  allowNested: true,
	  lineComment: "//",
	  tokenHooks: {
		 "/": function(stream, state) {
			if (stream.eat("/")) {
			  stream.skipToEnd();
			  return ["comment", "comment"];
			} else if (stream.eat("*")) {
			  state.tokenize = tokenCComment;
			  return tokenCComment(stream, state);
			} else {
			  return ["operator", "operator"];
			}
		 },
		 "@": function(stream) {
			if (stream.eat("{")) return [null, "interpolation"];
			if (stream.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/i, false)) return false;
			stream.eatWhile(/[\w\\\-]/);
			if (stream.match(/^\s*:/, false))
			  return ["variable-2", "variable-definition"];
			return ["variable-2", "variable"];
		 },
		 "&": function() {
			return ["atom", "atom"];
		 }
	  },
	  name: "css",
	  helperType: "less"
	});

	CodeMirror.defineMIME("text/x-gss", {
	  documentTypes: documentTypes,
	  mediaTypes: mediaTypes,
	  mediaFeatures: mediaFeatures,
	  propertyKeywords: propertyKeywords,
	  nonStandardPropertyKeywords: nonStandardPropertyKeywords,
	  fontProperties: fontProperties,
	  counterDescriptors: counterDescriptors,
	  colorKeywords: colorKeywords,
	  valueKeywords: valueKeywords,
	  supportsAtComponent: true,
	  tokenHooks: {
		 "/": function(stream, state) {
			if (!stream.eat("*")) return false;
			state.tokenize = tokenCComment;
			return tokenCComment(stream, state);
		 }
	  },
	  name: "css",
	  helperType: "gss"
	});

 });

/*!
 * angular-translate - v2.18.1 - 2018-05-19
 * 
 * Copyright (c) 2018 The angular-translate team, Pascal Precht; Licensed MIT
 */
(function (root, factory) {
	if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module unless amdModuleId is set
		define([], function () {
			return (factory());
		});
	} else if (typeof module === 'object' && module.exports) {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like environments that support module.exports,
		// like Node.
		module.exports = factory();
	} else {
		factory();
	}
}(this, function () {

	angular.module('pascalprecht.translate')
		/**
		 * @ngdoc object
		 * @name pascalprecht.translate.$translatePartialLoaderProvider
		 *
		 * @description
		 * By using a $translatePartialLoaderProvider you can configure a list of a needed
		 * translation parts directly during the configuration phase of your application's
		 * lifetime. All parts you add by using this provider would be loaded by
		 * angular-translate at the startup as soon as possible.
		 */
		.provider('$translatePartialLoader', $translatePartialLoader);

	function $translatePartialLoader() {

		'use strict';

		/**
		 * @constructor
		 * @name Part
		 *
		 * @description
		 * Represents Part object to add and set parts at runtime.
		 */
		function Part(name, priority, urlTemplate) {
			this.name = name;
			this.isActive = true;
			this.tables = {};
			this.priority = priority || 0;
			this.langPromises = {};
			this.urlTemplate = urlTemplate;
		}

		/**
		 * @name parseUrl
		 * @method
		 *
		 * @description
		 * Returns a parsed url template string and replaces given target lang
		 * and part name it.
		 *
		 * @param {string|function} urlTemplate - Either a string containing an url pattern (with
		 *                                        '{part}' and '{lang}') or a function(part, lang)
		 *                                        returning a string.
		 * @param {string} targetLang - Language key for language to be used.
		 * @return {string} Parsed url template string
		 */
		Part.prototype.parseUrl = function (urlTemplate, targetLang) {
			if (angular.isFunction(urlTemplate)) {
				return urlTemplate(this.name, targetLang);
			}
			return urlTemplate.replace(/\{part\}/g, this.name).replace(/\{lang\}/g, targetLang);
		};

		Part.prototype.getTable = function (lang, $q, $http, $httpOptions, urlTemplate, errorHandler) {

			//locals
			var self = this;
			var lastLangPromise = this.langPromises[lang];
			var deferred = $q.defer();

			//private helper helpers
			var fetchData = function () {
				return $q(function (resolve, reject) {
					if (self.urlTemplate != null || urlTemplate != null) {
						$http({
								method: 'GET',
								url: self.parseUrl(self.urlTemplate || urlTemplate, lang)
							},
							$httpOptions).then(function (response) {
							if (response != null && response.data != null) {
								resolve(response);
							} else {
								reject();
							}
						}).catch(function () {
							reject();
						});
					} else {
						reject();
					}
				});
				// return $http(
				//   angular.extend({
				//       method : 'GET',
				//       url : self.parseUrl(self.urlTemplate || urlTemplate, lang)
				//     },
				//     $httpOptions)
				// );
			};

			//private helper
			var handleNewData = function (data) {
				self.tables[lang] = data;
				deferred.resolve(data);
			};

			//private helper
			var rejectDeferredWithPartName = function () {
				deferred.reject(self.name);
			};

			//private helper
			var tryGettingThisTable = function () {
				//data fetching logic
				fetchData().then(
					function (result) {
						handleNewData(result.data);
					},
					function (errorResponse) {
						if (errorHandler) {
							errorHandler(self.name, lang, errorResponse).then(handleNewData, rejectDeferredWithPartName);
						} else {
							rejectDeferredWithPartName();
						}
					});
			};

			//loading logic
			if (!this.tables[lang]) {
				//let's try loading the data
				if (!lastLangPromise) {
					//this is the first request - just go ahead and hit the server
					tryGettingThisTable();
				} else {
					//this is an additional request after one or more unfinished or failed requests
					//chain the deferred off the previous request's promise so that this request conditionally executes
					//if the previous request succeeds then the result will be passed through, but if it fails then this request will try again and hit the server
					lastLangPromise.then(deferred.resolve, tryGettingThisTable);
				}
				//retain a reference to the last promise so we can continue the chain if another request is made before any succeed
				//you can picture the promise chain as a singly-linked list (formed by the .then handler queues) that's traversed by the execution context
				this.langPromises[lang] = deferred.promise;
			} else {
				//the part has already been loaded - if lastLangPromise is also undefined then the table has been populated using setPart
				//this breaks the promise chain because we're not tying langDeferred's outcome to a previous call's promise handler queues, but we don't care because there's no asynchronous execution context to keep track of anymore
				deferred.resolve(this.tables[lang]);
			}
			return deferred.promise;
		};

		var parts = {};

		function hasPart(name) {
			return Object.prototype.hasOwnProperty.call(parts, name);
		}

		function isStringValid(str) {
			return angular.isString(str) && str !== '';
		}

		function isPartAvailable(name) {
			if (!isStringValid(name)) {
				throw new TypeError('Invalid type of a first argument, a non-empty string expected.');
			}

			return (hasPart(name) && parts[name].isActive);
		}

		function deepExtend(dst, src) {
			for (var property in src) {
				if (src[property] && src[property].constructor &&
					src[property].constructor === Object) {
					dst[property] = dst[property] || {};
					deepExtend(dst[property], src[property]);
				} else {
					dst[property] = src[property];
				}
			}
			return dst;
		}

		function getPrioritizedParts() {
			var prioritizedParts = [];
			for (var part in parts) {
				if (parts[part].isActive) {
					prioritizedParts.push(parts[part]);
				}
			}
			prioritizedParts.sort(function (a, b) {
				return a.priority - b.priority;
			});
			return prioritizedParts;
		}


		/**
		 * @ngdoc function
		 * @name pascalprecht.translate.$translatePartialLoaderProvider#addPart
		 * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
		 *
		 * @description
		 * Registers a new part of the translation table to be loaded once the
		 * `angular-translate` gets into runtime phase. It does not actually load any
		 * translation data, but only registers a part to be loaded in the future.
		 *
		 * @param {string} name A name of the part to add
		 * @param {int} [priority=0] Sets the load priority of this part.
		 *
		 * @returns {object} $translatePartialLoaderProvider, so this method is chainable
		 * @throws {TypeError} The method could throw a **TypeError** if you pass the param
		 * of the wrong type. Please, note that the `name` param has to be a
		 * non-empty **string**.
		 */
		this.addPart = function (name, priority, urlTemplate) {
			if (!isStringValid(name)) {
				throw new TypeError('Couldn\'t add part, part name has to be a string!');
			}

			if (!hasPart(name)) {
				parts[name] = new Part(name, priority, urlTemplate);
			}
			parts[name].isActive = true;

			return this;
		};

		/**
		 * @ngdocs function
		 * @name pascalprecht.translate.$translatePartialLoaderProvider#setPart
		 * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
		 *
		 * @description
		 * Sets a translation table to the specified part. This method does not make the
		 * specified part available, but only avoids loading this part from the server.
		 *
		 * @param {string} lang A language of the given translation table
		 * @param {string} part A name of the target part
		 * @param {object} table A translation table to set to the specified part
		 *
		 * @return {object} $translatePartialLoaderProvider, so this method is chainable
		 * @throws {TypeError} The method could throw a **TypeError** if you pass params
		 * of the wrong type. Please, note that the `lang` and `part` params have to be a
		 * non-empty **string**s and the `table` param has to be an object.
		 */
		this.setPart = function (lang, part, table) {
			if (!isStringValid(lang)) {
				throw new TypeError('Couldn\'t set part.`lang` parameter has to be a string!');
			}
			if (!isStringValid(part)) {
				throw new TypeError('Couldn\'t set part.`part` parameter has to be a string!');
			}
			if (typeof table !== 'object' || table === null) {
				throw new TypeError('Couldn\'t set part. `table` parameter has to be an object!');
			}

			if (!hasPart(part)) {
				parts[part] = new Part(part);
				parts[part].isActive = false;
			}

			parts[part].tables[lang] = table;
			return this;
		};

		/**
		 * @ngdoc function
		 * @name pascalprecht.translate.$translatePartialLoaderProvider#deletePart
		 * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
		 *
		 * @description
		 * Removes the previously added part of the translation data. So, `angular-translate` will not
		 * load it at the startup.
		 *
		 * @param {string} name A name of the part to delete
		 *
		 * @returns {object} $translatePartialLoaderProvider, so this method is chainable
		 *
		 * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
		 * type. Please, note that the `name` param has to be a non-empty **string**.
		 */
		this.deletePart = function (name) {
			if (!isStringValid(name)) {
				throw new TypeError('Couldn\'t delete part, first arg has to be string.');
			}

			if (hasPart(name)) {
				parts[name].isActive = false;
			}

			return this;
		};


		/**
		 * @ngdoc function
		 * @name pascalprecht.translate.$translatePartialLoaderProvider#isPartAvailable
		 * @methodOf pascalprecht.translate.$translatePartialLoaderProvider
		 *
		 * @description
		 * Checks if the specific part is available. A part becomes available after it was added by the
		 * `addPart` method. Available parts would be loaded from the server once the `angular-translate`
		 * asks the loader to that.
		 *
		 * @param {string} name A name of the part to check
		 *
		 * @returns {boolean} Returns **true** if the part is available now and **false** if not.
		 *
		 * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
		 * type. Please, note that the `name` param has to be a non-empty **string**.
		 */
		this.isPartAvailable = isPartAvailable;

		/**
		 * @ngdoc object
		 * @name pascalprecht.translate.$translatePartialLoader
		 *
		 * @requires $q
		 * @requires $http
		 * @requires $injector
		 * @requires $rootScope
		 * @requires $translate
		 *
		 * @description
		 *
		 * @param {object} options Options object
		 *
		 * @throws {TypeError}
		 */
		this.$get = ['$rootScope', '$injector', '$q', '$http', '$log',
			function ($rootScope, $injector, $q, $http, $log) {

				/**
				 * @ngdoc event
				 * @name pascalprecht.translate.$translatePartialLoader#$translatePartialLoaderStructureChanged
				 * @eventOf pascalprecht.translate.$translatePartialLoader
				 * @eventType broadcast on root scope
				 *
				 * @description
				 * A $translatePartialLoaderStructureChanged event is called when a state of the loader was
				 * changed somehow. It could mean either some part is added or some part is deleted. Anyway when
				 * you get this event the translation table is not longer current and has to be updated.
				 *
				 * @param {string} name A name of the part which is a reason why the event was fired
				 */

				var service = function (options) {
					if (!isStringValid(options.key)) {
						throw new TypeError('Unable to load data, a key is not a non-empty string.');
					}

					if (!isStringValid(options.urlTemplate) && !angular.isFunction(options.urlTemplate)) {
						throw new TypeError('Unable to load data, a urlTemplate is not a non-empty string or not a function.');
					}

					var errorHandler = options.loadFailureHandler;
					if (errorHandler !== undefined) {
						if (!angular.isString(errorHandler)) {
							throw new Error('Unable to load data, a loadFailureHandler is not a string.');
						} else {
							errorHandler = $injector.get(errorHandler);
						}
					}

					var loaders = [],
						prioritizedParts = getPrioritizedParts();

					angular.forEach(prioritizedParts, function (part) {
						loaders.push(
							part.getTable(options.key, $q, $http, options.$http, options.urlTemplate, errorHandler)
						);
						part.urlTemplate = part.urlTemplate || options.urlTemplate;
					});

					// workaround for #1781
					var structureHasBeenChangedWhileLoading = false;
					var dirtyCheckEventCloser = $rootScope.$on('$translatePartialLoaderStructureChanged', function () {
						structureHasBeenChangedWhileLoading = true;
					});

					return $q.all(loaders)
						.then(function () {
							dirtyCheckEventCloser();
							if (structureHasBeenChangedWhileLoading) {
								if (!options.__retries) {
									// the part structure has been changed while loading (the origin ones)
									// this can happen if an addPart/removePart has been invoked right after a $translate.use(lang)
									// TODO maybe we can optimize this with the actual list of missing parts
									options.__retries = (options.__retries || 0) + 1;
									return service(options);
								} else {
									// the part structure has been changed again while loading (retried one)
									// because this could an infinite loop, this will not load another one again
									$log.warn('The partial loader has detected a multiple structure change (with addPort/removePart) ' +
										'while loading translations. You should consider using promises of $translate.use(lang) and ' +
										'$translate.refresh(). Also parts should be added/removed right before an explicit refresh ' +
										'if possible.');
								}
							}
							var table = {};
							prioritizedParts = getPrioritizedParts();
							angular.forEach(prioritizedParts, function (part) {
								deepExtend(table, part.tables[options.key]);
							});
							return table;
						}, function () {
							dirtyCheckEventCloser();
							return $q.reject(options.key);
						});
				};

				/**
				 * @ngdoc function
				 * @name pascalprecht.translate.$translatePartialLoader#addPart
				 * @methodOf pascalprecht.translate.$translatePartialLoader
				 *
				 * @description
				 * Registers a new part of the translation table. This method does not actually perform any xhr
				 * requests to get translation data. The new parts will be loaded in order of priority from the server next time
				 * `angular-translate` asks the loader to load translations.
				 *
				 * @param {string} name A name of the part to add
				 * @param {int} [priority=0] Sets the load priority of this part.
				 *
				 * @returns {object} $translatePartialLoader, so this method is chainable
				 *
				 * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
				 * event would be fired by this method in case the new part affected somehow on the loaders
				 * state. This way it means that there are a new translation data available to be loaded from
				 * the server.
				 *
				 * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
				 * type. Please, note that the `name` param has to be a non-empty **string**.
				 */
				service.addPart = function (name, priority, urlTemplate) {
					if (!isStringValid(name)) {
						throw new TypeError('Couldn\'t add part, first arg has to be a string');
					}

					if (!hasPart(name)) {
						parts[name] = new Part(name, priority, urlTemplate);
						$rootScope.$emit('$translatePartialLoaderStructureChanged', name);
					} else if (!parts[name].isActive) {
						parts[name].isActive = true;
						$rootScope.$emit('$translatePartialLoaderStructureChanged', name);
					}

					return service;
				};

				/**
				 * @ngdoc function
				 * @name pascalprecht.translate.$translatePartialLoader#deletePart
				 * @methodOf pascalprecht.translate.$translatePartialLoader
				 *
				 * @description
				 * Deletes the previously added part of the translation data. The target part could be deleted
				 * either logically or physically. When the data is deleted logically it is not actually deleted
				 * from the browser, but the loader marks it as not active and prevents it from affecting on the
				 * translations. If the deleted in such way part is added again, the loader will use the
				 * previously loaded data rather than loading it from the server once more time. But if the data
				 * is deleted physically, the loader will completely remove all information about it. So in case
				 * of recycling this part will be loaded from the server again.
				 *
				 * @param {string} name A name of the part to delete
				 * @param {boolean=} [removeData=false] An indicator if the loader has to remove a loaded
				 * translation data physically. If the `removeData` if set to **false** the loaded data will not be
				 * deleted physically and might be reused in the future to prevent an additional xhr requests.
				 *
				 * @returns {object} $translatePartialLoader, so this method is chainable
				 *
				 * @fires {$translatePartialLoaderStructureChanged} The $translatePartialLoaderStructureChanged
				 * event would be fired by this method in case a part deletion process affects somehow on the
				 * loaders state. This way it means that some part of the translation data is now deprecated and
				 * the translation table has to be recompiled with the remaining translation parts.
				 *
				 * @throws {TypeError} The method could throw a **TypeError** if you pass some param of the
				 * wrong type. Please, note that the `name` param has to be a non-empty **string** and
				 * the `removeData` param has to be either **undefined** or **boolean**.
				 */
				service.deletePart = function (name, removeData) {
					if (!isStringValid(name)) {
						throw new TypeError('Couldn\'t delete part, first arg has to be string');
					}

					if (removeData === undefined) {
						removeData = false;
					} else if (typeof removeData !== 'boolean') {
						throw new TypeError('Invalid type of a second argument, a boolean expected.');
					}

					if (hasPart(name)) {
						var wasActive = parts[name].isActive;
						if (removeData) {
							var $translate = $injector.get('$translate');
							var cache = $translate.loaderCache();
							if (typeof (cache) === 'string') {
								// getting on-demand instance of loader
								cache = $injector.get(cache);
							}
							// Purging items from cache...
							if (typeof (cache) === 'object') {
								angular.forEach(parts[name].tables, function (value, key) {
									cache.remove(parts[name].parseUrl(parts[name].urlTemplate, key));
								});
							}
							delete parts[name];
						} else {
							parts[name].isActive = false;
						}
						if (wasActive) {
							$rootScope.$emit('$translatePartialLoaderStructureChanged', name);
						}
					}

					return service;
				};

				/**
				 * @ngdoc function
				 * @name pascalprecht.translate.$translatePartialLoader#isPartLoaded
				 * @methodOf pascalprecht.translate.$translatePartialLoader
				 *
				 * @description
				 * Checks if the registered translation part is loaded into the translation table.
				 *
				 * @param {string} name A name of the part
				 * @param {string} lang A key of the language
				 *
				 * @returns {boolean} Returns **true** if the translation of the part is loaded to the translation table and **false** if not.
				 *
				 * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
				 * type. Please, note that the `name` and `lang` params have to be non-empty **string**.
				 */
				service.isPartLoaded = function (name, lang) {
					return angular.isDefined(parts[name]) && angular.isDefined(parts[name].tables[lang]);
				};

				/**
				 * @ngdoc function
				 * @name pascalprecht.translate.$translatePartialLoader#getRegisteredParts
				 * @methodOf pascalprecht.translate.$translatePartialLoader
				 *
				 * @description
				 * Gets names of the parts that were added with the `addPart`.
				 *
				 * @returns {array} Returns array of registered parts, if none were registered then an empty array is returned.
				 */
				service.getRegisteredParts = function () {
					var registeredParts = [];
					angular.forEach(parts, function (p) {
						if (p.isActive) {
							registeredParts.push(p.name);
						}
					});
					return registeredParts;
				};


				/**
				 * @ngdoc function
				 * @name pascalprecht.translate.$translatePartialLoader#isPartAvailable
				 * @methodOf pascalprecht.translate.$translatePartialLoader
				 *
				 * @description
				 * Checks if a target translation part is available. The part becomes available just after it was
				 * added by the `addPart` method. Part's availability does not mean that it was loaded from the
				 * server, but only that it was added to the loader. The available part might be loaded next
				 * time the loader is called.
				 *
				 * @param {string} name A name of the part to delete
				 *
				 * @returns {boolean} Returns **true** if the part is available now and **false** if not.
				 *
				 * @throws {TypeError} The method could throw a **TypeError** if you pass the param of the wrong
				 * type. Please, note that the `name` param has to be a non-empty **string**.
				 */
				service.isPartAvailable = isPartAvailable;

				return service;

			}
		];

	}

	$translatePartialLoader.displayName = '$translatePartialLoader';
	return 'pascalprecht.translate';

}));


(function () {
	'use strict';

	angular.module('app.front').config(config);

	function config($stateProvider, $translatePartialLoaderProvider) {
		$stateProvider
			.state('app.touristAttractions', {
				url: '/tourist_attractions',
				views: {
					'content@app': {
						templateUrl: 'app/main/tourist_attractions/tourist_attractions.html',
						controller: 'touristAttractionsController as vm'
					}
				},
				data: {
					permissions: ['TOURIST_ATTRACTION']
				}
			})
			.state('app.touristAttractions.add', {
				url: '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/tourist_attractions/add/add_tourist_attraction.html',
						controller: 'addTouristAttractionController as vm'
					}
				},
				data: {
					permissions: ['TOURIST_ATTRACTION']
				}
			})
			.state('app.touristAttractions.update', {
				url: '/update/{id}',
				views: {
					'content@app': {
						templateUrl: 'app/main/tourist_attractions/add/add_tourist_attraction.html',
						controller: 'addTouristAttractionController as vm'
					}
				},
				data: {
					permissions: ['TOURIST_ATTRACTION']
				}
			});

		$translatePartialLoaderProvider.addPart('app/main/tourist_attractions');

	}
})();

(function () {
	'use strict';

	angular.module('app.front')
		.config(config);

	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		$stateProvider
			.state('app.statistics', {
				url: '/statistics',
				views: {
					'content@app': {
						templateUrl: 'app/main/statistics/statistics.html',
						controller: 'statisticsController as vm'
					}
				}
			})
			.state('app.statistics.edit', {
				url: '/edit',
				views: {
					'content@app': {
						templateUrl: 'app/main/statistics/edit/editStatistics.html',
						controller: 'editStatisticsController as vm'
					}
				},
				data: {
					permissions: ['COMPLETE_OCCUPATION_STATISTICS']
				}
			})
			.state('app.statistics.display', {
				url: '/display',
				views: {
					'content@app': {
						templateUrl: 'app/main/statistics/display/displayStatistics.html',
						controller: 'displayStatisticsController as vm'
					}
				},
				data: {
					permissions: ['OCCUPATION_STATISTICS']
				}
			})
			.state('app.statistics.automatic', {
				url: '/automatic',
				views: {
					'content@app': {
						templateUrl: 'app/main/statistics/automatic/automaticStatistics.html',
						controller: 'automaticStatisticsController as vm'
					}
				},
				data: {
					permissions: ['MONTHLY_STATISTICS']
				}
			})
			.state('app.statistics.repartition', {
				url: '/repartition',
				views: {
					'content@app': {
						templateUrl: 'app/main/statistics/repartition/repartitionStatistics.html',
						controller: 'repartitionStatisticsController as vm'
					}
				},
				data: {
					permissions: ['REPARTITION']
				}
			})
			.state('app.statistics.reporting', {
				url: '/reporting',
				views: {
					'content@app': {
						templateUrl: 'app/main/statistics/reporting/reportingStatistics.html',
						controller: 'reportingStatisticsController as vm'
					}
				},
				data: {
					permissions: ['COMMERCIAL_REPORTING']
				}
			});

		$translatePartialLoaderProvider.addPart('app/main/statistics');

	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		// State
		$stateProvider
			.state('app.statistic_company', {
				url: '/statistic_company',
				views: {
					'content@app': {
						templateUrl: 'app/main/statistic_company/statistic_company.html',
						controller: 'StatisticCompanyController as vm'
					}
				},
				data: {
					permissions: ['COMPANY_STATISTICS']
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/statistic_company');

	}

})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		// State
		$stateProvider
			.state('app.statistic_banners', {
				url: '/statistic_banners',
				views: {
					'content@app': {
						templateUrl: 'app/main/statistic_banner/statistic_banner.html',
						controller: 'StatisticBannersController as vm'
					}
				},
				data: {
					permissions: ['COMPANY_STATISTICS']
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/statistic_banner');

	}

})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		// State
		$stateProvider
			.state('app.statistic_articles', {
				url: '/statistic_articles',
				views: {
					'content@app': {
						templateUrl: 'app/main/statistic_articles/statistic_articles.html',
						controller: 'StatisticArticlesController as vm'
					}
				},
				data: {
					permissions: ['COMPANY_STATISTICS']
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/statistic_articles');

	}

})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		// State
		$stateProvider
			.state('app.sites', {
				url: '/sites',
				views: {
					'content@app': {
						templateUrl: 'app/main/sites_management/sites/sites.html',
						controller: 'SitesController as vm'
					}
				},
				data: {
					permissions: ['WEBSITES']
				}
			})
			.state('app.blocs', {
				url: '/blocs',
				views: {
					'content@app': {
						templateUrl: 'app/main/sites_management/blocs/blocs.html',
						controller: 'BlocsController as vm'
					}
				},
				data: {
					permissions: ['WEBSITE_BLOCS']
				}
			})
			.state('app.blocs.bloc', {
				url: '/bloc/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/sites_management/blocs/bloc/bloc.html',
						controller: 'BlocController as vm'
					}
				},
				data: {
					permissions: ['WEBSITE_BLOCS']
				}
			})
			.state('app.pages', {
				url: '/pages',
				views: {
					'content@app': {
						templateUrl: 'app/main/sites_management/pages/pages.html',
						controller: 'PagesController as vm'
					}
				},
				data: {
					permissions: ['PAGES']
				}
			})
			.state('app.pages.page', {
				url: '/page/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/sites_management/pages/page/page.html',
						controller: 'PageController as vm'
					}
				},
				data: {
					permissions: ['PAGES']
				}
			})
			.state('app.siteMenu', {
				url: '/siteMenu',
				views: {
					'content@app': {
						templateUrl: 'app/main/sites_management/siteMenu/siteMenu.html',
						controller: 'SiteMenuController as vm'
					}
				},
				data: {
					permissions: ['MENUS']
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/sites_management');

	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $provide) {

		// State
		$stateProvider
			.state('app.similar_companies', {
				url: '/similar_companies',
				views: {
					'content@app': {
						templateUrl: 'app/main/similar_companies/similar_companies.html',
						controller: 'SimilarCompaniesController as vm'
					}
				},
				data: {
					permissions: ['SIMILAR_COMPANIES']
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/similar_companies');

		// Menu
		// Voir app/settings/settings.module.js

		$provide.decorator('$state', ['$delegate', '$window', function ($delegate, $window) {
			var extended = {
				goNewTab: function (stateName, params) {
					$window.open(
						$delegate.href(stateName, params, {
							absolute: true
						}), '_blank');
				}
			};
			angular.extend($delegate, extended);
			return $delegate;
		}]);

	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.database', {
				url: '/database',
				views: {
					'content@app': {
						templateUrl: 'app/main/settings/database/database.html',
						controller: 'databaseController as vm'
					}
				}
			})
			.state('app.database.companies', {
				url: '/companies',
				views: {
					'content@app': {
						templateUrl: 'app/main/models/model_view.html',
						controller: 'databaseCompaniesController as vm'
					}
				},
				data: {
					permissions: ['COMPANIES_FIELDS']
				}
			})
			.state('app.database.companies.fields', {
				url: '/contacts/settings/fields?modelType?categoryId',
				views: {
					'content@app': {
						templateUrl: 'app/main/models/fields_models.html',
						controller: 'fieldsModelsController as vm'
					}
				},
				data: {
					permissions: ['CONTACTS_SETTINGS']
				}
			})
			.state('app.database.settings', {
				url: '/companies/settings',
				views: {
					'content@app': {
						templateUrl: 'app/main/settings/database/companies_settings.html',
						controller: 'companiesSettingsController as vm'
					}
				},
				data: {
					permissions: ['FIELD_LINKS']
				}
			})
			.state('app.database.types', {
				url: '/companies/types',
				views: {
					'content@app': {
						templateUrl: 'app/main/models/model_types.html',
						controller: 'databaseCompaniesTypesController as vm'
					}
				},
				data: {
					permissions: ['COMPANIES_TYPES']
				}
			})
			.state('app.database.types.research_page_creation', {
				url: '/research_page_creation?modelType?subTypeId',
				views: {
					'content@app': {
						templateUrl: 'app/main/settings/research_page_creation/research_page_creation.html',
						controller: 'ResearchPageCreationController as vm'
					}
				},
				data: {
					permissions: ['COMPANIES_TYPES']
				}
			})
			.state('app.database.languages', {
				url: '/languages',
				views: {
					'content@app': {
						templateUrl: 'app/main/settings/languages/languages.html',
						controller: 'languagesController as vm'
					}
				}
			})
			.state('app.database.contacts', {
				url: '/contacts',
				views: {
					'content@app': {
						templateUrl: 'app/main/models/model_view.html',
						controller: 'databaseContactsController as vm'
					}
				},
				data: {
					permissions: ['CONTACTS_FIELDS']
				}
			})
			.state('app.database.contactsSettings', {
				url: '/contacts/settings',
				views: {
					'content@app': {
						templateUrl: 'app/main/settings/database/contacts_settings.html',
						controller: 'databaseContactsSettingsController as vm'
					}
				},
				data: {
					permissions: ['CONTACTS_SETTINGS']
				}
			})
			.state('app.database.contacts.fields', {
				url: '/contacts/settings/fields?modelType?categoryId',
				views: {
					'content@app': {
						templateUrl: 'app/main/models/fields_models.html',
						controller: 'fieldsModelsController as vm'
					}
				},
				data: {
					permissions: ['CONTACTS_SETTINGS']
				}
			})
			.state('app.database.registrationSettings', {
				url: '/registrations/settings?modelType',
				views: {
					'content@app': {
						templateUrl: 'app/main/settings/research_page_creation/research_page_creation.html',
						controller: 'ResearchPageCreationController as vm'
					}
				},
				data: {
					permissions: ['REGISTRATION_SETTINGS']
				},
				params: {
					modelType: 'INSCRIPTION_MODEL'
				}
			})
			.state('app.settingsmessage', {
				url: '/settings/message',
				views: {
					'content@app': {
						templateUrl: 'app/main/settings/message/message_settings.html',
						controller: 'MessageSettingsController as vm'
					}
				},
				data: {
					permissions: ['MESSAGE_ACTIONS']
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/settings');

	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		// State
		$stateProvider
			.state('app.rfp', {
				url: '/rfp',
				views: {
					'content@app': {
						templateUrl: 'app/main/request_for_proposal/rfp.html',
						controller: 'RequestForProposalController as vm'
					}
				},
				data: {
					permissions: ['QUOTES_REQUEST']
				}
			})
			.state('app.rfp.members', {
				url: '/members',
				views: {
					'content@app': {
						templateUrl: 'app/main/request_for_proposal/request_for_proposal_members/request_for_proposal_members.html',
						controller: 'MembersController as vm'
					}
				},
				data: {
					permissions: ['QUOTES_REQUEST']
				}
			})
			.state('app.rfp.members.details', {
				url: '/members/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/request_for_proposal/request_for_proposal_members/details/details_member.html',
						controller: 'DetailsMembersController as vm'
					}
				},
				data: {
					permissions: ['QUOTES_REQUEST']
				}
			})
			.state('app.rfp.company', {
				url: '/company',
				views: {
					'content@app': {
						templateUrl: 'app/main/request_for_proposal/request_for_proposal_company/request_for_proposal_company.html',
						controller: 'RequestForProposalCompanyController as vm'
					}
				},
				data: {
					permissions: ['QUOTES_REQUEST']
				}
			})
			.state('app.rfp.details', {
				url: '/details/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/request_for_proposal/details/rfp_details.html',
						controller: 'RequestForProposalDetailsController as vm'
					}
				},
				data: {
					permissions: ['QUOTES_REQUEST']
				}
			});


		// Translation
		$translatePartialLoaderProvider.addPart('app/main/request_for_proposal');

	}

})();

(function () {
	'use strict';

	angular.module('app.front')
		.config(config);

	function config($stateProvider, $translatePartialLoaderProvider) {
		$stateProvider
			.state('app.packages', {
				url: '/packages',
				views: {
					'content@app': {
						templateUrl: 'app/main/packages/packages.html',
						controller: 'packagesController as vm'
					}
				},
				data: {
					permissions: ['PACKAGES']
				}
			})
			.state('app.packages.add', {
				url: '/add',
				views: {
					'content@app': {
						templateUrl: 'app/main/packages/add/addPackage.html',
						controller: 'addPackagesController as vm'
					}
				},
				data: {
					permissions: ['PACKAGES']
				}
			})
			.state('app.packages.update', {
				url: '/update/{id}',
				views: {
					'content@app': {
						templateUrl: 'app/main/packages/add/addPackage.html',
						controller: 'addPackagesController as vm'
					}
				},
				data: {
					permissions: ['PACKAGES']
				}
			});

		$translatePartialLoaderProvider.addPart('app/main/packages');

	}
})();

(function () {
	'use strict';

	angular.module('app.front')
		.config(config);

	function config($stateProvider, $translatePartialLoaderProvider) {
		$stateProvider
			.state('app.notations', {
				url: '/notations',
				views: {
					'content@app': {
						templateUrl: 'app/main/notations/notations.html',
						controller: 'NotationsController as vm'
					}
				}
			});

		$translatePartialLoaderProvider.addPart('app/main/notations');

	}
})();

(function () {
	'use strict';

	angular.module('app.front')
		.config(config);

	function config($stateProvider, $translatePartialLoaderProvider) {
		$stateProvider
			.state('app.newsletter', {
				url: '/newsletter',
				views: {
					'content@app': {
						templateUrl: 'app/main/newsletter/newsletter.html',
						controller: 'NewsletterController as vm'
					}
				}
				// ,
				// data: {
				// 	permissions: ['GALLERIES']
				// }
			});

		$translatePartialLoaderProvider.addPart('app/main/newsletter');

	}
})();

(function () {
  'use strict';

  angular.module('app.front')
    .config(config);

  function config($stateProvider, $translatePartialLoaderProvider,$mdDateLocaleProvider) {

    $translatePartialLoaderProvider.addPart('app/main/missing_infos_tool');

  }

})();

(function () {
	'use strict';

	angular.module('app.front')
		.config(config);

	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
		$stateProvider
			.state('app.message', {
				url: '/message',
				views: {
					'content@app': {
						templateUrl: 'app/main/message/message.html',
						controller: 'MessageController as vm'
					}
				},
				data: {
					permissions: ['MESSAGE']
				}
			});
		$translatePartialLoaderProvider.addPart('app/main/message');

		$mdDateLocaleProvider.formatDate = function (date) {
			return date ? moment(date).format('DD/MM/YYYY') : "";
		};

	}
})();

(function () {
	'use strict';

	angular.module('app.front')
		.config(config);

	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
		$stateProvider
			.state('app.folders', {
				url: '/folders',
				views: {
					'content@app': {
						templateUrl: 'app/main/media/folders.html',
						controller: 'databaseFoldersController as vm'
					}
				},
				data: {
					permissions: ['FOLDERS']
				}
			});
		$translatePartialLoaderProvider.addPart('app/main/media');

	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		// State
		$stateProvider
			.state('app.mailing_blocs', {
				url: '/mailing/blocs',
				views: {
					'content@app': {
						templateUrl: 'app/main/mailing/blocs/blocs.html',
						controller: 'MailingBlocsController as vm'
					}
				},
				data: {
					permissions: ['COMMUNICATION_BLOCS']
				}
			})
			.state('app.mailing_blocs.bloc', {
				url: '/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/mailing/blocs/bloc/bloc.html',
						controller: 'MailingBlocController as vm'
					}
				},
				data: {
					permissions: ['COMMUNICATION_BLOCS']
				}
			})
			.state('app.mailing_pages', {
				url: '/mailing/pages',
				views: {
					'content@app': {
						templateUrl: 'app/main/mailing/pages/pages.html',
						controller: 'MailingPagesController as vm'
					}
				},
				data: {
					permissions: ['EMAILS']
				}
			})
			.state('app.mailing_pages.page', {
				url: '/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/mailing/pages/page/page.html',
						controller: 'MailingPageController as vm'
					}
				},
				data: {
					permissions: ['EMAILS']
				}
			})
			.state('app.mailing_triggers', {
				url: '/mailing/triggers',
				views: {
					'content@app': {
						templateUrl: 'app/main/mailing/triggers/triggers.html',
						controller: 'MailingTriggersController as vm'
					}
				},
				data: {
					permissions: ['EMAILS_TRIGGER']
				}
			})
			.state('app.mailing_triggers.trigger', {
				url: '/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/mailing/triggers/trigger/trigger.html',
						controller: 'MailingTriggerController as vm'
					}
				},
				data: {
					permissions: ['EMAILS_TRIGGER']
				}
			})
			.state('app.mailing_tags', {
				url: '/mailing/tags',
				views: {
					'content@app': {
						templateUrl: 'app/main/mailing/tags/tags.html',
						controller: 'MailingTagsController as vm'
					}
				},
				data: {
					permissions: ['TAGS']
				}
			})
			// .state('app.mailing_expeditors', {
			// 	url: '/mailing/expeditors',
			// 	views: {
			// 		'content@app': {
			// 			templateUrl: 'app/main/mailing/expeditors/expeditors.html',
			// 			controller: 'MailingExpeditorsController as vm'
			// 		}
			// 	}
			// })
			.state('app.mailing_history', {
				url: '/mailing/history',
				views: {
					'content@app': {
						templateUrl: 'app/main/mailing/history/history.html',
						controller: 'MailingHistoryController as vm'
					}
				},
				data: {
					permissions: ['HISTORY']
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/mailing');

	}
})();

(function () {
	'use strict';

	angular.module('app.front').config(config).run(run);

	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {

		// State
		$stateProvider
			.state('app.companies', {
				url: '/companies/:subType',
				views: {
					'content@app': {
						templateUrl: 'app/main/globe_network/companies/companies.html',
						controller: 'companiesController as vm'
					}
				},
				data: {
					permissions: ['DATABASE'],
					checkUserCompanySubTypes: true
				}
			})
			.state('app.companies.details', {
				url: '/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/globe_network/companies/company.html',
						controller: 'companyController as vm'
					}
				},
				data: {
					permissions: ['DATABASE'],
					checkUserCompanySubTypes: true
				}
			})
			.state('app.companies.details.contact', {
				url: '/contact/:contactId',
				views: {
					'content@app': {
						templateUrl: 'app/main/globe_network/companies/contacts/contact.html',
						controller: 'contactController as vm'
					}
				},
				params: {
					inscriptionId: null
				},
				data: {
					permissions: ['DATABASE'],
					checkUserCompanySubTypes: true
				}
			})
			.state('app.companies.details.contact.logistic', {
				url: '/logistic/:logisticId',
				views: {
					'content@app': {
						templateUrl: 'app/main/globe_network/companies/contacts/logistic.html',
						controller: 'logisticController as vm'
					}
				},
				data: {
					permissions: ['DATABASE'],
					checkUserCompanySubTypes: true
				}
			})
			.state('app.inscriptions_admin', {
				url: '/inscriptions_admin',
				views: {
					'content@app': {
						templateUrl: 'app/main/globe_network/inscriptions/inscriptions_admin.html',
						controller: 'InscriptionsAdminController as vm'
					}
				},
				data: {
					permissions: ['REGISTRATIONS']
				}
			})
			.state('app.inscriptions_admin.settings', {
				url: '/inscriptions_admin/settings?modelType',
				views: {
					'content@app': {
						templateUrl: 'app/main/settings/research_page_creation/research_page_creation.html',
						controller: 'ResearchPageCreationController as vm'
					}
				},
				data: {
					permissions: ['REGISTRATIONS']
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/globe_network');

	}

	function run($rootScope, $translate, $location, modelService, msNavigationService, userService) {
		var modelType = 'COMPANY_MODEL';
		var baseUrl = './api/rest/model/' + modelType;

		$rootScope.refreshCompanyTypes = function (langKey) {
			var lang = langKey != null ? langKey : $translate.preferredLanguage();
			msNavigationService.saveItem('database.phantom', {
				title: 'phantom',
				state: 'app.phantom',
				weight: 2,
				hidden: function () {
					return true;
				}
			});

			userService.getCurrent($translate.preferredLanguage(), false).then(function (data) {
				$rootScope.user = data;
				modelService.getSubTypes(baseUrl, lang, true).then(function (response) {

						if (angular.isArray($rootScope.companiesMenus)) {
							angular.forEach($rootScope.companiesMenus, function (item) {
								msNavigationService.deleteItem('database.company_' + item.index);
							});
						}

						$rootScope.companiesMenus = response.data;

						// Companies types menus
						if (userService.containsRole('DATABASE')) {
							for (var i = 0; i < response.data.length; i++) {
								var subtype = response.data[i];
								if ($rootScope.user.allCompanySubTypes || $rootScope.user.subTypeIds.lastIndexOf(subtype.id) > -1) {
									msNavigationService.saveItem('database.company_' + subtype.index, {
										title: subtype.name,
										state: 'app.companies',
										stateParams: {
											'subType': subtype.id
										},
										weight: 20 + subtype.index
									});
								}
							}
						} else if (userService.isMember()) {
							msNavigationService.saveItem('database.company_' + $rootScope.user.company.subTypes[0].index, {
								title: 'Profile',
								state: 'app.companies.details',
								stateParams: {
									'subType': $rootScope.user.company.subTypes[0].id,
									'id': $rootScope.user.company.id
								},
								weight: 1
							});
						}



					}) // end service
					.catch(function () {});
			}).catch(function () {});
		};

		if ($location.path().lastIndexOf('/crm/') === -1) {
			$rootScope.refreshCompanyTypes();
		}

		$rootScope.$on('refreshCompanyTypes', function (event, args) {
			if (args != null && args.langKey != null) {
				$rootScope.refreshCompanyTypes(args.langKey);
			} else {
				$rootScope.refreshCompanyTypes();
			}
		});

	}

})();

(function () {
	'use strict';

	angular.module('app.front')
		.config(config);

	function config($stateProvider, $translatePartialLoaderProvider) {
		$stateProvider
			.state('app.gallery', {
				url: '/galleries',
				views: {
					'content@app': {
						templateUrl: 'app/main/gallery/gallery.html',
						controller: 'GalleryController as vm'
					}
				},
				data: {
					permissions: ['GALLERIES']
				}
			})
			.state('app.gallery.details', {
				url: '/details/{uuid}',
				views: {
					'content@app': {
						templateUrl: 'app/main/gallery/details/details.html',
						controller: 'DetailsGalleryController as vm'
					}
				},
				data: {
					permissions: ['GALLERIES']
				}
			})
			.state('app.gallery.details.sub', {
				url: '/subGallery/{uuidSub}',
				views: {
					'content@app': {
						templateUrl: 'app/main/gallery/subGallery/subGallery.html',
						controller: 'SubGalleryController as vm'
					}
				},
				data: {
					permissions: ['GALLERIES']
				}
			});

		$translatePartialLoaderProvider.addPart('app/main/gallery');

	}
})();

(function () {
	'use strict';

	angular.module('app.front')
		.config(config);

	function config($stateProvider, $translatePartialLoaderProvider, $mdDateLocaleProvider) {
		$stateProvider
			.state('app.festival', {
				url: '/festival',
				views: {
					'content@app': {
						templateUrl: 'app/main/festival/festival.html',
						controller: 'FestivalController as vm'
					}
				},
				data: {
					permissions: ['FESTIVALS']
				}
			});
		$translatePartialLoaderProvider.addPart('app/main/festival');

		// $mdDateLocaleProvider.formatDate = function(date) {
		//   return date ? moment(date).format('DD/MM/YYYY') : "";
		// };


	}
})();

(function () {
	'use strict';

	angular.module('app.front').config(config);

	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
// Translation
$translatePartialLoaderProvider.addPart('app/main/events');

		$stateProvider
			.state('app.events', {
				url: '/events',
				views: {
					'content@app': {
						templateUrl: 'app/main/events/events.html',
						controller: 'eventsController as vm'
					}
				},
				data: {
					permissions: ['EVENTS']
				}
			}).state('app.events.inscriptionModel', {
				url: '/:id/registration/model',
				views: {
					'content@app': {
						templateUrl: 'app/main/models/model_view.html',
						controller: 'inscriptionModelController as vm'

					}
				},
				data: {
					permissions: ['EVENTS', 'EVENTS_SEE_REGISTRATION_FIELDS'],
					checkUserEvents: true
				}
			}).state('app.events.inscriptionStatus', {
				url: '/registration/status',
				views: {
					'content@app': {
						templateUrl: 'app/main/events/inscriptions/status.html',
						controller: 'inscriptionStatusController as vm'

					}
				},
				data: {
					permissions: ['EVENTS', 'EVENTS_REGISTRATION_STATUS']
				}

			}).state('app.events.inscriptionSubCategories', {
				url: '/registration/subcategories',
				views: {
					'content@app': {
						templateUrl: 'app/main/events/inscriptions/sub_categories.html',
						controller: 'inscriptionSubCategoriesController as vm'

					}
				},
				data: {
					permissions: ['EVENTS', 'EVENTS_SUB_CAT']
				}

			}).state('app.events.logisticalModel', {
				url: '/:id/logistical/model',
				views: {
					'content@app': {
						templateUrl: 'app/main/models/model_view.html',
						controller: 'logisticalModelController as vm'

					}
				},
				data: {
					permissions: ['EVENTS', 'EVENTS_SEE_LOGISTIC_FIELDS'],
					checkUserEvents: true
				}
			}).state('app.events.logisticalStatus', {
				url: '/logistical/status',
				views: {
					'content@app': {
						templateUrl: 'app/main/events/logistics/status.html',
						controller: 'logisticalStatusController as vm'

					}
				},
				data: {
					permissions: ['EVENTS', 'EVENTS_LOGISTICAL_STATUS']
				}

			}).state('app.events.inscriptionForms', {
				url: '/:id/inscription/forms',
				views: {
					'content@app': {
						templateUrl: 'app/main/events/inscriptions/forms/forms.html',
						controller: 'inscriptionFormsController as vm'
					}
				},
				data: {
					permissions: ['EVENTS', 'EVENTS_SEE_REGISTRATION_FORMS'],
					checkUserEvents: true
				}
			}).state('app.events.inscriptionFields', {
				url: '/:id/inscription/form/:formId',
				views: {
					'content@app': {
						templateUrl: 'app/main/events/inscriptions/forms/fields.html',
						controller: 'inscriptionFieldsController as vm'
					}
				},
				data: {
					permissions: ['EVENTS', 'EVENTS_SEE_REGISTRATION_FORMS'],
					checkUserEvents: true
				}
			});










	}

})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $provide) {

		// State
		$stateProvider
			.state('app.duplication_tool', {
				url: '/duplication_tool',
				views: {
					'content@app': {
						templateUrl: 'app/main/duplication_tool/duplication_tool.html',
						controller: 'DuplicationToolController as vm'
					}
				},
				params: {
					'_modelType': null,
					'_modelSubTypeId': null,
					'_companyId': null,
					'_modelPaginationDto': null,
					'_fields': []
				},
				data: {
					permissions: ['DUPLICATION_TOOL']
				}
			})
			.state('app.merge_tool', {
				//url: '/merge_tool',
				//url: '/merge_tool?_modelType?_modelSubTypeId?_modelsToMerge',
				url: '/merge_tool/:_modelType/:_modelSubTypeId/:_modelsToMerge',
				views: {
					'content@app': {
						templateUrl: 'app/main/duplication_tool/merge_tool/merge_tool.html',
						controller: 'MergeToolController as vm'
					}
				},
				data: {
					permissions: ['DUPLICATION_TOOL']
				}
				/*params : {
					'_modelType' : null,
					'_modelSubTypeId' : null,
					'_modelsToMerge' : []
				}*/
			})
			.state('app.junk_box', {
				url: '/junk_box',
				views: {
					'content@app': {
						templateUrl: 'app/main/duplication_tool/junk_box/junk_box.html',
						controller: 'JunkBoxController as vm'
					}
				},
				params: {},
				data: {
					permissions: ['JUNK_BOX']
				}
			})
			.state('app.junk_box.details', {
				url: '/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/duplication_tool/junk_box/details/junk_box_details.html',
						controller: 'JunkBoxDetailsController as vm'
					}
				},
				params: {},
				data: {
					permissions: ['JUNK_BOX']
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/duplication_tool');

		// Menu
		// Voir app/settings/settings.module.js

		$provide.decorator('$state', ['$delegate', '$window', function ($delegate, $window) {
			var extended = {
				goNewTab: function (stateName, params) {
					$window.open(
						$delegate.href(stateName, params, {
							absolute: true
						}), '_blank');
				}
			};
			angular.extend($delegate, extended);
			return $delegate;
		}]);

	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {

		// State
		$stateProvider
			.state('app.data_import', {
				url: '/data_import',
				views: {
					'content@app': {
						templateUrl: 'app/main/data_import/data_import.html',
						controller: 'DataImportController as vm'
					}
				},
				params: {},
				data: {
					permissions: ['DATA_IMPORT']
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/data_import');

	}

})();

(function () {
	'use strict';

	angular.module('app.front')
		.config(config);

	function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, $mdDateLocaleProvider) {
		$stateProvider
			.state('app.calendarExtern', {
				url: '/calendarExtern',
				views: {
					'content@app': {
						templateUrl: 'app/main/calendarExtern/calendarExtern.html',
						controller: 'CalendarExternController as vm'
					}
				}
			});
		$translatePartialLoaderProvider.addPart('app/main/calendarExtern');


		// msNavigationServiceProvider.saveItem('calendarExtern', {
		//   title: 'Agenda Externe',
		//   state: 'app.calendarExtern',
		//   translate: 'CALENDAR_EXTERN.TITLE',
		//   weight: 2
		// });

		// $mdDateLocaleProvider.formatDate = function(date) {
		//   return date ? moment(date).format('DD/MM/YYYY') : "";
		// };


	}
})();

(function () {
	'use strict';

	angular.module('app.front')
		.config(config);

	function config($stateProvider, $translatePartialLoaderProvider, $mdDateLocaleProvider) {
		$stateProvider
			.state('app.blog', {
				url: '/blog',
				views: {
					'content@app': {
						templateUrl: 'app/main/blog/blog.html',
						controller: 'BlogController as vm'
					}
				},
				data: {
					permissions: ['BLOG']
				}
			});
		$translatePartialLoaderProvider.addPart('app/main/blog');

		$stateProvider
			.state('app.blog.edit', {
				url: '/:lang/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/blog/add_blog.html',
						controller: 'addBlogCtrl as vm'
					}
				},
				data: {
					permissions: ['BLOG']
				}
			});
		$translatePartialLoaderProvider.addPart('app/main/blog');

		$stateProvider
			.state('app.tags', {
				url: '/tags',
				views: {
					'content@app': {
						templateUrl: 'app/main/blog/tags/tags.html',
						controller: 'TagsController as vm'
					}
				},
				data: {
					permissions: ['BLOG']
				}
			});
		$translatePartialLoaderProvider.addPart('app/main/blog');

		$stateProvider
			.state('app.banners', {
				url: '/banners',
				views: {
					'content@app': {
						templateUrl: 'app/main/blog/banners/banners.html',
						controller: 'BannersController as vm'
					}
				},
				data: {
					permissions: ['BLOG']
				}
			});
		$translatePartialLoaderProvider.addPart('app/main/blog');

		$stateProvider
			.state('app.banners.edit', {
				url: '/:lang/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/blog/banners/addBanner.html',
						controller: 'addBannerCtrl as vm'
					}
				},
				data: {
					permissions: ['BLOG']
				}
			});
		$translatePartialLoaderProvider.addPart('app/main/blog');

		$stateProvider
			.state('app.countries', {
				url: '/countries',
				views: {
					'content@app': {
						templateUrl: 'app/main/blog/countries/countries.html',
						controller: 'CountriesController as vm'
					}
				},
				data: {
					permissions: ['BLOG']
				}
			});
		$translatePartialLoaderProvider.addPart('app/main/blog');

		$stateProvider
			.state('app.regions', {
				url: '/regions',
				views: {
					'content@app': {
						templateUrl: 'app/main/blog/regions/regions.html',
						controller: 'RegionsController as vm'
					}
				},
				data: {
					permissions: ['BLOG']
				}
			});
		$translatePartialLoaderProvider.addPart('app/main/blog');

		// $mdDateLocaleProvider.formatDate = function(date) {
		//   return date ? moment(date).format('DD/MM/YYYY') : "";
		// };


	}
})();

(function () {
	'use strict';

	angular
		.module('app.front')
		.config(config);

	/** @ngInject */
	function config($stateProvider, $translatePartialLoaderProvider) {
		// State
		$stateProvider
			.state('app.usersLogs', {
				url: '/usersLogs',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin/usersLogs/usersLogs.html',
						controller: 'usersLogsController as vm'
					}
				},
				data: {
					permissions: ['USERS_LOGS']
				}
			}).state('app.messagesLogs', {
				url: '/messagesLogs',
				views: {
					'content@app': {
						templateUrl: 'app/main/admin/messagesLogs/messages_logs.html',
						controller: 'messagesLogsController as vm'
					}
				},
				data: {
					permissions: ['MESSAGES_LOGS']
				}
			});

		// Translation
		$translatePartialLoaderProvider.addPart('app/main/admin');
	}
})();

(function () {
	'use strict';

	angular.module('app.front').config(config);

	function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
		// State
		$stateProvider
			.state('app.users', {
				url: '/users',
				views: {
					'content@app': {
						templateUrl: 'app/main/access_rights/users/users.html',
						controller: 'usersController as vm'
					}
				},
				data: {
					permissions: ['USERS']
				}
			})
			.state('app.groups', {
				url: '/groups',
				views: {
					'content@app': {
						templateUrl: 'app/main/access_rights/groups/groups.html',
						controller: 'groupsController as vm'
					}
				},
				data: {
					permissions: ['GROUPS']
				}
			})
			.state('app.associations', {
				url: '/associations',
				views: {
					'content@app': {
						templateUrl: 'app/main/access_rights/associations/associations.html',
						controller: 'associationsController as vm'
					}
				},
				data: {
					permissions: ['ASSOCIATIONS']
				}
			})
			.state('app.association', {
				url: '/association/:id',
				views: {
					'content@app': {
						templateUrl: 'app/main/access_rights/associations/association.html',
						controller: 'associationController as vm'
					}
				},
				data: {
					permissions: ['ASSOCIATIONS']
				}
			});


		// Translation
		$translatePartialLoaderProvider.addPart('app/main/access_rights');

	}
})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/navigation/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" \nui-view=\"toolbar\" ng-if=\"false\"></md-toolbar><md-content id=\"content\" class=\"animate-fade-in md-hue-2\" \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-fade-in md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-fade-in md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-fade-in md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/blog/add_blog.html","<div id=\"top_blog_edit\" class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div ng-if=\"article.id\" translate=\"BLOG.CREATION.UPDATE\"></div><div ng-if=\"!article.id\" \ntranslate=\"BLOG.CREATION.ADD\"></div></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" \nng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"></div></div><div class=\"content\"><div \nclass=\"nl-Block\"><form name=\"formCreateArticle\" novalidate><div layout=\"row\"><md-input-container class=\"mb-0\"><label>\n{{\"BLOG.CREATION.NAME\"|translate}}</label><input ng-model=\"article.name\" name=\"articleName\" maxlength=\"255\" required \nautocomplete=\"name\"><div class=\"pl-20\" ng-messages=\"formCreateArticle.articleName.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container class=\"mb-0\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-hide-icons=\"calendar\" \nng-model=\"article.startDateForm\" name=\"articleStartDate\" md-placeholder=\"{{\'BLOG.CREATION.DATE\' | translate}} *\" \nmd-open-on-focus required=\"\"></md-datepicker><div class=\"pl-20\" \nng-messages=\"formCreateArticle.articleStartDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"ml-20\">\n<md-checkbox class=\"md-primary md-hue-2\" name=\"\" ng-model=\"article.active\" aria-label=\"publish\">\n{{\"BLOG.CREATION.ACTIVE\"|translate}}</md-checkbox></md-input-container><md-input-container class=\"ml-20\"><md-checkbox \nclass=\"md-primary md-hue-2\" name=\"\" ng-model=\"article.coupCoeur\" aria-label=\"favorite\">\n{{\"BLOG.CREATION.FAVORITE\"|translate}}</md-checkbox></md-input-container></div><md-input-container class=\"mb-0\"><label>\n{{\"BLOG.CREATION.SHORT_DESCRIPTION\"|translate}}</label><input ng-model=\"article.shortDescription\" \nname=\"shortDescription\" maxlength=\"255\" required autocomplete=\"name\"><div class=\"pl-20\" \nng-messages=\"formCreateArticle.shortDescription.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div class=\"nl_Trix nl_Trix--block\"><label \nclass=\"nl_Trix-label\" \nstyle=\"{{formCreateArticle.articleContent.$touched && formCreateArticle.articleContent.$invalid ? \'color:#D81313;\' : \'\'}}\">\n{{\"BLOG.CREATION.CONTENT\"|translate}}<label style=\"font-size:13px; vertical-align: top\">*</label></label>\n<ng-quill-editor id=\"editor_blog\" on-editor-created=\"onEditorCreated(editor)\" ng-model=\"article.content\" \nname=\"articleContent\" required></ng-quill-editor><div \nng-if=\"formCreateArticle.articleContent.$touched && formCreateArticle.articleContent.$invalid\" \nclass=\"ng-scope nl_form-error-input\"><span style=\"color:#D81313\">{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n<md-input-container flex=\"100\"><md-chips class=\"nl-chips nl-chips__floating\" ng-model=\"article.tags\" name=\"tags\" \nmd-on-add=\"addField($chip, article.tags)\"><md-autocomplete md-search-text=\"search.tag\" md-select-on-match=\"true\" \nmd-autoselect=\"true\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'TAGS.TITLE\' | translate}}\" \nmd-items=\"field in fieldsSelected(tags, article.tags) | filter: {name: search.tag}\" md-item-text=\"field.name\" \nmd-min-length=\"0\"><span>{{field.name}}</span></md-autocomplete><md-chip-template><span>{{$chip.name}}</span>\n</md-chip-template></md-chips></md-input-container><md-input-container flex=\"100\"><md-chips \nclass=\"nl-chips nl-chips__floating\" ng-model=\"article.countries\" name=\"pays\" \nmd-on-add=\"addField($chip, article.countries)\"><md-autocomplete md-search-text=\"search.country\" \nmd-select-on-match=\"true\" md-autoselect=\"true\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'TAGS.COUNTRIES\' | translate}}\" \nmd-items=\"field in fieldsSelected(countries, article.countries) | filter: {libelle: search.country}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"100\"><md-chips \nclass=\"nl-chips nl-chips__floating\" ng-model=\"article.regions\" name=\"region\" \nmd-on-add=\"addField($chip, article.regions)\"><md-autocomplete md-search-text=\"search.region\" md-select-on-match=\"true\" \nmd-autoselect=\"true\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'TAGS.REGIONS\' | translate}}\" \nmd-items=\"field in fieldsSelected(regions, article.regions) | filter: {libelle: search.region}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><div \nstyle=\"max-width: 50%; padding: 1.6rem; border: 1px solid #ebebeb\"><div layout=\"row\" layout-align=\"start center\">\n<md-input-container class=\"nl-Input-container\" flex><md-select class=\"\" ng-model=\"_newCompany\" name=\"companies\">\n<md-select-header><section><input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"_searchCompany\" ng-model-options=\"{ debounce: 500 }\"></section></md-select-header><md-option \nng-repeat=\"company in search.companies | orderBy: \'modelPattern\' track by company.id\" ng-value=\"company\">\n{{company.modelPattern}}</md-option></md-select><label class=\"\" translate=\"BLOG.COMPANY.COMPANIES\"></label>\n</md-input-container><md-button type=\"button\" \nclass=\"layout-row layout-align-center-center ml-25 md-raised md-primary md-button\" ng-if=\"_newCompany.id\" \nng-click=\"addCompany()\"><md-icon style=\"margin: 0 0 1px 0\" md-font-icon=\"icon-plus\"></md-icon>\n{{\"GENERAL.ADD\" | translate}}</md-button></div><div class=\"nl-Providers\" ng-if=\"article.id\"><h3 \nclass=\"nl-Providers__title\" translate=\"BLOG.COMPANY.TITLE\"></h3><div class=\"nl-Providers__item\" \nng-repeat=\"company in article.companies | orderBy: \'index\' track by company.index\" layout=\"row\"><div \nclass=\"nl-Providers__item__title layout-row layout-align-start-center\">{{company.company.modelPattern}}</div><div \nclass=\"layout-row layout-align-end-center\"><div ng-if=\"article.companies.length>1\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"!(company.index > 0)\" ng-click=\"up(company.id)\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"company.index === article.companies.length - 1 || articles.companies.length <= 1\" \nng-click=\"down(company.id)\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div><md-button \nclass=\"layout-row layout-align-start-center ml-25 md-raised md-warn md-hue-2\" ng-click=\"deleteCompany(company)\">\n<md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button></div></div>\n</div><div class=\"nl-Providers\" ng-if=\"!article.id\"><h3 class=\"nl-Providers__title\" translate=\"BLOG.COMPANY.TITLE\">\n</h3><div class=\"nl-Providers__item\" ng-repeat=\"company in companiesTmp | orderBy: \'modelPattern\' track by company.id\" \nlayout=\"row\"><div class=\"nl-Providers__item__title layout-row layout-align-start-center\">{{company.modelPattern}}</div>\n<md-button class=\"layout-row layout-align-end-center md-raised md-warn md-hue-2\" ng-click=\"deleteCompany(company)\">\n<md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button></div></div>\n</div><div class=\"mv-20\"><div layout=\"row\"><div class=\"m-5 nl-Form-dropify\" flex=\"25\" \nng-repeat=\"photo in article.photos | orderBy: \'index\' track by $index\" layout=\"column\" layout-align=\"start end\"><div \nclass=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify has--image\" ng-src=\"alternatedocroots/{{photo.location}}\">\n</div><div ng-if=\"photo.isMiniature\">{{\"BLOG.FIRST_PHOTO\" | translate}}</div><md-button ng-if=\"!photo.isMiniature\" \nclass=\"md-raised md-warn md-hue-2\" ng-click=\"setMiniature(photo,article)\">{{\"BLOG.SET_MINIATURE\" | translate}}\n</md-button><md-button class=\"md-raised md-warn md-hue-2\" ng-click=\"displayPopUpDeletePhoto(photo, $index)\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\"></md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button><div \nng-if=\"article.photos.length>1\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(photo.index > 0)\" ng-click=\"upPhoto(photo)\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"photo.index === article.photos.length - 1 || articles.photos.length <= 1\" ng-click=\"downPhoto(photo)\">\n<md-icon md-font-icon=\"icon-arrow-right\" class=\"s18\"></md-icon></md-button></div></div></div></div><div class=\"mv-20\">\n<md-button type=\"button\" class=\"md-raised md-primary md-hue-2\" ng-click=\"photos.push({})\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>{{\"BLOG.ADD_PHOTO\" | translate}}</md-button><div layout=\"row\"><div \nclass=\"m-5 nl-Form-dropify\" flex=\"25\" ng-repeat=\"photo in photos\" layout=\"column\" layout-align=\"start end\">\n<dropify-directive class=\"dropify-wrapper has--deleteBtn\" filesave=\"photo.uploadFile\" ng-model=\"photo.model\"><md-button\n class=\"md-raised md-warn md-hue-2\" ng-click=\"deletePhoto($index)\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div><md-button class=\"md-warn md-hue-2\" \nng-click=\"cancelArticleForm()\" aria-label=\"Annuler\" translate=\"GENERAL.CANCEL\"></md-button><md-button \nclass=\"md-primary md-raised md-hue-2\" ng-disabled=\"formCreateArticle.$invalid\" ng-click=\"saveArticle()\" \naria-label=\"Enregistrer\" translate=\"GENERAL.SAVE\"></md-button></div></form></div></div></div>");
$templateCache.put("app/main/blog/blog.html","<div id=\"top_blog\" class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"BLOG.TITLE\"></div></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-button class=\"md-accent md-hue-1 mr-15\" \ntype=\"button\" ng-click=\"showFormBlog()\"><md-icon md-font-icon=\"icon-plus\" class=\"s20\"></md-icon><span \ntranslate=\"BLOG.CREATION.ADD\"></span></md-button><md-input-container flex class=\"md-accent md-hue-1\"><md-select \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-button class=\"md-accent md-hue-1 mr-15\" type=\"button\" \nng-click=\"showFormBlog()\"><md-icon md-font-icon=\"icon-plus\" class=\"s20\"></md-icon><span translate=\"BLOG.CREATION.ADD\">\n</span></md-button><md-input-container flex class=\"md-accent md-hue-1\"><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><div class=\"nl-Block\"><div class=\"\"><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"simple list-view\"><thead><th>ID</th><th>{{\"BLOG.CREATION.NAME\" | translate}}</th><th>\n{{\"BLOG.CREATION.DATE\" | translate}}</th><th>{{\"BLOG.CREATION.ACTIVE\" | translate}}</th><th>\n{{\"BLOG.CREATION.FAVORITE\" | translate}}</th><th>{{\"BLOG.CREATION.SHORT_DESCRIPTION\" | translate}}</th><th>\n{{\"BLOG.ACTION\" | translate}}</th></thead><tbody><tr ng-repeat=\"article in articles as arrayData\"><td>{{article.id}}\n</td><td>{{article.name}}</td><td>{{getDate(article.dateStart) | date:\'dd/MM/yyyy\'}}</td><td><md-checkbox \nclass=\"md-primary md-hue-2\" readonly=\"readonly\" ng-model=\"article.active\" aria-label=\"publish\" \nng-click=\"setActive(article)\"></md-checkbox></td><td><md-checkbox class=\"md-primary md-hue-2\" readonly=\"readonly\" \nng-model=\"article.coupCoeur\" aria-label=\"favorite\" ng-click=\"setFavorite(article)\"></md-checkbox></td><td><div \nclass=\"ql-editor\" ng-bind-html=\"unsafe(article.shortDescription)\"></div></td><td><md-button md-no-ink \nng-click=\"updateArticle(article)\" class=\"md-raised md-primary md-hue-2\" aria-label=\"update\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button md-no-ink ng-click=\"removeArticle(article)\" \nclass=\"md-warn md-hue-2\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr></tbody></table>\n</div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div \nclass=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/calendarExtern/calendarExtern.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h1\"><span><md-icon\n md-font-icon=\"icon-city\" class=\"s24\"></md-icon></span><span translate=\"CALENDAR_EXTERN.TITLE_PAGE\"></span></div></div>\n</div></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><md-input-container \nclass=\"nl-Input-container\"><label></label><md-select ng-model=\"language.key\" class=\"nl-Input-select md-no-underline\" \naria-label=\"language\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div><div \nid=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" ng-class=\"vm.currentMonthKey\">\n<div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button\" ng-click=\"changeView(\'today\')\" aria-label=\"Today\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span>Aujourd\'hui</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button\" ng-click=\"changeView(\'agendaDay\')\" aria-label=\"Day\"><md-icon md-font-icon=\"icon-view-day\">\n</md-icon><md-tooltip><span>Jour</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"changeView(\'agendaWeek\')\" aria-label=\"Week\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip>\n<span>Semaine</span></md-tooltip></md-button><md-button class=\"md-icon-button\" ng-click=\"changeView(\'month\')\" \naria-label=\"Month\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span>Mois</span></md-tooltip>\n</md-button></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button arrow\" ng-click=\"prev()\" aria-label=\"Previous\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><md-button class=\"md-icon-button arrow\" ng-click=\"next()\" aria-label=\"Next\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div><md-button class=\"add-event-button md-fab md-warn\" \nng-click=\"addEvent($event)\" aria-label=\"Add event\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content\" id=\"calendar-view-wrapper\" \nstyle=\"max-height: calc(100vh - 325px);\n    min-height: 0;\n    overflow: auto\"><div id=\"calendarView\" \nclass=\"calendar_intervenant\" ui-calendar=\"calendarUiConfig.calendar\" ng-model=\"events\" calendar=\"myCalendar\"></div>\n</div></div></div></div>");
$templateCache.put("app/main/data_import/data_import.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"DATA_IMPORT.TITLE\"></div></div>\n</div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp p-10\"><form name=\"dataImportForm.fileForm\" \nclass=\"md-inline-form m-20\" novalidate><fieldset class=\"standard mt-20 mb-20\"><div layout=\"row\" layout-wrap \nclass=\"m-10 p-10\"><md-input-container class=\"nl-Input-container m-0 p-0\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.file}\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\n{{\"DATA_IMPORT.FILE_FIELD_LABEL\" | translate}}</label><input type=\"file\" name=\"file\" required \nid=\"data_import_input_file\" placeholder=\"\"><div ng-messages=\"error\" role=\"alert\"><div ng-message=\"file\"><span>\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></div></md-input-container><md-button type=\"button\" flex md-no-ink \nclass=\"\" ng-disabled=\"inProgress\" ng-click=\"onColumnsMatching();\"><md-icon md-font-icon=\"icon-view-column\"></md-icon>\n{{\'DATA_IMPORT.COLUMN_MATCHING_BTN\' | translate}}</md-button></div></fieldset><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" class=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\" \nng-if=\"inProgress\"><md-progress-circular class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></form><form name=\"dataImportForm.matchingForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"dataImportForm.matchingForm.$valid && importDataFn()\" \nng-if=\"_sheets.length > 0 && _importMode.value && _importMode.value === \'MATCHING_COLUMN\'\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"m-5 p-5\"><md-button type=\"submit\" flex md-no-ink class=\"md-primary\" \nng-disabled=\"inProgress\"><md-icon md-font-icon=\"icon-import\"></md-icon>{{\'DATA_IMPORT.IMPORT_DATA_BTN\' | translate}}\n</md-button></div><div ng-if=\"errorImport\" layout=\"row\" layout-align=\"center start\" style=\"color: rgb(236, 53, 53)\">\nImportation error: Line {{errorImportRows}}, Column {{errorImportColumns}}</div><div layout=\"row\" \nlayout-align=\"start center\" class=\"m-10 p-10\"><table class=\"dataTable row-border hover\" \nng-repeat=\"_sheet in _sheets | orderBy : \'sheetIndex\'\"><thead><tr><th width=\"25%\">{{\'DATA_IMPORT.COLUMN\' | translate}}\n</th><th width=\"15%\" style=\"text-align:center!important\">{{\'DATA_IMPORT.INCLUDE_IN_DUPLICATE_SEARCH\' | translate}}</th>\n<th width=\"25%\">{{ \'DATA_IMPORT.MODEL\' | translate }}</th><th width=\"35%\">{{ \'DATA_IMPORT.FIELD\' | translate }}</th>\n</tr></thead><tbody ng-repeat=\"_column in _sheet.columns | orderBy : \'columnIndex\'\"><tr><td width=\"25%\">\n{{_column.columnIndex}} - {{_column.columnName}}</td><td width=\"15%\" style=\"text-align:center!important\"><md-checkbox \nclass=\"md-primary md-hue-2 mb-0\" ng-model=\"_column.lookForDuplicate\" ng-disabled=\"overwriteData.value\"></md-checkbox>\n</td><td width=\"25%\"><md-input-container class=\"\"><md-select name=\"modelType{{$index}}\" ng-model=\"_column.modelType\" \nplaceholder=\"{{\'DUPLICATION_TOOL.SELECT_MODEL_TYPE\' | translate}}\" ng-required=\"_column.lookForDuplicate\" \nng-change=\"modelTypeSelectedFn(_column);\"><md-option ng-repeat=\"modelType in MODELS_TYPES track by $index\" \nng-value=\"modelType\">{{\'GENERAL.\' + modelType | translate}}</md-option></md-select><div class=\"\" \nng-messages=\"dataImportForm.matchingForm[\'modelType\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"_column.modelType && _column.modelType == MODELS_TYPES.COMPANY_MODEL\"><md-select \nname=\"modelSubTypeId{{$index}}}\" ng-model=\"_column.modelSubTypeId\" \nplaceholder=\"{{\'DUPLICATION_TOOL.SELECT_COMPANY_MODEL_TYPE\' | translate}}\" md-on-close=\"_searchSubType = \'\'\" \nng-change=\"modelSubTypeSelectedFn(_column);\" \nng-required=\"_column.modelType && _column.modelType == MODELS_TYPES.COMPANY_MODEL\"><md-select-header><section><input \nforce-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchSubType\"></section>\n</md-select-header><md-option \nng-repeat=\"modelSubType in modelSubTypes | filter : _searchSubType | orderBy : \'name\' track by $index\" \nng-value=\"modelSubType.id\">{{modelSubType.name}}</md-option></md-select><div class=\"\" \nng-messages=\"dataImportForm.matchingForm[\'modelSubTypeId\'+$index].$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></td><td width=\"35%\">\n<md-input-container class=\"\" \nng-if=\"!_column.modelType || (_column.modelType && _column.modelType != MODELS_TYPES.MEMBER)\"><md-select \nname=\"field{{$index}}\" ng-model=\"_column.fieldId\" placeholder=\"{{\'DATA_IMPORT.SELECT_FIELD\' | translate}}\" \nmd-on-close=\"_searchField = \'\'\" ng-required=\"_column.modelType && _column.modelType != MODELS_TYPES.MEMBER\" \nng-model-options=\"{trackBy: \'$value\'}\" \nng-disabled=\"!_column.modelType || (_column.modelType && _column.modelType == MODELS_TYPES.COMPANY_MODEL && !_column.modelSubTypeId)\">\n<md-select-header><section><input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"_searchField\"></section></md-select-header><md-option \nng-repeat=\"field in _column.fields | filter : _searchField | orderBy : \'libelle\' track by field.id\" \nng-value=\"field.id\">{{field.libelle}}</md-option></md-select><div class=\"\" \nng-messages=\"dataImportForm.matchingForm[\'field\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"_column.modelType && _column.modelType == MODELS_TYPES.MEMBER\"><md-select name=\"field{{$index}}\" \nng-model=\"_column.customValue\" placeholder=\"{{\'DATA_IMPORT.SELECT_FIELD\' | translate}}\" \nmd-on-close=\"_searchField = \'\'\" ng-required=\"_column.modelType && _column.modelType == MODELS_TYPES.MEMBER\" \nng-model-options=\"{trackBy: \'$value\'}\" ng-disabled=\"!_column.modelType\"><md-select-header><section><input \nforce-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField\"></section>\n</md-select-header><md-option \nng-repeat=\"field in MEMBER_FIELDS | filter : _searchField | orderBy : \'libelle\' track by $index\" \nng-value=\"field.value\">{{\'GENERAL.\' + field.value | translate}}</md-option></md-select><div class=\"\" \nng-messages=\"dataImportForm.matchingForm[\'field\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></td></tr></tbody><tbody><tr><td colspan=\"4\">\n<fieldset class=\"standard mt-20 mb-20\"><legend>{{\"DATA_IMPORT.ADD_MEMBER\" | translate}}</legend><div layout=\"row\" \nlayout-wrap class=\"m-10 p-10\"><md-input-container class=\"\"><md-select name=\"login{{$index}}\" \nng-model=\"_sheet.memberLoginColumnIndex\" placeholder=\"{{\'DATA_IMPORT.MEMBER_LOGIN_COLUMN\' | translate}}\" \nmd-on-close=\"_searchField = \'\'\" \nng-required=\"_sheet.memberPasswordColumnIndex || _sheet.memberNameColumnIndex || _sheet.memberMailColumnIndex\" \nng-model-options=\"{trackBy: \'$value\'}\" ng-disabled=\"false\"><md-select-header><section><input force-select-focus \ntype=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField\"></section></md-select-header>\n<md-option \nng-repeat=\"_column in _sheet.columns | filter : _searchField | orderBy : \'columnName\' track by _column.columnIndex\" \nng-value=\"_column.columnIndex\">{{_column.columnName}}</md-option></md-select><label>\n{{\'DATA_IMPORT.MEMBER_LOGIN_COLUMN\' | translate}}</label><div class=\"\" \nng-messages=\"dataImportForm.matchingForm[\'login\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\"><md-select \nname=\"password{{$index}}\" ng-model=\"_sheet.memberPasswordColumnIndex\" \nplaceholder=\"{{\'DATA_IMPORT.MEMBER_PASSWORD_COLUMN\' | translate}}\" md-on-close=\"_searchField = \'\'\" \nng-required=\"_sheet.memberLoginColumnIndex || _sheet.memberNameColumnIndex || _sheet.memberMailColumnIndex\" \nng-model-options=\"{trackBy: \'$value\'}\" ng-disabled=\"false\"><md-select-header><section><input force-select-focus \ntype=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField\"></section></md-select-header>\n<md-option \nng-repeat=\"_column in _sheet.columns | filter : _searchField | orderBy : \'columnName\' track by _column.columnIndex\" \nng-value=\"_column.columnIndex\">{{_column.columnName}}</md-option></md-select><label>\n{{\'DATA_IMPORT.MEMBER_PASSWORD_COLUMN\' | translate}}</label><div class=\"\" \nng-messages=\"dataImportForm.matchingForm[\'password\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\"><md-select \nname=\"name{{$index}}\" ng-model=\"_sheet.memberNameColumnIndex\" \nplaceholder=\"{{\'DATA_IMPORT.MEMBER_NAME_COLUMN\' | translate}}\" md-on-close=\"_searchField = \'\'\" \nng-model-options=\"{trackBy: \'$value\'}\" ng-disabled=\"false\"><md-select-header><section><input force-select-focus \ntype=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField\"></section></md-select-header>\n<md-option \nng-repeat=\"_column in _sheet.columns | filter : _searchField | orderBy : \'columnName\' track by _column.columnIndex\" \nng-value=\"_column.columnIndex\">{{_column.columnName}}</md-option></md-select><label>\n{{\'DATA_IMPORT.MEMBER_NAME_COLUMN\' | translate}}</label></md-input-container><md-input-container class=\"\"><md-select \nname=\"email{{$index}}\" ng-model=\"_sheet.memberMailColumnIndex\" \nplaceholder=\"{{\'DATA_IMPORT.MEMBER_MAIL_COLUMN\' | translate}}\" md-on-close=\"_searchField = \'\'\" \nng-model-options=\"{trackBy: \'$value\'}\" ng-disabled=\"false\"><md-select-header><section><input force-select-focus \ntype=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField\"></section></md-select-header>\n<md-option \nng-repeat=\"_column in _sheet.columns | filter : _searchField | orderBy : \'columnName\' track by _column.columnIndex\" \nng-value=\"_column.columnIndex\">{{_column.columnName}}</md-option></md-select><label>\n{{\'DATA_IMPORT.MEMBER_MAIL_COLUMN\' | translate}}</label></md-input-container></div></fieldset></td></tr></tbody>\n</table></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\" ng-if=\"inProgress\">\n<md-progress-circular class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\" class=\"m-5 p-5\">\n<md-checkbox class=\"md-primary md-hue-2 mb-0\" name=\"\" ng-model=\"overwriteData.value\" \nng-change=\"overwriteDataChanged()\" aria-label=\"overwrite data\">{{\'DATA_IMPORT.OVERWRITE_DATA\' | translate}}\n</md-checkbox><md-button type=\"submit\" flex md-no-ink class=\"md-primary\" ng-disabled=\"inProgress\"><md-icon \nmd-font-icon=\"icon-import\"></md-icon>{{\'DATA_IMPORT.IMPORT_DATA_BTN\' | translate}}</md-button></div><div \nng-if=\"errorImport\" layout=\"row\" layout-align=\"center start\" style=\"margin-left: 230px;color: rgb(236, 53, 53)\">\nImportation error: Line {{errorImportRows}}, Column {{errorImportColumns}}</div></form><form \nname=\"dataImportForm.duplicateModelsform\" class=\"md-inline-form m-20\" novalidate \nng-submit=\"dataImportForm.duplicateModelsform.$valid && submitImportDataResult()\" \nng-if=\"_dataImportResults.length>0 && _importMode.value && _importMode.value === \'MATCHING_COLUMN\'\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"m-5 p-5 bold\"><span flex class=\"\" style=\"text-align:center!important\"><u>\n{{\'DATA_IMPORT.IMPORT_RESULT_LIBELLE\' | translate}}</u></span></div><div class=\"\" \nng-repeat=\"_sheet in _dataImportResults\"><div layout=\"row\" layout-align=\"start center\" class=\"m-5 p-5\"><table \nclass=\"dataTable hover\"><tbody><tr><td><div>{{\'DATA_IMPORT.TOTAL_ROWS\' | translate}} : {{ _sheet.totalRows }}</div>\n<div>{{\'DATA_IMPORT.ROW_IMPORTED_SUCCESSFULLY\' | translate}} : {{ _sheet.importedRows }}</div><div>\n{{\'DATA_IMPORT.DUPLICATE_ROWS_DB_MATCHING\' | translate}} : {{ _sheet.duplicateFromBdd }}</div></td></tr></tbody>\n</table></div><div class=\"m-5 p-5\" ng-if=\"_sheet.duplicateFromBdd > 0\"><div layout=\"row\" layout-align=\"start center\">\n<table class=\"dataTable hover\" width=\"100%\" style=\"border-top: none!important\"><thead><tr><th width=\"10%\">\n{{\'DATA_IMPORT.ROW\' | translate}}</th><th width=\"15%\">{{\'DATA_IMPORT.MODEL\' | translate}}</th><th width=\"15%\" \nstyle=\"text-align:center!important\">{{\'DATA_IMPORT.IS_A_DUPLICATE_ROW\' | translate}}</th><th width=\"20%\" \nstyle=\"padding-left:12px!important\">{{ \'DATA_IMPORT.FIELD\' | translate }}</th><th width=\"20%\">\n{{ \'DATA_IMPORT.DUPLICATE_ROW_DB_VALUE\' | translate }}</th><th width=\"20%\">\n{{ \'DATA_IMPORT.DUPLICATE_ROW_FILE_VALUE\' | translate }}</th></tr></thead></table></div><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"_rows in _sheet.rows\"><table class=\"dataTable hover\" width=\"100%\"><tbody \nng-repeat=\"_row in _rows | orderBy : \'rowIndex\'\" \nng-if=\"_row.modelType === \'COMPANY_MODEL\' ||\n                                        (_row.modelType === \'CONTACT_MODEL\' && _row.duplicateIds.length>0)\">\n<tr><td width=\"10%\">{{\'DATA_IMPORT.ROW\' | translate}} - {{ _row.rowIndex }}</td><td width=\"15%\" \nstyle=\"border-bottom: 1px dotted #dddddd!important\">{{_row.modelType}}</td><td width=\"15%\" \nstyle=\"text-align:center!important;border-bottom: 1px dotted #dddddd!important\"><md-checkbox \nng-model=\"_row.isADuplicate\" ng-change=\"_rowIsADuplicateFn(_row, _rows);\" \nng-disabled=\"_row.modelType === \'CONTACT_MODEL\' && !_row.companyIsADuplicate\"></md-checkbox></td><td width=\"60%\" \nstyle=\"border-bottom: 1px dotted #dddddd!important\"><table width=\"100%\"><tr \nng-repeat=\"_valuedField in _row.valuedFields | orderBy : \'fieldLibelle\'\" style=\"background-color: inherit!important\" \nng-init=\"_valuedField.lookingForDuplicate ? _valuedField.noModelSelected = false :  _valuedField.noModelSelected = true;\">\n<td width=\"30%\" style=\"padding-left:0px!important\">{{ _valuedField.dataFromDb.fieldLibelle }} <span \nng-if=\"_valuedField.noModelSelected && _row.isADuplicate\" style=\"color:red\">*</span></td><td width=\"30%\" \nstyle=\"padding-left:8px!important\"><md-checkbox ng-model=\"_valuedField.dataFromDb.selected\" ng-if=\"_row.isADuplicate\" \nstyle=\"margin-top: 0px!important;margin-bottom: 0px!important\" \nng-change=\"_modelFieldSelectedFn(_sheet, _row, _valuedField, _valuedField.dataFromDb, _valuedField.dataFromFile)\">\n</md-checkbox><span ng-if=\"_valuedField.dataFromDb.fieldType == \'BOOLEAN\'\"><span \nng-if=\"_valuedField.dataFromDb.valuedFieldValue && _valuedField.dataFromDb.valuedFieldValue == \'true\'\"><span \ntranslate=\"DUPLICATION_TOOL.MERGE.FIELD_VALUE.BOOLEAN.YES\"></span> </span><span \nng-if=\"!_valuedField.dataFromDb.value || (_valuedField.dataFromDb.value && _valuedField.dataFromDb.valuedFieldValue != \'true\')\">\n<span translate=\"DUPLICATION_TOOL.MERGE.FIELD_VALUE.BOOLEAN.NO\"></span> </span></span><span \nng-if=\"_valuedField.dataFromDb.fieldType != \'BOOLEAN\'\"><span \nng-if=\"_valuedField.dataFromDb.fieldType == \'MULTIPLE_SELECT\'\"><span \nng-repeat=\"_value in _valuedField.dataFromDb.valuedFieldValues\">{{ _value.libelle }} <span ng-if=\"!$last\">, </span>\n</span></span><span ng-if=\"_valuedField.dataFromDb.fieldType != \'MULTIPLE_SELECT\'\">\n{{ _valuedField.dataFromDb.valuedFieldValue }}</span></span></td><td width=\"30%\" style=\"padding-left:20px!important\">\n<md-checkbox ng-model=\"_valuedField.dataFromFile.selected\" ng-if=\"_row.isADuplicate\" \nstyle=\"margin-top: 0px!important;margin-bottom: 0px!important\" \nng-change=\"_modelFieldSelectedFn(_sheet, _row, _valuedField, _valuedField.dataFromFile, _valuedField.dataFromDb)\">\n</md-checkbox><span ng-if=\"_valuedField.dataFromFile.fieldType == \'BOOLEAN\'\"><span \nng-if=\"_valuedField.dataFromFile.valuedFieldValue && _valuedField.dataFromFile.valuedFieldValue == \'true\'\"><span \ntranslate=\"DUPLICATION_TOOL.MERGE.FIELD_VALUE.BOOLEAN.YES\"></span> </span><span \nng-if=\"!_valuedField.dataFromFile.value || (_valuedField.dataFromFile.value && _valuedField.dataFromFile.valuedFieldValue != \'true\')\">\n<span translate=\"DUPLICATION_TOOL.MERGE.FIELD_VALUE.BOOLEAN.NO\"></span> </span></span><span \nng-if=\"_valuedField.dataFromFile.fieldType != \'BOOLEAN\'\"><span \nng-if=\"_valuedField.dataFromFile.fieldType == \'MULTIPLE_SELECT\'\"><span \nng-repeat=\"_value in _valuedField.dataFromFile.valuedFieldValues\">{{ _value.libelle }} <span ng-if=\"!$last\">, </span>\n</span></span><span ng-if=\"_valuedField.dataFromFile.fieldType != \'MULTIPLE_SELECT\'\">\n{{ _valuedField.dataFromFile.valuedFieldValue }}</span></span></td></tr></table></td></tr></tbody></table></div><div \nlayout=\"row\" layout-align=\"start center\" class=\"m-5 p-5\"><md-button type=\"submit\" flex md-no-ink class=\"md-primary\" \nng-disabled=\"inProgress\"><md-icon md-font-icon=\"icon-import\"></md-icon>\n{{\'DATA_IMPORT.IMPORT_RESULT_DUPLICATE_BTN\' | translate}}</md-button></div></div></div></form><form \nname=\"dataImportForm.updatingDataForm\" class=\"md-inline-form m-20\" novalidate \nng-submit=\"dataImportForm.updatingDataForm.$valid && onUpdatingDataSubmit()\" \nng-if=\"_importMode.value && _importMode.value === \'UPDATING_DATA\'\"><div ng-if=\"_dataImportResults.length===0\"><div \nlayout=\"row\" layout-align=\"start center\" class=\"\"><md-input-container class=\"\"><md-select name=\"updatingDataLanguage\" \nng-model=\"language.key\" placeholder=\"{{\'DATA_IMPORT.COLUMN_NAMES_LANGUAGE\' | translate}}\" required><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select><label>{{\'DATA_IMPORT.COLUMN_NAMES_LANGUAGE\' | translate}}</label><div class=\"\" \nng-messages=\"dataImportForm.updatingDataForm.updatingDataLanguage.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\" class=\"\"><md-button type=\"submit\" flex md-no-ink class=\"md-primary\" \nng-disabled=\"inProgress\"><md-icon md-font-icon=\"icon-chevron-double-right\"></md-icon>\n{{\'DATA_IMPORT.UPDATE_DATA_SUBMIT_BTN\' | translate}}<md-icon md-font-icon=\"icon-chevron-double-left\"></md-icon>\n</md-button></div></div><div ng-if=\"_dataImportResults.length>0\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"m-5 p-5 bold\"><span flex class=\"\" style=\"text-align:center!important\"><u>\n{{\'DATA_IMPORT.UPDATING_RESULT_LIBELLE\' | translate}}</u></span></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"m-5 p-5\"><table class=\"dataTable hover\"><tbody><tr><td><div>\n{{\'DATA_IMPORT.TOTAL_ROWS\' | translate}} : {{ _sheet.totalRows }}</div><div>\n{{\'DATA_IMPORT.ROW_IMPORTED_SUCCESSFULLY\' | translate}} : {{ _sheet.importedRows }}</div><div>\n{{\'DATA_IMPORT.DUPLICATE_ROWS_DB_MATCHING\' | translate}} : {{ _sheet.duplicateFromBdd }}</div></td></tr></tbody>\n</table></div></div></form></div></div></div>");
$templateCache.put("app/main/duplication_tool/duplication_tool.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"DUPLICATION_TOOL.TITLE\"></div>\n</div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><form name=\"duplicationToolForm.form\" \nclass=\"md-inline-form\" novalidate><div layout=\"row\" layout-wrap class=\"m-20 p-20\" \nng-if=\"!progress.initDataInProgress.value\"><md-input-container class=\"\"><md-select name=\"modelType\" \nng-model=\"duplicationToolDto.modelType\" placeholder=\"{{\'DUPLICATION_TOOL.SELECT_MODEL_TYPE\' | translate}}\" \nng-change=\"modelTypeSelectedFn();\" required><md-option ng-repeat=\"modelType in MODELS_TYPES track by $index\" \nng-value=\"modelType\">{{\'GENERAL.\' + modelType | translate}}</md-option></md-select><label>\n{{\'DUPLICATION_TOOL.LABEL_MODEL\' | translate}}</label><div class=\"\" \nng-messages=\"duplicationToolForm.form.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.COMPANY_MODEL\"><md-select \nname=\"modelSubTypeId\" ng-model=\"duplicationToolDto.modelSubTypeId\" \nplaceholder=\"{{\'DUPLICATION_TOOL.SELECT_COMPANY_MODEL_TYPE\' | translate}}\" md-on-close=\"_searchSubType = \'\'\" \nng-change=\"modelSubTypeSelectedFn();\" ng-model-options=\"{trackBy: \'$value\'}\" \nng-required=\"duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.COMPANY_MODEL\">\n<md-select-header><section><input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"_searchSubType\"></section></md-select-header><md-option ng-value=\"-1\">\n{{\'DUPLICATION_TOOL.ALL_COMPANY_TYPES\' | translate}}</md-option><md-option \nng-repeat=\"modelSubType in modelSubTypes | filter : _searchSubType | orderBy : \'name\' track by $index\" \nng-value=\"{{modelSubType.id}}\">{{modelSubType.name}}</md-option></md-select><label>\n{{\'DUPLICATION_TOOL.LABEL_COMPANY_TYPE\' | translate}}</label><div class=\"\" \nng-messages=\"duplicationToolForm.form.modelSubTypeId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"(duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.CONTACT_MODEL) ||\n                            (duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.COMPANY_MODEL && duplicationToolDto.companyId)\">\n<md-select name=\"companyId\" ng-model=\"duplicationToolDto.companyId\" \nplaceholder=\"{{\'DUPLICATION_TOOL.SELECT_COMPANY_FOR_CONTACT_DUPLICATES_SEARCH\' | translate}}\" \nmd-on-close=\"search.company = \'\'\" ng-model-options=\"{trackBy: \'$value\'}\"><md-select-header><section><input \nforce-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"search.company\" \nng-change=\"searchCompany()\"></section></md-select-header><md-option \nng-repeat=\"_company in _companies | orderBy : \'modelPattern\' track by $index\" ng-value=\"{{_company.id}}\">\n{{_company.modelPattern}}</md-option></md-select><label>{{\'DUPLICATION_TOOL.LABEL_COMPANY\' | translate}}</label>\n</md-input-container><md-input-container class=\"\" \nng-if=\"(duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.COMPANY_MODEL && duplicationToolDto.modelSubTypeId) ||\n                            (duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.CONTACT_MODEL)\" \nng-if=\"!progress.fieldsListInProgress.value\"><md-select name=\"fields\" multiple=\"multiple\" \nng-model=\"duplicationToolDto.fields\" placeholder=\"{{\'DUPLICATION_TOOL.SELECT_FIELD\' | translate}}\" \nmd-on-close=\"_searchField = \'\'\" required ng-model-options=\"{trackBy: \'$value.id\'}\"><md-select-header><section><input \nforce-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField\"></section>\n</md-select-header><md-option \nng-repeat=\"field in fields | filter : _searchField | orderBy : \'libelle\' track by field.id\" ng-value=\"field\">\n{{field.libelle}}</md-option></md-select><label \nng-if=\"duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.COMPANY_MODEL\">\n{{\'DUPLICATION_TOOL.LABEL_COMPANY_FIELDS\' | translate}}</label><label \nng-if=\"duplicationToolDto.modelType && duplicationToolDto.modelType == MODELS_TYPES.CONTACT_MODEL\">\n{{\'DUPLICATION_TOOL.LABEL_CONTACT_FIELDS\' | translate}}</label><div class=\"\" \nng-messages=\"duplicationToolForm.form.fields.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" class=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\" \nng-if=\"progress.inProgress.value || progress.fieldsListInProgress.value || progress.initDataInProgress.value\">\n<md-progress-circular class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\" class=\"m-20 p-20\">\n<md-button flex md-no-ink class=\"md-primary\" \nng-disabled=\"progress.inProgress.value || progress.fieldsListInProgress.value || progress.initDataInProgress.value\" \nng-click=\"lookForDuplicatesFn();\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon>\n{{\'DUPLICATION_TOOL.FIND_DUPLICACTE_BTN\' | translate}}</md-button></div></form></div></div><div class=\"content\" \nng-if=\"duplicatesEntityDto && duplicatesEntityDto.dto\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" \nlayout-wrap class=\"m-20 p-20\"><table class=\"dataTable row-border hover\" ng-if=\"duplicatesEntityDto.dto.length != 0\">\n<thead><tr><th>{{ \'DUPLICATION_TOOL.FIELD_LIBELLE\' | translate }}</th><th>\n{{ \'DUPLICATION_TOOL.FIELD_VALUE\' | translate }}</th><th></th></tr></thead><tbody \nng-repeat=\"dto in duplicatesEntityDto.dto\"><tr ng-repeat=\"valuedField in dto.valuedFields | orderBy : \'fieldLibelle\'\">\n<td>{{ valuedField.fieldLibelle }}</td><td><span ng-if=\"valuedField.fieldType != \'MULTIPLE_SELECT\'\">\n{{ valuedField.valuedFieldValue }}</span> <span ng-if=\"valuedField.fieldType == \'MULTIPLE_SELECT\'\"><div \nng-repeat=\"_valuedFieldValue in valuedField.valuedFieldValues  | orderBy : \'libelle\'\">- {{_valuedFieldValue.libelle}}\n</div></span></td></tr><tr><td></td><td></td><td><span ng-if=\"dto.duplicateIds.length == 0\" \ntranslate=\"DUPLICATION_TOOL.ANY_OCCURENCE_FOUND\"></span>\n ({{ dto.duplicateIds.length }} {{ \'DUPLICATION_TOOL.OCCURENCES_FOUND\' | translate }})<md-button flex md-no-ink \nclass=\"md-primary\" ng-click=\"removeDuplicatesFn(dto.duplicateIds);\"><md-icon md-font-icon=\"icon-table-column-remove\">\n</md-icon>{{\'DUPLICATION_TOOL.REMOVE_DUPLICACTE_BTN\' | translate}}</md-button></td></tr></tbody></table><table \nclass=\"dataTable row-border hover\" ng-if=\"duplicatesEntityDto.dto.length == 0\"><tbody><tr><td><span \ntranslate=\"DUPLICATION_TOOL.ANY_OCCURENCE_FOUND\"></span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/events/events.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"EVENT.TITLE\"></div></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"goAdd()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\"GENERAL.ADD\" | translate}}\n</md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"goToSubCategories()\" \npermissions=\"[\'EVENTS_SUB_CAT\']\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n{{\'INSCRIPTION_SUB_CATEGORY.TITLE\' | translate}}</md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"goToLogisticalStatus()\" permissions=\"[\'EVENTS_LOGISTICAL_STATUS\']\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon>{{\'LOGISTICAL_STATUS.TITLE\' | translate}}</md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"goToInscriptionStatus()\" permissions=\"[\'EVENTS_REGISTRATION_STATUS\']\"><md-icon md-font-icon=\"icon-pencil\">\n</md-icon>{{\'INSCRIPTION_STATUS.TITLE\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" \nclass=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div \nclass=\"nl-FixedRightBar-panel\"><div layout=\"column\" layout-align=\"start start\"><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"goToSubCategories()\" permissions=\"[\'EVENTS_SUB_CAT\']\"><md-icon \nmd-font-icon=\"icon-pencil\"></md-icon>{{\'INSCRIPTION_SUB_CATEGORY.TITLE\' | translate}}</md-button><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"goToLogisticalStatus()\" permissions=\"[\'EVENTS_LOGISTICAL_STATUS\']\">\n<md-icon md-font-icon=\"icon-pencil\"></md-icon>{{\'LOGISTICAL_STATUS.TITLE\' | translate}}</md-button><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"goToInscriptionStatus()\" \npermissions=\"[\'EVENTS_REGISTRATION_STATUS\']\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n{{\'INSCRIPTION_STATUS.TITLE\' | translate}}</md-button></div></div></div><div class=\"content\"><div \nclass=\"nl-Block nl-Block--table\"><div class=\"nl-listing\"><table \nclass=\"simple list-view nl-Table nl-Table--makeResponsive nl-Table--events\"><thead><th>\n{{\"EVENT.COLUMNS.LOGO\" | translate}}</th><th>{{\"EVENT.COLUMNS.NAME\" | translate}}</th><th>\n{{\"EVENT.COLUMNS.START\" | translate}}</th><th>{{\"EVENT.COLUMNS.END\" | translate}}</th><th>\n{{\"EVENT.COLUMNS.SITE\" | translate}}</th><th>{{\"EVENT.COLUMNS.ACTIONS\" | translate}}</th></thead><tbody><tr \nng-repeat=\"event in events | orderBy: \'name\' track by event.id\" \nng-if=\"currentUser.allEvents || currentUser.eventIds.lastIndexOf(event.id) > -1\"><td class=\"type\" show-gt-sm><a \nhref=\"{{URL.alternatedocroots + \'/\' + event.logo}}\" target=\"_blank\" ng-if=\"event.logo != null\"><img \nng-src=\"{{URL.alternatedocroots + \'/\' + event.logo}}\" style=\"max-height: 80px;max-width: 200px\"></a></td><td>\n{{event.name}}</td><td>{{\'GENERAL.DATE_FORMAT\' | translate : {date: getDate(event.start)} }}</td><td>\n{{\'GENERAL.DATE_FORMAT\' | translate : {date: getDate(event.end)} }}</td><td>{{event.site.name}}</td><td><md-button \nmd-no-ink ng-click=\"seeInscriptionForms(event)\" class=\"md-primary md-raised md-hue-2\" \naria-label=\"See inscription forms\" permissions=\"[\'EVENTS_SEE_REGISTRATION_FORMS\']\">\n{{\"EVENT.SEE_INSCRIPTION_FORMS\" | translate}}</md-button><md-button md-no-ink ng-click=\"seeInscriptionFields(event)\" \nclass=\"md-primary md-raised md-hue-2\" aria-label=\"See fields\" permissions=\"[\'EVENTS_SEE_REGISTRATION_FIELDS\']\">\n{{\"EVENT.SEE_INSCRIPTION_FIELDS\" | translate}}</md-button><md-button md-no-ink ng-click=\"seeLogisticalFields(event)\" \nclass=\"md-primary md-raised md-hue-2\" aria-label=\"See fields\" permissions=\"[\'EVENTS_SEE_LOGISTIC_FIELDS\']\">\n{{\"EVENT.SEE_LOGISTICAL_FIELDS\" | translate}}</md-button><md-button md-no-ink ng-click=\"update(event)\" \nclass=\"md-primary md-raised md-hue-2\" aria-label=\"Supprimer\" permissions=\"[\'EVENTS_UPDATE\']\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button md-no-ink ng-click=\"showPopUpDelete(event, $index)\" \nclass=\"md-warn md-hue-2\" aria-label=\"Supprimer\" permissions=\"[\'EVENTS_DELETE\']\">{{\"GENERAL.DELETE\" | translate}}\n</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/festival/festival.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"FESTIVAL.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-input-container flex><md-select \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><div class=\"nl-Block\"><md-button md-no-ink class=\"md-raised md-primary md-hue-2\" type=\"button\" \nng-click=\"showFormFestival()\" id=\"formFestival\">{{\"FESTIVAL.CREATION.ADD\" | translate}}</md-button></div><div \nclass=\"nl-Block mt-30\" ng-if=\"showForm\"><form name=\"formCreateFestival\" class=\"nl-Form-xs\" novalidate>\n<md-input-container><label>{{\"FESTIVAL.CREATION.NAME\"|translate}}</label><input ng-model=\"festival.name\" \nname=\"festivalName\" maxlength=\"255\" required autocomplete=\"name\"><div class=\"pl-5\" \nng-messages=\"formCreateFestival.festivalName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" ng-model=\"festival.startDateForm\" name=\"festivalStartDate\" \nmd-placeholder=\"{{\'FESTIVAL.CREATION.DATE_START\' | translate}}\" md-open-on-focus md-hide-icons=\"calendar\">\n</md-datepicker></md-input-container><md-input-container><label>{{\'FESTIVAL.CREATION.TIME_START\' | translate}} hh:mm\n</label><input type=\"text\" class=\"input-value\" name=\"festivalStartTime\" ng-model=\"festival.startTime\" \nui-time-mask=\"short\"><div class=\"pl-5\" ng-messages=\"formCreateFestival.festivalStartTime.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"time\"><span>{{\"GENERAL.FORM.INVALID_FORMAT\" | translate}} (hh:mm)</span></div>\n</div><div ng-if=\"timeNotMatch\" class=\"ng-scope nl_form-error-input\"><span>{{\"FESTIVAL.TIME_ERROR\" | translate}}</span>\n</div></md-input-container><md-input-container><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" \nng-model=\"festival.endDateForm\" name=\"festivalEndDate\" md-placeholder=\"{{\'FESTIVAL.CREATION.DATE_END\' | translate}}\" \nmd-min-date=\"festival.startDateForm\" md-open-on-focus md-hide-icons=\"calendar\"></md-datepicker></md-input-container>\n<md-input-container><label>{{\'FESTIVAL.CREATION.TIME_END\' | translate}} hh:mm</label><input type=\"text\" \nclass=\"input-value\" name=\"festivalEndTime\" ng-model=\"festival.endTime\" ui-time-mask=\"short\"><div class=\"pl-5\" \nng-messages=\"formCreateFestival.festivalEndTime.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"time\"><span>\n{{\"GENERAL.FORM.INVALID_FORMAT\" | translate}} (hh:mm)</span></div></div><div ng-if=\"timeNotMatch\" \nclass=\"ng-scope nl_form-error-input\"><span>{{\"FESTIVAL.TIME_ERROR\" | translate}}</span></div></md-input-container><div \nclass=\"nl_Trix\"><label class=\"nl_Trix-label\">{{\"FESTIVAL.CREATION.DESCRIPTION\"|translate}}</label><ng-quill-editor \nng-model=\"festival.description\" name=\"festivalDescription\"></ng-quill-editor><div \nng-if=\"formCreateFestival.festivalDescription.$touched && formCreateFestival.festivalDescription.$invalid\" \nclass=\"ng-scope nl_form-error-input\"><span style=\"color:#D81313\">{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n<md-input-container><label>{{\"FESTIVAL.CREATION.ADDRESS\"|translate}}</label><input ng-model=\"festival.address\" \nname=\"festivalAddress\" required><div class=\"pl-5\" ng-messages=\"formCreateFestival.festivalAddress.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container><label>{{\"FESTIVAL.CREATION.COUNTRY\"|translate}}</label><input ng-model=\"festival.country\" \nname=\"festivalCountry\" required><div class=\"pl-5\" ng-messages=\"formCreateFestival.festivalCountry.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container><label>{{\"FESTIVAL.CREATION.WEBSITE\"|translate}}</label><input ng-model=\"festival.website\" \nname=\"festivalWebsite\" required><div class=\"pl-5\" ng-messages=\"formCreateFestival.festivalWebsite.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container ng-if=\"userService.isUserAdmin() || userService.isUserLinkedToAssociations()\"><md-checkbox name=\"\" \nclass=\"md-primary\" ng-model=\"festival.publish\" aria-label=\"publish\">{{\"FESTIVAL.CREATION.PUBLISH\"|translate}}\n</md-checkbox></md-input-container><div class=\"mv-20\"><div layout=\"row\" layout-wrap><div class=\"m-5 nl-Form-dropify\" \nflex=\"15\" ng-repeat=\"photo in festival.photos track by $index\" layout=\"column\" layout-align=\"start end\"><div \nclass=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify has--image\" ng-src=\"alternatedocroots/{{photo.location}}\">\n</div><md-button class=\"md-raised md-warn md-hue-2\" ng-click=\"displayPopUpDeletePhoto(photo, $index)\"><md-icon \nmd-font-icon=\"icon-close-circle-outline\"></md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div \nclass=\"mv-20\"><md-button type=\"button\" class=\"md-raised md-primary md-hue-2\" ng-click=\"photos.push({})\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>{{\"FESTIVAL.ADD_PHOTO\" | translate}}</md-button><div layout=\"row\" layout-wrap><div \nclass=\"m-5 nl-Form-dropify\" flex=\"nogrow\" ng-repeat=\"photo in photos\" layout=\"column\" layout-align=\"start end\">\n<dropify-directive class=\"dropify-wrapper has--deleteBtn\" filesave=\"photo.uploadFile\" ng-model=\"photo.model\"><md-button\n class=\"md-raised md-warn md-hue-2\" ng-click=\"deletePhoto($index)\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div><md-button \nclass=\"md-raised md-primary md-hue-2\" aria-label=\"Enregistrer\" ng-disabled=\"formCreateFestival.$invalid\" \nng-click=\"saveFestival()\">{{\"GENERAL.SAVE\" | translate}}</md-button><md-button class=\"md-warn md-hue-2\" \naria-label=\"Annuler\" ng-click=\"cancelFestivalForm()\">{{\"GENERAL.CANCEL\" | translate}}</md-button></div></form></div>\n<div class=\"nl-Block mt-30\"><div><table nl-responsive-table nl-table-data=\"arrayData\" class=\"simple list-view\"><thead>\n<th>{{\"FESTIVAL.CREATION.NAME\" | translate}}</th><th>\n{{\"FESTIVAL.CREATION.DATE_START\" | translate}} - {{\"FESTIVAL.CREATION.DATE_END\" | translate}}</th><th>\n{{\"FESTIVAL.CREATION.PLACE\" | translate}}</th><th>{{\"FESTIVAL.CREATION.PUBLISH\" | translate}}</th><th>\n{{\"FESTIVAL.ACTION\" | translate}}</th></thead><tbody><tr \nng-repeat=\"festival in festivals | orderBy : \'name\' as arrayData\"><td>{{festival.name}}</td><td>\n{{getDate(festival.dateStart) | date:\'dd/MM/yyyy HH:mm\'}} <span \nng-if=\"festival.dateStart != null && festival.dateEnd != null\">- </span>\n{{getDate(festival.dateEnd) | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{festival.address+\' \'+festival.country}}</td><td>\n<md-checkbox readonly=\"readonly\" disabled=\"disabled\" ng-model=\"festival.publish\" aria-label=\"publish\"></md-checkbox>\n</td><td><md-button ng-click=\"updateFestival(festival)\" \nclass=\"nl-listing-item-button md-primary md-raised md-hue-2 md-teal-theme-theme\" aria-label=\"Supprimer\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button ng-click=\"removeFestival(festival)\" \nclass=\"nl-listing-item-button md-warn\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr>\n</tbody></table></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/gallery/addGallery.popup.html","<md-dialog class=\"nl_Dialog\" aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\" ng-if=\"updateMode\">{{\"GALLERY.POPUP.TITLE_UPDATE\" | translate}}</div><div class=\"contact-name\" \nng-if=\"!updateMode\">{{\"GALLERY.POPUP.TITLE_ADD\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Popup-content-body\"><form name=\"addGalleryForm\"><md-input-container>\n<label>{{\"GALLERY.TITLE\" | translate}}</label><input type=\"text\" class=\"\" ng-model=\"gallery.title\" name=\"title\" \nrequired maxlength=\"255\"></md-input-container><md-button md-no-ink class=\"md-raised md-primary\" \nng-disabled=\"addGalleryForm.$invalid\" ng-click=\"addGallery()\">{{\"GENERAL.SAVE\" | translate }}</md-button><md-button \nmd-no-ink class=\"md-accent md-hue-2\" aria-label=\"Annuler\" ng-click=\"hidePopup()\">{{\"GENERAL.CANCEL\" | translate }}\n</md-button></form></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gallery/gallery.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"GALLERY.TITLE_PAGE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"showPopUAdd()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\"GALLERY.ADD\" | translate}}</md-button><div><md-input-container flex><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><div class=\"nl-Block mt-30\"><div><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"simple list-view\"><thead><th>{{\"GALLERY.TITLE\" | translate}}</th><th>{{\"GALLERY.UUID\" | translate}}</th><th>\n{{\"GALLERY.ACTION\" | translate}}</th></thead><tbody><tr ng-repeat=\"gallery in galleries as arrayData\" \nng-if=\"galleries.length > 0\"><td>{{gallery.title}}</td><td>{{gallery.uuid}}</td><td><md-button \nng-click=\"showPopUAdd(gallery, $index)\" \nclass=\"nl-listing-item-button md-primary md-raised md-hue-2 md-teal-theme-theme\" aria-label=\"Supprimer\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button ng-click=\"goDetails(gallery)\" \nclass=\"nl-listing-item-button md-primary md-raised md-hue-2 md-teal-theme-theme\" aria-label=\"Supprimer\">\n{{\"GENERAL.DETAILS\" | translate}}</md-button><md-button ng-click=\"showPopUpRemove(gallery, $index)\" \nclass=\"nl-listing-item-button md-warn\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr><tr\n ng-if=\"galleries.length === 0\"><td colspan=\"3\" layout=\"center center\">{{\"GALLERY.NO_GALLERY\" | translate}}</td></tr>\n</tbody></table></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/gallery/removeGallery.popup.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\"GALLERY.POPUP.DELETE_TITLE\" | translate}}\n</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"nl-Popup-content-body\"><div class=\"nl-Popup-content-body-title\">{{\"GALLERY.POPUP.CONFIRM_DELETE\" | translate}}\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-primary md-raised md-hue-2\" \nng-click=\"removeGallery()\" translate=\"GENERAL.YES\"></md-button><md-button class=\"md-primary md-hue-2\" \nng-click=\"hidePopup()\" translate=\"GENERAL.NO\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/home/empty.html","");
$templateCache.put("app/main/home/home.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"AGENDA.TITLE_PAGE\"></div></div><div layout=\"row\" layout-align=\"start center\">\n</div></div><div class=\"content\"><div class=\"\"><div layout=\"row\" layout-align=\"center center\" class=\"mb-5\"><button \nng-click=\"sortMessage(\'asc\')\" class=\"nl-Table-header-button\" ng-class=\"{\'nl-selected\':date.sort ==\'asc\'}\"><md-icon \nmd-font-icon=\"icon-sort-ascending\" class=\"s14\"></md-icon></button> <button ng-click=\"sortMessage(\'desc\')\" \nclass=\"nl-Table-header-button\" ng-class=\"{\'nl-selected\':date.sort ==\'desc\'}\"><md-icon \nmd-font-icon=\"icon-sort-descending\" class=\"s14\"></md-icon></button> <button hide show-gt-sm \nng-click=\"date.year = getYear(-1);displayDays(\'year\')\" class=\"nl-Table-header-button\" \nng-class=\"{\'nl-selected\' : date.year == getYear(-1)}\">{{getYear(-1)}}</button> <button hide show-gt-sm \nng-click=\"date.year = getYear(0);displayDays(\'year\')\" class=\"nl-Table-header-button\" \nng-class=\"{\'nl-selected\' : date.year == getYear(0)}\">{{getYear(0)}}</button> <button hide show-gt-sm \nng-click=\"date.year = getYear(1);displayDays(\'year\')\" class=\"nl-Table-header-button\" \nng-class=\"{\'nl-selected\' : date.year == getYear(1)}\">{{getYear(1)}}</button><md-input-container hide-gt-sm \nclass=\"nl-Input-container ml-15\" flex=\"100\"><md-select ng-change=\"displayDays(\'year\')\" ng-model=\"date.year\" \nname=\"agendaYear\"><md-option ng-value=\"0\">Pas d\'année</md-option><md-option ng-value=\"getYear(-1);\">{{getYear(-1)}}\n</md-option><md-option ng-value=\"getYear(0);\">{{getYear(0)}}</md-option><md-option ng-value=\"getYear(1);\">\n{{getYear(1)}}</md-option></md-select><label class=\"\">Year</label></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"date.year\" class=\"mv-5\"><button hide show-gt-sm ng-repeat=\"month in months\" \nng-click=\"date.month = month;displayDays(\'month\')\" class=\"nl-Table-header-button\" \nng-class=\"{\'nl-selected\' : date.month == month, \'nl-month-selected\' : monthSelected}\">{{month}}</button>\n<md-input-container hide-gt-sm class=\"nl-Input-container ml-15\" flex=\"100\"><md-select ng-change=\"displayDays(\'month\')\" \nng-model=\"date.month\" name=\"agendaMonth\"><md-option ng-value=\"0\">Pas de Mois</md-option><md-option \nng-repeat=\"month in months\" ng-value=\"month\">{{month}}</md-option></md-select><label class=\"\">Month</label>\n</md-input-container></div><div layout=\"row\" layout-align=\"center center\" ng-if=\"date.month\" class=\"mb-5\"><button hide \nshow-gt-sm ng-repeat-start=\"n in [].constructor(daysInMonth) track by $index\" \nng-if=\"$index+1 != daysInMonth && displayCircle($index)\" ng-click=\"selectWeek($index+2)\" \nclass=\"nl-Table-header-button button-icon\" \nng-class=\"{\'nl-week-selected\' : weekSelected && getTimeOfDay($index+1) >= circleClickedStartDate && getTimeOfDay($index+1) < circleClickedEndDate}\">\n<md-icon style=\"cursor: pointer\" md-font-icon=\"icon-brightness-1\" class=\"s8\"></md-icon></button> <button hide \nshow-gt-sm ng-repeat-end ng-click=\"date.day = $index+1;displayDays()\" class=\"nl-Table-header-button\" \nng-class=\"{\'nl-selected\' : date.day == $index+1, \'nl-month-selected\' : daysSelected, \'nl-week-selected\' : weekSelected && getTimeOfDay($index+1) >= circleClickedStartDate && getTimeOfDay($index+1) < circleClickedEndDate}\">\n{{$index+1}}</button><md-input-container hide-gt-sm class=\"nl-Input-container ml-15\" flex=\"100\"><md-select \nng-change=\"displayDays()\" ng-model=\"date.day\" name=\"agendaDay\"><md-option ng-value=\"0\">Pas de Jours</md-option>\n<md-option ng-repeat-start=\"n in [].constructor(daysInMonth) track by $index\" ng-value=\"$index+1\">{{$index+1}}\n</md-option><md-option ng-repeat-end ng-if=\"$index+1 != daysInMonth && displayCircle($index+1)\" \nng-click=\"selectWeek($index+2)\" ng-value=\"x\"><md-icon md-font-icon=\"icon-brightness-1\" class=\"s8\"></md-icon>\n</md-option></md-select><label class=\"\">Day</label></md-input-container></div></div><div class=\"\" \nng-if=\"date.day && daysWeek.length == 0\"><table class=\"nl-Table table-agenda\"><tbody><h2 class=\"font-weight-500\" \nstyle=\"color: #212121\">{{dayClicked | date:\'dd/MM/yyyy\'}}</h2><tr><td><div class=\"nl-Table-day\" layout=\"row\" \nlayou-align=\"start center\"><div class=\"nl-Table-day-hour\" layout=\"row\" layout-align=\"start top\"><div \nclass=\"nl-Table-day-hour-value\">&lt;8</div><span class=\"nl-Table-day-hour-expo\">h</span></div><div \nng-if=\"(actionsMessage | filter :filterMessageUnder(8)).length == 0\"><span class=\"nl-Table-header-empty\">\n{{\"AGENDA.EMPTY\" | translate}}</span></div><div ng-if=\"(actionsMessage | filter :filterMessageUnder(8)).length > 0\">\n<div class=\"nl-Table-message\" ng-repeat=\"message in actionsMessage | filter:filterMessageUnder(8)\" \nng-click=\"updateMessage(message)\"><table class=\"nl-Table\"><tbody><tr class=\"nl-Msg\"><td><div \nclass=\"nl-form--receivedMsg--subject\">{{message.subject}}</div><div class=\"nl-form--receivedMsg--content pb-10\">\n{{message.content | limitTo: 70}}</div><div ng-if=\"message.action\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-Msg-check\" ng-class=\"{\'nl-validated\': message.action.actionDone}\" \nng-click=\"confirmAction($event,message.action)\" layout=\"row\" layout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div>\n<div class=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div><div \nclass=\"nl-Table-message-action-deadline\">\nDeadline : {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div></div></div></div></td><td ng-if=\"message.company || message.contact\"><div class=\"nl-Msg-link-company\" \nng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div><a \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\" ng-click=\"$event.stopPropagation();\"><b>\n{{message.company.modelPattern}}</b></a></div><div class=\"nl-Msg-link-contact\" ng-if=\"message.contact\"><div \ntranslate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\" \nng-click=\"$event.stopPropagation();\"><b>{{message.contact.modelPattern}}</b></a></div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></td><td><span class=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div ng-if=\"message.sender.pictureLocation\" \nclass=\"nl-Msg-avatar\"><img title=\"{{message.sender.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"message.sender.pictureLocation != null\"></div><span ng-if=\"!message.sender.pictureLocation\" \nclass=\"nl-Badge\">{{message.sender.fullName}}</span> <span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id\"><md-icon class=\"mr-8\" \nmd-font-icon=\"icon-chevron-right\"></md-icon></span><div \nng-if=\"message.receiver.pictureLocation && message.receiver.id!=message.sender.id\" class=\"nl-Msg-avatar\"><img \ntitle=\"{{message.receiver.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.receiver.pictureLocation}}\" \nhas-profile-picture=\"message.receiver.pictureLocation != null\"></div><span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id && !message.receiver.pictureLocation\" \nclass=\"nl-Badge\">{{message.receiver.fullName}}</span></div></td><td><md-button \nclass=\"nl-listing-item-button md-accent\" aria-label=\"Update\">{{\"GENERAL.UPDATE\" | translate}}</md-button></td></tr>\n</tbody></table></div></div></div></td></tr><tr ng-repeat=\"hour in hoursInDay\"><td><div class=\"nl-Table-day\" \nlayout=\"row\" layou-align=\"start center\"><div class=\"nl-Table-day-hour\" layout=\"row\" layout-align=\"start top\"><div \nclass=\"nl-Table-day-hour-value\">{{hour}}</div><span class=\"nl-Table-day-hour-expo\">h</span></div><div \nng-if=\"(actionsMessage | filter:filterMessageByHour(hour)).length == 0\"><span class=\"nl-Table-header-empty\">\n{{\"AGENDA.EMPTY\" | translate}}</span></div><div ng-if=\"(actionsMessage | filter:filterMessageByHour(hour)).length > 0\">\n<div class=\"nl-Table-message\" ng-repeat=\"message in actionsMessage | filter:filterMessageByHour(hour)\" \nng-click=\"updateMessage(message)\"><table class=\"nl-Table\"><tbody><tr class=\"nl-Msg\"><td><div \nclass=\"nl-form--receivedMsg--subject\">{{message.subject}}</div><div class=\"nl-form--receivedMsg--content pb-10\">\n{{message.content | limitTo: 70}}</div><div ng-if=\"message.action\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-Msg-check\" ng-class=\"{\'nl-validated\': message.action.actionDone}\" \nng-click=\"confirmAction($event,message.action)\" layout=\"row\" layout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div>\n<div class=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div><div \nclass=\"nl-Table-message-action-deadline\">\nDeadline : {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div></div></div></div></td><td ng-if=\"message.company || message.contact\"><div class=\"nl-Msg-link-company\" \nng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div><a \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\" ng-click=\"$event.stopPropagation();\"><b>\n{{message.company.modelPattern}}</b></a></div><div class=\"nl-Msg-link-contact\" ng-if=\"message.contact\"><div \ntranslate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\" \nng-click=\"$event.stopPropagation();\"><b>{{message.contact.modelPattern}}</b></a></div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></td><td><span class=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div ng-if=\"message.sender.pictureLocation\" \nclass=\"nl-Msg-avatar\"><img title=\"{{message.sender.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"message.sender.pictureLocation != null\"></div><span ng-if=\"!message.sender.pictureLocation\" \nclass=\"nl-Badge\">{{message.sender.fullName}}</span> <span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id\"><md-icon class=\"mr-8\" \nmd-font-icon=\"icon-chevron-right\"></md-icon></span><div \nng-if=\"message.receiver.pictureLocation && message.receiver.id!=message.sender.id\" class=\"nl-Msg-avatar\"><img \ntitle=\"{{message.receiver.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.receiver.pictureLocation}}\" \nhas-profile-picture=\"message.receiver.pictureLocation != null\"></div><span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id && !message.receiver.pictureLocation\" \nclass=\"nl-Badge\">{{message.receiver.fullName}}</span></div></td><td><md-button \nclass=\"nl-listing-item-button md-accent\" aria-label=\"Update\">{{\"GENERAL.UPDATE\" | translate}}</md-button></td></tr>\n</tbody></table></div></div></div></td></tr><tr><td><div class=\"nl-Table-day\" layout=\"row\" layou-align=\"start center\">\n<div class=\"nl-Table-day-hour\" layout=\"row\" layout-align=\"start top\"><div class=\"nl-Table-day-hour-value\">>19</div>\n<span class=\"nl-Table-day-hour-expo\">h</span></div><div \nng-if=\"(actionsMessage | filter :filterMessageOver(19)).length == 0\"><span class=\"nl-Table-header-empty\">\n{{\"AGENDA.EMPTY\" | translate}}</span></div><div ng-if=\"(actionsMessage | filter :filterMessageOver(19)).length > 0\">\n<div class=\"nl-Table-message\" ng-repeat=\"message in actionsMessage | filter:filterMessageOver(19)\" \nng-click=\"updateMessage(message)\"><table class=\"nl-Table\"><tbody><tr class=\"nl-Msg\"><td><div \nclass=\"nl-form--receivedMsg--subject\">{{message.subject}}</div><div class=\"nl-form--receivedMsg--content pb-10\">\n{{message.content | limitTo: 70}}</div><div ng-if=\"message.action\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-Msg-check\" ng-class=\"{\'nl-validated\': message.action.actionDone}\" \nng-click=\"confirmAction($event,message.action)\" layout=\"row\" layout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div>\n<div class=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div><div \nclass=\"nl-Table-message-action-deadline\">\nDeadline : {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div></div></div></div></td><td ng-if=\"message.company || message.contact\"><div class=\"nl-Msg-link-company\" \nng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div><a \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\" ng-click=\"$event.stopPropagation();\"><b>\n{{message.company.modelPattern}}</b></a></div><div class=\"nl-Msg-link-contact\" ng-if=\"message.contact\"><div \ntranslate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\" \nng-click=\"$event.stopPropagation();\"><b>{{message.contact.modelPattern}}</b></a></div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></td><td><span class=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div ng-if=\"message.sender.pictureLocation\" \nclass=\"nl-Msg-avatar\"><img title=\"{{message.sender.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"message.sender.pictureLocation != null\"></div><span ng-if=\"!message.sender.pictureLocation\" \nclass=\"nl-Badge\">{{message.sender.fullName}}</span> <span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id\"><md-icon class=\"mr-8\" \nmd-font-icon=\"icon-chevron-right\"></md-icon></span><div \nng-if=\"message.receiver.pictureLocation && message.receiver.id!=message.sender.id\" class=\"nl-Msg-avatar\"><img \ntitle=\"{{message.receiver.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.receiver.pictureLocation}}\" \nhas-profile-picture=\"message.receiver.pictureLocation != null\"></div><span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id && !message.receiver.pictureLocation\" \nclass=\"nl-Badge\">{{message.receiver.fullName}}</span></div></td><td><md-button \nclass=\"nl-listing-item-button md-accent\" aria-label=\"Update\">{{\"GENERAL.UPDATE\" | translate}}</md-button></td></tr>\n</tbody></table></div></div></div></td></tr></tbody></table></div><div class=\"\" \nng-if=\"!date.day && !date.month && date.year\"><table class=\"nl-Table table-agenda\"><tbody \nclass=\"nl-Table-responsive-tbody\"><tr class=\"nl-Table-responsive-tr\"><td ng-repeat=\"month in months\" \nclass=\"nl-Table-responsive-td nl-Table-header-month\"><p><button class=\"nl-Table-button-simple button-title\" \nng-click=\"date.month = month;displayDays(\'month\')\">{{month}}</button></p><span class=\"nl-Table-header-empty\" \nng-if=\"(actionsMessage |filter:filterMessageByMonth(month)).length == 0\">{{\"AGENDA.EMPTY\" | translate}}</span> <span \nclass=\"nl-Table-header-year\" ng-if=\"(actionsMessage |filter:filterMessageByMonth(month)).length > 0\" \nng-click=\"date.month = month;displayDays(\'month\')\">\n{{(actionsMessage |filter:filterMessageByMonth(month)).length}} actions</span></td></tr></tbody></table></div><div \nclass=\"\" ng-if=\"!date.day && date.month && daysWeek.length == 0\"><table class=\"nl-Table table-agenda\"><tbody \nclass=\"nl-Table-responsive-tbody\"><h2 class=\"font-weight-500\" style=\"color: #212121\">\n{{monthClicked | date: \'MMM yyyy\'}}</h2><tr class=\"nl-Table-responsive-tr\"><th \nclass=\"nl-Table-responsive-th text-center text-uppercase font-size-12 pb-10\" style=\"color : #888\">\n{{\"GENERAL.DAYS.0\" | translate}}</th><th class=\"nl-Table-responsive-th text-center text-uppercase font-size-12 pb-10\" \nstyle=\"color : #888\">{{\"GENERAL.DAYS.1\" | translate}}</th><th \nclass=\"nl-Table-responsive-th text-center text-uppercase font-size-12 pb-10\" style=\"color : #888\">\n{{\"GENERAL.DAYS.2\" | translate}}</th><th class=\"nl-Table-responsive-th text-center text-uppercase font-size-12 pb-10\" \nstyle=\"color : #888\">{{\"GENERAL.DAYS.3\" | translate}}</th><th \nclass=\"nl-Table-responsive-th text-center text-uppercase font-size-12 pb-10\" style=\"color : #888\">\n{{\"GENERAL.DAYS.4\" | translate}}</th><th class=\"nl-Table-responsive-th text-center text-uppercase font-size-12 pb-10\" \nstyle=\"color : #888\">{{\"GENERAL.DAYS.5\" | translate}}</th><th \nclass=\"nl-Table-responsive-th text-center text-uppercase font-size-12 pb-10\" style=\"color : #888\">\n{{\"GENERAL.DAYS.6\" | translate}}</th></tr><tr class=\"nl-Table-responsive-tr\" ng-if=\"startOfMonthSunday()\"><td class=\"\">\n</td><td class=\"\"></td><td class=\"\"></td><td class=\"\"></td><td class=\"\"></td><td class=\"\"></td><td \nclass=\"nl-Table-responsive-td nl-Table-month-day-wrapper\"><button class=\"nl-Table-month-day\">\n{{getDateMonthCalendar(0,0)}}</button><p class=\"text-center\" \nng-if=\"getDateMonthCalendar(0,0) != \'\' && (actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar(0,0))).length==0\">\n<span class=\"nl-Table-header-empty\">{{\"AGENDA.EMPTY\" | translate}}</span></p></td></tr><tr \nclass=\"nl-Table-responsive-tr\" ng-repeat=\"n in [].constructor(5) track by $index\"><td \nclass=\"nl-Table-responsive-td nl-Table-month-day-wrapper\" \nng-class=\"{\'nl-Table-month-day-out\' : getDateMonthCalendar($index,1) == \'\'}\"><button class=\"nl-Table-month-day\" \nng-click=\"date.day = getDateMonthCalendar($index,1);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,1) == \'\'}\">{{getDateMonthCalendar($index,1)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,1) != \'\' && (actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,1))).length==0\">\n<span class=\"nl-Table-header-empty\">{{\"AGENDA.EMPTY\" | translate}}</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,1))\"><span \nclass=\"nl-Badge nl-Badge--primary nl-Badge--tag mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge nl-Badge--tag\">{{message.action.libelle}}</span><div ng-if=\"message.company || message.contact\"><div \nclass=\"nl-Msg-link-table\" ng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div><a \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\"><b>{{message.company.modelPattern}}</b></a>\n</div><div class=\"nl-Msg-link-table\" ng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n<b>{{message.contact.modelPattern}}</b></a></div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-table\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-table\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></div></div></td><td \nclass=\"nl-Table-responsive-td nl-Table-month-day-wrapper\" \nng-class=\"{\'nl-Table-month-day-out\' : getDateMonthCalendar($index,2) == \'\'}\"><button class=\"nl-Table-month-day\" \nng-click=\"date.day = getDateMonthCalendar($index,2);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,2) == \'\'}\">{{getDateMonthCalendar($index,2)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,2) != \'\' && (actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,2))).length==0\">\n<span class=\"nl-Table-header-empty\">{{\"AGENDA.EMPTY\" | translate}}</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,2))\"><span \nclass=\"nl-Badge nl-Badge--primary nl-Badge--tag mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge nl-Badge--tag\">{{message.action.libelle}}</span><div ng-if=\"message.company || message.contact\"><div \nclass=\"nl-Msg-link-table\" ng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div><a \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\"><b>{{message.company.modelPattern}}</b></a>\n</div><div class=\"nl-Msg-link-table\" ng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n<b>{{message.contact.modelPattern}}</b></a></div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-table\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-table\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></div></div></td><td \nclass=\"nl-Table-responsive-td nl-Table-month-day-wrapper\" \nng-class=\"{\'nl-Table-month-day-out\' : getDateMonthCalendar($index,3) == \'\'}\"><button class=\"nl-Table-month-day\" \nng-click=\"date.day = getDateMonthCalendar($index,3);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,3) == \'\'}\">{{getDateMonthCalendar($index,3)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,3) != \'\' && (actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,3))).length==0\">\n<span class=\"nl-Table-header-empty\">{{\"AGENDA.EMPTY\" | translate}}</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,3))\"><span \nclass=\"nl-Badge nl-Badge--primary nl-Badge--tag mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge nl-Badge--tag\">{{message.action.libelle}}</span><div ng-if=\"message.company || message.contact\"><div \nclass=\"nl-Msg-link-table\" ng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div><a \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\"><b>{{message.company.modelPattern}}</b></a>\n</div><div class=\"nl-Msg-link-table\" ng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n<b>{{message.contact.modelPattern}}</b></a></div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-table\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-table\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></div></div></td><td \nclass=\"nl-Table-responsive-td nl-Table-month-day-wrapper\" \nng-class=\"{\'nl-Table-month-day-out\' : getDateMonthCalendar($index,4) == \'\'}\"><button class=\"nl-Table-month-day\" \nng-click=\"date.day = getDateMonthCalendar($index,4);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,4) == \'\'}\">{{getDateMonthCalendar($index,4)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,4) != \'\' && (actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,4))).length==0\">\n<span class=\"nl-Table-header-empty\">{{\"AGENDA.EMPTY\" | translate}}</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,4))\"><span \nclass=\"nl-Badge nl-Badge--primary nl-Badge--tag mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge nl-Badge--tag\">{{message.action.libelle}}</span><div ng-if=\"message.company || message.contact\"><div \nclass=\"nl-Msg-link-table\" ng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div><a \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\"><b>{{message.company.modelPattern}}</b></a>\n</div><div class=\"nl-Msg-link-table\" ng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n<b>{{message.contact.modelPattern}}</b></a></div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-table\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-table\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></div></div></td><td \nclass=\"nl-Table-responsive-td nl-Table-month-day-wrapper\" \nng-class=\"{\'nl-Table-month-day-out\' : getDateMonthCalendar($index,5) == \'\'}\"><button class=\"nl-Table-month-day\" \nng-click=\"date.day = getDateMonthCalendar($index,5);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,5) == \'\'}\">{{getDateMonthCalendar($index,5)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,5) != \'\' && (actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,5))).length==0\">\n<span class=\"nl-Table-header-empty\">{{\"AGENDA.EMPTY\" | translate}}</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,5))\"><span \nclass=\"nl-Badge nl-Badge--primary nl-Badge--tag mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge nl-Badge--tag\">{{message.action.libelle}}</span><div ng-if=\"message.company || message.contact\"><div \nclass=\"nl-Msg-link-company\" ng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div><a \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\"><b>{{message.company.modelPattern}}</b></a>\n</div><div class=\"nl-Msg-link-contact\" ng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n<b>{{message.contact.modelPattern}}</b></a></div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></div></div></td><td \nclass=\"nl-Table-responsive-td nl-Table-month-day-wrapper\" \nng-class=\"{\'nl-Table-month-day-out\' : getDateMonthCalendar($index,6) == \'\'}\"><button class=\"nl-Table-month-day\" \nng-click=\"date.day = getDateMonthCalendar($index,6);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,6) == \'\'}\">{{getDateMonthCalendar($index,6)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,6) != \'\' && (actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,6))).length==0\">\n<span class=\"nl-Table-header-empty\">{{\"AGENDA.EMPTY\" | translate}}</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,6))\"><span \nclass=\"nl-Badge nl-Badge--primary nl-Badge--tag mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge nl-Badge--tag\">{{message.action.libelle}}</span><div ng-if=\"message.company || message.contact\"><div \nclass=\"nl-Msg-link-company\" ng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div><a \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\"><b>{{message.company.modelPattern}}</b></a>\n</div><div class=\"nl-Msg-link-contact\" ng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n<b>{{message.contact.modelPattern}}</b></a></div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></div></div></td><td \nclass=\"nl-Table-responsive-td nl-Table-month-day-wrapper\" \nng-class=\"{\'nl-Table-month-day-out\' : getDateMonthCalendar($index,7) == \'\'}\"><button class=\"nl-Table-month-day\" \nng-click=\"date.day = getDateMonthCalendar($index,7);displayDays()\" \nng-class=\"{\'nl-empty\': getDateMonthCalendar($index,7) == \'\'}\">{{getDateMonthCalendar($index,7)}}</button><p \nclass=\"text-center\" \nng-if=\"getDateMonthCalendar($index,7) != \'\' && (actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,7))).length==0\">\n<span class=\"nl-Table-header-empty\">{{\"AGENDA.EMPTY\" | translate}}</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actionsMessage | filter:filterMessageByDaysInMonth(getDateMonthCalendar($index,7))\"><span \nclass=\"nl-Badge nl-Badge--primary mb-5\">{{message.action.dateAction | date : \'HH:mm\'}}</span><br><span \nclass=\"nl-Badge\">{{message.action.libelle}}</span><div ng-if=\"message.company || message.contact\"><div \nclass=\"nl-Msg-link-company\" ng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div><a \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\"><b>{{message.company.modelPattern}}</b></a>\n</div><div class=\"nl-Msg-link-contact\" ng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n<b>{{message.contact.modelPattern}}</b></a></div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></div></div></td></tr></tbody></table></div><div class=\"\" \nng-if=\"daysWeek.length > 0 && !date.sort\"><table class=\"nl-Table table-agenda\"><h2 class=\"font-weight-500\" \nstyle=\"color: #212121\">\nSemaine du {{circleClickedStartDate | date: \'dd/MM/yyyy\'}} au {{circleClickedEndDate | date: \'dd/MM/yyyy\'}}</h2><tbody \nclass=\"nl-Table-responsive-tbody\"><tr class=\"nl-Table-responsive-th\"><th \nclass=\"nl-Table-responsive-th text-center text-uppercase font-size-12\" style=\"color : #888\">\n{{\"GENERAL.DAYS.0\" | translate}}</th><th class=\"nl-Table-responsive-th text-center text-uppercase font-size-12\" \nstyle=\"color : #888\">{{\"GENERAL.DAYS.1\" | translate}}</th><th \nclass=\"nl-Table-responsive-th text-center text-uppercase font-size-12\" style=\"color : #888\">\n{{\"GENERAL.DAYS.2\" | translate}}</th><th class=\"nl-Table-responsive-th text-center text-uppercase font-size-12\" \nstyle=\"color : #888\">{{\"GENERAL.DAYS.3\" | translate}}</th><th \nclass=\"nl-Table-responsive-th text-center text-uppercase font-size-12\" style=\"color : #888\">\n{{\"GENERAL.DAYS.4\" | translate}}</th><th class=\"nl-Table-responsive-th text-center text-uppercase font-size-12\" \nstyle=\"color : #888\">{{\"GENERAL.DAYS.5\" | translate}}</th><th \nclass=\"nl-Table-responsive-th text-center text-uppercase font-size-12\" style=\"color : #888\">\n{{\"GENERAL.DAYS.6\" | translate}}</th></tr><tr class=\"nl-Table-responsive-tr\"><td \nclass=\"nl-Table-responsive-td nl-Table-month-day-wrapper\" ng-repeat=\"day in daysWeek\"><button \nclass=\"nl-Table-month-day\" ng-click=\"setDate(day);displayDays()\">{{day.date}}</button><p class=\"text-center\" \nng-if=\"(actionsMessage | filter:filterMessageByDaysInMonth(day.date)).length == 0\"><span class=\"nl-Table-header-empty\">\n{{\"AGENDA.EMPTY\" | translate}}</span></p><div class=\"nl-Table-month-rdv\" \nng-repeat=\"message in actionsMessage | filter:filterMessageByDaysInMonth(day.date)\"><span \nclass=\"nl-Badge nl-Badge--primary nl-Badge--tag mb-5\">{{getDate(message.action.dateAction) | date : \'HH:mm\'}}</span>\n<br><span class=\"nl-Badge nl-Badge--tag\">{{message.action.libelle}}</span><div \nng-if=\"message.company || message.contact\"><div class=\"nl-Msg-link-table\" ng-if=\"message.company\"><div \ntranslate=\"GENERAL.COMPANY\"></div><a href=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\"><b>\n{{message.company.modelPattern}}</b></a></div><div class=\"nl-Msg-link-table\" ng-if=\"message.contact\"><div \ntranslate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n<b>{{message.contact.modelPattern}}</b></a></div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-table\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-table\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></div></div></td></tr></tbody></table></div><div class=\"\" \nng-if=\"!date.day && !date.month && !date.year\"><table class=\"nl-Table\"><tbody><tr \nng-repeat-start=\"message in actionsMessage\"><th class=\"nl-Table-header-date\">\n{{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}}</th></tr><tr ng-repeat-end=\"\"><td><div \nclass=\"nl-Table-message\"><table class=\"nl-Table\"><tbody><tr class=\"nl-Msg\"><td><div \nclass=\"nl-form--receivedMsg--subject\">{{message.subject}}</div><div class=\"nl-form--receivedMsg--content\">\n{{message.content | limitTo: 70}}</div><div ng-if=\"message.action\" layout=\"row\" layout-align=\"start center\" \nclass=\"mt-10\"><div class=\"nl-Msg-check\" ng-class=\"{\'nl-validated\': message.action.actionDone}\" \nng-click=\"confirmAction($event,message.action)\" layout=\"row\" layout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div><div>\nDeadline : {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div></div></div></td><td ng-if=\"message.company || message.contact\"><div class=\"nl-Msg-link-company\" \nng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\"></div><a \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\"><b>{{message.company.modelPattern}}</b></a>\n</div><div class=\"nl-Msg-link-contact\" ng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n<b>{{message.contact.modelPattern}}</b></a></div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></td><td><span class=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div ng-if=\"message.sender.pictureLocation\" \nclass=\"nl-Msg-avatar\"><img title=\"{{message.sender.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"message.sender.pictureLocation != null\"></div><span ng-if=\"!message.sender.pictureLocation\" \nclass=\"nl-Badge\">{{message.sender.fullName}}</span> <span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id\"><md-icon class=\"mr-8\" \nmd-font-icon=\"icon-chevron-right\"></md-icon></span><div \nng-if=\"message.receiver.pictureLocation && message.receiver.id!=message.sender.id\" class=\"nl-Msg-avatar\"><img \ntitle=\"{{message.receiver.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.receiver.pictureLocation}}\" \nhas-profile-picture=\"message.receiver.pictureLocation != null\"></div><span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id && !message.receiver.pictureLocation\" \nclass=\"nl-Badge\">{{message.receiver.fullName}}</span></div></td></tr></tbody></table></div></td></tr></tbody></table>\n</div></div></div>");
$templateCache.put("app/main/login/activate_account.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>P</span></div><div class=\"title\">Activation du compte</div><form \nname=\"activateAccountForm\" novalidate ng-submit=\"activateAccountForm.$valid && updatePassword()\"><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"passwordDTO.newPassword\" \nplaceholder=\"Mot de passe\" required><div ng-messages=\"activateAccountForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Information requise.</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" ng-model=\"passwordDTO.passwordConfirm\" \nplaceholder=\"Confirmation du mot de passe\" ng-pattern=\"passwordDTO.newPassword\" required><div \nng-messages=\"activateAccountForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nInformation requise.</span></div><div ng-message=\"pattern\"><span>Les deux mots de passe sont différents</span></div>\n</div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"Activer le compte\" ng-disabled=\" activateAccountForm.$pristine\">Activer mon compte</md-button></form></div>\n</div></div>");
$templateCache.put("app/main/login/forgot_password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll md-theme=\"teal-theme\"><div \nid=\"forgot-password-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" \nclass=\"md-whiteframe-4dp\"><div><img src=\"/alternatedocroots/default_logo.png\" alt=\"\" \nstyle=\"width: 200px !important; margin: 24px 0\"></div><div class=\"title\">Password Recovery</div><form \nname=\"forgotPasswordForm\" novalidate ng-submit=\"forgotPasswordForm.$valid && sendForgotPassword()\"><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"loginDTO.email\" placeholder=\"Email Address\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Email required</span></div><div ng-message=\"pattern\"><span>\nEmail not valid</span></div><div ng-message=\"email\"><span>Email not valid</span></div></div></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET\">RESET</md-button></form><div \nclass=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"login\">Back to Login</a></div></div>\n</div></div>");
$templateCache.put("app/main/login/login.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\" md-theme=\"teal-theme\"><div id=\"login-v2-intro\" flex hide \nshow-gt-sm><div class=\"logo\" ng-if=\"association == null || association.logo == null\" \nstyle=\"width: 190px; height: 190px; border-radius: 500px; background-color: #ffffff; box-shadow: 1px 1px 4px rgba(0,0,0,0.2)\" \nlayout=\"row\" layout-align=\"center center\"><img src=\"/alternatedocroots/default_logo.png\" alt=\"\" style=\"width: 142px\">\n</div><div class=\"logo\" ng-if=\"association != null && association.logo != null\"><img \nng-src=\"{{alternatedocroots + \'/\' + association.logo}}\"></div><div class=\"title\" \nstyle=\"color: #fff; font-weight: 500;text-shadow: 1px 1px 2px rgba(0,0,0,0.7)\">\n{{\"LOGIN.WELCOME\" | translate}} Pure</div><div class=\"description\"></div></div><div \nid=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div id=\"login-v2-form\"><div \nclass=\"logo\" hide-gt-sm><span>Lebanon</span></div><div class=\"title\">{{\"LOGIN.CONNECTION\" | translate}} Pure\n</div><div class=\"description\"></div><form name=\"loginForm\" novalidate ng-submit=\"login()\"><span class=\"red-600-fg\" \nng-show=\"loginError\">{{\"LOGIN.IDENTIFIERS_ERROR\" | translate}}</span><md-input-container class=\"md-block\" md-no-float>\n<input type=\"text\" name=\"login\" ng-model=\"loginDTO.usermail\" placeholder=\"{{\'LOGIN.USERNAME\' | translate}}\" required>\n<div ng-messages=\"loginForm.login.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\"LOGIN.ENTER_LOGIN\" | translate}}</span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" ng-model=\"loginDTO.password\" \nplaceholder=\"{{\'LOGIN.PASSWORD\' | translate}}\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"LOGIN.ENTER_PASSWORD\" | translate}}</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><a \nui-sref=\"forgotPassword\" class=\"forgot-password md-accent-color\">{{\'LOGIN.FORGOT_PASSWORD\' | translate}}</a></div>\n<md-button type=\"submit\" class=\"md-raised md-primary md-hue-2 submit-button\" \naria-label=\"{{\'LOGIN.LOGIN\' | translate}}\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\">\n{{\'LOGIN.LOGIN\' | translate}}</md-button></form></div></div></div>");
$templateCache.put("app/main/login/update_password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-4dp\"><div><img \nsrc=\"/alternatedocroots/default_logo.png\" alt=\"\" style=\"width: 200px !important; margin: 24px 0\"></div><div \nclass=\"title\">Resetting password</div><form name=\"initPasswordForm\" novalidate \nng-submit=\"initPasswordForm.$valid && sendUpdatePassword()\"><md-input-container class=\"md-block\" md-no-float><input \ntype=\"password\" name=\"password\" ng-model=\"loginDTO.password\" placeholder=\"Password\" required><div \nng-messages=\"initPasswordForm.password.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nPassword required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input \ntype=\"password\" name=\"confirmPassword\" ng-model=\"loginDTO.confirmPassword\" placeholder=\"Password confirmation\" \nng-pattern=\"loginDTO.password\" required><div ng-messages=\"initPasswordForm.confirmPassword.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>Password required</span></div><div ng-message=\"pattern\"><span>\nDifferent Password</span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"Réinitialiser\">Reset</md-button></form><div class=\"login\" \nlayout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"login\">Back to login</a></div></div></div></div>");
$templateCache.put("app/main/media/folders.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"FOLDERS.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"openAddFile()\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>\n{{\'FOLDERS.UPLOAD_FILE\' | translate}}</md-button><md-button class=\"md-accent md-hue-1\" ng-click=\"showFolderForm()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'FOLDERS.CREATE_FOLDER\' | translate}}</md-button><div>\n<md-input-container><md-select ng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\">\n<md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}\n</md-option></md-select></md-input-container></div></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\">\n<div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><div class=\"nl-Block\"><a ng-click=\"findFolders(language.key);findDocuments()\">/</a> <span \nng-repeat=\"folder in thread track by $index\"><a ng-click=\"goToFolder(folder,true)\">{{folder.name}}</a>\n {{( thread.length-1 > $index) ? \"/\":\"\"}}</span></div><div class=\"nl-Block mt-30\" ng-show=\"showForm\"><div \nclass=\"panel-body\"><form name=\"formFolderCreation\" class=\"form-horizontal\" role=\"form\" novalidate><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"mt-30 mb-0\"><label>{{\'FOLDERS.NAME\' | translate}} :\n</label><input type=\"text\" ng-model=\"newFolder.name\" name=\"folderName\" aria-label=\"newFolderName\" required><div \nng-messages=\"formFolderCreation.folderName.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><div><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"formFolderCreation.$valid && createFolder();\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s24\"></md-icon>Ajouter</md-button></div></div></form></div></div><div \nclass=\"nl-Block mt-10\"><div><div ng-if=\"newFolder.idParent\" ng-click=\"returnParent()\"><md-button \nclass=\"md-primary md-hue-2\" aria-label=\"Dossier\"><md-icon md-font-icon=\"icon-reply\" class=\"nl-listing-item-icon\">\n</md-icon>{{\'FOLDERS.BACK\' | translate}}</md-button></div><table class=\"simple list-view\"><tbody><tr \nng-repeat=\"folder in folders\" ng-click=\"goToFolder(folder)\"><td class=\"file-icon\" style=\"width:72px\"><i \nclass=\"icon-folder\"></i></td><td ng-if=\"!folder.update\">{{folder.name}}</td><td ng-if=\"folder.update\" \nng-click=\"$event.stopPropagation();\"><md-input-container class=\"mt-10 mb-0 nl-Form-input--noError\"><label>\n{{\"FOLDERS.NAME\" | translate}}</label><input type=\"text\" ng-model=\"folderNameCopy.name\" required maxlength=\"255\">\n</md-input-container></td><td><div layout=\"row\" layout-align=\"end center\"><md-button \nng-click=\"$event.stopPropagation();deleteFolder(folder)\" md-no-ink class=\"md-raised md-warn md-hue-2\" \naria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button><md-button ng-hide=\"folder.update\" md-no-ink \nng-click=\"$event.stopPropagation();updateFolder(folder)\" class=\"md-accent md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button ng-show=\"folder.update\" md-no-ink \nng-click=\"$event.stopPropagation();updateFolder(folder)\" class=\"md-warn md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.CANCEL\" | translate}}</md-button><md-button ng-show=\"folder.update\" md-no-ink \nng-click=\"$event.stopPropagation();saveUpdateFolder(folder)\" class=\"md-raised md-primary md-hue-2\" \naria-label=\"Supprimer\" ng-disabled=\"!folderNameCopy.name\">{{\"GENERAL.SAVE\" | translate}}</md-button></div></td></tr><tr\n ng-repeat=\"file in files\" ng-class=\"{\'selected\' : vm.selected === file}\"><td class=\"file-icon\"><i \nclass=\"icon-file-document\"></i></td><td class=\"name\">{{file.originalFileName}}</td><td class=\"type\" show-gt-sm><a \nhref=\"alternatedocroots/{{file.location}}\" target=\"_blank\" ng-if=\"isPicture(file.originalFileName)\"><img \nng-src=\"alternatedocroots/{{file.location}}\" style=\"max-height: 80px;max-width: 200px\"></a></td><td class=\"owner\" \nhide-xs>{{getUrl()}}/alternatedocroots/{{file.location}}</td><td class=\"size\" hide-xs>{{file.size}} Ko</td><td \nclass=\"last-modified\" hide show-gt-md><md-button ng-click=\"$event.stopPropagation();deleteFile(file)\" \nclass=\"nl-listing-item-button md-warn\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr>\n</tbody></table><div class=\"p-16\" ng-show=\"folders.length == 0 && files.length == 0\">\n{{\'FOLDERS.NO_FOLDER\' | translate}}</div></div></div></div></div>");
$templateCache.put("app/main/message/message.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"MESSAGE.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"showPopUpMessage()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'MESSAGE.CREATION.NEW\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\">\n<div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"showPopUpMessage()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'MESSAGE.CREATION.NEW\' | translate}}\n</md-button></div></div></div><div class=\"content\"><div><div layout=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label>{{\"MESSAGE.BOX.TITLE\" | translate}}</label><md-select ng-model=\"filter.sender\" aria-label=\"language\" \nname=\"receiver\" ng-change=\"findAllMessages(true)\"><md-option ng-value=\"false\">{{\"MESSAGE.BOX.RECEPTION\" | translate}}\n</md-option><md-option ng-value=\"true\">{{\"MESSAGE.BOX.SENT\" | translate}}</md-option><md-option ng-value=\"null\">\n{{\"MESSAGE.BOX.ALL\" | translate}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>{{\"MESSAGE.TYPE.TITLE\" | translate}}</label><md-select ng-model=\"filter.action\" \naria-label=\"language\" name=\"receiver\" ng-change=\"findAllMessages(true)\"><md-option ng-value=\"null\">\n{{\"MESSAGE.TYPE.ALL\" | translate}}</md-option><md-option ng-value=\"typeAction.TO_DO\">\n{{\"MESSAGE.TYPE.TO_DO\" | translate}}</md-option><md-option ng-value=\"typeAction.DONE\">\n{{\"MESSAGE.TYPE.DONE\" | translate}}</md-option><md-option ng-value=\"typeAction.ALL\">\n{{\"MESSAGE.TYPE.ALL_ACTION\" | translate}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>{{\"MESSAGE.CORRESPONDANT\" | translate}}</label><md-select \nmd-on-close=\"filterSelectText = \'\'\" ng-model=\"filter.receiverForm\" aria-label=\"language\" name=\"receiver\" \nmultiple=\"multiple\" ng-change=\"findAllMessages(true)\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"user in users | filterText: filterSelectText\" value=\"{{user}}\">{{user.fullName}}</md-option></md-select>\n</md-input-container></div><div class=\"nl-Block nl-Block--table mt-15\" \ninfinite-scroll-disabled=\"infiniteScrollPrevent\" infinite-scroll=\"findAllMessages()\" \ninfinite-scroll-container=\"\'#content\'\"><div class=\"nl-form--receivedMsg\"><table \nclass=\"simple list-view nl-Table nl-Table--makeResponsive nl-Table--msg\"><thead><th>\n{{\"MESSAGE.DISPLAY.MESSAGE\" | translate}}</th><th>{{\"MESSAGE.DISPLAY.LINK\" | translate}}</th><th>\n{{\"MESSAGE.DISPLAY.SENDER\" | translate}}</th><th>{{\"MESSAGE.DISPLAY.ACTIONS\" | translate}}</th></thead><tbody><tr \nng-repeat=\"message in messages track by message.id\" class=\"nl-Msg\"><td><div class=\"nl-form--receivedMsg--subject\">\n{{message.subject}}</div><div class=\"nl-form--receivedMsg--content\" ng-bind-html=\"message.content | limitTo: 70\"></div>\n<div ng-if=\"message.action\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-check\" \nng-class=\"{\'nl-validated\': message.action.actionDone}\" ng-click=\"confirmAction(message.action)\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div><div>\nDeadline : {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div></div></div></td><td><div class=\"nl-Msg-link-company\" ng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\">\n</div><a href=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\">{{message.company.modelPattern}}\n</a></div><div class=\"nl-Msg-link-contact\" ng-if=\"message.contact\"><div translate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n{{message.contact.modelPattern}}</a></div><div ng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" \nng-if=\"field.index != null && field.value\" class=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon \nmd-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s22\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></td><td><span class=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div ng-if=\"message.sender.pictureLocation\" \nclass=\"nl-Msg-avatar\"><img title=\"{{message.sender.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"message.sender.pictureLocation != null\"></div><span ng-if=\"!message.sender.pictureLocation\" \nclass=\"nl-Badge\">{{message.sender.fullName}}</span> <span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id\"><md-icon class=\"mr-8\" \nmd-font-icon=\"icon-chevron-right\"></md-icon></span><div \nng-if=\"message.receiver.pictureLocation && message.receiver.id!=message.sender.id\" class=\"nl-Msg-avatar\"><img \ntitle=\"{{message.receiver.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.receiver.pictureLocation}}\" \nhas-profile-picture=\"message.receiver.pictureLocation != null\"></div><span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id && !message.receiver.pictureLocation\" \nclass=\"nl-Badge\">{{message.receiver.fullName}}</span></div></td><td><md-button ng-click=\"updateMessage(message)\" \nclass=\"nl-listing-item-button md-accent\" aria-label=\"Update\">{{\"GENERAL.UPDATE\" | translate}}</md-button></td></tr>\n</tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/models/draw_token.html","<div class=\"page-content container-fluid\"><div class=\"panel panel panel-bordered\"><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"nl_categories-item-title nl_categories-item-title--first\"><div>\n{{\'SETTINGS.DATABASE.MODELS.TITLE_DRAW_TOKEN\' | translate}}</div></div><div class=\"nl-Block\"><div><div><form \nnovalidate class=\"form-horizontal\" name=\"drawPatternForm\"><div class=\"form-body\"><div ng-show=\"showDrawHelp\" \nclass=\"nl-Models-help\"><help-draw-token-builder help-draw-token-title=\"helpDrawTokenTitle\" \nhelp-draw-token-content=\"helpDrawTokenContent\"></help-draw-token-builder></div><blockquote ng-if=\"tokensModified\" \nclass=\"md-yellow-600-bg pr-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-alert-circle\" aria-hidden=\"true\"></md-icon><div class=\"ml-15\">\n{{\'GENERAL.NOT_SAVED\' | translate}}</div></div><div layout=\"row\" layout-align=\"start center\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"saveDrawTokens();\" noo-tooltip tooltip-title=\"Sauvegarder\">\n<md-icon md-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"cancelModifTokens();\" noo-tooltip tooltip-title=\"Annuler\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s18\"></md-icon></md-button></div></blockquote><div layout=\"column\"><md-input-container\n class=\"mv-0\" flex=\"100\"><label class=\"md-no-float md-container-ignore\" translate=\"SETTINGS.DATABASE.MODELS.PATTERN\">\n</label><input ng-disabled=\"true\" type=\"text\" ng-value=\"calculatedPattern()\" readonly=\"readonly\"></md-input-container>\n<div ng-repeat=\"drawToken in drawTokenList | orderBy:\'index\'\" layout=\"row\"><md-input-container class=\"mt-18 mb-0\" \nflex=\"33\"><label translate=\"SETTINGS.DATABASE.MODELS.PREFIX\"></label><input type=\"text\" ng-change=\"changeElement();\" \nng-trim=\"false\" ng-model=\"drawToken.prefix\"></md-input-container><md-input-container class=\"mt-18 mb-0\" flex=\"33\">\n<label translate=\"SETTINGS.DATABASE.MODELS.FIELD\"></label><md-select md-on-close=\"filterSelectText = \'\'\" \nng-change=\"changeElement();\" ng-model=\"drawToken.field\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-select-header>\n<section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"field in champsListRequired | filterText: filterSelectText | simpleTypeRequiredFilter | orderBy: \'libelle\' track by field.id\" \nng-value=\"field\">{{field.libelle}}</md-option></md-select></md-input-container><md-input-container class=\"mt-18 mb-0\" \nflex=\"33\"><label class=\"\" translate=\"SETTINGS.DATABASE.MODELS.SUFFIX\"></label><input type=\"text\" class=\"\" \nng-change=\"changeElement();\" ng-trim=\"false\" ng-model=\"drawToken.suffix\"></md-input-container><div class=\"\"><md-button \ntype=\"button\" class=\"md-raised md-warn md-hue-2\" ng-click=\"deleteToken($index);\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s18\"></md-icon>{{\'GENERAL.DELETE\' | translate}}</md-button></div></div><div class=\"form-group row\"><div>\n<md-button md-no-ink type=\"button\" class=\"md-raised md-primary md-hue-2\" ng-click=\"addPatternToken();\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></div></form>\n</div></div></div></div></div>");
$templateCache.put("app/main/models/fields_models.html","<div id=\"researchPageCreation\" class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.TITLE\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content\"><div class=\"content\"><div class=\"nl-Block\"><div><div><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.ADD_FIELD_TO_FILTER_ENGINE\"></span></div></div><div \nclass=\"panel-body\"><div class=\"row\"><div class=\"col-md-12\"><form name=\"researchPageCreationFilterForm\" role=\"form\" \nnovalidate><div layout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"\"><md-select \nname=\"newFieldToFilter\" id=\"newFieldToFilter\" ng-model=\"fieldToAdd\" placeholder=\"\"><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsAvalaible\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span \nng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-select><div \nng-messages=\"researchPageCreationFilterForm.newFieldToFilter.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nObligatoire.</span></div></div></md-input-container><div><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"addField();\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></form></div></div></div></div></div><div class=\"nl-Block mt-15\">\n<div ng-repeat=\"display in displaysModels | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><h3 class=\"\">{{display.fieldModel.libelle}}</h3></div><md-input-container \nclass=\"\" flex=\"10\"><md-select ng-change=\"setIcon(display)\" name=\"iconFieldContact\" id=\"iconFieldContact\" \nng-model=\"display.icon\" placeholder=\"\"><md-option ng-value=\"undefined\">Aucune</md-option><md-option \nng-value=\"icon.name\" ng-repeat=\"icon in DISPLAY_MODELS_ICONS\"><md-icon md-font-icon=\"{{icon.value}}\" class=\"s22\">\n</md-icon></md-option></md-select></md-input-container><div class=\"panel-actions panel-actions-keep\" layout=\"row\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"removeField(display);\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div \nclass=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"goUp(display)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"!(display.index > 0 && displaysModels.length > 1)\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button ng-click=\"goDown(display)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"(display.index + 1 == displaysModels.length)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/models/help_draw_token.html","<div class=\"row\"><div class=\"example m-t-0 m-x-0\"><div class=\"ribbon\"><span class=\"ribbon-inner\">{{helpDrawTokenTitle}}\n</span></div><h4>But de l\'affichage</h4><p>{{helpDrawTokenContent}}</p><br><h4>Principe de fonctionnement</h4><p>\nPar défault l\'objet est représenté par la liste de toutes ses valeurs séparées par des \",\" (CHAMPS1,CHAMPS2,CHAMPS3)\n</p><p>On peut modifier se comportement en renseignant un pattern d\'affichage. Pour se faire il faut selectionner\n<md-button type=\"button\" class=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-plus\" class=\"s24\"></md-icon></md-button>.\n</p><p>\nUn block en 3 parties apparait permettant de configurer l\'affichage. Pour afficher par exemple un utilisateur de la forme : PRENOM (EMAIL) il faudra configurer le pattern de cette façon :\n</p><br><form class=\"form-horizontal\"><div class=\"form-group row\"><label class=\"col-xs-12 col-md-3 form-control-label\">\nPattern d\'affichage</label><div class=\"col-md-5 col-xs-12\"><input type=\"text\" class=\"form-control form-control-sm\" \nvalue=\"PRENOM (MAIL)\" readonly=\"readonly\"></div></div><div class=\"form-group row\"><label \nclass=\"col-xs-12 col-md-3 form-control-label\">Prefix</label><div class=\"col-md-5 col-xs-12\"><input type=\"text\" \nclass=\"form-control form-control-sm\" readonly=\"readonly\"></div></div><div class=\"form-group row\"><label \nclass=\"col-xs-12 col-md-3 form-control-label\">Champs</label><div class=\"col-md-5 col-xs-12\"><select \nclass=\"form-control form-control-sm\" disabled=\"disabled\"><option>PRENOM</option></select></div></div><div \nclass=\"form-group row\"><label class=\"col-xs-12 col-md-3 form-control-label\">Suffix</label><div \nclass=\"col-md-5 col-xs-12\"><input type=\"text\" class=\"form-control form-control-sm\" readonly=\"readonly\"></div></div><div\n class=\"form-group row\"><label class=\"col-xs-12 col-md-3 form-control-label\">--</label></div><div \nclass=\"form-group row\"><label class=\"col-xs-12 col-md-3 form-control-label\">Prefix</label><div \nclass=\"col-md-5 col-xs-12\"><input type=\"text\" class=\"form-control form-control-sm\" value=\"(\" readonly=\"readonly\"></div>\n</div><div class=\"form-group row\"><label class=\"col-xs-12 col-md-3 form-control-label\">Champs</label><div \nclass=\"col-md-5 col-xs-12\"><select class=\"form-control form-control-sm\" disabled=\"disabled\"><option>MAIL</option>\n</select></div></div><div class=\"form-group row\"><label class=\"col-xs-12 col-md-3 form-control-label\">Suffix</label>\n<div class=\"col-md-5 col-xs-12\"><input type=\"text\" class=\"form-control form-control-sm\" value=\")\" readonly=\"readonly\">\n</div></div></form></div></div>");
$templateCache.put("app/main/models/help_model.html","<div class=\"row\"><div class=\"example m-t-0 m-x-0\"><div class=\"ribbon\"><span class=\"ribbon-inner\">{{helpModelTitle}}\n</span></div><h4>But du modèle</h4><p>{{helpModelContent}}</p><p>\nAfin de préciser au mieux le modèle, vous avez le choix entre 4 types d\'attributs :</p><p></p><blockquote \nclass=\"blockquote custom-blockquote blockquote-info\">\nSTRING - Représente une réponse au format texte de moins de 255 charactères.<br>\nLONG_STRING - Représente une réponse au format texte pouvant dépasser 255 charactères.<br>\nNUMBER - Représente un nombre positif ou négatif.<br>DATE - Représente une date.<br>\nBOOLEAN - Représente un cas oui/non, cela sera affiché comme une case à cocher à l\'utilisateur.</blockquote><p></p><h4>\nPrincipe de fonctionnement</h4><p>\nPour commencer à gérer les champs, vous devez entrer le libellé de votre champs et cliquer sur<md-button type=\"button\" \nclass=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-help\" class=\"s24\"></md-icon></md-button>.</p><p>Les boutons\n<md-button type=\"button\" class=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s24\"></md-icon>\n</md-button>et<md-button type=\"button\" class=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s24\">\n</md-icon></md-button>vous permettrons de réordonner les champs.</p><p>\nPour modifier un champs, commencer par activer la modification avec le bouton<md-button type=\"button\" \nclass=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-pencil\" class=\"s24\"></md-icon></md-button>\n. Il faut ensuite modifier le libellé du champs et/ou son type et valider la modification en cliquant sur<md-button \ntype=\"button\" class=\"md-fab md-mini\"><md-icon md-font-icon=\"icon-content-save\" class=\"s24\"></md-icon></md-button>.</p>\n<p>Pour supprimer un champs, il faut cliquer sur<md-button type=\"button\" class=\"md-fab md-mini\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s24\"></md-icon></md-button>\n. ATTENTION toutes les informations liées à ce champs seront supprimées!</p></div></div>");
$templateCache.put("app/main/models/infos_category.html","<div class=\"nl_categories-thread\" ng-if=\"category.values.length || category.subCategories.length\" layout=\"row\" \nlayout-wrap><div class=\"nl_categories-item item-l{{level+1}} flex-100 flex-sm-100 flex-xs-100\" layout-wrap \nng-show=\"(parent == null || parent != null && !parent.defaultClosed)\"><div class=\"\" \nng-class=\"level >0 ? \'nl_categories-item-subtitle\':\'nl_categories-item-title\'\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"category.defaultClosed = !category.defaultClosed\"><div>{{category.name}}\n</div><button ng-if=\"edition\" type=\"button\" class=\"ml-10\"><md-icon md-font-icon=\"icon-eye\" \nng-if=\"category.defaultClosed\"></md-icon><md-icon md-font-icon=\"icon-eye-off\" ng-if=\"!category.defaultClosed\">\n</md-icon></button></div><div layout=\"row\" layout-wrap ng-show=\"(!edition || !category.defaultClosed)\"><div \nclass=\"flex-sm-100 flex-xs-100\" \nng-repeat=\"valueField in filtered = (category.values | filter : { fieldDisplayable : \'true\', hide: false } | onlyRequired: !edition | orderBy: \'index\') track by valueField.id\" \nng-class=\"edition ? \'{{\'flex-\'+valueField.size}}\' : \'flex-100\'\" ng-if=\"!valueField.hidden\"><noo-input \nmodel=\"abstractModel\" sub-type=\"subTypeId\" form-name=\"formName\" edition=\"edition\" ng-model=\"valueField\" \nindex=\"{{$index}}\" content=\"{{valueField.typeChamps}}\" big-display-area=\"valueField.bigDisplayArea\" \nmodel-type=\"modelType\"></noo-input><div class=\"clearfix visible-lg-block\" ng-if=\"($index+1) % 3 === 0 && $index !== 0\">\n</div><div class=\"clearfix visible-md-block\" ng-if=\"($index+1) % 3 === 0 && $index !== 0\"></div><div \nclass=\"clearfix visible-sm-block\" ng-if=\"($index+1) % 2 === 0 && $index !== 0\"></div></div></div></div>\n<noo-infos-category class=\"flex-sm-100 flex-xs-100\" model=\"abstractModel\" ng-if=\"edition\" \nng-class=\"edition ? \'{{\'flex-\' + subCategory.size}}\' : \'flex-100\'\" model-type=\"modelType\" sub-type=\"subTypeId\" \nedition=\"edition\" form-name=\"formName\" ng-model=\"subCategory\" parent=\"category\" level=\"nextLevel\" \nng-repeat=\"subCategory in category.subCategories | orderBy: \'index\' track by subCategory.id\"></noo-infos-category>\n<noo-infos-category class=\"flex-sm-100 flex-xs-100\" model=\"abstractModel\" ng-if=\"!edition\" \nng-class=\"edition ? \'{{\'flex-\' + subCategory.size}}\' : \'flex-100\'\" model-type=\"modelType\" sub-type=\"subTypeId\" \nedition=\"edition\" form-name=\"formName\" ng-model=\"subCategory\" parent=\"category\" level=\"nextLevel\" \nng-repeat=\"subCategory in category.subCategories | filter : { required: true } | orderBy: \'index\' track by subCategory.id\">\n</noo-infos-category></div>");
$templateCache.put("app/main/models/infos_model.html","<div><div \nng-show=\"showSettings && edition && modelType !== \'LOGISTIC_MODEL\' && modelType !== \'INSCRIPTION_MODEL\' || (!edition && modelType === \'COMPANY_MODEL\')\" \nclass=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"typesShowed = !typesShowed\"><div>{{\'GENERAL.SETTINGS\' | translate}}</div><div \nng-if=\"modelType === \'CONTACT_MODEL\'\" style=\"text-transform: none\" layout-align=\"end center\"><span \nng-click=\"$event.stopPropagation()\">#{{model.number}}</span> <button type=\"button\" class=\"ml-10\"><md-icon \nmd-font-icon=\"icon-eye\" ng-if=\"!typesShowed\"></md-icon><md-icon md-font-icon=\"icon-eye-off\" ng-if=\"typesShowed\">\n</md-icon></button></div></div><div ng-show=\"typesShowed\"><div layout=\"row\" ng-if=\"modelType === \'COMPANY_MODEL\'\">\n<md-input-container class=\"m-0\"><md-select md-on-close=\"filterSiteSelectText = \'\'\" ng-model=\"model.sites\" \nng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\" ng-change=\"edition && updateSite()\"><md-select-header>\n<section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSiteSelectText\"></section></md-select-header><md-option \nng-repeat=\"site in sites | filterText: filterSiteSelectText | orderBy: \'name\' track by site.id\" ng-value=\"site\">\n{{ site.name }}</md-option></md-select><label translate=\"SITES_MANAGEMENT.SITES.TITLES\"></label></md-input-container>\n</div><div layout=\"row\" ng-if=\"modelType === \'COMPANY_MODEL\'\"><md-input-container class=\"m-0\"><md-select \nmd-on-close=\"filterSelectText = \'\'\" ng-model=\"model.associations\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nmultiple=\"multiple\" ng-change=\"edition && updateAssociation()\"><md-select-header><section><input force-select-focus \ntype=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header>\n<md-option \nng-repeat=\"association in associations | filterText: filterSelectText | orderBy: \'name\' track by association.id\" \nng-value=\"association\">{{ association.name }}</md-option></md-select><label translate=\"ASSOCIATIONS.TITLE\"></label>\n</md-input-container></div><div layout=\"row\" ng-if=\"modelType === \'COMPANY_MODEL\'\"><md-input-container class=\"m-0\">\n<md-chips class=\"nl-chips\" ng-model=\"model.tags\" name=\"tags\" md-on-add=\"edition && addField($chip, model.tags,\'TAGS\')\" \nmd-on-remove=\"edition && addField($chip, model.tags,\'TAGS\')\"><md-autocomplete md-search-text=\"search.tag\" \nmd-select-on-match=\"true\" md-autoselect=\"true\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'TAGS.TITLE\' | translate}}\" \nmd-items=\"field in fieldsSelected(tags, model.tags) | filter: {name: search.tag}\" md-item-text=\"field.name\" \nmd-min-length=\"0\"><span>{{field.name}}</span></md-autocomplete><md-chip-template><span>{{$chip.name}}</span>\n</md-chip-template></md-chips></md-input-container></div><div layout=\"row\" ng-if=\"modelType === \'COMPANY_MODEL\'\">\n<md-input-container class=\"m-0\"><md-chips class=\"nl-chips\" ng-model=\"model.countries\" name=\"pays\" \nmd-on-add=\"edition && addField($chip, model.countries,\'COUNTRIES\')\" \nmd-on-remove=\"edition && addField($chip, model.countries,\'COUNTRIES\')\"><md-autocomplete \nmd-search-text=\"search.country\" md-select-on-match=\"true\" md-autoselect=\"true\" md-match-case-insensitive=\"true\" \nmd-no-cache=\"true\" md-floating-label=\"{{\'TAGS.COUNTRIES\' | translate}}\" \nmd-items=\"field in fieldsSelected(countries, model.countries) | filter: {libelle: search.country}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container></div><div layout=\"row\" \nng-if=\"modelType === \'COMPANY_MODEL\'\"><md-input-container class=\"m-0\"><md-chips class=\"nl-chips\" \nng-model=\"model.regions\" name=\"regions\" md-on-add=\"edition && addField($chip, model.regions,\'REGIONS\')\" \nmd-on-remove=\"edition && addField($chip, model.regions,\'REGIONS\')\"><md-autocomplete md-search-text=\"search.region\" \nmd-select-on-match=\"true\" md-autoselect=\"true\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'TAGS.REGIONS\' | translate}}\" \nmd-items=\"field in fieldsSelected(regions, model.regions) | filter: {libelle: search.region}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container></div><div layout=\"row\" \nng-if=\"modelType === \'COMPANY_MODEL\'\"><md-input-container class=\"m-0\"><md-select ng-model=\"model.status\" \nng-change=\"edition && updateStatus()\"><md-option ng-repeat=\"stat in status\" ng-value=\"stat.value\">{{ stat.value }}\n</md-option></md-select><label translate=\"COMPANIES.STATUS\"></label></md-input-container></div><div layout=\"row\"><div \nstyle=\"display: flex; flex-direction: row; flex-wrap: wrap\"><md-input-container style=\"flex: 1 0 33%\" class=\"m-0\" \nng-repeat=\"type in subTypes | orderBy: \'index\' track by $index\"><md-switch class=\"md-primary m-0\" \nng-model=\"model[\'type_\' + type.id]\" ng-change=\"updateSubTypes(type, true)\">{{type.name}}</md-switch>\n</md-input-container></div><md-input-container class=\"m-0\" \nng-if=\"edition && modelType !== \'INSCRIPTION_MODEL\' && modelType !== \'LOGISTIC_MODEL\'\"><md-switch \nclass=\"md-primary m-0\" ng-model=\"model.activate\" ng-change=\"updateActive()\">{{\'GENERAL.ACTIVE\' | translate}}\n</md-switch></md-input-container><md-input-container class=\"m-0\" \nng-if=\"edition && modelType !== \'INSCRIPTION_MODEL\' && modelType !== \'LOGISTIC_MODEL\'\"><md-switch \nclass=\"md-primary m-0\" ng-model=\"model.checked\" ng-change=\"updateChecked()\">{{\'GENERAL.CHECKED\' | translate}}\n</md-switch></md-input-container></div></div><div layout=\"row\" ng-if=\"modelType === \'INSCRIPTION_MODEL\'\">\n<md-input-container class=\"m-0\"><md-select ng-model=\"model.subCategory\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"edition && updateSubCategory()\"><md-option \nng-repeat=\"sub in subCategories | orderBy: \'index\' track by sub.id\" ng-value=\"sub\">{{ sub.name }}</md-option>\n</md-select><label translate=\"INSCRIPTION_SUB_CATEGORY.TITLE\"></label></md-input-container><md-input-container \nclass=\"m-0\"><md-select md-on-close=\"filterInscriptionStatus = \'\'\" ng-model=\"model.inscriptionStatus\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"edition && updateInscriptionStatus()\"><md-select-header><section>\n<input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterInscriptionStatus\">\n</section></md-select-header><md-option \nng-repeat=\"status in inscriptionStatuses | filterText: filterInscriptionStatus | orderBy: \'index\' track by status.id\" \nng-value=\"status\">{{ status.name }}</md-option></md-select><label translate=\"INSCRIPTION_STATUS.TITLE\"></label>\n</md-input-container><md-input-container class=\"m-0\"><md-select ng-model=\"model.logistic\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"edition && updateLogisticStatus()\"><md-option \nng-repeat=\"logistic in logistics | orderBy: \'index\' track by logistic.id\" ng-value=\"logistic\">{{ logistic.name }}\n</md-option></md-select><label translate=\"LOGISTICAL_STATUS.TITLE\"></label></md-input-container></div>\n<noo-infos-category model=\"model\" ng-if=\"edition\" form-name=\"formName\" ng-model=\"category\" level=\"firstLevel\" \nedition=\"edition\" ng-repeat=\"category in categories | orderBy: \'index\' track by category.id\" sub-type=\"subTypeId\" \nmodel-type=\"modelType\"></noo-infos-category><noo-infos-category model=\"model\" ng-if=\"!edition\" form-name=\"formName\" \nng-model=\"category\" level=\"firstLevel\" edition=\"edition\" \nng-repeat=\"category in categories | filter : { required: true } | orderBy: \'index\' track by category.id\" \nsub-type=\"subTypeId\" model-type=\"modelType\"></noo-infos-category></div>");
$templateCache.put("app/main/models/input.html","<div ng-form=\"cellForm\" ng-switch=\"content\"><md-input-container class=\"nl-Input-container\" ng-switch-when=\"STRING\" \nng-class=\"\"><label>{{model.libelle}}</label><input ng-required=\"model.required\" ng-model=\"model.value\" \nid=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" type=\"text\" class=\"\" ng-disabled=\"!(model.fieldEditable)\" \nng-model-options=\"{ updateOn: \'blur\' }\"><div ng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span></div></md-input-container><md-input-container class=\"nl-Input-container\" \nng-switch-when=\"DATE\"><label class=\"floating-label textarea-label\" for=\"genericField_{{model.id+ \'_\'+index}} \">\n{{model.libelle}}</label><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"model.dateTime\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" \nng-disabled=\"!model.fieldEditable\" ng-required=\"model.required\"></md-datepicker></md-input-container>\n<md-input-container class=\"nl-Input-container\" ng-switch-when=\"URL\" ng-class=\"\"><label>{{model.libelle}}</label><input \nng-required=\"model.required\" ng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" \ntype=\"text\" class=\"\" ng-disabled=\"!(model.fieldEditable)\" ng-model-options=\"{ updateOn: \'blur\' }\"><div \nng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span> <span \nng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div></md-input-container><md-input-container \nclass=\"nl-Input-container\" ng-switch-when=\"EMAIL\" ng-class=\"\"><label>{{model.libelle}}</label><input \nng-required=\"model.required\" ng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" \ntype=\"text\" class=\"\" ng-disabled=\"!(model.fieldEditable)\" ng-model-options=\"{ updateOn: \'blur\' }\"><div \nng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span> <span \nng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div></md-input-container><md-input-container \nclass=\"nl-Input-container\" ng-switch-when=\"INTEGER\"><label>{{model.libelle}}</label><input string-to-number \nng-required=\"model.required\" ng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" \ntype=\"number\" class=\"\" ng-disabled=\"!(model.fieldEditable)\" step=\"1\" ng-pattern=\"/^[0-9]\\d*$/\" \nng-model-options=\"{ updateOn: \'blur\' }\"><div ng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span> <span ng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"NUMBER\"><label>{{model.libelle}}</label><input \nstring-to-number ng-required=\"model.required\" ng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" \nname=\"genericField\" type=\"number\" class=\"\" ng-disabled=\"!(model.fieldEditable)\" step=\"any\" \nng-model-options=\"{ updateOn: \'blur\' }\"><div ng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span> <span ng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"LONG_STRING\"><label class=\"floating-label textarea-label\">\n{{model.libelle}}</label><textarea md-detect-hidden ng-required=\"model.required\" ng-model=\"model.value\" \nid=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" class=\"\" ng-disabled=\"!(model.fieldEditable)\" rows=\"3\" \nng-model-options=\"{ updateOn: \'blur\' }\"></textarea><div ng-messages=\"cellForm.genericField.$error\"><span \nng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div></md-input-container><div ng-switch-when=\"RICH_TEXT\" \nclass=\"nl_Trix\"><label class=\"nl_Trix-label\">{{model.libelle}}</label><ng-quill-editor ng-required=\"model.required\" \nng-disabled=\"!(model.fieldEditable)\" angular-trix ng-model=\"model.value\" name=\"genericField\" \nng-model-options=\"{ debounce: 200 }\"></ng-quill-editor></div><md-input-container ng-switch-when=\"BOOLEAN\"><md-switch \nid=\"genericField_{{model.id+ \'_\'+index}}\" ng-disabled=\"!(model.fieldEditable)\" ng-model=\"model.value\" \naria-label=\"Switch 2\" class=\"md-primary\" name=\"genericField\" ng-model-options=\"{ updateOn: \'blur\' }\">{{model.libelle}}\n</md-switch><div ng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\">\n</span></div></md-input-container><md-input-container ng-switch-when=\"LIST_SELECT\"><md-select md-on-open=\"\" \nmd-on-close=\"filterSelectText = \'\'\" id=\"genericField_{{model.id+ \'_\'+index}} \" name=\"genericField \" \nng-required=\"model.required \" ng-disabled=\"!(model.fieldEditable)\" ng-model=\"model.value\" \nng-model-options=\"{\'trackBy\': \'$value.id\'}\" ng-style=\"model.value.color != null ?{\'color\': model.value.color} : {}\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"event.stopPropagation()\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option ng-value=\"null\"></md-option><md-option \nng-repeat=\"option in model.listFieldsDTO | filterText: filterSelectText | orderBy : \'index\' track by option.id\" \nng-value=\"option\" ng-style=\"option.color != null ?{\'color\': option.color} : {}\">{{option.value}}</md-option>\n</md-select><label>{{model.libelle}}</label><div ng-messages=\"cellForm.genericField.$error\"><span \nng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div></md-input-container><md-input-container \nng-switch-when=\"MULTIPLE_SELECT\"><md-select md-on-open=\"\" md-on-close=\"filterSelectText = \'\'\" \nid=\"genericField_{{model.id+ \'_\'+index}} \" name=\"genericField \" ng-required=\"model.required \" \nng-disabled=\"!(model.fieldEditable) \" ng-model=\"model.values \" ng-model-options=\"{\'trackBy\': \'$value.id\'}\" \nmultiple=\"multiple\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"event.stopPropagation()\" ng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"option in model.selectableObject | filterText: filterSelectText | orderBy: \'index\' track by option.id\" \nng-value=\"option\"><span ng-style=\"option.color != null ?{\'color\': option.color} : {}\">\n{{option.libelle != null ? option.libelle : option.value}}</span></md-option></md-select><label>{{model.libelle}}\n</label><div ng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\">\n</span></div></md-input-container><div class=\"nl-info-block-list-img animated fadeIn\" ng-switch-when=\"IMAGE\"><label \nfor=\"genericField_{{model.id+\'_\'+index}}\" style=\"color: rgba(0,0,0,0.38)\">{{field.name}} <span ng-if=\"required\" \nstyle=\"color:rgb(213,0,0)\">*</span></label><dropify-directive id=\"genericField_file_{{model.id+ \'_\'+model.index}}\" \nfilesave=\"photo.uploadFile\" ng-model=\"model\"></div><md-input-container class=\"nl-Input-container\" flex=\"100\" \nng-switch-when=\"IMAGE\"><input type=\"text\" ng-model-options=\"{updateOn: \'blur\'}\" ng-model=\"model.description\"><label>\n{{ \"COMPANIES.PHOTO_DESCRIPTION\" | translate}}</label></md-input-container><md-input-container md-no-float \nng-switch-when=\"FILE\"><label>{{model.libelle}}</label><input type=\"file\" placeholder=\"{{model.libelle}}\" \nng-model=\"model.value\" id=\"genericField_file_{{model.id+ \'_\'+model.index}}\" name=\"genericField\"><div \nng-if=\"model.location != null\" ng-click=\"download()\" style=\"text-decoration: underline\">{{model.filename}}</div>\n</md-input-container><md-input-container ng-switch-default><label>{{model.libelle}}</label><input \nng-model=\"model.value \" id=\"genericField_{{model.id+ \'_\'+index}} \" name=\"genericField \" type=\"text \" class=\"\" \nng-disabled=\"!(model.fieldEditable) \" ng-model-options=\"{ updateOn: \'blur\' }\"></md-input-container></div>");
$templateCache.put("app/main/models/model.html","<div class=\"mb-15\"><form class=\"form-horizontal\" name=\"updateCategoryForm\" role=\"form\" novalidate><div \nng-repeat=\"category in categories | orderBy:\'index\' track by category.id\" class=\"nl-Block\" ng-form=\"categoryForm\"><div \nng-init=\"category.show = false; category.active = false; !!category.subCategories ? \'\' : category.subCategories = [];\">\n<div layout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"flex-sm-100\"><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"mt-25 mb-0\" flex=\"noshrink\"><input \nng-disabled=\"!category.active\" type=\"text\" ng-model=\"category.name\" name=\"name\" maxlength=\"255\" required><div \nng-messages=\"categoryForm.name.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"ml-25 mt-0 mb-0\" ng-if=\"level > 0\" flex=\"noshrink\"><label>\n{{\'SETTINGS.DATABASE.MODELS.CATEGORY_SIZE\' | translate}}</label><md-select ng-disabled=\"!category.active\" \nng-model=\"category.size\"><md-option ng-value=\"10\">10%</md-option><md-option ng-value=\"15\">15%</md-option><md-option \nng-value=\"20\">20%</md-option><md-option ng-value=\"25\">25%</md-option><md-option ng-value=\"33\">33%</md-option><md-option\n ng-value=\"50\">50%</md-option><md-option ng-value=\"66\">66%</md-option><md-option ng-value=\"75\">75%</md-option>\n<md-option ng-value=\"100\">100%</md-option></md-select></md-input-container></div></div><div class=\"flex-sm-100\"><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div class=\"flex-xs-100\" layout=\"row\" layout-align=\"start center\" \nng-if=\"modelType === \'COMPANY_MODEL\'\"><md-input-container class=\"\" ng-if=\"types != null\" flex=\"auto\"><label \ntranslate=\"SETTINGS.DATABASE.TYPES.TITLE_PAGE\"></label><md-select md-on-close=\"filterSelectText = \'\'\" \nng-disabled=\"!category.active\" ng-model=\"category.subTypes\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nmultiple=\"multiple\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"type in types | filterText: filterSelectText\" ng-value=\"type\">{{type.name}}</md-option></md-select>\n</md-input-container></div><div class=\"flex-xs-100\" layout=\"row\" layout-align=\"start center\"><md-switch \nng-disabled=\"!category.active\" ng-model=\"category.defaultClosed\" class=\"ml-15 md-primary md-hue-2\" \naria-label=\"default closed\">{{\'SETTINGS.DATABASE.MODELS.DEFAULT_CLOSED\' | translate}}</md-switch></div><div \nclass=\"flex-xs-100\" class=\"pl-25\" layout=\"row\" layout-align=\"start center\"><div><md-button type=\"button\" \nclass=\"md-fab md-mini md-accent md-hue-1\" ng-click=\"category.show = !category.show\"><md-icon ng-show=\"category.show\" \nmd-font-icon=\"icon-eye-off\" class=\"s18\"></md-icon><md-icon ng-hide=\"category.show\" md-font-icon=\"icon-eye\" class=\"s18\">\n</md-icon></md-button></div><div ng-if=\"category.active\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"updateCategory(category)\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button></div><div ng-if=\"!category.active\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"category.active = true;\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button></div><div><md-button type=\"button\" \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"removeCategory($index, category);\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button></div><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" ng-disabled=\"!(category.index > 1)\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"upCategory(category)\"><md-icon md-font-icon=\"icon-arrow-up\" \nclass=\"s18\"></md-icon></md-button><md-button type=\"button\" ng-disabled=\"!(category.index != categories.length)\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"downCategory(category)\"><md-icon md-font-icon=\"icon-arrow-down\" \nclass=\"s18\"></md-icon></md-button></div></div></div></div></div><form class=\"form-horizontal\" role=\"form\" \nname=\"champsForm\" novalidate><div class=\"nl-Models-details\" ng-show=\"category.show\"><div class=\"row\" \nng-repeat=\"champs in category.fields | orderBy:\'index\'\" \nng-init=\"champs.idCategory = category.id; !!champs.listFieldsDTO ? \'\' : champs.listFieldsDTO = [];\" \nng-form=\"updateChampsForm\"><div class=\"form-group\" layout=\"row\"><md-input-container flex=\"auto\" \nclass=\"nl-Form-container--auto nl-container--input\"><div>#{{champs.id}}</div></md-input-container><md-input-container \nflex=\"auto\" class=\"nl-Form-container--auto nl-container--switch\"><md-switch \nng-change=\"activateChamps(champs.id,champs.activated)\" ng-model=\"champs.activated\" aria-label=\"Switch 2\" \nclass=\"md-primary\" name=\"activated\"></md-switch></md-input-container><md-input-container flex=\"auto\"><label>\n{{\'SETTINGS.DATABASE.MODELS.FIELD\' | translate}} {{champs.index}}</label><input class=\"\" ng-disabled=\"!champs.active\" \nname=\"libelle\" type=\"text\" ng-model=\"champs.libelle\" maxlength=\"255\" required><div \nng-messages=\"updateChampsForm.libelle.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container><md-input-container class=\"ml-15\" flex=\"10\"><label>\n{{\'SETTINGS.DATABASE.MODELS.FIELD_SIZE\' | translate}}</label><md-select ng-disabled=\"!champs.active\" \nng-model=\"champs.size\"><md-option ng-value=\"10\">10%</md-option><md-option ng-value=\"15\">15%</md-option><md-option \nng-value=\"20\">20%</md-option><md-option ng-value=\"25\">25%</md-option><md-option ng-value=\"33\">33%</md-option><md-option\n ng-value=\"50\">50%</md-option><md-option ng-value=\"66\">66%</md-option><md-option ng-value=\"75\">75%</md-option>\n<md-option ng-value=\"100\">100%</md-option></md-select></md-input-container><md-input-container class=\"ml-15\" \nflex=\"auto\"><label translate=\"SETTINGS.DATABASE.MODELS.FIELD_TYPE\"></label><md-select ng-disabled=\"!champs.active\" \nng-model=\"champs.typeChamps\"><md-option ng-repeat=\"enumType in enumTypes\" ng-value=\"enumType.type\">\n{{\'SETTINGS.DATABASE.TYPES.\'+enumType.texte | translate}}</md-option></md-select></md-input-container>\n<md-input-container class=\"ml-15\" ng-if=\"types != null && modelType === \'COMPANY_MODEL\'\" flex=\"auto\"><label \ntranslate=\"SETTINGS.DATABASE.TYPES.TITLE_PAGE\"></label><md-select md-on-close=\"filterSelectText = \'\'\" \nng-disabled=\"!champs.active\" ng-model=\"champs.subTypes\" ng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"type in types | filterText: filterSelectText\" ng-value=\"type\">{{type.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"ml-15\" flex=\"10\"><md-checkbox \nid=\"fieldRequiredInputCheckbox-{{$index}}\" class=\"md-primary md-hue-2\" value=\"true\" ng-disabled=\"!champs.active\" \nng-model=\"champs.required\">{{\'GENERAL.REQUIRED\' | translate}}</md-checkbox></md-input-container><md-input-container \nclass=\"ml-15\" flex=\"auto\" ng-if=\"modelType === \'COMPANY_MODEL\'\"><md-checkbox \nid=\"fieldSearchableInputCheckbox-{{$index}}\" class=\"md-primary md-hue-2\" value=\"true\" ng-disabled=\"!champs.active\" \nng-model=\"champs.searchable\">{{\'GENERAL.SEARCHABLE\' | translate}}</md-checkbox></md-input-container><md-input-container\n class=\"ml-15\" flex=\"auto\"><md-checkbox id=\"fieldVisibleByManagerInputCheckbox-{{$index}}\" class=\"md-primary md-hue-2\" \nvalue=\"true\" ng-disabled=\"!champs.active\" ng-model=\"champs.visibleByManager\">\n{{\'GENERAL.VISIBLE_BY_MANAGER\' | translate}}</md-checkbox></md-input-container><md-input-container class=\"ml-15\" \nflex=\"10\"><md-checkbox id=\"fieldProfilePictureInputCheckbox-{{$index}}\" class=\"md-primary md-hue-2\" \nng-disabled=\"!champs.active\" value=\"true\" ng-if=\"champs.typeChamps === \'IMAGE\'\" ng-model=\"champs.profilePicture\">\n{{\'SETTINGS.DATABASE.MODELS.PRINCIPAL_PICTURE\' | translate}}</md-checkbox></md-input-container><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"cancelFieldUpdating(champs.id, category.fields);\" ng-if=\"champs.active\" \ntype=\"button\" class=\"md-fab md-mini md-accent md-hue-1\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</md-button><md-button ng-click=\"updateChamps(champs, updateChampsForm)\" ng-if=\"champs.active\" \nclass=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"((champs.typeChamps == \'LIST\' || champs.typeChamps == \'MULTIPLE_SELECTION\') && (!champs.libelle || champs.listFieldsDTO.length<2)) || (champs.typeChamps != \'LIST\' && !champs.libelle)\">\n<md-icon md-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button><md-button ng-if=\"!champs.active\" \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"enabledFieldUpdating(champs);\" noo-tooltip \ntooltip-title=\"Modifier ce champ\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button><div \nlayout=\"row\" layout-align=\"start center\" class=\"ml-15\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"openMoveChamps(category, champs)\"><md-icon \nmd-font-icon=\"icon-cursor-move\" class=\"s18\"></md-icon></md-button><md-button ng-if=\"champs.index > 1\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"upChamps(category, champs)\" noo-tooltip \ntooltip-title=\"Monter d\'un rang\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-if=\"champs.index != category.fields.length\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"downChamps(category, champs)\" noo-tooltip tooltip-title=\"Descendre d\'un rang\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div><div \nclass=\"form-group offset-md-2 row\" \nng-if=\"(champs.typeChamps == \'LIST_SELECT\' || champs.typeChamps == \'MULTIPLE_SELECT\') && champs.active\"><div \nclass=\"col-xs-12\" ng-class=\"!!enumSubTypes ? \'col-md-7\' : \'col-md-5\'\"><div class=\"panel panel-line\" \nng-class=\"champs.listFieldsDTO.length < 2 ? \'panel-danger\' : \'panel-success\'\"><div class=\"panel-heading\"><h3 \nng-class=\"{\'panel-title\' : champs.listFieldsDTO.length < 2}\"><span ng-if=\"champs.listFieldsDTO.length < 2\">\n{{\'SETTINGS.DATABASE.2_VALUES\' | translate}}</span></h3></div><div class=\"panel-body\"><div \nng-repeat=\"listFieldsDTOItem in champs.listFieldsDTO | orderBy:\'index\'\"><div layout=\"row\"><md-input-container \nclass=\"nl-Input-container\" flex=\"20\"><label>\n{{\'SETTINGS.DATABASE.VALUE\' | translate}} {{listFieldsDTOItem.index}} #{{listFieldsDTOItem.id}}</label><input class=\"\" \ntype=\"text\" ng-model=\"listFieldsDTOItem.value\" name=\"listFieldsDTOItem{{$index}}\" maxlength=\"255\"></md-input-container>\n<md-input-container class=\"nl-Input-container ml-15\" flex=\"20\"><label>\n{{\'SETTINGS.DATABASE.MODELS.COLOR\' | translate}} {{listFieldsDTOItem.index}}</label><input class=\"\" \npattern=\"^#+([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$\" type=\"text\" ng-model=\"listFieldsDTOItem.color\" \nname=\"listFieldsDTOColor{{$index}}\"><div ng-messages=\"champsForm[\'listFieldsDTOColor\'+$index].$error\"><div \nng-message=\"pattern\" translate=\"GENERAL.INVALID_HEX\"></div></div></md-input-container><div layout=\"row\" flex=\"60\">\n<md-button type=\"button\" class=\"md-fab md-mini\" \nng-click=\"removeItemFromFieldListType(listFieldsDTOItem, champs.listFieldsDTO)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s18\"></md-icon></md-button><md-button ng-if=\"listFieldsDTOItem.index > 1\" type=\"button\" class=\"md-fab md-mini\" \nng-click=\"upFieldListTypeItem(listFieldsDTOItem, champs.listFieldsDTO)\" noo-tooltip tooltip-title=\"Monter d\'un rang\">\n<md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-if=\"listFieldsDTOItem.index != champs.listFieldsDTO.length\" type=\"button\" class=\"md-fab md-mini\" \nng-click=\"downFieldListTypeItem(listFieldsDTOItem, champs.listFieldsDTO)\"><md-icon md-font-icon=\"icon-arrow-down\" \nclass=\"s18\"></md-icon></md-button></div></div></div><div layout=\"row\" \nng-init=\'this[\"_newItemForUpdating\"+this.champs.index] = {}\'><md-input-container class=\"nl-Input-container\" flex=\"20\">\n<label>{{\'SETTINGS.DATABASE.VALUE\' | translate}}</label><input class=\"\" type=\"text\" \nng-model=\'this[\"_newItemForUpdating\"+this.champs.index].value\' maxlength=\"255\"></md-input-container><md-input-container\n class=\"nl-Input-container ml-15\" flex=\"20\"><label>\n{{\'SETTINGS.DATABASE.MODELS.COLOR\' | translate}} {{listFieldsDTOItem.index}}</label><input class=\"\" type=\"text\" \nng-model=\'this[\"_newItemForUpdating\"+this.champs.index].color\' maxlength=\"255\"></md-input-container><div \nclass=\"col-md-6 col-xs-12\" layout=\"row\"><md-button ng-disabled=\'!this[\"_newItemForUpdating\"+this.champs.index].value\' \ntype=\"button\" class=\"md-fab md-mini\" \nng-click=\'addItemToFieldListType(this[\"_newItemForUpdating\"+this.champs.index], champs.listFieldsDTO); this[\"_newItemForUpdating\"+this.champs.index] = {};\'>\n<md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div><div \nlayout=\"column\" \nng-init=\"category.newChamps = {idCategory: category.id, typeChamps:\'STRING\', listFieldsDTO:[], modelType: modelType, size:100};\" \nng-form=\"newChampsForm\"><div class=\"form-group\" layout=\"row\"><md-input-container class=\"mb-0\" flex=\"auto\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.NAME\"></label><input class=\"\" type=\"text\" ng-model=\"category.newChamps.libelle\" \nname=\"libelle\" required maxlength=\"255\"><div ng-messages=\"newChampsForm.libelle.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container class=\"ml-15 mb-0\" flex=\"auto\">\n<label translate=\"SETTINGS.DATABASE.MODELS.FIELD_SIZE\"></label><md-select ng-model=\"category.newChamps.size\"><md-option\n ng-value=\"10\">10%</md-option><md-option ng-value=\"15\">15%</md-option><md-option ng-value=\"20\">20%</md-option>\n<md-option ng-value=\"25\">25%</md-option><md-option ng-value=\"33\">33%</md-option><md-option ng-value=\"50\">50%\n</md-option><md-option ng-value=\"66\">66%</md-option><md-option ng-value=\"75\">75%</md-option><md-option ng-value=\"100\">\n100%</md-option></md-select></md-input-container><md-input-container class=\"ml-15 mb-0\" flex=\"auto\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.FIELD_TYPE\"></label><md-select ng-model=\"category.newChamps.typeChamps\"><md-option \nng-repeat=\"enumType in enumTypes\" ng-value=\"enumType.type\">{{\'SETTINGS.DATABASE.TYPES.\'+enumType.texte | translate}}\n</md-option></md-select></md-input-container><md-input-container class=\"ml-15 mb-0\" \nng-if=\"types != null && modelType === \'COMPANY_MODEL\'\" flex=\"auto\"><label \ntranslate=\"SETTINGS.DATABASE.TYPES.TITLE_PAGE\"></label><md-select md-on-close=\"filterSelectTextSub = \'\'\" \nng-model=\"category.newChamps.subTypes\" multiple=\"multiple\"><md-select-header><section><input force-select-focus \ntype=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextSub\"></section></md-select-header>\n<md-option ng-repeat=\"type in types | filterText: filterSelectTextSub\" ng-value=\"type\">{{type.name}}</md-option>\n</md-select></md-input-container><md-input-container class=\"ml-15 mb-0\" flex=\"auto\"><md-checkbox \nid=\"newFieldRequiredInputCheckbox-{{$index}}\" class=\"md-primary md-hue-2\" value=\"true\" \nng-model=\"category.newChamps.required\">{{\"GENERAL.REQUIRED\" | translate}}</md-checkbox></md-input-container>\n<md-input-container class=\"ml-15 mb-0\" flex=\"auto\" ng-if=\"modelType === \'COMPANY_MODEL\'\"><md-checkbox \nid=\"newFieldSearchableInputCheckbox-{{$index}}\" class=\"md-primary md-hue-2\" value=\"true\" \nng-model=\"category.newChamps.searchable\">{{\"GENERAL.SEARCHABLE\" | translate}}</md-checkbox></md-input-container>\n<md-input-container class=\"ml-15\" flex=\"auto\"><md-checkbox id=\"newFieldVisibleByManagerInputCheckbox-{{$index}}\" \nclass=\"md-primary md-hue-2\" value=\"true\" ng-model=\"category.newChamps.visibleByManager\">\n{{\'GENERAL.VISIBLE_BY_MANAGER\' | translate}}</md-checkbox></md-input-container><div class=\"\" layout=\"row\" \nlayout-align=\"end center\"><md-button \nng-disabled=\"((category.newChamps.typeChamps == \'LIST_SELECT\' || category.newChamps.typeChamps == \'MULTIPLE_SELECT\') && (!category.newChamps.libelle || category.newChamps.listFieldsDTO.length<2)) || ((category.newChamps.typeChamps != \'LIST_SELECT\' || category.newChamps.typeChamps == \'MULTIPLE_SELECT\') && !category.newChamps.libelle)\" \ntype=\"button\" class=\"md-raised md-primary md-hue-2\" ng-click=\"saveChamps(category, newChampsForm);\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div><div \nclass=\"form-group offset-md-2 row\" \nng-if=\"category.newChamps.typeChamps == \'LIST_SELECT\' || category.newChamps.typeChamps == \'MULTIPLE_SELECT\'\"><div \nclass=\"col-xs-12\" ng-class=\"!!enumSubTypes ? \'col-md-7\' : \'col-md-5\'\"><div class=\"panel panel-line\" \nng-class=\"category.newChamps.listFieldsDTO.length < 2 ? \'panel-danger\' : \'panel-success\'\"><div class=\"panel-heading\">\n<h3 ng-class=\"{\'panel-title\' : category.newChamps.listFieldsDTO.length < 2}\"><span \nng-if=\"category.newChamps.listFieldsDTO.length < 2\">{{\'SETTINGS.DATABASE.2_VALUES\' | translate}}</span></h3></div><div \nclass=\"panel-body\"><div ng-repeat=\"listFieldsDTOItem in category.newChamps.listFieldsDTO | orderBy:\'index\'\"><div \nlayout=\"row\"><md-input-container><label>{{\'SETTINGS.DATABASE.VALUE\' | translate}} {{listFieldsDTOItem.index}}</label>\n<input class=\"\" type=\"text\" ng-model=\"listFieldsDTOItem.value\" name=\"listFieldsDTOItem{{$index}}\" maxlength=\"255\">\n</md-input-container><div class=\"\"><md-button type=\"button\" class=\"md-fab md-mini\" \nng-click=\"removeItemFromFieldListType($index, category.newChamps.listFieldsDTO)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s18\"></md-icon></md-button><md-button ng-if=\"listFieldsDTOItem.index > 1\" type=\"button\" class=\"md-fab md-mini\" \nng-click=\"upFieldListTypeItem(listFieldsDTOItem, category.newChamps.listFieldsDTO)\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-if=\"listFieldsDTOItem.index != category.newChamps.listFieldsDTO.length\" type=\"button\" class=\"md-fab md-mini\" \nng-click=\"downFieldListTypeItem(listFieldsDTOItem, category.newChamps.listFieldsDTO)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div><div layout=\"row\" \nng-init=\"_newItemForCreating = {}\"><md-input-container><label>{{\'SETTINGS.DATABASE.VALUE\' | translate}}</label><input \ntype=\"text\" ng-model=\"_newItemForCreating.value\" maxlength=\"255\"></md-input-container><div class=\"\"><md-button \ntype=\"button\" ng-disabled=\"!_newItemForCreating.value\" class=\"md-fab md-mini\" \nng-click=\"addItemToFieldListType(_newItemForCreating, category.newChamps.listFieldsDTO); _newItemForCreating = {};\">\n<md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div><div \nng-if=\"level < 1\"><model-builder model-type=\"modelType\" base-url=\"baseUrl\" categories=\"category.subCategories\" \nlanguage=\"language\" level=\"level+1\" event-id=\"eventId\" parent-id=\"category.id\"></model-builder></div></div></form>\n</div></div></form><div class=\"nl-loader\" ng-show=\"!loaded\" ng-if=\"level === 0\"><div class=\"spinner\"><div \nclass=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div></div><div class=\"nl-Block\" ng-show=\"level<2\"><div \nng-init=\"showModelHelp = false;\"><div class=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" \nlayout-align=\"space-between center\"><div><span ng-show=\"level === 0\" \ntranslate=\"SETTINGS.DATABASE.MODELS.CREATE_CATEGORY\"></span> <span ng-show=\"level > 0\" \ntranslate=\"SETTINGS.DATABASE.MODELS.CREATE_SUBCATEGORY\"></span></div></div></div><div><div><div><form \nclass=\"form-horizontal\" name=\"newCategoryForm\" role=\"form\" novalidate><div ng-form=\"newCategoryMiniForm\"><div \nng-show=\"showModelHelp\" class=\"nl-Models-help\"><help-model-builder help-model-title=\"helpModelTitle\" \nhelp-model-content=\"helpModelContent\"><help-model-builder></help-model-builder></help-model-builder></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"mt-10\"><div layout=\"row\" layout-align=\"start center\">\n<md-input-container flex=\"noshrink\" class=\"mt-25 mb-0\"><label>{{\'SETTINGS.DATABASE.MODELS.NAME\' | translate}}</label>\n<input type=\"text\" ng-model=\"newCategory.name\" name=\"name\" maxlength=\"255\" required><div \nng-messages=\"newCategoryMiniForm.name.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container><md-input-container class=\"ml-15 mt-0 mb-0\" flex=\"noshrink\" ng-if=\"level > 0\"><label>\n{{\'SETTINGS.DATABASE.MODELS.CATEGORY_SIZE\' | translate}}</label><md-select ng-model=\"newCategory.size\"><md-option \nng-value=\"10\">10%</md-option><md-option ng-value=\"15\">15%</md-option><md-option ng-value=\"20\">20%</md-option><md-option\n ng-value=\"25\">25%</md-option><md-option ng-value=\"33\">33%</md-option><md-option ng-value=\"50\">50%</md-option>\n<md-option ng-value=\"66\">66%</md-option><md-option ng-value=\"75\">75%</md-option><md-option ng-value=\"100\">100%\n</md-option></md-select></md-input-container></div><div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"ml-15\" ng-if=\"types != null && modelType === \'COMPANY_MODEL\'\" \nflex=\"auto\"><label translate=\"SETTINGS.DATABASE.TYPES.TITLE_PAGE\"></label><md-select \nmd-on-close=\"filterSelectText = \'\'\" ng-model=\"newCategory.subTypes\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nmultiple=\"multiple\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"type in types | filterText: filterSelectText\" ng-value=\"type\">{{type.name}}</md-option></md-select>\n</md-input-container></div><div class=\"mr-20\"><md-switch ng-model=\"newCategory.defaultClosed\" \nclass=\"md-primary md-hue-2\" aria-label=\"default closed\">{{\'SETTINGS.DATABASE.MODELS.DEFAULT_CLOSED\' | translate}}\n</md-switch></div><md-button md-no-ink type=\"button\" class=\"md-raised md-primary md-hue-2\" \nng-click=\"saveCategory(newCategoryMiniForm);\"><md-icon md-font-icon=\"icon-plus pb-\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/main/models/model_types.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"SETTINGS.DATABASE.TYPES.TITLE_COMPANY\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-input-container><md-select \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><div class=\"\"><model-type this-model=\"modelType\" types=\"types\" base-url=\"baseUrl\" \nlanguage=\"language\"></model-type></div></div></div>");
$templateCache.put("app/main/models/model_view.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" ng-if=\"modelType === \'COMPANY_MODEL\'\" translate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\">\n</div><div class=\"\" ng-if=\"modelType === \'CONTACT_MODEL\'\" translate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\"></div>\n</div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide \nshow-gt-sm><md-input-container><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><model-builder ng-init=\"firstTreeLevel = 0\" model-type=\"modelType\" base-url=\"baseUrl\" \ncategories=\"categories\" level=\"firstTreeLevel\" language=\"language\" help-model-title=\"helpModelTitle\" \nhelp-model-content=\"helpModelContent\" event-id=\"eventId\"></model-builder><div class=\"nl-Block mt-15\" \nng-if=\"modelType !== \'COMPANY_MODEL\' && modelType !== \'INSCRIPTION_MODEL\' && modelType !== \'LOGISTIC_MODEL\'\">\n<draw-token-builder base-url=\"baseUrl\" draw-token-title=\"drawTokenTitle\" help-draw-token-title=\"helpDrawTokenTitle\" \nhelp-draw-token-content=\"helpDrawTokenContent\" language=\"language\"></draw-token-builder></div></div></div>");
$templateCache.put("app/main/models/move_field.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">\n{{\'SETTINGS.DATABASE.MODELS.MOVE_FIELD\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form novalidate name=\"moveFieldForm\" ng-submit=\"moveFieldForm.$valid && update()\"><md-dialog-content>\n<md-input-container><md-select ng-model=\"champs.idCategory\" name=\"idCategory\" required><md-option \nng-repeat=\"category in categories track by category.id\" ng-value=\"category.id\" \nng-disabled=\"currentCategory.id === category.id\">{{category.name}}</md-option></md-select><label>\n{{\'SETTINGS.DATABASE.MODELS.CATEGORY\' | translate}}</label><div ng-messages=\"moveFieldForm.idCategory.$error\"><span \nng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\"><md-button class=\"md-primary md-raised md-hue-2\" type=\"submit\" \ntranslate=\"GENERAL.SAVE\"></md-button><md-button type=\"button\" class=\"md-warn md-hue-2\" ng-click=\"hidePopup()\" \ntranslate=\"GENERAL.CANCEL\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/models/simple_model.html","<div class=\"row\"><div class=\"col-md-12\"><div class=\"portlet light portlet-fit portlet-datatable bordered\"><div \nclass=\"portlet-title\"><div class=\"caption\"><i class=\"icon-settings font-dark\"></i> <span \nclass=\"caption-subject font-dark sbold uppercase\">{{modelTitle}}</span></div><div class=\"actions\"><a \nng-click=\"showHelp = !showHelp\" class=\"btn btn-circle btn-icon-only btn-default\" href=\"javascript:;\"><i \nclass=\"fa fa-question\"></i></a></div><div class=\"inputs\" style=\"margin-top: 1.2px\"><div \nclass=\"portlet-input input-inline input-medium\" style=\"margin-right: 20px\"><input type=\"text\" \nclass=\"form-control form-control input-circle\" placeholder=\"Rechercher ici ...\" ng-model=\"simpleModelSearch\"></div>\n</div></div><div class=\"portlet-body\"><form novalidate class=\"form-horizontal\" name=\"modelForm\"><div \nng-show=\"showHelp\" class=\"note note-info\"><h3>{{helpModelTitle}}</h3><p>\nPour commencer, vous devez entrer le libellé de votre modèle et cliquer sur <a \nclass=\"btn btn-circle btn-icon-only green\" href=\"javascript:;\"><i class=\"fa fa-plus\"></i></a></p><p>Les boutons <a \nclass=\"btn btn-circle btn-icon-only btn-default\" href=\"javascript:;\"><i class=\"fa fa-arrow-up\"></i> </a>et <a \nclass=\"btn btn-circle btn-icon-only btn-default\" href=\"javascript:;\"><i class=\"fa fa-arrow-down\"></i> </a>\nvous permettrons de réordonner les modèles</p><p>\nPour modifier un champs, commencer par activer la modification avec le bouton <a \nclass=\"btn btn-circle btn-icon-only btn-default\" href=\"javascript:;\"><i class=\"fa fa-pencil-square-o\"></i> </a>.</p><p>\nIl faut ensuite modifier le libellé du champs et valider la modification en cliquant sur <a \nclass=\"btn btn-circle btn-icon-only btn-success\" href=\"javascript:;\"><i class=\"fa fa-save\"></i></a></p><p>\nPour supprimer un champs, il faut cliquer sur <a class=\"btn btn-circle btn-icon-only btn-danger\" href=\"javascript:;\"><i\n class=\"fa fa-trash\"></i></a></p><p>ATTENTION toutes les informations liées à ce champs seront supprimé!</p></div><div \nclass=\"form-body\"><div class=\"row\"><div \nng-repeat=\"field in fields | filter: {libelle : simpleModelSearch} | orderBy:\'index\'\" class=\"form-group\"><label \nclass=\"col-md-3 control-label\">{{modelName}} {{field.index}}</label><div class=\"col-md-4\"><input \nng-disabled=\"!field.active\" type=\"text\" ng-model=\"field.libelle\" class=\"form-control\"></div><div class=\"col-md-4\"><a \nng-if=\"field.active\" ng-click=\"updateField(field)\" class=\"btn btn-circle btn-icon-only btn-success\" \nhref=\"javascript:;\"><i class=\"fa fa-save\"></i> </a><a ng-if=\"!field.active\" ng-click=\"field.active = !field.active\" \nclass=\"btn btn-circle btn-icon-only btn-default\" href=\"javascript:;\"><i class=\"fa fa-pencil-square-o\"></i> </a><button \nclass=\"btn btn-circle btn-icon-only btn-danger\" mwl-confirm title=\"Suppression\" \nmessage=\"Êtes-vous sûr de vouloir supprimer ce champs?\" confirm-text=\"Valider\" cancel-text=\"Annuler\" placement=\"top\" \non-confirm=\"removeField(field)\" on-cancel=\"cancelClicked = true\" confirm-button-type=\"danger\" \ncancel-button-type=\"default\"><i class=\"fa fa-trash\"></i></button> <a ng-if=\"field.index > 1\" ng-click=\"upField(field)\" \nclass=\"btn btn-circle btn-icon-only btn-default\" href=\"javascript:;\"><i class=\"fa fa-arrow-up\"></i> </a><a \nng-if=\"field.index != fields.length\" ng-click=\"downField(field)\" class=\"btn btn-circle btn-icon-only btn-default\" \nhref=\"javascript:;\"><i class=\"fa fa-arrow-down\"></i></a></div></div><div class=\"form-group\"><label \nclass=\"col-md-3 control-label\">Nom</label><div class=\"col-md-4\"><input type=\"text\" ng-model=\"newField.libelle\" \nclass=\"form-control\"></div><div class=\"col-md-4\"><a ng-click=\"saveField();\" class=\"btn btn-circle btn-icon-only green\" \nhref=\"javascript:;\"><i class=\"fa fa-plus\"></i></a></div></div></div></div></form></div></div></div></div>");
$templateCache.put("app/main/models/type.html","<div class=\"nl-Block\"><div><div class=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" \nlayout-align=\"space-between center\"><div><span translate=\"SETTINGS.DATABASE.TYPES.CREATION\"></span></div><div></div>\n</div></div><div><div><div><form class=\"form-horizontal\" role=\"form\" novalidate name=\"addTypeForm\" \nng-submit=\"addTypeForm.$valid && saveType()\"><div><div layout=\"row\"><md-input-container><label>\n{{\'SETTINGS.DATABASE.TYPES.NAME\' | translate}}</label><input type=\"text\" name=\"name\" ng-model=\"newType.name\" required \nmaxlength=\"255\"><div ng-messages=\"addTypeForm.name.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><div><md-button type=\"submit\" \nclass=\"md-raised md-primary md-hue-2\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form></div></div></div></div><div class=\"mt-15\"><div \nng-repeat=\"type in types | orderBy:\'index\'\" class=\"nl-Block\"><form \nng-submit=\"type.active && updateTypeForm.$valid && updateType(type)\" novalidate name=\"updateForm\"><ng-form \nname=\"updateTypeForm\"><div><div class=\"panel panel panel-bordered m-b-0\"><div layout=\"row\" layout-align=\"start center\">\n<div flex=\"5\"><i class=\"icon md-widgets\" aria-hidden=\"true\"></i> &nbsp;#{{type.id}}</div><div><div \nclass=\"input-search inline-block\"><md-input-container class=\"mt-18 mb-0\"><input type=\"text\" ng-disabled=\"!type.active\" \nng-model=\"type.name\" name=\"name_update\" required maxlength=\"255\"><div ng-messages=\"updateTypeForm.name_update.$error\" \nrole=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div>\n</div><div class=\"ml-25\" layout=\"row\" layout-align=\"end end\"><div ng-if=\"type.active\"><md-button type=\"submit\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button>\n</div><div ng-if=\"!type.active\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"type.active = true;\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button></div><div>\n<md-button type=\"button\" class=\"md-fab md-mini md-accent\" ng-click=\"filterConfig(type);\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"s18\"></md-icon></md-button></div><div><md-button type=\"button\" \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"removeType($index, type);\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s18\"></md-icon></md-button></div><div class=\"ml-15\" layout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"$index === 0 || loading\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"upType(type, $index)\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-disabled=\"$last || loading\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"downType(type, $last)\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div>\n</div></div></div><div class=\"nl-Models-details\"><draw-token-builder base-url=\"baseUrl\" \ndraw-token-title=\"\'to translate\'\" help-draw-token-title=\"\'to translate\'\" help-draw-token-content=\"\'to translate\'\" \nlanguage=\"language\" sub-type-id=\"type.id\" model-type=\"thisModel\"></draw-token-builder></div></ng-form></form></div>\n</div>");
$templateCache.put("app/main/newsletter/newsletter.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\">{{ \"NEWSLETTER.LIST_TITLE\" | translate}}</div></div></div><div class=\"content\"><div \nflex=\"20\" layout=\"row\" ng-if=\"newsletters!=[] && loaded\"><md-button ng-click=\"export()\" \nclass=\"md-primary md-hue-2 submit-button md-raised mt-0\" ng-disabled=\"exportInProgress\" flex \nlayout-align=\"center center\"><md-icon md-font-icon=\"icon-export\"></md-icon>{{\'COMPANIES.EXPORT.TITLE\' | translate}}\n</md-button></div><div class=\"nl-Block nl-Block--table\"><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\">\n<div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\">\n<div class=\"half-circle\"></div></div></div></div></div><div layout=\"row\"><table nl-responsive-table \nnl-table-data=\"arrayData\" class=\"dataTable row-border hover\"><thead><th translate=\"NEWSLETTER.FIELDS.REGISTER_DATE\">\n</th><th translate=\"NEWSLETTER.FIELDS.MAIL\"></th><th translate=\"NEWSLETTER.FIELDS.ACTIONS\"></th></thead><tbody><tr \nng-repeat=\"data in newsletters | orderBy: \'-creationDate\' as arrayData\"><td>\n{{data.creationDate | date : \'dd/MM/yy HH:mm\'}}</td><td>{{data.email}}</td><td><button \nclass=\"md-fab md-mini md-warn md-hue-2 md-button md-teal-theme-theme md-ink-ripple\" type=\"button\" \nng-click=\"deleteItem(data.id)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s20 md-teal-theme-theme md-font material-icons icon-delete\" role=\"img\" aria-label=\"icon-delete\"></md-icon>\n</button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/notations/notations.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\">{{ \"NOTATIONS.TITLE\" | translate}}</div></div></div><div class=\"content\"><div \nclass=\"nl-Block nl-Block--table\"><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div><div layout=\"row\"><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"dataTable row-border hover\"><thead><th translate=\"NOTATIONS.DATE\"></th><th translate=\"NOTATIONS.ACCOUNT\"></th>\n<th translate=\"NOTATIONS.COMPANY\"></th><th translate=\"NOTATIONS.NOTE\"></th><th translate=\"NOTATIONS.COMMENT\"></th><th \ntranslate=\"NOTATIONS.STATE\"></th></thead><tbody><tr \nng-repeat=\"data in notations | orderBy: \'-creationDate\' as arrayData\"><td>\n{{data.creationDate | date : \'dd/MM/yy HH:mm\'}}</td><td>\n{{data.user.applicantLastName}} {{data.user.applicantFirstName}} {{data.user.applicantCompany ? \' - \'+ data.user.applicantCompany : \'\'}}\n</td><td>{{data.company.modelPattern}}</td><td>{{data.value}}</td><td><button \nclass=\"md-accent md-raised md-hue-2 md-button\" ng-click=\"showComment(data)\">{{ \"NOTATIONS.SHOW_COMMENT\" | translate}}\n</button></td><td><md-checkbox class=\"md-primary md-hue-2\" readonly=\"readonly\" ng-model=\"data.validate\" \naria-label=\"favorite\" ng-click=\"setValidate(data)\"><span ng-if=\"data.validate\">{{ \"NOTATIONS.VALID\" | translate}}\n</span> <span ng-if=\"!data.validate\">{{ \"NOTATIONS.NOT_VALID\" | translate}}</span></md-checkbox></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/packages/packages.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"PACKAGES.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"goAdd()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\"GENERAL.ADD\" | translate}}\n</md-button><div><md-input-container flex><md-select ng-change=\"initPackages()\" ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex><md-select ng-change=\"initPackages()\" \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div></div><div class=\"content\"><div class=\"nl-Block nl-Block--table\"><div \nclass=\"nl-listing\"><table nl-responsive-table nl-table-data=\"arrayData\" class=\"simple list-view\"><thead><th>\n{{\"PACKAGES.COLUMNS.NAME\" | translate}}</th><th>{{\"PACKAGES.COLUMNS.DURATION\" | translate}}</th><th>\n{{\"PACKAGES.COLUMNS.REGION\" | translate}}</th><th>{{\"PACKAGES.COLUMNS.TYPE\" | translate}}</th><th>\n{{\"PACKAGES.COLUMNS.COMPANY_NAME\" | translate}}</th><th>{{\"FESTIVAL.CREATION.PUBLISH\" | translate}}</th><th>\n{{\"PACKAGES.COLUMNS.ACTIONS\" | translate}}</th></thead><tbody><tr \nng-repeat=\"package in packages | orderBy : \'name\' as arrayData track by $index\"><td>{{package.name}}</td><td>\n{{package.duration}}</td><td><span ng-if=\"package.regions != null && package.regions.length > 0\" \nng-repeat=\"region in package.regions | limitTo: 3\">{{region.value}} <span ng-if=\"!$last\">{{\', \'}}</span> <span \nng-if=\"$last && package.regions.length > 3\">{{\',...\'}}</span></span></td><td><span \nng-if=\"package.typesTourisme != null && package.typesTourisme.length > 0\" \nng-repeat=\"type in package.typesTourisme | limitTo: 3\">{{type.value}} <span ng-if=\"!$last\">{{\', \'}}</span> <span \nng-if=\"$last && package.typesTourisme.length > 3\">{{\',...\'}}</span></span></td><td>{{package.company}}</td><td>\n<md-checkbox readonly=\"readonly\" disabled=\"disabled\" ng-model=\"package.publish\" aria-label=\"publish\"></md-checkbox>\n</td><td><md-button md-no-ink ng-click=\"update(package)\" class=\"md-primary md-raised md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button md-no-ink ng-click=\"showPopUpDelete(package, $index)\" \nclass=\"md-warn md-hue-2\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr></tbody></table>\n</div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div \nclass=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/popup/confirm.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{content.title}}</div></div><md-button \nclass=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content>{{content.message}}</md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button md-no-ink class=\"md-raised md-primary md-hue-2\" ng-click=\"confirmAction()\" \ntranslate=\"GENERAL.YES\"></md-button><md-button class=\"md-warn md-hue-2\" ng-click=\"hidePopup()\" \ntranslate=\"GENERAL.CANCEL\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/request_for_proposal/rfp.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\">{{ \"REQUEST_FOR_PROPOSAL.LIST_TITLE\" | translate}}</div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-accent md-hue-1 md-button md-ink-ripple md-teal-theme-theme\" \nng-click=\"goToMembers()\"><md-icon md-font-icon=\"icon-account\"></md-icon>\n{{\'REQUEST_FOR_PROPOSAL.GESTION_MEMBERS\' | translate}}</md-button><md-button \nclass=\"md-accent md-hue-1 md-button md-ink-ripple md-teal-theme-theme\" ng-click=\"changeVue()\"><md-icon \nmd-font-icon=\"icon-city\"></md-icon>{{\'REQUEST_FOR_PROPOSAL.VIEW_COMPANY\' | translate}}</md-button></div></div><div \nclass=\"content\"><div class=\"nl-Block mb-20\" style=\"margin-bottom: 30px!important\" \nng-if=\"user.associationIds.length > 0 || user.admin\"><div class=\"nl_categories-item-title\" layout=\"row\" \nlayout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</div><div layout=\"row\"><md-radio-group \nlayout=\"row\" layout-align=\"space-between center\" ng-model=\"filter.by\" ng-change=\"typeSearchChanged()\"><md-radio-button \nng-value=\"\'COMPANY\'\"><span>{{\'GENERAL.COMPANY\' | translate}}</span></md-radio-button><md-radio-button \nng-value=\"\'USER\'\"><span>{{\'REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_CONTACT\' | translate}}</span></md-radio-button>\n</md-radio-group></div><div layout=\"row\"><md-input-container ng-if=\"filter.by==\'COMPANY\'\" class=\"nl-Input-container\">\n<label>{{\'GENERAL.COMPANY\' | translate}}</label><md-select name=\"company\" ng-model=\"filter.companyID\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectTextCompany.value\"></section></md-select-header><md-option ng-value=\"null\" selected=\"selected\">\n{{\'STATISTICS.DISPLAY.ALL_COMPANIES\' | translate}}</md-option><md-option ng-value=\"company.id\" \nng-repeat=\"company in companies | orderBy : \'modelPattern\'\">{{company.modelPattern}}</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"filter.by==\'USER\'\" class=\"nl-Input-container\"><label>\n{{\'REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_CONTACT\' | translate}}</label><md-select name=\"user\" ng-model=\"filter.userID\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model-options=\"{ debounce: 500 }\" ng-model=\"filterSelectTextUser.value\"></section></md-select-header><md-option \nng-value=\"null\" selected=\"selected\">{{\'REQUEST_FOR_PROPOSAL.FIELDS.ALL_CONTACTS\' | translate}}</md-option><md-option \nng-value=\"user.id\" ng-repeat=\"user in users | orderBy : \'mail\'\">{{user.mail}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container><label>{{\'REQUEST_FOR_PROPOSAL.ACTIVITY\' | translate}}\n</label><md-select ng-model=\"filter.activity\" md-on-open=\"\" md-on-close=\"filterActivitySelect = \'\'\"><md-select-header>\n<section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterActivitySelect\"></section></md-select-header><md-option ng-value=\"null\" selected=\"selected\">\n{{\'REQUEST_FOR_PROPOSAL.ALL_ACTIVITIES\' | translate}}</md-option><md-option ng-value=\"activity\" \nng-repeat=\"activity in activities | filter : filterActivitySelect  | orderBy: \'libelle\'\">{{activity.libelle}}\n</md-option></md-select></md-input-container></div><div layout=\"row\"><md-input-container><label>\n{{\'REQUEST_FOR_PROPOSAL.SITE\' | translate}}</label><md-select ng-model=\"filter.siteId\" md-on-open=\"\" \nmd-on-close=\"filterSiteSelect = \'\'\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSiteSelect\"></section></md-select-header><md-option \nng-value=\"null\" selected=\"selected\">{{\'REQUEST_FOR_PROPOSAL.ALL_SITES\' | translate}}</md-option><md-option \nng-value=\"site.id\" ng-repeat=\"site in sites | filter : filterSiteSelect  | orderBy: \'name\'\">{{site.name}}</md-option>\n</md-select></md-input-container></div><div class=\"mt-5\" style=\"text-align:center!important\"><md-button \nclass=\"md-raised md-primary md-hue-2\" md-no-ink ng-click=\"onGetRfp();\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}\n</md-button></div></div><div class=\"nl-Block nl-Block--table\"><div class=\"nl-loader\" ng-show=\"!loaded\"><div \nclass=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div \nclass=\"right\"><div class=\"half-circle\"></div></div></div></div></div><div layout=\"row\"><table nl-responsive-table \nnl-table-data=\"arrayData\" class=\"dataTable row-border hover\"><thead><th \ntranslate=\"REQUEST_FOR_PROPOSAL.FIELDS.CREATION_DATE\"></th><th translate=\"REQUEST_FOR_PROPOSAL.FIELDS.EVENT_TITLE\">\n</th><th translate=\"REQUEST_FOR_PROPOSAL.FIELDS.DESIRED_ACTIVITIES\"></th><th \ntranslate=\"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_COMPANY\"></th><th \ntranslate=\"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_NAME\"></th><th \ntranslate=\"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_CONTACT\"></th><th \ntranslate=\"REQUEST_FOR_PROPOSAL.FIELDS.TARGET_PROVIDERS\" ng-if=\"user.admin\"></th><th \ntranslate=\"REQUEST_FOR_PROPOSAL.FIELDS.DATES\"></th><th translate=\"REQUEST_FOR_PROPOSAL.FIELDS.NUMBER_OF_PARTICIPANTS\">\n</th><th translate=\"REQUEST_FOR_PROPOSAL.FIELDS.STATUS\" style=\"text-align: center!important\"></th></thead><tbody><tr \nng-repeat=\"rfp in requestForProposals | orderBy: \'-creationDate\' as arrayData\" ng-click=\"details(rfp);\"><td>\n{{rfp.creationDate | date : \'dd/MM/yy HH:mm\'}}</td><td><div class=\"nl-Block--table--company\">{{ rfp.eventTitle }}</div>\n</td><td><span ng-repeat=\"activity in rfp.desiredActivities\">{{activity + ($last ? \'\' : \' | \')}}</span></td><td>\n{{rfp.applicantCompany}}</td><td>{{rfp.applicantCivility + \' \' + rfp.applicantFirstName + \' \' + rfp.applicantLastName}}\n</td><td><div ng-if=\"rfp.applicantDirectPhone\">{{rfp.applicantDirectPhone}}</div><div ng-if=\"rfp.applicantMobilePhone\">\n{{rfp.applicantMobilePhone}}</div><div ng-if=\"rfp.applicantEmail\">{{rfp.applicantEmail}}</div></td><td \nng-if=\"user.admin\"><span ng-repeat=\"company in rfp.companies\">{{company.pattern + ($last ? \'\': \' | \')}}</span></td><td>\n<div ng-if=\"rfp.dateStart && rfp.dateEnd\">{{rfp.dateStart + \' -> \' + rfp.dateEnd}}</div></td><td>\n{{rfp.numberOfParticipants}}</td><td><span ng-if=\"rfp.status==\'FINISH\' \">\n{{\'REQUEST_FOR_PROPOSAL.FIELDS.CLOSED\' | translate}}</span> <span ng-if=\"rfp.status==\'IN_PROGRESS\'\">\n{{\'REQUEST_FOR_PROPOSAL.FIELDS.IN_PROGRESS\' | translate}}</span></td></tr></tbody></table></div></div><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\"><md-button \nng-disabled=\"allLoaded || !loaded\" type=\"button\" class=\"md-accent\" ng-click=\"_onLoadRfp()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>{{\'COMPANIES.LOAD_MORE\' | translate}}</md-button></div></div></div>");
$templateCache.put("app/main/similar_companies/similar_companies.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"SIMILAR_COMPANIES.TITLE\"></div>\n</div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><form name=\"similarCompaniesForm.form\" \nclass=\"md-inline-form\" novalidate><div layout=\"row\" layout-wrap class=\"m-20 p-20\" \nng-if=\"!progress.initDataInProgress.value\"><md-input-container class=\"\"><md-select name=\"modelSubTypeId\" \nng-model=\"similarConfig.modelSubTypeId\" md-on-close=\"_searchSubType = \'\'\" \nng-change=\"listFields(similarConfig.modelSubTypeId);\" required><md-select-header><section><input force-select-focus \ntype=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchSubType\"></section></md-select-header>\n<md-option ng-value=\"-1\">{{\'DUPLICATION_TOOL.ALL_COMPANY_TYPES\' | translate}}</md-option><md-option \nng-repeat=\"modelSubType in modelSubTypes | filter : _searchSubType | orderBy : \'name\' track by $index\" \nng-value=\"{{modelSubType.id}}\">{{modelSubType.name}}</md-option></md-select><label \ntranslate=\"SIMILAR_COMPANIES.COMPANY_SUBTYPES\"></label><div class=\"\" \nng-messages=\"similarCompaniesForm.form.modelSubTypeId.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"similarConfig.modelSubTypeId != null\"><md-select name=\"fieldId\" ng-model=\"similarConfig.fieldId\" \nmd-on-close=\"_searchField = \'\'\" required><md-select-header><section><input force-select-focus type=\"search\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField\"></section></md-select-header><md-option \nng-repeat=\"field in fields | filter : _searchField | orderBy : \'libelle\' track by field.id\" ng-value=\"field.id\">\n{{field.libelle}}</md-option></md-select><label translate=\"SIMILAR_COMPANIES.FIELD\"></label><div class=\"\" \nng-messages=\"similarCompaniesForm.form.fields.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"similarConfig.fieldId != null\"><input type=\"number\" name=\"maxOccurrence\" ng-model=\"similarConfig.maxOccurrence\" \nstep=\"1\" min=\"2\" required><label translate=\"SIMILAR_COMPANIES.MAX_OCCURRENCE\"></label><div class=\"\" \nng-messages=\"similarCompaniesForm.form.fields.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div><div ng-message=\"min\"><span>{{\"GENERAL.MIN\" | translate}}</span></div>\n</div></md-input-container></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\" ng-if=\"progress.lookForSimilarities\">\n<md-progress-circular class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-align=\"start center\" class=\"m-20 p-20\">\n<md-button flex md-no-ink class=\"md-primary\" ng-disabled=\"progress.lookForSimilarities\" \nng-click=\"lookForSimilarities();\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon>\n{{\'SIMILAR_COMPANIES.FIND_SIMILARITIES\' | translate}}</md-button></div></form></div></div><div class=\"content\" \nng-if=\"similarities != null\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" layout-wrap class=\"m-20 p-20\">\n<div ng-if=\"similarities.length === 0\" translate=\"SIMILAR_COMPANIES.NO_SIMILARITY_FOUND\"></div><table \nclass=\"dataTable row-border hover\" ng-if=\"similarities.length > 0\"><thead><tr><th>\n{{ \'SIMILAR_COMPANIES.TOKEN\' | translate }}</th><th></th></tr></thead><tbody><tr \nng-repeat=\"similarity in similarities track by similarity.key\"><td>{{ similarity.key }}</td><td>\n({{ similarity.ids.length }} {{ \'SIMILAR_COMPANIES.OCCURENCES_FOUND\' | translate }})<md-button flex md-no-ink \nclass=\"md-primary\" ng-click=\"removeDuplicatesFn(similarity.ids);\"><md-icon md-font-icon=\"icon-table-column-remove\">\n</md-icon>{{\'SIMILAR_COMPANIES.REMOVE_DUPLICATE_BTN\' | translate}}</md-button></td></tr></tbody></table><table \nclass=\"dataTable row-border hover\" ng-if=\"duplicatesEntityDto.dto.length == 0\"><tbody><tr><td><span \ntranslate=\"DUPLICATION_TOOL.ANY_OCCURENCE_FOUND\"></span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/statistic_articles/statistic_articles.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"STATISTIC_ARTICLES.TITLE\"></div></div><div layout=\"row\" layout-align=\"end center\" \nhide show-gt-sm><md-button layout=\"row\" class=\"md-accent md-hue-1 md-button md-ink-ripple md-teal-theme-theme\" \nng-if=\"arrayResults && arrayResults.length>0\" ng-click=\"export()\" ng-disabled=\"loading.export\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon>{{\'STATISTIC_ARTICLES.EXPORT\' | translate}}<md-progress-circular \nng-if=\"loading.export\" class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular></md-button></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button></div><div class=\"content\"><div><div class=\"nl-Block\"><div class=\"nl_categories-item-title\" \nlayout=\"row\" layout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</div><div layout=\"row\">\n<md-input-container ng-if=\"filter.by==\'ARTICLE\'\"><label>{{\'STATISTIC_ARTICLES.ARTICLES\' | translate}}</label><md-select\n ng-model=\"filter.articleID\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextArticle.value\" \nng-model-options=\"{ debounce: 500 }\"></section></md-select-header><md-option ng-value=\"null\" selected=\"selected\">\n{{\'STATISTICS.DISPLAY.ALL_ARTICLES\' | translate}}</md-option><md-option ng-value=\"article.id\" \nng-repeat=\"article in articles | orderBy : \'name\'\">{{article.name}}</md-option></md-select></md-input-container>\n<md-input-container><label>{{\'GENERAL.TAG\' | translate}}</label><md-select ng-model=\"filter.tagID\"><md-select-header>\n<section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectTextTag.value\" ng-model-options=\"{ debounce: 500 }\"></section></md-select-header><md-option \nng-value=\"null\" selected=\"selected\">{{\'STATISTIC_COMPANY.ALL_TAGS\' | translate}}</md-option><md-option \nng-value=\"tag.id\" ng-repeat=\"tag in tagsCategory | orderBy : \'name\'\">{{tag.name}}</md-option></md-select>\n</md-input-container><md-input-container><label>{{\'GENERAL.COUNTRY\' | translate}}</label><md-select \nng-model=\"filter.countryID\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextCountry.value\" \nng-model-options=\"{ debounce: 500 }\"></section></md-select-header><md-option ng-value=\"null\" selected=\"selected\">\n{{\'STATISTIC_COMPANY.ALL_COUNTRIES\' | translate}}</md-option><md-option ng-value=\"country.id\" \nng-repeat=\"country in countriesTags | orderBy : \'libelle\'\">{{country.libelle}}</md-option></md-select>\n</md-input-container><md-input-container><label>{{\'GENERAL.REGION\' | translate}}</label><md-select \nng-model=\"filter.regionID\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextRegion.value\" \nng-model-options=\"{ debounce: 500 }\"></section></md-select-header><md-option ng-value=\"null\" selected=\"selected\">\n{{\'STATISTIC_COMPANY.ALL_REGIONS\' | translate}}</md-option><md-option ng-value=\"region.id\" \nng-repeat=\"region in regionsTags | orderBy : \'libelle\'\">{{region.libelle}}</md-option></md-select></md-input-container>\n</div><div layout=\"row\"><md-input-container><label>{{\'STATISTIC_COMPANY.FILTER_MODE_LIBELLE\' | translate}}</label>\n<md-select ng-model=\"filter.mode\"><md-option ng-value=\"filterMode.key\" ng-repeat=\"filterMode in filterModes\">\n{{ \'STATISTIC_COMPANY.FILTER_MODE.\' + filterMode.key | translate }}</md-option></md-select></md-input-container></div>\n<div class=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"filter.mode === \'PERIOD\'\">{{\'STATISTICS.DISPLAY.RESULT_BETWEEN\' | translate}}</div><div layout=\"row\" \nng-if=\"filter.mode === \'DAY\' || filter.mode === \'PERIOD\'\"><md-input-container class=\"nl-Input-container\" flex>\n<md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" \nng-model=\"filter.begin.date\" name=\"day\"></md-datepicker></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"filter.end.date\" name=\"day\" ng-hide=\"filter.mode === \'DAY\'\"></md-datepicker>\n</md-input-container></div><div layout=\"row\" ng-if=\"filter.mode === \'MONTH\' || filter.mode === \'YEAR\'\">\n<md-input-container flex=\"50\" ng-if=\"filter.mode === \'MONTH\'\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filter.begin.month\"><md-option \nng-value=\"month.value\" ng-repeat=\"month in monthNames track by $index\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option></md-select></md-input-container><md-input-container \nflex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"filter.begin.year\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.filter.begin\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYear(true)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option></md-select></md-input-container></div><div><md-checkbox ng-model=\"filter.secondPeriod.checked\">\n{{ \'STATISTIC_ARTICLES.COMPARE\' | translate }}</md-checkbox></div><div ng-if=\"filter.secondPeriod.checked\"><div \nlayout=\"row\"><md-input-container><label>{{\'STATISTIC_COMPANY.FILTER_MODE_LIBELLE\' | translate}}</label><md-select \nng-model=\"filter.secondPeriod.mode\"><md-option ng-value=\"filterMode.key\" ng-repeat=\"filterMode in filterModes\">\n{{ \'STATISTIC_COMPANY.FILTER_MODE.\' + filterMode.key | translate }}</md-option></md-select></md-input-container></div>\n<div class=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"filter.secondPeriod.mode === \'PERIOD\'\">{{\'STATISTICS.DISPLAY.RESULT_BETWEEN\' | translate}}</div><div \nlayout=\"row\" ng-if=\"filter.secondPeriod.mode === \'DAY\' || filter.secondPeriod.mode === \'PERIOD\'\"><md-input-container \nclass=\"nl-Input-container\" flex><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"filter.secondPeriod.begin.date\" name=\"day\"></md-datepicker></md-input-container>\n<md-input-container class=\"nl-Input-container\" flex><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" \nmd-open-on-focus md-hide-icons=\"calendar\" ng-model=\"filter.secondPeriod.end.date\" name=\"day\" \nng-hide=\"filter.secondPeriod.mode === \'DAY\'\"></md-datepicker></md-input-container></div><div layout=\"row\" \nng-if=\"filter.secondPeriod.mode === \'MONTH\' || filter.secondPeriod.mode === \'YEAR\'\"><md-input-container flex=\"50\" \nng-if=\"filter.secondPeriod.mode === \'MONTH\'\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label>\n<md-select ng-model=\"filter.secondPeriod.begin.month\"><md-option ng-value=\"month.value\" \nng-repeat=\"month in monthNames track by $index\">{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option>\n</md-select></md-input-container><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"filter.secondPeriod.begin.year\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.filterSecond.begin\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYearSecond(true)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option></md-select></md-input-container></div></div><div class=\"mt-5\" style=\"text-align:center!important\">\n<md-button class=\"md-raised md-primary md-hue-2\" md-no-ink ng-click=\"getStatsArticles()\">\n{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</md-button></div></div><div class=\"nl-Block mt-25\"><div class=\"nl-loader\" \nng-show=\"loading.filter\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div \nclass=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div><div><div \nclass=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.STATS_BY_ARTICLE\' | translate}}</div><table ng-if=\"arrayResults.length>0\" \nclass=\"nl-Table pure-table pure-table-bordered\"><tr style=\"border-bottom: 1px solid #cbcbcb\"><th style=\"width:20%\" \nrowspan=\"{{isForTwoPeriods ? 2 : 1}}\">{{\'STATISTIC_ARTICLES.ARTICLES\' | translate}}</th><th \ncolspan=\"{{isForTwoPeriods ? 2 : 1}}\">{{ \'STATISTIC_ARTICLES.SHOW\' | translate }}</th><th \ncolspan=\"{{isForTwoPeriods ? 2 : 1}}\">{{ \'STATISTIC_ARTICLES.READ\' | translate }}</th><th \ncolspan=\"{{isForTwoPeriods ? 2 : 1}}\">{{ \'STATISTIC_ARTICLES.SHOW_FAVORITE\' | translate }}</th><th \ncolspan=\"{{isForTwoPeriods ? 2 : 1}}\">{{ \'STATISTIC_ARTICLES.READ_FAVORITE\' | translate }}</th><th \ncolspan=\"{{isForTwoPeriods ? 2 : 1}}\">{{ \'STATISTIC_ARTICLES.SHOW_SPECIAL\' | translate }}</th><th \ncolspan=\"{{isForTwoPeriods ? 2 : 1}}\">{{ \'STATISTIC_ARTICLES.READ_SPECIAL\' | translate }}</th></tr><tr \nng-if=\"isForTwoPeriods\"><td align=\"center\">P1</td><td align=\"center\">P2</td><td align=\"center\">P1</td><td \nalign=\"center\">P2</td><td align=\"center\">P1</td><td align=\"center\">P2</td><td align=\"center\">P1</td><td align=\"center\">\nP2</td><td align=\"center\">P1</td><td align=\"center\">P2</td><td align=\"center\">P1</td><td align=\"center\">P2</td></tr><tr\n ng-repeat=\"art in arrayResults | orderBy: \'articleName\' track by $index\"><td align=\"center\">{{art.articleName}}</td>\n<td align=\"center\">{{art.period1.totalShown}}</td><td align=\"center\" ng-if=\"isForTwoPeriods\">{{art.period2.totalShown}}\n</td><td align=\"center\">{{art.period1.totalRead}}</td><td align=\"center\" ng-if=\"isForTwoPeriods\">\n{{art.period2.totalRead}}</td><td align=\"center\">{{art.period1.totalShownInFavoriteBloc}}</td><td align=\"center\" \nng-if=\"isForTwoPeriods\">{{art.period2.totalShownInFavoriteBloc}}</td><td align=\"center\">\n{{art.period1.totalReadInFavoriteBloc}}</td><td align=\"center\" ng-if=\"isForTwoPeriods\">\n{{art.period2.totalReadInFavoriteBloc}}</td><td align=\"center\">{{art.period1.totalShownInSpecialFolder}}</td><td \nalign=\"center\" ng-if=\"isForTwoPeriods\">{{art.period2.totalShownInSpecialFolder}}</td><td align=\"center\">\n{{art.period1.totalReadInSpecialFolder}}</td><td align=\"center\" ng-if=\"isForTwoPeriods\">\n{{art.period2.totalReadInSpecialFolder}}</td></tr><tr ng-if=\"arrayResults && arrayResults.length>0\"><td align=\"right\">\n<strong>{{\'STATISTIC_COMPANY.TOTAL\' | translate}}</strong></td><td align=\"center\"><strong>{{totalShown}}</strong></td>\n<td align=\"center\" ng-if=\"isForTwoPeriods\"><strong>{{totalShown2}}</strong></td><td align=\"center\"><strong>\n{{totalRead}}</strong></td><td align=\"center\" ng-if=\"isForTwoPeriods\"><strong>{{totalRead2}}</strong></td><td \nalign=\"center\"><strong>{{totalShownInFavoriteBloc}}</strong></td><td align=\"center\" ng-if=\"isForTwoPeriods\"><strong>\n{{totalShownInFavoriteBloc2}}</strong></td><td align=\"center\"><strong>{{totalReadInFavoriteBloc}}</strong></td><td \nalign=\"center\" ng-if=\"isForTwoPeriods\"><strong>{{totalReadInFavoriteBloc2}}</strong></td><td align=\"center\"><strong>\n{{totalShownInSpecialFolder}}</strong></td><td align=\"center\" ng-if=\"isForTwoPeriods\"><strong>\n{{totalShownInSpecialFolder2}}</strong></td><td align=\"center\"><strong>{{totalReadInSpecialFolder}}</strong></td><td \nalign=\"center\" ng-if=\"isForTwoPeriods\"><strong>{{totalReadInSpecialFolder2}}</strong></td></tr></table></div></div>\n</div></div></div>");
$templateCache.put("app/main/statistic_banner/statistic_banner.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"STATISTIC_BANNERS.TITLE\"></div></div><div layout=\"row\" layout-align=\"end center\" \nhide show-gt-sm><md-button layout=\"row\" class=\"md-accent md-hue-1 md-button md-ink-ripple md-teal-theme-theme\" \nng-if=\"arrayResults && arrayResults.length>0\" ng-click=\"export()\" ng-disabled=\"loading.export\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon>{{\'STATISTIC_COMPANY.EXPORT\' | translate}}<md-progress-circular \nng-if=\"loading.export\" class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular></md-button></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button></div><div class=\"content\"><div><div class=\"nl-Block\"><div class=\"nl_categories-item-title\" \nlayout=\"row\" layout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</div><div layout=\"row\">\n<md-input-container><label>{{\'STATISTIC_BANNERS.BANNERS\' | translate}}</label><md-select ng-model=\"filter.bannerID\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectTextBanner.value\" ng-model-options=\"{ debounce: 500 }\"></section></md-select-header><md-option \nng-value=\"null\" selected=\"selected\">{{\'STATISTICS.DISPLAY.ALL_BANNERS\' | translate}}</md-option><md-option \nng-value=\"banner.id\" ng-repeat=\"banner in banners | orderBy : \'title\'\">{{banner.title}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\"><md-input-container><label>\n{{\'STATISTIC_COMPANY.FILTER_MODE_LIBELLE\' | translate}}</label><md-select ng-model=\"filter.mode\"><md-option \nng-value=\"filterMode.key\" ng-repeat=\"filterMode in filterModes\">\n{{ \'STATISTIC_COMPANY.FILTER_MODE.\' + filterMode.key | translate }}</md-option></md-select></md-input-container></div>\n<div class=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"filter.mode === \'PERIOD\'\">{{\'STATISTICS.DISPLAY.RESULT_BETWEEN\' | translate}}</div><div layout=\"row\" \nng-if=\"filter.mode === \'DAY\' || filter.mode === \'PERIOD\'\"><md-input-container class=\"nl-Input-container\" flex>\n<md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" \nng-model=\"filter.begin.date\" name=\"day\"></md-datepicker></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"filter.end.date\" name=\"day\" ng-hide=\"filter.mode === \'DAY\'\"></md-datepicker>\n</md-input-container></div><div layout=\"row\" ng-if=\"filter.mode === \'MONTH\' || filter.mode === \'YEAR\'\">\n<md-input-container flex=\"50\" ng-if=\"filter.mode === \'MONTH\'\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filter.begin.month\"><md-option \nng-value=\"month.value\" ng-repeat=\"month in monthNames track by $index\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option></md-select></md-input-container><md-input-container \nflex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"filter.begin.year\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.filter.begin\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYear(true)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option></md-select></md-input-container></div><div><md-checkbox ng-model=\"filter.secondPeriod.checked\">\n{{ \'STATISTIC_BANNERS.COMPARE\' | translate }}</md-checkbox></div><div ng-if=\"filter.secondPeriod.checked\"><div \nlayout=\"row\"><md-input-container><label>{{\'STATISTIC_COMPANY.FILTER_MODE_LIBELLE\' | translate}}</label><md-select \nng-model=\"filter.secondPeriod.mode\"><md-option ng-value=\"filterMode.key\" ng-repeat=\"filterMode in filterModes\">\n{{ \'STATISTIC_COMPANY.FILTER_MODE.\' + filterMode.key | translate }}</md-option></md-select></md-input-container></div>\n<div class=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"filter.secondPeriod.mode === \'PERIOD\'\">{{\'STATISTICS.DISPLAY.RESULT_BETWEEN\' | translate}}</div><div \nlayout=\"row\" ng-if=\"filter.secondPeriod.mode === \'DAY\' || filter.secondPeriod.mode === \'PERIOD\'\"><md-input-container \nclass=\"nl-Input-container\" flex><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"filter.secondPeriod.begin.date\" name=\"day\"></md-datepicker></md-input-container>\n<md-input-container class=\"nl-Input-container\" flex><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" \nmd-open-on-focus md-hide-icons=\"calendar\" ng-model=\"filter.secondPeriod.end.date\" name=\"day\" \nng-hide=\"filter.secondPeriod.mode === \'DAY\'\"></md-datepicker></md-input-container></div><div layout=\"row\" \nng-if=\"filter.secondPeriod.mode === \'MONTH\' || filter.secondPeriod.mode === \'YEAR\'\"><md-input-container flex=\"50\" \nng-if=\"filter.secondPeriod.mode === \'MONTH\'\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label>\n<md-select ng-model=\"filter.secondPeriod.begin.month\"><md-option ng-value=\"month.value\" \nng-repeat=\"month in monthNames track by $index\">{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option>\n</md-select></md-input-container><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"filter.secondPeriod.begin.year\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.filterSecond.begin\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYearSecond(true)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option></md-select></md-input-container></div></div><div class=\"mt-5\" style=\"text-align:center!important\">\n<md-button class=\"md-raised md-primary md-hue-2\" md-no-ink ng-click=\"getStatsBanners()\">\n{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</md-button></div></div><div class=\"nl-Block mt-25\"><div class=\"nl-loader\" \nng-show=\"loading.filter\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div \nclass=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div><div><div \nclass=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.STATS_BY_BANNER\' | translate}}</div><table ng-if=\"arrayResults.length>0\" \nclass=\"nl-Table pure-table pure-table-bordered\"><tr style=\"border-bottom: 1px solid #cbcbcb\"><th style=\"width:20%\" \nrowspan=\"{{isForTwoPeriods ? 2 : 1}}\">{{\'STATISTIC_BANNERS.BANNERS\' | translate}}</th><th \ncolspan=\"{{isForTwoPeriods ? 2 : 1}}\">{{ \'STATISTIC_BANNERS.SHOW\' | translate }}</th><th \ncolspan=\"{{isForTwoPeriods ? 2 : 1}}\">{{ \'STATISTIC_BANNERS.READ\' | translate }}</th></tr><tr ng-if=\"isForTwoPeriods\">\n<td>P1</td><td>P2</td><td>P1</td><td>P2</td></tr><tr \nng-repeat=\"ban in arrayResults | orderBy: \'bannerName\' track by $index\"><td>{{ban.bannerName}}</td><td>\n{{ban.period1.totalShown}}</td><td ng-if=\"isForTwoPeriods\">{{ban.period2.totalShown}}</td><td>{{ban.period1.totalRead}}\n</td><td ng-if=\"isForTwoPeriods\">{{ban.period2.totalRead}}</td></tr></table></div></div></div></div></div>");
$templateCache.put("app/main/statistic_company/statistic_company.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"STATISTIC_COMPANY.TITLE\"></div></div><div layout=\"row\" layout-align=\"end center\" \nhide show-gt-sm><md-button layout=\"row\" class=\"md-accent md-hue-1 md-button md-ink-ripple md-teal-theme-theme\" \nng-if=\"statisticsArray && statisticsArray.length>0\" ng-click=\"export()\" ng-disabled=\"loading.export\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon>{{\'STATISTIC_COMPANY.EXPORT\' | translate}}<md-progress-circular \nng-if=\"loading.export\" class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\" md-diameter=\"24\"></md-progress-circular></md-button></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button></div><div class=\"content\"><div><div class=\"nl-Block\"><div class=\"nl_categories-item-title\" \nlayout=\"row\" layout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</div><div layout=\"row\">\n</div><div layout=\"row\"><md-input-container><label>{{\'GENERAL.COMPANY\' | translate}}</label><md-select \nng-model=\"filter.companyID\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextCompany.value\" \nng-model-options=\"{ debounce: 500 }\"></section></md-select-header><md-option ng-value=\"null\" selected=\"selected\">\n{{\'STATISTICS.DISPLAY.ALL_COMPANIES\' | translate}}</md-option><md-option ng-value=\"company.id\" \nng-repeat=\"company in companies | orderBy : \'modelPattern\'\">{{company.modelPattern}}</md-option></md-select>\n</md-input-container><md-input-container><label>{{\'GENERAL.TAG\' | translate}}</label><md-select \nng-model=\"filter.tagID\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextTag.value\" ng-model-options=\"{ debounce: 500 }\">\n</section></md-select-header><md-option ng-value=\"null\" selected=\"selected\">\n{{\'STATISTIC_COMPANY.ALL_TAGS\' | translate}}</md-option><md-option ng-value=\"tag.id\" \nng-repeat=\"tag in tagsCategory | orderBy : \'name\'\">{{tag.name}}</md-option></md-select></md-input-container>\n<md-input-container><label>{{\'GENERAL.COUNTRY\' | translate}}</label><md-select ng-model=\"filter.countryID\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectTextCountry.value\" ng-model-options=\"{ debounce: 500 }\"></section></md-select-header><md-option \nng-value=\"null\" selected=\"selected\">{{\'STATISTIC_COMPANY.ALL_COUNTRIES\' | translate}}</md-option><md-option \nng-value=\"country.id\" ng-repeat=\"country in countriesTags | orderBy : \'libelle\'\">{{country.libelle}}</md-option>\n</md-select></md-input-container><md-input-container><label>{{\'GENERAL.REGION\' | translate}}</label><md-select \nng-model=\"filter.regionID\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextRegion.value\" \nng-model-options=\"{ debounce: 500 }\"></section></md-select-header><md-option ng-value=\"null\" selected=\"selected\">\n{{\'STATISTIC_COMPANY.ALL_REGIONS\' | translate}}</md-option><md-option ng-value=\"region.id\" \nng-repeat=\"region in regionsTags | orderBy : \'libelle\'\">{{region.libelle}}</md-option></md-select></md-input-container>\n</div><div layout=\"row\"><md-input-container><label>{{\'STATISTIC_COMPANY.FILTER_MODE_LIBELLE\' | translate}}</label>\n<md-select ng-model=\"filter.mode\"><md-option ng-value=\"filterMode.key\" ng-repeat=\"filterMode in filterModes\">\n{{ \'STATISTIC_COMPANY.FILTER_MODE.\' + filterMode.key | translate }}</md-option></md-select></md-input-container></div>\n<div class=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"filter.mode === \'PERIOD\'\">{{\'STATISTICS.DISPLAY.RESULT_BETWEEN\' | translate}}</div><div layout=\"row\" \nng-if=\"filter.mode === \'DAY\' || filter.mode === \'PERIOD\'\"><md-input-container class=\"nl-Input-container\" flex>\n<md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" \nng-model=\"filter.begin.date\" name=\"day\"></md-datepicker></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"filter.end.date\" name=\"day\" ng-hide=\"filter.mode === \'DAY\'\"></md-datepicker>\n</md-input-container></div><div layout=\"row\" ng-if=\"filter.mode === \'MONTH\' || filter.mode === \'YEAR\'\">\n<md-input-container flex=\"50\" ng-if=\"filter.mode === \'MONTH\'\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filter.begin.month\"><md-option \nng-value=\"month.value\" ng-repeat=\"month in monthNames track by $index\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option></md-select></md-input-container><md-input-container \nflex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"filter.begin.year\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.filter.begin\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYear(true)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">{{customYear.filter.begin}}</md-option></md-select>\n</md-input-container></div><div><md-checkbox ng-model=\"filter.secondPeriod.checked\">\n{{ \'STATISTIC_COMPANY.COMPARE\' | translate }}</md-checkbox></div><div ng-if=\"filter.secondPeriod.checked\"><div \nlayout=\"row\"><md-input-container><label>{{\'STATISTIC_COMPANY.FILTER_MODE_LIBELLE\' | translate}}</label><md-select \nng-model=\"filter.secondPeriod.mode\"><md-option ng-value=\"filterMode.key\" ng-repeat=\"filterMode in filterModes\">\n{{ \'STATISTIC_COMPANY.FILTER_MODE.\' + filterMode.key | translate }}</md-option></md-select></md-input-container></div>\n<div class=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"filter.secondPeriod.mode === \'PERIOD\'\">{{\'STATISTICS.DISPLAY.RESULT_BETWEEN\' | translate}}</div><div \nlayout=\"row\" ng-if=\"filter.secondPeriod.mode === \'DAY\' || filter.secondPeriod.mode === \'PERIOD\'\"><md-input-container \nclass=\"nl-Input-container\" flex><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"filter.secondPeriod.begin.date\" name=\"day\"></md-datepicker></md-input-container>\n<md-input-container class=\"nl-Input-container\" flex><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" \nmd-open-on-focus md-hide-icons=\"calendar\" ng-model=\"filter.secondPeriod.end.date\" name=\"day\" \nng-hide=\"filter.secondPeriod.mode === \'DAY\'\"></md-datepicker></md-input-container></div><div layout=\"row\" \nng-if=\"filter.secondPeriod.mode === \'MONTH\' || filter.secondPeriod.mode === \'YEAR\'\"><md-input-container flex=\"50\" \nng-if=\"filter.secondPeriod.mode === \'MONTH\'\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label>\n<md-select ng-model=\"filter.secondPeriod.begin.month\"><md-option ng-value=\"month.value\" \nng-repeat=\"month in monthNames track by $index\">{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option>\n</md-select></md-input-container><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"filter.secondPeriod.begin.year\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.filterSecond.begin\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYearSecond(true)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option></md-select></md-input-container></div></div><div class=\"mt-5\" style=\"text-align:center!important\">\n<md-button class=\"md-raised md-primary md-hue-2\" md-no-ink ng-click=\"getStatsCompanies()\">\n{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</md-button></div></div><div class=\"nl-Block mt-25\"><div class=\"nl-loader\" \nng-show=\"loading.filter\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div \nclass=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div><div><div \nclass=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.STATS_BY_COMPANY\' | translate}}</div><table class=\"nl-Table pure-table pure-table-bordered\"><tr \nstyle=\"border-bottom: 1px solid #cbcbcb\"><th style=\"width:30%\" rowspan=\"{{isForTwoPeriods ? 2 : 1}}\">\n{{\'GENERAL.COMPANY\' | translate}}</th><th colspan=\"{{isForTwoPeriods ? 2 : 1}}\">\n{{ \'STATISTIC_COMPANY.SHOWN\' | translate }}</th><th colspan=\"{{isForTwoPeriods ? 2 : 1}}\">\n{{ \'STATISTIC_COMPANY.VIEW\' | translate }}</th><th colspan=\"{{isForTwoPeriods ? 2 : 1}}\">\n{{ \'STATISTIC_COMPANY.QUOTE_REQUEST\' | translate }}</th><th colspan=\"{{isForTwoPeriods ? 2 : 1}}\">\n{{ \'STATISTIC_COMPANY.QUOTE_REQUEST_ACCEPTED\' | translate }}</th><th colspan=\"{{isForTwoPeriods ? 2 : 1}}\">\n{{ \'STATISTIC_COMPANY.CLICKS_PHONE\' | translate }}</th><th colspan=\"{{isForTwoPeriods ? 2 : 1}}\">\n{{ \'STATISTIC_COMPANY.CLICKS_MAIL\' | translate }}</th></tr><tr ng-if=\"isForTwoPeriods\"><td>P1</td><td>P2</td><td>P1\n</td><td>P2</td><td>P1</td><td>P2</td><td>P1</td><td>P2</td><td>P1</td><td>P2</td><td>P1</td><td>P2</td></tr><tr \nng-repeat=\"elt in statisticsArray | orderBy: \'companyPattern\' track by $index\"><td>{{elt.companyPattern}}</td><td>\n{{elt.shown}}</td><td ng-if=\"isForTwoPeriods\">{{elt.shown2}}</td><td>{{elt.view}}</td><td ng-if=\"isForTwoPeriods\">\n{{elt.view2}}</td><td>{{elt.quoteRequest}}</td><td ng-if=\"isForTwoPeriods\">{{elt.quoteRequest2}}</td><td>\n{{elt.quoteRequestAccepted}}</td><td ng-if=\"isForTwoPeriods\">{{elt.quoteRequestAccepted2}}</td><td>{{elt.clicksPhone}}\n</td><td ng-if=\"isForTwoPeriods\">{{elt.clicksSecondPeriodPhone}}</td><td>{{elt.clicksEmail}}</td><td \nng-if=\"isForTwoPeriods\">{{elt.clicksSecondPeriodEmail}}</td></tr><tr \nng-if=\"statisticsArray && statisticsArray.length>0\"><td style=\"text-align: right!important\"><strong>\n{{\'STATISTIC_COMPANY.TOTAL\' | translate}}</strong></td><td><strong>{{totalShowns}}</strong></td><td \nng-if=\"isForTwoPeriods\"><strong>{{totalShowns2}}</strong></td><td><strong>{{totalViews}}</strong></td><td \nng-if=\"isForTwoPeriods\"><strong>{{totalViews2}}</strong></td><td><strong>{{totalQuoteRequest}}</strong></td><td \nng-if=\"isForTwoPeriods\"><strong>{{totalQuoteRequest2}}</strong></td><td><strong>{{totalQuoteRequestAccepted}}</strong>\n</td><td ng-if=\"isForTwoPeriods\"><strong>{{totalQuoteRequestAccepted2}}</strong></td><td><strong>{{totalClicksPhone}}\n</strong></td><td ng-if=\"isForTwoPeriods\"><strong>{{totalClicksPhone2}}</strong></td><td><strong>{{totalClicksEmail}}\n</strong></td><td ng-if=\"isForTwoPeriods\"><strong>{{totalClicksEmail2}}</strong></td></tr></table></div></div></div>\n</div></div>");
$templateCache.put("app/main/statistics/statistics.html","");
$templateCache.put("app/main/tourist_attractions/tourist_attractions.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"TOURIST.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" cla∑ss=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"goAdd()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\"GENERAL.ADD\" | translate}}\n</md-button><div><md-input-container flex><md-select ng-change=\"initTourists()\" ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex><md-select ng-change=\"initTourists()\" \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div></div><div class=\"content\"><div class=\"nl-Block nl-Block--table\"><div \nclass=\"nl-listing\"><table nl-responsive-table nl-table-data=\"arrayData\" class=\"simple list-view\"><thead><th>\n{{\"TOURIST.COLUMNS.NAME\" | translate}}</th><th>{{\"TOURIST.COLUMNS.CITY\" | translate}}</th><th>\n{{\"TOURIST.COLUMNS.REGION\" | translate}}</th><th>{{\"TOURIST.COLUMNS.TYPE\" | translate}}</th><th>\n{{\"TOURIST.COLUMNS.ACTIONS\" | translate}}</th></thead><tbody><tr \nng-repeat=\"tourist in tourists | orderBy: \'name\' as arrayData track by tourist.id\"><td>{{tourist.name}}</td><td>\n{{tourist.city != null ? tourist.city.value : \'\'}}</td><td>{{tourist.region != null ? tourist.region.value : \'\'}}</td>\n<td><span ng-maxlength=\"10\" ng-repeat=\"type in tourist.typeTourisme | limitTo: limitNbrTypes\">\n{{type.value}}{{$last ? (tourist.typeTourisme.length > limitNbrTypes ? \',...\' : \'\'): \', \'}}</span></td><td><md-button \nmd-no-ink ng-click=\"update(tourist)\" class=\"md-primary md-raised md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button md-no-ink ng-click=\"showPopUpDelete(tourist, $index)\" \nclass=\"md-warn md-hue-2\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr></tbody></table>\n</div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div \nclass=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div>\n</div></div></div></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div class=\"\" \nlayout=\"row\" layout-align=\"start center\" style=\"height:100%\"><img src=\"/alternatedocroots/default_logo.png\" alt=\"\" \nstyle=\"max-height:100%;max-width: 90%\"></div><br><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide \nshow-gt-sm ng-click=\"vm.toggleMsNavigationFolded()\" ng-if=\",\"></md-icon><md-menu id=\"language-menu\" \nmd-offset=\"0 42\" md-position-mode=\"target-right target\" ng-if=\",\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target style=\"min-width: 55px\"><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"></div></md-button><md-menu-content width=\"3\" \nid=\"language-menu-content\"><md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button \nng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\">\n<span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n</md-toolbar><a class=\"nl-navigation-item--avatar\"><div layout=\"row\" class=\"ms-navigation-button nl-Nav-item--avatar\" \nng-class=\"{\'noImage\': !$root.user.pictureLocation}\"><div ng-if=\"$root.user.pictureLocation\"><img \nclass=\"icon nl-Nav-icon--avatar\" http-src=\"./alternatedocroots/{{$root.user.pictureLocation}}\" \nhas-profile-picture=\"$root.user.pictureLocation != null\"></div><div class=\"title nl-Nav-item-folded\"><span \nclass=\"nl-Nav-item-title nl-Nav-item-title--avatar\" flex>{{$root.user.fullName}}</span><div \nclass=\"nl-Nav-item-subTitle\" flex></div><button type=\"button\" class=\"nl-Nav-item--btnLogout\" ng-click=\"$root.logout()\">\n<md-icon md-font-icon=\"icon-logout\" class=\"s14\" style=\"margin-bottom: 2px\"></md-icon>\n{{vm.selectedLanguage.code === \'en\' ? \'Logout\' : \'Se déconnecter\'}}</button></div></div></a><ms-navigation \nclass=\"scrollable override-class\" folded=\"vm.folded\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\" class=\"s16\"></md-icon>\n</md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-primary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-primary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-primary\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\nJohn Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>Jhonny Deep</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/main/access_rights/associations/association.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\">{{\'ASSOCIATIONS.TITLE\' | translate}}</div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"></div>\n</div><div class=\"content\"><div class=\"nl-Block nl-Block--table\"><div layout=\"row\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\" flex=\"100\"><thead><th \ntranslate=\"ASSOCIATIONS.COMPANIES.NAME\"></th><th translate=\"ASSOCIATIONS.COMPANIES.MANAGER\"></th></thead><tbody><tr \nng-repeat=\"company in association.companies | orderBy: \'modelPattern\' track by company.id\"><td>{{company.modelPattern}}\n</td><td><md-button class=\"md-fab md-mini md-hue-2\" type=\"md-button\" ng-click=\"addManager(company)\" \nng-if=\"company.manager == null\"><md-icon md-font-icon=\"icon-link\"></md-icon></md-button>\n{{ company.manager != null ? company.manager.fullName : \'\'}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/access_rights/associations/associations.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\">{{\'ASSOCIATIONS.TITLE\' | translate}}</div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"openAddAssociation()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'ASSOCIATIONS.NEW\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"openAddAssociation()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'ASSOCIATIONS.NEW\' | translate}}\n</md-button></div></div></div><div class=\"content\"><div class=\"nl-Block nl-Block--table\"><div layout=\"row\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\" ng-if=\"loaded\" flex=\"100\"><thead><th \ntranslate=\"ASSOCIATIONS.ID\"></th><th translate=\"ASSOCIATIONS.LOGO\"></th><th translate=\"ASSOCIATIONS.NAME\"></th><th \ntranslate=\"ASSOCIATIONS.ADMIN\"></th><th translate=\"GENERAL.ACTIONS\"></th></thead><tbody><tr \nng-repeat=\"association in associations | orderBy: \'name\' track by association.id\" \nng-click=\"detailsCompany(association);\"><td>{{association.id}}</td><td><img style=\"width:200px\" \nng-src=\"{{alternatedocroots + \'/\' + association.logo}}\" ng-if=\"association.logo != null\"></td><td><b>\n{{ association.name }}</b></td><td>{{ association.admin.fullName }}</td><td><md-button type=\"button\" \nclass=\"md-fab md-mini md-hue-2\" ng-click=\"$event.stopPropagation();details(association)\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"$event.stopPropagation();openRemoveAssociation(association);\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button></td></tr></tbody></table></div></div></div>\n</div>");
$templateCache.put("app/main/access_rights/groups/groups.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\">{{\'GROUPS.TITLE\' | translate}}</div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"openAddGroup()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'GROUPS.NEW\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"openAddGroup()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'GROUPS.NEW\' | translate}}</md-button></div>\n</div></div><div class=\"content\"><div class=\"nl-Block nl-Block--table\"><div layout=\"row\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\" ng-if=\"loaded\"><thead><th \ntranslate=\"GROUPS.NAME\"></th><th translate=\"GROUPS.RIGHTS\"></th><th translate=\"GENERAL.ACTIONS\"></th></thead><tbody><tr\n ng-repeat=\"group in groups | orderBy: \'name\' track by group.id\"><td ng-click=\"details(group)\"><b>{{ group.name }}</b>\n</td><td ng-click=\"details(group)\"><span ng-repeat=\"role in group.roles track by role.id\">\n{{\'ROLES.\' + role.name | translate}}</span></td><td><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"openRemoveGroup(group);\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/access_rights/users/users.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\">{{\'USERS.TITLE\' | translate}}</div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"switchActives()\"><md-icon md-font-icon=\"icon-auto-fix\"></md-icon><span \nng-hide=\"showAllUsers\" translate=\"USERS.SEE_INACTIVES\"></span> <span ng-show=\"showAllUsers\" \ntranslate=\"USERS.HIDE_INACTIVES\"></span></md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"openAddUser()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'USERS.NEW\' | translate}}</md-button></div>\n</div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" \nng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div layout=\"column\" \nlayout-align=\"start start\"><md-button type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"switchActives()\"><md-icon \nmd-font-icon=\"icon-auto-fix\"></md-icon><span ng-hide=\"showAllUsers\" translate=\"USERS.SEE_INACTIVES\"></span> <span \nng-show=\"showAllUsers\" translate=\"USERS.HIDE_INACTIVES\"></span></md-button><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"openAddUser()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'USERS.NEW\' | translate}}</md-button></div></div></div><div class=\"content\"><div class=\"nl-Block nl-Block--table\">\n<div layout=\"row\"><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"dtOptions\" ng-if=\"loaded\">\n<thead><th translate=\"USERS.NAME\"></th><th translate=\"USERS.ID\"></th><th translate=\"USERS.GROUPS\"></th><th \ntranslate=\"USERS.RIGHTS\"></th><th translate=\"USERS.STATUS\"></th></thead><tbody><tr \nng-repeat=\"user in users | showAllUsers: showAllUsers | orderBy: \'fullName\' track by user.id\" ng-click=\"details(user)\">\n<td><div layout=\"row\" layout-align=\"start center\"><img ng-if=\"user.pictureLocation\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{user.pictureLocation}}\" has-profile-picture=\"user.pictureLocation != null\"> <b>\n{{ user.fullName }}</b></div></td><td>{{ user.login }}</td><td><span \nng-repeat=\"group in user.groups track by group.id\">{{group.name}}</span></td><td><span \nng-repeat=\"right in user.rights track by right.id\">{{\'ROLES.\' + right.name | translate}}</span></td><td><span \nclass=\"nl-Badge nl-Badge--primary\" ng-if=\"user.activated\">{{(\'USERS.ACTIVATED\' | translate)}}</span> <span \nclass=\"nl-Badge nl-Badge--warn\" ng-if=\"!user.activated\">{{(\'USERS.DISABLED\' | translate)}}</span></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/admin/messagesLogs/message.html","<md-dialog class=\"nl_Dialog\" aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{message.subject}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"nl-Popup-content-body\" layout=\"column\"><div flex=\"100\" class=\"ql-editor\" \nng-bind-html=\"message.content\"></div><div flex=\"100\"><md-button md-no-ink class=\"md-accent md-hue-2\" \naria-label=\"Annuler\" ng-click=\"hidePopup()\">{{\"GENERAL.OK\" | translate }}</md-button></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/admin/messagesLogs/messages_logs.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"ADMIN.MESSAGES_LOGS.TITLE\"></div>\n</div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table nl-responsive-table \nnl-table-data=\"arrayData\" class=\"dataTable row-border hover\"><thead><tr><th><div>\n{{\'ADMIN.MESSAGES_LOGS.COLUMNS.DATE\' | translate}}</div></th><th><div>\n{{\'ADMIN.MESSAGES_LOGS.COLUMNS.SENDER\' | translate}}</div></th><th><div>\n{{\'ADMIN.MESSAGES_LOGS.COLUMNS.RECEIVER\' | translate}}</div></th><th><div>\n{{\'ADMIN.MESSAGES_LOGS.COLUMNS.ACTIONS\' | translate}}</div></th></tr></thead><tbody><tr \nng-repeat=\"message in messages as arrayData track by message.id\" infinite-scroll-disabled=\"infiniteScrollPrevent\" \ninfinite-scroll=\"loadMore()\"><td>{{\'GENERAL.DATE_TIME_FORMAT\' | translate: {date: message.creationDate} }}</td><td>\n{{message.sender.fullName}}</td><td>{{message.receiver.fullName}}</td><td><md-button type=\"button\" \nng-click=\"seeMessage(message)\" translate=\"ADMIN.MESSAGES_LOGS.DETAILS\"></md-button></td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/admin/messagesLogs/usersLogs.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"ADMIN.USERSLOGS.TITLE\"></div>\n</div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table nl-responsive-table \nnl-table-data=\"arrayData\" class=\"dataTable row-border hover\"><thead><tr><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.DATE\' | translate}}</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.USER\' | translate}}</div>\n</th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.ENTITY\' | translate}}</div></th><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.ACTION\' | translate}}</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.OLD_VALUE\' | translate}}\n</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.NEW_VALUE\' | translate}}</div></th></tr></thead><tbody><tr \nng-repeat=\"log in logs as arrayData\"><td>{{log.date | date: \'dd/MM/yyyy à HH:mm\'}}</td><td>{{log.user}} <span \nng-if=\"log.userID\">(id: {{log.userID}})</span></td><td>{{ ENTITY_CONCERNED[log.type] | translate }}</td><td>\n{{ ACTIONS[log.action] | translate }}</td><td>{{log.oldValue}}</td><td>{{log.newValue}}</td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/admin/usersLogs/usersLogs.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"ADMIN.USERSLOGS.TITLE\"></div>\n</div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table nl-responsive-table \nnl-table-data=\"arrayData\" class=\"dataTable row-border hover\"><thead><tr><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.DATE\' | translate}}</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.USER\' | translate}}</div>\n</th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.ENTITY\' | translate}}</div></th><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.ACTION\' | translate}}</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.OLD_VALUE\' | translate}}\n</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.NEW_VALUE\' | translate}}</div></th></tr></thead><tbody><tr \nng-repeat=\"log in logs as arrayData\"><td>{{log.date | date: \'dd/MM/yyyy à HH:mm\'}}</td><td><div ng-if=\"log.userPic\" \nclass=\"nl-Msg-avatar mr-10\"><img class=\"nl-Table-avatar\" http-src=\"./alternatedocroots/{{log.userPic}}\" \nhas-profile-picture=\"log.userPic != null\"></div>{{log.user}}<br><div ng-if=\"log.userID\">(id: {{log.userID}})</div></td>\n<td><span ng-if=\"log.idContact\">\n{{\'ADMIN.USERSLOGS.ENTITIES.CONTACT\' | translate}}#{{log.idContact}} ({{\'ADMIN.USERSLOGS.ENTITIES.COMPANY\' | translate}}#{{log.idEntity}})\n</span> <span ng-if=\"!log.idContact\">{{\'ADMIN.USERSLOGS.ENTITIES.COMPANY\' | translate}}#{{log.idEntity}}</span></td>\n<td>{{ ACTIONS[log.action] | translate }}</td><td>{{log.oldValue | limitTo: 100}}</td><td>\n{{log.newValue | limitTo: 100}}</td></tr></tbody></table></div></div><md-button ng-disabled=\"allLoaded\" type=\"button\" \nclass=\"md-accent\" ng-click=\"getLogs()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'COMPANIES.LOAD_MORE\' | translate}}</md-button></div></div>");
$templateCache.put("app/main/blog/banners/addBanner.html","<div id=\"top_blog_edit\" class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div ng-if=\"banner.id\" translate=\"BANNER.UPDATE\"></div><div ng-if=\"!banner.id\" translate=\"BANNER.ADD\">\n</div></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button></div><div id=\"nl-js--FixedRightBar\" \nclass=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div \nclass=\"nl-FixedRightBar-panel\"></div></div><div class=\"content\"><div class=\"nl-Block\"><form name=\"formCreateBanner\" \nnovalidate><div class=\"mt-15\" layout=\"column\"><md-input-container class=\"mb-0\"><label>{{\"BANNER.NAME\"|translate}}\n</label><input ng-model=\"banner.title\" name=\"bannerName\" maxlength=\"255\" required autocomplete=\"name\"><div \nclass=\"pl-20\" ng-messages=\"formCreateBanner.bannerName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"mb-0\"><label>\n{{\"BANNER.URL\"|translate}}</label><input ng-model=\"banner.url\" name=\"bannerUrl\" maxlength=\"255\" required><div \nclass=\"pl-20\" ng-messages=\"formCreateBanner.bannerUrl.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"mb-0\"><label>\n{{\'BANNER.DATE_START\' | translate}}</label><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" \nmd-hide-icons=\"calendar\" ng-model=\"banner.startDateForm\" name=\"bannerStartDate\" md-open-on-focus required=\"\">\n</md-datepicker><div class=\"pl-20\" ng-messages=\"formCreateBanner.bannerStartDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container class=\"mb-0\"><label>{{\'BANNER.DATE_END\' | translate}}</label><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-hide-icons=\"calendar\" ng-model=\"banner.endDateForm\" name=\"bannerEndDate\" \nmd-open-on-focus required=\"\"></md-datepicker><div class=\"pl-20\" ng-messages=\"formCreateBanner.bannerEndDate.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container class=\"ml-20\"><md-checkbox class=\"md-primary md-hue-2\" \nng-model=\"banner.active\" aria-label=\"active\">{{\"BANNER.ACTIVE\"|translate}}</md-checkbox></md-input-container>\n<md-input-container class=\"ml-20\"><md-checkbox class=\"md-primary md-hue-2\" ng-model=\"banner.publish\" \naria-label=\"publish\">{{\"BANNER.PUBLISHED\"|translate}}</md-checkbox></md-input-container></div><div class=\"mv-20\"><div \nlayout=\"row\"><div class=\"m-5 nl-Form-dropify\" flex=\"100\" ng-if=\"banner.img\" layout=\"column\" layout-align=\"start end\">\n<div class=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify nl-Form-dropify--imgFull has--image\" \nng-src=\"alternatedocroots/{{banner.img.location}}\"></div><md-button class=\"md-raised md-warn md-hue-2\" \nng-click=\"displayPopUpDeletePhoto(banner.img)\"><md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon>\n{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div class=\"mv-20\"><md-button \nng-if=\"(!banner.id && photos.length==0) || (banner.id && !banner.img)\" type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"addNewPhoto()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\"BLOG.ADD_PHOTO\" | translate}}</md-button><div layout=\"row\"><div class=\"m-5 nl-Form-dropify\" flex=\"25\" \nng-repeat=\"photo in photos\" layout=\"column\" layout-align=\"start end\"><dropify-directive \nclass=\"dropify-wrapper has--deleteBtn\" filesave=\"photo.uploadFile\" ng-model=\"photo.model\"><md-button \nclass=\"md-raised md-warn md-hue-2\" ng-click=\"deletePhoto($index)\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div><md-button class=\"md-warn md-hue-2\" \nng-click=\"cancelAdd()\" aria-label=\"Annuler\" translate=\"GENERAL.CANCEL\"></md-button><md-button \nclass=\"md-primary md-raised md-hue-2\" ng-disabled=\"formCreateBanner.$invalid\" ng-click=\"saveBanner()\" \naria-label=\"Enregistrer\" translate=\"GENERAL.SAVE\"></md-button></div></form></div></div></div>");
$templateCache.put("app/main/blog/banners/banners.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"BANNER.TITLE\"></div></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-button class=\"md-accent md-hue-1 mr-15\" \ntype=\"button\" ng-click=\"goToAddPage()\"><md-icon md-font-icon=\"icon-plus\" class=\"s20\"></md-icon><span \ntranslate=\"BANNER.ADD\"></span></md-button><md-input-container flex class=\"md-accent md-hue-1\"><md-select \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-button class=\"md-accent md-hue-1 mr-15\" type=\"button\" \nng-click=\"goToAddPage()\"><md-icon md-font-icon=\"icon-plus\" class=\"s20\"></md-icon><span translate=\"BANNER.ADD\"></span>\n</md-button><md-input-container flex class=\"md-accent md-hue-1\"><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><div class=\"nl-Block\"><div class=\"\"><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"simple list-view\"><thead><th>ID</th><th>{{\"BANNER.NAME\" | translate}}</th><th>{{\"BANNER.DATE\" | translate}}</th>\n<th>{{\"BANNER.ACTIVE\" | translate}}</th><th>{{\"BANNER.PUBLISHED\" | translate}}</th><th>{{\"BLOG.ACTION\" | translate}}\n</th></thead><tbody><tr ng-repeat=\"banner in banners | orderBy: \'startDate\' as arrayData\"><td>{{banner.id}}</td><td>\n{{banner.title}}</td><td>\n{{getDate(banner.startDate) | date:\'dd/MM/yyyy\'}} > {{getDate(banner.endDate) | date:\'dd/MM/yyyy\'}}</td><td>\n<md-checkbox class=\"md-primary md-hue-2\" readonly=\"readonly\" ng-model=\"banner.active\" aria-label=\"valid\" \nng-click=\"setActive(banner)\"></md-checkbox></td><td><md-checkbox class=\"md-primary md-hue-2\" readonly=\"readonly\" \nng-model=\"banner.publish\" aria-label=\"publish\" ng-click=\"setPublish(banner)\"></md-checkbox></td><td><md-button \nmd-no-ink ng-click=\"updateBanner(banner)\" class=\"md-raised md-primary md-hue-2\" aria-label=\"update\">\n{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button md-no-ink ng-if=\"banner.url\" ng-click=\"goToURL(banner)\" \nclass=\"md-raised md-primary md-hue-2\" aria-label=\"URL\">{{\"BANNER.URL\" | translate}}</md-button><md-button md-no-ink \nng-click=\"removeBanner(banner)\" class=\"md-warn md-hue-2\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}\n</md-button></td></tr></tbody></table></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div \nclass=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/blog/countries/countries.html","<div id=\"top_blog\" class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"TAGS.COUNTRIES\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-input-container flex \nclass=\"md-accent md-hue-1\"><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex class=\"md-accent md-hue-1\"><md-select \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div></div><div class=\"content\"><div class=\"nl-Block\"><div class=\"\"><table \nnl-responsive-table nl-table-data=\"arrayData\" class=\"simple list-view\"><thead><th>ID</th><th>\n{{\"TAGS.LIBELLE\" | translate}}</th></thead><tbody><tr \nng-repeat=\"country in countries | orderBy: \'libelle\' as arrayData\"><td>{{country.id}}</td><td>{{country.libelle}}</td>\n</tr></tbody></table></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/blog/popup/add_tag.html","<md-dialog md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"column\" layout-align=\"center center\"><div ng-if=\"!tag.id\" class=\"contact-name\">\n{{\"BLOG.CREATION.ADD_TAG\" | translate}}</div><div ng-if=\"tag.id\" class=\"contact-name\">\n{{\"BLOG.CREATION.UPDATE_TAG\" | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"nl-Popup-content-body\"><form name=\"formAddTag\" novalidate><md-input-container \nclass=\"mb-0\"><label>{{\"BLOG.CREATION.NAME_TAG\"|translate}}</label><input ng-model=\"tag.name\" name=\"tagName\" \nmaxlength=\"255\" required autocomplete=\"name\"><div class=\"pl-20\" ng-messages=\"formAddTag.tagName.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></form>\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-warn md-hue-2\" ng-click=\"hidePopup()\" \ntranslate=\"GENERAL.CANCEL\"></md-button><md-button class=\"md-primary md-raised md-hue-2\" \nng-disabled=\"!tag.name || onSave\" ng-click=\"saveTag()\" translate=\"GENERAL.SAVE\"></md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/blog/popup/deletePhoto.popup.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\"BLOG.DELETE_PHOTO\" | translate}}</div></div>\n<md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"nl-Popup-content-body\"><div class=\"nl-Popup-content-body-title\">\n{{\"BLOG.CONFIRM_DELETE_PHOTO_BANNER\" | translate}}</div><br><img ng-src=\"alternatedocroots/{{photoToDelete.location}}\">\n</div></md-dialog-content><md-dialog-actions layout=\"row\"><md-button class=\"md-primary md-raised md-hue-2\" \nng-click=\"deletePhotoPermanentely()\" translate=\"GENERAL.YES\"></md-button><md-button class=\"md-warn md-hue-2\" \nng-click=\"hidePopup()\" translate=\"GENERAL.NO\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/blog/regions/regions.html","<div id=\"top_blog\" class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"TAGS.REGIONS\"></div></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-input-container flex \nclass=\"md-accent md-hue-1\"><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex class=\"md-accent md-hue-1\"><md-select \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div></div><div class=\"content\"><div class=\"nl-Block\"><div class=\"\"><table \nnl-responsive-table nl-table-data=\"arrayData\" class=\"simple list-view\"><thead><th>ID</th><th>\n{{\"TAGS.LIBELLE\" | translate}}</th></thead><tbody><tr ng-repeat=\"region in regions | orderBy: \'libelle\' as arrayData\">\n<td>{{region.id}}</td><td>{{region.libelle}}</td></tr></tbody></table></div><div class=\"nl-loader\" ng-show=\"!loaded\">\n<div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div>\n<div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/blog/tags/tags.html","<div id=\"top_blog\" class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"TAGS.TITLE\"></div></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-button class=\"md-accent md-hue-1 mr-15\" \ntype=\"button\" ng-click=\"showFormTag()\"><md-icon md-font-icon=\"icon-plus\" class=\"s20\"></md-icon><span \ntranslate=\"BLOG.CREATION.ADD_TAG\"></span></md-button><md-input-container flex class=\"md-accent md-hue-1\"><md-select \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-button class=\"md-accent md-hue-1 mr-15\" type=\"button\" \nng-click=\"showFormBlog()\"><md-icon md-font-icon=\"icon-plus\" class=\"s20\"></md-icon><span \ntranslate=\"BLOG.CREATION.ADD_TAG\"></span></md-button><md-input-container flex class=\"md-accent md-hue-1\"><md-select \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div></div><div class=\"content\"><div class=\"nl-Block\"><div class=\"\"><table \nnl-responsive-table nl-table-data=\"arrayData\" class=\"simple list-view\"><thead><th>ID</th><th>\n{{\"BLOG.CREATION.NAME_TAG\" | translate}}</th><th>{{\"BLOG.ACTION\" | translate}}</th></thead><tbody><tr \nng-repeat=\"tag in tags | orderBy: \'index\' as arrayData\"><td>{{tag.id}}</td><td>{{tag.name}}</td><td><div class=\"ml-15\" \nlayout=\"row\" layout-align=\"space-between center\"><md-button md-no-ink ng-click=\"showUpdateTag(tag)\" \nclass=\"md-raised md-primary md-hue-2\" aria-label=\"update\">{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button \nmd-no-ink ng-click=\"removeTag(tag)\" class=\"md-warn md-hue-2\" aria-label=\"Supprimer\">{{\"GENERAL.DELETE\" | translate}}\n</md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"!(tag.index > 0)\" \nng-click=\"up(tag.id);\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"tag.index === tags.length - 1 || tags.length <= 1\" ng-click=\"down(tag.id);\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></td></tr></tbody></table></div><div \nclass=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\">\n<div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div></div>\n</div></div>");
$templateCache.put("app/main/calendarExtern/popup/addEvent.html","<md-dialog class=\"document-dialog\" aria-label=\"Document\" flex=\"40\" md-theme=\"teal-theme\"><form name=\"eventForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"eventForm.$valid && saveEvent()\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'FOLDERS.UPLOAD_FILE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-input-container class=\"nl-Input-container\" flex=\"100\"><label>\n{{\"CALENDAR_EXTERN.CREATION.NAME\" | translate}}</label><input ng-model=\"event.name\" name=\"name\" required><div \nng-messages=\"eventForm.name\" role=\"alert\"><div ng-message=\"required\"><span>{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><label>\n{{\"CALENDAR_EXTERN.CREATION.PLACE\" | translate}}</label><input ng-model=\"event.place\" name=\"place\" required><div \nng-messages=\"eventForm.place\" role=\"alert\"><div ng-message=\"required\"><span>{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><label>\n{{\"CALENDAR_EXTERN.CREATION.WEBSITE\" | translate}}</label><input ng-model=\"event.website\" name=\"website\" required><div \nng-messages=\"eventForm.website\" role=\"alert\"><div ng-message=\"required\"><span>{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></div></md-input-container><md-input-container class=\"md-block\"><md-datepicker ng-model=\"event.startDateForm\" \nname=\"eventStartDate\" md-placeholder=\"{{\'CALENDAR_EXTERN.CREATION.DATE_START\' | translate}}\" md-open-on-focus \nrequired=\"\"></md-datepicker><div class=\"pl-20\" ng-messages=\"eventForm.eventStartDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container class=\"md-block mv-0\"><label>{{\'CALENDAR_EXTERN.CREATION.TIME_START\' | translate}} hh:mm</label>\n<input type=\"text\" class=\"input-value\" name=\"eventStartTime\" ng-model=\"event.startTime\" ui-time-mask=\"short\" required>\n<div class=\"pl-20\" ng-messages=\"eventForm.eventStartTime.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div><div ng-message=\"time\"><span>\n{{\"GENERAL.FORM.INVALID_FORMAT\" | translate}} (hh:mm)</span></div></div><div ng-if=\"timeNotMatch\" \nclass=\"ng-scope nl_form-error-input\"><span>{{\"CALENDAR_EXTERN.TIME_ERROR\" | translate}}</span></div>\n</md-input-container><md-input-container class=\"md-block\"><md-datepicker ng-model=\"event.endDateForm\" \nname=\"eventEndDate\" md-placeholder=\"{{\'CALENDAR_EXTERN.CREATION.DATE_END\' | translate}}\" \nmd-min-date=\"event.startDateForm\" md-open-on-focus required></md-datepicker><div class=\"pl-20\" \nng-messages=\"eventForm.eventEndDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"md-block mv-0\">\n<label>{{\'CALENDAR_EXTERN.CREATION.TIME_END\' | translate}} hh:mm</label><input type=\"text\" class=\"input-value\" \nname=\"eventEndTime\" ng-model=\"event.endTime\" ui-time-mask=\"short\" required><div class=\"pl-20\" \nng-messages=\"eventForm.eventEndTime.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div><div ng-message=\"time\"><span>\n{{\"GENERAL.FORM.INVALID_FORMAT\" | translate}} (hh:mm)</span></div></div><div ng-if=\"timeNotMatch\" \nclass=\"ng-scope nl_form-error-input\"><span>{{\"CALENDAR_EXTERN.TIME_ERROR\" | translate}}</span></div>\n</md-input-container></md-dialog-content><md-dialog-actions class=\"pr-25\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 md-raised\" aria-label=\"Ajouter\">{{\"GENERAL.SAVE\" | translate}}</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/duplication_tool/junk_box/junk_box.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\">{{ \'JUNK_BOX.TITLE\' | translate }}</div></div><div layout=\"row\" layout-align=\"start center\">\n<div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" class=\"\" \nng-click=\"onDeleteJunkBoxSelection();\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>\n{{\'JUNK_BOX.ACTIONS.REMOVE_SELECTION_CONFIRMATION_TITLE\' | translate}}</md-button></div></div></div><div \nclass=\"content\"><div class=\"nl-Block nl-Block--table\"><div layout=\"row\"><table class=\"dataTable row-border hover\">\n<thead><th width=\"10%\" style=\"text-align:center!important\"><md-checkbox class=\"md-primary md-hue-2 mb-0\" name=\"\" \nng-model=\"modelsSelected.all\" aria-label=\"select all\" ng-change=\"onSelectAll();\"></md-checkbox></th><th width=\"35%\" \ntranslate=\"JUNK_BOX.FIELDS.NAME\"></th><th width=\"25%\" translate=\"JUNK_BOX.FIELDS.MODEL_TYPE\"></th><th width=\"20%\" \ntranslate=\"JUNK_BOX.FIELDS.DELETION_DATE\"></th><th width=\"10%\"></th></thead><tbody><tr \nng-repeat=\"_model in models | orderBy: \'-updateDate\'\" ng-click=\"onDetailsJunkBox(_model)\"><td \nstyle=\"text-align:center!important\"><md-checkbox class=\"md-primary md-hue-2 mb-0\" name=\"\" ng-model=\"_model.selected\" \naria-label=\"select\" ng-click=\"$event.stopPropagation();\"></md-checkbox></td><td><div class=\"nl-Block--table--company\">\n{{ _model.modelPattern }}</div></td><td>{{ \'JUNK_BOX.FIELDS.TYPES.\' + _model.modelType | translate }}</td><td>\n{{_model.updateDate|date:\'dd/MM/yyyy HH:mm\'}}</td><td><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row\"><md-button flex type=\"button\" \nclass=\"md-warn md-hue-2 nl-Button--small\" ng-click=\"$event.stopPropagation();onDeleteJunkBox(_model)\" \nng-if=\"!_model.actionInProgress\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-progress-circular \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" md-mode=\"indeterminate\" md-diameter=\"36\" \nng-if=\"_model.actionInProgress\"></md-progress-circular></div></td></tr></tbody></table></div><div class=\"nl-loader\" \nng-show=\"loaded\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div \nclass=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/duplication_tool/merge_tool/merge_tool.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"DUPLICATION_TOOL.MERGE.TITLE\">\n</div></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide \nshow-gt-sm><md-button type=\"button\" class=\"\" ng-click=\"_mergeModelsFn();\" ng-disabled=\"inProgress || !_modelsToMerge\">\n<md-icon md-font-icon=\"icon-arrange-bring-to-front\"></md-icon>{{\'DUPLICATION_TOOL.MERGE.MERGE_BTN\' | translate}}\n</md-button></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" \nng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div layout=\"column\" \nlayout-align=\"start start\"><md-button type=\"button\" class=\"\" ng-click=\"_mergeModelsFn();\" \nng-disabled=\"inProgress || !_modelsToMerge\"><md-icon md-font-icon=\"icon-arrange-bring-to-front\"></md-icon>\n{{\'DUPLICATION_TOOL.MERGE.MERGE_BTN\' | translate}}</md-button></div></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\" layout-wrap class=\"m-20 p-20\" style=\"overflow-x:auto\" \nng-if=\"_modelsToMerge\"><table class=\"dataTable row-border\"><thead><tr class=\"md-grey-50-bg\"><th \nstyle=\"min-width:150px!important\">{{ \'DUPLICATION_TOOL.MERGE.COLUMNS.CATEGORY\' | translate}}</th><th \nstyle=\"min-width:150px!important\">{{ \'DUPLICATION_TOOL.MERGE.COLUMNS.SUB_CATEGORY\' | translate}}</th><th \nstyle=\"min-width:150px!important\">{{ \'DUPLICATION_TOOL.MERGE.COLUMNS.FIELD\' | translate}}</th><th \nstyle=\"min-width:250px!important\" ng-repeat=\"_model in _modelsToMerge.models | orderBy : \'modelPattern\'\" ng-style=\"\">\n<div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row\" style=\"text-align: center!important\">\n{{_model.modelPattern}}</div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row mt-5\" style=\"text-align: center!important\">\n{{ \'DUPLICATION_TOOL.MERGE.CREATION_DATE\' | translate}} : {{_model.creation | date:\'dd/MM/yyyy - HH:mm\' }}</div><div \nlayout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row\"><span><md-button type=\"button\" \nclass=\"md-accent md-hue-2 md-teal-theme-theme\" ng-if=\"_modelsToMerge.models.length > 2\" \nng-click=\"_removeFalsePositiveColumnFn(_model);\"><md-icon md-font-icon=\"icon-bookmark-remove\"></md-icon><md-tooltip \nmd-direction=\"bottom\">{{\'DUPLICATION_TOOL.MERGE.FALSE_POSITIVE_COLUMN_TITLE\' | translate}}</md-tooltip></md-button>\n<md-button type=\"button\" class=\"md-accent md-hue-2 md-teal-theme-theme\" ng-click=\"_defaultColumnSelectedFn(_model);\">\n<md-icon md-font-icon=\"icon-check-all\" ng-if=\"!_model._defaultColumnSelected\" style=\"color: #ef9a9a!important\">\n</md-icon><md-icon md-font-icon=\"icon-check-all\" ng-if=\"_model._defaultColumnSelected\" \nstyle=\"color: #81c784!important\"></md-icon><md-tooltip md-direction=\"bottom\" ng-if=\"!_model._defaultColumnSelected\">\n{{\'DUPLICATION_TOOL.MERGE.SELECT_LIKE_DEFAULT_COLUMN\' | translate}}</md-tooltip><md-tooltip md-direction=\"bottom\" \nng-if=\"_model._defaultColumnSelected\">{{\'DUPLICATION_TOOL.MERGE.DEFAULT_COLUMN_SELECTED\' | translate}}</md-tooltip>\n</md-button></span></div></th></tr></thead><tbody \nng-repeat=\"_category in _modelsToMerge.categories | orderBy : \'index\'\"><tr \nng-repeat=\"_field in _category.values | orderBy : [\'subCatIndex\', \'libelle\']\" ng-init=\"\"><td \nrowspan=\"{{_category.values.length}}\" ng-hide=\"$index>0\" style=\"border-bottom: 1px solid #e0e0e0 !important\"><strong \nng-if=\"!_category.fixeFieldCategory\">{{_category.name}}</strong> <strong ng-if=\"_category.fixeFieldCategory\">\n{{ \'DUPLICATION_TOOL.MERGE.FIXE_FIELD_CATEGORY\' | translate}}</strong></td><td><strong>{{_field.subCatName}}</strong>\n</td><td><span ng-if=\"!_field.fixeField\">{{_field.libelle}}</span> <span ng-if=\"_field.fixeField\">\n{{ \'DUPLICATION_TOOL.MERGE.\' + _field.libelle | translate}}</span> <span ng-if=\"_field.noModelSelected\" \nstyle=\"color:red\">*</span></td><td ng-repeat=\"_valuedField in _field.values | orderBy : \'modelInfos.modelPattern\'\">\n<span><md-checkbox ng-model=\"_valuedField.selected\" ng-change=\"_modelFieldSelectedFn(_category, _field, _valuedField)\">\n<span><span ng-if=\"_field.typeChamps != \'MULTIPLE_SELECT\'\"><span \nng-show=\"_field.typeChamps == \'BOOLEAN\' || _field.typeChamps == \'RICH_TEXT\' || _field.typeChamps == \'FILE\' \n                                                    || _field.typeChamps == \'IMAGE\'\">\n<span ng-if=\"_field.typeChamps == \'BOOLEAN\'\"><span ng-if=\"_valuedField.value && _valuedField.value == \'true\'\" \nng-init=\"_valuedField.valueTmp = true\"><span translate=\"DUPLICATION_TOOL.MERGE.FIELD_VALUE.BOOLEAN.YES\"></span> </span>\n<span ng-if=\"!_valuedField.value || (_valuedField.value && _valuedField.value != \'true\')\" \nng-init=\"_valuedField.valueTmp = false\"><span translate=\"DUPLICATION_TOOL.MERGE.FIELD_VALUE.BOOLEAN.NO\"></span> </span>\n</span><span ng-if=\"_field.typeChamps == \'RICH_TEXT\'\"><span ng-bind-html=\"unsafe(_valuedField.value)\"></span> </span>\n<span ng-if=\"_field.typeChamps == \'FILE\' || _field.typeChamps == \'IMAGE\'\"><span ng-if=\"_field.typeChamps == \'FILE\'\">\n{{_valuedField.fileName}}</span> <span ng-if=\"_field.typeChamps == \'IMAGE\' && _valuedField.fileLocation\"><img \nng-src=\"/alternatedocroots/{{_valuedField.fileLocation}}\" alt=\"img\" style=\"max-width: 80px!important\"> </span></span>\n</span><span \nng-hide=\"_field.typeChamps == \'BOOLEAN\' || _field.typeChamps == \'RICH_TEXT\' || _field.typeChamps == \'FILE\' \n                                                    || _field.typeChamps == \'IMAGE\'\">\n{{_valuedField.value}} </span></span><span ng-if=\"_field.typeChamps == \'MULTIPLE_SELECT\'\"><span \nng-repeat=\"_value in _valuedField.values  | orderBy : \'libelle\'\"><label class=\"label-toogle\" \nng-init=\"_value.selected = false\" \nng-click=\"$event.stopPropagation();onMultipleSelectValueClick(_value, _valuedField, _field, _category);\" \nng-class=\"{\'label-toogle-selected\' : _value.selected, \'label-toogle-unselected\' : !_value.selected}\">\n- {{_value.libelle}}</label><span ng-if=\"!$last\"><br></span></span></span></span></md-checkbox></span></td></tr>\n</tbody></table></div><div class=\"layout-align-space-around-stretch layout-row m-20 p-20\" ng-if=\"inProgress\">\n<md-progress-circular class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><div layout=\"row\" layout-wrap class=\"m-10 p-10\"><md-button flex \nmd-no-ink class=\"md-primary\" ng-click=\"_mergeModelsFn();\" ng-disabled=\"inProgress || !_modelsToMerge\"><md-icon \nmd-font-icon=\"icon-arrange-bring-to-front\"></md-icon>{{\'DUPLICATION_TOOL.MERGE.MERGE_BTN\' | translate}}</md-button>\n</div></div></div></div>");
$templateCache.put("app/main/errors/401/error-401.html","<div id=\"error-401\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\">{{\'ACCESS_DENIED.TITLE\' | translate}}</div><div class=\"message\">\n{{\'ACCESS_DENIED.MESSAGE\' | translate}}</div><a class=\"back-link md-accent-color mt-32\" href=\"/\">\n{{\'ACCESS_DENIED.BACK\' | translate}}</a></div></div>");
$templateCache.put("app/main/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\">404</div><div class=\"message\">\nDésolé, nous n\'avons pu trouver la page à laquelle vous voulez accéder</div><a class=\"back-link md-accent-color mt-32\" \nhref=\"/\">Retour à l\'accueil</a></div></div>");
$templateCache.put("app/main/events/inscriptions/status.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"INSCRIPTION_STATUS.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-input-container flex><md-select\n ng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><div class=\"nl-Block mt-20\"><form name=\"newStatusForm\" role=\"form\" novalidate \nng-submit=\"newStatusForm.$valid && add(newStatusForm)\"><div layout=\"column\"><h3 translate=\"INSCRIPTION_STATUS.TITLE\">\n</h3><div layout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"\"><label \ntranslate=\"INSCRIPTION_STATUS.NAME\"></label><input type=\"text\" maxlength=\"255\" required ng-model=\"newStatus.name\" \nrequired name=\"name\"><div ng-messages=\"newStatusForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nObligatoire.</span></div></div></md-input-container><md-input-container class=\"\"><label \ntranslate=\"INSCRIPTION_STATUS.COLOR\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"newStatus.color\" \nname=\"color\"></md-input-container><div><md-button type=\"submit\" class=\"md-raised md-primary md-hue-2\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form><div \nng-repeat=\"status in statuses | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" flex><div layout=\"row\" flex ng-if=\"!status.editionMode\"><h3 \nclass=\"\" flex=\"50\">{{status.name}}</h3><h3 class=\"ml-30\" flex>\n{{\'INSCRIPTION_STATUS.COLOR\' | translate }} : {{status.color}}</h3></div><div layout=\"row\" ng-if=\"status.editionMode\" \nflex><md-input-container><label translate=\"INSCRIPTION_STATUS.NAME\"></label><input type=\"text\" maxlength=\"255\" \nrequired ng-model=\"statusToEdit.name\" name=\"name\"><div ng-messages=\"editStatusForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container><md-input-container class=\"\"><label \ntranslate=\"INSCRIPTION_STATUS.COLOR\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"statusToEdit.color\" \nname=\"color\"></md-input-container></div></div><div class=\"panel-actions panel-actions-keep\" layout=\"row\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-if=\"!status.editionMode\" type=\"button\" \nclass=\"md-fab md-mini md-hue-2\" ng-click=\"edit(status);\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon>\n</md-button><div class=\"ml-15\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"status.editionMode\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"update(status);\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-hue-2\" ng-click=\"cancel(status);\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</md-button></div><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"remove(status.id);\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(status.index > 0)\" ng-click=\"up(status.id);\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"status.index === statuses.length - 1 || statuses.length <= 1\" ng-click=\"down(status.id);\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/events/inscriptions/sub_categories.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"INSCRIPTION_SUB_CATEGORY.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-input-container flex><md-select\n ng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><div class=\"nl-Block mt-20\"><form name=\"newSubCategoryForm\" role=\"form\" novalidate \nng-submit=\"newSubCategoryForm.$valid && add(newSubCategoryForm)\"><div layout=\"column\"><h3 \ntranslate=\"INSCRIPTION_SUB_CATEGORY.TITLE\"></h3><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container class=\"\"><input type=\"text\" maxlength=\"255\" required ng-model=\"newSubCategory.name\" required \nname=\"name\"><div ng-messages=\"newSubCategoryForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nObligatoire.</span></div></div></md-input-container><div><md-button type=\"submit\" \nclass=\"md-raised md-primary md-hue-2\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form><div \nng-repeat=\"category in subcategories | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><h3 class=\"\" ng-if=\"!category.editionMode\">{{category.name}}</h3>\n<md-input-container ng-if=\"category.editionMode\"><input type=\"text\" maxlength=\"255\" required \nng-model=\"subCategoryToEdit.name\" required name=\"name\"><div ng-messages=\"editStatusForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container></div><div \nclass=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-if=\"!category.editionMode\" type=\"button\" class=\"md-fab md-mini md-hue-2\" ng-click=\"edit(category);\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\" ng-if=\"category.editionMode\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"update(category);\"><md-icon md-font-icon=\"icon-content-save\" \nclass=\"s18\"></md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-hue-2\" \nng-click=\"cancel(category);\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></md-button></div><md-button \ntype=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"remove(category.id);\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(category.index > 0)\" ng-click=\"up(category.id);\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"category.index === subcategories.length - 1 || subcategories.length <= 1\" ng-click=\"down(category.id);\">\n<md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/events/logistics/status.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"LOGISTICAL_STATUS.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-input-container flex><md-select\n ng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><div class=\"nl-Block mt-20\"><form name=\"newStatusForm\" role=\"form\" novalidate \nng-submit=\"newStatusForm.$valid && add(newStatusForm)\"><div layout=\"column\"><h3 translate=\"LOGISTICAL_STATUS.TITLE\">\n</h3><div layout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"\"><label \ntranslate=\"LOGISTICAL_STATUS.NAME\"></label><input type=\"text\" maxlength=\"255\" required ng-model=\"newStatus.name\" \nname=\"name\"><div ng-messages=\"newStatusForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Obligatoire.\n</span></div></div></md-input-container><md-input-container class=\"\"><label translate=\"LOGISTICAL_STATUS.COLOR\">\n</label><input type=\"text\" maxlength=\"255\" ng-model=\"newStatus.color\" name=\"color\"></md-input-container><div><md-button\n type=\"submit\" class=\"md-raised md-primary md-hue-2\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form><div \nng-repeat=\"status in statuses | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" flex><div layout=\"row\" flex ng-if=\"!status.editionMode\"><h3 \nclass=\"\" flex=\"50\">{{status.name}}</h3><h3 class=\"ml-30\" flex>\n{{\'LOGISTICAL_STATUS.COLOR\' | translate }} : {{status.color}}</h3></div><div layout=\"row\" ng-if=\"status.editionMode\" \nflex><md-input-container><label translate=\"LOGISTICAL_STATUS.NAME\"></label><input type=\"text\" maxlength=\"255\" required \nng-model=\"statusToEdit.name\" name=\"name\"><div ng-messages=\"editStatusForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container><md-input-container class=\"\"><label \ntranslate=\"LOGISTICAL_STATUS.COLOR\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"statusToEdit.color\" \nname=\"color\"></md-input-container></div></div><div class=\"panel-actions panel-actions-keep\" layout=\"row\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-if=\"!status.editionMode\" type=\"button\" \nclass=\"md-fab md-mini md-hue-2\" ng-click=\"edit(status);\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon>\n</md-button><div class=\"ml-15\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"status.editionMode\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"update(status);\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-hue-2\" ng-click=\"cancel(status);\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</md-button></div><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"remove(status.id);\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(status.index > 0)\" ng-click=\"up(status.id);\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"status.index === statuses.length - 1 || statuses.length <= 1\" ng-click=\"down(status.id);\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/events/popup/add_event.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add event\" flex=\"40\" md-theme=\"teal-theme\"><form name=\"newEventForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"newEventForm.$valid && save(newEventForm)\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'EVENT.NEW\' | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"row\" layout-wrap><div class=\"nl-info-block-list-img animated fadeIn\" flex=\"30\">\n<dropify-directive id=\"add_event_dropify\" filesave=\"photo.uploadFile\" name=\"logo\" ng-model=\"event\"></div><div \nflex=\"65\" class=\"\" layout=\"column\"><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" \nclass=\"\" ng-model=\"event.name\" name=\"name\" required maxlength=\"255\"><label class=\"\" translate=\"EVENT.COLUMNS.NAME\">\n</label><div ng-messages=\"newEventForm.name.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" ng-model=\"event.start\" name=\"start\" \nmd-placeholder=\"{{\'EVENT.COLUMNS.START\' | translate}}\" md-open-on-focus required=\"\" md-hide-icons=\"calendar\">\n</md-datepicker><div ng-messages=\"newEventForm.start.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" \nng-model=\"event.end\" name=\"end\" md-placeholder=\"{{\'EVENT.COLUMNS.END\' | translate}}\" md-open-on-focus \nmd-hide-icons=\"calendar\"></md-datepicker></md-input-container><md-input-container class=\"nl-Input-container ml-15\" \nflex=\"100\"><md-select ng-model=\"event.site\" ng-model-options=\"{trackBy: \'$value.id\'}\" name=\"site\" required><md-option \nng-repeat=\"site in sites | orderBy: \'name\' track by site.id\" ng-value=\"site\">{{site.name}}</md-option></md-select>\n<label class=\"\" translate=\"EVENT.COLUMNS.SITE\"></label><div ng-messages=\"newEventForm.site.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 md-raised\" ng-disabled=\"newEventForm.$invalid\" aria-label=\"Sauvegarder\" \ntranslate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/festival/popup/deletePhoto.popup.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\"FESTIVAL.DELETE_PHOTO\" | translate}}</div>\n</div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nclass=\"nl-Popup-content-body\"><div class=\"nl-Popup-content-body-title\">{{\"FESTIVAL.CONFIRM_DELETE_PHOTO\" | translate}}\n</div><br><img ng-src=\"alternatedocroots/{{photoToDelete.location}}\"></div></md-dialog-content><md-dialog-actions \nlayout=\"row\"><md-button class=\"md-primary md-raised md-hue-2\" ng-click=\"deletePhotoPermanentely()\" \ntranslate=\"GENERAL.YES\"></md-button><md-button class=\"md-primary md-hue-2\" ng-click=\"hidePopup()\" \ntranslate=\"GENERAL.NO\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/gallery/details/addSubGallery.popup.html","<md-dialog class=\"nl_Dialog\" aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\"GALLERY.POPUP.TITLE_SUB\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Popup-content-body\"></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/gallery/details/details.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"GALLERY.DETAILS.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-input-container flex><md-select \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><md-button ng-click=\"goBack()\" md-no-ink class=\"md-primary md-raised md-hue-2\" \ntranslate=\"GALLERY.GO_GALLERIES\"></md-button><div class=\"nl-Block\"><form layout=\"row\" ng-if=\"loaded\" \nname=\"detailsGalleryForm\" class=\"nl-Form-xs\" ng-submit=\"detailsGalleryForm.$valid && upate()\"><md-input-container>\n<label>{{\"GALLERY.TITLE\" | translate}}</label><input type=\"text\" ng-model=\"gallery.title\" name=\"title\" required><div \nng-messages=\"detailsGalleryForm.title.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-button type=\"submit\" md-no-ink \nclass=\"md-primary md-raised md-hue-2\" translate=\"GENERAL.SAVE\"></md-button></form><span \nng-if=\"gallery.subGalleries.length > 0\"><div class=\"nl_categories-item-subtitle\">{{\"GALLERY.SUBGALLERIES\" | translate}}\n</div><span ng-repeat=\"sub in gallery.subGalleries | orderBy: \'index\'\"><div class=\"nl_categories-item-subtitle\"><div \nlayout=\"row\" layout-align=\"start center\">{{sub.title}}<md-button ng-click=\"goAddSubGallery(sub)\" md-no-ink \nclass=\"md-primary md-raised md-hue-2\" translate=\"GENERAL.UPDATE\"></md-button><md-button ng-disabled=\"!(sub.index > 0)\" \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"upSub(sub)\"><md-icon md-font-icon=\"icon-arrow-up\" \nclass=\"s18\"></md-icon></md-button><md-button ng-disabled=\"!(sub.index != gallery.subGalleries.length - 1)\" \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"downSub(sub)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button><md-button class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"showPopUpRemove(sub, $index)\"><md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></div>\n</div>{{\"GALLERY.UUID\" | translate}}: {{sub.uuid}}<div layout=\"row\" layout-wrap><div class=\"m-5 nl-Form-dropify\" \nflex=\"15\" ng-repeat=\"photo in sub.pictures | limitTo: 5 track by $index\" layout=\"column\" layout-align=\"start end\"><div \nclass=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify has--image\" ng-src=\"alternatedocroots/{{photo.location}}\">\n</div></div></div><span ng-if=\"sub.pictures.length > 5\">{{\"GALLERY.MORE_PICTURES\" | translate}}</span></span></span>\n<md-button ng-click=\"goAddSubGallery()\" md-no-ink class=\"md-primary md-raised md-hue-2\" \ntranslate=\"GALLERY.ADD_SUBGALLERY\"></md-button><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div \nclass=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/gallery/details/removeSubGallery.popup.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">\n{{\"GALLERY.DETAILS.POPUP.DELETE_TITLE\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Popup-content-body\"><div class=\"nl-Popup-content-body-title\">\n{{\"GALLERY.DETAILS.POPUP.CONFIRM_DELETE\" | translate}}</div></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button class=\"md-primary md-raised md-hue-2\" ng-click=\"removeSubGallery()\" translate=\"GENERAL.YES\"></md-button>\n<md-button class=\"md-primary md-hue-2\" ng-click=\"hidePopup()\" translate=\"GENERAL.NO\"></md-button></md-dialog-actions>\n</md-dialog>");
$templateCache.put("app/main/gallery/subGallery/subGallery.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div ng-if=\"!updateMode\" class=\"\" translate=\"GALLERY.ADD_SUBGALLERY\"></div><div ng-if=\"updateMode\" \nclass=\"\" translate=\"GALLERY.UPDATE_SUBGALLERY\"></div></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-input-container flex><md-select \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><md-button ng-click=\"goBack()\" md-no-ink class=\"md-primary md-raised md-hue-2\" \ntranslate=\"GALLERY.GO_GALLERY\"></md-button><form name=\"addPSubGalleryForm\" class=\"nl-Form-xs\" \nng-submit=\"addPSubGalleryForm.$valid && update()\"><md-input-container><label>{{\"GALLERY.TITLE\" | translate}}</label>\n<input type=\"text\" ng-model=\"subGallery.title\" name=\"title\" required><div \nng-messages=\"addPSubGalleryForm.title.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><div layout=\"row\" layout-wrap><div \nclass=\"m-5 nl-Form-dropify\" flex=\"15\" ng-repeat=\"photo in subGallery.pictures track by $index\" layout=\"column\" \nlayout-align=\"start end\"><div class=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify has--image\" \nng-src=\"alternatedocroots/{{photo.location}}\"></div><md-button class=\"md-raised md-warn md-hue-2\" \nng-click=\"displayPopUpDeletePhoto(photo, $index, subGallery)\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>{{\"GENERAL.DELETE\" | translate}}</md-button></div></div><div class=\"mv-20\"><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"photos.push({})\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\"PACKAGES.ADD.ADD_PHOTO\" | translate}}</md-button><div layout=\"row\" layout-wrap><div class=\"m-5 nl-Form-dropify\" \nflex=\"nogrow\" ng-repeat=\"photo in photos\" layout=\"column\" layout-align=\"start end\"><dropify-directive \nclass=\"dropify-wrapper has--deleteBtn\" filesave=\"photo.uploadFile\" ng-model=\"photo.model\"><md-button type=\"button\" \nclass=\"md-raised md-warn md-hue-2\" ng-click=\"deletePhoto($index)\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>{{\"PACKAGES.ADD.DELETE_PHOTO\" | translate}}</md-button></div></div></div><md-button type=\"submit\" \nng-disabled=\"updatingPhotos\" md-no-ink class=\"md-primary md-raised md-hue-2\"><span ng-if=\"updatingPhotos\"><div \nclass=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div \nclass=\"right\"><div class=\"half-circle\"></div></div></div></div></span><span ng-if=\"!updatingPhotos\" \ntranslate=\"GENERAL.SAVE\"></span></md-button></form><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div \nclass=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div></div></div>");
$templateCache.put("app/main/globe_network/companies/companies.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><md-progress-linear \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" mode=\"indeterminate\" \nng-if=\"_mdProgressLinear\"></md-progress-linear><md-progress-linear \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-determinate\" mode=\"determinate\" \nvalue=\"{{determinateValue}}\" ng-if=\"_mdProgressLinear\"></md-progress-linear><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\">{{subTypeObj.name}}</div></div><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm>\n<md-button type=\"button\" class=\"md-accent md-hue-1 md-button md-ink-ripple md-teal-theme-theme\" \nng-click=\"showCompanyDialog()\" permissions=\"[\'DB_ADD_COMPANY\']\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'COMPANIES.ADD\' | translate}}</md-button><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavRight()\" aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button></div><div layout=\"row\" layout-align=\"start center\" hide><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"toggleSidenavRight();lookForMissingInfos()\" \npermissions=\"[\'DB_MISSING_INFOS_TOOLS\']\"><md-icon md-font-icon=\"icon-alert-circle\"></md-icon><span \ntranslate=\"MISSING_INFOS_TOOL.TITLE\"></span></md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"toggleSidenavRight();oadDuplicationTool()\"><md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><span \ntranslate=\"COMPANIES.DUPLICATION_TOOL\"></span></md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"toggleSidenavRight();_mailingDialogOpenFn()\" permissions=\"[\'DB_SEND_MAIL\']\"><md-icon \nmd-font-icon=\"icon-bullhorn\"></md-icon><span translate=\"MAILING.DO_MAILING.MAILING_BTN\"></span></md-button><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"toggleSidenavRight();showFieldsStats = !showFieldsStats; showFieldsStats ? getStatisticsBySubTypeID(filter): null;\" \npermissions=\"[\'DB_GET_STATS_REPARTITION\']\"><md-icon md-font-icon=\" icon-trending-up\"></md-icon><span \ntranslate=\"COMPANIES.GET_STATS_REPART\"></span></md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"toggleSidenavRight();_openAutoMergeDialog()\"><md-icon md-font-icon=\"icon-flash-auto\"></md-icon><span \ntranslate=\"COMPANIES.AUTO_MERGE\"></span></md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"toggleSidenavRight();showExport = !showExport\" permissions=\"[\'DB_EXPORT\']\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"COMPANIES.EXPORT.TITLE\"></span></md-button><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"toggleSidenavRight();switchActives()\" \npermissions=\"[\'DB_DISPLAY_INACTIVES\']\"><md-icon md-font-icon=\"icon-auto-fix\"></md-icon><span ng-hide=\"!hideAll\" \ntranslate=\"USERS.SEE_INACTIVES\"></span> <span ng-show=\"!hideAll\" translate=\"USERS.HIDE_INACTIVES\"></span></md-button>\n<md-button type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"toggleSidenavRight();showBulkUpdateDialog()\" \npermissions=\"[\'DB_BULK_UPDATE\']\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>{{\'COMPANIES.BULK_UPDATE\' | translate}}\n</md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"toggleSidenavRight();showBulkMessageDialog()\" permissions=\"[\'DB_BULK_MESSAGE\']\"><md-icon \nmd-font-icon=\"icon-message\"></md-icon>{{\'COMPANIES.BULK_MESSAGE\' | translate}}</md-button></div></div><div \nid=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" \nng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div layout=\"column\" \nlayout-align=\"start start\"><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"toggleSidenavRight();lookForMissingInfos()\" permissions=\"[\'DB_MISSING_INFOS_TOOLS\']\"><md-icon \nmd-font-icon=\"icon-alert-circle\"></md-icon><span translate=\"MISSING_INFOS_TOOL.TITLE\"></span></md-button><md-button \nng-if=\"showIfAllowed\" type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"toggleSidenavRight();loadDuplicationTool()\">\n<md-icon md-font-icon=\"icon-content-duplicate\"></md-icon><span translate=\"COMPANIES.DUPLICATION_TOOL\"></span>\n</md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"toggleSidenavRight();_mailingDialogOpenFn()\" \npermissions=\"[\'DB_SEND_MAIL\']\"><md-icon md-font-icon=\"icon-bullhorn\"></md-icon><span \ntranslate=\"MAILING.DO_MAILING.MAILING_BTN\"></span></md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"toggleSidenavRight();showFieldsStats = !showFieldsStats; showFieldsStats ? getStatisticsBySubTypeID(filter): null;\" \npermissions=\"[\'DB_GET_STATS_REPARTITION\']\"><md-icon md-font-icon=\" icon-trending-up\"></md-icon><span \ntranslate=\"COMPANIES.GET_STATS_REPART\"></span></md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"toggleSidenavRight();_openAutoMergeDialog()\" permissions=\"[\'DB_AUTO_MERGE\']\"><md-icon \nmd-font-icon=\"icon-flash-auto\"></md-icon><span translate=\"COMPANIES.AUTO_MERGE\"></span></md-button><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"toggleSidenavRight();showExport = !showExport\" \npermissions=\"[\'DB_EXPORT\']\"><md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"COMPANIES.EXPORT.TITLE\">\n</span></md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"toggleSidenavRight();switchActives()\" \npermissions=\"[\'DB_DISPLAY_INACTIVES\']\"><md-icon md-font-icon=\"icon-auto-fix\"></md-icon><span ng-hide=\"!hideAll\" \ntranslate=\"USERS.SEE_INACTIVES\"></span> <span ng-show=\"!hideAll\" translate=\"USERS.HIDE_INACTIVES\"></span></md-button>\n<md-button type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"toggleSidenavRight();showBulkUpdateDialog()\" \npermissions=\"[\'DB_BULK_UPDATE\']\"><md-icon md-font-icon=\"icon-pencil\"></md-icon>{{\'COMPANIES.BULK_UPDATE\' | translate}}\n</md-button><md-button type=\"button\" class=\"md-accent md-hue-1\" \nng-click=\"toggleSidenavRight();showBulkMessageDialog()\" permissions=\"[\'DB_BULK_MESSAGE\']\"><md-icon \nmd-font-icon=\"icon-message\"></md-icon>{{\'COMPANIES.BULK_MESSAGE\' | translate}}</md-button></div></div></div><div \nclass=\"content\"><div ng-show=\"showExport\" class=\"nl-Block nl-Block--bordered nl-Block--theme1\" \nstyle=\"margin-bottom: 20px !important\"><form ng-submit=\"exportForm.$valid && launchExport()\" novalidate \nname=\"exportForm\"><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" class=\"mb-0\"><label \ntranslate=\"COMPANIES.EXPORT.PRESELECTION_LOADING\"></label><md-select ng-model=\"_exportParams\" name=\"preselection\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"exportChanged()\"><md-option ng-value=\"null\"></md-option><md-option\n ng-repeat=\"export in exports | orderBy: \'name\' track by export.id\" ng-value=\"export\">{{export.name}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"100\" class=\"mb-0\"><md-chips \nclass=\"nl-chips nl-chips__floating\" ng-model=\"_exportParams.companyFields\" name=\"companyFields\" \nmd-on-add=\"addField($chip, _exportParams.companyFields)\"><md-autocomplete md-search-text=\"search.company\" \nmd-select-on-match=\"true\" md-autoselect=\"false\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'COMPANIES.EXPORT.COMPANY_FIELDS\' | translate}}\" \nmd-items=\"field in fieldsSelected(companyFields, _exportParams.companyFields) | filter: {libelle: search.company}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"100\"><md-chips \nclass=\"nl-chips nl-chips__floating\" ng-model=\"_exportParams.contactFields\" name=\"contactFields\" \nmd-on-add=\"addField($chip, _exportParams.contactFields)\"><md-autocomplete \nmd-floating-label=\"{{\'COMPANIES.EXPORT.CONTACT_FIELDS\' | translate}}\" md-no-cache=\"true\" \nmd-search-text=\"search.contact\" md-select-on-match=\"true\" md-autoselect=\"false\" md-match-case-insensitive=\"true\" \nmd-no-cache=\"true\" \nmd-items=\"field in fieldsSelected(contactFields, _exportParams.contactFields)| filter: {libelle: search.contact}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"55\" class=\"mb-0\">\n<label translate=\"COMPANIES.EXPORT.OPTIONS\"></label><md-select ng-model=\"_exportParams._option\" name=\"option\">\n<md-option ng-value=\"\'\'\"></md-option><md-option translate=\"COMPANIES.EXPORT.COMPANY_ONLY\" value=\"COMPANY_ONLY\">\n</md-option><md-option translate=\"COMPANIES.EXPORT.MEETING_ROOM_CAPACITY\" value=\"MEETING_ROOM_CAPACITY\"></md-option>\n<md-option translate=\"COMPANIES.EXPORT.MESSAGING\" value=\"MESSAGING\"></md-option></md-select></md-input-container>\n<md-input-container flex=\"25\" class=\"mb-0\"><label translate=\"COMPANIES.EXPORT.ID\"></label><input type=\"text\" \nmaxlength=\"255\" ng-model=\"_exportParams._name\" name=\"name\" autocomplete=\"new-password\"></md-input-container><div \nflex=\"20\" class=\"mt-15\"><md-button type=\"button\" class=\"\" ng-click=\"saveExport()\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon>{{\'GENERAL.SAVE\' | translate}}</md-button><md-button type=\"button\" \nng-disabled=\"_exportParams.id == null\" class=\"md-warn md-hue-2 md-teal-theme-theme\" ng-click=\"openDeleteExport()\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon>{{\'GENERAL.DELETE\' | translate}}</md-button></div><md-input-container \nflex=\"100\"><label translate=\"COMPANIES.EXPORT.SECURITY\"></label><input type=\"password\" \nng-model=\"_exportParams.password\" name=\"password\" autocomplete=\"new-password\"></md-input-container><div \nclass=\"nl-loader\" ng-if=\"exportInProgress\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div \nclass=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div>\n</div><div flex=\"100\" layout=\"row\"><md-button type=\"submit\" class=\"md-primary md-hue-2 submit-button md-raised mt-0\" \nng-disabled=\"exportInProgress\" flex layout-align=\"center center\"><md-icon md-font-icon=\"icon-export\"></md-icon>\n{{\'COMPANIES.EXPORT.TITLE\' | translate}}</md-button></div></div></form></div><research-engine-filter \nmodel-type=\"COMPANY_MODEL\" sub-type-id=\"subTypeId\" on-filter=\"filterCompanies(filter)\"></research-engine-filter><div \nlayout=\"row\" layout-wrap><div ng-if=\"companies.length > 0\" layout=\"row\" layout-align=\"start center\" flex=\"30\" \nflex-xs=\"100\"><span layout=\"row\" layout-align=\"start center\" flex style=\"color:#757575;font-size: 11px\"><b \nclass=\"mr-5\" style=\"font-size: 20px\">{{companies[0].nbrResults}}</b> {{\'COMPANIES.NUMBER_RESULTS\' | translate}} <b \nclass=\"ml-10 mr-5\" style=\"font-size: 20px\">{{companies[0].nbContacts}}</b> {{\'COMPANIES.NUMBER_CONTACTS\' | translate}}\n</span></div><div flex=\"30\"><md-input-container class=\"nl-Input-container ml-15\" flex=\"15\"><md-select \nng-model=\"pagination.start\" ng-change=\"getCompanies();\"><md-option \nng-repeat=\"x in [].constructor(maxNumberPage) track by $index\" ng-value=\"$index\">{{$index+1}}</md-option></md-select>\n</md-input-container></div><div flex=\"40\" flex-xs=\"100\"><research-engine-sort model-type=\"COMPANY_MODEL\" \nsub-type-id=\"subTypeId\" on-sort=\"sortCompanies(sort)\"></research-engine-sort></div></div><div class=\"nl-loader\" \nng-show=\"loadingStatsRepartition\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div\n class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div><div \nclass=\"nl-Block\" ng-show=\"showFieldsStats\" layout=\"row\" ng-if=\"fieldsStats.length > 0\"><div class=\"nl-Table-fake\"><div \nclass=\"nl-Table-header\" layout=\"row\" layout-align=\"start start\"><div class=\"nl-Table-header-item\" flex><b>\n{{\"STATISTICS.REPARTITION.VALUE\" | translate}}</b></div><div class=\"nl-Table-header-item\" flex><b>\n{{\"STATISTICS.REPARTITION.NUMBER\" | translate}}</b></div><div class=\"nl-Table-header-item\" flex><b>\n{{\"STATISTICS.REPARTITION.VALUE\" | translate}}</b></div><div class=\"nl-Table-header-item\" flex><b>\n{{\"STATISTICS.REPARTITION.NUMBER\" | translate}}</b></div></div><div class=\"nl-Table-body\" layout=\"row\" layout-wrap \nlayout-align=\"start stretch\"><div class=\"nl-Table-body-tr\" flex=\"50\" ng-repeat=\"field in fieldsStats\"><div \nclass=\"nl-Table-body-item nl-Table-body-item--title\" flex>{{field.field}}</div><div class=\"nl-Table-body-item-value\" \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"stat in field.stats | orderBy: \'number\': true\"><div \nclass=\"nl-Table-body-value nl-Table-body-item--value--title\" flex><b>{{stat.valueStat}}</b></div><div \nclass=\"nl-Table-body-value nl-Table-body-item--value--title\" flex>{{stat.number}}</div></div></div></div></div></div>\n<div class=\"nl-Block nl-Block--table\"><div layout=\"row\"><table class=\"dataTable row-border hover nl-Table--responsive\">\n<thead><th translate=\"COMPANIES.NAME\"></th><th></th><th></th><th></th><th translate=\"COMPANIES.SUBTYPES\"></th><th></th>\n</thead><tbody><tr style=\"cursor: pointer\" ng-repeat=\"company in companies | orderBy: order: reverse\"><td \nstyle=\"padding-top:5px; padding-bottom:5px;vertical-align: text-top\"><div class=\"nl-Block--table--company\"><a \nui-sref-opts=\"{reload:true}\" ui-sref=\"app.companies.details({\'id\': company.id})\" \nstyle=\"text-decoration: none; color: black\">{{ company.modelPattern }}</a> <span ng-if=\"!company.activate\" \nstyle=\"background-color: #f44336; color: white;border-radius: 1px;font-size: 10px;font-weight: 500;padding: 2px 4px\" \ntranslate=\"GENERAL.INACTIVE\"></span> <span ng-if=\"!company.checked\" \nstyle=\"background-color: #03a9f4; color: white;border-radius: 1px;font-size: 10px;font-weight: 500;padding: 2px 4px\" \ntranslate=\"GENERAL.NOT_CHECKED\"></span></div><div ng-repeat=\"contact in company.contacts\" style=\"min-height: 19px\">\n<md-icon md-font-icon=\"icon-account\" ng-style=\"{{ !contact.activate ? {\'color\': \'#f44336\'} : {} }}\" class=\"s14\">\n</md-icon><span class=\"nl-Block--table--newcontact\" ui-sref-opts=\"{reload:true}\" ng-click=\"$event.stopPropagation()\"><a\n ui-sref=\"app.companies.details.contact({\'id\': company.id, \'contactId\': contact.id })\" \nstyle=\"text-decoration: none; color: black\">{{contact.modelPattern}}</a></span></div></td><td \nstyle=\"padding-top:5px; padding-bottom:5px;vertical-align: text-top\" \nng-repeat=\"column in company.columns track by $index\" ng-click=\"$event.stopPropagation()\"><div \nclass=\"nl-Block--table--company\" \nng-bind-html=\"trustAsHtml(filterModel(company, column.columnIndex) == \'\' || filterModel(company, column.columnIndex) == null ? \'&nbsp;\' : filterModel(company, column.columnIndex))\">\n</div><div ng-repeat=\"contact in company.contacts\" style=\"min-height: 19px\"><div class=\"nl-Block--table--newcontact\" \nng-bind-html=\"trustAsHtml(filterModel(contact, column.columnIndex) == \'\' || filterModel(contact, column.columnIndex) == null ? \'&nbsp;\' : filterModel(contact, column.columnIndex))\">\n</div></div></td><td style=\"padding-top:5px; padding-bottom:5px;vertical-align: text-top\"><span \nng-repeat=\"subType in company.subTypesNames\">{{subType + ($last ? \'\' : \' / \')}}</span></td><td \nstyle=\"max-height:49px;width:80px\"><img class=\"nl-Msg-profile-img\" ng-if=\"company.profilePictureLocation != null\" \nhttp-src=\"./alternatedocroots/{{company.profilePictureLocation}}\" has-profile-picture=\"true\" \nstyle=\"max-height:49px;max-width:80px\"></td></tr></tbody></table></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div \nclass=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div \nclass=\"right\"><div class=\"half-circle\"></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/globe_network/companies/company.html","<div class=\"page-layout simple fullwidth nl-Has--Responsive--FixedBar\" md-theme=\"teal-theme\"><md-progress-linear \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" mode=\"indeterminate\" \nng-if=\"_mdProgressLinear\"></md-progress-linear><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\" hide-gt-sm><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\">{{company.modelPattern}}</div></div></div>\n<div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" \nng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div layout=\"column\" \nlayout-align=\"start start\"><md-button type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"openAddAssociation()\"><md-icon\n md-font-icon=\"icon-plus\"></md-icon>{{\'ASSOCIATIONS.NEW\' | translate}}</md-button></div></div></div><div \nclass=\"content content-sm nl-Form-xs\" layout=\"row\" layout-align=\"start stretch\" layout-wrap><div flex=\"20\" \nflex-sm=\"100\" flex-xs=\"100\" class=\"nl-Panel\"><div layout=\"column\" layout-wrap><div flex=\"100\" layout=\"column\"><div \nclass=\"nl-Block nl-Block--contact nl-Block--customers nl-selected\" layout=\"row\" layout-align=\"center top\" layout-wrap>\n<div flex=\"100\" layout=\"row\" layout-align=\"start center\" class=\"nl-Panel-mainTitle\"><div flex=\"80\" class=\"pl-15\">\n{{company.modelPattern}}</div><md-input-container flex=\"20\" class=\"nl-Form-SwitchContainer\"><md-switch \nclass=\"md-primary m-0\" ng-model=\"company.activate\" ng-change=\"setActivated(company.id, company.activate)\"></md-switch>\n</md-input-container></div><div layout=\"row\" flex=\"100\" layout-wrap><div class=\"nl-Panel-infos\" flex=\"60\" \nflex-sm=\"100\" flex-xs=\"100\" flex-order-sm=\"2\" flex-order-xs=\"2\"><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"field in company.valuedFields | orderBy: \'index\'\" \nng-if=\"(field.index != null && field.value)\n				|| (field.index != null && field.values != null && field.values.length > 0)\">\n<div class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s14\"></md-icon></div>\n<div class=\"nl-Panel-infos-text\" ng-if=\"field.index != null && field.value && field.typeChamps == \'URL\'\"><a \nhref=\"http://{{field.value}}\" target=\"_blank\">{{field.value}}</a></div><div class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps == \'EMAIL\'\"><a href=\"mailto:{{field.value}}\">\n{{field.value}}</a></div><div class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps != \'URL\' && field.typeChamps != \'EMAIL\'\n									&& field.typeChamps != \'BOOLEAN\' && field.typeChamps != \'DATE\' && field.typeChamps != \'LIST_SELECT\'\n									&& field.typeChamps != \'MULTIPLE_SELECT\'\" \nng-style=\"{\'font-weight\': $index == 0 ? \'bold\' : \'normal\' }\">{{field.value}}</div><div class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.values && field.values.length > 0\"><span \nng-repeat=\"value in field.values  | orderBy: \'libelle\'\">{{ $last ? value.libelle : value.libelle + \' | \' }}</span>\n</div></div></div><div class=\"nl-Msg-profile--wrapper\" flex=\"40\" flex-sm=\"100\" flex-xs=\"100\" flex-order-sm=\"1\" \nflex-order-xs=\"1\"><div class=\"nl-Msg-profile\"><img class=\"nl-Msg-profile-img--cover\" \nhttp-src=\"./alternatedocroots/{{company.profilePictureLocation}}\" has-profile-picture=\"true\"></div></div></div></div>\n<div class=\"nl-Block nl-Block--contact nl-Block--customers\" \nng-repeat=\"contact in contacts | filter : {deleted: false} track by contact.id\" layout=\"row\" layout-align=\"center top\" \nlayout-wrap ng-click=\"detailsContact(contact.id)\"><div flex=\"100\" layout=\"row\" layout-align=\"start center\" \nclass=\"nl-Panel-mainTitle\"><div flex=\"80\" class=\"pl-15\"><md-icon ng-if=\"company.favouriteId === contact.id\" \nmd-font-icon=\"icon-star\"></md-icon>{{contact.modelPattern}} <span ng-if=\"contact.deleted\">\n({{\'CONTACTS.DELETED\'|translate}})</span></div><md-input-container flex=\"20\" class=\"nl-Form-SwitchContainer\"><md-switch\n class=\"md-primary m-0\" ng-model=\"contact.activate\" ng-change=\"setContactActivated(contact.id, contact.activate)\">\n</md-switch></md-input-container></div><div layout=\"row\" flex=\"100\" layout-wrap><div class=\"nl-Panel-infos\" flex=\"60\" \nflex-sm=\"100\" flex-xs=\"100\" flex-order-sm=\"2\" flex-order-xs=\"2\" \nng-if=\"contact.valuedFields != null && contact.valuedFields.length > 0\"><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"field in contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\"><div \nclass=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s14\"></md-icon></div><div \nclass=\"nl-Panel-infos-text\" ng-if=\"field.index != null && field.value && field.typeChamps == \'URL\'\"><a \nhref=\"http://{{field.value}}\" target=\"_blank\" ng-click=\"$event.stopPropagation();\">{{field.value}}</a></div><div \nclass=\"nl-Panel-infos-text\" ng-if=\"field.index != null && field.value && field.typeChamps == \'EMAIL\'\"><a \nhref=\"mailto:{{field.value}}\" target=\"_blank\" ng-click=\"$event.stopPropagation();\">{{field.value}}</a></div><div \nclass=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps != \'URL\' && field.typeChamps != \'EMAIL\'\n									&& field.typeChamps != \'BOOLEAN\' && field.typeChamps != \'DATE\' && field.typeChamps != \'LIST_SELECT\'\n									&& field.typeChamps != \'MULTIPLE_SELECT\'\" \nng-style=\"{\'font-weight\': $index == 0 ? \'bold\' : \'normal\' }\">{{field.value}}</div></div></div><div \nclass=\"nl-Msg-profile--wrapper\" flex=\"40\" flex-sm=\"100\" flex-xs=\"100\" flex-order-sm=\"1\" flex-order-xs=\"1\"><div \nclass=\"nl-Msg-profile\" ng-if=\"contact.profilePictureLocation != null\"><img class=\"nl-Msg-profile-img--cover\" \nhttp-src=\"./alternatedocroots/{{contact.profilePictureLocation}}\" has-profile-picture=\"true\"></div></div></div></div>\n</div></div><div layout=\"row\" layout-align=\"center center\" permissions=\"[\'COMPANY_LEFT_CHECK_MY_PROFILE\']\"><md-button \ntype=\"button\" class=\"md-primary\" ng-click=\"checkMyProfileOnline()\"><md-icon md-font-icon=\"icon-check-circle\"></md-icon>\n{{\'COMPANIES.CHECK_MY_PROFILE_ONLINE_BTN\' | translate}}</md-button></div><div layout=\"row\" \nlayout-align=\"center center\" permissions=\"[\'COMPANY_LEFT_ADD_CONTACT\']\"><md-button type=\"button\" class=\"md-primary\" \nng-click=\"openAddContact()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'CONTACTS.ADD\' | translate}}</md-button>\n</div><div layout=\"row\" layout-align=\"center center\" permissions=\"[\'COMPANY_LEFT_SHOW_INACTIVE_CONTACTS\']\"><md-button \nng-hide=\"hiddenContact\" type=\"button\" class=\"md-primary\" ng-click=\"showMoreContacts()\"><md-icon \nmd-font-icon=\"icon-eye\"></md-icon>{{\'CONTACTS.SHOW\' | translate}}</md-button><md-button ng-if=\"hiddenContact\" \ntype=\"button\" class=\"md-primary\" ng-click=\"hideMoreContacts()\"><md-icon md-font-icon=\"icon-eye-off\"></md-icon>\n{{\'CONTACTS.HIDE\' | translate}}</md-button></div><div layout=\"row\" layout-align=\"center center\" \npermissions=\"[\'COMPANY_LEFT_COMPANY_DUPLICATION_TOOL\']\"><md-button type=\"button\" class=\"md-primary\" \nng-click=\"_lookForThisCompanyDuplicates()\" style=\"white-space: normal!important;line-height: 36px!important\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon>{{\'DUPLICATION_TOOL.COMPANY_TITLE\' | translate}}</md-button></div><div \nlayout=\"row\" layout-align=\"center center\" permissions=\"[\'COMPANY_LEFT_CONTACT_DUPLICATION_TOOL\']\"><md-button \ntype=\"button\" class=\"md-primary\" ng-click=\"_lookForContactDuplicates()\" \nstyle=\"white-space: normal!important;line-height: 36px!important\"><md-icon md-font-icon=\"icon-content-duplicate\">\n</md-icon>{{\'DUPLICATION_TOOL.CONTACT_TITLE\' | translate}}</md-button></div><div layout=\"row\" \nlayout-align=\"center center\" permissions=\"[\'COMPANY_LEFT_DUPLICATES_AUTO_MERGE\']\"><md-button type=\"button\" \nclass=\"md-primary\" ng-click=\"_contactDuplicatesAutoMergeFn()\" \nstyle=\"white-space: normal!important;line-height: 36px!important\"><md-icon md-font-icon=\"icon-flash-auto\"></md-icon>\n{{\'DUPLICATION_TOOL.CONTACT_AUTO_MERGE_TITLE\' | translate}}</md-button></div><div layout=\"row\" \nlayout-align=\"center center\" permissions=\"[\'COMPANY_LEFT_LOGS\']\"><md-button type=\"button\" class=\"md-primary\" \nng-click=\"showLogs()\"><md-icon md-font-icon=\"icon-timelapse\"></md-icon>{{\'COMPANIES.LOGS\' | translate}}</md-button>\n</div></div><div flex=\"80\" flex-sm=\"100\" flex-xs=\"100\" ng-if=\"!logsShowed && !statsClicksShowed\"><div class=\"nl-Block\">\n<div layout=\"row\" class=\"\"><form name=\"updateFolderForm\" novalidate=\"\" flex=\"100\"><noo-infos-model \nng-model=\"categories\" edition=\"true\" form-name=\"updateFolderForm\" sub-type=\"subTypeId\" sub-types=\"subTypes\" \nmodel-type=\"modelType\" model=\"company\" show-settings=\"showSettings\"></noo-infos-model></form></div><div class=\"\"><div \nclass=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\"><div>\n{{\"COMPANIES.DISPOSITION.TITLE_CAT\" | translate }}</div><md-button md-no-ink class=\"nl_button--header m-0\" \ntranslate=\"COMPANIES.DISPOSITION.ADD\" ng-click=\"openDispositionDialogFn();\"></md-button></div><div layout=\"row\" \nclass=\"nl-Table--wrapper\"><table class=\"dataTable row-border hover nl-Tablegit nl-Table--center\"><thead><tr><th \nclass=\"secondary-text\">{{\"COMPANIES.DISPOSITION.NAME\" | translate }}</th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.SQUARE_METTER\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"COMPANIES.DISPOSITION.SQUARE_FEET\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.L_W_H\"></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.DAY_LIGHT\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" \naria-label=\"square meter\"><md-tooltip>{{\"COMPANIES.DISPOSITION.THEATER\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/theatre.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.CLASS_ROOM\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/classroom.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.BOARD_ROOM\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/boardroom.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.U_STYLE\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/ustyle.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.BANQUET\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/banquet.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.COCKTAIL\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/cocktail.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.CONFERENCE\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/conference.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.CABARET\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/cabaret.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.AUDITORIUM\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/auditorium.svg\"></md-icon></md-button></div></th></tr></thead><tbody><tr \nng-repeat=\"_disposition in company.dispositions track by $index\" ng-click=\"openDispositionDialogFn(_disposition);\"><td>\n{{ _disposition.name }}</td><td>{{ _disposition.squareMeter }}</td><td>{{ _disposition.squareFeet }}</td><td>\n{{ _disposition.length ? _disposition.length : \"xx\" }}/{{ _disposition.width ? _disposition.width : \"xx\" }}/{{ _disposition.height ? _disposition.height : \"xx\" }}\n</td><td>{{ !_disposition.dayLight ? \'COMPANIES.NO\' : \'COMPANIES.YES\' | translate }}</td><td>{{ _disposition.theatre }}\n</td><td>{{ _disposition.classRoom }}</td><td>{{ _disposition.boardRoom }}</td><td>{{ _disposition.uStyle }}</td><td>\n{{ _disposition.banquet }}</td><td>{{ _disposition.cocktail }}</td><td>{{ _disposition.conference }}</td><td>\n{{ _disposition.cabaret }}</td><td>{{ _disposition.auditorium }}</td></tr></tbody></table></div></div></div><div \nclass=\"nl-Block\" ng-if=\"inscriptions != null && inscriptions.length > 0\"><div class=\"nl_categories-item-title\" \nlayout=\"row\" layout-align=\"space-between center\"><div>{{\"INSCRIPTION.TITLE\" | translate}}</div><button type=\"button\" \nclass=\"ml-10\" ng-click=\"hideInscription = !hideInscription\"><md-icon md-font-icon=\"icon-eye\" ng-if=\"!hideInscription\">\n</md-icon><md-icon md-font-icon=\"icon-eye-off\" ng-if=\"hideInscription\"></md-icon></button></div><div layout=\"column\" \nng-show=\"hideInscription\" ng-repeat=\"inscription in inscriptions | orderBy: \'creation\': true\"><div \nclass=\"nl_categories-item-subtitle\" layout=\"row\"><div flex=\"20\" style=\"font-weight: 600\">\n{{inscription.contact.modelPattern}}</div><div flex=\"20\">{{inscription.event.name}}</div><div flex=\"10\" \nng-if=\"inscription.inscriptionStatus != null\"><span ng-style=\"setStatusStyle(inscription.inscriptionStatus)\">\n{{inscription.inscriptionStatus.name}}</span></div><div flex=\"10\" ng-if=\"inscription.logisticStatus != null\"><span \nng-style=\"setStatusStyle(inscription.inscriptionStatus)\">{{inscription.logisticStatus}}</span></div><div flex=\"20\">\n{{\'GENERAL.DATE_TIME_FORMAT\' | translate: {date: inscription.creation} }}</div><div flex layout=\"row\" \nlayout-align=\"end center\"><div>\n{{(inscription.throughAdmin ? \'INSCRIPTION_ADMIN.THROUGH_ADMIN\' : \'INSCRIPTION_ADMIN.THROUGH_FORM\') | translate}}</div>\n</div></div></div></div><div class=\"nl-Block\" \nng-if=\"userService.isUserAdmin() || userService.isUserLinkedToAssociations()\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n{{\"MESSAGE.TITLE_BLOC\" | translate}}</div><md-button md-no-ink class=\"nl_button--header m-0\" \nng-click=\"showPopUpMessage()\" translate=\"MESSAGE.CREATION.NEW\"></md-button></div><div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>{{\"MESSAGE.BOX.TITLE\" | translate}}</label><md-select \nng-model=\"filter.sender\" aria-label=\"language\" name=\"receiver\" ng-change=\"findAllMessages()\"><md-option \nng-value=\"false\">{{\"MESSAGE.BOX.RECEPTION\" | translate}}</md-option><md-option ng-value=\"true\">\n{{\"MESSAGE.BOX.SENT\" | translate}}</md-option><md-option ng-value=\"null\">{{\"MESSAGE.BOX.ALL\" | translate}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\n{{\"MESSAGE.TYPE.TITLE\" | translate}}</label><md-select ng-model=\"filter.action\" aria-label=\"language\" name=\"receiver\" \nng-change=\"findAllMessages()\"><md-option ng-value=\"null\">{{\"MESSAGE.TYPE.ALL\" | translate}}</md-option><md-option \nng-value=\"typeAction.TO_DO\">{{\"MESSAGE.TYPE.TO_DO\" | translate}}</md-option><md-option ng-value=\"typeAction.DONE\">\n{{\"MESSAGE.TYPE.DONE\" | translate}}</md-option><md-option ng-value=\"typeAction.ALL\">\n{{\"MESSAGE.TYPE.ALL_ACTION\" | translate}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>{{\"MESSAGE.CORRESPONDANT\" | translate}}</label><md-select md-on-open=\"\" \nmd-on-close=\"filterSelectText = \'\'\" ng-model=\"filter.receiverForm\" aria-label=\"language\" name=\"receiver\" \nmultiple=\"multiple\" ng-change=\"findAllMessages()\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"user in users | filterText: filterSelectText\" value=\"{{user}}\">{{user.fullName}}</md-option></md-select>\n</md-input-container></div><div class=\"nl-form--receivedMsg mt-15\"><table \nclass=\"simple list-view nl-Table nl-Table--makeResponsive nl-Table--msg\"><thead><th>\n{{\"MESSAGE.DISPLAY.MESSAGE\" | translate}}</th><th>{{\"MESSAGE.DISPLAY.LINK\" | translate}}</th><th>\n{{\"MESSAGE.DISPLAY.SENDER\" | translate}}</th><th>{{\"MESSAGE.DISPLAY.ACTIONS\" | translate}}</th></thead><tbody><tr \nng-repeat=\"message in messages\" class=\"nl-Msg\"><td><div class=\"nl-form--receivedMsg--subject\">{{message.subject}}</div>\n<div class=\"nl-form--receivedMsg--content\" ng-bind-html=\"message.content | limitTo: 70\"></div><div \nng-if=\"message.action\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-check\" \nng-class=\"{\'nl-validated\': message.action.actionDone}\" ng-click=\"confirmAction(message.action)\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div><div>\nDeadline : {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div></div></div></td><td><div class=\"nl-Msg-link-company\">{{message.company.modelPattern}}</div><div \nclass=\"nl-Msg-link-contact\">{{message.contact.modelPattern}}</div></td><td><span class=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div ng-if=\"message.sender.pictureLocation\" \nclass=\"nl-Msg-avatar\"><img title=\"{{message.sender.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"message.sender.pictureLocation != null\"></div><span ng-if=\"!message.sender.pictureLocation\" \nclass=\"nl-Badge\">{{message.sender.fullName}}</span> <span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id\"><md-icon class=\"mr-8\" \nmd-font-icon=\"icon-chevron-right\"></md-icon></span><div \nng-if=\"message.receiver.pictureLocation && message.receiver.id!=message.sender.id\" class=\"nl-Msg-avatar\"><img \ntitle=\"{{message.receiver.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.receiver.pictureLocation}}\" \nhas-profile-picture=\"message.receiver.pictureLocation != null\"></div><span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id && !message.receiver.pictureLocation\" \nclass=\"nl-Badge\">{{message.receiver.fullName}}</span></div></td><td><md-button ng-click=\"updateMessage(message)\" \nclass=\"nl-listing-item-button md-accent\" aria-label=\"Update\">{{\"GENERAL.UPDATE\" | translate}}</md-button></td></tr>\n</tbody></table></div></div></div></div><div flex=\"80\" flex-sm=\"100\" flex-xs=\"100\" ng-if=\"logsShowed\"><div \nng-include=\"\'app/main/globe_network/companies/logs/companyLogs.html\'\" ng-controller=\"companyLogsController\"></div>\n</div><div flex=\"80\" flex-sm=\"100\" flex-xs=\"100\" ng-if=\"statsClicksShowed\"><div \nng-include=\"\'app/main/globe_network/companies/statsClicks/statsClicks.html\'\" ng-controller=\"statsClicksController\">\n</div></div></div></div>");
$templateCache.put("app/main/globe_network/inscriptions/inscriptions_admin.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"INSCRIPTION_ADMIN.PLURAL_TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"_mailingDialogOpenFn()\" permissions=\"[\'REGISTRATION_SEND_MAIL\']\"><md-icon \nmd-font-icon=\"icon-bullhorn\"></md-icon><span translate=\"MAILING.DO_MAILING.MAILING_BTN\"></span></md-button><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"showExport = !showExport\" permissions=\"[\'REGISTRATION_EXPORT\']\">\n<md-icon md-font-icon=\"icon-export\"></md-icon><span translate=\"COMPANIES.EXPORT.TITLE\"></span></md-button></div></div>\n<div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" \nng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div layout=\"column\" \nlayout-align=\"start start\"><md-button type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"_mailingDialogOpenFn()\">\n<md-icon md-font-icon=\"icon-bullhorn\"></md-icon><span translate=\"MAILING.DO_MAILING.MAILING_BTN\"></span></md-button>\n<md-button type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"showExport = !showExport\"><md-icon \nmd-font-icon=\"icon-export\"></md-icon><span translate=\"COMPANIES.EXPORT.TITLE\"></span></md-button><md-button \ntype=\"button\" class=\"md-accent md-hue-1\" ng-click=\"_goToInscriptionsAdminSettings();\"><md-icon md-font-icon=\"icon-cog\">\n</md-icon><span translate=\"INSCRIPTION_ADMIN.SETTINGS.SETTINGS_ACCESS_BUTTON_TITLE\"></span></md-button></div></div>\n</div><div class=\"content\"><div ng-show=\"showExport\" class=\"nl-Block nl-Block--bordered nl-Block--theme1\" \nstyle=\"margin-bottom: 20px !important\"><form ng-submit=\"exportForm.$valid && launchExport()\" novalidate \nname=\"exportForm\"><div layout=\"row\" layout-wrap><md-input-container flex=\"100\" class=\"mb-0\"><label \ntranslate=\"COMPANIES.EXPORT.PRESELECTION_LOADING\"></label><md-select ng-model=\"_exportParams\" name=\"preselection\" \nng-change=\"exportChanged()\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-value=\"null\"></md-option><md-option\n ng-repeat=\"export in exports | orderBy: \'name\' track by export.id\" ng-value=\"export\">{{export.name}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"100\" class=\"mb-0\"><md-chips \nclass=\"nl-chips nl-chips__floating\" ng-model=\"_exportParams.inscriptionFields\" name=\"inscriptionFields\" \nmd-on-add=\"addField($chip, _exportParams.inscriptionFields)\"><md-autocomplete md-select-on-match=\"true\" \nmd-autoselect=\"false\" md-match-case-insensitive=\"true\" \nmd-floating-label=\"{{\'COMPANIES.EXPORT.INSCRIPTION_FIELDS\' | translate}}\" md-no-cache=\"true\" \nmd-search-text=\"search.inscription\" \nmd-items=\"field in fieldsSelected(inscriptionFields, _exportParams.inscriptionFields) | filter: {libelle: search.inscription}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"100\" class=\"mb-0\">\n<md-chips class=\"nl-chips nl-chips__floating\" ng-model=\"_exportParams.logisticFields\" name=\"logisticFields\" \nmd-on-add=\"addField($chip, _exportParams.logisticFields)\"><md-autocomplete md-select-on-match=\"true\" \nmd-autoselect=\"false\" md-match-case-insensitive=\"true\" \nmd-floating-label=\"{{\'COMPANIES.EXPORT.LOGISTIC_FIELDS\' | translate}}\" md-no-cache=\"true\" \nmd-search-text=\"search.logistic\" \nmd-items=\"field in fieldsSelected(logisticFields, _exportParams.logisticFields) | filter: {libelle: search.logistic}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"100\" class=\"mb-0\">\n<md-chips class=\"nl-chips nl-chips__floating\" ng-model=\"_exportParams.transportFields\" name=\"transportFields\" \nmd-on-add=\"addTransportField($chip, _exportParams.transportFields, _exportParams.transportFields)\"><md-autocomplete \nmd-select-on-match=\"true\" md-autoselect=\"false\" md-match-case-insensitive=\"true\" \nmd-floating-label=\"{{\'COMPANIES.EXPORT.TRANSPORT_FIELDS\' | translate}}\" md-no-cache=\"true\" \nmd-search-text=\"search.transport\" \nmd-items=\"field in fieldsSelected(transportFields, _exportParams.transportFields, true) | orderBy: \'translateKey | translate\' | filterTranslate: search.transport\" \nmd-item-text=\"field.key\" md-min-length=\"0\"><span>{{field.translateKey | translate}}</span></md-autocomplete>\n<md-chip-template><span>{{$chip.translateKey | translate}}</span></md-chip-template></md-chips></md-input-container>\n<md-input-container flex=\"100\" class=\"mb-0\"><md-chips class=\"nl-chips nl-chips__floating\" \nng-model=\"_exportParams.companyFields\" name=\"companyFields\" md-on-add=\"addField($chip, _exportParams.companyFields)\">\n<md-autocomplete md-select-on-match=\"true\" md-autoselect=\"false\" md-match-case-insensitive=\"true\" \nmd-floating-label=\"{{\'COMPANIES.EXPORT.COMPANY_FIELDS\' | translate}}\" md-search-text=\"search.company\" \nmd-no-cache=\"true\" \nmd-items=\"field in fieldsSelected(companyFields, _exportParams.companyFields) | filter: {libelle: search.company}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"100\"><md-chips \nclass=\"nl-chips nl-chips__floating\" ng-model=\"_exportParams.contactFields\" name=\"contactFields\" \nmd-on-add=\"addField($chip, _exportParams.contactFields)\"><md-autocomplete md-select-on-match=\"true\" \nmd-autoselect=\"false\" md-match-case-insensitive=\"true\" \nmd-floating-label=\"{{\'COMPANIES.EXPORT.CONTACT_FIELDS\' | translate}}\" md-search-text=\"search.contact\" \nmd-no-cache=\"true\" \nmd-items=\"field in fieldsSelected(contactFields, _exportParams.contactFields) | filter: {libelle: search.contact}\" \nmd-item-text=\"field.libelle\" md-min-length=\"0\"><span>{{field.libelle}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.libelle}}</span></md-chip-template></md-chips></md-input-container><md-input-container flex=\"55\"><label \ntranslate=\"COMPANIES.EXPORT.OPTIONS\"></label><md-select ng-model=\"_exportParams._option\" name=\"option\"><md-option \nng-value=\"\'\'\"></md-option><md-option translate=\"COMPANIES.EXPORT.TRANSPORT_ONLY\" value=\"TRANSPORT_ONLY\"></md-option>\n<md-option translate=\"COMPANIES.EXPORT.DEPARTURE_AND_ARRIVAL\" value=\"DEPARTURE_AND_ARRIVAL\"></md-option></md-select>\n</md-input-container><md-input-container flex=\"25\"><label translate=\"COMPANIES.EXPORT.ID\"></label><input type=\"text\" \nmaxlength=\"255\" ng-model=\"_exportParams._name\" name=\"name\" autocomplete=\"new-password\"></md-input-container><div \nflex=\"20\" class=\"mt-15\"><md-button type=\"button\" class=\"\" ng-click=\"saveExport()\"><md-icon \nmd-font-icon=\"icon-content-save\"></md-icon>{{\'GENERAL.SAVE\' | translate}}</md-button><md-button type=\"button\" \nng-disabled=\"_exportParams.id == null\" class=\"md-warn md-hue-2 md-teal-theme-theme\" ng-click=\"openDeleteExport()\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon>{{\'GENERAL.DELETE\' | translate}}</md-button></div><md-input-container \nflex=\"100\" class=\"mt-0\"><label translate=\"COMPANIES.EXPORT.SECURITY\"></label><input type=\"password\" \nng-model=\"_exportParams.password\" name=\"password\" autocomplete=\"new-password\"></md-input-container><div \nclass=\"nl-loader\" ng-if=\"exportInProgress\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div \nclass=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div>\n</div><div flex=\"100\" layout=\"row\"><md-button type=\"submit\" class=\"md-primary md-hue-2 submit-button md-raised mt-0\" \nflex layout-align=\"center center\"><md-icon md-font-icon=\"icon-export\"></md-icon>\n{{\'COMPANIES.EXPORT.TITLE\' | translate}}</md-button></div></div></form></div><research-engine-filter \nmodel-type=\"INSCRIPTION_MODEL\" sub-type-id=\"subTypeId\" on-filter=\"_filterInscritpionFn(filter)\">\n</research-engine-filter><div layout=\"row\"><div ng-if=\"_inscriptions.length > 0\" layout=\"row\" \nlayout-align=\"start center\" flex=\"50\" style=\"color:#757575;font-size: 11px\"><b class=\"mr-5\" style=\"font-size: 20px\">\n{{_inscriptions[0].nbrResults}}</b> {{\'COMPANIES.NUMBER_REGISTRATIONS\' | translate}}</div><div flex>\n<research-engine-sort model-type=\"INSCRIPTION_MODEL\" sub-type-id=\"subTypeId\" on-sort=\"_sortInscriptionFn(sort)\">\n</research-engine-sort></div></div><div class=\"nl-Block nl-Block--table\"><div layout=\"row\"><table \nclass=\"dataTable row-border hover nl-Table nl-Table--makeResponsive nl-Table--registration\"><thead><th \ntranslate=\"REGISTRATIONS_TABLE.EVENT\" style=\"max-height:49px;width:80px\"></th><th \ntranslate=\"REGISTRATIONS_TABLE.COMPANY\"></th><th translate=\"REGISTRATIONS_TABLE.CONTACT\"></th><th \ntranslate=\"REGISTRATIONS_TABLE.TYPE\"></th><th translate=\"REGISTRATIONS_TABLE.STATUS\"></th><th \ntranslate=\"REGISTRATIONS_TABLE.LOGISTIC\"></th><th></th></thead><tbody><tr \nng-repeat=\"_inscription in _inscriptions | orderBy: \'infos.creation\': true\"><td style=\"max-height:49px;width:80px\"><img\n class=\"nl-Msg-profile-img\" ng-if=\"_inscription.infos.event.logo != null\" \nhttp-src=\"./alternatedocroots/{{_inscription.infos.event.logo}}\" has-profile-picture=\"true\" \nstyle=\"max-height:49px;max-width:80px\"></td><td style=\"padding-top:5px; padding-bottom:5px;vertical-align: text-top\">\n<div><a ui-sref-opts=\"{reload:true}\" \nui-sref=\"app.companies.details({\'subType\': _inscription.company.subTypesIds[0], \'id\': _inscription.company.id})\" \nstyle=\"text-decoration: none; color: black;font-weight:bold\">{{_inscription.company.modelPattern}}</a></div><div \nng-repeat=\"field in _inscription.company.valuedFields | orderBy: \'index\'\" \nng-if=\"(field.index != null && field.value) || (field.index != null && field.values != null && field.values.length > 0)\">\n<md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s16\" ng-if=\"field.icon\"></md-icon><span \nclass=\"nl-Block--table--newcontact\"><span class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps == \'URL\'\"><a href=\"http://{{field.value}}\" \ntarget=\"_blank\">{{field.value}} </a></span><span class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps == \'EMAIL\'\"><a href=\"mailto:{{field.value}}\">\n{{field.value}} </a></span><span class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps != \'URL\' && field.typeChamps != \'EMAIL\'\">{{field.value}}\n</span> <span class=\"nl-Panel-infos-text\" ng-if=\"field.index != null && field.values && field.values.length > 0\"><span \nng-repeat=\"value in field.values  | orderBy: \'libelle\'\"><a href=\"\" ng-if=\"value\"></a>\n {{ $last ? value.libelle : value.libelle + \' | \' }}</span></span></span></div></td><td \nstyle=\"padding-top:5px; padding-bottom:5px;vertical-align: text-top\"><div style=\"font-weight:bold\"><a \nui-sref=\"app.companies.details.contact({\'subType\': _inscription.company.subTypesIds[0],\'id\': _inscription.company.id, \'contactId\': _inscription.contact.id })\" \nstyle=\"text-decoration: none; color: black\">{{_inscription.contact.modelPattern}}</a></div><div \nng-repeat=\"field in _inscription.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\">\n<md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s16\" ng-if=\"field.icon\"></md-icon><span \nclass=\"nl-Panel-infos-text\" ng-if=\"field.index != null && field.value && field.typeChamps == \'URL\'\"><a \nhref=\"http://{{field.value}}\" target=\"_blank\">{{field.value}} </a></span><span class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps == \'EMAIL\'\"><a href=\"mailto:{{field.value}}\">\n{{field.value}} </a></span><span class=\"nl-Block--table--newcontact\" \nng-if=\"field.index != null && field.value && field.typeChamps != \'URL\' && field.typeChamps != \'EMAIL\'\">{{field.value}}\n</span></div></td><td>{{_inscription.infos.subCategory.name}}</td><td style=\"padding-top:5px; padding-bottom:5px\"><span\n style=\"color: white;border-radius: 1px;font-size: 10px;font-weight: 500;padding: 2px 4px\" \nng-style=\"{\'background-color\':_inscription.infos.inscriptionStatus.color ? _inscription.infos.inscriptionStatus.color : \'grey\'}\" \nng-if=\"_inscription.infos.inscriptionStatus\">{{_inscription.infos.inscriptionStatus.name}}</span></td><td \nstyle=\"padding-top:5px; padding-bottom:5px\"><span \nstyle=\"color: white;border-radius: 1px;font-size: 10px;font-weight: 500;padding: 2px 4px\" \nng-style=\"{\'background-color\':_inscription.logistic.status.color ? _inscription.logistic.status.color : \'grey\'}\" \nng-if=\"_inscription.logistic.status\">{{_inscription.logistic.status.name}}</span></td><td \nng-click=\"$event.stopPropagation()\" style=\"text-align:center!important\"><div>\n{{ _inscription.infos.creation | date:\"dd/MM/yyyy - HH:mm\" }}</div><div><a ui-sref-opts=\"{reload:true}\" \nui-sref=\"app.companies.details.contact({\n                                            \'subType\': _inscription.company.subTypesIds[0],\n                                            \'id\': _inscription.company.id,\n                                            \'contactId\': _inscription.contact.id,\n                                            \'inscriptionId\': _inscription.infos.id\n                                        })\" \nclass=\"md-accent md-hue-2 md-button md-teal-theme-theme\">{{\'REGISTRATIONS_TABLE.CONTACT\' | translate}}</a> <a \nng-if=\"_inscription.logistic\" ui-sref-opts=\"{reload:true}\" \nui-sref=\"app.companies.details.contact.logistic({\n                                            \'subType\': _inscription.company.subTypesIds[0],\n                                            \'id\': _inscription.company.id,\n                                            \'contactId\': _inscription.contact.id,\n                                            \'logisticId\': _inscription.logistic.id\n                                        })\" \nclass=\"md-accent md-hue-2 md-button md-teal-theme-theme\">{{\'REGISTRATIONS_TABLE.LOGISTIC\' | translate}}</a></div></td>\n</tr></tbody></table></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div></div><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\"><md-button \nng-disabled=\"allLoaded || !loaded\" type=\"button\" class=\"md-accent\" ng-click=\"_findInscriptionsFn()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>{{\'COMPANIES.LOAD_MORE\' | translate}}</md-button></div></div></div>");
$templateCache.put("app/main/globe_network/mailing/mailing_modal.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Look For Duplicates\" flex=\"40\" md-theme=\"teal-theme\" \nstyle=\"max-width: 65%!important;min-width: 50%!important;max-height: 80%!important\"><form name=\"mailingForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">\n{{\'MAILING.DO_MAILING.MAILING_MODAL_TITLE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\" ng-disabled=\"inProgress\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"!initDataInProgress\" \nstyle=\"min-height: 60%!important\"><fieldset class=\"standard mt-20 mb-20\"><legend>\n{{\"MAILING.DO_MAILING.FIELD_TO_LINK_FOR_EMAIL_ADDRESS_LEGEND\" | translate}}</legend><md-input-container class=\"\">\n<md-select name=\"_fieldForEmailAdr\" ng-model=\"dto.fieldLinkDestAdrEmail\" \nplaceholder=\"{{\'MAILING.DO_MAILING.FIELD_TO_LINK_FOR_EMAIL_ADDRESS_PLACEHOLDER\' | translate}}\" required \nmd-on-close=\"_searchFieldForEmailAdr = \'\'\" multiple=\"multiple\"><md-select-header><section><input force-select-focus \ntype=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchFieldForEmailAdr\"></section>\n</md-select-header><md-option ng-if=\"(emailFields|filter : { modelType : \'COMPANY_MODEL\' }).length==0\" \nng-repeat=\"field in emailFields | filter : { modelType : \'CONTACT_MODEL\' } | filter : _searchFieldForEmailAdr | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option><md-optgroup label=\"\" \nng-if=\"(emailFields|filter : { modelType : \'COMPANY_MODEL\' }).length>0\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\"></label><md-option \nng-repeat=\"field in emailFields | filter : { modelType : \'CONTACT_MODEL\' } | filter : _searchFieldForEmailAdr | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option></md-optgroup><md-optgroup label=\"\" \nng-if=\"(emailFields|filter : { modelType : \'COMPANY_MODEL\' }).length>0\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></label><md-option \nng-repeat=\"field in emailFields | filter : { modelType : \'COMPANY_MODEL\' } | filter : _searchFieldForEmailAdr | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option></md-optgroup></md-select><div class=\"\" \nng-messages=\"mailingForm.form._fieldForEmailAdr.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></fieldset><md-input-container class=\"\">\n<md-select name=\"page\" ng-model=\"dto.page\" \nplaceholder=\"{{\'MAILING.DO_MAILING.SELECT_TEMPLATE_PLACEHOLDER\' | translate}}\" md-on-close=\"_searchPage = \'\'\" required>\n<md-select-header><section><input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"_searchPage\"></section></md-select-header><md-option \nng-repeat=\"page in pages | filter : _searchPage | orderBy : \'name\' track by page.id\" ng-value=\"page\">{{page.name}}\n</md-option></md-select><label>{{\'MAILING.DO_MAILING.SELECT_TEMPLATE_LABEL\' | translate}}</label><div class=\"\" \nng-messages=\"mailingForm.form.page.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"dto.page\"><md-select name=\"language\" ng-model=\"dto.page.language\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS.SELECT_LANGUAGE_PLACEHOLDER\' | translate}}\" ng-change=\"_changeLanguageFn();\" \nrequired ng-model-options=\"{trackBy: \'$value.key\'}\"><md-option ng-repeat=\"lang in languages | orderBy : \'libelle\'\" \nng-value=\"lang\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select><label>\n{{\'MAILING.DO_MAILING.SELECT_LANGUAGE_LABEL\' | translate}}</label><div class=\"\" \nng-messages=\"mailingForm.form.language.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></md-dialog-content><md-dialog-content \nng-if=\"initDataInProgress || inProgress\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\"><md-progress-circular \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" md-mode=\"indeterminate\">\n</md-progress-circular></div></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button \ntype=\"submit\" ng-click=\"doAMailing(mailingForm)\" class=\"md-primary md-hue-2 submit-button md-raised\" \nng-disabled=\"mailingForm.$invalid || mailingForm.$pristine || initDataInProgress || inProgress\" aria-label=\"Submit\">\n{{\'MAILING.DO_MAILING.SEND_BTN\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/home/popup/actionsToDo.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\"ACTION_TO_DO\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap ng-repeat=\"message in actionsToDo\" class=\"nl-Call-item\">\n<div flex=\"100\" class=\"nl-Call-item-title-wrapper\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"nl-Call-item-title\">{{message.subject}}</div><div class=\"nl-Call-item-tag\" \nng-class=\"{\'nl-Call-item-tag--meeting\': message.action.libelle === \'Meeting\', \'nl-Call-item-tag--call\': message.action.libelle === \'Call\'}\">\n{{message.action.libelle}}</div></div><div flex=\"50\" class=\"nl-Call-item-column\"><div \nclass=\"mt-5 nl-form--receivedMsg--content\">{{message.content | limitTo: 70}}</div><div class=\"nl-Call-item-deadline\">\n{{\"MESSAGE.LIMIT\" | translate}}: {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div><div class=\"nl-Call-item-deadline\" ng-if=\"message.receiver != null\">\n{{\"MESSAGE.RECEIVER\" | translate}}: {{message.receiver.fullName}}</div></div><div flex=\"50\" \nclass=\"nl-Call-item-separator nl-Call-item-column\"><div class=\"ml-15\" ng-if=\"message.company != null\"><div \nclass=\"nl-Call-item-type\" translate=\"GENERAL.COMPANY\" style=\"font-weight: 500\"></div><a class=\"nl-Call-item-status\" \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\">{{message.company.modelPattern}}</a></div>\n<div class=\"ml-15\" ng-if=\"message.contact != null\"><div class=\"nl-Call-item-type\" translate=\"GENERAL.CONTACT\" \nstyle=\"font-weight: 500\"></div><a class=\"nl-Call-item-status\" \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n{{message.contact.modelPattern}}</a></div><div class=\"ml-15\" \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Call-item-infos\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div><div class=\"ml-15\" \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Call-item-infos\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></div></div></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button ng-click=\"hidePopup()\" class=\"md-primary md-raised md-hue-2\" \naria-label=\"Sauvegarder\">{{\"GENERAL.OK\" | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/home/popup/lateActions.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\"ACTION_NOT_DONE\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap ng-repeat=\"message in actionsNotDone\" \nclass=\"nl-Call-item\"><div flex=\"100\" class=\"nl-Call-item-title-wrapper\" layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"nl-Call-item-title\">{{message.subject}}</div><div \nclass=\"nl-Call-item-tag\" \nng-class=\"{\'nl-Call-item-tag--meeting\': message.action.libelle === \'Meeting\', \'nl-Call-item-tag--call\': message.action.libelle === \'Call\'}\">\n{{message.action.libelle}}</div></div><div flex=\"50\" class=\"nl-Call-item-column\"><div \nclass=\"mt-5 nl-form--receivedMsg--content\">{{message.content | limitTo: 70}}</div><div class=\"nl-Call-item-deadline\">\n{{\"MESSAGE.LIMIT\" | translate}}: {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div><div class=\"nl-Call-item-deadline\" ng-if=\"message.receiver != null\">\n{{\"MESSAGE.RECEIVER\" | translate}}: {{message.receiver.fullName}}</div></div><div flex=\"50\" \nclass=\"nl-Call-item-separator nl-Call-item-column\"><div ng-if=\"message.company != null\"><div class=\"nl-Call-item-type\" \ntranslate=\"GENERAL.COMPANY\"></div><a class=\"nl-Call-item-status\" \nhref=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\">{{message.company.modelPattern}}</a></div>\n<div ng-if=\"message.contact != null\"><div class=\"nl-Call-item-type\" translate=\"GENERAL.CONTACT\"></div><a \nclass=\"nl-Call-item-status\" \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n{{message.contact.modelPattern}}</a></div><div ng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" \nng-if=\"field.index != null && field.value\" class=\"nl-Call-item-infos\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon \nmd-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s22\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Call-item-infos\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></div></div></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button ng-click=\"hidePopup()\" class=\"md-primary md-raised md-hue-2\" \naria-label=\"Sauvegarder\">{{\"GENERAL.OK\" | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/home/popup/senderActionsDone.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\"ACTION_DONE\" | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"row\" layout-wrap ng-repeat=\"message in senderActionsDone\" class=\"nl-Call-item\"><div \nflex=\"100\" class=\"nl-Call-item-title-wrapper\" layout=\"row\" layout-align=\"space-between start\"><div \nclass=\"nl-Call-item-title\">{{message.subject}}</div><div class=\"nl-Call-item-tag\" \nng-class=\"{\'nl-Call-item-tag--meeting\': message.action.libelle === \'Meeting\', \'nl-Call-item-tag--call\': message.action.libelle === \'Call\'}\">\n{{message.action.libelle}}</div></div><div flex=\"50\" class=\"nl-Call-item-column\"><div \nclass=\"mt-5 nl-form--receivedMsg--content\">{{message.content | limitTo: 70}}</div><div class=\"nl-Call-item-deadline\">\n{{\"MESSAGE.LIMIT\" | translate}}: {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div><div class=\"nl-Call-item-deadline\">{{\"MESSAGE.RECEIVER\" | translate}}: {{message.receiver.fullName}}</div></div>\n<div flex=\"50\" class=\"nl-Call-item-separator nl-Call-item-column\"><div class=\"ml-15\" ng-if=\"message.company != null\">\n<div class=\"nl-Call-item-type\" translate=\"GENERAL.COMPANY\" style=\"font-weight: 500\"></div><a \nclass=\"nl-Call-item-status\" href=\"/companies/{{message.company.subTypesIds[0]}}/{{message.company.id}}\">\n{{message.company.modelPattern}}</a></div><div class=\"ml-15\" ng-if=\"message.contact != null\"><div \nclass=\"nl-Call-item-type\" translate=\"GENERAL.CONTACT\" style=\"font-weight: 500\"></div><a class=\"nl-Call-item-status\" \nhref=\"/companies/{{message.contact.companySubTypesIds[0]}}/{{message.contact.companyId}}/contact/{{message.contact.id}}\">\n{{message.contact.modelPattern}}</a></div><div class=\"ml-15\" \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Call-item-infos\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div><div class=\"ml-15\" \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Call-item-infos\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s22\"></md-icon></span>{{field.value}}</div></div></div></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button ng-click=\"hidePopup()\" class=\"md-primary md-raised md-hue-2\" \naria-label=\"Sauvegarder\">{{\"GENERAL.OK\" | translate}}</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/mailing/blocs/blocs.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"MAILING.BLOCS.TITLES\"></div></div>\n<md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide \nshow-gt-sm><md-button type=\"button\" class=\"\" ng-click=\"_blocDetailsFn()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'MAILING.BLOCS.ADD\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div\n class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"\" ng-click=\"_blocDetailsFn()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>{{\'MAILING.BLOCS.ADD\' | translate}}</md-button></div></div></div><div \nclass=\"content\"><div layout=\"row\" layout-wrap hide-gt-sm><md-input-container flex=\"50\"><input type=\"text\" \nng-model=\"search.name\" placeholder=\"{{\'MAILING.BLOCS.FIELDS_SEARCH.NAME\' | translate}}\"></md-input-container>\n<md-input-container flex=\"50\"><input type=\"text\" ng-model=\"search.type\" \nplaceholder=\"{{\'MAILING.BLOCS.FIELDS_SEARCH.TYPE\' | translate}}\"></md-input-container></div><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"dataTable row-border hover\"><thead><tr><th><div class=\"nl-responsive-table--text\">\n{{\'MAILING.BLOCS.FIELDS.NAME\' | translate}}</div><div><input type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'MAILING.BLOCS.FIELDS_SEARCH.NAME\' | translate}}\"></div></th><th><div class=\"nl-responsive-table--text\">\n{{\'MAILING.BLOCS.FIELDS.TYPE\' | translate}}</div><div><input type=\"text\" ng-model=\"search.type\" \nplaceholder=\"{{\'MAILING.BLOCS.FIELDS_SEARCH.TYPE\' | translate}}\"></div></th></tr></thead><tbody><tr \nng-repeat=\"_bloc in blocs | filter:search | orderBy : \'name\' as arrayData track by $index\" \nng-click=\"_blocDetailsFn(_bloc.id);\"><td>{{ _bloc.name }}</td><td>{{ _bloc.type }}</td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/mailing/expeditors/expeditors.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"MAILING.TRIGGERS.TITLES\"></div>\n</div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide \nshow-gt-sm><md-button type=\"button\" class=\"\" ng-click=\"showPopUpAddExpeditor()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon>{{\'MAILING.EXPEDITORS.ADD\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" \nclass=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div \nclass=\"nl-FixedRightBar-panel\"><div layout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"\" \nng-click=\"showPopUpAddExpeditor()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'MAILING.EXPEDITORS.ADD\' | translate}}\n</md-button></div></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th><div>{{\'MAILING.EXPEDITORS.NAME\' | translate}}</div></th><th><div>\n{{\'MAILING.EXPEDITORS.MAIL\' | translate}}</div></th><th></th></tr></thead><tbody><tr \nng-repeat=\"expeditor in expeditors\" ng-click=\"showPopUpAddExpeditor(expeditor)\"><td>{{expeditor.name}}</td><td>\n{{expeditor.mail}}</td><td><md-button ng-click=\"showPopUpDelete(expeditor); $event.stopPropagation();\" md-no-ink \nclass=\"md-raised md-warn md-hue-2\" aria-label=\"Delete\">{{\'GENERAL.DELETE\' | translate}}</md-button></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/mailing/history/history.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"MAILING.HISTORY.TITLE\"></div>\n</div></div><div class=\"content\"><md-input-container class=\"md-block\" flex-gt-sm><label>\n{{\'MAILING.HISTORY.TYPE\'| translate}}</label><md-select ng-model=\"filter.types\" aria-label=\"types\" name=\"types\" \nng-change=\"getHistory(true)\" multiple=\"multiple\"><md-option ng-repeat=\"type in MAILING_HISTORY_TYPES\" ng-value=\"type\">\n{{\'MAILING.HISTORY.TYPES.\' + type | translate}}</md-option></md-select></md-input-container><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"dataTable row-border hover\"><thead><tr><th><div>{{\'MAILING.HISTORY.COLUMNS.DATE\' | translate}}</div></th><th>\n<div>{{\'MAILING.HISTORY.COLUMNS.RECEIVER\' | translate}}</div></th><th><div>\n{{\'MAILING.HISTORY.COLUMNS.SUBJECT\' | translate}}</div></th><th><div>{{\'MAILING.HISTORY.COLUMNS.EMAIL\' | translate}}\n</div></th><th><div>{{\'MAILING.HISTORY.COLUMNS.MANUAL_TRIGGER\' | translate}}</div></th><th><div>\n{{\'MAILING.HISTORY.COLUMNS.CONTACT_COMPANY\' | translate}}</div></th></tr></thead><tbody><tr \nng-repeat=\"hist in history track by hist.id\"><td>{{hist.date | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{hist.receiver}}</td>\n<td>{{hist.subject}}</td><td>{{hist.mailingPage.name}}</td><td>\n{{hist.type != \'COMPANY_VIEW\' && hist.type != \'CONTACT_VIEW\' && hist.type != \'INSCRIPTION_VIEW\' ? (\"MAILING.HISTORY.TYPES.\"+hist.type | translate) : \'-\'}}\n</td><td><div ng-if=\"hist.company\"><div><a ui-sref-opts=\"{reload:true}\" \nui-sref=\"app.companies.details({\'subType\': hist.company.subTypesIds[0], \'id\': hist.company.id})\" \nstyle=\"text-decoration: none; color: black;font-weight:bold\">{{hist.company.modelPattern}}</a></div><div \nng-repeat=\"field in hist.company.valuedFields | orderBy: \'index\'\" \nng-if=\"(field.index != null && field.value) || (field.index != null && field.values != null && field.values.length > 0)\">\n<md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s16\" ng-if=\"field.icon\"></md-icon><span \nclass=\"nl-Block--table--newcontact\"><span class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps == \'URL\'\"><a href=\"http://{{field.value}}\" \ntarget=\"_blank\">{{field.value}} </a></span><span class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps == \'EMAIL\'\"><a href=\"mailto:{{field.value}}\">\n{{field.value}} </a></span><span class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps != \'URL\' && field.typeChamps != \'EMAIL\'\">{{field.value}}\n</span> <span class=\"nl-Panel-infos-text\" ng-if=\"field.index != null && field.values && field.values.length > 0\"><span \nng-repeat=\"value in field.values  | orderBy: \'libelle\'\"><a href=\"\" ng-if=\"value\"></a>\n {{ $last ? value.libelle : value.libelle + \' | \' }}</span></span></span></div></div><div ng-if=\"hist.contact\"><div \nstyle=\"font-weight:bold\"><a \nui-sref=\"app.companies.details.contact({\'subType\': hist.contact.company.subTypesIds[0],\'id\': hist.contact.company.id, \'contactId\': hist.contact.id })\" \nstyle=\"text-decoration: none; color: black\">{{hist.contact.modelPattern}}</a></div><div \nng-repeat=\"field in hist.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\"><md-icon \nmd-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s16\" ng-if=\"field.icon\"></md-icon><span class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps == \'URL\'\"><a href=\"http://{{field.value}}\" \ntarget=\"_blank\">{{field.value}} </a></span><span class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps == \'EMAIL\'\"><a href=\"mailto:{{field.value}}\">\n{{field.value}} </a></span><span class=\"nl-Block--table--newcontact\" \nng-if=\"field.index != null && field.value && field.typeChamps != \'URL\' && field.typeChamps != \'EMAIL\'\">{{field.value}}\n</span></div></div></td></tr></tbody></table></div></div><md-button ng-disabled=\"allLoaded\" type=\"button\" \nclass=\"md-accent\" ng-click=\"getHistory(false)\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'MAILING.HISTORY.LOAD_MORE\' | translate}}</md-button></div></div>");
$templateCache.put("app/main/mailing/pages/pages.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"MAILING.PAGES.TITLES\"></div></div>\n<md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide \nshow-gt-sm><md-button type=\"button\" class=\"\" ng-click=\"_pageDetailsFn()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'MAILING.PAGES.ADD\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div\n class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"\" ng-click=\"_pageDetailsFn()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon>{{\'MAILING.PAGES.ADD\' | translate}}</md-button></div></div></div><div \nclass=\"content\"><div layout=\"row\" layout-wrap hide-gt-sm><md-input-container flex=\"33\"><input type=\"text\" \nng-model=\"search.name\" placeholder=\"{{\'MAILING.PAGES.FIELDS_SEARCH.NAME\' | translate}}\"></md-input-container>\n<md-input-container flex=\"33\"><input type=\"text\" ng-model=\"search.tags.name\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS_SEARCH.TAGS\' | translate}}\"></md-input-container><md-input-container flex=\"33\">\n<input type=\"text\" ng-model=\"search.pageBlocs.bloc.name\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS_SEARCH.BLOCS\' | translate}}\"></md-input-container></div><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"dataTable row-border hover\"><thead><tr><th><div class=\"nl-responsive-table--text\">\n{{\'MAILING.PAGES.FIELDS.NAME\' | translate}}</div><div><input type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS_SEARCH.NAME\' | translate}}\"></div></th><th><div class=\"nl-responsive-table--text\">\n{{\'MAILING.PAGES.FIELDS.TAGS\' | translate}}</div><div><input type=\"text\" ng-model=\"search.tags.name\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS_SEARCH.TAGS\' | translate}}\"></div></th><th><div class=\"nl-responsive-table--text\">\n{{\'MAILING.PAGES.FIELDS.BLOCS\' | translate}}</div><div><input type=\"text\" ng-model=\"search.pageBlocs.bloc.name\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS_SEARCH.BLOCS\' | translate}}\"></div></th><th>Actions</th></tr></thead><tbody><tr \nng-repeat=\"_page in pages | filter:search  | orderBy: \'name\' as arrayData track by $index\"><td>{{ _page.name }}</td>\n<td><span ng-repeat=\"tag in _page.tags | orderBy:\'name\'\" \nstyle=\"color: white;border-radius: 1px;font-size: 10px;font-weight: 500;padding: 2px 4px\" \nng-style=\"{\'background-color\':tag.color ? tag.color : \'grey\'}\" class=\"mr-5\">{{tag.name}}</span></td><td><span \nng-repeat=\"_pageBloc in _page.pageBlocs | orderBy: \'bloc.name\' track by $index\" class=\"mr-5 md-grey-300-bg p-5\">\n{{ _pageBloc.bloc.name }}</span></td><td><md-button type=\"button\" class=\"\" ng-click=\"previewMail(_page.id,_page.key)\">\n<md-icon md-font-icon=\"icon-responsive\"></md-icon>{{\'MAILING.ACTIONS.PREVIEW\' | translate}}</md-button><md-button \ntype=\"button\" class=\"\" ng-click=\"_pageDetailsFn(_page.id);\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n{{\'MAILING.ACTIONS.EDIT\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"showDuplicate(_page);\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon>{{\'MAILING.ACTIONS.DUPLICATE\' | translate}}</md-button></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/mailing/tags/tags.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"MAILING.TAGS.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-input-container flex><md-select\n ng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><div class=\"nl-Block mt-20\"><form name=\"newTagForm\" role=\"form\" novalidate \nng-submit=\"newTagForm.$valid && add(newTagForm)\"><div layout=\"column\"><h3 translate=\"MAILING.TAGS.TITLE\"></h3><div \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><md-input-container flex-xs=\"50\" flex=\"40\" class=\"\"><label\n translate=\"MAILING.TAGS.NAME\"></label><input type=\"text\" maxlength=\"255\" required ng-model=\"newTag.name\" required \nname=\"name\"><div ng-messages=\"newTagForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>Obligatoire.</span>\n</div></div></md-input-container><md-input-container flex-xs=\"50\" flex=\"40\" class=\"\"><label \ntranslate=\"MAILING.TAGS.COLOR\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"newTag.color\" name=\"color\">\n</md-input-container><div flex-xs=\"100\" flex=\"20\"><md-button type=\"submit\" class=\"md-raised md-primary md-hue-2\">\n<md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div>\n</form><div ng-repeat=\"tag in tags | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\" layout-wrap><div layout=\"row\" flex flex-xs=\"100\"><div layout=\"row\" flex \nng-if=\"!tag.editionMode\"><h3 class=\"\" flex=\"50\">{{tag.name}}</h3><h3 class=\"ml-30\" flex>\n{{\'MAILING.TAGS.COLOR\' | translate }} : {{tag.color}}</h3></div><div layout=\"row\" ng-if=\"tag.editionMode\" flex>\n<md-input-container><label translate=\"MAILING.TAGS.NAME\"></label><input type=\"text\" maxlength=\"255\" required \nng-model=\"tagToEdit.name\" name=\"name\"><div ng-messages=\"editTagForm.name.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container><md-input-container class=\"\"><label \ntranslate=\"MAILING.TAGS.COLOR\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"tagToEdit.color\" name=\"color\">\n</md-input-container></div></div><div class=\"panel-actions panel-actions-keep\" layout=\"row\" flex-xs=\"100\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button ng-if=\"!tag.editionMode\" type=\"button\" \nclass=\"md-fab md-mini md-hue-2\" ng-click=\"edit(tag);\"><md-icon md-font-icon=\"icon-pencil\" class=\"s18\"></md-icon>\n</md-button><div class=\"ml-15\" layout=\"row\" layout-align=\"space-between center\" ng-if=\"tag.editionMode\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"update(tag);\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-hue-2\" ng-click=\"cancel(tag);\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</md-button></div><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"remove(tag.id);\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(tag.index > 0)\" ng-click=\"up(tag.id);\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon>\n</md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"tag.index === tags.length - 1 || tags.length <= 1\" ng-click=\"down(tag.id);\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div></div></div>\n</div>");
$templateCache.put("app/main/mailing/triggers/triggers.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"MAILING.TRIGGERS.TITLES\"></div>\n</div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide \nshow-gt-sm><md-button type=\"button\" class=\"\" ng-click=\"_triggerDetailsFn()\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon>{{\'MAILING.TRIGGERS.ADD\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" \nclass=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div \nclass=\"nl-FixedRightBar-panel\"><div layout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"\" \nng-click=\"_triggerDetailsFn()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'MAILING.TRIGGERS.ADD\' | translate}}\n</md-button></div></div></div><div class=\"content\"><div layout=\"row\" layout-wrap hide-gt-sm><md-input-container \nflex=\"33\"><input type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.NAME\' | translate}}\"></md-input-container><md-input-container flex=\"33\">\n<input type=\"text\" ng-model=\"search.type\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.TYPE\' | translate}}\">\n</md-input-container><md-input-container flex=\"33\"><input type=\"text\" ng-model=\"search.modelType\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.MODEL_TYPE\' | translate}}\"></md-input-container><md-input-container \nflex=\"50\"><input type=\"text\" ng-model=\"search.field.libelle\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.FIELD\' | translate}}\"></md-input-container><md-input-container \nflex=\"50\"><input type=\"text\" ng-model=\"search.fieldValue.value\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.FIELD_VALUE\' | translate}}\"></md-input-container><md-input-container \nflex=\"50\"><input type=\"text\" ng-model=\"search.event.name\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.EVENT\' | translate}}\"></md-input-container><md-input-container \nflex=\"50\"><input type=\"text\" ng-model=\"search.registrationForm.name\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.REGISTRATION_FORM\' | translate}}\"></md-input-container></div><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"dataTable row-border hover\"><thead><tr><th><div class=\"nl-responsive-table--text\">\n{{\'MAILING.TRIGGERS.FIELDS.NAME\' | translate}}</div><div><input type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.NAME\' | translate}}\"></div></th><th><div \nclass=\"nl-responsive-table--text\">{{\'MAILING.TRIGGERS.FIELDS.TYPE\' | translate}}</div><div><input type=\"text\" \nng-model=\"search.type\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.TYPE\' | translate}}\"></div></th><th><div \nclass=\"nl-responsive-table--text\">{{\'MAILING.TRIGGERS.FIELDS.MODEL_TYPE\' | translate}}</div><div><input type=\"text\" \nng-model=\"search.modelType\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.MODEL_TYPE\' | translate}}\"></div></th><th>\n<div class=\"nl-responsive-table--text\">{{\'MAILING.TRIGGERS.FIELDS.FIELD\' | translate}}</div><div><input type=\"text\" \nng-model=\"search.field.libelle\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.FIELD\' | translate}}\"></div></th><th>\n<div class=\"nl-responsive-table--text\">{{\'MAILING.TRIGGERS.FIELDS.FIELD_VALUE\' | translate}}</div><div><input \ntype=\"text\" ng-model=\"search.fieldValue.value\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.FIELD_VALUE\' | translate}}\"></div></th><th><div \nclass=\"nl-responsive-table--text\">{{\'MAILING.TRIGGERS.FIELDS.EVENT\' | translate}}</div><div><input type=\"text\" \nng-model=\"search.event.name\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.EVENT\' | translate}}\"></div></th><th><div \nclass=\"nl-responsive-table--text\">{{\'MAILING.TRIGGERS.FIELDS.REGISTRATION_FORM\' | translate}}</div><div><input \ntype=\"text\" ng-model=\"search.registrationForm.name\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS_SEARCH.REGISTRATION_FORM\' | translate}}\"></div></th></tr></thead><tbody><tr \nng-repeat=\"_trigger in triggers | filter:search  | orderBy: \'name\' as arrayData track by $index\" \nng-click=\"_triggerDetailsFn(_trigger.id);\"><td>{{_trigger.name}}</td><td>\n{{\'MAILING.TRIGGERS.TYPES.\'+_trigger.type | translate}}</td><td>{{_trigger.modelType}}</td><td><span \nng-if=\"_trigger.subType === \'FIELD_MODEL\'\">{{_trigger.field.libelle}}</span> <span \nng-if=\"_trigger.subType === \'FIXE_FIELD_LOGISTIC_STATUS\'\">\n{{ \'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_LOGISTIC_STATUS\' | translate }}</span> <span \nng-if=\"_trigger.subType === \'FIXE_FIELD_REGISTRATION_STATUS\'\">\n{{ \'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_REGISTRATION_STATUS\' | translate }} </span><span \nng-if=\"_trigger.subType === \'FIXE_FIELD_REGISTRATION_SUBCATEGORY\'\">\n{{ \'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIXE_FIELD_REGISTRATION_SUBCATEGORY\' | translate }}</span></td><td><span \nng-if=\"_trigger.subType === \'FIELD_MODEL\'\">{{_trigger.fieldValue.value}}</span> <span \nng-if=\"_trigger.subType === \'FIXE_FIELD_LOGISTIC_STATUS\'\">{{_trigger.logisticStatus.name}}</span> <span \nng-if=\"_trigger.subType === \'FIXE_FIELD_REGISTRATION_STATUS\'\">{{_trigger.registrationStatus.name}}</span> <span \nng-if=\"_trigger.subType === \'FIXE_FIELD_REGISTRATION_SUBCATEGORY\'\">{{_trigger.registrationSubCategory.name}}</span>\n</td><td>{{_trigger.event.name}}</td><td>{{_trigger.registrationForm.name}}</td></tr></tbody></table></div></div></div>\n</div>");
$templateCache.put("app/main/mailing_preview/app/mailing_preview.html","<div class=\"nl_EmailPreview\"><div class=\"nl_EmailPreview-btn-wrapper\"><div layout=\"row\" layout-align=\"center center\">\n<md-button type=\"button\" class=\"nl_EmailPreview-btn\" ng-class=\"{\'nl_EmailPreview__active\': localWidth == 360}\" \nng-click=\"previewResponsiveFn(360, 640)\"><md-icon md-font-icon=\"icon-cellphone-android\"></md-icon></md-button>\n<md-button type=\"button\" class=\"nl_EmailPreview-btn\" ng-class=\"{\'nl_EmailPreview__active\': localWidth == 768}\" \nng-click=\"previewResponsiveFn(768, 1024)\"><md-icon md-font-icon=\"icon-tablet-android\"></md-icon></md-button><md-button \ntype=\"button\" class=\"nl_EmailPreview-btn\" ng-class=\"{\'nl_EmailPreview__active\': localWidth == 1440}\" \nng-click=\"previewResponsiveFn(1440, 900)\"><md-icon md-font-icon=\"icon-monitor\"></md-icon></md-button></div></div><div \nclass=\"nl_EmailPreview-content\"><div class=\"frame_container nl_EmailPreview-wrapper\"><iframe \nid=\"preview_frame_container\" width=\"{{localWidth}}\" height=\"{{localHeight}}\" frameborder=\"0\"></iframe></div></div>\n</div>");
$templateCache.put("app/main/media/popup/document_popup.html","<md-dialog class=\"nl_Dialog document-dialog\" aria-label=\"Document\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"documentForm\" class=\"md-inline-form\" novalidate ng-submit=\"documentForm.$valid && saveDocument()\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'FOLDERS.UPLOAD_FILE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-input-container class=\"nl-Input-container\" flex=\"100\" \nng-class=\"{\'md-input-invalid\': error.file}\"><label class=\"nl-Input-label md-no-float md-container-ignore\">\n{{\"FOLDERS.FILE\" | translate}}</label><input type=\"file\" name=\"file\" required id=\"document_input_file\" placeholder=\"\">\n<div ng-messages=\"error\" role=\"alert\"><div ng-message=\"file\"><span>{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</div></md-input-container></md-dialog-content><md-dialog-actions class=\"pr-25\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 md-raised\" aria-label=\"Ajouter\">{{\"GENERAL.SAVE\" | translate}}</md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/message/popup/update_message.html","<md-dialog class=\"nl_Dialog\" aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\"GENERAL.UPDATE\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Popup-content-body\"><form name=\"formCreateMessage\" novalidate>\n<md-input-container><label translate=\"MESSAGE.CREATION.RECEIVER\"></label><md-select \nmd-on-close=\"filterSelectText = \'\'\" name=\"receiver\" ng-model=\"message.receiverForm\" aria-label=\"language\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option value=\"null\">\n{{\"MESSAGE.CREATION.ALL_USERS\" | translate}}</md-option><md-optgroup label=\"{{\'MESSAGE.CREATION.USERS\' | translate}}\">\n<md-option ng-repeat=\"user in users | orderBy: \'fullName\' | filterText: filterSelectText\" value=\"{{user}}\">\n{{user.fullName}}</md-option></md-optgroup></md-select></md-input-container><div \nclass=\"nl_categories-item-subtitle mb-15\">{{\"MESSAGE.CREATION.ACTION_REQUEST\" | translate}}</div><div layout=\"column\">\n<md-input-container flex=\"100\" class=\"mb-0\"><label>{{\"MESSAGE.CREATION.ACTION\" | translate}}</label><md-select \nng-model=\"message.actionForm\" name=\"action\" aria-label=\"language\"><md-option ng-value=\"null\">\n{{\"MESSAGE.CREATION.NO_ACTION\" | translate}}</md-option><md-option ng-repeat=\"action in actions\" value=\"{{action}}\">\n{{action.libelle}}</md-option></md-select></md-input-container><md-input-container ng-if=\"message.actionForm != null\" \nflex=\"100\" class=\"mb-0\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-hide-icons=\"calendar\" \nng-model=\"message.startDateForm\" name=\"actionDate\" md-placeholder=\"{{\'MESSAGE.CREATION.DATE\' | translate}}\" \nmd-open-on-focus ng-required=\"message.actionForm != null\"></md-datepicker><div class=\"pl-20\" \nng-messages=\"formCreateMessage.actionDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"message.actionForm != null\" flex=\"100\" class=\"mb-0\"><label class=\"input-prefix\">\n{{\'MESSAGE.CREATION.HOUR\' | translate}} hh:mm</label><input type=\"text\" class=\"input-value\" name=\"actionTime\" \nng-model=\"message.startTime\" ui-time-mask=\"short\" required><div class=\"pl-20\" \nng-messages=\"formCreateMessage.actionTime.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div><div ng-message=\"time\"><span>\n{{\"GENERAL.FORM.INVALID_FORMAT\" | translate}} (hh:mm)</span></div></div><div ng-if=\"timeNotMatch\" \nclass=\"ng-scope nl_form-error-input\"><span>{{\"FESTIVAL.TIME_ERROR\" | translate}}</span></div></md-input-container>\n<md-input-container ng-if=\"message.actionForm !== null\" class=\"m-0\" flex=\"100\"><md-switch class=\"md-primary\" \nng-model=\"message.actionDone\" aria-label=\"Switch 1\">{{\"MESSAGE.CREATION.DONE\" | translate}}</md-switch>\n</md-input-container></div><div class=\"nl_categories-item-subtitle mb-15\">{{\"MESSAGE.TITLE\" | translate}}</div><div \nlayout=\"column\"><md-input-container class=\"md-block mb-0\" flex-gt-sm><label>{{\"MESSAGE.CREATION.SUBJECT\"|translate}}\n</label><input ng-model=\"message.subject\" name=\"subject\" maxlength=\"255\" required><div class=\"pl-20\" \nng-messages=\"formCreateMessage.subject.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex-gt-sm><label>{{\"MESSAGE.CREATION.CONTENT\"|translate}}</label><textarea rows=\"4\" ng-model=\"message.content\" \nname=\"content\" required></textarea><div class=\"pl-20\" ng-messages=\"formCreateMessage.content.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><md-button \nmd-no-ink class=\"md-raised md-primary\" ng-disabled=\"formCreateMessage.$invalid\" ng-click=\"saveMessage()\">\n{{\"GENERAL.SAVE\" | translate }}</md-button><md-button md-no-ink class=\"md-accent md-hue-2\" aria-label=\"Annuler\" \nng-click=\"cancelFormMessage()\">{{\"GENERAL.CANCEL\" | translate }}</md-button></form></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/missing_infos_tool/missing_infos_tool_modal/missing_infos_tool_modal.html","<md-dialog class=\"admin-user-dialog nl-Modal\" aria-label=\"Look For Duplicates\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"form\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'MISSING_INFOS_TOOL.TITLE\' | translate}}</div>\n</div><md-button class=\"md-icon-button\" ng-click=\"cancelPopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ng-if=\"!loading\">\n<md-input-container class=\"\"><md-select name=\"modelType\" ng-model=\"datas.modelType\" \nplaceholder=\"{{\'COMPANIES.MODEL_TYPE\' | translate}}\" ng-change=\"onModelTypeSelected();\" required><md-option \nng-repeat=\"modelType in MODELS_TYPES\" ng-value=\"modelType\">{{\'GENERAL.\'+modelType | translate}}</md-option></md-select>\n<div class=\"\" ng-messages=\"form.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"datas.modelType\"><md-select name=\"field\" ng-model=\"datas.fieldId\" \nplaceholder=\"{{\'DUPLICATION_TOOL.SELECT_FIELD\' | translate}}\" md-on-close=\"searchField = \'\'\" required>\n<md-select-header><section><input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"searchField\"></section></md-select-header><md-option \nng-if=\"datas.modelType && datas.modelType == \'COMPANY_MODEL\'\" \nng-repeat=\"field in companyFields | filter : searchField | orderBy : \'libelle\' track by field.id\" ng-value=\"field.id\">\n{{field.libelle}}</md-option><md-option ng-if=\"datas.modelType && datas.modelType == \'CONTACT_MODEL\'\" \nng-repeat=\"field in contactFields | filter : searchField | orderBy : \'libelle\' track by field.id\" ng-value=\"field.id\">\n{{field.libelle}}</md-option></md-select><div class=\"\" ng-messages=\"form.field.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n</md-dialog-content><md-dialog-content ng-if=\"loading\"><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"space-around\" class=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\">\n<md-progress-circular class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button type=\"submit\" ng-click=\"lookForMissingInfos(form)\" \nclass=\"md-primary md-hue-2 submit-button md-raised\" ng-disabled=\"form.$invalid || form.$pristine || loading\" \naria-label=\"Submit\">{{\'MISSING_INFOS_TOOL.BTN_SUBMIT_TITLE\' | translate}}</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/notations/popup/comment.popup.html","<md-dialog flex=\"40\" aria-label=\"Comment\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div>\n<div layout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'NOTATIONS.COMMENT_TITLE\' | translate}}\n</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div>{{notationToShow.comment}}\n</div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/packages/add/addPackage.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><span ng-if=\"package.id == null\" translate=\"PACKAGES.ADD.TITLE\"></span> <span ng-if=\"package.id != null\" \ntranslate=\"PACKAGES.UPDATE.TITLE\"></span></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-input-container flex><md-select \nng-change=\"langageChanged()\" ng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\">\n<md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}\n</md-option></md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex><md-select ng-change=\"langageChanged()\" \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div></div><div class=\"content\"><div class=\"nl-Block\"><form name=\"addPackageForm\" \nclass=\"nl-Form-xs\" ng-submit=\"addPackageForm.$valid && add()\"><md-input-container class=\"nl-Input-container\"><label>\n{{\'GENERAL.COMPANY\' | translate}}</label><md-select name=\"company\" ng-model=\"package.companyID\" required>\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectTextCompany.value\"></section></md-select-header><md-option ng-value=\"company.id\" \nng-repeat=\"company in companies | orderBy : \'modelPattern\'\">{{company.modelPattern}}</md-option></md-select><div \nng-messages=\"addPackageForm.company.$error\" role=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container><label>{{\"PACKAGES.COLUMNS.NAME\" | translate}}</label><input \ntype=\"text\" ng-model=\"package.name\" name=\"name\" required><div ng-messages=\"addPackageForm.name.$error\" role=\"alert\">\n<span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container>\n<label>{{\"PACKAGES.COLUMNS.DURATION\" | translate}}</label><input type=\"number\" ng-model=\"package.duration\" \nname=\"duration\" required><div ng-messages=\"addPackageForm.duration.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container class=\"nl-Input-container\">\n<label>{{\"PACKAGES.COLUMNS.REGION\" | translate}}</label><md-select multiple=\"multiple\" ng-model=\"package.regions\" \nng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"region\" name=\"region\" required><md-option \nng-repeat=\"region in regions\" ng-value=\"region\">{{region.value}}</md-option></md-select><div \nng-messages=\"addPackageForm.region.$error\" role=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><br><md-input-container class=\"nl-Input-container\"><label>\n{{\"PACKAGES.COLUMNS.TYPE\" | translate}}</label><md-select multiple=\"multiple\" ng-model=\"package.typesTourisme\" \nng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"tourism\" name=\"tourism\" required><md-option \nng-repeat=\"tourism in tourisms\" ng-value=\"tourism\">{{tourism.value}}</md-option></md-select><div \nng-messages=\"addPackageForm.tourism.$error\" role=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><div class=\"nl_Trix\"><label class=\"nl_Trix-label\">Description</label><ng-quill-editor\n ng-model=\"package.description\"></ng-quill-editor></div><md-input-container \nng-if=\"userService.isUserAdmin() || userService.isUserLinkedToAssociations()\"><md-checkbox name=\"\" class=\"md-primary\" \nng-model=\"package.publish\" aria-label=\"publish\">{{\"FESTIVAL.CREATION.PUBLISH\"|translate}}</md-checkbox>\n</md-input-container><div ng-if=\"updateMode\" class=\"mv-20\"><div layout=\"row\" layout-wrap><div \nclass=\"m-5 nl-Form-dropify\" flex=\"15\" ng-repeat=\"photo in package.documents track by $index\" layout=\"column\" \nlayout-align=\"start end\"><div class=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify has--image\" \nng-src=\"alternatedocroots/{{photo.location}}\"></div><md-button class=\"md-raised md-warn md-hue-2\" \nng-click=\"displayPopUpDeletePhoto(photo, $index)\"><md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon>\n{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div class=\"mv-20\"><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"photos.push({})\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\"PACKAGES.ADD.ADD_PHOTO\" | translate}}</md-button><div layout=\"row\" layout-wrap><div class=\"m-5 nl-Form-dropify\" \nflex=\"nogrow\" ng-repeat=\"photo in photos\" layout=\"column\" layout-align=\"start end\"><dropify-directive \nclass=\"dropify-wrapper has--deleteBtn\" filesave=\"photo.uploadFile\" ng-model=\"photo.model\"><md-button type=\"button\" \nclass=\"md-raised md-warn md-hue-2\" ng-click=\"deletePhoto($index)\"><md-icon md-font-icon=\"icon-close-circle-outline\">\n</md-icon>{{\"PACKAGES.ADD.DELETE_PHOTO\" | translate}}</md-button></div></div></div><md-button type=\"submit\" md-no-ink \nclass=\"md-primary md-raised md-hue-2\" translate=\"GENERAL.SAVE\"></md-button></form></div></div></div>");
$templateCache.put("app/main/packages/popup/deletePhoto.popup.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">\n{{\"PACKAGES.POPUP_DELETE_PHOTO.TITLE\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Popup-content-body\"><div class=\"nl-Popup-content-body-title\">\n{{\"PACKAGES.POPUP_DELETE_PHOTO.MESSAGE\" | translate}}</div><br><img \nng-src=\"alternatedocroots/{{photoToDelete.location}}\"></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button md-no-ink class=\"md-primary md-raised md-hue-2\" ng-click=\"deletePhotoPermanentely()\" \ntranslate=\"GENERAL.YES\"></md-button><md-button class=\"md-warn md-hue-2\" ng-click=\"hidePopup()\" translate=\"GENERAL.NO\">\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/request_for_proposal/details/rfp_details.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"\">{{ \"REQUEST_FOR_PROPOSAL.DETAILS_TITLE\" | translate}}</div>\n</div></div><div class=\"content\"><div class=\"nl-Block nl-Block--table\"><div class=\"nl-panel-header\">\n{{ \"REQUEST_FOR_PROPOSAL.APPLICANT_INFOS\" | translate}}</div><div layout=\"column\" class=\"p-20\"><div flex><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_COMPANY\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{rfp.applicantCompany}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_COMPANY_TYPE\" | translate}} :</div>\n<div class=\"nl-prestataire-search-item-text\">{{rfp.applicantCompanyType}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_WEB_SITE\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{rfp.applicantWebSite}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_CIVILITY\" | translate}}/ {{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_FIRST_NAME\" | translate}}/ {{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_LAST_NAME\" | translate}} :\n</div><div class=\"nl-prestataire-search-item-text\">\n{{rfp.applicantCivility}} {{rfp.applicantFirstName}} {{rfp.applicantLastName}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_FUNCTION\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{rfp.applicantFunction}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_ADDRESS\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{rfp.applicantAddress1}}</div><div class=\"nl-prestataire-search-item-text\" \nng-if=\"rfp.applicantAddress2\">, {{rfp.applicantAddress2}}</div><div class=\"nl-prestataire-search-item-text\" \nng-if=\"rfp.applicantAddress3\">, {{rfp.applicantAddress3}}</div><div class=\"nl-prestataire-search-item-text\" \nng-if=\"rfp.applicantPostCode || rfp.applicantCity || rfp.applicantCountry\">\n, {{rfp.applicantPostCode}} {{rfp.applicantCity}}, {{rfp.applicantCountry}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_DIRECT_PHONE\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{rfp.applicantDirectPhone}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_MOBILE_PHONE\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{rfp.applicantMobilePhone}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_EMAIL\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{rfp.applicantEmail}}</div></div></div></div></div><div class=\"nl-Block nl-Block--table mt-20\"><div \nclass=\"nl-panel-header\">{{ \"REQUEST_FOR_PROPOSAL.DETAILS_TITLE\" | translate}}</div><div layout=\"column\" class=\"p-20\">\n<div class=\"nl-Rpf__set\"><div class=\"layout-row p-15 layout-align-center-center\"><md-button \nng-if=\"rfp.status!=\'FINISH\'\" ng-disabled=\"loading\" type=\"button\" class=\"flex-50 md-primary md-raised\" \nng-click=\"setFinish(rfp)\"><span>{{\'REQUEST_FOR_PROPOSAL.FIELDS.SET_FINISH\' | translate}}</span></md-button><md-button \nng-if=\"rfp.status!=\'IN_PROGRESS\'\" ng-disabled=\"loading\" type=\"button\" \nclass=\"flex-50 md-orange-600-bg md-primary-bg md-raised\" ng-click=\"setInProgress(rfp)\"><span>\n{{\'REQUEST_FOR_PROPOSAL.FIELDS.SET_IN_PROGRESS\' | translate}}</span></md-button></div><div \nclass=\"p-20 nl-Rpf__set__content\" ng-if=\"rfp.status==\'FINISH\'\"><md-input-container><label>\n{{\'REQUEST_FOR_PROPOSAL.FIELDS.COMPANIES_WHO_WON\' | translate}}</label><md-select ng-model=\"rfp.companiesWhoWon\" \nng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\"><md-option \nng-repeat=\"company in companiesToCheck | orderBy: \'pattern\'\" ng-value=\"company\">{{company.pattern}}</md-option>\n</md-select></md-input-container><md-input-container><label>\n{{\'REQUEST_FOR_PROPOSAL.FIELDS.COMPANIES_WHO_LOST\' | translate}}</label><md-select ng-model=\"rfp.companiesWhoLost\" \nng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\"><md-option \nng-repeat=\"company in companiesToCheck | orderBy: \'pattern\'\" ng-value=\"company\">{{company.pattern}}</md-option>\n</md-select></md-input-container><md-button class=\"mh-0 md-raised md-primary\" type=\"button\" ng-click=\"valid()\">\n{{\'REQUEST_FOR_PROPOSAL.FIELDS.VALIDATE\' | translate}}</md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.TARGET_PROVIDER\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n<span ng-repeat=\"company in rfp.companies | orderBy : \'pattern\'\">{{company.pattern + (!$last ? \' | \' : \'\')}}</span>\n</div></div><div ng-if=\"!rfp.cahierDeCharges || (rfp.cahierDeCharges && rfp.cahierDeCharges.type==\'FORM\')\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.EVENT_TITLE\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{rfp.eventTitle}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">{{ \"REQUEST_FOR_PROPOSAL.FIELDS.EVENT_TYPE\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{rfp.eventType}}</div></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"rfp.document\"><a target=\"_self\" href=\"{{rfp.document}}\" style=\"color: rgb(13, 164, 180)!important\" download>\nDocument</a></div><div layout=\"row\" layout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.NUMBER_OF_PARTICIPANTS\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{rfp.numberOfParticipants}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.START_DATE\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{rfp.dateStart}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">{{ \"REQUEST_FOR_PROPOSAL.FIELDS.END_DATE\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{rfp.dateEnd}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">{{ \"REQUEST_FOR_PROPOSAL.FIELDS.DESIRED_ACTIVITIES\" | translate}} :</div><div\n class=\"nl-prestataire-search-item-text\"><span ng-repeat=\"activity in rfp.desiredActivities\">\n{{activity + ($last ? \'\' : \' | \')}}</span></div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">{{ \"REQUEST_FOR_PROPOSAL.FIELDS.ROOM_NUMBER\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{rfp.roomNumber}}</div></div><div layout=\"row\" layout-align=\"start center\">\n<div class=\"nl-prestataire-search-item-strong\">{{ \"REQUEST_FOR_PROPOSAL.FIELDS.ROOM_CAPACITY_MAX\" | translate}} :</div>\n<div class=\"nl-prestataire-search-item-text\">{{rfp.roomCapacityMax}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.CONFIGURATION\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{rfp.desiredConfiguration}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">{{ \"REQUEST_FOR_PROPOSAL.FIELDS.SQUARE\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{rfp.square}} <span ng-if=\"rfp.square && rfp.squareUnit\">\n{{\"REQUEST_FOR_PROPOSAL.\" + rfp.squareUnit | translate}}</span></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.TECHNICAL_EQUIPMENT\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{rfp.technicalEquipment}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">{{ \"REQUEST_FOR_PROPOSAL.FIELDS.PRECISION_TO_THE_HOTEL\" | translate}} :</div>\n<div class=\"nl-prestataire-search-item-text\">{{rfp.precisiontoTheHotel}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.PRECISION_TO_THE_EVENT_PLACE\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{rfp.precisiontoTheEventPlace}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.PRECISION_FOR_THE_RECEPTIVE\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{rfp.precisionForTheReceptive}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.PRECISION_FOR_THE_CARRIER\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{rfp.precisionForTheCarrier}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.OTHER_PRECISION\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{rfp.otherPrecision}}</div></div></div><div class=\"mt-30 mb-10 flex-100\" \nng-if=\"(rfp.cahierDeCharges && rfp.cahierDeCharges.type==\'PDF\')\"><md-button \nstyle=\"min-width: 20%; margin: auto; display: block\" ng-click=\"download(rfp.cahierDeCharges.id)\" \nclass=\"md-primary md-raised nl-Button--small\"><md-icon md-font-icon=\"icon-download\"></md-icon>\n{{\'GENERAL.DOWNLOAD\' | translate}}</md-button></div></div></div></div></div>");
$templateCache.put("app/main/request_for_proposal/request_for_proposal_company/request_for_proposal_company.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"REQUEST_FOR_PROPOSAL.VIEW_COMPANY\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button></div><div class=\"content\"><div><div class=\"layout-row layout-align-start-stretch\"><div \nclass=\"nl-Block\" flex=\"50\" style=\"margin-bottom: 0\"><div class=\"nl_categories-item-title\" layout=\"row\" \nlayout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</div><div layout=\"row\">\n<md-input-container><label>{{\'GENERAL.COMPANY\' | translate}}</label><md-select required ng-model=\"filter.companyID\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectTextCompany.value\" ng-model-options=\"{ debounce: 500 }\"></section></md-select-header><md-option \nng-value=\"company.id\" ng-repeat=\"company in companies | orderBy : \'modelPattern\'\">{{company.modelPattern}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\"><md-input-container><label>\n{{\'STATISTIC_COMPANY.FILTER_MODE_LIBELLE\' | translate}}</label><md-select ng-model=\"filter.mode\"><md-option \nng-value=\"filterMode.key\" ng-repeat=\"filterMode in filterModes\">\n{{ \'STATISTIC_COMPANY.FILTER_MODE.\' + filterMode.key | translate }}</md-option></md-select></md-input-container></div>\n<div class=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\" \nng-if=\"filter.mode === \'PERIOD\'\">{{\'STATISTICS.DISPLAY.RESULT_BETWEEN\' | translate}}</div><div layout=\"row\" \nng-if=\"filter.mode === \'DAY\' || filter.mode === \'PERIOD\'\"><md-input-container class=\"nl-Input-container\" flex>\n<md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" \nng-model=\"filter.begin.date\" name=\"day\"></md-datepicker></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"filter.end.date\" name=\"day\" ng-hide=\"filter.mode === \'DAY\'\"></md-datepicker>\n</md-input-container></div><div layout=\"row\" ng-if=\"filter.mode === \'MONTH\' || filter.mode === \'YEAR\'\">\n<md-input-container flex=\"50\" ng-if=\"filter.mode === \'MONTH\'\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filter.begin.month\"><md-option \nng-value=\"month.value\" ng-repeat=\"month in monthNames track by $index\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option></md-select></md-input-container><md-input-container \nflex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"filter.begin.year\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.filter.begin\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYear(true)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">{{customYear.filter.begin}}</md-option></md-select>\n</md-input-container></div><div class=\"mt-5\" style=\"text-align:center!important\"><md-button \nclass=\"md-raised md-primary md-hue-2\" md-no-ink ng-click=\"getRFPCompanies()\">\n{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</md-button></div></div><div class=\"nl-Block ml-10\" flex=\"50\"><div \nclass=\"text-center\"><div class=\"nl-RfpWL__mainTitle\">{{array.length}}</div><div class=\"nl-RfpWL__mainSubtitle\">\n{{array.length==1 ? \'Appel d\\\'offre reçu\' : \'Appels d\\\'offres reçus\'}}</div></div><div \nclass=\"layout-row layout-align-start-start\"><div class=\"flex-50 text-center nl-RfpWL__bordered\"><img \nclass=\"nl-RfpWL__img\" src=\"./assets/images/logo/like.svg\" alt=\"\"><div class=\"nl-RfpWL__title\">{{wins}}</div><div \nclass=\"nl-RfpWL__subtitle\">{{wins==1 ? \'gagné\':\'gagnés\'}}</div><div class=\"mb-16\"><div class=\"nl-RfpWL__text\">\n(Total: {{participants}} pax)</div></div></div><div class=\"flex-50 text-center\"><img class=\"nl-RfpWL__img\" \nsrc=\"./assets/images/logo/dislike.svg\" alt=\"\"><div class=\"nl-RfpWL__title nl-RfpWL__title--lost\">{{lost}}</div><div \nclass=\"nl-RfpWL__subtitle nl-RfpWL__subtitle--lost\">{{lost==1 ? \'perdu\':\'perdus\'}}</div></div></div></div></div><div \nclass=\"mt-25\"><div class=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\">\n{{\'REQUEST_FOR_PROPOSAL.LIST_TITLE\' | translate}}</div><div class=\"nl-loader\" ng-show=\"loading.filter\"><div \nclass=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div \nclass=\"right\"><div class=\"half-circle\"></div></div></div></div></div><div class=\"nl-Block nl-Block--table\"><div><table \nclass=\"dataTable row-border hover nl-Table-responsive\"><tr style=\"border-bottom: 1px solid #cbcbcb\"><th>\n{{\'REQUEST_FOR_PROPOSAL.TABLE.CREATION_DATE\' | translate}}</th><th>{{\'REQUEST_FOR_PROPOSAL.TABLE.SENDER\' | translate }}\n</th><th>{{ \'REQUEST_FOR_PROPOSAL.TABLE.START_DATE\' | translate }}</th><th>\n{{ \'REQUEST_FOR_PROPOSAL.TABLE.END_DATE\' | translate }}</th><th>\n{{ \'REQUEST_FOR_PROPOSAL.TABLE.NUMBER_PARTICIPANTS\' | translate }}</th><th>\n{{ \'REQUEST_FOR_PROPOSAL.TABLE.STATUS\' | translate }}</th></tr><tr \nng-repeat=\"rfp in array | orderBy: \'-creationDate\' track by $index\"><td align=\"center\">\n{{rfp.creationDate | date : \'dd/MM/yy HH:mm\'}}</td><td align=\"center\">\n{{rfp.applicantFirstName}} {{rfp.applicantLastName}}<br>{{rfp.applicantCompany}}</td><td align=\"center\">\n{{rfp.dateStart | date : \'dd/MM/yy HH:mm\'}}</td><td align=\"center\">{{rfp.dateEnd | date : \'dd/MM/yy HH:mm\'}}</td><td \nalign=\"center\">{{rfp.numberOfParticipants}}</td><td align=\"center\"><span class=\"nl-TableTag\" \nng-class=\"{\'nl-TableTag--lost\': rfp.statusCompany === \'LOST\'}\">{{rfp.statusCompany==\"WIN\" ? \"Gagné\" : \"Perdu\"}}</span>\n</td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/main/request_for_proposal/request_for_proposal_members/request_for_proposal_members.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"STATISTIC_COMPANY.MEMBERS.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button></div><div class=\"content\"><div><div class=\"nl-Block mt-25\"><div class=\"nl-loader\" \nng-show=\"loading.filter\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div \nclass=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div><div><div \nclass=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\">\n{{\'REQUEST_FOR_PROPOSAL.MEMBERS\' | translate}}</div><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"dataTable row-border hover\"><thead><th style=\"width:30%\">{{\'REQUEST_FOR_PROPOSAL.FIELDS.MEMBER\' | translate}}\n</th><th>{{ \'REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_COMPANY\' | translate }}</th><th>\n{{ \'REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_COMPANY_TYPE\' | translate }}</th><th>\n{{ \'REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_WEB_SITE\' | translate }}</th><th>\n{{ \'REQUEST_FOR_PROPOSAL.FIELDS.ACTIONS\' | translate }}</th></thead><tbody><tr \nng-repeat=\"member in members | orderBy: \'applicantFirstName\' as arrayData\"><td>\n{{member.applicantCivility+\' \'+member.applicantFirstName+\' \'+member.applicantLastName+\' (\'+member.mail+\')\'}}</td><td>\n{{member.applicantCompany}}</td><td>{{member.applicantCompanyType}}</td><td>{{member.applicantWebSite}}</td><td>\n<md-button ng-click=\"goToDetails(member)\">{{ \'REQUEST_FOR_PROPOSAL.FIELDS.SHOW_DETAILS\' | translate }}</md-button></td>\n</tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/main/settings/database/companies.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div class=\"white-fg\" layout=\"row\" layout-align=\"start center\" flex><div \nlayout=\"row\" layout-align=\"start center\"><div layout=\"column\" layout-align=\"start start\"><div class=\"h1\"><span><md-icon\n md-font-icon=\"icon-city\" class=\"s24\"></md-icon></span><span translate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></span>\n</div></div></div></div><div layout=\"column\" layout-align=\"center end\" flex><md-button \naria-label=\"Ajouter une pharmacie\" class=\"md-fab md-red-600-bg\" ng-click=\"showPharmacyDialog()\"><md-tooltip \nmd-direction=\"bottom\">Ajouter une pharmacie</md-tooltip><md-icon md-font-icon=\"icon-plus\" \nclass=\"md-default-theme md-font material-icons\" role=\"img\" aria-hidden=\"true\"></md-icon></md-button></div></div><div \nclass=\"white-bg md-whiteframe-4dp\"></div></div>");
$templateCache.put("app/main/settings/database/companies_settings.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"SETTINGS.DATABASE.COMPANIES.SETTINGS\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content\"><div class=\"nl-Block\"><form name=\"fieldLinkForm\" \nnovalidate ng-submit=\"fieldLinkForm.$valid && saveLink()\"><div layout=\"column\"><md-input-container \nng-repeat=\"specific in specifics | orderBy: translate track by $index\"><label \ntranslate=\"{{\'SETTINGS.DATABASE.COMPANIES.\'+specific.type}}\"></label><md-select ng-model=\"specific.fieldModel\" \nng-model-options=\"{\'trackBy\': \'$value.id\'}\" ng-if=\"specific.type !== \'PHOTOS\' && specific.type !== \'COMPANY_EMAIL\'\">\n<md-option ng-value=\"null\"></md-option><md-option ng-repeat=\"field in fields | orderBy: \'libelle\' track by field.id\" \nng-value=\"field\">{{field.libelle}}</md-option></md-select><md-select ng-model=\"specific.fieldModel\" \nng-model-options=\"{\'trackBy\': \'$value.id\'}\" ng-if=\"specific.type === \'COMPANY_EMAIL\'\"><md-option ng-value=\"null\">\n</md-option><md-option ng-repeat=\"email in companyEmail track by email.id\" ng-value=\"email\">{{email.libelle}}\n</md-option></md-select><md-select ng-model=\"specific.category\" ng-model-options=\"{\'trackBy\': \'$value.id\'}\" \nng-if=\"specific.type === \'PHOTOS\'\"><md-option ng-value=\"null\"></md-option><md-option \nng-repeat=\"category in categories | orderBy: \'index\' track by category.id\" ng-value=\"category\">{{category.name}}\n</md-option></md-select></md-input-container><md-button type=\"submit\" class=\"md-primary md-hue-2 md-raised\" \ntranslate=\"GENERAL.SAVE\"></md-button></div></form></div></div></div>");
$templateCache.put("app/main/settings/database/contacts_settings.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"SETTINGS.DATABASE.CONTACTS.SETTINGS\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content\"><div class=\"nl-Block mt-20\"><div><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.COLUMNS\"></span></div></div><form name=\"\" role=\"form\" novalidate>\n<div layout=\"column\" ng-repeat=\"column in columns | orderBy: \'columnIndex\'\" ng-form=\"columnForm\"><h3>\nColumn {{column.columnIndex}}</h3><div layout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"\">\n<md-select md-on-close=\"filterSelectText = \'\'\" name=\"selectedField\" ng-model=\"column.selectedField\" placeholder=\"\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option ng-value=\"field\" \nng-repeat=\"field in columnFields | filterText: filterSelectText | orderBy: \'libelle\' track by field.id\" \nng-disabled=\"column.fieldsIds.lastIndexOf(field.id) > -1\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span> \n<span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-select><div \nng-messages=\"columnForm.selectedField.$error\" role=\"alert\"><div ng-message=\"required\"><span>Obligatoire.</span></div>\n</div></md-input-container><div><md-button type=\"button\" class=\"md-raised md-primary md-hue-2\" \nng-click=\"addToColumn(column);\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}\n</md-button></div></div><div ng-repeat=\"field in column.fields | orderBy:\'fieldIndex\'\" class=\"nl-Models-item\"><div>\n<div><div layout=\"row\" layout-align=\"space-between center\"><div><h3 class=\"\">{{field.field.libelle}}</h3></div><div \nclass=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"removeFromColumn(field.id);\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(field.fieldIndex > 1)\" ng-click=\"upField(field.id);\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(field.fieldIndex !== column.fields.length)\" ng-click=\"downField(field.id);\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div></div>\n</form></div><br><div class=\"nl-Block mt-15\"><div class=\"nl_categories-item-title nl_categories-item-title--first\">\n<span translate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.TITLE\"></span></div><div \nng-repeat=\"display in displaysModels | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><h3 class=\"\">{{display.fieldModel.libelle}}</h3></div><md-input-container \nclass=\"\" flex=\"10\"><md-select ng-change=\"setIcon(display)\" name=\"iconFieldContact\" id=\"iconFieldContact\" \nng-model=\"display.icon\" placeholder=\"\"><md-option ng-value=\"undefined\">\n{{\'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.NOTHING\' | translate}}</md-option><md-option ng-value=\"icon.name\" \nng-repeat=\"icon in DISPLAY_MODELS_ICONS\"><md-icon md-font-icon=\"{{icon.value}}\" class=\"s22\"></md-icon></md-option>\n</md-select></md-input-container><div class=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"removeField(display);\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div \nclass=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"goUp(display)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"!(display.index > 0 && displaysModels.length > 1)\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button ng-click=\"goDown(display)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"(display.index + 1 == displaysModels.length)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div><form \nname=\"researchPageCreationFilterForm\" role=\"form\" novalidate><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container class=\"\"><md-select md-on-close=\"filterSelectTextSecond = \'\'\" name=\"newFieldToFilter\" \nid=\"newFieldToFilter\" ng-model=\"fieldToAdd\" placeholder=\"\"><md-select-header><section><input force-select-focus \ntype=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextSecond\"></section>\n</md-select-header><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsAvalaible | filterText: filterSelectTextSecond\"><span ng-if=\"field.modelType\">\n{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-select>\n<div ng-messages=\"researchPageCreationFilterForm.newFieldToFilter.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Obligatoire.</span></div></div></md-input-container><div><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"addField();\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></form></div></div></div>");
$templateCache.put("app/main/settings/database/database.html","");
$templateCache.put("app/main/settings/message/message_settings.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"SETTINGS.MESSAGE.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-input-container><md-select \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container><md-select ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select></md-input-container></div></div></div>\n<div class=\"content\"><div class=\"nl-Block\"><div><div><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span translate=\"SETTINGS.MESSAGE.CREATION_ACTION.CREATE\"></span></div></div></div><div><div><div><form \nclass=\"form-horizontal\" role=\"form\" novalidate name=\"addActionForm\" \nng-submit=\"addActionForm.$valid && saveAction(action,addActionForm)\"><div><div layout=\"row\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"mt-18 mb-0\"><label>\n{{\'SETTINGS.MESSAGE.CREATION_ACTION.NAME\' | translate}} :</label><input type=\"text\" name=\"libelle\" \nng-model=\"action.libelle\" required><div ng-messages=\"addActionForm.libelle.$error\" role=\"alert\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><div><md-button \ntype=\"submit\" md-no-ink type=\"button\" class=\"md-raised md-primary md-hue-2\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"s18\"></md-icon>Ajouter</md-button></div></div></div></form></div></div></div></div></div><div class=\"mt-15\"><div\n ng-repeat=\"action in actions | orderBy:\'index\'\" class=\"nl-Block\"><form \nng-submit=\"updateActionForm.$valid && saveAction(action)\" novalidate name=\"updateActionForm\"><div \nclass=\"page-content container-fluid p-b-0\"><div class=\"panel panel panel-bordered m-b-0\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"mt-18 mb-0\"><input type=\"text\" ng-disabled=\"!action.active\" ng-model=\"action.libelle\" name=\"name_update\" \nrequired><div ng-messages=\"updateActionForm.name_update.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div><div layout=\"row\"><div ng-if=\"action.active\">\n<md-button type=\"submit\" class=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-content-save\" \nclass=\"s18\"></md-icon></md-button></div><div ng-if=\"!action.active\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"action.active = true;\"><md-icon md-font-icon=\"icon-pencil\" \nclass=\"s18\"></md-icon></md-button></div><div><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"removeAction(action);\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button></div><div \nclass=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"(action.index === 1)\" ng-click=\"upAction(action.id);\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"(action.index === actions.length)\" \nng-click=\"downAction(action.id);\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div>\n</div></div></div></div></form></div></div></div></div>");
$templateCache.put("app/main/settings/research_page_creation/research_page_creation.html","<div id=\"researchPageCreation\" class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.TITLE\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content\"><div class=\"content\"><div \nng-include=\"\'app/main/settings/research_page_creation/includes/filters.html\'\"></div></div><div class=\"content mt-20\">\n<md-content ng-include=\"\'app/main/settings/research_page_creation/includes/sorting.html\'\"></md-content></div><div \nclass=\"nl-Block mt-20\" ng-if=\"modelType != \'INSCRIPTION_MODEL\'\"><div><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.COLUMNS\"></span></div></div><form name=\"\" role=\"form\" novalidate>\n<div layout=\"column\" ng-repeat=\"column in columns | orderBy: \'columnIndex\'\" ng-form=\"columnForm\"><h3>\nColumn {{column.columnIndex}}</h3><div ng-repeat=\"field in column.fields | orderBy:\'fieldIndex\'\" \nclass=\"nl-Models-item\"><div><div><div layout=\"row\" layout-align=\"space-between center\"><div><h3 class=\"\"><span \nng-hide=\"field.fixField\">{{ field.field.libelle }}</span> <span ng-show=\"field.fixField\">\n{{ \'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.\' + field.fixFieldKey | translate }}</span></h3></div><div \nclass=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"removeFromColumn(field.id);\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(field.fieldIndex > 1)\" ng-click=\"upField(field.id);\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(field.fieldIndex !== column.fields.length)\" ng-click=\"downField(field.id);\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div><div \nlayout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"\"><md-select \nmd-on-close=\"filterSelectText = \'\'\" name=\"selectedField\" ng-model=\"column.selectedField\" placeholder=\"\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option ng-value=\"field\" \nng-repeat=\"field in columnFields | filterText: filterSelectText | orderBy: \'libelle\' track by field.id\" \nng-disabled=\"column.fieldsIds.lastIndexOf(field.id) > -1\" ng-if=\"modelType == \'COMPANY_MODEL\'\"><span>\n{{ field.libelle }}</span></md-option><md-optgroup label=\"\" ng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></label><md-option ng-value=\"field\" \nng-repeat=\"field in columnFields | filterText: filterSelectText | orderBy: \'libelle\' track by field.id\" \nng-if=\"field.modelType == companyModelType\"><span>{{ field.libelle }}</span></md-option></md-optgroup><md-optgroup \nlabel=\"\" ng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\"></label>\n<md-option ng-value=\"field\" \nng-repeat=\"field in columnFields | filterText: filterSelectText | orderBy: \'libelle\' track by field.id\" \nng-if=\"field.modelType == contactModelType\"><span>{{ field.libelle }}</span></md-option></md-optgroup><md-optgroup \nlabel=\"\" ng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_INSCRIPTION\">\n</label><md-option ng-value=\"field\" \nng-repeat=\"field in columnFields | filterText: filterSelectText | orderBy: \'libelle\' track by field.id\" \nng-if=\"field.modelType == registrationModelType || field.fixFieldKey == \'FIXE_FIELD_REGISTRATION_SUBCATEGORY\' \n                        || field.fixFieldKey == \'FIXE_FIELD_REGISTRATION_STATUS\'\">\n<span>{{ field.libelle }}</span></md-option></md-optgroup><md-optgroup label=\"\" \nng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_LOGISTIC\"></label><md-option \nng-value=\"field\" \nng-repeat=\"field in columnFields | filterText: filterSelectText | orderBy: \'libelle\' track by field.id\" \nng-if=\"field.modelType == logisticModelType || field.fixFieldKey == \'FIXE_FIELD_LOGISTIC_STATUS\'\"><span>\n{{ field.libelle }}</span></md-option></md-optgroup></md-select><div ng-messages=\"columnForm.selectedField.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\'GENERAL.REQUIRED\' | translate}}</span></div></div>\n</md-input-container><div><md-button type=\"button\" class=\"md-raised md-primary md-hue-2\" \nng-click=\"addToColumn(column);\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}\n</md-button></div></div></div></form></div><br><div class=\"nl-Block mt-15\" ng-if=\"modelType != \'INSCRIPTION_MODEL\'\">\n<div class=\"nl_categories-item-title nl_categories-item-title--first\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.TITLE\"></span></div><div \nng-repeat=\"display in displaysModels | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><h3 class=\"\">{{display.fieldModel.libelle}}</h3></div><md-input-container \nclass=\"\" flex=\"10\"><md-select ng-change=\"setIcon(display)\" name=\"iconFieldContact\" id=\"iconFieldContact\" \nng-model=\"display.icon\" placeholder=\"\"><md-option ng-value=\"undefined\">\n{{\'SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.FIELDS.NOTHING\' | translate}}</md-option><md-option ng-value=\"icon.name\" \nng-repeat=\"icon in DISPLAY_MODELS_ICONS\"><md-icon md-font-icon=\"{{icon.value}}\" class=\"s22\"></md-icon></md-option>\n</md-select></md-input-container><div class=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"removeField(display);\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div \nclass=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button ng-click=\"goUp(display)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"!(display.index > 0 && displaysModels.length > 1)\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button ng-click=\"goDown(display)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"(display.index + 1 == displaysModels.length)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div><form \nname=\"researchPageCreationFilterForm\" role=\"form\" novalidate><div layout=\"row\" layout-align=\"space-between center\">\n<md-input-container class=\"\"><md-select md-on-close=\"filterSelectTextSecond = \'\'\" name=\"newFieldToFilter\" \nid=\"newFieldToFilter\" ng-model=\"fieldToAdd.field\" placeholder=\"\"><md-select-header><section><input force-select-focus \ntype=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextSecond\"></section>\n</md-select-header><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsAvalaible | filterText: filterSelectTextSecond\"><span ng-if=\"field.modelType\">\n{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-select>\n<div ng-messages=\"researchPageCreationFilterForm.newFieldToFilter.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{\'GENERAL.REQUIRED\' | translate}}</span></div></div></md-input-container><div><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"addField();\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></form></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/blocs.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"SITES_MANAGEMENT.BLOCS.TITLES\">\n</div></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide \nshow-gt-sm><md-button type=\"button\" class=\"\" ng-click=\"_blocDetailsFn()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'SITES_MANAGEMENT.BLOCS.ADD\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" \nclass=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div \nclass=\"nl-FixedRightBar-panel\"><div layout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"\" \nng-click=\"_blocDetailsFn()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'SITES_MANAGEMENT.BLOCS.ADD\' | translate}}\n</md-button></div></div></div><div class=\"content\"><div layout=\"row\" layout-wrap hide-gt-sm><md-input-container \nflex=\"50\"><input type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.NAME\' | translate}}\"></md-input-container><md-input-container \nflex=\"50\"><md-select ng-model=\"search.type\" placeholder=\"{{\'SITES_MANAGEMENT.BLOCS.FIELDS_SEARCH.TYPE\' | translate}}\">\n<md-option ng-repeat=\"_thisType in types | orderBy : \'translation\' track by $index\" ng-value=\"_thisType.value\">\n{{_thisType.translation | translate}}</md-option></md-select></md-input-container></div><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"dataTable row-border hover\"><thead><tr><th><div class=\"nl-responsive-table--text\">\n{{\'SITES_MANAGEMENT.BLOCS.FIELDS.NAME\' | translate}}</div><div><input type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.NAME\' | translate}}\"></div></th><th><div \nclass=\"nl-responsive-table--text\">{{\'SITES_MANAGEMENT.BLOCS.FIELDS.TYPE\' | translate}}</div><div><md-select \nng-model=\"search.type\" placeholder=\"{{\'SITES_MANAGEMENT.BLOCS.FIELDS_SEARCH.TYPE\' | translate}}\"><md-option \nng-repeat=\"_thisType in types | orderBy : \'translation\' track by $index\" ng-value=\"_thisType.value\">\n{{_thisType.translation | translate}}</md-option></md-select></div></th></tr></thead><tbody><tr \nng-repeat=\"_bloc in blocs | filter:search | orderBy : \'name\' as arrayData track by $index\" \nng-click=\"_blocDetailsFn(_bloc.id);\"><td>{{ _bloc.name }}</td><td>{{ _bloc.type }}</td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/sites_management/pages/pages.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"SITES_MANAGEMENT.PAGES.TITLES\">\n</div></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide \nshow-gt-sm><md-button type=\"button\" class=\"\" ng-click=\"_pageDetailsFn()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'SITES_MANAGEMENT.PAGES.ADD\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" \nclass=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div \nclass=\"nl-FixedRightBar-panel\"><div layout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"\" \nng-click=\"_pageDetailsFn()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'SITES_MANAGEMENT.PAGES.ADD\' | translate}}\n</md-button></div></div></div><div class=\"content\"><div layout=\"row\" layout-wrap hide-gt-sm><md-input-container \nflex=\"33\" flex-xs=\"33\"><input class=\"nl-Input\" type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.NAME\' | translate}}\"></md-input-container><md-input-container \nflex=\"33\" flex-xs=\"33\"><input class=\"nl-Input\" type=\"text\" ng-model=\"search.site.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.PAGES.FIELDS_SEARCH.SITE\' | translate}}\"></md-input-container><md-input-container \nflex=\"33\" flex-xs=\"33\"><input class=\"nl-Input\" type=\"text\" ng-model=\"search.pageBlocs.bloc.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.PAGES.FIELDS_SEARCH.BLOCS\' | translate}}\"></md-input-container></div><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"dataTable row-border hover\"><thead><tr><th><div class=\"nl-responsive-table--text\">\n{{\'SITES_MANAGEMENT.PAGES.FIELDS.NAME\' | translate}}</div><div><input type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.NAME\' | translate}}\"></div></th><th><div \nclass=\"nl-responsive-table--text\">{{\'SITES_MANAGEMENT.PAGES.FIELDS.SITE\' | translate}}</div><div><input type=\"text\" \nng-model=\"search.sites.name\" placeholder=\"{{\'SITES_MANAGEMENT.PAGES.FIELDS_SEARCH.SITE\' | translate}}\"></div></th><th>\n<div class=\"nl-responsive-table--text\">{{\'SITES_MANAGEMENT.PAGES.FIELDS.BLOCS\' | translate}}</div><div><input \ntype=\"text\" ng-model=\"search.pageBlocs.bloc.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.PAGES.FIELDS_SEARCH.BLOCS\' | translate}}\"></div></th></tr></thead><tbody><tr \nng-repeat=\"_page in pages | filter:search  | orderBy: \'name\' as arrayData track by $index\" \nng-click=\"_pageDetailsFn(_page.id);\"><td>{{ _page.name }}</td><td><span ng-repeat=\"site in _page.sites | limitTo: 4\">\n{{site.name}} <span ng-if=\"!$last\">,</span></span></td><td><span \nng-repeat=\"_pageBloc in _page.pageBlocs | orderBy: \'index\' track by $index\" class=\"mr-5 md-grey-300-bg\">\n{{ _pageBloc.bloc.name }}</span></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/sites_management/siteMenu/siteMenu.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"SITES_MANAGEMENT.MENUS.TITLES\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-input-container><md-select \nng-change=\"getSiteMenu(); getSitePages();\" ng-model=\"language.key\" \nclass=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container><md-select ng-change=\"getSiteMenu(); getSitePages();\" \nng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright\"><md-option ng-repeat=\"lang in languages\" \nng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select>\n</md-input-container></div></div></div><div class=\"content\"><md-input-container><label>\n{{\'SITES_MANAGEMENT.MENUS.SITE\' | translate}}</label><md-select ng-model=\"siteID\" \nng-change=\"getSiteMenu(); getSitePages();\"><md-option ng-value=\"site.id\" ng-repeat=\"site in sites\">{{site.name}}\n</md-option></md-select></md-input-container><md-button class=\"md-raised md-primary md-hue-2 mv-15\" \nng-click=\"addItem(0, null)\" ng-if=\"siteID != null\">\n{{\'SITES_MANAGEMENT.MENUS.ADD_MENU\' | translate}}{{\'SITES_MANAGEMENT.MENUS.LEVEL0\' | translate}}</md-button><div \nclass=\"nl-Block\" ng-repeat=\"item in siteMenu.items | orderBy: \'index\'\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\">\n{{\'SITES_MANAGEMENT.MENUS.LEVEL\' | translate}} {{item.level + 1}}</div><div layout=\"row\" layout-wrap \nlayout-align=\"space-between center\"><div flex-xs=\"100\" layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"mt-20 mb-0\"><label>{{\'SITES_MANAGEMENT.MENUS.TITLE\' | translate}}</label><input class=\"\" type=\"text\" \nng-model=\"item.title\"></md-input-container><md-checkbox style=\"width: 100%; margin-left: 32px; margin-right: 32px\" \nclass=\"mb-0\" ng-model=\"item.directUrl\" ng-change=\"directUrlCheckboxChanged(item)\">\n{{\'SITES_MANAGEMENT.MENUS.DIRECT_URL\' | translate}}</md-checkbox><md-input-container class=\"mb-5 mt-0\" \nng-if=\"!item.directUrl\"><label translate=\"SITES_MANAGEMENT.MENUS.LINKED_PAGE\"></label><md-select \nng-model=\"item.pageID\"><md-option ng-value=\"page.id\" ng-repeat=\"page in pages | orderBy : \'name\' track by $index\">\n{{page.name}}</md-option></md-select></md-input-container><md-input-container class=\"mt-20 mb-0\" \nng-if=\"item.directUrl\"><label>{{\'SITES_MANAGEMENT.MENUS.DIRECT_URL\' | translate}}</label><input class=\"\" type=\"text\" \nng-model=\"item.url\"></md-input-container></div><div flex-xs=\"100\" layout=\"row\" layout-align=\"start center\" \nlayout-align-xs=\"space-around center\" layout-wrap><md-button ng-disabled=\"!(item.index > 0)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"upItem(item, item.index, null, null)\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-disabled=\"!(item.index != siteMenu.items.length - 1)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"downItem(item, item.index, null, null)\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon>\n</md-button><md-button class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"saveItem(item)\"><md-icon \nmd-font-icon=\"icon-content-save\" class=\"s20\"></md-icon></md-button><md-button class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"deleteItem(item)\"><md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button><md-button \nflex-xs=\"100\" class=\"md-raised md-primary md-hue-2 ml-20\" ng-click=\"addItem(1, item.id)\">\n{{\'SITES_MANAGEMENT.MENUS.ADD_MENU\' | translate}}{{\'SITES_MANAGEMENT.MENUS.LEVEL1\' | translate}}</md-button></div>\n</div><div class=\"nl-block pl-20\" ng-repeat=\"subItem in item.subItems | orderBy: \'index\'\"><div \nclass=\"nl_categories-item-subtitle\">{{\'SITES_MANAGEMENT.MENUS.LEVEL\' | translate}} {{subItem.level + 1}}</div><div \nlayout=\" row\" layout-align=\"space-between center\" layout-wrap><div flex-xs=\"100\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"mt-20 mb-0\"><label>\n{{\'SITES_MANAGEMENT.MENUS.TITLE\' | translate}}</label><input class=\"\" type=\"text\" ng-model=\"subItem.title\">\n</md-input-container><md-checkbox style=\"width: 100%; margin-left: 32px; margin-right: 32px\" class=\"mb-0\" \nng-model=\"subItem.directUrl\" ng-change=\"directUrlCheckboxChanged(subItem)\">\n{{\'SITES_MANAGEMENT.MENUS.DIRECT_URL\' | translate}}</md-checkbox><md-input-container class=\"mb-5 mt-0\" \nng-if=\"!subItem.directUrl\"><label>{{\'SITES_MANAGEMENT.MENUS.LINKED_PAGE\' | translate}}</label><md-select \nng-model=\"subItem.pageID\"><md-option ng-value=\"page.id\" ng-repeat=\"page in pages | orderBy : \'name\' track by $index\">\n{{page.name}}</md-option></md-select></md-input-container><md-input-container class=\"mt-20 mb-0\" \nng-if=\"subItem.directUrl\"><label>{{\'SITES_MANAGEMENT.MENUS.DIRECT_URL\' | translate}}</label><input class=\"\" \ntype=\"text\" ng-model=\"subItem.url\"></md-input-container></div><div flex-xs=\"100\" layout=\"row\" \nlayout-align=\"start center\" layout-align-xs=\"space-around center\" layout-wrap><md-button \nng-disabled=\"!(subItem.index > 0)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"upItem(subItem, item.index, subItem.index, null)\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button ng-disabled=\"!(subItem.index != item.subItems.length - 1)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"downItem(subItem, item.index, subItem.index, null)\"><md-icon \nmd-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button><md-button class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"saveItem(subItem)\"><md-icon md-font-icon=\"icon-content-save\" class=\"s20\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"deleteItem(subItem)\"><md-icon md-font-icon=\"icon-delete\" class=\"s20\">\n</md-icon></md-button><md-button flex-xs=\"100\" class=\"md-raised md-primary md-hue-2 ml-20\" \nng-click=\"addItem(2, subItem.id)\">\n{{\'SITES_MANAGEMENT.MENUS.ADD_MENU\' | translate}}{{\'SITES_MANAGEMENT.MENUS.LEVEL2\' | translate}}</md-button></div>\n</div><div class=\"nl-block ml-20\" ng-repeat=\"subSubItem in subItem.subItems | orderBy: \'index\'\"><div \nclass=\"nl_categories-item-subtitle\">{{\'SITES_MANAGEMENT.MENUS.LEVEL\' | translate}} {{subSubItem.level + 1}}</div><div \nlayout=\" row\" layout-align=\"space-between center\" layout-wrap><div flex-xs=\"100\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"mt-20 mb-0\"><label>\n{{\'SITES_MANAGEMENT.MENUS.TITLE\' | translate}}</label><input type=\"text\" ng-model=\"subSubItem.title\">\n</md-input-container><md-checkbox style=\"width: 100%; margin-left: 32px; margin-right: 32px\" class=\"mb-0\" \nng-model=\"subSubItem.directUrl\" ng-change=\"directUrlCheckboxChanged(subSubItem)\">\n{{\'SITES_MANAGEMENT.MENUS.DIRECT_URL\' | translate}}</md-checkbox><md-input-container class=\"mb-5 mt-0\" \nng-if=\"!subSubItem.directUrl\"><label>{{\'SITES_MANAGEMENT.MENUS.LINKED_PAGE\' | translate}}</label><md-select \nng-model=\"subSubItem.pageID\"><md-option ng-value=\"page.id\" \nng-repeat=\"page in pages | orderBy : \'name\' track by $index\">{{page.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"mt-20 mb-0\" ng-if=\"subSubItem.directUrl\"><label>\n{{\'SITES_MANAGEMENT.MENUS.DIRECT_URL\' | translate}}</label><input class=\"\" type=\"text\" ng-model=\"subSubItem.url\">\n</md-input-container></div><div flex-xs=\"100\" layout=\"row\" layout-align=\"start center\" \nlayout-align-xs=\"space-around center\"><md-button ng-disabled=\"!(subSubItem.index > 0)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"upItem(subSubItem, item.index, subItem.index, subSubItem.index)\">\n<md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-disabled=\"!(subSubItem.index != subItem.subItems.length - 1)\" type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"downItem(subSubItem, item.index, subItem.index, subSubItem.index)\"><md-icon md-font-icon=\"icon-arrow-down\" \nclass=\"s18\"></md-icon></md-button><md-button class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"saveItem(subSubItem)\"><md-icon md-font-icon=\"icon-content-save\" class=\"s20\"></md-icon></md-button><md-button \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"deleteItem(subSubItem)\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s20\"></md-icon></md-button></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/sites/site.dialog.html","<md-dialog class=\"nl_Dialog sites-dialog\" aria-label=\"Disposition\" flex style=\"max-height:95%!important\"><form \nname=\"siteForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name pt-10\" ng-if=\"!site.id\">\n{{\'SITES_MANAGEMENT.SITES.ADD\' | translate}}</div><div class=\"contact-name pt-10\" ng-if=\"site.id\">\n{{\'SITES_MANAGEMENT.SITES.MAJ\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"$mdDialog.cancel();\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content layout=\"column\"><div layout=\"row\" layout-wrap class=\"mt-50\"><div layout=\"row\" \nlayout-wrap><div class=\"nl-info-block-list-img animated fadeIn\" flex=\"30\"><md-input-container class=\"\"><input \ntype=\"text\" name=\"name\" ng-model=\"site.name\" placeholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS.NAME\' | translate}}\" \nrequired><div class=\"\" ng-messages=\"siteForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\"><input \ntype=\"text\" name=\"url\" ng-model=\"site.url\" placeholder=\"URL\" required><div class=\"\" ng-messages=\"siteForm.url.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container></div><div flex=\"10\" class=\"\" layout=\"column\"></div><div flex=\"30\" class=\"\" layout=\"column\">\n<md-input-container class=\"\" style=\"margin-left:100px\"><label>Logo</label><dropify-directive \nfilesave=\"photo.uploadFile\" ng-model=\"site\" placeholder=\"\" id=\"site_logo\"></md-input-container></div><div flex=\"30\" \nclass=\"\" layout=\"column\"><md-input-container class=\"\" style=\"margin-left:100px\"><label>Image réseaux sociaux</label>\n<dropify-directive filesave=\"photo.uploadFileSocialNetwork\" ng-model=\"siteRS\" placeholder=\"\" id=\"site_logo_facebook\">\n</md-input-container></div></div><md-input-container class=\"\"><md-select ng-model=\"site.languages\" multiple=\"multiple\" \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"lang in languages | orderBy : \'key\'\" ng-value=\"lang\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select><label class=\"\" \ntranslate=\"SITES_MANAGEMENT.SITES.FIELDS.LANGUAGES\"></label></md-input-container><md-input-container class=\"\">\n<md-select name=\"defaultLanguage\" ng-model=\"site.defaultLanguage\" required><md-option \nng-repeat=\"lang in languages | orderBy : \'key\'\" ng-value=\"lang\" ng-selected=\"lang.id == site.defaultLanguage.id\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select><label class=\"\" \ntranslate=\"SITES_MANAGEMENT.SITES.FIELDS.DEFAULT_LANGUAGE\"></label><div class=\"\" \nng-messages=\"siteForm.defaultLanguage.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" ng-if=\"site.id\">\n<md-select name=\"homePage\" ng-model=\"site.homePage\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"_page in pages | orderBy : \'name\'\" ng-value=\"_page\">{{_page.name}}</md-option></md-select><label class=\"\" \ntranslate=\"SITES_MANAGEMENT.SITES.FIELDS.WELCOME_PAGE\"></label></md-input-container><md-input-container class=\"\"><input\n type=\"text\" name=\"twitterUrl\" ng-model=\"site.twitterUrl\" placeholder=\"twitter\"></md-input-container>\n<md-input-container class=\"\"><input type=\"text\" name=\"facebookUrl\" ng-model=\"site.facebookUrl\" placeholder=\"Facebook\">\n</md-input-container><md-input-container class=\"\"><input type=\"text\" name=\"instagramUrl\" ng-model=\"site.instagramUrl\" \nplaceholder=\"Instagram\"></md-input-container><md-input-container class=\"\"><input type=\"text\" name=\"linkedinUrl\" \nng-model=\"site.linkedinUrl\" placeholder=\"Linkedin\"></md-input-container><md-input-container class=\"\"><input \ntype=\"text\" name=\"youtubeUrl\" ng-model=\"site.youtubeUrl\" placeholder=\"Youtube\"></md-input-container><md-input-container\n class=\"\"><input type=\"text\" name=\"companyUrl\" ng-model=\"site.companyUrl\" placeholder=\"Company\"></md-input-container>\n<md-input-container class=\"\"><input type=\"text\" name=\"articleUrl\" ng-model=\"site.articleUrl\" placeholder=\"Article\">\n</md-input-container><md-input-container class=\"\"><textarea name=\"css\" ng-model=\"site.css\" placeholder=\"CSS\" rows=\"5\">\n</textarea></md-input-container><md-input-container class=\"\"><textarea name=\"footer\" ng-model=\"site.footer\" \nplaceholder=\"Footer\" rows=\"5\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button type=\"button\" ng-if=\"site.id\" ng-click=\"_delete()\" \nclass=\"md-red-400-bg submit-button md-raised\" aria-label=\"Delete\">{{\'SITES_MANAGEMENT.ACTIONS.DELETE\' | translate}}\n</md-button><md-button type=\"submit\" ng-click=\"_save(siteForm);\" class=\"md-accent submit-button md-raised\" \naria-label=\"Save\">{{\'SITES_MANAGEMENT.ACTIONS.SAVE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/sites_management/sites/sites.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"SITES_MANAGEMENT.SITES.TITLES\">\n</div></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-apps\" class=\"icon\"></md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide \nshow-gt-sm><md-button type=\"button\" class=\"\" ng-click=\"_dialogFn()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'SITES_MANAGEMENT.SITES.ADD\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" \nclass=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div \nclass=\"nl-FixedRightBar-panel\"><div layout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"\" \nng-click=\"_dialogFn()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'SITES_MANAGEMENT.SITES.ADD\' | translate}}\n</md-button></div></div></div><div class=\"content\"><div layout=\"row\" layout-wrap hide-gt-sm><md-input-container \nflex=\"33\"><input type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.NAME\' | translate}}\"></md-input-container><md-input-container \nflex=\"33\"><input type=\"text\" ng-model=\"search.url\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.URL\' | translate}}\"></md-input-container><md-input-container \nflex=\"33\"><input type=\"text\" ng-model=\"search.languagesTmp.libelle\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.LANGUAGES\' | translate}}\"></md-input-container></div><div \nclass=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table nl-responsive-table nl-table-data=\"arrayData\" \nclass=\"dataTable row-border hover\"><thead><tr><th><div class=\"nl-responsive-table--text\">\n{{\'SITES_MANAGEMENT.SITES.FIELDS.NAME\' | translate}}</div><div><input type=\"text\" ng-model=\"search.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.NAME\' | translate}}\"></div></th><th><div \nclass=\"nl-responsive-table--text\">URL</div><div><input type=\"text\" ng-model=\"search.url\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.URL\' | translate}}\"></div></th><th><div \nclass=\"nl-responsive-table--text\">{{\'SITES_MANAGEMENT.SITES.FIELDS.LANGUAGES\' | translate}}</div><div><input \ntype=\"text\" ng-model=\"search.languagesTmp.libelle\" \nplaceholder=\"{{\'SITES_MANAGEMENT.SITES.FIELDS_SEARCH.LANGUAGES\' | translate}}\"></div></th></tr></thead><tbody><tr \nng-repeat=\"_site in sites | filter:search | orderBy : \'name\' as arrayData track by $index\" ng-click=\"_dialogFn(_site)\">\n<td>{{ _site.name }}</td><td>{{ _site.url }}</td><td><span \nng-repeat=\"lang in _site.languagesTmp | orderBy: \'key\' track by $index\" class=\"mr-5\" \nng-class=\"lang.defaultLanguage ? \'md-green-800-bg\' : \'md-grey-300-bg\'\">{{ lang.libelle }}</span></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/statistics/automatic/automaticStatistics.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"STATISTICS.AUTOMATIC.TITLE\"></div></div><div layout=\"row\" \nlayout-align=\"start center\"></div></div><div class=\"content\"><div class=\"nl-Block\"><div layout=\"row\">\n<md-input-container flex><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"year\" \nng-change=\"getStatistics()\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYear(false)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option value=\"all\">\n{{\"STATISTICS.AUTOMATIC.ALL\" | translate}}</md-option><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">{{customYear}}</md-option></md-select>\n</md-input-container><md-input-container flex><md-select ng-change=\"getStatistics()\" \nplaceholder=\"{{\'STATISTICS.REPARTITION.PLACEHOLDER.TYPE\' | translate}}\" ng-model=\"filter.typeID\" name=\"typeID\">\n<md-option ng-value=\"null\" selected=\"selected\">{{\'STATISTICS.AUTOMATIC.ALL\' | translate}}</md-option><md-option \nng-repeat=\"type in typesCompany\" ng-value=\"type.id\">{{type.name}}</md-option></md-select></md-input-container></div>\n<div ng-if=\"statistics.length > 0\"><table class=\"nl-Table pure-table pure-table-bordered\"><thead><th>\n{{\"STATISTICS.AUTOMATIC.TABLE.DATE\" | translate}}</th><th>\n{{\"STATISTICS.AUTOMATIC.TABLE.NBR_COMPANIES_ACTIVE\" | translate}}</th><th>\n{{\"STATISTICS.AUTOMATIC.TABLE.NBR_COMPANIES_INACTIVE\" | translate}}</th><th>\n{{\"STATISTICS.AUTOMATIC.TABLE.NBR_USERS_ACTIVE\" | translate}}</th><th>\n{{\"STATISTICS.AUTOMATIC.TABLE.NBR_USERS_INACTIVE\" | translate}}</th></thead><tbody><tr ng-repeat=\"stat in statistics\">\n<td>{{(stat.month > 9 ? stat.month : \'0\' + stat.month ) + \'/\' + stat.year}}</td><td>{{stat.nbrActiveCompanies}}</td>\n<td>{{stat.nbrInactiveCompanies}}</td><td>{{stat.nbrActiveUsers}}</td><td>{{stat.nbrInactiveUsers}}</td></tr></tbody>\n</table><br><canvas id=\"line\" class=\"chart chart-line\" chart-data=\"chart.data\" chart-labels=\"chart.labels\" \nchart-series=\"chart.series\" chart-options=\"chart.options\" chart-dataset-override=\"chart.datasetOverride\"></canvas>\n</div><div class=\"mb-15 mh-10\" ng-if=\"statistics.length === 0\">{{\"STATISTICS.AUTOMATIC.NO_RESULT\" | translate}}</div>\n</div></div></div>");
$templateCache.put("app/main/statistics/display/displayStatistics.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"STATISTICS.DISPLAY.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"switchMode()\"><md-icon md-font-icon=\"icon-swap-horizontal\"></md-icon><span \nng-if=\"!filterMode\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</span> <span ng-if=\"!!filterMode\">\n{{\'STATISTICS.DISPLAY.COMPARE\' | translate}}</span></md-button></div></div><div id=\"nl-js--FixedRightBar\" \nclass=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div \nclass=\"nl-FixedRightBar-panel\"><div layout=\"column\" layout-align=\"start start\"><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"switchMode()\"><md-icon md-font-icon=\"icon-swap-horizontal\"></md-icon><span \nng-if=\"!filterMode\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</span> <span ng-if=\"!!filterMode\">\n{{\'STATISTICS.DISPLAY.COMPARE\' | translate}}</span></md-button></div></div></div><div class=\"content\"><div \nng-if=\"!!filterMode\"><div class=\"nl-Block\"><div class=\"nl_categories-item-title\" layout=\"row\" \nlayout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</div><div \nclass=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.RESULT_BETWEEN\' | translate}}</div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filter.begin.month\"><md-option \nng-value=\"month.value\" ng-repeat=\"month in monthNames track by $index\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option></md-select></md-input-container><md-input-container \nflex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"filter.begin.year\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.filter.begin\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYear(true)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">{{customYear.filter.begin}}</md-option></md-select>\n</md-input-container></div><div class=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.AND\' | translate}}</div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filter.end.month\"><md-option \nng-value=\"month.value\" ng-repeat=\"month in monthNames track by $index\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option></md-select></md-input-container><md-input-container \nflex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"filter.end.year\">\n<md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.filter.end\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYear(false)\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">\n{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">{{customYear.filter.end}}</md-option></md-select>\n</md-input-container></div><md-input-container ng-if=\"!oneCompanyMode\"><md-input-container><md-select \nng-model=\"filter.companyID\" ng-change=\"getStatistics()\"><md-select-header><section><input force-select-focus \ntype=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextCompany.value\"></section>\n</md-select-header><md-option ng-value=\"null\" selected=\"selected\">{{\'STATISTICS.DISPLAY.ALL_COMPANIES\' | translate}}\n</md-option><md-option ng-value=\"company.id\" ng-repeat=\"company in companies | orderBy : \'modelPattern\'\">\n{{company.modelPattern}}</md-option></md-select></md-input-container></md-input-container><md-input-container \nng-repeat=\"field in specificFields\" ng-if=\"!oneCompanyMode\"><label>{{field.libelle}}</label><md-select \nng-model=\"specificFieldsValue[field.id]\"><md-option ng-value=\"null\" selected=\"selected\">\n{{\'STATISTICS.AUTOMATIC.ALL\' | translate}}</md-option><md-option ng-value=\"value.id\" \nng-repeat=\"value in field.listFieldsDTO | orderBy: \'value\'\">{{value.value}}</md-option></md-select>\n</md-input-container><md-input-container ng-if=\"!oneCompanyMode\"><label>{{\'STATISTICS.REGROUP_BY\' | translate }}\n</label><md-select ng-model=\"filter.regroupment\"><md-option ng-value=\"null\" selected=\"selected\">\n{{\'STATISTICS.AUTOMATIC.ALL\' | translate}}</md-option><md-option ng-value=\"field.id\" \nng-repeat=\"field in specificFields | orderBy: \'libelle\'\">{{field.libelle}}</md-option></md-select></md-input-container>\n<md-input-container class=\"mt-0 mb-0\"><md-checkbox name=\"\" class=\"md-primary md-hue-2\" ng-model=\"filter.onlyAverage\" \naria-label=\"onlyAverage\">{{\'STATISTICS.DISPLAY.ONLY_AVERAGE\'|translate}}</md-checkbox></md-input-container><div \nclass=\"mt-5\"><md-button class=\"md-raised md-primary md-hue-2\" md-no-ink ng-click=\"getStatsCompanies()\">\n{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</md-button><md-button class=\"md-raised md-primary md-hue-2\" md-no-ink \nng-click=\"getStatsNationalities()\">{{\'STATISTICS.DISPLAY.BUTTON_GET_STATS_NATIONALITIES\' | translate}}</md-button>\n<md-button class=\"md-primary md-hue-2 ml-30\" ng-click=\"downloadCompanies()\">\n{{\'STATISTICS.DISPLAY.BUTTON_DOWNLOAD_COMPANIES\' | translate}}</md-button><md-button class=\"md-primary md-hue-2\" \nng-click=\"downloadNationalities()\">{{\'STATISTICS.DISPLAY.BUTTON_DOWNLOAD_NATIONALITIES\' | translate}}</md-button></div>\n</div><div class=\"nl-Block mt-25\"><div class=\"nl-loader\" ng-show=\"loading.filter\"><div class=\"spinner\"><div \nclass=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div><div ng-if=\"byCompany != null && byCompany\"><div \nclass=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.STATS_BY_COMPANY\' | translate}}</div><table class=\"nl-Table pure-table pure-table-bordered\" \nng-if=\"statisticsArray.length > 0\"><thead><tr><th style=\"width:10%\">{{\'GENERAL.COMPANY\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.STAR_RATING\' | translate}}</th><th>{{\'STATISTICS.EDIT.FIELDS.REGION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.MONTH\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_ARRIVALS\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_LEAVINGS\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.NBR_ROOMS\' | translate}}</th><th>{{\'STATISTICS.EDIT.FIELDS.NBR_OCCUPED_ROOMS\' | translate}}\n</th><th>{{\'STATISTICS.EDIT.FIELDS.INCOME_ON_MONTH\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.INCOME_BY_DAY\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.AVERAGE_DURATION_STAY\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.OCCUPATION_PERCENTAGE\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.NBR_EMPLOYEES_FULL_TIME\' | translate}}</th><th>\n{{\'STATISTICS.EDIT.FIELDS.NBR_EMPLOYEES_PART_TIME\' | translate}}</th></tr></thead><tbody \nstyle=\"border-bottom: 1px solid #cbcbcb\" ng-repeat=\"elt in statisticsArray | orderBy: \'company\'\"><tr \nng-repeat=\"stat in elt.statistics track by $index\"><td ng-if=\"$index === 0\" rowspan=\"{{elt.statistics.length}}\">\n{{elt.company}}</td><td>{{elt.category}}</td><td>{{elt.region}}</td><td ng-if=\"!stat.average\">\n{{(stat.month >= 9 ? (stat.month+1) : \"0\" + (stat.month+1)) + \"/\" + stat.year}}</td><td ng-if=\"stat.average\">\n{{\'STATISTICS.DISPLAY.AVERAGE\' | translate}}</td><td>{{stat.nbrArrivals}}</td><td>{{stat.nbrDepartures}}</td><td>\n{{stat.nbrRooms}}</td><td>{{stat.nbrOccupedRooms}}</td><td>{{stat.incomeOnMonth}}</td><td>{{stat.incomeByDay | number}}\n</td><td>{{stat.averageDurationStay}}</td><td>\n{{(stat.nbrOccupedRooms != null && stat.nbrRooms != null && stat.nbrRooms != 0) ? ((stat.nbrOccupedRooms / stat.nbrRooms) * 100) : \"\" | limitTo: 4}}{{(stat.nbrOccupedRooms != null && stat.nbrRooms != null && stat.nbrRooms != 0) ? \"%\" : \"\"}}\n</td><td>{{stat.nbrEmployeesFullTime}}</td><td>{{stat.nbrEmployeesPartTime}}</td></tr></tbody></table><div \nclass=\"pt-10 pb-15 ph-10\" ng-if=\"statisticsArray.length === 0\">{{\'STATISTICS.DISPLAY.NO_RESULT\' | translate}}</div>\n</div><div ng-if=\"byCompany != null && !byCompany\"><div class=\"nl_categories-item-title\" layout=\"row\" \nlayout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.STATS_BY_NATIONALITY\' | translate}}</div><table \nclass=\"nl-Table pure-table pure-table-bordered\" ng-if=\"statisticsNatArray.length > 0\"><thead><tr><th>\n{{\'STATISTICS.DISPLAY.TABLE_NATIONALITIES.NATIONALITY\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_NATIONALITIES.NBR_ARRIVALS\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_NATIONALITIES.NBR_LEAVINGS\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_NATIONALITIES.NBR_TOTAL_CUSTOMERS\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_NATIONALITIES.NBR_TOTAL_NIGHTS\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_NATIONALITIES.AVERAGE_NBR_NIGHTS_PERSON\' | translate}}</th></tr></thead><tbody><tr \nng-repeat=\"stat in statisticsNatArray\"><td>{{stat.nationality.libelle}}</td><td>{{stat.nbrArrivals}}</td><td>\n{{stat.nbrLeavings}}</td><td>{{stat.nbrArrivals + stat.nbrLeavings}}</td><td>{{stat.nbrNights}}</td><td>\n{{stat.nbrNights / (stat.nbrArrivals + stat.nbrLeavings == 0 ? 1 : stat.nbrArrivals + stat.nbrLeavings) | limitTo: 3}}\n</td></tr></tbody></table><div class=\"pt-10 pb-15 ph-10\" ng-if=\"statisticsNatArray.length === 0\">\n{{\'STATISTICS.DISPLAY.NO_RESULT\' | translate}}</div></div></div></div><div ng-if=\"!filterMode\" class=\"nl-Block\"><div \nclass=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.PERIOD1\' | translate}}</div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filterFirstPeriod.begin.month\">\n<md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames track by $index\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option></md-select></md-input-container><md-input-container \nflex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select \nng-model=\"filterFirstPeriod.begin.year\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"customYear.compare.firstPeriod.begin\" onkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button \nng-click=\"searchStatisticsCompareCustomYear(true, true)\" class=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button>\n</md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">{{year}}</md-option><md-option \nvalue=\"custom\" style=\"display: none\">{{customYear.compare.firstPeriod.begin}}</md-option></md-select>\n</md-input-container></div><div class=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.AND\' | translate}}</div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filterFirstPeriod.end.month\">\n<md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames track by $index\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option></md-select></md-input-container><md-input-container \nflex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select \nng-model=\"filterFirstPeriod.end.year\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"customYear.compare.firstPeriod.end\" onkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button \nng-click=\"searchStatisticsCompareCustomYear(true, false)\" class=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button>\n</md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">{{year}}</md-option><md-option \nvalue=\"custom\" style=\"display: none\">{{customYear.compare.firstPeriod.end}}</md-option></md-select>\n</md-input-container></div><div class=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.PERIOD2\' | translate}}</div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filterSecondPeriod.begin.month\">\n<md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames track by $index\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option></md-select></md-input-container><md-input-container \nflex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select \nng-model=\"filterSecondPeriod.begin.year\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"customYear.compare.secondPeriod.begin\" onkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button \nng-click=\"searchStatisticsCompareCustomYear(false, true)\" class=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button>\n</md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">{{year}}</md-option><md-option \nvalue=\"custom\" style=\"display: none\">{{customYear.compare.secondPeriod.begin}}</md-option></md-select>\n</md-input-container></div><div class=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\">\n{{\'STATISTICS.DISPLAY.AND\' | translate}}</div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filterSecondPeriod.end.month\">\n<md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames track by $index\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option></md-select></md-input-container><md-input-container \nflex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select \nng-model=\"filterSecondPeriod.end.year\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"customYear.compare.secondPeriod.end\" onkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button \nng-click=\"searchStatisticsCompareCustomYear(false, false)\" class=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button>\n</md-select-header><md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">{{year}}</md-option><md-option \nvalue=\"custom\" style=\"display: none\">{{customYear.compare.secondPeriod.end}}</md-option></md-select>\n</md-input-container></div><md-button md-no-ink class=\"md-raised md-primary md-hue-2\" \nng-click=\"getStatsCompareCompanies()\">{{\'STATISTICS.DISPLAY.COMPARE\' | translate}}</md-button><md-button \nclass=\"md-primary md-hue-2 ml-30\" ng-click=\"exportOccupationStats()\">{{\'STATISTICS.DISPLAY.EXPORT\'| translate}}\n</md-button><div class=\"nl-loader\" ng-show=\"loading.compare\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\">\n</div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div>\n</div></div></div><div class=\"mt-25\" ng-if=\"statisticsCompare.length > 0\"><table \nclass=\"nl-Table pure-table pure-table-bordered\"><thead><tr><th rowspan=\"2\" width=\"6%\">{{\'GENERAL.COMPANY\' | translate}}\n</th><th colspan=\"3\">{{\'STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_ARRIVALS\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_LEAVINGS\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.NBR_ROOMS\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.INCOME_ON_MONTH\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.AVERAGE_DURATION_STAY\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.DISPLAY.OCCUPATION_PERCENTAGE\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.NBR_EMPLOYEES_FULL_TIME\' | translate}}</th><th colspan=\"3\">\n{{\'STATISTICS.EDIT.FIELDS.NBR_EMPLOYEES_PART_TIME\' | translate}}</th></tr><tr><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD1\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.PERIOD2\' | translate}}</th><th>\n{{\'STATISTICS.DISPLAY.TABLE_COMPARE.EVOLUTION\' | translate}}</th></tr></thead><tbody><tr \nng-repeat=\"stat in statisticsCompare[0] track by $index\"><td>{{stat.company}}</td><td>\n{{stat.statistics[0].nbrArrivals}}</td><td>{{statisticsCompare[1][$index].statistics[0].nbrArrivals}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoNbrArrivals === 0 ? \'\': (stat.statistics[0].evoNbrArrivals >= 0 ? \'green\': \'red\')) }\">\n{{stat.statistics[0].evoNbrArrivals}}%</td><td>{{stat.statistics[0].nbrDepartures}}</td><td>\n{{statisticsCompare[1][$index].statistics[0].nbrDepartures}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoNbrDepartures === 0 ? \'\': (stat.statistics[0].evoNbrDepartures >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoNbrDepartures}}%</td><td>{{stat.statistics[0].nbrRooms}}</td><td>\n{{statisticsCompare[1][$index].statistics[0].nbrRooms}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoNbrRooms === 0 ? \'\': (stat.statistics[0].evoNbrRooms >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoNbrRooms}}%</td><td>{{stat.statistics[0].incomeOnMonth}}</td><td>\n{{statisticsCompare[1][$index].statistics[0].incomeOnMonth}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoIncomeOnMonth === 0 ? \'\': (stat.statistics[0].evoIncomeOnMonth >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoIncomeOnMonth}}%</td><td>{{stat.statistics[0].averageDurationStay}}</td><td>\n{{statisticsCompare[1][$index].statistics[0].averageDurationStay}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoAverageDurationStay === 0 ? \'\': (stat.statistics[0].evoAverageDurationStay >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoAverageDurationStay}}%</td><td>{{stat.statistics[0].occupationRate}}%</td><td>\n{{statisticsCompare[1][$index].statistics[0].occupationRate}}%</td><td \nng-style=\"{ color: (stat.statistics[0].evoOccupationRate === 0 ? \'\': (stat.statistics[0].evoOccupationRate >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoOccupationRate}}%</td><td>{{stat.statistics[0].nbrEmployeesFullTime}}</td><td>\n{{statisticsCompare[1][$index].statistics[0].nbrEmployeesFullTime}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoNbrEmployeesFullTime === 0 ? \'\': (stat.statistics[0].evoNbrEmployeesFullTime >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoNbrEmployeesFullTime}}%</td><td>{{stat.statistics[0].nbrEmployeesPartTime}}</td><td>\n{{statisticsCompare[1][$index].statistics[0].nbrEmployeesPartTime}}</td><td \nng-style=\"{ color: (stat.statistics[0].evoNbrEmployeesPartTime === 0 ? \'\': (stat.statistics[0].evoNbrEmployeesPartTime >= 0 ? \'green\': \'red\'))}\">\n{{stat.statistics[0].evoNbrEmployeesPartTime}}%</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/statistics/edit/editStatistics.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"STATISTICS.EDIT.TITLE\"></div></div><div layout=\"row\" layout-align=\"start center\">\n</div></div><div class=\"content\"><div layout=\"row\" ng-if=\"isAdmin\"><md-input-container><md-select \nng-model=\"selectCompany.id\" ng-change=\"getStatistics()\"><md-select-header><section><input force-select-focus \ntype=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectTextCompany.value\"></section>\n</md-select-header><md-option ng-value=\"company.id\" \nng-repeat=\"company in companies | orderBy : \'modelPattern\' track by company.id\">{{company.modelPattern}}</md-option>\n</md-select></md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"selectedPeriod.month\" \nng-change=\"getStatistics()\"><md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames track by $index\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option></md-select></md-input-container><md-input-container \nflex=\"50\"><label>{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"selectedPeriod.year\" \nng-change=\"getStatistics()\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button ng-click=\"searchStatisticsCustomYear()\" class=\"m-0\">\n{{\'GENERAL.OK\' | translate}}</md-button></md-select-header><md-option ng-value=\"year\" \nng-repeat=\"year in yearValues track by $index\">{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">\n{{customYear}}</md-option></md-select></md-input-container></div><md-input-container><label \ntranslate=\"STATISTICS.EDIT.FIELDS.NBR_ROOMS\"></label><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"statistics.nbrRooms\"></md-input-container><md-input-container><label \ntranslate=\"STATISTICS.EDIT.FIELDS.NBR_OCCUPED_ROOMS\"></label><input class=\"\" type=\"number\" min=\"0\" step=\"1\" \nng-model=\"statistics.nbrOccupedRooms\"></md-input-container><div layout=\"row\" \nng-repeat=\"statNat in statistics.statsNationality | orderBy: \'nationality.libelle\' track by $index\"><md-input-container\n flex=\"23\"><label translate=\"STATISTICS.EDIT.NATIONALITY\"></label><md-select md-on-close=\"filterSelectText = \'\'\" \nname=\"nationality\" ng-model=\"statNat.nationality\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-select-header><section>\n<input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\">\n</section></md-select-header><md-option ng-repeat=\"nationality in nationalities | filterText: filterSelectText\" \nng-value=\"nationality\" ng-disabled=\"!!nationality.alreadyHere\">{{nationality.libelle}}</md-option></md-select>\n</md-input-container><md-input-container flex=\"23\"><label \ntranslate=\"STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_LEAVINGS\"></label><input class=\"\" type=\"number\" min=\"0\" \nstep=\"1\" ng-model=\"statNat.nbrLeavings\"></md-input-container><md-input-container flex=\"23\"><label \ntranslate=\"STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_ARRIVALS\"></label><input class=\"\" type=\"number\" min=\"0\" \nstep=\"1\" ng-model=\"statNat.nbrArrivals\"></md-input-container><md-input-container flex=\"23\"><label \ntranslate=\"STATISTICS.EDIT.FIELDS.STATS_NATIONALITY.NBR_NIGHTS\"></label><input class=\"\" type=\"number\" min=\"0\" step=\"1\" \nng-model=\"statNat.nbrNights\"></md-input-container><md-button class=\"md-icon-button md-warn\" aria-label=\"\" \nng-click=\"removeNationality($index)\">X</md-button></div><md-button class=\"md-primary\" ng-click=\"addNationality()\" \nng-if=\"statistics.statsNationality.length < nationalities.length\">\n{{\'STATISTICS.EDIT.BUTTONS.ADD_NATIONALITY\' | translate}}</md-button><md-input-container><label \ntranslate=\"STATISTICS.EDIT.FIELDS.NBR_CLIENTS\"></label><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"statistics.nbrClients\"></md-input-container><md-input-container><label \ntranslate=\"STATISTICS.EDIT.FIELDS.INCOME_ON_MONTH\"></label><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"statistics.incomeOnMonth\"></md-input-container><md-input-container><label \nclass=\"nl-Input-label md-no-float md-container-ignore\" translate=\"STATISTICS.EDIT.FIELDS.AVERAGE_DURATION_STAY\">\n</label><input type=\"number\" min=\"0\" ng-model=\"statistics.averageDurationStay\"></md-input-container>\n<md-input-container><label class=\"nl-Input-label md-no-float md-container-ignore\" \ntranslate=\"STATISTICS.EDIT.FIELDS.NBR_EMPLOYEES_FULL_TIME\"></label><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"statistics.nbrEmployeesFullTime\"></md-input-container><md-input-container><label \nclass=\"nl-Input-label md-no-float md-container-ignore\" translate=\"STATISTICS.EDIT.FIELDS.NBR_EMPLOYEES_PART_TIME\">\n</label><input type=\"number\" min=\"0\" step=\"1\" ng-model=\"statistics.nbrEmployeesPartTime\"></md-input-container>\n<md-button class=\"md-primary\" ng-click=\"save()\"><span ng-if=\"!!overwriteMode\">\n{{\'STATISTICS.EDIT.BUTTONS.VALIDATE.UPDATE\' | translate}}</span> <span ng-if=\"!overwriteMode\">\n{{\'STATISTICS.EDIT.BUTTONS.VALIDATE.SAVE\' | translate}}</span></md-button></div></div>");
$templateCache.put("app/main/statistics/repartition/repartitionStatistics.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"STATISTICS.REPARTITION.TITLE\"></div></div></div><div class=\"content\"><div \nlayout=\"row\" class=\"nl-Block\"><md-input-container><md-select \nplaceholder=\"{{\'STATISTICS.REPARTITION.PLACEHOLDER.ENTITY\' | translate}}\" ng-model=\"userValues.typeRepartition\" \nname=\"repartition\" ng-change=\"checkTypeRepartition()\" flex=\"33\"><md-option ng-repeat=\"type in typesRepartition\" \nng-value=\"type.value\">{{type.name}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"userValues.typeRepartition === \'COMPANY_MODEL\'\"><md-select \nplaceholder=\"{{\'STATISTICS.REPARTITION.PLACEHOLDER.TYPE\' | translate}}\" ng-model=\"userValues.typeCompany\" \nname=\"typeCompany\" ng-change=\"checkTypeCompany()\" flex=\"33\"><md-option ng-repeat=\"type in data.typesCompany\" \nng-value=\"type.id\">{{type.name}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"userValues.typeRepartition === \'CONTACT_MODEL\'\"><md-select \nplaceholder=\"{{\'STATISTICS.REPARTITION.PLACEHOLDER.TYPE\' | translate}}\" ng-model=\"userValues.typeCompanyContact\" \nname=\"typeCompanyContact\" ng-change=\"checkField()\" flex=\"33\"><md-option ng-value=\"null\">\n{{\"STATISTICS.AUTOMATIC.ALL\" | translate}}</md-option><md-option ng-repeat=\"type in data.typesCompany\" \nng-value=\"type.id\">{{type.name}}</md-option></md-select></md-input-container><md-input-container \nng-if=\"(userValues.typeRepartition === \'CONTACT_MODEL\' || (userValues.typeRepartition === \'COMPANY_MODEL\' && userValues.typeCompany !== null)) && data.fields.length > 0\">\n<md-select placeholder=\"{{\'STATISTICS.REPARTITION.PLACEHOLDER.CRITERIA\' | translate}}\" ng-model=\"userValues.field\" \nname=\"field\" ng-change=\"checkField()\" flex=\"33\"><md-option ng-repeat=\"field in data.fields\" ng-value=\"field.id\">\n{{field.libelle}}</md-option></md-select></md-input-container></div><canvas ng-if=\"!displayChartSubTypes\" id=\"pie\" \nclass=\"chart chart-pie mt-30\" chart-data=\"chart.data\" chart-labels=\"chart.labels\" chart-options=\"chart.options\">\n</canvas><div ng-if=\"displayChartSubTypes\"><canvas id=\"pieCompanies\" class=\"chart chart-pie mt-30\" \nchart-data=\"chart.dataSubTypes.companies\" chart-labels=\"chart.labelsSubTypes\" chart-options=\"chart.optionsCompanies\">\n</canvas><canvas id=\"pieContacts\" class=\"chart chart-pie mt-30\" chart-data=\"chart.dataSubTypes.contacts\" \nchart-labels=\"chart.labelsSubTypes\" chart-options=\"chart.optionsContacts\"></canvas></div></div></div>");
$templateCache.put("app/main/statistics/reporting/reportingStatistics.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"STATISTICS.REPORTING.TITLE\"></div></div></div><div class=\"content\"><div \nclass=\"nl-Block nl-Block--form\"><div layout=\"row\" layout-align=\"start stretch\" layout-wrap><md-input-container \nclass=\"nl-Block--inputContainer\" flex=\"100\"><label>{{\'STATISTICS.REPORTING.GROUP\' | translate}}</label><md-select \nmd-on-open=\"\" md-on-close=\"filterSelectText = \'\'\" ng-model=\"filter.groupIDs\" aria-label=\"language\" name=\"receiver\" \nmultiple=\"multiple\" ng-change=\"getUsersByGroups()\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"group in groups | filterText: filterSelectText\" value=\"{{group.id}}\">{{group.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"nl-Block--inputContainer\" flex=\"100\"><md-chips \nclass=\"nl-chips nl-chips__floating nl-chips--form\" ng-model=\"filter.userIDs\" name=\"users\" \nmd-on-add=\"addField($chip, filter.userIDs)\"><md-autocomplete \nmd-floating-label=\"{{\'STATISTICS.REPORTING.USER\' | translate}}\" md-no-cache=\"true\" md-search-text=\"searchUser\" \nmd-select-on-match=\"true\" md-autoselect=\"false\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-items=\"user in usersSelected(users, filter.userIDs)| orderBy: \'fullName\' |filter: {fullName: searchUser}\" \nmd-item-text=\"user.fullName\" md-min-length=\"0\"><span>{{user.fullName}}</span></md-autocomplete><md-chip-template><span>\n{{$chip.fullName}}</span></md-chip-template></md-chips></md-input-container><md-input-container \nclass=\"nl-Block--inputContainer\" flex=\"100\"><label>{{\'STATISTICS.REPORTING.ACTION\' | translate}}</label><md-select \nmd-on-open=\"\" md-on-close=\"filterSelectText2 = \'\'\" ng-model=\"filter.actionIDs\" aria-label=\"language\" name=\"receiver\" \nmultiple=\"multiple\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText2\"></section></md-select-header><md-option \nng-repeat=\"action in actions | filterText: filterSelectText2\" value=\"{{action.id}}\">{{action.libelle}}</md-option>\n</md-select></md-input-container><md-input-container flex=\"10\" flex-xs=\"100\" class=\"nl-Block--inputContainer\">\n<md-select flex ng-model=\"year.value\" ng-if=\"!customPeriod\"><md-select-header><input type=\"number\" min=\"0\" step=\"1\" \nng-model=\"customPeriods.filter\" onkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button \nng-click=\"searchStatisticsCustomYear(false)\" class=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button></md-select-header>\n<md-option value=\"all\">{{\"STATISTICS.AUTOMATIC.ALL\" | translate}}</md-option><md-option ng-value=\"year\" \nng-repeat=\"year in yearValues\">{{year}}</md-option><md-option value=\"custom\" style=\"display: none\">\n{{customPeriods.filter}}</md-option></md-select></md-input-container><md-input-container class=\"ml-20\" flex=\"80\">\n<md-checkbox class=\"md-primary md-hue-2\" name=\"\" ng-model=\"customPeriod\" aria-label=\"custom period\">\n{{\"STATISTICS.AUTOMATIC.CUSTOM_PERIOD\"|translate}}</md-checkbox></md-input-container><div ng-if=\"!!customPeriod\" \nclass=\"nl_categories-item-subtitle\" layout=\"row\" layout-align=\"space-between center\" flex=\"100\">\n{{\'STATISTICS.DISPLAY.RESULT_BETWEEN\' | translate}}</div><div layout=\"row\" ng-if=\"!!customPeriod\" flex=\"100\">\n<md-input-container class=\"mb-0\" flex=\"50\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" \nmd-hide-icons=\"calendar\" ng-model=\"customFilter.begin.date\" name=\"articleStartDate\" \nmd-placeholder=\"{{\'STATISTICS.REPORTING.START_DATE\' | translate}}\" md-open-on-focus required=\"\"></md-datepicker><div \nclass=\"pl-20\" ng-messages=\"formCreateArticle.articleStartDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"mb-0\" flex=\"50\">\n<md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-hide-icons=\"calendar\" ng-model=\"customFilter.end.date\" \nname=\"articleStartDate\" md-placeholder=\"{{\'STATISTICS.REPORTING.END_DATE\' | translate}}\" md-open-on-focus required=\"\">\n</md-datepicker><div class=\"pl-20\" ng-messages=\"formCreateArticle.articleStartDate.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div></div><div \nlayout=\"row\"><md-button flex=\"80\" type=\"button\" ng-click=\"getStatisticsReporting()\" \nclass=\"md-raised md-primary md-hue-2\">{{\'COMPANIES.FILTER\' | translate}}</md-button><md-button flex=\"20\" type=\"button\" \nng-click=\"downloadStatisticsReporting()\" class=\"md-raised md-primary md-hue-2\">{{\'GENERAL.DOWNLOAD\' | translate}}\n</md-button></div></div><div class=\"layout-align-space-around-stretch layout-row m-20 p-20\" ng-if=\"inProgress\">\n<md-progress-circular class=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" \nmd-mode=\"indeterminate\"></md-progress-circular></div><div class=\"mt-30\" \nng-if=\"stats.length > 0 && !displayCustomPeriod\"><h3 class=\"nl-Block-title\">\n{{\'STATISTICS.REPORTING.NBR_ACTIONS\' | translate}}</h3><table \nclass=\"nl-Table nl-table-nobg nl-Table-doublebody pure-table pure-table-bordered\"><thead><tr><th width=\"20%\"></th><th \nng-repeat=\"month in monthNames\"><span layout=\"row\" layout-align=\"center center\" class=\"text-uppercase font-size-12\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</span></th></tr></thead><tbody ng-repeat=\"group in stats\"><tr \nclass=\"nl-Table-group\"><td colspan=\"13\"><span layout=\"row\" layout-align=\"start center\">{{group.groupLibelle}}</span>\n</td></tr><tr ng-repeat-start=\"statJSON in group.statsJSON\"><td>{{statJSON.actionName}}</td><td \nng-repeat=\"month in monthNames\"><span layout=\"row\" layout-align=\"center center\">{{statJSON.months[$index]}}</span></td>\n</tr><tr ng-repeat-end><td>{{statJSON.actionName}}{{\'STATISTICS.REPORTING.ACCRUED\' | translate}}</td><td \nng-repeat=\"month in monthNames\"><span layout=\"row\" layout-align=\"center center\">{{statJSON.monthsAccrued[$index]}}\n</span></td></tr></tbody></table></div><div class=\"mt-30\" ng-if=\"stats.length > 0 && displayCustomPeriod\"><h3 \nclass=\"nl-Block-title\">{{\'STATISTICS.REPORTING.NBR_ACTIONS\' | translate}}</h3><table \nclass=\"nl-Table nl-table-nobg nl-Table-doublebody pure-table pure-table-bordered\"><thead><tr><th></th><th \nclass=\"text-uppercase font-size-12\"><span layout=\"row\" layout-align=\"center center\">\n{{\'STATISTICS.REPORTING.NBR_ACTIONS\' | translate}}</span></th></tr></thead><tbody ng-repeat=\"group in stats\"><tr \nclass=\"nl-Table-group\"><td colspan=\"2\"><span layout=\"row\" layout-align=\"start center\">{{group.groupLibelle}}</span>\n</td></tr><tr ng-repeat=\"stat in group.statsJSON\"><td>{{stat.actionName}}</td><td><span layout=\"row\" \nlayout-align=\"center center\">{{stat.value}}</span></td></tr></tbody></table></div><div class=\"mt-30\" \nng-if=\"messagesArray.length > 0\"><h3 class=\"nl-Block-title\">{{\'STATISTICS.REPORTING.MESSAGES\' | translate}}</h3><table \nclass=\"nl-Table nl-table-nobg nl-Table-doublebody pure-table pure-table-bordered\" style=\"table-layout: auto\"><thead>\n<tr><th width=\"50%\">{{\'STATISTICS.REPORTING.ROWS.ACTION\' | translate}}</th><th width=\"30%\">\n{{\'STATISTICS.REPORTING.ROWS.ENTITY\' | translate}}</th><th>{{\'STATISTICS.REPORTING.ROWS.SENDER\' | translate}}</th></tr>\n</thead><tbody ng-repeat=\"group in messagesArray\"><tr class=\"nl-Table-group\"><td colspan=\"6\"><div layout=\"row\"><img \nng-if=\"group.user.pictureLocation != null\" src=\"./alternatedocroots/{{group.user.pictureLocation}}\" alt=\"\" \nclass=\"nl-Table-avatar\"> <span layout=\"row\" layout-align=\"center center\">{{group.user.fullName}}</span></div></td></tr>\n<tr ng-repeat=\"msg in group.msgs | orderBy: \'creationDate\': true\"><td><div ng-if=\"msg.action\" layout=\"row\" \nlayout-align=\"start center\"><div><div class=\"nl-Table-MsgTitle\">{{msg.subject}}</div><div \nclass=\"layout-row layout-align-start-center\"><div class=\"nl-Msg-check\" \nng-class=\"{\'nl-validated\': msg.action.actionDone}\" ng-click=\"confirmAction(msg.action)\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !msg.action.actionDone, \'icon-check\' : msg.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{msg.action.libelle}}</div><div>\n{{\'STATISTICS.REPORTING.ROWS.DEADLINE\' | translate}} : {{getDate(msg.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(msg.action.dateAction) | date:\'HH:mm\'}}\n</div></div></div></div></div></td><td><div class=\"nl-Msg-link-company\" ng-if=\"msg.company\"><div \ntranslate=\"GENERAL.COMPANY\"></div><a href=\"/companies/{{msg.company.subTypesIds[0]}}/{{msg.company.id}}\"><b>\n{{msg.company.modelPattern}}</b></a></div><div class=\"nl-Msg-link-contact\" ng-if=\"msg.contact\"><div \ntranslate=\"GENERAL.CONTACT\"></div><a \nhref=\"/companies/{{msg.contact.companySubTypesIds[0]}}/{{msg.contact.companyId}}/contact/{{msg.contact.id}}\"><b>\n{{msg.contact.modelPattern}}</b></a></div><div ng-repeat=\"field in msg.contact.valuedFields | orderBy: \'index\'\" \nng-if=\"field.index != null && field.value\" class=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon \nmd-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in msg.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></td><td><div layout=\"row\" layout-align=\"start center\"><img \nng-if=\"msg.sender.pictureLocation != null\" src=\"./alternatedocroots/{{msg.sender.pictureLocation}}\" alt=\"\" \nclass=\"nl-Table-avatar\"><div><div>{{msg.creationDate | date: \'dd/MM/yyyy à HH:mm\'}}</div><div><span \nclass=\"nl-Badge nl-Badge--tag\">{{msg.sender.fullName}}</span></div></div></div></td></tr></tbody></table></div></div>\n</div>");
$templateCache.put("app/main/tourist_attractions/add/add_tourist_attraction.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><span ng-if=\"tourist.id == null\" translate=\"TOURIST.ADD.TITLE\"></span> <span ng-if=\"tourist.id != null\" \ntranslate=\"TOURIST.UPDATE.TITLE\"></span></div><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\"></md-icon>\n</md-button><div layout=\"row\" layout-align=\"end center\" hide show-gt-sm><md-input-container flex><md-select \nng-change=\"langageChanged()\" ng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\">\n<md-option ng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}\n</md-option></md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container flex><md-select \nclass=\"nl-Form--select nl-Form--select__bright\" ng-change=\"langageChanged()\" ng-model=\"language.key\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div></div><div class=\"content\"><div class=\"nl-Block\"><form \nname=\"addTouristForm\" class=\"nl-Form-xs\" ng-submit=\"addTouristForm.$valid && add()\"><md-input-container><label>\n{{\"TOURIST.COLUMNS.NAME\" | translate}}</label><input type=\"text\" ng-model=\"tourist.name\" name=\"name\" required><div \nng-messages=\"addTouristForm.name.$error\" role=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container><label>{{\"TOURIST.COLUMNS.COORDINATES\" | translate}}</label>\n<input type=\"text\" ng-model=\"tourist.coordinates\" name=\"coordinates\"></md-input-container><md-input-container><label>\n{{\"TOURIST.COLUMNS.CITY\" | translate}}</label><md-select ng-model=\"tourist.city\" \nng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"region\" name=\"region\" required><md-option \nng-repeat=\"city in cities track by city.id\" ng-value=\"city\">{{city.value}}</md-option></md-select><div \nng-messages=\"addTouristForm.duration.$error\" role=\"alert\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container class=\"nl-Input-container\">\n<label>{{\"TOURIST.COLUMNS.REGION\" | translate}}</label><md-select ng-model=\"tourist.region\" \nng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"region\" name=\"region\" required><md-option \nng-repeat=\"region in regions track by region.id\" ng-value=\"region\">{{region.value}}</md-option></md-select><div \nng-messages=\"addTouristForm.region.$error\" role=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><br><md-input-container class=\"nl-Input-container\"><label>\n{{\"TOURIST.COLUMNS.TYPE\" | translate}}</label><md-select multiple=\"multiple\" ng-model=\"tourist.typeTourisme\" \nng-model-options=\"{trackBy: \'$value.id\'}\" aria-label=\"tourism\" name=\"tourism\" required><md-option \nng-repeat=\"tourism in tourisms track by tourism.id\" ng-value=\"tourism\">{{tourism.value}}</md-option></md-select><div \nng-messages=\"addTouristForm.tourism.$error\" role=\"alert\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><div class=\"nl_Trix\"><label class=\"nl_Trix-label\">Description</label><ng-quill-editor\n ng-model=\"tourist.description\"></ng-quill-editor></div><div ng-if=\"updateMode\" class=\"mv-20\"><div layout=\"row\" \nlayout-wrap><div class=\"m-5 nl-Form-dropify\" flex=\"15\" \nng-repeat=\"photo in tourist.photos | orderBy: \'docNumber\' track by $index\" layout=\"column\" layout-align=\"start end\">\n<div class=\"nl-Form-dropify-wrapper\"><img class=\"nl-Form-dropify has--image\" \nng-src=\"alternatedocroots/{{photo.location}}\"></div><md-button class=\"md-raised md-warn md-hue-2\" \nng-click=\"displayPopUpDeletePhoto(photo, $index)\"><md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon>\n{{\"GENERAL.DELETE\" | translate}}</md-button></div></div></div><div class=\"mv-20\"><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"photos.push({})\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\"TOURIST.ADD.ADD_PHOTO\" | translate}}</md-button><div layout=\"row\" layout-wrap><div class=\"m-5 nl-Form-dropify\" \nflex=\"nogrow\" ng-repeat=\"photo in photos\" layout=\"column\" layout-align=\"start end\"><dropify-directive \nclass=\"dropify-wrapper has--deleteBtn\" id=\"tourist_photo_{{$index}}\" filesave=\"photo.uploadFile\" \nng-model=\"photo.model\"><md-button type=\"button\" class=\"md-raised md-warn md-hue-2\" ng-click=\"deletePhoto($index)\">\n<md-icon md-font-icon=\"icon-close-circle-outline\"></md-icon>{{\"TOURIST.ADD.DELETE_PHOTO\" | translate}}</md-button>\n</div></div></div><md-button type=\"submit\" md-no-ink class=\"md-primary md-raised md-hue-2\" translate=\"GENERAL.SAVE\">\n</md-button></form></div></div></div>");
$templateCache.put("app/main/tourist_attractions/popup/delete_photo.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">\n{{\"TOURIST.POPUP_DELETE_PHOTO.TITLE\" | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div class=\"nl-Popup-content-body\"><div class=\"nl-Popup-content-body-title\">\n{{\"TOURIST.POPUP_DELETE_PHOTO.MESSAGE\" | translate}}</div><br><img \nng-src=\"alternatedocroots/{{photoToDelete.location}}\"></div></md-dialog-content><md-dialog-actions layout=\"row\">\n<md-button md-no-ink class=\"md-primary md-hue-2 md-raised\" ng-click=\"deletePhotoPermanentely()\" \ntranslate=\"GENERAL.YES\"></md-button><md-button class=\"md-warn md-hue-2\" ng-click=\"hidePopup()\" translate=\"GENERAL.NO\">\n</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n    <div class=\"ms-navigation-button nl-Nav-item\" ng-if=\"!node.uisref && node.title\">\n      <i class=\"icon s16 nl-Nav-icon {{node.icon}}\" ng-if=\"node.icon\"></i>\n      <span class=\"title nl-Nav-item-title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n      <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n      <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n    </div>\n\n    <a class=\"ms-navigation-button nl-Nav-item\"  ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\" ng-if=\"node.uisref && node.title\">\n      <i class=\"icon nl-Nav-icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n      <span class=\"title nl-Nav-item-title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n      <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n      <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n    </a>\n\n  </div>\n\n  <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n    <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\" ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n      ng-include=\"\'navigation-nested.html\'\"></li>\n  </ul>\n</script>");
$templateCache.put("app/main/access_rights/associations/popup/add_association.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"newAssociationForm\" class=\"md-inline-form\" novalidate \nng-submit=\"newAssociationForm.$valid && save(newAssociationForm)\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div>\n<div layout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'ASSOCIATIONS.NEW\' | translate}}</div>\n</div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap>\n<div class=\"nl-info-block-list-img animated fadeIn\" flex=\"30\"><dropify-directive id=\"add_association_dropify\" \nfilesave=\"photo.uploadFile\" name=\"logo\" ng-model=\"newAssociation\" required><div ng-if=\"missingFile\" \nclass=\"md-input-messages-animation ng-active\" aria-live=\"assertive\"><span \nclass=\"md-input-message-animation ng-binding ng-scope\" \nstyle=\"opacity: 1; margin-top: 0px;color: rgb(213,0,0);font-size: 12px;line-height: 14px\" translate=\"GENERAL.REQUIRED\">\n</span></div></div><div flex=\"70\" class=\"\" layout=\"column\"><md-input-container class=\"nl-Input-container ml-15\" \nflex=\"100\"><input type=\"text\" class=\"\" ng-model=\"newAssociation.name\" name=\"name\" required maxlength=\"255\"><label \nclass=\"\" translate=\"ASSOCIATIONS.NAME\"></label><div ng-messages=\"newAssociationForm.name.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><md-select ng-model=\"newAssociation.admin\" name=\"admin\" required><md-option\n ng-repeat=\"user in users | orderBy: \'fullName\' track by user.id\" ng-value=\"user\">{{user.fullName}}</md-option>\n</md-select><label class=\"\" translate=\"ASSOCIATIONS.ADMIN\"></label><div ng-messages=\"newAssociationForm.admin.$error\">\n<span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 md-raised\" ng-disabled=\"newAssociationForm.$invalid\" aria-label=\"Sauvegarder\" \ntranslate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/access_rights/associations/popup/edit_association.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"editAssociationForm\" class=\"md-inline-form\" novalidate \nng-submit=\"editAssociationForm.$valid && update(editAssociationForm)\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'ASSOCIATIONS.UPDATE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap><div class=\"nl-info-block-list-img animated fadeIn\" \nflex=\"30\"><dropify-directive id=\"edit_association_dropify\" filesave=\"photo.uploadFile\" name=\"logo\" \nng-model=\"association\" required></div><div flex=\"70\" class=\"\" layout=\"column\"><div flex=\"100\" class=\"ml-15\" \nng-if=\"associationUrl != null\">URL de login de l\'association : {{associationUrl}}</div><md-input-container \nclass=\"nl-Input-container ml-15\" flex=\"100\"><input type=\"text\" class=\"\" ng-model=\"association.name\" name=\"name\" \nmaxlength=\"255\" required><label class=\"\" translate=\"ASSOCIATIONS.NAME\"></label><div \nng-messages=\"editAssociationForm.name.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span>\n</div></md-input-container><md-input-container class=\"nl-Input-container ml-15\" flex=\"100\"><md-select \nng-model=\"association.admin\" name=\"admin\" ng-model-options=\"{trackBy: \'$value.id\'}\" required><md-option \nng-repeat=\"user in users | orderBy: \'fullName\' track by user.id\" ng-value=\"user\">{{user.fullName}}</md-option>\n</md-select><label class=\"\" translate=\"ASSOCIATIONS.ADMIN\"></label><div ng-messages=\"editAssociationForm.admin.$error\">\n<span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div></div>\n</md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 submit-button md-raised\" ng-disabled=\"editAssociationForm.$invalid\" \naria-label=\"Sauvegarder\" translate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/access_rights/groups/popup/add_group.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"newGroupForm\" class=\"md-inline-form\" novalidate ng-submit=\"newGroupForm.$valid && save(newGroupForm)\"><md-toolbar\n class=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'GROUPS.NEW\' | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"row\" layout-wrap><h3 translate=\"GROUPS.PARAMS\" flex=\"100\"></h3><md-input-container \nclass=\"nl-Input-container\" flex=\"70\"><input type=\"text\" class=\"\" ng-model=\"newGroup.name\" name=\"name\" required><label \nclass=\"\" translate=\"GROUPS.NAME\"></label><div ng-messages=\"newGroupForm.name.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container class=\"nl-Input-container\" \nflex=\"30\"><input type=\"number\" step=\"1\" class=\"\" ng-model=\"newGroup.index\" name=\"index\" required><label class=\"\" \ntranslate=\"GROUPS.INDEX\"></label><div ng-messages=\"newGroupForm.index.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"nl-Input-container\" flex=\"30\"><md-switch class=\"md-primary\" \nng-model=\"newGroup.allEvents\" ng-change=\"allEventsChanged()\" name=\"allEvents\">{{\'ROLES.ALL_EVENTS\' | translate}}\n</md-switch></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"70\"><md-select class=\"\" \nng-model=\"newGroup.eventIds\" name=\"eventIds\" ng-disabled=\"newGroup.allEvents\" multiple=\"multiple\"><md-option \nng-repeat=\"event in events | orderBy: \'name\' track by event.id\" ng-value=\"event.id\">{{event.name}}</md-option>\n</md-select><label class=\"\" translate=\"ROLES.EVENTS\"></label></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"nl-Input-container\" flex=\"30\"><md-switch class=\"md-primary\" \nng-model=\"newGroup.allCompanySubTypes\" ng-change=\"allSubTypesChanged()\" name=\"allCompanySubTypes\">\n{{\'ROLES.ALL_COMPANY_SUBTYPES\' | translate}}</md-switch></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex=\"70\"><md-select class=\"\" ng-model=\"newGroup.subTypeIds\" name=\"subTypeIds\" \nmultiple=\"multiple\" ng-disabled=\"newGroup.allCompanySubTypes\"><md-option \nng-repeat=\"companySubType in companySubTypes | orderBy: \'name\' track by companySubType.id\" \nng-value=\"companySubType.id\">{{companySubType.name}}</md-option></md-select><label class=\"\" \ntranslate=\"ROLES.COMPANY_SUBTYPES\"></label></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"nl-Input-container\" flex=\"100\"><md-chips class=\"nl-chips nl-chips__floating\" ng-model=\"newGroup.roles\" \nname=\"rights\" md-on-add=\"addField($chip, newGroup.roles)\"><md-autocomplete md-search-text=\"search\" \nmd-select-on-match=\"true\" md-autoselect=\"false\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'USERS.RIGHTS\' | translate}}\" \nmd-items=\"right in fieldsSelected(roles, newGroup.roles) | orderBy: orderByCustom | filter: {nameTranslated: search}\" \nmd-item-text=\"right.nameTranslated\" md-min-length=\"0\" style=\"width: 700px\"><span>{{right.nameTranslated}}</span>\n</md-autocomplete><md-chip-template><span>{{$chip.nameTranslated}}</span></md-chip-template></md-chips>\n</md-input-container></div></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button \ntype=\"submit\" class=\"md-primary md-hue-2 submit-button md-raised\" ng-disabled=\"newGroupForm.$invalid\" \naria-label=\"Sauvegarder\" translate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/access_rights/groups/popup/edit_group.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"editGroupForm\" class=\"md-inline-form\" novalidate ng-submit=\"editGroupForm.$valid && update(editGroupForm)\">\n<md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"row\" layout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'GROUPS.UPDATE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap><h3 translate=\"GROUPS.PARAMS\" flex=\"100\"></h3>\n<md-input-container class=\"nl-Input-container\" flex=\"70\"><input type=\"text\" class=\"\" ng-model=\"group.name\" name=\"name\" \nrequired><label class=\"\" translate=\"GROUPS.NAME\"></label><div ng-messages=\"editGroupForm.name.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex=\"30\"><input type=\"number\" step=\"1\" class=\"\" ng-model=\"group.index\" name=\"index\" \nrequired><label class=\"\" translate=\"GROUPS.INDEX\"></label><div ng-messages=\"editGroupForm.index.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"nl-Input-container\" flex=\"30\"><md-switch class=\"md-primary\" \nng-model=\"group.allEvents\" ng-change=\"allEventsChanged()\" name=\"allEvents\">{{\'ROLES.ALL_EVENTS\' | translate}}\n</md-switch></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"70\"><md-select class=\"\" \nng-model=\"group.eventIds\" name=\"eventIds\" ng-disabled=\"group.allEvents\" multiple=\"multiple\"><md-option \nng-repeat=\"event in events | orderBy: \'name\' track by event.id\" ng-value=\"event.id\">{{event.name}}</md-option>\n</md-select><label class=\"\" translate=\"ROLES.EVENTS\"></label></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"nl-Input-container\" flex=\"30\"><md-switch class=\"md-primary\" \nng-model=\"group.allCompanySubTypes\" ng-change=\"allSubTypesChanged()\" name=\"allCompanySubTypes\">\n{{\'ROLES.ALL_COMPANY_SUBTYPES\' | translate}}</md-switch></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex=\"70\"><md-select class=\"\" ng-model=\"group.subTypeIds\" name=\"subTypeIds\" \nmultiple=\"multiple\" ng-disabled=\"group.allCompanySubTypes\"><md-option \nng-repeat=\"companySubType in companySubTypes | orderBy: \'name\' track by companySubType.id\" \nng-value=\"companySubType.id\">{{companySubType.name}}</md-option></md-select><label class=\"\" \ntranslate=\"ROLES.COMPANY_SUBTYPES\"></label></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"nl-Input-container\" flex=\"100\"><md-chips class=\"nl-chips nl-chips__floating\" ng-model=\"group.roles\" \nname=\"rights\" md-on-add=\"addField($chip, group.roles)\"><md-autocomplete md-search-text=\"search\" \nmd-select-on-match=\"true\" md-autoselect=\"false\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'USERS.RIGHTS\' | translate}}\" \nmd-items=\"right in fieldsSelected(roles, group.roles) | orderBy: orderByCustom | filter: {nameTranslated: search}\" \nmd-item-text=\"right.nameTranslated\" md-min-length=\"0\" style=\"width: 700px\"><span>{{right.nameTranslated}}</span>\n</md-autocomplete><md-chip-template><span>{{$chip.nameTranslated}}</span></md-chip-template></md-chips>\n</md-input-container></div></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button \ntype=\"submit\" class=\"md-primary md-hue-2 submit-button md-raised\" ng-disabled=\"editGroupForm.$invalid\" \naria-label=\"Sauvegarder\" translate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/access_rights/users/popup/add_user.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form name=\"newUserForm\" \nclass=\"md-inline-form\" novalidate ng-submit=\"newUserForm.$valid && saveUser(newUserForm)\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'USERS.NEW\' | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content><div layout=\"row\" layout-align=\"start center\" layout-wrap><h3 translate=\"USERS.CONNECTION\" \nflex=\"100\"></h3><md-input-container class=\"nl-Input-container mb-0 mt-10\" flex=\"50\"><input type=\"text\" class=\"\" \nng-model=\"newUser.login\" name=\"login\" required><label class=\"\" translate=\"USERS.ID\"></label><div \nng-messages=\"newUserForm.login.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container mb-0 mt-10\" flex=\"50\"><input type=\"password\" \nclass=\"\" ng-model=\"newUser.password\" name=\"password\" required><label class=\"\" translate=\"USERS.PASSWORD\"></label><div \nng-messages=\"newUserForm.login.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\" layout-wrap ng-if=\"!company\">\n<md-input-container class=\"nl-Input-container mb-0 mt-0\" flex=\"100\"><md-select class=\"\" ng-model=\"newUser.groups\" \nname=\"groups\" ng-model-options=\"{trackBy: \'$value.id\'}\" multiple=\"multiple\"><md-option \nng-repeat=\"group in groups | orderBy: \'name\' track by group.id\" ng-value=\"group\">{{group.name}}</md-option></md-select>\n<label class=\"\" translate=\"USERS.GROUPS\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container mb-0 mt-0\" flex=\"100\"><md-chips class=\"nl-chips nl-chips__floating\" \nng-model=\"newUser.rights\" name=\"rights\" md-on-add=\"addField($chip, newUser.rights)\"><md-autocomplete \nmd-search-text=\"search\" md-select-on-match=\"true\" md-autoselect=\"false\" md-match-case-insensitive=\"true\" \nmd-no-cache=\"true\" md-floating-label=\"{{\'USERS.RIGHTS\' | translate}}\" \nmd-items=\"right in fieldsSelected(roles, newUser.rights) | orderBy: orderByCustom | filter: {nameTranslated: search}\" \nmd-item-text=\"right.nameTranslated\" md-min-length=\"0\" style=\"width: 700px\"><span>{{right.nameTranslated}}</span>\n</md-autocomplete><md-chip-template><span>{{$chip.nameTranslated}}</span></md-chip-template></md-chips>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\" ng-if=\"!company\"><md-input-container \nclass=\"nl-Input-container mb-0 mt-0\" flex=\"30\"><md-switch class=\"md-primary\" ng-model=\"newUser.allEvents\" \nng-change=\"allEventsChanged()\" name=\"allEvents\">{{\'ROLES.ALL_EVENTS\' | translate}}</md-switch></md-input-container>\n<md-input-container class=\"nl-Input-container mb-0 mt-0\" flex=\"70\"><md-select class=\"\" ng-model=\"newUser.eventIds\" \nname=\"eventIds\" ng-disabled=\"newUser.allEvents\" multiple=\"multiple\"><md-option \nng-repeat=\"event in events | orderBy: \'name\' track by event.id\" ng-value=\"event.id\">{{event.name}}</md-option>\n</md-select><label class=\"\" translate=\"ROLES.EVENTS\"></label></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!company\"><md-input-container class=\"nl-Input-container mb-0 mt-0\" flex=\"30\">\n<md-switch class=\"md-primary\" ng-model=\"newUser.allCompanySubTypes\" ng-change=\"allSubTypesChanged()\" \nname=\"allCompanySubTypes\">{{\'ROLES.ALL_COMPANY_SUBTYPES\' | translate}}</md-switch></md-input-container>\n<md-input-container class=\"nl-Input-container mb-0 mt-0\" flex=\"70\"><md-select class=\"\" ng-model=\"newUser.subTypeIds\" \nname=\"subTypeIds\" multiple=\"multiple\" ng-disabled=\"newUser.allCompanySubTypes\"><md-option \nng-repeat=\"companySubType in companySubTypes | orderBy: \'name\' track by companySubType.id\" \nng-value=\"companySubType.id\">{{companySubType.name}}</md-option></md-select><label class=\"\" \ntranslate=\"ROLES.COMPANY_SUBTYPES\"></label></md-input-container></div><div layout=\"row\" layout-wrap><h3 \ntranslate=\"USERS.PROFILE\" flex=\"100\"></h3><div class=\"nl-info-block-list-img animated fadeIn\" flex=\"30\">\n<dropify-directive id=\"add_user_dropify\" filesave=\"photo.uploadFile\" ng-model=\"newUser\"></div><div flex=\"70\" class=\"\" \nlayout=\"column\"><md-input-container class=\"nl-Input-container ml-15 mb-0 mt-0\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"newUser.fullName\" name=\"fullname\" required><label class=\"\" translate=\"USERS.NAME\"></label><div \nng-messages=\"newUserForm.fullname.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15 mb-0 mt-0\" flex=\"100\"><input type=\"email\" \nclass=\"\" ng-model=\"newUser.mail\" name=\"mail\" required><label class=\"\" translate=\"USERS.EMAIL\"></label><div \nng-messages=\"newUserForm.mail.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span> <span \nng-message=\"email\">{{\'GENERAL.PATTERN\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-15 mb-0 mt-0\" flex=\"100\"><md-switch class=\"md-primary\" ng-model=\"newUser.activated\" \nname=\"activated\">{{\'USERS.ACTIVE\' | translate}}</md-switch></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 submit-button md-raised\" aria-label=\"Sauvegarder\" translate=\"GENERAL.SAVE\"></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/access_rights/users/popup/edit_user.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"editUserForm\" class=\"md-inline-form\" novalidate ng-submit=\"editUserForm.$valid && update(editUserForm)\">\n<md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"row\" layout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'USERS.UPDATE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div layout=\"row\" layout-wrap><h3 translate=\"USERS.CONNECTION\" flex=\"100\"></h3>\n<md-input-container class=\"nl-Input-container mb-0 mt-0\" flex=\"50\"><input type=\"text\" class=\"\" ng-model=\"user.login\" \nname=\"login\" required><label class=\"\" translate=\"USERS.ID\"></label><div ng-messages=\"editUserForm.login.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container mb-0 mt-0\" flex=\"50\"><input type=\"password\" class=\"\" ng-model=\"user.password\" \nname=\"password\"><label class=\"\" translate=\"USERS.PASSWORD\"></label></md-input-container></div><div layout=\"row\" \nlayout-wrap layout-align=\"start center\"><md-input-container class=\"nl-Input-container mb-0 mt-0\" flex=\"100\"><md-select \nclass=\"\" ng-model=\"user.groups\" ng-model-options=\"{trackBy: \'$value.id\'}\" name=\"groups\" multiple=\"multiple\"><md-option \nng-repeat=\"group in groups | orderBy: \'name\' track by group.id\" ng-value=\"group\">{{group.name}}</md-option></md-select>\n<label class=\"\" translate=\"USERS.GROUPS\"></label></md-input-container><md-input-container \nclass=\"nl-Input-container mb-0 mt-0\" flex=\"100\"><md-chips class=\"nl-chips nl-chips__floating\" ng-model=\"user.rights\" \nname=\"rights\" md-on-add=\"addField($chip, user.rights)\"><md-autocomplete md-search-text=\"search\" \nmd-select-on-match=\"true\" md-autoselect=\"false\" md-match-case-insensitive=\"true\" md-no-cache=\"true\" \nmd-floating-label=\"{{\'USERS.RIGHTS\' | translate}}\" \nmd-items=\"right in fieldsSelected(roles, user.rights) | orderBy: orderByCustom | filter: {nameTranslated: search}\" \nmd-item-text=\"right.nameTranslated\" md-min-length=\"0\" style=\"width: 700px\"><span>{{right.nameTranslated}}</span>\n</md-autocomplete><md-chip-template><span>{{$chip.nameTranslated}}</span></md-chip-template></md-chips>\n</md-input-container></div><div layout=\"row\" layout-align=\"start center\"><md-input-container \nclass=\"nl-Input-container mb-0 mt-0\" flex=\"30\"><md-switch class=\"md-primary\" ng-model=\"user.allEvents\" \nng-change=\"allEventsChanged()\" name=\"allEvents\">{{\'ROLES.ALL_EVENTS\' | translate}}</md-switch></md-input-container>\n<md-input-container class=\"nl-Input-container mb-0 mt-0\" flex=\"70\"><md-select class=\"\" ng-model=\"user.eventIds\" \nname=\"eventIds\" ng-disabled=\"user.allEvents\" multiple=\"multiple\"><md-option \nng-repeat=\"event in events | orderBy: \'name\' track by event.id\" ng-value=\"event.id\">{{event.name}}</md-option>\n</md-select><label class=\"\" translate=\"ROLES.EVENTS\"></label></md-input-container></div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container class=\"nl-Input-container mb-0 mt-0\" flex=\"30\"><md-switch \nclass=\"md-primary\" ng-model=\"user.allCompanySubTypes\" ng-change=\"allSubTypesChanged()\" name=\"allCompanySubTypes\">\n{{\'ROLES.ALL_COMPANY_SUBTYPES\' | translate}}</md-switch></md-input-container><md-input-container \nclass=\"nl-Input-container mb-0 mt-0\" flex=\"70\"><md-select class=\"\" ng-model=\"user.subTypeIds\" name=\"subTypeIds\" \nmultiple=\"multiple\" ng-disabled=\"user.allCompanySubTypes\"><md-option \nng-repeat=\"companySubType in companySubTypes | orderBy: \'name\' track by companySubType.id\" \nng-value=\"companySubType.id\">{{companySubType.name}}</md-option></md-select><label class=\"\" \ntranslate=\"ROLES.COMPANY_SUBTYPES\"></label></md-input-container></div><div layout=\"row\" layout-wrap><h3 \ntranslate=\"USERS.PROFILE\" flex=\"100\"></h3><div class=\"nl-info-block-list-img animated fadeIn mt-0 mb-0\" flex=\"30\">\n<dropify-directive id=\"edit_user_dropify\" filesave=\"photo.uploadFile\" ng-model=\"user\"></div><div flex=\"70\" class=\"\" \nlayout=\"column\"><md-input-container class=\"nl-Input-container ml-15 mt-0 mb-0\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"user.fullName\" name=\"fullname\" required><label class=\"\" translate=\"USERS.NAME\"></label><div \nng-messages=\"editUserForm.fullname.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><md-input-container class=\"nl-Input-container ml-15 mt-0 mb-0\" flex=\"100\"><input type=\"email\" \nclass=\"\" ng-model=\"user.mail\" name=\"mail\" required><label class=\"\" translate=\"USERS.EMAIL\"></label><div \nng-messages=\"editUserForm.mail.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span> <span \nng-message=\"email\">{{\'GENERAL.PATTERN\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container ml-10 mb-0 mt-0\" flex=\"100\"><md-switch class=\"md-primary\" ng-model=\"user.activated\" \nname=\"activated\">{{\'USERS.ACTIVE\' | translate}}</md-switch></md-input-container><md-input-container \nclass=\"nl-Input-container ml-10 mt-0 mb-0\" flex=\"100\"><md-switch class=\"md-primary\" ng-model=\"user.seeInactiveContact\" \nname=\"activated\">{{\'USERS.SEE_INACTIVES\' | translate}}</md-switch></md-input-container></div></div></md-dialog-content>\n<md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 submit-button md-raised\" ng-disabled=\"editUserForm.$invalid\" aria-label=\"Sauvegarder\" \ntranslate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/duplication_tool/junk_box/details/junk_box_details.html","<div class=\"page-layout simple fullwidth nl-Has--Responsive--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\" hide-gt-sm><div\n layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\">pattern</div></div></div><div class=\"content content-sm nl-Form-xs\" layout=\"row\" \nlayout-align=\"start stretch\" layout-wrap ng-if=\"!loaded\"><div flex=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div \nclass=\"nl-Block m-5\"><div layout=\"row\" class=\"\"><form name=\"_form\" novalidate=\"\" flex=\"100\"><noo-infos-model \nng-model=\"categories\" edition=\"true\" form-name=\"_form\" model-type=\"modelType\" model=\"model\"></noo-infos-model></form>\n</div></div></div></div><div class=\"nl-loader\" ng-if=\"loaded\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\">\n</div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/events/inscriptions/forms/fields.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"INSCRIPTION_FORMS.FIELDS.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-input-container \nng-if=\"form.paginated\"><md-select ng-model=\"pagination.page\" \nclass=\"nl-Form--select nl-Form--select__bright md-no-underline\" ng-change=\"refreshFields()\"><md-option ng-value=\"1\">\n{{\'INSCRIPTION_FORMS.FIELDS.PAGE\'|translate}} 1</md-option><md-option ng-value=\"2\">\n{{\'INSCRIPTION_FORMS.FIELDS.PAGE\'|translate}} 2</md-option><md-option ng-value=\"3\">\n{{\'INSCRIPTION_FORMS.FIELDS.PAGE\'|translate}} 3</md-option></md-select></md-input-container><md-input-container>\n<md-select ng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright md-no-underline\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-input-container ng-if=\"form.paginated\"><md-select \nng-model=\"pagination.page\" class=\"nl-Form--select nl-Form--select__bright\" ng-change=\"refreshFields()\"><md-option \nng-value=\"1\">{{\'INSCRIPTION_FORMS.FIELDS.PAGE\'|translate}} 1</md-option><md-option ng-value=\"2\">\n{{\'INSCRIPTION_FORMS.FIELDS.PAGE\'|translate}} 2</md-option><md-option ng-value=\"3\">\n{{\'INSCRIPTION_FORMS.FIELDS.PAGE\'|translate}} 3</md-option></md-select></md-input-container><md-input-container>\n<md-select ng-model=\"language.key\" class=\"nl-Form--select nl-Form--select__bright\"><md-option \nng-repeat=\"lang in languages\" ng-value=\"lang.key\">{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option>\n</md-select></md-input-container></div></div></div><div class=\"content\"><div class=\"nl-Block\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span translate=\"INSCRIPTION_FORMS.FIELDS.COLUMN_1\" aria-hidden=\"false\"></span></div></div><form \nname=\"inscriptionFieldsForm1\" novalidate><div><div class=\"nl-RowResponsive\" layout=\"row\" layout-sm=\"column\" \nlayout-xs=\"column\" layout-align=\"start center\" \nng-repeat=\"field in inscriptionFields | filter: {column: 1} as column1Fields track by field.id\" ng-form=\"fieldForm1\">\n<md-input-container flex=\"10\" flex-sm=\"95\" flex-xs=\"95\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.TYPE\"|translate}}</label><md-select ng-model=\"field.typeField\" name=\"typeField\" required \nng-disabled=\"!field.active\"><md-option ng-repeat=\"typeField in typeFields\" ng-value=\"typeField\">{{typeField}}\n</md-option></md-select><div class=\"pl-5\" ng-messages=\"fieldForm1.typeField.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container ng-if=\"field.typeField === \'FIELD\'\" class=\"ml-25 mt-25 mb-0\" flex=\"15\" flex-sm=\"95\" flex-xs=\"95\">\n<label>{{\"INSCRIPTION_FORMS.FIELDS.NAME\"|translate}}</label><input type=\"text\" maxlength=\"255\" ng-model=\"field.name\" \nname=\"name\" required ng-disabled=\"!field.active\"><div class=\"pl-5\" ng-messages=\"fieldForm1.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container ng-if=\"field.typeField === \'FIELD\'\" flex=\"10\" flex-sm=\"95\" flex-xs=\"95\" class=\"ml-25 mt-0 mb-0\">\n<label>{{\"INSCRIPTION_FORMS.FIELDS.MODEL_TYPE\"|translate}}</label><md-select ng-model=\"field.modelType\" \nname=\"modelType\" required ng-change=\"getFields(field)\" ng-disabled=\"!field.active\"><md-option \nng-repeat=\"modelType in modelTypes\" ng-value=\"modelType\">{{\'GENERAL.\'+modelType | translate}}</md-option></md-select>\n<div class=\"pl-5\" ng-messages=\"fieldForm1.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"field.typeField === \'FIELD\'\" flex=\"15\" flex-sm=\"95\" flex-xs=\"95\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.FIELD\"|translate}}</label><md-select ng-model=\"field.field\" name=\"field\" \nng-model-options=\"{trackBy: \'$value.id\'}\" required ng-disabled=\"!field.active\"><md-option \nng-repeat=\"field in field.fields | orderBy: \'libelle\'\" ng-value=\"field\">{{field.libelle}}</md-option></md-select><div \nclass=\"pl-5\" ng-messages=\"fieldForm1.field.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"field.typeField === \'HEADER\'\" flex=\"20\" flex-sm=\"95\" flex-xs=\"95\" class=\"ml-25 mt-25 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.HEADER\"|translate}}</label><input type=\"text\" maxlength=\"255\" ng-model=\"field.header\" \nname=\"header\" required ng-disabled=\"!field.active\"><div class=\"pl-5\" ng-messages=\"fieldForm1.header.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container ng-if=\"field.typeField === \'EXPLANATION\'\" flex=\"20\" flex-sm=\"95\" flex-xs=\"95\" \nclass=\"ml-25 mt-25 mb-0\"><label>{{\"INSCRIPTION_FORMS.FIELDS.EXPLANATION\"|translate}}</label><textarea \nng-model=\"field.text\" rows=\"5\" name=\"text\" required ng-disabled=\"!field.active\">\n							</textarea><div class=\"pl-5\" \nng-messages=\"fieldForm1.text.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"5\" flex-sm=\"95\" \nflex-xs=\"95\" ng-if=\"field.typeField === \'FIELD\'\"><md-checkbox class=\"md-primary md-hue-2\" ng-model=\"field.required\" \nname=\"required\" ng-disabled=\"!field.active\">{{\"INSCRIPTION_FORMS.FIELDS.REQUIRED\"|translate}}</md-checkbox>\n</md-input-container><md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"5\" flex-sm=\"95\" flex-xs=\"95\" \nng-if=\"field.typeField === \'FIELD\'\"><md-checkbox class=\"md-primary md-hue-2\" ng-model=\"field.prefilling\" \nname=\"prefilling\" ng-disabled=\"!field.active\">{{\"INSCRIPTION_FORMS.FIELDS.PREFILLING\"|translate}}</md-checkbox>\n</md-input-container><md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"10\" flex-sm=\"95\" flex-xs=\"95\" \nng-show=\"field.typeField === \'FIELD\' && (field.modelType === \'COMPANY_MODEL\' || field.modelType === \'CONTACT_MODEL\')\">\n<md-checkbox class=\"md-primary md-hue-2\" ng-model=\"field.createIfUpdate\" name=\"paginated\" ng-disabled=\"!field.active\">\n{{(field.modelType === \'CONTACT_MODEL\' ? \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_CONTACT\" : \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_COMPANY\")|translate}}\n</md-checkbox></md-input-container><div layout=\"row\" layout-align=\"end center\" flex flex-sm=\"100\" flex-xs=\"100\">\n<md-button type=\"button\" class=\"md-fab md-mini md-orange-400-bg md-hue-2\" ng-click=\"openConditional(field);\"><md-icon \nmd-font-icon=\"icon-routes\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"removeField(field, $index);\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s18\"></md-icon></md-button><md-button ng-click=\"cancelFieldUpdating(field, $index);\" ng-if=\"field.active\" \ntype=\"button\" class=\"md-fab md-mini md-accent md-hue-1\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</md-button><md-button ng-click=\"updateField(field, $index)\" ng-if=\"field.active\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button>\n<md-button ng-if=\"!field.active\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"enabledFieldUpdating(field);\" noo-tooltip tooltip-title=\"Modifier ce champ\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button><div layout=\"row\" layout-align=\"end center\" class=\"ml-15\">\n<md-button ng-if=\"field.index > 0\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"up(field)\" \nnoo-tooltip tooltip-title=\"Monter d\'un rang\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button>\n<md-button ng-if=\"field.index < column1Fields.length -1\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"down(field)\" noo-tooltip tooltip-title=\"Descendre d\'un rang\"><md-icon md-font-icon=\"icon-arrow-down\" \nclass=\"s18\"></md-icon></md-button></div></div></div></div></form><div class=\"nl-Block mt-20\"><form \nname=\"addFieldForm1\" novalidate ng-submit=\"addFieldForm1.$valid && addItem(1, addFieldForm1)\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span translate=\"INSCRIPTION_FORMS.FIELDS.NEW_FIELD\" aria-hidden=\"false\"></span></div></div><div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.NAME\"|translate}}</label><md-select ng-model=\"newField1.typeField\" name=\"typeField\" \nrequired><md-option ng-repeat=\"typeField in typeFields\" ng-value=\"typeField\">{{typeField}}</md-option></md-select><div \nclass=\"pl-5\" ng-messages=\"addFieldForm1.typeField.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField1.typeField === \'FIELD\'\" class=\"ml-25 mt-25 mb-0\" flex=\"15\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.NAME\"|translate}}</label><input type=\"text\" maxlength=\"255\" ng-model=\"newField1.name\" \nrequired><div class=\"pl-5\" ng-messages=\"addFieldForm1.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField1.typeField === \'FIELD\'\" flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.MODEL_TYPE\"|translate}}</label><md-select ng-model=\"newField1.modelType\" name=\"modelType\" \nrequired ng-change=\"getFields(newField1)\"><md-option ng-repeat=\"modelType in modelTypes\" ng-value=\"modelType\">\n{{\'GENERAL.\'+modelType | translate}}</md-option></md-select><div class=\"pl-5\" \nng-messages=\"addFieldForm1.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField1.typeField === \'FIELD\'\" flex=\"15\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.FIELD\"|translate}}</label><md-select ng-model=\"newField1.field\" name=\"field\" required>\n<md-option ng-repeat=\"field in newField1.fields  | orderBy: \'libelle\'\" ng-value=\"field\">{{field.libelle}}</md-option>\n</md-select><div class=\"pl-5\" ng-messages=\"addFieldForm1.field.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField1.typeField === \'HEADER\'\" flex=\"30\" class=\"ml-25 mt-25 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.HEADER\"|translate}}</label><input type=\"text\" maxlength=\"255\" ng-model=\"newField1.header\" \nname=\"header\" required><div class=\"pl-5\" ng-messages=\"addFieldForm1.header.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container ng-if=\"newField1.typeField === \'EXPLANATION\'\" flex=\"30\" class=\"ml-25 mt-25 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.EXPLANATION\"|translate}}</label><textarea ng-model=\"newField1.text\" rows=\"5\" name=\"text\" \nrequired>\n								</textarea><div class=\"pl-5\" ng-messages=\"addFieldForm1.text.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"10\" ng-if=\"newField1.typeField === \'FIELD\'\"><md-checkbox \nclass=\"md-primary md-hue-2\" ng-model=\"newField1.required\" name=\"paginated\">\n{{\"INSCRIPTION_FORMS.FIELDS.REQUIRED\"|translate}}</md-checkbox></md-input-container><md-input-container \nclass=\"ml-25 mt-25 mb-0\" flex=\"10\" ng-if=\"newField1.typeField === \'FIELD\'\"><md-checkbox class=\"md-primary md-hue-2\" \nng-model=\"newField1.prefilling\" name=\"prefilling\">{{\"INSCRIPTION_FORMS.FIELDS.PREFILLING\"|translate}}</md-checkbox>\n</md-input-container><md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"15\" \nng-show=\"newField1.typeField === \'FIELD\' && (newField1.modelType === \'COMPANY_MODEL\' || newField1.modelType === \'CONTACT_MODEL\')\">\n<md-checkbox class=\"md-primary md-hue-2\" ng-model=\"newField1.createIfUpdate\" name=\"createIfUpdate\">\n{{(newField1.modelType === \'CONTACT_MODEL\' ? \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_CONTACT\" : \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_COMPANY\")|translate}}\n</md-checkbox></md-input-container><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" \nclass=\"md-raised md-primary md-hue-2\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form></div></div><div class=\"nl-Block mt-20\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span translate=\"INSCRIPTION_FORMS.FIELDS.COLUMN_2\" aria-hidden=\"false\"></span></div></div><form \nname=\"inscriptionFieldsForm2\" novalidate><div><div layout=\"row\" layout-align=\"start center\" ng-init=\"getFields(field)\" \nng-repeat=\"field in inscriptionFields | filter: {column: 2} as column2Fields track by field.id\" ng-form=\"fieldForm2\">\n<md-input-container flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label>{{\"INSCRIPTION_FORMS.FIELDS.TYPE\"|translate}}</label>\n<md-select ng-model=\"field.typeField\" name=\"typeField\" required ng-disabled=\"!field.active\"><md-option \nng-repeat=\"typeField in typeFields\" ng-value=\"typeField\">{{typeField}}</md-option></md-select><div class=\"pl-5\" \nng-messages=\"fieldForm2.typeField.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"field.typeField === \'FIELD\'\" class=\"ml-25 mt-25 mb-0\" flex=\"15\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.NAME\"|translate}}</label><input type=\"text\" maxlength=\"255\" ng-model=\"field.name\" \nname=\"name\" required ng-disabled=\"!field.active\"><div class=\"pl-5\" ng-messages=\"fieldForm2.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container ng-if=\"field.typeField === \'FIELD\'\" flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.MODEL_TYPE\"|translate}}</label><md-select ng-model=\"field.modelType\" name=\"modelType\" \nrequired ng-change=\"getFields(field)\" ng-disabled=\"!field.active\"><md-option ng-repeat=\"modelType in modelTypes\" \nng-value=\"modelType\">{{\'GENERAL.\'+modelType | translate}}</md-option></md-select><div class=\"pl-5\" \nng-messages=\"fieldForm2.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"field.typeField === \'FIELD\'\" flex=\"15\" class=\"ml-25 mt-0 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.FIELD\"|translate}}</label><md-select ng-model=\"field.field\" name=\"field\" \nng-model-options=\"{trackBy: \'$value.id\'}\" required ng-disabled=\"!field.active\"><md-option \nng-repeat=\"field in field.fields | orderBy: \'libelle\'\" ng-value=\"field\">{{field.libelle}}</md-option></md-select><div \nclass=\"pl-5\" ng-messages=\"fieldForm2.field.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"field.typeField === \'HEADER\'\" flex=\"20\" class=\"ml-25 mt-25 mb-0\"><label>\n{{\"INSCRIPTION_FORMS.FIELDS.HEADER\"|translate}}</label><input type=\"text\" maxlength=\"255\" ng-model=\"field.header\" \nname=\"header\" required ng-disabled=\"!field.active\"><div class=\"pl-5\" ng-messages=\"fieldForm2.header.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container ng-if=\"field.typeField === \'EXPLANATION\'\" flex=\"20\" class=\"ml-25 mt-25 mb-0\">\n<label>{{\"INSCRIPTION_FORMS.FIELDS.EXPLANATION\"|translate}}</label><textarea ng-model=\"field.text\" rows=\"5\" \nname=\"text\" required ng-disabled=\"!field.active\">\n							</textarea><div class=\"pl-5\" \nng-messages=\"fieldForm2.text.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"5\" \nng-if=\"field.typeField === \'FIELD\'\"><md-checkbox class=\"md-primary md-hue-2\" ng-model=\"field.required\" \nname=\"paginated\" ng-disabled=\"!field.active\">{{\"INSCRIPTION_FORMS.FIELDS.REQUIRED\"|translate}}</md-checkbox>\n</md-input-container><md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"5\" ng-if=\"field.typeField === \'FIELD\'\">\n<md-checkbox class=\"md-primary md-hue-2\" ng-model=\"field.prefilling\" name=\"prefilling\" ng-disabled=\"!field.active\">\n{{\"INSCRIPTION_FORMS.FIELDS.PREFILLING\"|translate}}</md-checkbox></md-input-container><md-input-container \nclass=\"ml-25 mt-25 mb-0\" flex=\"10\" \nng-show=\"field.typeField === \'FIELD\' && (field.modelType === \'COMPANY_MODEL\' || field.modelType === \'CONTACT_MODEL\')\">\n<md-checkbox class=\"md-primary md-hue-2\" ng-model=\"field.createIfUpdate\" name=\"paginated\" ng-disabled=\"!field.active\">\n{{(field.modelType === \'CONTACT_MODEL\' ? \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_CONTACT\" : \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_COMPANY\")|translate}}\n</md-checkbox></md-input-container><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"button\" \nclass=\"md-fab md-mini md-orange-400-bg md-hue-2\" ng-click=\"openConditional(field);\"><md-icon \nmd-font-icon=\"icon-routes\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"removeField(field, $index);\"><md-icon md-font-icon=\"icon-delete\" \nclass=\"s18\"></md-icon></md-button><md-button ng-click=\"cancelFieldUpdating(field, $index);\" ng-if=\"field.active\" \ntype=\"button\" class=\"md-fab md-mini md-accent md-hue-1\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon>\n</md-button><md-button ng-click=\"updateField(field, $index)\" ng-if=\"field.active\" \nclass=\"md-fab md-mini md-primary md-hue-2\"><md-icon md-font-icon=\"icon-content-save\" class=\"s18\"></md-icon></md-button>\n<md-button ng-if=\"!field.active\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"enabledFieldUpdating(field);\" noo-tooltip tooltip-title=\"Modifier ce champ\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s18\"></md-icon></md-button><div layout=\"row\" layout-align=\"end center\" class=\"ml-15\">\n<md-button ng-if=\"field.index > 0\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" ng-click=\"up(field)\" \nnoo-tooltip tooltip-title=\"Monter d\'un rang\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button>\n<md-button ng-if=\"field.index < column2Fields.length -1\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-click=\"down(field)\" noo-tooltip tooltip-title=\"Descendre d\'un rang\"><md-icon md-font-icon=\"icon-arrow-down\" \nclass=\"s18\"></md-icon></md-button></div></div></div></div></form><div class=\"nl-Block mt-20\"><form \nname=\"addFieldForm2\" novalidate ng-submit=\"addFieldForm2.$valid && addItem(2, addFieldForm2)\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n<span translate=\"INSCRIPTION_FORMS.FIELDS.NEW_FIELD\" aria-hidden=\"false\"></span></div></div><div><div layout=\"row\" \nlayout-align=\"start center\"><md-input-container flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label \ntranslate=\"INSCRIPTION_FORMS.FIELDS.NAME\"></label><md-select ng-model=\"newField2.typeField\" name=\"typeField\" required>\n<md-option ng-repeat=\"typeField in typeFields\" ng-value=\"typeField\">{{typeField}}</md-option></md-select><div \nclass=\"pl-5\" ng-messages=\"addFieldForm2.typeField.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField2.typeField === \'FIELD\'\" class=\"ml-25 mt-25 mb-0\" flex=\"15\"><label \ntranslate=\"INSCRIPTION_FORMS.FIELDS.NAME\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"newField2.name\" \nname=\"name\" required><div class=\"pl-5\" ng-messages=\"addFieldForm2.name.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField2.typeField === \'FIELD\'\" flex=\"10\" class=\"ml-25 mt-0 mb-0\"><label \ntranslate=\"INSCRIPTION_FORMS.FIELDS.MODEL_TYPE\"></label><md-select ng-model=\"newField2.modelType\" name=\"modelType\" \nrequired ng-change=\"getFields(newField2)\"><md-option ng-repeat=\"modelType in modelTypes\" ng-value=\"modelType\">\n{{\'GENERAL.\'+modelType | translate}}</md-option></md-select><div class=\"pl-5\" \nng-messages=\"addFieldForm2.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField2.typeField === \'FIELD\'\" flex=\"15\" class=\"ml-25 mt-0 mb-0\"><label \ntranslate=\"INSCRIPTION_FORMS.FIELDS.FIELD\"></label><md-select ng-model=\"newField2.field\" name=\"field\" required>\n<md-option ng-repeat=\"field in newField2.fields | orderBy: \'libelle\'\" ng-value=\"field\">{{field.libelle}}</md-option>\n</md-select><div class=\"pl-5\" ng-messages=\"addFieldForm2.field.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"newField2.typeField === \'HEADER\'\" flex=\"30\" class=\"ml-25 mt-25 mb-0\"><label \ntranslate=\"INSCRIPTION_FORMS.FIELDS.HEADER\"></label><input type=\"text\" maxlength=\"255\" ng-model=\"newField2.header\" \nname=\"header\" required><div class=\"pl-5\" ng-messages=\"addFieldForm2.header.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container ng-if=\"newField2.typeField === \'EXPLANATION\'\" flex=\"30\" class=\"ml-25 mt-25 mb-0\"><label \ntranslate=\"INSCRIPTION_FORMS.FIELDS.EXPLANATION\"></label><textarea ng-model=\"newField2.text\" rows=\"5\" required \nname=\"text\">\n								</textarea><div class=\"pl-5\" ng-messages=\"addFieldForm2.text.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"10\" ng-if=\"newField2.typeField === \'FIELD\'\"><md-checkbox \nclass=\"md-primary md-hue-2\" ng-model=\"newField2.required\" name=\"required\">\n{{\"INSCRIPTION_FORMS.FIELDS.REQUIRED\"|translate}}</md-checkbox></md-input-container><md-input-container \nclass=\"ml-25 mt-25 mb-0\" flex=\"10\" ng-if=\"newField2.typeField === \'FIELD\'\"><md-checkbox class=\"md-primary md-hue-2\" \nng-model=\"newField2.prefilling\" name=\"prefilling\">{{\"INSCRIPTION_FORMS.FIELDS.PREFILLING\"|translate}}</md-checkbox>\n</md-input-container><md-input-container class=\"ml-25 mt-25 mb-0\" flex=\"15\" \nng-show=\"newField2.typeField === \'FIELD\' && (newField2.modelType === \'COMPANY_MODEL\' || newField2.modelType === \'CONTACT_MODEL\')\">\n<md-checkbox class=\"md-primary md-hue-2\" ng-model=\"newField2.createIfUpdate\" name=\"createIfUpdate\">\n{{(newField2.modelType === \'CONTACT_MODEL\' ? \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_CONTACT\" : \"INSCRIPTION_FORMS.FIELDS.CAN_CREATE_NEW_COMPANY\")|translate}}\n</md-checkbox></md-input-container><div layout=\"row\" layout-align=\"end center\" flex><md-button type=\"submit\" \nclass=\"md-raised md-primary md-hue-2\"><md-icon md-font-icon=\"icon-plus\" class=\"s18\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div></form></div></div></div></div>");
$templateCache.put("app/main/events/inscriptions/forms/forms.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\" translate=\"INSCRIPTION_FORMS.TITLE\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" \nclass=\"md-accent md-hue-1\" ng-click=\"openAdd()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'GENERAL.ADD\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\"><div \nclass=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"md-accent md-hue-1\" ng-click=\"openAdd()\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div></div><div \nclass=\"content\"><div class=\"nl-Block nl-Block--table\"><div class=\"nl-zlisting\"><table \nclass=\"simple list-view nl-Table nl-Table--makeResponsive nl-Table--forms\"><thead><th>\n{{\"INSCRIPTION_FORMS.COLUMNS.ID\" | translate}}</th><th>{{\"INSCRIPTION_FORMS.COLUMNS.NAME\" | translate}}</th><th>\n{{\"INSCRIPTION_FORMS.COLUMNS.MODEL_SUBTYPE\" | translate}}</th><th>\n{{\"INSCRIPTION_FORMS.COLUMNS.SUB_CATEGORY\" | translate}}</th><th>\n{{\"INSCRIPTION_FORMS.COLUMNS.MULTIPLE_PAGES\" | translate}}</th><th>{{\"INSCRIPTION_FORMS.COLUMNS.ACTIONS\" | translate}}\n</th></thead><tbody><tr ng-repeat=\"form in forms track by form.id\"><td>{{form.id}}</td><td>{{form.name}}</td><td>\n{{form.subtype.name}}</td><td>{{form.subCategory != null ? form.subCategory.name : \'\'}}</td><td><md-checkbox \nreadonly=\"readonly\" disabled=\"disabled\" ng-model=\"form.paginated\" aria-label=\"publish\"></md-checkbox></td><td>\n<md-button md-no-ink ng-click=\"details(form)\" class=\"md-primary md-raised md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.DETAILS\" | translate}}</md-button><md-button md-no-ink ng-click=\"update(form)\" \nclass=\"md-primary md-raised md-hue-2\" aria-label=\"Supprimer\">{{\"GENERAL.UPDATE\" | translate}}</md-button><md-button \nmd-no-ink ng-click=\"showPopUpDelete(form, $index)\" class=\"md-warn md-hue-2\" aria-label=\"Supprimer\">\n{{\"GENERAL.DELETE\" | translate}}</md-button></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/globe_network/companies/contacts/contact.html","<div class=\"page-layout simple fullwidth nl-Has--Responsive--FixedBar\" md-theme=\"teal-theme\"><md-progress-linear \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" mode=\"indeterminate\" \nng-if=\"_mdProgressLinear\"></md-progress-linear><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\" hide-gt-sm><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\">{{company.modelPattern}}</div></div></div>\n<div class=\"content content-sm nl-Form-xs\" layout=\"row\" layout-align=\"start stretch\" layout-wrap><div flex=\"20\" \nflex-sm=\"100\" flex-xs=\"100\" class=\"nl-Panel\"><div layout=\"column\" layout-wrap><div flex=\"100\" layout=\"column\"><div \nclass=\"nl-Block nl-Block--contact nl-Block--customers\" layout=\"row\" layout-align=\"center top\" layout-wrap \nng-click=\"backToCompany()\"><div flex=\"100\" layout=\"row\" layout-align=\"start center\" class=\"nl-Panel-mainTitle\"><div \nflex=\"80\" class=\"pl-15\">{{company.modelPattern}}</div><md-input-container flex=\"20\" class=\"nl-Form-SwitchContainer\">\n<md-switch class=\"md-primary m-0\" ng-model=\"company.activate\" \nng-change=\"setCompanyActivated(company.id, company.activate)\"></md-switch></md-input-container></div><div layout=\"row\" \nflex=\"100\"><div class=\"nl-Panel-infos\" flex=\"60\" flex-sm=\"100\" flex-xs=\"100\" flex-order-sm=\"2\" flex-order-xs=\"2\"><div \nlayout=\"row\" layout-align=\"start center\" ng-repeat=\"field in company.valuedFields | orderBy: \'index\'\" \nng-if=\"field.index != null && field.value\"><div class=\"mr-5\" ng-if=\"field.icon\"><md-icon \nmd-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s14\"></md-icon></div><div class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps == \'URL\'\"><a href=\"http://{{field.value}}\" \ntarget=\"_blank\" ng-click=\"$event.stopPropagation();\">{{field.value}}</a></div><div class=\"nl-Panel-infos-text\" \nng-if=\"field.index != null && field.value && field.typeChamps == \'EMAIL\'\"><a href=\"mailto:{{field.value}}\" \ntarget=\"_blank\" ng-click=\"$event.stopPropagation();\">{{field.value}}</a></div><div \nng-if=\"field.index != null && field.value && field.typeChamps != \'URL\' && field.typeChamps != \'EMAIL\'\n										&& field.typeChamps != \'BOOLEAN\' && field.typeChamps != \'DATE\' && field.typeChamps != \'LIST_SELECT\'\n										&& field.typeChamps != \'MULTIPLE_SELECT\'\" \nclass=\"nl-Panel-infos-text\">{{field.value}}</div></div></div><div class=\"nl-Msg-profile--wrapper\" flex=\"40\" \nflex-sm=\"100\" flex-xs=\"100\" flex-order-sm=\"1\" flex-order-xs=\"1\"><div class=\"nl-Msg-profile\" \nng-if=\"company.profilePictureLocation != null\"><img class=\"nl-Msg-profile-img\" \nhttp-src=\"./alternatedocroots/{{company.profilePictureLocation}}\" has-profile-picture=\"true\"></div></div></div></div>\n<div class=\"nl-Block nl-Block--contact nl-Block--customers\" \nng-repeat=\"contact in contacts | filter : {deleted: false} track by contact.id\" \nng-class=\"{\'nl-selected\': contact.id === selectedContact.id}\" ng-click=\"detailsContact(contact.id)\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div flex=\"100\" layout=\"row\" layout-align=\"start center\" \nclass=\"nl-Panel-mainTitle\"><div flex=\"80\" class=\"pl-15\"><md-icon ng-if=\"company.favouriteId === contact.id\" \nmd-font-icon=\"icon-star\"></md-icon>{{contact.modelPattern}} <span ng-if=\"contact.deleted\">\n({{\'CONTACTS.DELETED\'|translate}})</span></div><md-input-container flex=\"20\" class=\"nl-Form-SwitchContainer\"><md-switch\n class=\"md-primary m-0\" ng-model=\"contact.activate\" ng-change=\"setContactActivated(contact.id, contact.activate)\">\n</md-switch></md-input-container></div><div layout=\"row\" flex=\"100\"><div class=\"nl-Panel-infos\" flex=\"60\" \nflex-sm=\"100\" flex-xs=\"100\" flex-order-sm=\"2\" flex-order-xs=\"2\" \nng-if=\"contact.valuedFields != null && contact.valuedFields.length > 0\"><div layout=\"row\" layout-align=\"start center\" \nng-repeat=\"field in contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\"><div \nclass=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s14\"></md-icon></div><div \nclass=\"nl-Panel-infos-text\" ng-if=\"field.index != null && field.value && field.typeChamps == \'URL\'\"><a \nhref=\"http://{{field.value}}\" target=\"_blank\" ng-click=\"$event.stopPropagation();\">{{field.value}}</a></div><div \nclass=\"nl-Panel-infos-text\" ng-if=\"field.index != null && field.value && field.typeChamps == \'EMAIL\'\"><a \nhref=\"mailto:{{field.value}}\" target=\"_blank\" ng-click=\"$event.stopPropagation();\">{{field.value}}</a></div><div \nng-if=\"field.index != null && field.value && field.typeChamps != \'URL\' && field.typeChamps != \'EMAIL\'\n										&& field.typeChamps != \'BOOLEAN\' && field.typeChamps != \'DATE\' && field.typeChamps != \'LIST_SELECT\'\n										&& field.typeChamps != \'MULTIPLE_SELECT\'\" \nclass=\"nl-Panel-infos-text\">{{field.value}}</div></div></div><div class=\"nl-Msg-profile--wrapper\" flex=\"40\" \nflex-sm=\"100\" flex-xs=\"100\" flex-order-sm=\"1\" flex-order-xs=\"1\"><div ng-if=\"contact.profilePictureLocation != null\" \nclass=\"nl-Msg-profile\"><img class=\"nl-Msg-profile-img--cover\" \nhttp-src=\"./alternatedocroots/{{contact.profilePictureLocation}}\" has-profile-picture=\"true\"></div></div></div></div>\n</div></div><div layout=\"row\" layout-align=\"center center\" permissions=\"[\'COMPANY_LEFT_CHECK_MY_PROFILE\']\"><md-button \ntype=\"button\" class=\"md-primary\" ng-click=\"checkMyProfileOnline()\"><md-icon md-font-icon=\"icon-check-circle\"></md-icon>\n{{\'COMPANIES.CHECK_MY_PROFILE_ONLINE_BTN\' | translate}}</md-button></div><div layout=\"row\" \nlayout-align=\"center center\" permissions=\"[\'COMPANY_LEFT_ADD_CONTACT\']\"><md-button type=\"button\" class=\"md-primary\" \nng-click=\"openAddContact()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'CONTACTS.ADD\' | translate}}</md-button>\n</div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"userService.containsRole(\'COMPANY_LEFT_SHOW_INACTIVE_CONTACTS\')\"><md-button ng-hide=\"hiddenContact\" \ntype=\"button\" class=\"md-primary\" ng-click=\"showMoreContacts()\"><md-icon md-font-icon=\"icon-eye\"></md-icon>\n{{\'CONTACTS.SHOW\' | translate}}</md-button><md-button ng-if=\"hiddenContact\" type=\"button\" class=\"md-primary\" \nng-click=\"hideMoreContacts()\"><md-icon md-font-icon=\"icon-eye-off\"></md-icon>{{\'CONTACTS.HIDE\' | translate}}\n</md-button></div><div layout=\"row\" layout-align=\"center center\" \nng-if=\"userService.containsRole(\'COMPANY_LEFT_CONTACT_DUPLICATION_TOOL\')\"><md-button type=\"button\" class=\"md-primary\" \nng-click=\"_lookForContactDuplicates()\" style=\"white-space: normal!important;line-height: 36px!important\"><md-icon \nmd-font-icon=\"icon-content-duplicate\"></md-icon>{{\'DUPLICATION_TOOL.CONTACT_TITLE\' | translate}}</md-button></div><div \nlayout=\"row\" layout-align=\"center center\" ng-if=\"userService.containsRole(\'COMPANY_LEFT_DUPLICATES_AUTO_MERGE\')\">\n<md-button type=\"button\" class=\"md-primary\" ng-click=\"_contactDuplicatesAutoMergeFn()\" \nstyle=\"white-space: normal!important;line-height: 36px!important\"><md-icon md-font-icon=\"icon-flash-auto\"></md-icon>\n{{\'DUPLICATION_TOOL.CONTACT_AUTO_MERGE_TITLE\' | translate}}</md-button></div><div layout=\"row\" \nlayout-align=\"center center\" ng-if=\"userService.containsRole(\'COMPANY_LEFT_LOGS\')\"><md-button type=\"button\" \nclass=\"md-primary\" ng-click=\"showLogs()\"><md-icon md-font-icon=\"icon-timelapse\"></md-icon>\n{{\'COMPANIES.LOGS\' | translate}}</md-button></div></div><div flex=\"80\" flex-sm=\"100\" flex-xs=\"100\" ng-if=\"!logsShowed\">\n<div class=\"nl-Block\"><div layout=\"row\" layout-align=\"space-between center\"><md-button flex type=\"button\" \nclass=\"md-accent md-hue-3 nl-Button--small\" ng-click=\"setPrincipal()\" permissions=\"[\'CONTACT_UP_MAIN\']\"><md-icon \nmd-font-icon=\"icon-star\"></md-icon>{{\'CONTACTS.PRINCIPAL\' | translate}}</md-button><md-button \nng-if=\"userService.containsRole(\'CONTACT_UP_SUBSCRIBE\')\" flex type=\"button\" \nclass=\"md-accent md-hue-3 nl-Button--small\" ng-click=\"openSubscribe()\"><md-icon md-font-icon=\"icon-ticket\"></md-icon>\n{{\'CONTACTS.SUBSCRIBE\' | translate}}</md-button><md-button ng-if=\"userService.containsRole(\'CONTACT_UP_SEND_MAIL\')\" \nflex type=\"button\" class=\"md-accent md-hue-3 nl-Button--small\" ng-click=\"_mailingDialogOpenFn()\"><md-icon \nmd-font-icon=\"icon-bullhorn\"></md-icon><span translate=\"MAILING.DO_MAILING.MAILING_BTN\"></span></md-button><md-button \nng-if=\"userService.containsRole(\'CONTACT_UP_TRANSFER\')\" flex type=\"button\" class=\"md-accent md-hue-3 nl-Button--small\" \nng-click=\"openMove()\"><md-icon md-font-icon=\"icon-cursor-move\"></md-icon>{{\'CONTACTS.MOVE\' | translate}}</md-button>\n<md-button ng-if=\"userService.containsRole(\'CONTACT_UP_COPY\')\" flex type=\"button\" \nclass=\"md-accent md-hue-3 nl-Button--small\" ng-click=\"openCopy()\"><md-icon md-font-icon=\"icon-content-copy\"></md-icon>\n</md-button><md-button ng-if=\"userService.containsRole(\'CONTACT_UP_DELETE\')\" flex type=\"button\" \nclass=\"md-warn md-hue-2 nl-Button--small\" ng-if=\"!selectedContact.deleted\" ng-click=\"showDeleteContact(true)\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button><md-button ng-if=\"userService.containsRole(\'CONTACT_UP_RESTORE\')\" \nflex type=\"button\" class=\"md-accent md-hue-3 nl-Button--small\" ng-if=\"selectedContact.deleted\" \nng-click=\"showDeleteContact(false)\"><md-icon md-font-icon=\"icon-auto-fix\"></md-icon>{{\'CONTACTS.RESTORE\' | translate}}\n</md-button></div><div layout=\"row\"><form name=\"updateFolderForm\" novalidate=\"\" flex=\"100\"><noo-infos-model \nng-model=\"categories\" edition=\"true\" form-name=\"updateFolderForm\" model-type=\"modelType\" model=\"selectedContact\" \nshow-settings=\"showSettings\"></noo-infos-model></form></div></div><div class=\"nl-Block\" \nng-if=\"inscriptions != null && inscriptions.length > 0\"><div class=\"nl_categories-item-title\" layout=\"row\" \nlayout-align=\"space-between center\" ng-click=\"showRegistrations = !showRegistrations\"><div>\n{{\"INSCRIPTION.TITLE\" | translate}}</div><button type=\"button\" class=\"ml-10\"><md-icon md-font-icon=\"icon-eye\" \nng-if=\"!showRegistrations\"></md-icon><md-icon md-font-icon=\"icon-eye-off\" ng-if=\"showRegistrations\"></md-icon></button>\n</div><div layout=\"column\" ng-repeat=\"inscription in inscriptions\" ng-if=\"showRegistrations\"><div \nclass=\"nl_categories-item-subtitle\" layout=\"row\" ng-click=\"inscription._showDetails = !inscription._showDetails\"><div \nflex=\"20\" style=\"font-weight: 600\">{{inscription.event.name}}</div><div flex=\"10\" \nng-if=\"inscription.inscriptionStatus != null\"><span ng-style=\"setStatusStyle(inscription.inscriptionStatus)\">\n{{inscription.inscriptionStatus.name}}</span></div><div flex=\"10\" ng-if=\"inscription.logisticStatus != null\"><span \nng-style=\"setStatusStyle(inscription.inscriptionStatus)\">{{inscription.logisticStatus}}</span></div><div flex=\"20\">\n{{\'GENERAL.DATE_TIME_FORMAT\' | translate: {date: inscription.creation} }}</div><div flex=\"20\" \ntranslate=\"CONTACTS.LOGISTIC\" ng-click=\"$event.stopPropagation(); goToLogistics(inscription.logisticId)\"></div><div \nflex layout=\"row\" layout-align=\"end center\"><div>\n{{(inscription.throughAdmin ? \'INSCRIPTION_ADMIN.THROUGH_ADMIN\' : \'INSCRIPTION_ADMIN.THROUGH_FORM\') | translate}}</div>\n</div></div><div layout=\"row\" layout-align=\"center center\" class=\"pl-20 pr-20\" flex=\"100\" \nng-show=\"inscription._showDetails\"><div flex=\"100\"><noo-infos-model ng-model=\"inscription.categories\" edition=\"true\" \nform-name=\"updateFolderForm\" model-type=\"\'INSCRIPTION_MODEL\'\" model=\"inscription\" show-settings=\"showSettings\">\n</noo-infos-model></div></div></div></div><div class=\"nl-Block\" \nng-if=\"userService.isUserAdmin() || userService.isUserLinkedToAssociations()\"><div \nclass=\"nl_categories-item-title nl_categories-item-title--first\" layout=\"row\" layout-align=\"space-between center\"><div>\n{{\"MESSAGE.CREATION.NEW\" | translate}}</div><md-button md-no-ink class=\"nl_button--header m-0\" \nng-click=\"showPopUpMessage()\" translate=\"MESSAGE.CREATION.NEW\"></md-button></div><div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>{{\"MESSAGE.BOX.TITLE\" | translate}}</label><md-select \nng-model=\"filter.sender\" aria-label=\"language\" name=\"receiver\" ng-change=\"findAllMessages()\"><md-option \nng-value=\"false\">{{\"MESSAGE.BOX.RECEPTION\" | translate}}</md-option><md-option ng-value=\"true\">\n{{\"MESSAGE.BOX.SENT\" | translate}}</md-option><md-option ng-value=\"null\">{{\"MESSAGE.BOX.ALL\" | translate}}</md-option>\n</md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\n{{\"MESSAGE.TYPE.TITLE\" | translate}}</label><md-select ng-model=\"filter.action\" aria-label=\"language\" name=\"receiver\" \nng-change=\"findAllMessages()\"><md-option ng-value=\"null\">{{\"MESSAGE.TYPE.ALL\" | translate}}</md-option><md-option \nng-value=\"typeAction.TO_DO\">{{\"MESSAGE.TYPE.TO_DO\" | translate}}</md-option><md-option ng-value=\"typeAction.DONE\">\n{{\"MESSAGE.TYPE.DONE\" | translate}}</md-option><md-option ng-value=\"typeAction.ALL\">\n{{\"MESSAGE.TYPE.ALL_ACTION\" | translate}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label>{{\"MESSAGE.CORRESPONDANT\" | translate}}</label><md-select \nmd-on-close=\"filterSelectText = \'\'\" ng-model=\"filter.receiverForm\" aria-label=\"language\" name=\"receiver\" \nmultiple=\"multiple\" ng-change=\"findAllMessages()\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"user in users | filterText: filterSelectText\" value=\"{{user}}\">{{user.fullName}}</md-option></md-select>\n</md-input-container></div><div class=\"nl-form--receivedMsg mt-15\"><table \nclass=\"simple list-view nl-Table nl-Table--makeResponsive nl-Table--msg\"><thead><th>\n{{\"MESSAGE.DISPLAY.MESSAGE\" | translate}}</th><th>{{\"MESSAGE.DISPLAY.LINK\" | translate}}</th><th>\n{{\"MESSAGE.DISPLAY.SENDER\" | translate}}</th><th>{{\"MESSAGE.DISPLAY.ACTIONS\" | translate}}</th></thead><tbody><tr \nng-repeat=\"message in messages\" class=\"nl-Msg\"><td><div class=\"nl-form--receivedMsg--subject\">{{message.subject}}</div>\n<div class=\"nl-form--receivedMsg--content\" ng-bind-html=\"message.content | limitTo: 70\"></div><div \nng-if=\"message.action\" layout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div class=\"nl-Msg-check\" \nng-class=\"{\'nl-validated\': message.action.actionDone}\" ng-click=\"confirmAction(message.action)\" layout=\"row\" \nlayout-align=\"center center\"><i class=\"icon s24\" \nng-class=\"{\'icon-exclamation\' : !message.action.actionDone, \'icon-check\' : message.action.actionDone}\"></i></div><div \nclass=\"ml-10\"><div class=\"nl-Table-message-action-title\">{{message.action.libelle}}</div><div>\nDeadline : {{getDate(message.action.dateAction) | date:\'dd/MM/yyyy\'}} - {{getDate(message.action.dateAction) | date:\'HH:mm\'}}\n</div></div></div></td><td><div class=\"nl-Msg-link-company\" ng-if=\"message.company\"><div translate=\"GENERAL.COMPANY\">\n</div>{{message.company.modelPattern}}</div><div class=\"nl-Msg-link-contact\" ng-if=\"message.contact\"><div \ntranslate=\"GENERAL.CONTACT\"></div>{{message.contact.modelPattern}}</div><div \nng-repeat=\"field in message.contact.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div><div \nng-repeat=\"field in message.company.valuedFields | orderBy: \'index\'\" ng-if=\"field.index != null && field.value\" \nclass=\"nl-Msg-link-contact\"><span class=\"mr-5\" ng-if=\"field.icon\"><md-icon md-font-icon=\"{{iconsDisplay[field.icon]}}\" \nclass=\"s14\"></md-icon></span>{{field.value}}</div></td><td><span class=\"nl-Msg-sender-date\">\n{{getDate(message.creationDate) | date:\'dd/MM/yyyy\'}} - {{getDate(message.creationDate) | date:\'HH:mm\'}}</span><div \nlayout=\"row\" layout-align=\"start center\" class=\"mt-10\"><div ng-if=\"message.sender.pictureLocation\" \nclass=\"nl-Msg-avatar\"><img title=\"{{message.sender.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.sender.pictureLocation}}\" \nhas-profile-picture=\"message.sender.pictureLocation != null\"></div><span ng-if=\"!message.sender.pictureLocation\" \nclass=\"nl-Badge\">{{message.sender.fullName}}</span> <span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id\"><md-icon class=\"mr-8\" \nmd-font-icon=\"icon-chevron-right\"></md-icon></span><div \nng-if=\"message.receiver.pictureLocation && message.receiver.id!=message.sender.id\" class=\"nl-Msg-avatar\"><img \ntitle=\"{{message.receiver.fullName}}\" class=\"nl-Table-avatar\" \nhttp-src=\"./alternatedocroots/{{message.receiver.pictureLocation}}\" \nhas-profile-picture=\"message.receiver.pictureLocation != null\"></div><span \nng-if=\"message.receiver && message.receiver.id!=message.sender.id && !message.receiver.pictureLocation\" \nclass=\"nl-Badge\">{{message.receiver.fullName}}</span></div></td><td><md-button ng-click=\"updateMessage(message)\" \nclass=\"nl-listing-item-button md-accent\" aria-label=\"Update\">{{\"GENERAL.UPDATE\" | translate}}</md-button></td></tr>\n</tbody></table></div></div></div></div><div flex=\"80\" flex-sm=\"100\" flex-xs=\"100\" ng-if=\"logsShowed\"><div \nng-include=\"\'app/main/globe_network/companies/logs/companyLogs.html\'\" ng-controller=\"companyLogsController\"></div>\n</div></div></div>");
$templateCache.put("app/main/globe_network/companies/contacts/logistic.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button nl-Fixed-BartoggleBtn\" \nng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"\">{{\'LOGISTIC.TITLE\' | translate}} #{{logistic.inscription.number}}</div></div><div \nlayout=\"row\" layout-align=\"start center\"></div></div><div class=\"content content-sm p-5 nl-Form-xs nl-Block\"><div \nlayout=\"column\" class=\"p-15\"><div class=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"generalInfosShowed = !generalInfosShowed\"><div>{{\'LOGISTIC.GENERAL_INFOS\' | translate}}</div><button \ntype=\"button\" class=\"ml-10\"><md-icon md-font-icon=\"icon-eye\" ng-if=\"!generalInfosShowed\"></md-icon><md-icon \nmd-font-icon=\"icon-eye-off\" ng-if=\"generalInfosShowed\"></md-icon></button></div><div ng-show=\"generalInfosShowed\"><div \nlayout=\"row\"><div flex=\"20\" layout=\"column\"><div class=\"nl_categories-item-subtitle\">{{\'LOGISTIC.EVENT\' | translate}}\n</div><div layout-align=\"center center\" layout=\"row\"><img style=\"width:100px\" \nng-src=\"{{alternatedocroots + \'/\' + logistic.inscription.event.logo}}\" ng-if=\"logistic.inscription.event.logo != null\">\n</div></div><div flex=\"20\" layout=\"column\"><div class=\"nl_categories-item-subtitle\">{{\'LOGISTIC.COMPANY\' | translate}}\n</div><div><div style=\"font-weight: 600\">{{logistic.company.modelPattern}}</div><div class=\"nl-Panel-infos\" flex=\"80\" \nng-if=\"logistic.company.valuedFields != null && logistic.company.valuedFields.length > 0\"><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"field in logistic.company.valuedFields | orderBy: \'index\'\" \nng-if=\"field.index != null && field.value\"><div class=\"mr-5\" ng-if=\"field.icon\"><md-icon \nmd-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s22\"></md-icon></div><div class=\"nl-Panel-infos-text\">\n{{field.value}}</div></div></div></div></div><div flex=\"20\" layout=\"column\"><div class=\"nl_categories-item-subtitle\">\n{{\'LOGISTIC.CONTACT\' | translate}}</div><div><div style=\"font-weight: 600\">{{logistic.contact.modelPattern}}</div><div \nclass=\"nl-Panel-infos\" flex=\"80\" \nng-if=\"logistic.contact.valuedFields != null && logistic.contact.valuedFields.length > 0\"><div layout=\"row\" \nlayout-align=\"start center\" ng-repeat=\"field in logistic.contact.valuedFields | orderBy: \'index\'\" \nng-if=\"field.index != null && field.value\"><div class=\"mr-5\" ng-if=\"field.icon\"><md-icon \nmd-font-icon=\"{{iconsDisplay[field.icon]}}\" class=\"s22\"></md-icon></div><div class=\"nl-Panel-infos-text\">\n{{field.value}}</div></div></div></div></div><div flex layout=\"column\"><div class=\"nl_categories-item-subtitle\">\n{{\'LOGISTIC.STATUS\' | translate}}</div><div layout=\"row\"><md-input-container class=\"m-0\"><md-select \nng-model=\"logistic.inscription.subCategory\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"changeSubCategory()\">\n<md-option ng-repeat=\"sub in subCategories | orderBy: \'index\' track by sub.id\" ng-value=\"sub\">{{ sub.name }}\n</md-option></md-select><label translate=\"INSCRIPTION_SUB_CATEGORY.TITLE\"></label></md-input-container>\n<md-input-container class=\"m-0\"><md-select md-on-close=\"filterInscriptionStatus = \'\'\" \nng-model=\"logistic.inscription.inscriptionStatus\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nng-change=\"changeInscriptionStatus()\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"filterInscriptionStatus\"></section></md-select-header><md-option\n ng-repeat=\"status in inscriptionStatuses | filterText: filterInscriptionStatus | orderBy: \'index\' track by status.id\" \nng-value=\"status\">{{ status.name }}</md-option></md-select><label translate=\"INSCRIPTION_STATUS.TITLE\"></label>\n</md-input-container><md-input-container class=\"m-0\"><md-select md-on-close=\"filterLogisticStatus = \'\'\" \nng-model=\"logistic.status\" ng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"changeLogisticStatus()\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterLogisticStatus\"></section></md-select-header><md-option \nng-repeat=\"status in logisticStatus | filterText: filterLogisticStatus | orderBy: \'index\' track by status.id\" \nng-value=\"status\">{{ status.name }}</md-option></md-select><label translate=\"LOGISTIC.LOGISTIC_STATUS\"></label>\n</md-input-container></div></div></div></div><form name=\"logisticForm\" novalidate=\"\" flex=\"100\"><noo-infos-model \nng-model=\"categories\" edition=\"true\" form-name=\"logisticForm\" model-type=\"modelType\" model=\"logistic\">\n</noo-infos-model></form><div class=\"nl_categories-item-title\" layout=\"row\" layout-align=\"space-between center\" \nng-click=\"transportPlansShowed = !transportPlansShowed\"><div>{{\'LOGISTIC.TRANSPORT_PLAN\' | translate}}</div><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"nl_button--header mr-20\" \nng-click=\"$event.stopPropagation(); addTransportPlan()\">{{\'LOGISTIC.ADD_TRANSPORT\' | translate}}</md-button><button \ntype=\"button\" class=\"ml-10\"><md-icon md-font-icon=\"icon-eye\" ng-if=\"!transportPlansShowed\"></md-icon><md-icon \nmd-font-icon=\"icon-eye-off\" ng-if=\"transportPlansShowed\"></md-icon></button></div></div><div \nng-show=\"transportPlansShowed\"><div layout=\"row\" class=\"nl_categories-plan-item\" \nng-repeat=\"plan in logistic.transportPlans | orderBy: [\'_departureDate\', \'_departureTime\'] track by plan.id\" \nlayout-wrap><div layout=\"row\" flex=\"100\"><md-input-container flex=\"20\"><md-select ng-model=\"plan.direction\" \nng-model-options=\"{trackBy: \'$value\'}\" ng-change=\"updateTransportPlan(plan)\"><md-option value=\"Going\" \ntranslate=\"LOGISTIC.GOING\"></md-option><md-option value=\"Return\" translate=\"LOGISTIC.RETURN\"></md-option></md-select>\n<label translate=\"LOGISTIC.DIRECTION\"></label></md-input-container><md-input-container flex=\"20\"><md-select \nng-model=\"plan.type\" ng-model-options=\"{trackBy: \'$value\'}\" ng-change=\"updateTransportPlan(plan)\"><md-option \nvalue=\"Plane\" translate=\"LOGISTIC.PLANE\"></md-option><md-option value=\"Train\" translate=\"LOGISTIC.TRAIN\"></md-option>\n<md-option value=\"Car\" translate=\"LOGISTIC.CAR\"></md-option><md-option value=\"Taxi\" translate=\"LOGISTIC.TAXI\">\n</md-option></md-select><label translate=\"LOGISTIC.TYPE\"></label></md-input-container><md-input-container flex=\"40\">\n<input type=\"text\" ng-model=\"plan.comment\" name=\"comment\" ng-change=\"updateTransportPlan(plan)\" \nng-model-options=\"{updateOn: \'blur\'}\"><label translate=\"LOGISTIC.COMMENT\"></label></md-input-container><div flex \nlayout=\"row\" layout-align=\"end center\"><md-button type=\"button\" class=\"md-accent md-hue-3 nl-Button--small\" \nng-click=\"openDeleteTransportPlan(plan.id)\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{\'LOGISTIC.DELETE_PLAN\' | translate}}</md-button></div></div><div layout=\"row\" flex=\"100\" layout-wrap \nlayout-align=\"start start\"><div flex=\"33\" layout=\"row\" layout-wrap><div class=\"nl_categories-item-subtitle\" \ntranslate=\"LOGISTIC.DEPARTURE\" flex=\"100\"></div><md-input-container flex=\"100\"><input type=\"text\" \nng-model=\"plan.departureLocation\" name=\"departureLocation\" ng-change=\"updateTransportPlan(plan)\" \nng-model-options=\"{updateOn: \'blur\'}\"><label translate=\"LOGISTIC.LOCATION\"></label></md-input-container>\n<md-input-container flex=\"70\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"plan._departureDate\" ng-change=\"updateTransportPlan(plan)\" name=\"departureDate\">\n</md-datepicker><label translate=\"LOGISTIC.DATE\"></label></md-input-container><md-input-container flex=\"30\"><input \ntype=\"time\" ng-model=\"plan._departureTime\" name=\"departureTime\" ng-change=\"updateTransportPlan(plan)\" \nng-model-options=\"{updateOn: \'blur\'}\"><label translate=\"LOGISTIC.TIME\"></label></md-input-container></div><div \nflex=\"33\" layout=\"row\" layout-wrap><div class=\"nl_categories-item-subtitle\" translate=\"LOGISTIC.ARRIVAL\" flex=\"100\">\n</div><md-input-container flex=\"100\"><input type=\"text\" ng-model=\"plan.arrivalLocation\" name=\"arrivalLocation\" \nng-change=\"updateTransportPlan(plan)\" ng-model-options=\"{updateOn: \'blur\'}\"><label translate=\"LOGISTIC.LOCATION\">\n</label></md-input-container><md-input-container flex=\"70\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" \nmd-open-on-focus md-hide-icons=\"calendar\" ng-model=\"plan._arrivalDate\" ng-change=\"updateTransportPlan(plan)\" \nname=\"arrivalDate\"></md-datepicker><label translate=\"LOGISTIC.DATE\"></label></md-input-container><md-input-container \nflex=\"30\"><input type=\"time\" ng-model=\"plan._arrivalTime\" name=\"arrivalTime\" ng-change=\"updateTransportPlan(plan)\" \nng-model-options=\"{updateOn: \'blur\'}\"><label translate=\"LOGISTIC.TIME\"></label></md-input-container></div><div \nflex=\"33\" layout=\"row\" layout-wrap><div class=\"nl_categories-item-subtitle\" translate=\"LOGISTIC.TICKET\" flex=\"100\">\n</div><div flex=\"50\" layout=\"row\" layout-align=\"start start\"><md-button type=\"button\" \nng-click=\"downloadTicket(plan.id)\" class=\"md-accent md-hue-3 nl-Button--small\" \nng-disabled=\"plan.ticketLocation == null\"><md-icon md-font-icon=\"icon-download\"></md-icon>\n{{\'GENERAL.DOWNLOAD\' | translate}}</md-button></div><div flex=\"50\" layout=\"row\" layout-align=\"end start\"><md-button \ntype=\"button\" ng-click=\"openDeleteTicket(plan.id)\" class=\"md-accent md-hue-3 nl-Button--small\" \nng-disabled=\"plan.ticketLocation == null\"><md-icon md-font-icon=\"icon-delete\"></md-icon>\n{{\'LOGISTIC.DELETE_TICKET\' | translate}}</md-button></div><md-input-container flex=\"100\"><input type=\"text\" \nng-model=\"plan.ticketNumber\" name=\"ticketNumber\" ng-change=\"updateTransportPlan(plan)\" \nng-model-options=\"{updateOn: \'blur\'}\"><label translate=\"LOGISTIC.TICKET_NUMBER\"></label></md-input-container>\n<md-input-container flex=\"100\"><input type=\"file\" id=\"ticket_{{plan.id}}\" plan=\"plan\" class=\"nl_form--file\" \nname=\"ticket\" file-input-changed call=\"uploadTicket(plan)\"><label translate=\"LOGISTIC.TICKET\"></label>\n</md-input-container></div></div></div></div></div><div layout=\"column\" class=\"p-5\"><md-button target=\"_blank\" \nflex=\"100\" md-no-ink class=\"md-warn\" ng-click=\"onDeleteRegistration();\"><md-icon md-font-icon=\"icon-trash\"></md-icon>\n{{\'LOGISTIC.DELETE_REGISTRATION\' | translate}}</md-button></div></div></div>");
$templateCache.put("app/main/globe_network/companies/duplication_tool/duplication_tool_modal.html","<md-dialog class=\"admin-user-dialog nl-Modal\" aria-label=\"Look For Duplicates\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"lookForDuplicatesForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div\n class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div\n layout=\"column\" layout-align=\"center center\"><div class=\"contact-name\" \nng-if=\"_dtToolData._modelType == MODELS_TYPES.COMPANY_MODEL\">{{\'DUPLICATION_TOOL.COMPANY_TITLE\' | translate}}</div><div\n class=\"contact-name\" ng-if=\"_dtToolData._modelType == MODELS_TYPES.CONTACT_MODEL\">\n{{\'DUPLICATION_TOOL.CONTACT_TITLE\' | translate}}</div></div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar>\n<md-dialog-content ng-if=\"!initDataInProgress\"><md-input-container class=\"\"><md-select name=\"field1\" \nng-model=\"_dtToolData._fields[0]\" placeholder=\"{{\'DUPLICATION_TOOL.SELECT_FIELD\' | translate}}\" \nmd-on-close=\"_searchField1 = \'\'\" required><md-select-header><section><input force-select-focus type=\"search\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField1\"></section></md-select-header><md-option \nng-repeat=\"field in fields | filter : _searchField1 | orderBy : \'libelle\' track by field.id\" ng-value=\"field\">\n{{field.libelle}}</md-option></md-select><div class=\"\" ng-messages=\"lookForDuplicatesForm.form.field1.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container class=\"\" \nng-if=\"_dtToolData && _dtToolData._modelType == MODELS_TYPES.CONTACT_MODEL\"><md-select name=\"field2\" \nng-model=\"_dtToolData._fields[1]\" placeholder=\"{{\'DUPLICATION_TOOL.SELECT_FIELD\' | translate}}\" \nmd-on-close=\"_searchField2 = \'\'\"><md-select-header><section><input force-select-focus type=\"search\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField2\"></section></md-select-header><md-option \nng-repeat=\"field in fields | filter : _searchField2 | orderBy : \'libelle\' track by field.id\" ng-value=\"field\">\n{{field.libelle}}</md-option></md-select></md-input-container></md-dialog-content><md-dialog-content \nng-if=\"initDataInProgress\"><div layout=\"row\" layout-sm=\"column\" layout-align=\"space-around\" \nclass=\"layout-sm-column layout-align-space-around-stretch layout-row pt-10 mt-10\"><md-progress-circular \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" md-mode=\"indeterminate\">\n</md-progress-circular></div></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button \ntype=\"submit\" ng-click=\"_lookForDuplicates(lookForDuplicatesForm)\" class=\"md-primary md-hue-2 submit-button md-raised\" \nng-disabled=\"lookForDuplicatesForm.$invalid || lookForDuplicatesForm.$pristine || initDataInProgress\" \naria-label=\"Submit\">{{\'DUPLICATION_TOOL.FIND_DUPLICACTE_BTN\' | translate}}</md-button></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/globe_network/companies/filter/filter.html","<div class=\"nl-Block nl-Block--bordered nl-Block--theme1\" ng-repeat=\"arrayFilter in arrayFilters track by $index\"><div \nlayout=\"row\" layout-xs=\"column\" flex layout-wrap layout-align=\"start end\"><div layout=\"row\" \nlayout-align=\"start stretch\" ng-if=\"!filter.notDisplayed\" \nng-repeat=\"filter in arrayFilter.fieldFilters | orderBy: \'fieldFilterIndex\' track by $index\" \nflex=\"{{filter.fieldFilterSize}}\" flex-sm=\"50\" flex-xs=\"100\" ng-show=\"$index < 8 || arrayFilter.showAll\"><div \nng-switch=\"filter.typeChamps\" layout=\"row\" layout-align=\"space-between end\" class=\"nl-Block-item\"><md-input-container \nflex class=\"nl-Block--inputContainer filterDb\" ng-switch-when=\"STRING\"><label><span \nng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label><input\n type=\"text\" ng-model=\"filter.criteria\" ng-enter=\"filterModelFn();\"></md-input-container><md-input-container flex \nclass=\"nl-Block--inputContainer filterDb\" ng-switch-when=\"EMAIL\"><label><span \nng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label><input\n type=\"text\" ng-model=\"filter.criteria\" ng-enter=\"filterModelFn();\"></md-input-container><md-input-container flex \nclass=\"nl-Block--inputContainer filterDb\" ng-switch-when=\"URL\"><label><span \nng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label><input\n type=\"text\" ng-enter=\"filterModelFn();\" ng-pattern=\"/^(https?:\\/\\/)?([\\da-z\\.-]+)\\.([a-z\\.]{2,6})([\\/\\w \\.-]*)*\\/?$/\" \nng-model=\"filter.criteria\"></md-input-container><div ng-switch-when=\"DATE\" layout=\"row\" layout-wrap class=\"w-100p\">\n<md-input-container flex class=\"nl-Block--inputContainer filterDb\" ng-if=\"!filter.customFixeFieldFilter\"><label><span \nng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label>\n<md-datepicker ng-enter=\"filterModelFn();\" class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"filter.dateTime\" ng-change=\"changeDate(filter)\"></md-datepicker>\n</md-input-container><div ng-if=\"filter.customFixeFieldFilter\" class=\"w-100p\"><div><label>{{filter.libelle}}</label>\n</div><div layout=\"row\" layout-align=\"start center\"><md-input-container class=\"nl-Block--inputContainer filterDb\" \nflex=\"50\"><label>min</label><md-datepicker ng-enter=\"filterModelFn();\" class=\"nl-Datepicker nl-Datepicker--fw\" \nmd-open-on-focus md-hide-icons=\"calendar\" ng-model=\"filter.minValue\" ng-change=\"changeDateRangeMin(filter)\">\n</md-datepicker></md-input-container><md-input-container class=\"nl-Block--inputContainer filterDb\" flex=\"50\"><label>max\n</label><md-datepicker ng-enter=\"filterModelFn();\" class=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus \nmd-hide-icons=\"calendar\" ng-model=\"filter.maxValue\" ng-change=\"changeDateRangeMax(filter)\"></md-datepicker>\n</md-input-container></div></div></div><div ng-switch-when=\"INTEGER|NUMBER\" ng-switch-when-separator=\"|\" layout=\"row\" \nlayout-wrap class=\"nl-Form-xs w-100p pr-50\"><md-input-container class=\"nl-Block--inputContainer\" flex=\"30\"><label>\n{{\'COMPANIES.FILTER_COMPARATOR\' | translate}}</label><md-select ng-enter=\"filterModelFn();\" \nng-model=\"filter.comparator\"><md-option value=\"<\">&lt;</md-option><md-option value=\"<=\">&lt;=</md-option><md-option \nvalue=\"=\" selected=\"selected\">=</md-option><md-option value=\">\">></md-option><md-option value=\">=\">>=</md-option>\n</md-select></md-input-container><md-input-container class=\"nl-Block--inputContainer\" \nng-if=\"filter.typeChamps === \'INTEGER\'\" flex><label><span ng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">\nDisposition &nbsp;-&nbsp;</span> <span ng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;\n</span> {{filter.libelle}}</label><input ng-enter=\"filterModelFn();\" type=\"number\" ng-model=\"filter.criteria\" step=\"1\">\n</md-input-container><md-input-container class=\"nl-Block--inputContainer\" ng-if=\"filter.typeChamps === \'NUMBER\'\" flex>\n<label><span ng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label><input\n ng-enter=\"filterModelFn();\" type=\"number\" ng-model=\"filter.criteria\" step=\"any\"></md-input-container></div>\n<md-input-container flex class=\"nl-Block--inputContainer filterDb\" ng-switch-when=\"LONG_STRING|RICH_TEXT\" \nng-switch-when-separator=\"|\"><label><span ng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">\nDisposition &nbsp;-&nbsp;</span> <span ng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;\n</span> {{filter.libelle}}</label><textarea ng-enter=\"filterModelFn();\" md-detect-hidden ng-model=\"filter.criteria\" \nrows=\"3\"></textarea></md-input-container><md-input-container flex class=\"nl-Block--inputContainer filterDb\" \nng-switch-when=\"BOOLEAN\"><label><span ng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">\nDisposition &nbsp;-&nbsp;</span> <span ng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;\n</span> {{filter.libelle}}</label><md-switch ng-enter=\"filterModelFn();\" ng-model=\"filter.criteria\" \naria-label=\"Switch\" class=\"md-primary\"></md-switch></md-input-container><md-input-container flex \nclass=\"nl-Block--inputContainer filterDb\" ng-switch-when=\"LIST_SELECT\"><label><span \nng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label>\n<md-select ng-enter=\"filterModelFn();\" md-on-close=\"filterSelectText = \'\'\" ng-model=\"filter.criteriaObj\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"option in filter.listFieldsDTO | filterText: filterSelectText | orderBy : \'index\'\" ng-value=\"option\">\n{{option.value}}</md-option></md-select></md-input-container><md-input-container flex \nclass=\"nl-Block--inputContainer filterDb\" ng-switch-when=\"MULTIPLE_SELECT\"><label><span \nng-if=\"filter.fixeFieldFilterClazz == \'CompanyDisposition\'\">Disposition &nbsp;-&nbsp;</span> <span \nng-if=\"filter.libellePrefix\">{{filter.libellePrefix | translate}} &nbsp;-&nbsp;</span> {{filter.libelle}}</label>\n<md-select ng-enter=\"filterModelFn();\" ng-model=\"filter.criterias\" multiple=\"multiple\"><md-option \nng-repeat=\"option in filter.listFieldsDTO | orderBy : \'index\'\" ng-value=\"option\">{{option.value}}</md-option>\n</md-select></md-input-container><md-button ng-if=\"filter.typeChamps !== \'INTEGER\' && filter.typeChamps !== \'NUMBER\'\" \nclass=\"md-icon-button md-accent\" aria-label=\"Favorite\" ng-click=\"filter.includeInFilter = !filter.includeInFilter\">\n<md-icon md-font-icon=\"icon-minus-circle-outline\" class=\"icon s18 mb-20\" ng-if=\"!filter.includeInFilter\" \nstyle=\"color:#e53935!important\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked-circle\" class=\"icon s18 mb-20\" \nng-if=\"filter.includeInFilter\" style=\"color:#208abe!important\"></md-icon></md-button></div></div><div layout=\"row\" \nlayout-align=\"start stretch\" flex=\"100\" ng-if=\"arrayFilter.fieldFilters.length > 8\"><md-button type=\"button\" \nclass=\"md-accent md-hue-2 md-teal-theme-theme\" flex=\"100\" ng-click=\"arrayFilter.showAll = !arrayFilter.showAll\">\n<md-icon ng-if=\"!arrayFilter.showAll\" md-font-icon=\"icon-plus-box\"></md-icon><md-icon ng-if=\"arrayFilter.showAll\" \nmd-font-icon=\"icon-minus-box\"></md-icon>{{\'COMPANIES.FILTERS\' | translate}}</md-button></div></div><div layout=\"row\" \nflex layout-wrap ng-if=\"!$first\"><md-button flex=\"100\" md-no-ink class=\"md-warn\" ng-click=\"removeFilterFn($index);\">\n<md-icon md-font-icon=\"icon-trash\"></md-icon>{{\"COMPANIES.REMOVE_EXPAND_SEARCH_LINE\" | translate}}</md-button></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-button target=\"_blank\" flex=\"50\" md-no-ink class=\"md-primary\" \nng-click=\"filterModelFn();\"><md-icon md-font-icon=\"icon-filter-outline\"></md-icon>{{\'COMPANIES.FILTER\' | translate}}\n</md-button><md-button flex=\"50\" md-no-ink class=\"md-accent md-hue-2\" ng-click=\"expandSearchFn();\"><md-icon \nmd-font-icon=\"icon-arrow-expand\"></md-icon>{{\'COMPANIES.EXPAND_SEARCH\' | translate}}</md-button></div>");
$templateCache.put("app/main/globe_network/companies/logs/companyLogs.html","<div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><div layout=\"row\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.DATE\' | translate}}</div></th><th>\n<div>{{\'ADMIN.USERSLOGS.COLUMNS.USER\' | translate}}</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.ENTITY\' | translate}}\n</div></th><th><div>{{\'ADMIN.USERSLOGS.COLUMNS.ACTION\' | translate}}</div></th><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.FIELD_NAME\' | translate}}</div></th><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.OLD_VALUE\' | translate}}</div></th><th><div>\n{{\'ADMIN.USERSLOGS.COLUMNS.NEW_VALUE\' | translate}}</div></th></tr></thead><tbody><tr ng-repeat=\"log in logs\"><td>\n{{log.date | date: \'dd/MM/yyyy à HH:mm\'}}</td><td><div ng-if=\"log.userPic\" class=\"nl-Msg-avatar mr-10\"><img \nclass=\"nl-Table-avatar\" http-src=\"./alternatedocroots/{{log.userPic}}\" has-profile-picture=\"log.userPic != null\"></div>\n<div ng-if=\"log.user\">{{log.user}}</div><div ng-if=\"log.userID\">(id: {{log.userID}})</div></td><td><span \nng-if=\"log.idContact\">{{\'ADMIN.USERSLOGS.ENTITIES.CONTACT\' | translate}}#{{log.idContact}}</span> <span \nng-if=\"!log.idContact\">{{\'ADMIN.USERSLOGS.ENTITIES.COMPANY\' | translate}}</span></td><td>\n{{ ACTIONS[log.action] | translate }}</td><td>{{log.nameField | limitTo: 100}}</td><td>{{log.oldValue | limitTo: 100}}\n</td><td>{{log.newValue | limitTo: 100}}</td></tr></tbody></table></div></div><md-button ng-disabled=\"allLoaded\" \ntype=\"button\" class=\"md-accent\" ng-click=\"getLogs()\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'COMPANIES.LOAD_MORE\' | translate}}</md-button></div>");
$templateCache.put("app/main/globe_network/companies/popup/add_company.html","<md-dialog class=\"admin-user-dialog nl-Modal\" aria-label=\"Add company\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"addCompanyForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'COMPANIES.ADD\' | translate}}</div></div>\n<md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><noo-infos-model \nng-model=\"categories\" edition=\"false\" form-name=\"addCompanyForm\" sub-type=\"subTypeId\" sub-types=\"subTypes\" \nmodel-type=\"modelType\" model=\"newCompany\"></noo-infos-model></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button type=\"submit\" ng-click=\"saveCompany(addCompanyForm)\" \nclass=\"md-primary md-hue-2 submit-button md-raised\" ng-disabled=\"addCompanyForm.$invalid || addCompanyForm.$pristine\" \naria-label=\"Sauvegarder\">{{\'GENERAL.SAVE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/globe_network/companies/popup/bulk_message.html","<md-dialog class=\"nl_Dialog\" aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\"GENERAL.UPDATE\" | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div class=\"nl-Popup-content-body\"><form name=\"formCreateMessage\" novalidate>\n<md-input-container class=\"\"><md-select name=\"modelType\" ng-model=\"message.modelType\" ng-change=\"refreshFields()\" \nplaceholder=\"{{\'COMPANIES.MODEL_TYPE\' | translate}}\" required><md-option ng-repeat=\"modelType in modelTypes\" \nng-value=\"modelType\">{{\'GENERAL.\'+modelType | translate}}</md-option></md-select><div class=\"pl-20\" \nng-messages=\"formCreateMessage.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container><label>\n{{\"MESSAGE.CREATION.RECEIVER\" | translate}}</label><md-select ng-model=\"message.receiverForm\" aria-label=\"language\" \nname=\"receiver\"><md-option value=\"null\">{{\"MESSAGE.CREATION.ALL_USERS\" | translate}}</md-option><md-optgroup \nlabel=\"{{\'MESSAGE.CREATION.USERS\' | translate}}\"><md-option ng-repeat=\"user in users\" value=\"{{user}}\">\n{{user.fullName}}</md-option></md-optgroup></md-select></md-input-container><div \nclass=\"nl_categories-item-subtitle mb-15\">{{\"MESSAGE.CREATION.ACTION_REQUEST\" | translate}}</div><div layout=\"column\">\n<md-input-container flex=\"100\" class=\"mb-0\"><label>{{\"MESSAGE.CREATION.ACTION\" | translate}}</label><md-select \nng-model=\"message.actionForm\" name=\"action\" aria-label=\"language\"><md-option ng-value=\"null\">\n{{\"MESSAGE.CREATION.NO_ACTION\" | translate}}</md-option><md-option ng-repeat=\"action in actions\" value=\"{{action}}\">\n{{action.libelle}}</md-option></md-select></md-input-container><md-input-container ng-if=\"message.actionForm != null\" \nflex=\"100\" class=\"mb-0\"><md-datepicker class=\"nl-Datepicker nl-Datepicker--fw\" md-hide-icons=\"calendar\" \nng-model=\"message.startDateForm\" name=\"actionDate\" md-placeholder=\"{{\'MESSAGE.CREATION.DATE\' | translate}}\" \nmd-open-on-focus ng-required=\"message.actionForm != null\"></md-datepicker><div class=\"pl-20\" \nng-messages=\"formCreateMessage.actionDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container \nng-if=\"message.actionForm != null\" flex=\"100\" class=\"mb-0\"><label class=\"input-prefix\">\n{{\'MESSAGE.CREATION.HOUR\' | translate}} hh:mm</label><input type=\"text\" class=\"input-value\" name=\"actionTime\" \nng-model=\"message.startTime\" ui-time-mask=\"short\" required><div class=\"pl-20\" \nng-messages=\"formCreateMessage.actionTime.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div><div ng-message=\"time\"><span>\n{{\"GENERAL.FORM.INVALID_FORMAT\" | translate}} (hh:mm)</span></div></div><div ng-if=\"timeNotMatch\" \nclass=\"ng-scope nl_form-error-input\"><span>{{\"FESTIVAL.TIME_ERROR\" | translate}}</span></div></md-input-container>\n<md-input-container ng-if=\"message.actionForm !== null\" class=\"m-0\" flex=\"100\"><md-switch class=\"md-primary\" \nng-model=\"message.actionDone\" aria-label=\"Switch 1\">{{\"MESSAGE.CREATION.DONE\" | translate}}</md-switch>\n</md-input-container></div><div class=\"nl_categories-item-subtitle mb-15\">{{\"MESSAGE.TITLE\" | translate}}</div><div \nlayout=\"column\"><md-input-container class=\"md-block mb-0\" flex-gt-sm><label>{{\"MESSAGE.CREATION.SUBJECT\"|translate}}\n</label><input ng-model=\"message.subject\" name=\"subject\" maxlength=\"255\" required><div class=\"pl-20\" \nng-messages=\"formCreateMessage.subject.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"md-block mb-0\" \nflex-gt-sm><label>{{\"MESSAGE.CREATION.CONTENT\"|translate}}</label><textarea rows=\"4\" ng-model=\"message.content\" \nname=\"content\" required></textarea><div class=\"pl-20\" ng-messages=\"formCreateMessage.content.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><md-button \nmd-no-ink class=\"md-raised md-primary\" ng-disabled=\"formCreateMessage.$invalid\" ng-click=\"saveMessage()\">\n{{\"GENERAL.SAVE\" | translate }}</md-button><md-button md-no-ink class=\"md-accent md-hue-2\" aria-label=\"Annuler\" \nng-click=\"cancelFormMessage()\">{{\"GENERAL.CANCEL\" | translate }}</md-button></form></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/globe_network/companies/popup/bulk_update.html","<md-dialog class=\"company-disposition-dialog nl-Modal\" aria-label=\"Disposition\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"bulkUpdateForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'COMPANIES.BULK_UPDATE\' | translate}}</div>\n</div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"\">\n<md-select name=\"modelType\" ng-model=\"bulkUpdateDTO.modelType\" ng-change=\"refreshFields()\" \nplaceholder=\"{{\'COMPANIES.MODEL_TYPE\' | translate}}\" required><md-option ng-repeat=\"modelType in modelTypes\" \nng-value=\"modelType\">{{\'GENERAL.\'+modelType | translate}}</md-option></md-select><div class=\"pl-20\" \nng-messages=\"bulkUpdateForm.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"bulkUpdateDTO.modelType != null\"><md-select name=\"field\" ng-model=\"bulkUpdateDTO.field\" \nng-change=\"bulkUpdateDTO.field.fieldEditable = true; bulkUpdateDTO.field.selectableObject = bulkUpdateDTO.field.listFieldsDTO\" \nplaceholder=\"{{\'COMPANIES.FIELD\' | translate}}\" required><md-option \nng-repeat=\"field in fields | orderBy: \'libelle\' track by $index\" ng-value=\"field\">{{field.libelle}}</md-option>\n</md-select><div class=\"pl-20\" ng-messages=\"bulkUpdateForm.field.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><noo-input form-name=\"bulkUpdateForm\" \nng-if=\"bulkUpdateDTO.field != null\" edition=\"true\" ng-model=\"bulkUpdateDTO.field\" index=\"0\" \ncontent=\"{{bulkUpdateDTO.field.typeChamps}}\" big-display-area=\"valueField.bigDisplayArea\" model-type=\"modelType\">\n</noo-input></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"button\" \nng-click=\"bulkUpdate();\" md-no-ink class=\"md-primary md-hue-2 md-raised\" \nng-disabled=\"bulkUpdateForm.$invalid || bulkUpdateForm.$pristine || bulkUpdating\" aria-label=\"Sauvegarder\"><div \nclass=\"nl-loader\" ng-show=\"bulkUpdating\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div \nclass=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div>\n</div>{{\'GENERAL.SAVE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/globe_network/companies/popup/confirm_duplicates_removal.html","<md-dialog aria-label=\"Confirm\" md-theme=\"teal-theme\"><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">\n{{\'COMPANIES.AUTO_MERGE_CONFIRM_TITLE\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content>{{\'COMPANIES.AUTO_MERGE_CONFIRM_MSG\' | translate}}</md-dialog-content>\n<md-dialog-actions layout=\"row\"><div layout=\"row\" layout-align=\"center center\"><md-progress-circular ng-if=\"loading\" \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate\" md-mode=\"indeterminate\" md-diameter=\"24\">\n</md-progress-circular><md-button ng-if=\"!loading\" md-no-ink class=\"md-raised md-primary md-hue-2\" \nng-click=\"_companiesDuplicatesAutoMergeFn()\" translate=\"GENERAL.YES\"></md-button></div><md-button \nclass=\"md-warn md-hue-2\" ng-click=\"hidePopup()\" translate=\"GENERAL.NO\"></md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/globe_network/companies/popup/disposition.html","<md-dialog class=\"nl_Dialog company-disposition-dialog nl-Modal\" aria-label=\"Disposition\" flex=\"40\" \nmd-theme=\"teal-theme\"><form name=\"companyDisposiotionForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\" ng-if=\"!newDisposition.id\">{{\'COMPANIES.DISPOSITION.ADD\' | translate}}</div><div \nclass=\"contact-name\" ng-if=\"newDisposition.id\">{{\'COMPANIES.DISPOSITION.MAJ\' | translate}}</div></div><md-button \nclass=\"md-icon-button\" ng-click=\"$mdDialog.cancel();\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container class=\"\"><input type=\"text\" \nname=\"name\" ng-model=\"newDisposition.name\" placeholder=\"{{\'COMPANIES.DISPOSITION.NAME\' | translate}}\" required><div \nclass=\"pl-20\" ng-messages=\"companyDisposiotionForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\"><input \ntype=\"number\" ng-model=\"newDisposition.squareMeter\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.SQUARE_METTER\' | translate}}\"></md-input-container><md-input-container class=\"\">\n<input type=\"number\" ng-model=\"newDisposition.squareFeet\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.SQUARE_FEET\' | translate}}\"></md-input-container><md-input-container class=\"\">\n<input type=\"number\" ng-model=\"newDisposition.length\" placeholder=\"{{\'COMPANIES.DISPOSITION.LENGTH\' | translate}}\">\n</md-input-container><md-input-container class=\"\"><input type=\"number\" ng-model=\"newDisposition.width\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.WIDTH\' | translate}}\"></md-input-container><md-input-container class=\"\"><input \ntype=\"number\" ng-model=\"newDisposition.height\" placeholder=\"{{\'COMPANIES.DISPOSITION.HEIGHT\' | translate}}\">\n</md-input-container><md-input-container class=\"\"><md-switch ng-model=\"newDisposition.dayLight\" aria-label=\"Switch\" \nclass=\"md-primary\">{{\'COMPANIES.DISPOSITION.DAY_LIGHT\' | translate}}</md-switch></md-input-container>\n<md-input-container class=\"\"><input type=\"number\" ng-model=\"newDisposition.theatre\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.THEATER\' | translate}}\"></md-input-container><md-input-container class=\"\"><input \ntype=\"number\" ng-model=\"newDisposition.classRoom\" placeholder=\"{{\'COMPANIES.DISPOSITION.CLASS_ROOM\' | translate}}\">\n</md-input-container><md-input-container class=\"\"><input type=\"number\" ng-model=\"newDisposition.boardRoom\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.BOARD_ROOM\' | translate}}\"></md-input-container><md-input-container class=\"\">\n<input type=\"number\" ng-model=\"newDisposition.uStyle\" placeholder=\"{{\'COMPANIES.DISPOSITION.U_STYLE\' | translate}}\">\n</md-input-container><md-input-container class=\"\"><input type=\"number\" ng-model=\"newDisposition.banquet\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.BANQUET\' | translate}}\"></md-input-container><md-input-container class=\"\"><input \ntype=\"number\" ng-model=\"newDisposition.cocktail\" placeholder=\"{{\'COMPANIES.DISPOSITION.COCKTAIL\' | translate}}\">\n</md-input-container><md-input-container class=\"\"><input type=\"number\" ng-model=\"newDisposition.conference\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.CONFERENCE\' | translate}}\"></md-input-container><md-input-container class=\"\">\n<input type=\"number\" ng-model=\"newDisposition.cabaret\" placeholder=\"{{\'COMPANIES.DISPOSITION.CABARET\' | translate}}\">\n</md-input-container><md-input-container class=\"\"><input type=\"number\" ng-model=\"newDisposition.auditorium\" \nplaceholder=\"{{\'COMPANIES.DISPOSITION.AUDITORIUM\' | translate}}\"></md-input-container></md-dialog-content>\n<md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"button\" ng-if=\"newDisposition.id\" \nng-click=\"deleteCompanyDisposition(newDisposition.id)\" md-no-ink class=\"md-warn md-hue-2\" aria-label=\"Supprimer\">\n{{\'GENERAL.DELETE\' | translate}}</md-button><md-button type=\"submit\" ng-click=\"saveCompanyDisposition();\" md-no-ink \nclass=\"md-primary md-hue-2 md-raised\" \nng-disabled=\"companyDisposiotionForm.$invalid || companyDisposiotionForm.$pristine\" aria-label=\"Sauvegarder\">\n{{\'GENERAL.SAVE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/globe_network/companies/sort/sort.html","<div layout=\"row\" layout-align=\"end center\"><md-input-container class=\"\" ng-repeat=\"sort in modelSortsDto.sorts\">\n<md-select ng-model=\"sort.fieldSortSelected\" placeholder=\"{{\'COMPANIES.COMPANY_SORT.SORT_BY\' | translate}}\" \nng-change=\"sortModelFn();\"><md-option ng-repeat=\"option in sort.fieldSorts | orderBy : \'fieldSortIndex\'\" \nng-value=\"option\"><span ng-show=\"option.fieldSortBaseType == \'FIXE_FIELD\'\">{{ option.libelle | translate}}</span> <span\n ng-hide=\"option.fieldSortBaseType == \'FIXE_FIELD\'\">{{option.libelle}}</span><md-icon ng-if=\"option.sortType == \'ASC\'\" \nmd-font-icon=\"icon-sort-ascending\" class=\"md-default-theme md-font material-icons\" role=\"img\" aria-hidden=\"true\">\n</md-icon><md-icon ng-if=\"option.sortType == \'DESC\'\" md-font-icon=\"icon-sort-descending\" \nclass=\"md-default-theme md-font material-icons\" role=\"img\" aria-hidden=\"true\"></md-icon></md-option></md-select>\n</md-input-container></div>");
$templateCache.put("app/main/globe_network/companies/statsClicks/statsClicks.html","<div class=\"content\"><div class=\"nl-Block\"><div class=\"nl_categories-item-title\" layout=\"row\" \nlayout-align=\"space-between center\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}</div><md-input-container><label>\n{{\'STATS_CLICKS.PERIOD_MODE\' | translate}}</label><md-select ng-model=\"periodMode.value\" name=\"periodMode\"><md-option \nng-repeat=\"period in periodModes\" ng-value=\"period.value\">{{period.name}}</md-option></md-select></md-input-container>\n<div layout=\"row\"><md-datepicker flex ng-if=\"periodMode.value === \'day\' || periodMode.value === \'custom\'\" \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-hide-icons=\"calendar\" ng-model=\"filter.date\" name=\"date\" \nmd-placeholder=\"{{\'BLOG.CREATION.DATE\' | translate}}\" md-open-on-focus></md-datepicker><md-datepicker flex \nng-if=\"periodMode.value === \'custom\'\" class=\"nl-Datepicker nl-Datepicker--fw\" md-hide-icons=\"calendar\" \nng-model=\"filter.dateCustom\" name=\"date\" md-placeholder=\"{{\'BLOG.CREATION.DATE\' | translate}}\" md-open-on-focus>\n</md-datepicker></div><div layout=\"row\"><md-input-container ng-if=\"periodMode.value === \'month\'\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.MONTH\' | translate}}</label><md-select ng-model=\"filter.month\" name=\"filterMonth\">\n<md-option ng-value=\"month.value\" ng-repeat=\"month in monthNames track by $index\">\n{{ \'GENERAL.MONTH_NAMES.\' + month.value | translate }}</md-option></md-select></md-input-container><md-input-container \nng-if=\"periodMode.value === \'month\' || periodMode.value === \'year\'\"><label>\n{{\'STATISTICS.EDIT.SELECT_PERIOD.YEAR\' | translate}}</label><md-select ng-model=\"filter.year\"><md-select-header><input \ntype=\"number\" min=\"0\" step=\"1\" ng-model=\"customYear.value\" onkeydown=\"mdSelectOnKeyDownOverride(event)\"><md-button \nng-click=\"searchStatisticsCustomYear()\" class=\"m-0\">{{\'GENERAL.OK\' | translate}}</md-button></md-select-header>\n<md-option ng-value=\"year\" ng-repeat=\"year in yearValues\">{{year}}</md-option><md-option value=\"custom\" \nstyle=\"display: none\">{{customYear.value}}</md-option></md-select></md-input-container></div><md-button \nclass=\"md-raised md-primary md-hue-2\" md-no-ink ng-click=\"getStatistics()\">{{\'STATISTICS.DISPLAY.FILTER\' | translate}}\n</md-button></div><div class=\"nl-Block nl-Block--table\" ng-if=\"statistics.clicks != null\"><div class=\"nl-listing\">\n<table class=\"simple list-view\"><thead><th>{{\"STATS_CLICKS.COLUMNS.TYPE\" | translate}}</th><th>\n{{\"STATS_CLICKS.COLUMNS.NBR\" | translate}}</th></thead><tbody><tr ng-repeat=\"stat in statistics.clicks\"><td>\n{{\"STATS_CLICKS.TYPES.\" + stat.type | translate}}</td><td>{{stat.nbr}}</td></tr></tbody></table></div></div></div>");
$templateCache.put("app/main/globe_network/inscriptions/settings/inscriptions_admin_settings.html","");
$templateCache.put("app/main/mailing/blocs/bloc/bloc.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"MAILING.BLOCS.ADD\" \nng-if=\"!bloc.id\"></div><div class=\"\" translate=\"MAILING.BLOCS.MAJ\" ng-if=\"bloc.id\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" class=\"\" \nng-click=\"_blocsListFn()\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n{{\'MAILING.BLOCS.LIST\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"_delete()\" ng-if=\"bloc.id\">\n<md-icon md-font-icon=\"icon-delete-variant\"></md-icon>{{\'MAILING.ACTIONS.DELETE\' | translate}}</md-button><md-button \ntype=\"button\" class=\"\" ng-click=\"_save(blocForm)\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n{{\'MAILING.ACTIONS.SAVE\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\">\n<div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"\" ng-click=\"_blocsListFn()\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon>{{\'MAILING.BLOCS.LIST\' | translate}}</md-button><md-button \ntype=\"button\" class=\"\" ng-click=\"_delete()\" ng-if=\"bloc.id\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>\n{{\'MAILING.ACTIONS.DELETE\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"_save(blocForm)\">\n<md-icon md-font-icon=\"icon-content-save\"></md-icon>{{\'MAILING.ACTIONS.SAVE\' | translate}}</md-button></div></div>\n</div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp p-40\"><div layout=\"column\"><form name=\"blocForm\" \nclass=\"md-inline-form\" novalidate><md-input-container class=\"\"><input type=\"text\" name=\"name\" ng-model=\"bloc.name\" \nplaceholder=\"{{\'MAILING.BLOCS.FIELDS.NAME\' | translate}}\" required><div class=\"\" ng-messages=\"blocForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container class=\"\"><md-select name=\"type\" ng-model=\"bloc.type\" \nplaceholder=\"{{\'MAILING.BLOCS.FIELDS.TYPE\' | translate}}\" required ng-change=\"getBloc()\"><md-option \nng-repeat=\"_thisType in types | orderBy : \'translation\' track by $index\" ng-value=\"_thisType.value\" \nng-selected=\"_thisType.value == bloc.type\">{{_thisType.translation | translate}}</md-option></md-select><div class=\"\" \nng-messages=\"blocForm.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"\" ng-if=\"loaded\"><textarea name=\"html\" \nid=\"{{\'html\' + (bloc.id ? bloc.id : -1)}}\" ng-model=\"bloc.html\" ng-init=\"initBeautify(bloc)\" rows=\"20\" required>\n</textarea><div class=\"\" ng-messages=\"blocForm.html.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></form></div></div></div></div>");
$templateCache.put("app/main/mailing/expeditors/popup/addExpeditor.dialog.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add expeditor\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"addExpeditorForm\" class=\"md-inline-form\" ng-submit=\"addExpeditor()\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\"><span ng-if=\"expeditor.id\">{{\'MAILING.EXPEDITORS.UPDATE\' | translate}} </span><span \nng-if=\"!expeditor.id\">{{\'MAILING.EXPEDITORS.ADD\' | translate}}</span></div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-input-container class=\"nl-Input-container\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"expeditor.name\" name=\"name\" maxlength=\"255\" required><label class=\"\" translate=\"MAILING.EXPEDITORS.NAME\">\n</label><div ng-messages=\"addExpeditorForm.name.$error\"><span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}\n</span></div></md-input-container><md-input-container class=\"nl-Input-container\" flex=\"100\"><input type=\"text\" \nclass=\"\" ng-pattern=\"/^[a-z]+[a-z0-9._]+@[a-z]+\\.[a-z.]{2,5}$/\" ng-model=\"expeditor.mail\" name=\"mail\" maxlength=\"255\" \nrequired><label class=\"\" translate=\"MAILING.EXPEDITORS.MAIL\"></label><div ng-messages=\"addExpeditorForm.mail.$error\">\n<span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span> <span ng-message=\"pattern\">\n{{\'GENERAL.FORM.INVALID_FORMAT\' | translate}}</span></div></md-input-container><md-input-container \nclass=\"nl-Input-container\" flex=\"100\"><input type=\"password\" minlength=\"6\" class=\"\" ng-model=\"expeditor.password\" \nname=\"password\" maxlength=\"255\" ng-required=\"expeditor.id != null ? false: true\"><label class=\"\" \ntranslate=\"MAILING.EXPEDITORS.PASSWORD\"></label><div ng-messages=\"addExpeditorForm.password.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span> <span ng-message=\"minlength\">\n{{\'GENERAL.EXPEDITORS.ERROR_LENGTH\' | translate}}</span></div></md-input-container><span ng-if=\"expeditor.id != null\">\n{{\'GENERAL.EXPEDITORS.PASSWORD_CHANGE\' | translate}}</span></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button type=\"submit\" class=\"md-primary md-hue-2 submit-button md-raised\" \nng-disabled=\"addExpeditorForm.$invalid || addExpeditorForm.$pristine\" aria-label=\"Save\">{{\'GENERAL.SAVE\' | translate}}\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mailing/pages/page/duplicate.dialog.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add expeditor\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"duplicatePageForm\" class=\"md-inline-form\" ng-submit=\"duplicate()\"><md-toolbar class=\"nl-Modal-header\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\" translate=\"MAILING.PAGES.DUPLICATE\"></div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><md-input-container class=\"nl-Input-container\" flex=\"100\"><input type=\"text\" class=\"\" \nng-model=\"pageToDuplicate.name\" name=\"name\" maxlength=\"255\" required><label class=\"\" \ntranslate=\"MAILING.PAGES.FIELDS.NAME\"></label><div ng-messages=\"duplicatePageForm.mail.$error\"><span \nng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></md-dialog-content>\n<md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nclass=\"md-primary md-hue-2 submit-button md-raised\" \nng-disabled=\"duplicatePageForm.$invalid || duplicatePageForm.$pristine\" aria-label=\"Save\">\n{{\'GENERAL.SAVE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mailing/pages/page/page.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"MAILING.PAGES.ADD\" \nng-if=\"!page.id\"></div><div class=\"\" translate=\"MAILING.PAGES.MAJ\" ng-if=\"page.id\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" class=\"\" \nng-click=\"_pagesListFn()\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n{{\'MAILING.PAGES.LIST\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"exportToHtmlFile()\">\n<md-icon md-font-icon=\"icon-export\"></md-icon>{{\'MAILING.ACTIONS.EXPORT_TO_HTML_FILE\' | translate}}</md-button>\n<md-button type=\"button\" class=\"\" ng-click=\"_viewSrcCode()\"><md-icon md-font-icon=\"icon-code-braces\"></md-icon><span \nng-if=\"!showSrcCode\">{{\'MAILING.ACTIONS.SHOW_SOURCE_CODE\' | translate}}</span> <span ng-if=\"showSrcCode\">\n{{\'MAILING.ACTIONS.HIDE_SOURCE_CODE\' | translate}}</span></md-button><md-button type=\"button\" class=\"\" \nng-click=\"previewMail()\"><md-icon md-font-icon=\"icon-responsive\"></md-icon>{{\'MAILING.ACTIONS.PREVIEW\' | translate}}\n</md-button><md-button type=\"button\" class=\"\" ng-click=\"_delete()\" ng-if=\"page.id\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>{{\'MAILING.ACTIONS.DELETE\' | translate}}</md-button><md-button \ntype=\"button\" class=\"\" ng-click=\"_save(pageForm)\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n{{\'MAILING.ACTIONS.SAVE\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" class=\"nl-FixedRightBar\">\n<div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div class=\"nl-FixedRightBar-panel\"><div \nlayout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"\" ng-click=\"_pagesListFn()\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon>{{\'MAILING.PAGES.LIST\' | translate}}</md-button><md-button \ntype=\"button\" class=\"\" ng-click=\"exportToHtmlFile()\"><md-icon md-font-icon=\"icon-export\"></md-icon>\n{{\'MAILING.ACTIONS.EXPORT_TO_HTML_FILE\' | translate}}</md-button><md-button type=\"button\" class=\"\" \nng-click=\"_viewSrcCode()\"><md-icon md-font-icon=\"icon-code-braces\"></md-icon><span ng-if=\"!showSrcCode\">\n{{\'MAILING.ACTIONS.SHOW_SOURCE_CODE\' | translate}}</span> <span ng-if=\"showSrcCode\">\n{{\'MAILING.ACTIONS.HIDE_SOURCE_CODE\' | translate}}</span></md-button><md-button type=\"button\" class=\"\" \nng-click=\"previewMail()\"><md-icon md-font-icon=\"icon-responsive\"></md-icon>{{\'MAILING.ACTIONS.PREVIEW\' | translate}}\n</md-button><md-button type=\"button\" class=\"\" ng-click=\"_delete()\" ng-if=\"page.id\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>{{\'MAILING.ACTIONS.DELETE\' | translate}}</md-button><md-button \ntype=\"button\" class=\"\" ng-click=\"_save(pageForm)\"><md-icon md-font-icon=\"icon-content-save\"></md-icon>\n{{\'MAILING.ACTIONS.SAVE\' | translate}}</md-button></div></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp p-40 mb-20\" ng-if=\"showSrcCode\"><div layout=\"column\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"\"><md-input-container><textarea name=\"pageSrcCode\" rows=\"3\" ng-model=\"pageSrcCode\" \nreadonly=\"readonly\" \nstyle=\"border-width: 2px 2px 2px 2px!important;\n                border-color: rgb(13, 164, 180)!important\" class=\"m-5\">\n</textarea></md-input-container></div></div></div><div class=\"white-bg md-whiteframe-4dp p-40\"><div layout=\"column\">\n<form name=\"pageForm\" class=\"md-inline-form\" novalidate><md-input-container class=\"\"><input type=\"text\" name=\"name\" \nng-model=\"page.name\" placeholder=\"{{\'MAILING.PAGES.FIELDS.NAME\' | translate}}\" required><div class=\"\" \nng-messages=\"pageForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"mt-20 mb-40\"><md-select ng-model=\"page.tags\" \nmultiple=\"multiple\" placeholder=\"{{\'MAILING.PAGES.FIELDS.TAGS\' | translate}}\" \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"tag in tags | orderBy : \'index\' track by $index\" \nng-value=\"tag\">{{tag.name}}</md-option></md-select></md-input-container><md-input-container class=\"mt-20 mb-20\">\n<md-select name=\"language\" ng-model=\"page.language\" placeholder=\"{{\'MAILING.PAGES.FIELDS.LANGUAGE\' | translate}}\" \nng-change=\"_changeLanguageFn();\" required ng-model-options=\"{trackBy: \'$value.key\'}\"><md-option \nng-repeat=\"lang in languages | orderBy : \'libelle\'\" ng-value=\"lang\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select><label>\n{{\'MAILING.TRIGGERS.FIELDS.LANGUAGE\' | translate}}</label><div class=\"\" ng-messages=\"pageForm.language.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container class=\"mt-40\"><input type=\"text\" name=\"subject\" ng-model=\"page.subject\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS.SUBJECT\' | translate}}\" required><div class=\"\" \nng-messages=\"pageForm.subject.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"\"><input type=\"text\" name=\"nameSender\" \nng-model=\"page.nameSender\" placeholder=\"{{\'MAILING.PAGES.FIELDS.SENDER_NAME\' | translate}}\"></md-input-container>\n<md-input-container class=\"\"><input type=\"email\" name=\"emailSender\" ng-model=\"page.emailSender\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS.SENDER_EMAIL\' | translate}}\"><div class=\"\" \nng-messages=\"pageForm.emailSender.$error\" role=\"alert\"><div ng-message=\"pattern\"><span>\n{{\"GENERAL.PATTERN\" | translate}}</span></div></div></md-input-container><md-input-container class=\"mt-40\"><textarea \nname=\"head\" rows=\"3\" ng-model=\"page.htmlHeader\" placeholder=\"{{\'MAILING.PAGES.FIELDS.HTML_HEADER\' | translate}}\">\n</textarea></md-input-container><fieldset class=\"fieldset-100 standard mt-20 mb-20\" \nng-repeat=\"_pageBloc in page.pageBlocs | orderBy : \'index\' track by $index\"><div layout=\"row\"><md-input-container \nclass=\"\" flex=\"80\"><md-select name=\"bloc{{$index}}\" ng-model=\"_pageBloc.bloc\" \nplaceholder=\"{{\'MAILING.PAGES.FIELDS.BLOC\' | translate}}\" ng-change=\"_changePageBlocFn(_pageBloc);\" required \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"_thisBloc in blocs | orderBy : \'name\' track by _thisBloc.id\" ng-value=\"_thisBloc\">{{_thisBloc.name}}\n</md-option></md-select><div class=\"\" ng-messages=\"pageForm[\'bloc\'+$index].$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div \nclass=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"moveBloc(_pageBloc, true, pageForm)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"$index==0\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-click=\"moveBloc(_pageBloc, false, pageForm)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"($index == page.pageBlocs.length-1)\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon>\n</md-button></div><md-button md-no-ink class=\"nl-listing-item-button md-accent\" type=\"button\" \nng-click=\"showHtml(_pageBloc)\" flex=\"20\">Show html</md-button></div><md-input-container class=\"\" \nng-if=\"_pageBloc.showHtml\"><textarea ng-init=\"initBeautify(_pageBloc,$index)\" id=\"{{\'html\' + $index}}\" \nname=\"html{{$index}}\" ng-model=\"_pageBloc.html\" required></textarea><div class=\"\" \nng-messages=\"pageForm[\'html\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div \nng-repeat=\"_pageBlocTranslation in _pageBloc.pageBlocTranslations  | orderBy : \'index\' track by $index\">\n<md-input-container class=\"\" ng-if=\"!_pageBlocTranslation.simpleField\"><md-select name=\"value{{$index}}\" \nng-model=\"_pageBlocTranslation.field\" placeholder=\"{{_getCleanKey(_pageBlocTranslation.key)}}\" \nng-required=\"!_pageBlocTranslation.simpleField\" md-on-close=\"_searchField = \'\'\" \nng-model-options=\"{trackBy: \'$value.id + $value.libelle + $value.inscriptionFieldFormId\'}\"><md-select-header><section>\n<input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField\"></section>\n</md-select-header><md-optgroup label=\"\" ng-if=\"fields.contact.length>0\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\"></label><md-option \nng-repeat=\"field in fields.contact | filter : _searchField | orderBy : \'libelle\'\" ng-value=\"field\">{{field.libelle}}\n</md-option></md-optgroup><md-optgroup label=\"\" ng-if=\"fields.company.length>0\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></label><md-option \nng-repeat=\"field in fields.company | filter : _searchField | orderBy : \'libelle\'\" ng-value=\"field\">{{field.libelle}}\n</md-option></md-optgroup><md-optgroup label=\"\" ng-if=\"fields.company.length>0\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_INSCRIPTION\"></label><md-option \nng-repeat=\"field in fields.inscription | filter : _searchField | orderBy : \'libelle\'\" ng-value=\"field\">\n{{field.libelle}}</md-option></md-optgroup></md-select><label>{{_getCleanKey(_pageBlocTranslation.key)}}</label><div \nclass=\"\" ng-messages=\"pageForm[\'value\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"\" \nng-if=\"_pageBlocTranslation.simpleField\"><textarea name=\"value{{$index}}\" ng-model=\"_pageBlocTranslation.value\" \nng-required=\"_pageBlocTranslation.simpleField\"></textarea><label>{{_getCleanKey(_pageBlocTranslation.key)}}</label><div\n class=\"\" ng-messages=\"pageForm[\'value\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><md-button type=\"button\" class=\"\" \nng-click=\"_removePageBlocFn(_pageBloc.id, pageForm)\" ng-if=\"blocs.length > 0\"><md-icon \nmd-font-icon=\"icon-delete-variant\"></md-icon>{{\'MAILING.ACTIONS.DELETE\' | translate}}</md-button></fieldset><div \nlayout=\"row\" layout-align=\"start center\" class=\"pt-20\"><md-button type=\"button\" class=\"\" \nng-click=\"_addPageBlocFn(pageForm)\" ng-if=\"blocs.length > 0\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n{{\'MAILING.PAGES.ADD_BLOC\' | translate}}</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/mailing/triggers/trigger/trigger.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"MAILING.TRIGGERS.ADD\" \nng-if=\"!trigger.id\"></div><div class=\"\" translate=\"MAILING.TRIGGERS.MAJ\" ng-if=\"trigger.id\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" class=\"\" \nng-click=\"_triggersListFn()\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n{{\'MAILING.TRIGGERS.LIST\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"_delete()\" \nng-if=\"trigger.id\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>{{\'MAILING.ACTIONS.DELETE\' | translate}}\n</md-button><md-button type=\"button\" class=\"\" ng-click=\"_save(triggerForm)\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon>{{\'MAILING.ACTIONS.SAVE\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" \nclass=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div \nclass=\"nl-FixedRightBar-panel\"><div layout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"\" \nng-click=\"_triggersListFn()\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n{{\'MAILING.TRIGGERS.LIST\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"_delete()\" \nng-if=\"trigger.id\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>{{\'MAILING.ACTIONS.DELETE\' | translate}}\n</md-button><md-button type=\"button\" class=\"\" ng-click=\"_save(triggerForm)\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon>{{\'MAILING.ACTIONS.SAVE\' | translate}}</md-button></div></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp p-40\"><div layout=\"column\"><form name=\"triggerForm\" class=\"md-inline-form\" \nnovalidate><md-input-container class=\"\"><input type=\"text\" name=\"name\" ng-model=\"trigger.name\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS.NAME\' | translate}}\" required><div class=\"\" \nng-messages=\"triggerForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"mt-20\"><md-select name=\"type\" \nng-model=\"trigger.type\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS.TYPE\' | translate}}\" required \nng-change=\"_triggerTypeChangeFn();\"><md-option ng-repeat=\"type in types | orderBy : \'value\'\" ng-value=\"type.value\">\n{{\'MAILING.TRIGGERS.TYPES.\'+ type.value | translate}}</md-option></md-select><label>\n{{\'MAILING.TRIGGERS.FIELDS.TYPE\' | translate}}</label><div class=\"\" ng-messages=\"triggerForm.type.$error\" role=\"alert\">\n<div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container class=\"mt-40\" ng-if=\"trigger.type && trigger.type == \'DROPDOWN_TRIGGER\'\"><md-select \nname=\"modelType\" ng-model=\"trigger.modelType\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS.MODEL_TYPE\' | translate}}\" \nng-required=\"trigger.type && trigger.type ==\'DROPDOWN_TRIGGER\'\" ng-change=\"_modelTypeChangeFn();\"><md-option \nng-repeat=\"modelType in MODELS_TYPES track by $index\" ng-value=\"modelType\">{{\'GENERAL.\' + modelType | translate}}\n</md-option></md-select><label>{{\'MAILING.TRIGGERS.FIELDS.MODEL_TYPE\' | translate}}</label><div class=\"\" \nng-messages=\"triggerForm.modelType.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div layout=\"row\" layout-wrap \nng-if=\"trigger.type && trigger.type == \'DROPDOWN_TRIGGER\'\"><div class=\"nl-info-block-list-img animated fadeIn\" \nflex=\"60\"><md-input-container class=\"mt-40\"><md-select name=\"field\" ng-model=\"trigger.field\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS.FIELD\' | translate}}\" \nng-required=\"trigger.type && trigger.type ==\'DROPDOWN_TRIGGER\'\" md-on-close=\"_searchField = \'\'\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"_fieldChangeFn();\"><md-select-header><section><input \nforce-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchField\"></section>\n</md-select-header><md-option ng-if=\"trigger.modelType==\'CONTACT_MODEL\'\" \nng-repeat=\"field in fields.contact | filter : { typeChamps : \'LIST_SELECT\' } | filter : _searchField | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option><md-option ng-if=\"trigger.modelType==\'COMPANY_MODEL\'\" \nng-repeat=\"field in fields.company | filter : { typeChamps : \'LIST_SELECT\' } | filter : _searchField | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option><md-option ng-if=\"trigger.modelType==\'INSCRIPTION_MODEL\'\" \nng-repeat=\"field in fields.inscription | filter : { typeChamps : \'LIST_SELECT\' } | filter : _searchField | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option><md-option ng-if=\"trigger.modelType==\'LOGISTIC_MODEL\'\" \nng-repeat=\"field in fields.logistic | filter : { typeChamps : \'LIST_SELECT\' } | filter : _searchField | orderBy : \'libelle\'\" \nng-value=\"field\">{{field.libelle}}</md-option></md-select><label>{{\'MAILING.TRIGGERS.FIELDS.FIELD\' | translate}}\n</label><div class=\"\" ng-messages=\"triggerForm.field.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><div \nclass=\"nl-info-block-list-img animated fadeIn\" flex=\"40\"><md-input-container class=\"mt-40\"><md-select \nname=\"fieldValue\" ng-model=\"trigger.fieldValue\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS.FIELD_VALUE\' | translate}}\" \nng-required=\"trigger.type && trigger.type ==\'DROPDOWN_TRIGGER\'\" md-on-close=\"_searchFieldValue = \'\'\" \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-select-header><section><input force-select-focus type=\"search\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchFieldValue\"></section></md-select-header><md-option \nng-repeat=\"fieldValue in trigger.field.listFieldsDTO | filter : _searchFieldValue | orderBy : \'value\'\" \nng-value=\"fieldValue\">{{fieldValue.value}}</md-option></md-select><label>\n{{\'MAILING.TRIGGERS.FIELDS.FIELD_VALUE\' | translate}}</label><div class=\"\" ng-messages=\"triggerForm.fieldValue.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container></div></div><div layout=\"row\" layout-wrap \nng-if=\"trigger.type && trigger.type == \'REGISTRATION_VALIDATED_TRIGGER\'\"><div \nclass=\"nl-info-block-list-img animated fadeIn\" flex=\"60\"><md-input-container class=\"mt-40\"><md-select name=\"event\" \nng-model=\"trigger.event\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS.EVENT\' | translate}}\" \nng-required=\"trigger.type && trigger.type ==\'REGISTRATION_VALIDATED_TRIGGER\'\" md-on-close=\"_searchEvent = \'\'\" \nng-model-options=\"{trackBy: \'$value.id\'}\" ng-change=\"listRegistrationFormsByEvent(trigger.event);\"><md-select-header>\n<section><input force-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchEvent\">\n</section></md-select-header><md-option ng-repeat=\"_event in events | filter : _searchEvent | orderBy : \'name\'\" \nng-value=\"_event\">{{_event.name}}</md-option></md-select><label>{{\'MAILING.TRIGGERS.FIELDS.EVENT\' | translate}}</label>\n<div class=\"\" ng-messages=\"triggerForm.event.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><div \nclass=\"nl-info-block-list-img animated fadeIn\" flex=\"40\"><md-input-container class=\"mt-40\"><md-select \nname=\"registrationForm\" ng-model=\"trigger.registrationForm\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS.REGISTRATION_FORM\' | translate}}\" \nng-required=\"trigger.type && trigger.type ==\'REGISTRATION_VALIDATED_TRIGGER\'\" \nmd-on-close=\"_searchRegistrationForm = \'\'\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-select-header><section><input \nforce-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchRegistrationForm\">\n</section></md-select-header><md-option \nng-repeat=\"registrationForm in registrationForms | filter : _searchRegistrationForm | orderBy : \'name\'\" \nng-value=\"registrationForm\">{{registrationForm.name}}</md-option></md-select><label>\n{{\'MAILING.TRIGGERS.FIELDS.REGISTRATION_FORM\' | translate}}</label><div class=\"\" \nng-messages=\"triggerForm.registrationForm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div></div><md-input-container \nclass=\"mt-40\" ng-if=\"trigger.type\"><md-select name=\"recipients\" ng-model=\"trigger.recipients\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS.RECIPIENTS\' | translate}}\" required multiple=\"multiple\" \nmd-on-close=\"_searchRecipient = \'\'\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-select-header><section><input \nforce-select-focus type=\"search\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"_searchRecipient\"></section>\n</md-select-header><md-optgroup label=\"\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\"></label><md-option \nng-repeat=\"recipient in fields.contact | filter : { typeChamps : \'EMAIL\' } | filter : _searchRecipient | orderBy : \'libelle\' track by recipient.id\" \nng-value=\"recipient\">{{recipient.libelle}}</md-option></md-optgroup><md-optgroup label=\"\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></label><md-option \nng-repeat=\"recipient in fields.company | filter : { typeChamps : \'EMAIL\' } | filter : _searchRecipient | orderBy : \'libelle\' track by recipient.id\" \nng-value=\"recipient\">{{recipient.libelle}}</md-option></md-optgroup></md-select><label>\n{{\'MAILING.TRIGGERS.FIELDS.RECIPIENTS\' | translate}}</label><div class=\"\" ng-messages=\"triggerForm.recipients.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container class=\"mt-40\" ng-if=\"trigger.type\"><md-select name=\"template\" \nng-model=\"trigger.template\" placeholder=\"{{\'MAILING.TRIGGERS.FIELDS.TEMPLATE\' | translate}}\" required \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"template in pages | orderBy : \'name\'\" \nng-value=\"template\">{{template.name}}</md-option></md-select><label>{{\'MAILING.TRIGGERS.FIELDS.TEMPLATE\' | translate}}\n</label><div class=\"\" ng-messages=\"triggerForm.template.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container class=\"mt-40\" \nng-if=\"trigger.type\"><md-select name=\"language\" ng-model=\"trigger.language\" \nplaceholder=\"{{\'MAILING.TRIGGERS.FIELDS.LANGUAGE\' | translate}}\" required ng-model-options=\"{trackBy: \'$value.key\'}\">\n<md-option ng-repeat=\"lang in languages | orderBy : \'libelle\'\" ng-value=\"lang\">\n{{\'SETTINGS.DATABASE.LANGUAGES.\'+ lang.key | translate}}</md-option></md-select><label>\n{{\'MAILING.TRIGGERS.FIELDS.LANGUAGE\' | translate}}</label><div class=\"\" ng-messages=\"triggerForm.language.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container></form></div></div></div></div>");
$templateCache.put("app/main/request_for_proposal/request_for_proposal_members/details/details_member.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\" md-theme=\"teal-theme\"><div \nclass=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"\">{{ \"REQUEST_FOR_PROPOSAL.MEMBERS\" | translate}}</div></div>\n</div><div class=\"content\"><div class=\"nl-Block nl-Block--table\"><div class=\"nl-panel-header\">\n{{ \"REQUEST_FOR_PROPOSAL.MEMBER_INFOS\" | translate}}</div><div layout=\"column\" class=\"p-20\"><div flex><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_COMPANY\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{member.user.applicantCompany}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_COMPANY_TYPE\" | translate}} :</div>\n<div class=\"nl-prestataire-search-item-text\">{{member.user.applicantCompanyType}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_WEB_SITE\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{member.user.applicantWebSite}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_CIVILITY\" | translate}}/ {{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_FIRST_NAME\" | translate}}/ {{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_LAST_NAME\" | translate}} :\n</div><div class=\"nl-prestataire-search-item-text\">\n{{member.user.applicantCivility}} {{member.user.applicantFirstName}} {{member.user.applicantLastName}}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_FUNCTION\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{member.user.applicantFunction}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_ADDRESS\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{member.user.applicantAddress1}}</div><div \nclass=\"nl-prestataire-search-item-text\" ng-if=\"member.user.applicantAddress2\">, {{member.user.applicantAddress2}}</div>\n<div class=\"nl-prestataire-search-item-text\" ng-if=\"member.user.applicantAddress3\">, {{member.user.applicantAddress3}}\n</div><div class=\"nl-prestataire-search-item-text\" \nng-if=\"member.user.applicantPostCode || member.user.applicantCity || member.user.applicantCountry\">\n, {{member.user.applicantPostCode}} {{member.user.applicantCity}}, {{member.user.applicantCountry}}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_DIRECT_PHONE\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{member.user.applicantDirectPhone}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_MOBILE_PHONE\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">{{member.user.applicantMobilePhone}}</div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\">\n{{ \"REQUEST_FOR_PROPOSAL.FIELDS.APPLICANT_EMAIL\" | translate}} :</div><div class=\"nl-prestataire-search-item-text\">\n{{member.user.mail}}</div></div><div layout=\"row\" layout-align=\"start center\"><div \nclass=\"nl-prestataire-search-item-strong\">{{ \"REQUEST_FOR_PROPOSAL.FIELDS.HOW_MUCH\" | translate}} :</div><div \nclass=\"nl-prestataire-search-item-text\">\n{{member.rfp}} ( {{ \"REQUEST_FOR_PROPOSAL.FIELDS.IN_PROGRESS\" | translate}} : {{member.inProgress}}, {{ \"REQUEST_FOR_PROPOSAL.FIELDS.FINISH\" | translate}} : {{member.finish}})\n</div></div></div></div></div></div></div>");
$templateCache.put("app/main/settings/research_page_creation/includes/filters.html","<div class=\"nl-Block mt-15\"><div><div class=\"nl_categories-item-title nl_categories-item-title--first\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.ADD_FIELD_TO_FILTER_ENGINE\"></span></div></div><div \nng-repeat=\"filter in filters | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><h3 class=\"\" ng-if=\"filter.baseType == \'MODEL_FIELD\'\"><span \nng-if=\"filter.fieldModelDto && filter.fieldModelDto.modelType == companyModelType\" \ntranslate=\"SETTINGS.DATABASE.COMPANY.TITLE\"></span> <span \nng-if=\"filter.fieldModelDto && filter.fieldModelDto.modelType == contactModelType\" \ntranslate=\"SETTINGS.DATABASE.CONTACT.TITLE\"></span> <span \nng-if=\"filter.fieldModelDto && filter.fieldModelDto.modelType == registrationModelType\" \ntranslate=\"SETTINGS.DATABASE.REGISTRATION.TITLE\"></span> <span \nng-if=\"filter.fieldModelDto && filter.fieldModelDto.modelType == logisticModelType\" \ntranslate=\"SETTINGS.DATABASE.LOGISTIC.TITLE\"></span> &nbsp;-&nbsp; {{filter.fieldModelDto.libelle}}</h3><h3 \nclass=\"panel-title\" ng-if=\"filter.baseType == \'FIXE_FIELD\'\"><span \nng-if=\"filter.fixeFieldDto && filter.fixeFieldDto.data.clazz == \'CompanyDisposition\'\">Disposition</span> <span \nng-if=\"filter.fixeFieldDto && (filter.fixeFieldDto.data.clazz == \'Contact\' || filter.fixeFieldDto.data.clazz == \'Company\')\" \ntranslate=\"SETTINGS.DATABASE.COMPANY.TITLE\"></span> <span \nng-if=\"filter.fixeFieldDto && (filter.fixeFieldDto.data.clazz == \'InscriptionSubCategory\'\n                  || filter.fixeFieldDto.data.clazz == \'InscriptionStatus\' || filter.fixeFieldDto.data.clazz == \'Event\')\" \ntranslate=\"SETTINGS.DATABASE.REGISTRATION.TITLE\"></span> <span \nng-if=\"filter.fixeFieldDto && filter.fixeFieldDto.data.clazz == \'LogisticalStatus\'\" \ntranslate=\"SETTINGS.DATABASE.LOGISTIC.TITLE\"></span> &nbsp;-&nbsp; <span translate=\"{{filter.fixeFieldDto.libelle}}\">\n</span></h3></div><div class=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" \nng-click=\"delete({config : \'FILTER\', data : filter });\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon>\n</md-button><div class=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"!(filter.index > 1)\" \nng-click=\"upFieldFilterOrSort({config : \'FILTER\', data : filter });\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\">\n</md-icon></md-button><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(filter.index != filters.length)\" ng-click=\"downFieldFilterOrSort({config : \'FILTER\', data : filter });\">\n<md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon></md-button></div></div></div></div></div></div></div>\n<form name=\"researchPageCreationFilterForm\" role=\"form\" novalidate><div layout=\"row\" \nlayout-align=\"space-between center\"><md-input-container class=\"\"><md-select md-on-close=\"filterSelectText = \'\'\" \nname=\"newFieldToFilter\" id=\"newFieldToFilter\" ng-model=\"newFieldToFilter.data\" placeholder=\" \" flex><md-select-header>\n<section><input force-select-focus type=\"text\" onkeydown=\"mdSelectOnKeyDownOverride(event)\" \nng-model=\"filterSelectText\"></section></md-select-header><md-optgroup label=\"\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></label><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsForFiltersFiltered | filterText: filterSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == companyModelType || (field.data && field.data.clazz == \'AbstractModel\')  || (field.data && field.data.clazz == \'Contact\') || (field.data && field.data.clazz == \'Company\')\">\n<span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\">\n</span></md-option></md-optgroup><md-optgroup label=\"\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\">\n</label><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsForFiltersFiltered | filterText: filterSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == contactModelType\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span \nng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-optgroup><md-optgroup label=\"\" \nng-if=\"modelType == \'COMPANY_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_DISPOSITION\"></label><md-option \nng-value=\"field\" ng-repeat=\"field in fieldsForFiltersFiltered | filterText: filterSelectText | orderBy: \'libelle\'\" \nng-if=\"field.data && field.data.clazz == \'CompanyDisposition\'\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span>\n <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-optgroup><md-optgroup label=\"\" \nng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_INSCRIPTION\"></label>\n<md-option ng-value=\"field\" \nng-repeat=\"field in fieldsForFiltersFiltered | filterText: filterSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == registrationModelType || (field.data && field.data.name == \'FIXE_FIELD_REGISTRATION_SUBCATEGORY\')\n                || (field.data && field.data.name == \'FIXE_FIELD_REGISTRATION_STATUS\' || field.data && field.data.name == \'FIXE_FIELD_EVENT\')\">\n<span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\">\n</span></md-option></md-optgroup><md-optgroup label=\"\" ng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_LOGISTIC\"></label><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsForFiltersFiltered | filterText: filterSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == logisticModelType || (field.data && field.data.name == \'FIXE_FIELD_LOGISTIC_STATUS\')\"><span \nng-if=\"field.modelType\">{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span>\n</md-option></md-optgroup></md-select><div ng-messages=\"researchPageCreationFilterForm.newFieldToFilter.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container><div><md-button \ntype=\"button\" class=\"md-raised md-primary md-hue-2\" ng-click=\"save({ config : \'FILTER\' });\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div></form></div>");
$templateCache.put("app/main/settings/research_page_creation/includes/sorting.html","<div class=\"nl-Block mt-15\"><div><div class=\"nl_categories-item-title nl_categories-item-title--first\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.ADD_FIELD_TO_SORT\">{{modelType}}</span></div></div><div \nng-repeat=\"sort in sorts | orderBy:\'index\'\" class=\"nl-Models-item\"><div><div><div layout=\"row\" \nlayout-align=\"space-between center\"><div><h3 class=\"\" ng-if=\"sort.baseType == \'MODEL_FIELD\'\">\n{{sort.fieldModelDto.libelle}}</h3><h3 class=\"panel-title\" ng-if=\"sort.baseType == \'FIXE_FIELD\'\"><span \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.{{sort.fixeFieldDto.data.name}}\"></span></h3></div><div \nclass=\"panel-actions panel-actions-keep\" layout=\"row\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"button\" class=\"md-fab md-mini md-warn md-hue-2\" ng-click=\"delete({config : \'SORT\', data : sort });\"><md-icon \nmd-font-icon=\"icon-delete\" class=\"s18\"></md-icon></md-button><div class=\"ml-15\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"!(sort.index > 1)\" ng-click=\"upFieldFilterOrSort({config : \'SORT\', data : sort });\"><md-icon \nmd-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button type=\"button\" \nclass=\"md-fab md-mini md-primary md-hue-2\" ng-disabled=\"!(sort.index != sorts.length)\" \nng-click=\"downFieldFilterOrSort({config : \'SORT\', data : sort });\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\">\n</md-icon></md-button></div></div></div></div></div></div></div><form name=\"researchPageCreationSortForm\" role=\"form\" \nnovalidate><div layout=\"row\" layout-align=\"space-between center\"><md-input-container class=\"\"><md-select \nmd-on-close=\"sortSelectText = \'\'\" name=\"newFieldToSort\" id=\"newFieldToSort\" ng-model=\"newFieldToSort.data\" \nplaceholder=\"\"><md-select-header><section><input force-select-focus type=\"text\" \nonkeydown=\"mdSelectOnKeyDownOverride(event)\" ng-model=\"sortSelectText\"></section></md-select-header><md-option \nng-value=\"field\" ng-repeat=\"field in fieldsForSortsFiltered | filterText: sortSelectText | orderBy: \'libelle\'\" \nng-if=\"modelType == \'COMPANY_MODEL\'\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span \nng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option><md-optgroup label=\"\" \nng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_COMPANY\"></label><md-option \nng-value=\"field\" ng-repeat=\"field in fieldsForSortsFiltered | filterText: sortSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == companyModelType\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span \nng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-optgroup><md-optgroup label=\"\" \nng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_CONTACT\"></label><md-option \nng-value=\"field\" ng-repeat=\"field in fieldsForSortsFiltered | filterText: sortSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == contactModelType\"><span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span \nng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span></md-option></md-optgroup><md-optgroup label=\"\" \nng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label translate=\"SETTINGS.DATABASE.MODELS.TITLE_INSCRIPTION\"></label>\n<md-option ng-value=\"field\" \nng-repeat=\"field in fieldsForSortsFiltered | filterText: sortSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == registrationModelType || (field.data && field.data.name == \'FIXE_FIELD_REGISTRATION_SUBCATEGORY\') \n                  || (field.data && field.data.name == \'FIXE_FIELD_REGISTRATION_STATUS\')\">\n<span ng-if=\"field.modelType\">{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\">\n</span></md-option></md-optgroup><md-optgroup label=\"\" ng-if=\"modelType == \'INSCRIPTION_MODEL\'\"><label \ntranslate=\"SETTINGS.DATABASE.MODELS.TITLE_LOGISTIC\"></label><md-option ng-value=\"field\" \nng-repeat=\"field in fieldsForSortsFiltered | filterText: sortSelectText | orderBy: \'libelle\'\" \nng-if=\"field.modelType == logisticModelType || (field.data && field.data.name == \'FIXE_FIELD_LOGISTIC_STATUS\')\"><span \nng-if=\"field.modelType\">{{ field.libelle }}</span> <span ng-if=\"!field.modelType\" translate=\"{{field.libelle}}\"></span>\n</md-option></md-optgroup></md-select><div ng-messages=\"researchPageCreationSortForm.newFieldToSort.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>Obligatoire.</span></div></div></md-input-container><div><md-button \ntype=\"button\" class=\"md-raised md-primary md-hue-2\" ng-click=\"save({ config : \'SORT\' });\"><md-icon \nmd-font-icon=\"icon-plus\" class=\"s18\"></md-icon>{{\'GENERAL.ADD\' | translate}}</md-button></div></div></form></div>");
$templateCache.put("app/main/sites_management/pages/page/page.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"SITES_MANAGEMENT.PAGES.ADD\" \nng-if=\"!page.id\"></div><div class=\"\" translate=\"SITES_MANAGEMENT.PAGES.MAJ\" ng-if=\"page.id\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" class=\"\" \nng-click=\"_pagesListFn()\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n{{\'SITES_MANAGEMENT.PAGES.LIST\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"_delete()\" \nng-if=\"page.id\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>{{\'SITES_MANAGEMENT.ACTIONS.DELETE\' | translate}}\n</md-button><md-button type=\"button\" class=\"\" ng-click=\"_save(pageForm)\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon>{{\'SITES_MANAGEMENT.ACTIONS.SAVE\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" \nclass=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div \nclass=\"nl-FixedRightBar-panel\"><div layout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"\" \nng-click=\"_pagesListFn()\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n{{\'SITES_MANAGEMENT.PAGES.LIST\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"_delete()\" \nng-if=\"page.id\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>{{\'SITES_MANAGEMENT.ACTIONS.DELETE\' | translate}}\n</md-button><md-button type=\"button\" class=\"\" ng-click=\"_save(pageForm)\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon>{{\'SITES_MANAGEMENT.ACTIONS.SAVE\' | translate}}</md-button></div></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp p-40\"><div layout=\"column\"><form name=\"pageForm\" class=\"md-inline-form\" novalidate>\n<md-input-container class=\"\"><input type=\"text\" name=\"name\" ng-model=\"page.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.PAGES.FIELDS.NAME\' | translate}}\" required><div class=\"\" \nng-messages=\"pageForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"\"><md-select name=\"site\" ng-model=\"page.sites\" \nmultiple=\"multiple\" ng-change=\"_changeSiteFn();\" required ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"_thisSite in sites | orderBy : \'name\' track by _thisSite.id\" ng-value=\"_thisSite\">{{_thisSite.name}}\n</md-option></md-select><label class=\"\" translate=\"SITES_MANAGEMENT.PAGES.FIELDS.SITE\"></label><div class=\"\" \nng-messages=\"pageForm.site.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"mt-40\"><md-select name=\"language\" \nng-model=\"page.targetLanguage\" ng-change=\"_changeLanguageFn($index);\" required \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-repeat=\"lang in languages | orderBy : \'libelle\'\" \nng-value=\"lang\">{{lang.libelle}}</md-option></md-select><label class=\"\" \ntranslate=\"SITES_MANAGEMENT.SITES.FIELDS.LANGUAGE\"></label><div class=\"\" ng-messages=\"pageForm.language.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><fieldset class=\"fieldset-100 standard mt-20 mb-20\" \nng-repeat=\"_pageBloc in page.pageBlocs | orderBy : \'index\' track by $index\"><div layout=\"row\"><md-input-container \nclass=\"\" flex=\"80\"><md-select name=\"bloc{{$index}}\" ng-model=\"_pageBloc.bloc\" \nplaceholder=\"{{\'SITES_MANAGEMENT.PAGES.FIELDS.BLOC\' | translate}}\" ng-change=\"_changePageBlocFn($index);\" required \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"_thisBloc in blocs | orderBy : \'name\' track by _thisBloc.id\" ng-value=\"_thisBloc\">{{_thisBloc.name}}\n</md-option></md-select><div class=\"\" ng-messages=\"pageForm[\'bloc\'+$index].$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div \nclass=\"ml-15\" layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"moveBloc(_pageBloc, true, pageForm)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"$index==0\"><md-icon md-font-icon=\"icon-arrow-up\" class=\"s18\"></md-icon></md-button><md-button \nng-click=\"moveBloc(_pageBloc, false, pageForm)\" type=\"button\" class=\"md-fab md-mini md-primary md-hue-2\" \nng-disabled=\"($index == page.pageBlocs.length-1)\"><md-icon md-font-icon=\"icon-arrow-down\" class=\"s18\"></md-icon>\n</md-button></div><md-button md-no-ink class=\"nl-listing-item-button md-accent\" type=\"button\" \nng-click=\"showHtml(_pageBloc)\" flex=\"20\">Show html</md-button></div><md-input-container class=\"\" \nng-if=\"_pageBloc.showHtml\"><textarea ng-init=\"initBeautify(_pageBloc,$index)\" id=\"{{\'html\' + $index}}\" \nname=\"html{{$index}}\" ng-model=\"_pageBloc.html\" required></textarea><div class=\"\" \nng-messages=\"pageForm[\'html\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div \nng-repeat=\"_pageBlocTranslation in _pageBloc.pageBlocTranslations | orderBy: \'index\' track by $index\">\n<md-input-container class=\"\"><textarea name=\"value{{$index}}\" ng-model=\"_pageBlocTranslation.value\" required>\n</textarea><label>{{_getCleanKey(_pageBlocTranslation.key)}}</label><div class=\"\" \nng-messages=\"pageForm[\'value\'+$index].$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><md-button type=\"button\" class=\"\" \nng-click=\"_removePageBlocFn(_pageBloc, pageForm)\" ng-if=\"blocs.length > 0\"><md-icon md-font-icon=\"icon-delete-variant\">\n</md-icon>{{\'SITES_MANAGEMENT.ACTIONS.DELETE\' | translate}}</md-button></fieldset><div layout=\"row\" \nlayout-align=\"start center\" class=\"pt-20\"><md-button type=\"button\" class=\"\" ng-click=\"_addPageBlocFn(pageForm)\" \nng-if=\"blocs.length > 0\"><md-icon md-font-icon=\"icon-plus\"></md-icon>{{\'SITES_MANAGEMENT.PAGES.ADD_BLOC\' | translate}}\n</md-button></div></form></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/actualites.template.type.html","<div class=\"nl_Row-content\"><div class=\"pt-60\"><div class=\"nl-Details__mainTitle\">Actualités</div></div><div \nclass=\"nl-relArticle__item nl-relArticle__floating flex-100\" role=\"button\"><div class=\"nl-relArticle__item__inner\"><div\n class=\"nl-relArticle__imgWrapper\"><img class=\"nl-relArticle__img nl-relArticle__img--noLogo\" \nsrc=\"assets/images/logo/pure.png\" alt=\"\"></div><div class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">\nTitre Article 1</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">Description en 2 ou 3 lignes\n</div><div class=\"nl-relArticle__btn\"><span>Lire la suite</span></div></div></div></div></div><div layout=\"row\" \nlayout-wrap layout-align=\"start start\"><div class=\"nl-relArticle__item nl-relArticle__floating flex-100 flex-gt-sm-50\" \nrole=\"button\"><div class=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"></div><div \nclass=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">Titre Article 1</div><div class=\"nl-relArticle__aside\">\n<div class=\"nl-relArticle__date\">Description en 2 ou 3 lignes</div><div class=\"nl-relArticle__btn\"><span>Lire la suite\n</span></div></div></div></div></div><div class=\"nl-relArticle__item nl-relArticle__floating flex-100 flex-gt-sm-50\" \nrole=\"button\"><div class=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"></div><div \nclass=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">Titre Article 2</div><div class=\"nl-relArticle__aside\">\n<div class=\"nl-relArticle__date\">Description en 2 ou 3 lignes</div><div class=\"nl-relArticle__btn\"><span>Lire la suite\n</span></div></div></div></div></div></div><div layout=\"row\" layout-wrap layout-align=\"start start\"><div \nclass=\"nl-relArticle__item nl-relArticle__item--long flex-100\" role=\"button\"><div class=\"nl-relArticle__item__inner\" \nlayout=\"row\"><div class=\"nl-relArticle__imgWrapper flex-33\"><img class=\"nl-relArticle__img nl-relArticle__img--noLogo\" \nsrc=\"assets/images/logo/pure.png\" alt=\"\"></div><div class=\"nl-relArticle__infos nl-relArticle__infos--alt\"><div \nclass=\"nl-relArticle__title\">Titre Article 3</div><div layout=\"row\" layout-wrap layout-align=\"space-between start\"><div\n class=\"nl-relArticle__date flex-sm-100\">Description en 2 ou 3 lignes</div><div class=\"nl-relArticle__btn\"><span>\nLire la suite</span></div></div></div></div></div><div class=\"nl-relArticle__item nl-relArticle__item--long flex-100\" \nrole=\"button\"><div class=\"nl-relArticle__item__inner\" layout=\"row\"><div class=\"nl-relArticle__imgWrapper flex-33\"><img \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"></div><div \nclass=\"nl-relArticle__infos nl-relArticle__infos--alt\"><div class=\"nl-relArticle__title\">Titre Article 4</div><div \nlayout=\"row\" layout-wrap layout-align=\"space-between start\"><div class=\"nl-relArticle__date flex-sm-100\">\nDescription en 2 ou 3 lignes</div><div class=\"nl-relArticle__btn\"><span>Lire la suite</span></div></div></div></div>\n</div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/article.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-prestataire-search--slick\" \nng-if=\"article.photos && article.photos.length > 0\"><div class=\"nl_slick--wrapper\"><button type=\"button\" \nng-click=\"_articleSlickConfig.method.slickPrev()\" class=\"nl_slick--button\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_articleSlickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"_articleSlickConfig\" \nclass=\"nl_slick nl_slick--article\"><div class=\"nl_slick--slide\" ng-repeat=\"_photo in article.photos\"><img \nclass=\"nl_slick--slide--img\" ng-src=\"{{_photo.url}}\" alt=\"\"></div></slick></div></div><div layout=\"row\" \nclass=\"nl-prestataire-search-item\" layout-wrap><div flex=\"70\" class=\"pr-20\" flex-sm=\"100\" flex-xs=\"100\" \nflex-order-sm=\"2\" flex-order-xs=\"2\"><div layout=\"column\"><div class=\"nl-titre--main nl--item\">{{article.name}}</div>\n<div><div class=\"nl-prestataire-search-item-description ql-editor\" ng-bind-html=\"trustAsHtml(article.content)\"></div>\n</div></div></div><div flex=\"30\" class=\"nl-prestataire-search-item-side\" flex-sm=\"100\" flex-xs=\"100\" flex-order-sm=\"1\" \nflex-order-xs=\"1\"><div layout=\"column\"><div class=\"nl-prestataire-search-detail-aside\"><div \nclass=\"nl-prestataire-search-item-title title--panel\">Date:</div><div class=\"nl-prestataire-search-item-text mb-10\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date:article.dateStart} }}</div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/article_100.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-relArticle__item nl-relArticle__floating flex-100\" \nng-init=\"getArticle(\'{{{Article Page Name}}}\',{{{Article_ID}}})\"><div class=\"nl-relArticle__item__inner\" \nng-click=\"details(news)\"><div class=\"nl-relArticle__imgWrapper\"><img \nng-if=\"news.photos == null || news.photos.length === 0\" class=\"nl-relArticle__img nl-relArticle__img--noLogo\" \nsrc=\"assets/images/logo/pure.png\" alt=\"\"> <img ng-if=\"news.photos != null && news.photos.length > 0\" \nclass=\"nl-relArticle__img\" ng-src=\"{{URL.alternatedocroots + \'/\' + news.miniature.location}}\" alt=\"\"></div><div \nclass=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{news.name}}</div><div class=\"nl-relArticle__aside\">\n<div class=\"nl-relArticle__date\">{{\'GENERAL.DATE_FORMAT\' | translate: {date: news.dateStart} }}</div><div \nclass=\"nl-relArticle__text\">{{news.shortDescription}}</div><div class=\"nl-relArticle__btn\" role=\"button\" \nng-click=\"$event.stopPropagation();details(news)\"><span>{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div>\n</div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/article_25.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" layout-wrap layout-align=\"start start\" \nng-init=\"getArticlesForSpecial(\'{{{Article Page Name}}}\',{{{Article_1_ID}}},{{{Article_2_ID}}},{{{Article_3_ID}}},{{{Article_4_ID}}})\">\n<div class=\"nl-relArticle__item flex-100 flex-gt-sm-50 flex-gt-md-25\" role=\"button\" \nng-click=\"details(folderDTO.article1)\"><div class=\"nl-relArticle__item__inner\"><div ng-if=\"folderDTO.article1\" \nclass=\"nl-relArticle__imgWrapper\"><img \nng-if=\"folderDTO.article1.photos == null || folderDTO.article1.photos.length === 0\" \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"> <img \nng-if=\"folderDTO.article1.photos != null && folderDTO.article1.photos.length > 0\" class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + folderDTO.article1.miniature.location}}\" alt=\"\"></div><div \nng-if=\"folderDTO.article1\" class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{folderDTO.article1.name}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: folderDTO.article1.dateStart} }}</div><div class=\"nl-relArticle__btn\" \nrole=\"button\" ng-click=\"$event.stopPropagation();details(folderDTO.article1.id)\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div><div \nclass=\"nl-relArticle__item flex-100 flex-gt-sm-50 flex-gt-md-25\" role=\"button\" ng-click=\"details(folderDTO.article2)\">\n<div class=\"nl-relArticle__item__inner\"><div ng-if=\"folderDTO.article2\" class=\"nl-relArticle__imgWrapper\"><img \nng-if=\"folderDTO.article2.photos == null || folderDTO.article2.photos.length === 0\" \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"> <img \nng-if=\"folderDTO.article2.photos != null && folderDTO.article2.photos.length > 0\" class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + folderDTO.article2.miniature.location}}\" alt=\"\"></div><div \nng-if=\"folderDTO.article2\" class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{folderDTO.article2.name}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: folderDTO.article2.dateStart} }}</div><div class=\"nl-relArticle__btn\" \nrole=\"button\" ng-click=\"$event.stopPropagation();details(folderDTO.article2)\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div><div \nclass=\"nl-relArticle__item flex-100 flex-gt-sm-50 flex-gt-md-25\" role=\"button\" ng-click=\"details(folderDTO.article3)\">\n<div class=\"nl-relArticle__item__inner\"><div ng-if=\"folderDTO.article3\" class=\"nl-relArticle__imgWrapper\"><img \nng-if=\"folderDTO.article3.photos == null || folderDTO.article3.photos.length === 0\" \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"> <img \nng-if=\"folderDTO.article3.photos != null && folderDTO.article3.photos.length > 0\" class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + folderDTO.article3.miniature.location}}\" alt=\"\"></div><div \nng-if=\"folderDTO.article3\" class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{folderDTO.article3.name}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: folderDTO.article3.dateStart} }}</div><div class=\"nl-relArticle__btn\" \nrole=\"button\" ng-click=\"$event.stopPropagation();details(folderDTO.article3)\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div><div \nclass=\"nl-relArticle__item flex-100 flex-gt-sm-50 flex-gt-md-25\" role=\"button\" ng-click=\"details(folderDTO.article4)\">\n<div class=\"nl-relArticle__item__inner\"><div ng-if=\"folderDTO.article4\" class=\"nl-relArticle__imgWrapper\"><img \nng-if=\"folderDTO.article4.photos == null || folderDTO.article4.photos.length === 0\" \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"> <img \nng-if=\"folderDTO.article4.photos != null && folderDTO.article4.photos.length > 0\" class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + folderDTO.article4.miniature.location}}\" alt=\"\"></div><div \nng-if=\"folderDTO.article4\" class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{folderDTO.article4.name}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: folderDTO.article4.dateStart} }}</div><div class=\"nl-relArticle__btn\" \nrole=\"button\" ng-click=\"$event.stopPropagation();details(folderDTO.article4)\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/article_33.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" layout-wrap layout-align=\"start start\" \nng-init=\"getArticlesForSpecial(\'{{{Article Page Name}}}\',{{{Article_1_ID}}},{{{Article_2_ID}}},{{{Article_3_ID}}})\">\n<div class=\"nl-relArticle__item flex-100 flex-gt-md-33\" role=\"button\" ng-click=\"details(folderDTO.article1)\"><div \nclass=\"nl-relArticle__item__inner\"><div ng-if=\"folderDTO.article1\" class=\"nl-relArticle__imgWrapper\"><img \nng-if=\"folderDTO.article1.photos == null || folderDTO.article1.photos.length === 0\" \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"> <img \nng-if=\"folderDTO.article1.photos != null && folderDTO.article1.photos.length > 0\" class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + folderDTO.article1.miniature.location}}\" alt=\"\"></div><div \nng-if=\"folderDTO.article1\" class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{folderDTO.article1.name}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: folderDTO.article1.dateStart} }}</div><div class=\"nl-relArticle__btn\" \nrole=\"button\" ng-click=\"$event.stopPropagation();details(folderDTO.article1)\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div><div \nclass=\"nl-relArticle__item flex-100 flex-gt-md-33\" role=\"button\" ng-click=\"details(folderDTO.article2)\"><div \nclass=\"nl-relArticle__item__inner\"><div ng-if=\"folderDTO.article2\" class=\"nl-relArticle__imgWrapper\"><img \nng-if=\"folderDTO.article2.photos == null || folderDTO.article2.photos.length === 0\" \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"> <img \nng-if=\"folderDTO.article2.photos != null && folderDTO.article2.photos.length > 0\" class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + folderDTO.article2.miniature.location}}\" alt=\"\"></div><div \nng-if=\"folderDTO.article2\" class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{folderDTO.article2.name}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: folderDTO.article2.dateStart} }}</div><div class=\"nl-relArticle__btn\" \nrole=\"button\" ng-click=\"$event.stopPropagation();details(folderDTO.article2)\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div><div \nclass=\"nl-relArticle__item flex-100 flex-gt-md-33\" role=\"button\" ng-click=\"details(folderDTO.article3)\"><div \nclass=\"nl-relArticle__item__inner\"><div ng-if=\"folderDTO.article3\" class=\"nl-relArticle__imgWrapper\"><img \nng-if=\"folderDTO.article3.photos == null || folderDTO.article3.photos.length === 0\" \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"> <img \nng-if=\"folderDTO.article3.photos != null && folderDTO.article3.photos.length > 0\" class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + folderDTO.article3.miniature.location}}\" alt=\"\"></div><div \nng-if=\"folderDTO.article3\" class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{folderDTO.article3.name}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: folderDTO.article3.dateStart} }}</div><div class=\"nl-relArticle__btn\" \nrole=\"button\" ng-click=\"details(folderDTO.article3)\"><span>{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div>\n</div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/article_50.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" layout-wrap layout-align=\"start start\" \nng-init=\"getArticlesForSpecial(\'{{{Article Page Name}}}\',{{{Article_1_ID}}},{{{Article_2_ID}}})\"><div \nclass=\"nl-relArticle__item nl-relArticle__floating flex-100 flex-gt-md-50\" role=\"button\" \nng-click=\"details(folderDTO.article1)\"><div class=\"nl-relArticle__item__inner\"><div ng-if=\"folderDTO.article1\" \nclass=\"nl-relArticle__imgWrapper\"><img \nng-if=\"folderDTO.article1.photos == null || folderDTO.article1.photos.length === 0\" \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"> <img \nng-if=\"folderDTO.article1.photos != null && folderDTO.article1.photos.length > 0\" class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + folderDTO.article1.miniature.location}}\" alt=\"\"></div><div \nng-if=\"folderDTO.article1\" class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{folderDTO.article1.name}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: folderDTO.article1.dateStart} }}</div><div \nclass=\"nl-relArticle__text flex-sm-100\">{{folderDTO.article1.shortDescription}}</div><div class=\"nl-relArticle__btn\" \nrole=\"button\" ng-click=\"$event.stopPropagation();details(folderDTO.article1)\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div><div \nclass=\"nl-relArticle__item nl-relArticle__floating flex-100 flex-gt-md-50\" role=\"button\" \nng-click=\"details(folderDTO.article2)\"><div class=\"nl-relArticle__item__inner\"><div ng-if=\"folderDTO.article2\" \nclass=\"nl-relArticle__imgWrapper\"><img \nng-if=\"folderDTO.article2.photos == null || folderDTO.article2.photos.length === 0\" \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"> <img \nng-if=\"folderDTO.article2.photos != null && folderDTO.article2.photos.length > 0\" class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + folderDTO.article2.miniature.location}}\" alt=\"\"></div><div \nng-if=\"folderDTO.article2\" class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{folderDTO.article2.name}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: folderDTO.article2.dateStart} }}</div><div \nclass=\"nl-relArticle__text flex-sm-100\">{{folderDTO.article2.shortDescription}}</div><div class=\"nl-relArticle__btn\" \nrole=\"button\" ng-click=\"$event.stopPropagation();details(folderDTO.article2)\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/article_pure.template.type.html","<div class=\"nl-Article__slick\" ng-if=\"article.photos && article.photos.length > 0\"><div class=\"nl_slick--wrapper\">\n<button type=\"button\" ng-click=\"_articleSlickConfig.method.slickPrev()\" class=\"nl_slick--button\"><img \nclass=\"nl-Slick__arrow\" src=\"assets/images/slick/back_thin_white.svg\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_articleSlickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nclass=\"nl-Slick__arrow\" src=\"assets/images/slick/next_thin_white.svg\" alt=\"\"></button><slick \nsettings=\"_articleSlickConfig\" class=\"nl_slick nl_Slick__article\"><div class=\"nl_slick--slide\" \nng-repeat=\"_photo in article.photos\"><img class=\"nl_slick--slide--img\" ng-src=\"{{_photo.url}}\" alt=\"\"></div></slick>\n</div></div><div class=\"nl-Article__content\" \nng-init=\"setPageNames(\'{{{General News Page Name}}}\',\'{{{Page name details company}}}\')\"><div \nclass=\"nl-Article__title__wrapper\" ng-class=\"{\'nl-noImg\': !(article.photos && article.photos.length > 0)}\"><div \nclass=\"nl-Article__title\">{{article.name}}</div></div><div layout=\"row\" layout-align=\"center start\" layout-wrap><div \nclass=\"flex-100 flex-gt-sm-50 flex-gt-md-50 flex-offset-gt-md-15\"><div class=\"nl-Article__description ql-editor\" \nng-bind-html=\"trustAsHtml(article.content)\"></div></div><div class=\"flex-100 flex-gt-xs-50 flex-gt-md-15\"><div \nclass=\"nl-Article-column\"><div class=\"nl-Article__side__item nl-Article__side__item--date\"><div \nclass=\"nl-Article__side__date\">\n{{\'SITE_GEN.ARTICLE.PUBLISHED_ON\' | translate}} {{\'GENERAL.DATE_FORMAT\' | translate: {date:article.dateStart} }}</div>\n</div><div class=\"nl-Article__side__item nl-Article__side__item--add\"><button type=\"button\" \nng-if=\"!isOnSelection(article)\" class=\"nl-Article__btn\" ng-click=\"addToSelection(article)\"><img \nsrc=\"./assets/images/slick/favorite.svg\" alt=\"\"> {{\'SITE_GEN.ARTICLE.ADD_SELECTION\' | translate}}</button> <button \ntype=\"button\" ng-if=\"isOnSelection(article)\" class=\"nl-Article__btn\" ng-click=\"deleteFromSelection(article)\"><img \nsrc=\"./assets/images/slick/dislike.svg\" alt=\"\"> {{\'SITE_GEN.ARTICLE.REMOVE_SELECTION\' | translate}}</button></div><div \nclass=\"nl-Article__side__item\" ng-if=\"article.tags && article.tags.length > 0\"><div class=\"nl-Article__side__title\">\n{{\'SITE_GEN.ARTICLE.TAGS_CATEGORY\' | translate}}</div><div class=\"nl-Article__side__tags\"><div \nclass=\"nl-Article__side__tag\" ng-repeat=\"tag in article.tags\" ng-click=\"goToFilterPage(tag,\'TAGS\')\">{{tag.name}}</div>\n</div></div><div class=\"nl-Article__side__item\" ng-if=\"article.countries && article.countries.length > 0\"><div \nclass=\"nl-Article__side__title\">{{\'SITE_GEN.ARTICLE.TAGS_COUNTRY\' | translate}}</div><div \nclass=\"nl-Article__side__tags\"><div class=\"nl-Article__side__tag\" ng-repeat=\"country in article.countries\" \nng-click=\"goToFilterPage(country,\'COUNTRIES\')\">{{country.libelle}}</div></div></div><div \nclass=\"nl-Article__side__item\" ng-if=\"article.regions && article.regions.length > 0\"><div \nclass=\"nl-Article__side__title\">{{\'SITE_GEN.ARTICLE.TAGS_REGION\' | translate}}</div><div \nclass=\"nl-Article__side__tags\"><div class=\"nl-Article__side__tag\" ng-repeat=\"region in article.regions\" \nng-click=\"goToFilterPage(region,\'REGIONS\')\">{{region.libelle}}</div></div></div><div class=\"nl-Article__side__item\" \nng-if=\"article.companies && article.companies.length > 0\"><div class=\"nl-Article__side__title\">\n{{\'SITE_GEN.ARTICLE.COMPANIES_RELATED\' | translate}}</div><div class=\"nl-Article__side__tags\"><div \nclass=\"nl-Article__side__tag\" ng-repeat=\"company in article.companies | orderBy: \'index\'\" \nng-click=\"goToDetailsCompany(company.company)\">{{company.company.modelPattern}}</div></div></div></div><div \nclass=\"nl-Article-column mt-15\"><div class=\"\"><div class=\"nl-Article__side__title\">Newsletter</div><div \nng-if=\"!mailsended\" class=\"nl-Newsletter--description\">{{\'SITE_GEN.NEWSLETTER.SUBSCRIBE\' | translate}}</div><div \nng-if=\"mailsended\" class=\"nl-Newsletter--description\">{{\'SITE_GEN.NEWSLETTER.THANKS\' | translate}}</div><div \nng-if=\"!mailsended\"><form name=\"newsletterForm\" class=\"md-inline-form\" novalidate><md-input-container \nclass=\"nl-Article__Input\" flex=\"100\" md-no-float><input type=\"email\" ng-model=\"newsletterMail.mail\" \nplaceholder=\"{{ \'SITE_GEN.ARTICLE.MAIL\' | translate }}\" name=\"mail\" required><div \nng-messages=\"newsletterForm.mail.$error\" class=\"nl-fixeDivError\"><span ng-message=\"email\">\n{{\'GENERAL.PATTERN\' | translate}}</span> <span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><button class=\"nl-Article__btn\" ng-disabled=\"!newsletterForm.$valid\" ng-click=\"sendNewsletter()\">\n{{\'SITE_GEN.NEWSLETTER.CONNECT\' | translate}}</button></form></div></div></div></div></div><div layout=\"row\" \nlayout-align=\"start start\" class=\"flex-100\"></div><div class=\"nl-Article\"><div class=\"nl_Row-content\"><h1 \nclass=\"nl-relArticle__mainTitle\">{{\'SITE_GEN.ARTICLE.RELATED\' | translate}}</h1><div layout=\"row\" \nlayout-align=\"start stretch\" layout-wrap><div class=\"nl-relArticle__item flex-100 flex-gt-sm-50 flex-gt-md-25\" \nng-repeat=\"article in articlesRelated track by article.id\" ng-click=\"details(\'{{{PAGE_NAME_ARTICLE}}}\', article.id)\">\n<div class=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img \nng-if=\"article.photos == null || article.photos.length === 0\" class=\"nl-relArticle__img nl-relArticle__img--noLogo\" \nsrc=\"assets/images/logo/pure.png\" alt=\"\"> <img ng-if=\"article.photos != null && article.photos.length > 0\" \nclass=\"nl-relArticle__img\" ng-src=\"{{URL.alternatedocroots + \'/\' + article.miniature.location}}\" alt=\"\"></div><div \nclass=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{article.name}}</div><div class=\"nl-relArticle__date\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date:article.dateStart} }}</div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/banner.template.type.html","<div class=\"nl_Row-content\" ng-init=\"getBanner({{{Id of banner}}})\"><div class=\"nl-Banner\" role=\"button\" \nng-if=\"banner\" ng-click=\"goToBanner()\"><img class=\"nl-Banner__img\" ng-src=\"alternatedocroots/{{banner.img.location}}\">\n</div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/banner_carousel.template.type.html","<div class=\"nl_Row-content\" ng-init=\"getBanners([{{{Reference of banners - separated by a comma }}}])\"><div \nclass=\"nl-Banner\" ng-if=\"banners && banners.length>0\"><slick settings=\"_bannerSlickConfig\"><div \nng-repeat=\"banner in banners track by banner.id\" ng-click=\"goToBanner(banner)\"><img class=\"nl-Banner__img\" \nng-src=\"alternatedocroots/{{banner.img.location}}\"></div></slick></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/bloc.html","<div class=\"page-layout simple fullwidth nl-Has--FixedBar\"><div class=\"nl-FixedBar nl-FixedBar--bg1 md-whiteframe-2dp\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavMain(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"\" translate=\"SITES_MANAGEMENT.BLOCS.ADD\" \nng-if=\"!bloc.id\"></div><div class=\"\" translate=\"SITES_MANAGEMENT.BLOCS.MAJ\" ng-if=\"bloc.id\"></div></div><md-button \nclass=\"md-icon-button nl-Fixed-BartoggleBtn\" ng-click=\"toggleSidenavRight()\" hide-gt-sm aria-label=\"Toggle navigation\" \ntranslate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-apps\" class=\"icon\">\n</md-icon></md-button><div layout=\"row\" layout-align=\"start center\" hide show-gt-sm><md-button type=\"button\" class=\"\" \nng-click=\"_blocsListFn()\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n{{\'SITES_MANAGEMENT.BLOCS.LIST\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"_delete()\" \nng-if=\"bloc.id\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>{{\'SITES_MANAGEMENT.ACTIONS.DELETE\' | translate}}\n</md-button><md-button type=\"button\" class=\"\" ng-click=\"_save(blocForm)\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon>{{\'SITES_MANAGEMENT.ACTIONS.SAVE\' | translate}}</md-button></div></div><div id=\"nl-js--FixedRightBar\" \nclass=\"nl-FixedRightBar\"><div class=\"nl-FixedRightBar-backdrop\" ng-click=\"toggleSidenavRight()\"></div><div \nclass=\"nl-FixedRightBar-panel\"><div layout=\"column\" layout-align=\"start start\"><md-button type=\"button\" class=\"\" \nng-click=\"_blocsListFn()\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon>\n{{\'SITES_MANAGEMENT.BLOCS.LIST\' | translate}}</md-button><md-button type=\"button\" class=\"\" ng-click=\"_delete()\" \nng-if=\"bloc.id\"><md-icon md-font-icon=\"icon-delete-variant\"></md-icon>{{\'SITES_MANAGEMENT.ACTIONS.DELETE\' | translate}}\n</md-button><md-button type=\"button\" class=\"\" ng-click=\"_save(blocForm)\"><md-icon md-font-icon=\"icon-content-save\">\n</md-icon>{{\'SITES_MANAGEMENT.ACTIONS.SAVE\' | translate}}</md-button></div></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp p-40\"><div layout=\"column\"><form name=\"blocForm\" class=\"md-inline-form\" novalidate>\n<md-input-container class=\"\"><input type=\"text\" name=\"name\" ng-model=\"bloc.name\" \nplaceholder=\"{{\'SITES_MANAGEMENT.BLOCS.FIELDS.NAME\' | translate}}\" required><div class=\"\" \nng-messages=\"blocForm.name.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"\"><md-select name=\"type\" ng-model=\"bloc.type\" \nplaceholder=\"{{\'SITES_MANAGEMENT.BLOCS.FIELDS.TYPE\' | translate}}\" required ng-change=\"getBloc()\"><md-option \nng-repeat=\"_thisType in types | orderBy : \'translation\' track by $index\" ng-value=\"_thisType.value\" \nng-selected=\"_thisType.value == bloc.type\">{{_thisType.translation | translate}}</md-option></md-select><div class=\"\" \nng-messages=\"blocForm.type.$error\" role=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}\n</span></div></div></md-input-container><md-input-container class=\"\" ng-if=\"loaded\"><textarea name=\"html\" \nid=\"{{\'html\' + (bloc.id ? bloc.id : -1)}}\" ng-model=\"bloc.html\" ng-init=\"initBeautify(bloc)\" rows=\"20\" required>\n</textarea><div class=\"\" ng-messages=\"blocForm.html.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></form></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/blog.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-Blog\"><div layout=\"row\" layout-wrap><div flex=\"50\" flex-sm=\"100\" \nflex-xs=\"100\"><div class=\"nl-Blog-news\" ng-repeat=\"news in lastNews track by news.id\" ng-if=\"$index == 0\" \nng-click=\"details(\'{{{PAGE_NAME_ARTICLE}}}\', news.id)\"><div class=\"nl-Blog-news-imgWrapper\"><div \nclass=\"nl-Blog-news-backdrop\"></div><img ng-if=\"news.photos == null || news.photos.length === 0\" \nclass=\"nl-Blog-news-img\" src=\"assets/images/slick/1.jpg\" alt=\"\"> <img \nng-if=\"news.photos != null && news.photos.length > 0\" class=\"nl-Blog-news-img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + news.miniature.location}}\" alt=\"\"><div class=\"nl-Blog-news-infos\"><div \nclass=\"nl-Blog-news-title\">{{news.name}}</div><div class=\"nl-Blog-news-date\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-calendar-blank\" class=\"s14 mr-5\"></md-icon><div class=\"nl-Blog-news-date-value\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: news.dateStart} }}</div></div></div></div></div></div><div flex=\"50\" \nflex-sm=\"100\" flex-xs=\"100\"><div layout=\"row\" layout-align=\"start start\" layout-wrap><div flex=\"50\" flex-sm=\"50\" \nflex-xs=\"100\" class=\"nl-Blog-news nl-Blog-news--sm\" ng-repeat=\"news in lastNews track by news.id\" \nng-if=\"$index > 0 && $index <= 4\" ng-click=\"details(\'{{{PAGE_NAME_ARTICLE}}}\', news.id)\"><div \nclass=\"nl-Blog-news-imgWrapper\"><div class=\"nl-Blog-news-backdrop\"></div><img \nng-if=\"news.photos == null || news.photos.length === 0\" class=\"nl-Blog-news-img\" src=\"assets/images/slick/1.jpg\" \nalt=\"\"> <img ng-if=\"news.photos != null && news.photos.length > 0\" class=\"nl-Blog-news-img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + news.miniature.location}}\" alt=\"\"><div class=\"nl-Blog-news-infos\"><div \nclass=\"nl-Blog-news-title\">{{news.name}}</div><div class=\"nl-Blog-news-date\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-calendar-blank\" class=\"s14 mr-5\"></md-icon><div class=\"nl-Blog-news-date-value\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date:news.dateStart} }}</div></div></div></div></div></div></div></div><div \nclass=\"nl-Blog-list\" layout=\"column\" layout-align=\"start start\" infinite-scroll=\"loadMoreArticles()\" \ninfinite-scroll-disabled=\"infiniteScrollPrevent\"><div class=\"nl-Blog-list-item\" layout=\"row\" \nlayout-align=\"start start\" ng-repeat=\"news in newsArray track by news.id\" \nng-click=\"details(\'{{{PAGE_NAME_ARTICLE}}}\', news.id)\" layout-wrap><div flex-sm=\"50\" flex-xs=\"100\"><div \nclass=\"nl-Blog-list-imgWrapper\"><img ng-if=\"news.photos == null || news.photos.length === 0\" class=\"nl-Blog-news-img\" \nsrc=\"assets/images/slick/1.jpg\" alt=\"\"> <img ng-if=\"news.photos != null && news.photos.length > 0\" \nclass=\"nl-Blog-news-img\" ng-src=\"{{URL.alternatedocroots + \'/\' + news.miniature.location}}\" alt=\"\"></div></div><div \nflex flex-sm=\"50\" flex-xs=\"100\"><div class=\"nl-Blog-list-title\">{{news.name}}</div><div class=\"nl-Blog-list-date\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-calendar-blank\" class=\"s14 mr-5\"></md-icon><div \nclass=\"nl-Blog-news-date-value\">{{\'GENERAL.DATE_FORMAT\' | translate: {date: news.dateStart} }}</div></div></div><div \nflex-sm=\"100\" flex-xs=\"100\" class=\"nl-Blog-list-description\">{{news.shortDescription}}</div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/blog_pure.template.type.html","<div class=\"nl_Row-content\" ng-init=\"init([],[],[],\'{{{Article Page Name}}}\')\"><h1 \nclass=\"nl-titre--main nl--center nl-Search__title\">{{\'GENERAL.FILTER_BY_ARTICLES\' | translate}}</h1><div \nclass=\"nl-Search__wrapper\" layout=\"row\" layout-align=\"center stretch\" layout-wrap><div \nclass=\"nl-Article__search flex-100 flex-gt-xs-50 flex-gt-sm-25\"><div class=\"pl-5 pr-15\"><div \nclass=\"nl-Article__side__title\"><b>{{\'GENERAL.BY\' | translate}} {{\'GENERAL.TAGS\' | translate}}</b></div>\n<md-input-container class=\"nl-Article__Input\" md-no-float><md-select class=\"nl-Article__Select\" ng-model=\"filter.tags\" \nmultiple=\"multiple\" placeholder=\"{{\'GENERAL.TAGS\' | translate}}\" multiple=\"multiple\"><md-option \nng-repeat=\"tag in tags | orderBy: \'index\' track by tag.id\" ng-value=\"tag.id\">{{tag.name}}</md-option></md-select>\n</md-input-container></div></div><div class=\"nl-Article__search flex-100 flex-gt-xs-50 flex-gt-sm-25\"><div \nclass=\"pl-5 pr-15\"><div class=\"nl-Article__side__title\"><b>\n{{\'GENERAL.BY\' | translate}} {{\'GENERAL.COUNTRIES\' | translate}}</b></div><md-input-container \nclass=\"nl-Article__Input\" md-no-float><md-select class=\"nl-Article__Select\" ng-model=\"filter.countries\" \nplaceholder=\"{{\'GENERAL.COUNTRIES\' | translate}}\" multiple=\"multiple\"><md-option \nng-repeat=\"country in countries | orderBy: \'libelle\' track by country.id\" ng-value=\"country.id\">{{country.libelle}}\n</md-option></md-select></md-input-container></div></div><div \nclass=\"nl-Article__search flex-100 flex-gt-xs-50 flex-gt-sm-25\"><div class=\"pl-5 pr-15\"><div \nclass=\"nl-Article__side__title\"><b>{{\'GENERAL.BY\' | translate}} {{\'GENERAL.REGIONS\' | translate}}</b></div>\n<md-input-container class=\"nl-Article__Input\" md-no-float><md-select class=\"nl-Article__Select\" \nng-model=\"filter.regions\" placeholder=\"{{\'GENERAL.REGIONS\' | translate}}\" multiple=\"multiple\"><md-option \nng-repeat=\"region in regions | orderBy: \'libelle\' track by region.id\" ng-value=\"region.id\">{{region.libelle}}\n</md-option></md-select></md-input-container></div></div><div \nclass=\"nl-Article__search layout-row layout-align-start-end flex-100 flex-gt-sm-20\"><button ng-click=\"filtrer()\" \nclass=\"nl-Article__btn\">{{\'COMPANIES.FILTER\' | translate}}</button></div></div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"flex-100 flex-gt-md-80 nl-Article__noResult\" ng-if=\"blogs.length === 0\">\n{{\'SITE_GEN.ARTICLE.NO_RESULTS\' | translate}}</div><div class=\"flex-100 flex-gt-md-80\" ng-if=\"blogs && blogs.length>0\">\n<div class=\"nl-Blog --general\"><div flex=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div \nng-repeat=\"news in blogs track by news.id\" class=\"nl-relArticle__item nl-relArticle__floating flex-100\" \nng-if=\"$index == 0\" ng-click=\"details(news.id)\"><div class=\"nl-relArticle__item__inner\"><div \nclass=\"nl-relArticle__imgWrapper\"><img ng-if=\"news.photos == null || news.photos.length === 0\" \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"> <img \nng-if=\"news.photos != null && news.photos.length > 0\" class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + news.photos[0].location}}\" alt=\"\"></div><div \nclass=\"nl-relArticle__infos nl-relArticle__infos--centered\"><div class=\"nl-relArticle__title\">{{news.name}}</div><div>\n<div class=\"nl-relArticle__date\">{{\'GENERAL.DATE_FORMAT\' | translate: {date: news.dateStart} }}</div><div \nclass=\"nl-relArticle__text flex-sm-100\">{{news.shortDescription}}</div><div class=\"nl-relArticle__btn\" role=\"button\" \nng-click=\"$event.stopPropagation();details(news.id)\"><span>{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div>\n</div></div></div></div><div layout=\"row\" layout-wrap layout-align=\"start center\"><div \nng-repeat=\"news in blogs track by news.id\" class=\"nl-relArticle__item nl-relArticle__floating flex-100 flex-gt-sm-50\" \nng-click=\"details(news.id)\" ng-if=\"$index > 0 && $index<5\"><div class=\"nl-relArticle__item__inner\"><div \nclass=\"nl-relArticle__imgWrapper\"><img ng-if=\"news.photos == null || news.photos.length === 0\" \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"> <img \nng-if=\"news.photos != null && news.photos.length > 0\" class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + news.photos[0].location}}\" alt=\"\"></div><div \nclass=\"nl-relArticle__infos nl-relArticle__infos--centered\"><div class=\"nl-relArticle__title\">{{news.name}}</div><div>\n<div class=\"nl-relArticle__date\">{{\'GENERAL.DATE_FORMAT\' | translate: {date: news.dateStart} }}</div><div \nclass=\"nl-text flex-sm-100\">{{news.shortDescription}}</div><div class=\"nl-relArticle__btn\" role=\"button\" \nng-click=\"$event.stopPropagation();details(news.id)\"><span>{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div>\n</div></div></div></div></div><div layout=\"row\" layout-wrap layout-align=\"start start\" ng-if=\"blogsList.length>0\"><div \nflex=\"100\"><dir-pagination-controls on-page-change=\"pageChanged(newPageNumber)\" pagination-id=\"paginationId\">\n</dir-pagination-controls></div><div class=\"nl-relArticle__item nl-relArticle__item--long flex-100\" \nng-click=\"details(news.id)\" dir-paginate=\"news in blogsList | itemsPerPage: pagination.max track by news.id\" \ntotal-items=\"pagination.total\" current-page=\"pagination.page\" pagination-id=\"paginationId\"><div \nclass=\"nl-relArticle__item__inner\" layout=\"row\"><div class=\"nl-relArticle__imgWrapper flex-33\"><img \nng-if=\"news.photos == null || news.photos.length === 0\" class=\"nl-relArticle__img nl-relArticle__img--noLogo\" \nsrc=\"assets/images/logo/pure.png\" alt=\"\"> <img ng-if=\"news.photos != null && news.photos.length > 0\" \nclass=\"nl-relArticle__img\" ng-src=\"{{URL.alternatedocroots + \'/\' + news.photos[0].location}}\" alt=\"\"></div><div \nclass=\"nl-relArticle__infos nl-relArticle__infos--alt\"><div class=\"nl-relArticle__title\">{{news.name}}</div><div \nlayout=\"row\" layout-wrap layout-align=\"space-between start\"><div class=\"nl-relArticle__date flex-100 flex-sm-100\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date: news.dateStart} }}</div><div class=\"nl-relArticle__text flex-sm-100\">\n{{news.shortDescription}}</div><div class=\"nl-relArticle__btn\" role=\"button\" \nng-click=\"$event.stopPropagation();details(news.id)\"><span>{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div>\n</div></div></div></div><div flex=\"100\"><dir-pagination-controls on-page-change=\"pageChanged(newPageNumber)\" \npagination-id=\"paginationId\"></dir-pagination-controls></div></div></div></div></div><div \nclass=\"nl-Article-column flex-100 flex-gt-md-20 mt-15 mr-15\"><div class=\"nl-Article__side__item\"><div \nclass=\"nl-Article__side__title\">Newsletter</div><div ng-if=\"!mailsended\" class=\"nl-Newsletter--description\">\n{{\'SITE_GEN.NEWSLETTER.SUBSCRIBE\' | translate}}</div><div ng-if=\"mailsended\" class=\"nl-Newsletter--description\">\n{{\'SITE_GEN.NEWSLETTER.THANKS\' | translate}}</div><div ng-if=\"!mailsended\"><form name=\"newsletterForm\" \nclass=\"md-inline-form\" novalidate><md-input-container class=\"nl-Article__Input\" flex=\"100\" md-no-float><input \ntype=\"email\" ng-model=\"newsletterMail.mail\" placeholder=\"{{ \'SITE_GEN.ARTICLE.MAIL\' | translate }}\" name=\"mail\" \nrequired><div ng-messages=\"newsletterForm.mail.$error\" class=\"nl-fixeDivError\"><span ng-message=\"email\">\n{{\'GENERAL.PATTERN\' | translate}}</span> <span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><button class=\"nl-Article__btn\" ng-disabled=\"!newsletterForm.$valid\" ng-click=\"sendNewsletter()\">\n{{\'SITE_GEN.NEWSLETTER.CONNECT\' | translate}}</button></form></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/button.template.type.html","<div class=\"nl-Search__wrapper layout-wrap layout-align-center-stretch layout-row\"><div class=\"flex-33 pt-15\"><button \ntype=\"button\" class=\"nl-BtnPure nl-BtnPure--primary nl-BtnPure--centered nl-BtnPure--block\" \nng-click=\"goToUrl(\'{{{URL}}}\');\"><span>{{{TITRE}}}</span></button></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/carousel.template.type.html","<div class=\"nl_slick--wrapper\"><button type=\"button\" ng-click=\"slickConfig.method.slickPrev()\" \nclass=\"nl_slick--button\"><img src=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"slickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"slickConfig\" class=\"nl_slick\"><div \nclass=\"nl_slick--slide\"><img class=\"nl_slick--slide--img\" src=\"{{{Image 1 URL Link}}}\" alt=\"\"></div></slick></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/carousel__clic.template.type.html","<div id=\"versionPure\" class=\"nl_slick--wrapper mb-30\"><button type=\"button\" ng-click=\"slickConfig.method.slickPrev()\" \nclass=\"nl_slick--button\"><img src=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"slickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"slickConfig\" class=\"nl_slick\"><div \nclass=\"nl_slick--slide--v2\"><div class=\"nl_slick--slide--text\" ng-click=\"goToUrlCarousel(\'{{{URL 1 Link}}}\')\"><h2 \nclass=\"nl_slick--slide--title\">{{{Title 1}}}</h2><div class=\"nl_slick--slide--description\">{{{Subtitle 1}}}</div></div>\n<div style=\"height: 100%;overflow: hidden;position: relative\"><img class=\"nl_slick--slide--img\" \nsrc=\"{{{Image 1 URL Link}}}\" alt=\"\" ng-click=\"goToUrlCarousel(\'{{{URL 1 Link}}}\')\"></div></div></slick></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/carousel__noclic.template.type.html","<div id=\"versionPure\" class=\"nl_slick--wrapper mb-30\"><button type=\"button\" ng-click=\"slickConfig.method.slickPrev()\" \nclass=\"nl_slick--button\"><img src=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"slickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"slickConfig\" class=\"nl_slick\"><div \nclass=\"nl_slick--slide--v2\"><div style=\"height: 100%;overflow: hidden;position: relative\"><img \nclass=\"nl_slick--slide--img\" src=\"{{{Image 1 URL Link}}}\" alt=\"\"></div></div></slick></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/carousel_pure.template.type.html","<div id=\"versionPure\" class=\"nl_slick--wrapper mb-30\"><button type=\"button\" ng-click=\"slickConfig.method.slickPrev()\" \nclass=\"nl_slick--button\"><img src=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"slickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"slickConfig\" class=\"nl_slick\"><div \nclass=\"nl_slick--slide--v2\"><div class=\"nl_slick--slide--text\" ng-click=\"goToUrlCarousel(\'{{{URL 1 Link}}}\')\"><h2 \nclass=\"nl_slick--slide--title\">{{{Title 1}}}</h2><div class=\"nl_slick--slide--description\">{{{Subtitle 1}}}</div></div>\n<div style=\"height: 100%;overflow: hidden;position: relative\"><img class=\"nl_slick--slide--img\" \nsrc=\"{{{Image 1 URL Link}}}\" alt=\"\" ng-click=\"goToUrlCarousel(\'{{{URL 1 Link}}}\')\"></div></div></slick></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/company.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-prestataire-search--slick\" \nng-if=\"company.photos && company.photos.length > 0\"><div class=\"nl_slick--wrapper\"><button type=\"button\" \nng-click=\"_companySlickConfig.method.slickPrev()\" class=\"nl_slick--button\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_companySlickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"_companySlickConfig\" style=\"height: 400px\">\n<div class=\"nl_slick--slide\" ng-repeat=\"_photo in company.photos\"><img class=\"nl_slick--slide--img\" \nng-src=\"{{_photo.url}}\" alt=\"\"></div></slick></div></div><div layout=\"row\" class=\"mt-50\" layout-wrap><div flex=\"70\" \nflex-xs=\"100\"><div class=\"nl-titre--main nl--item--bigger\">\n{{company.modelPattern}} {{searchValueById(15) != null ? \' - \' + searchValueById(15) : \'\'}}</div><div \nclass=\"nl-text--main\" ng-if=\"searchValueById(3);\">Company Activity : {{searchValueById(3);}}</div></div><div flex=\"30\" \nflex-xs=\"100\"><div class=\"nl-prestataire-search-item-logoWrapper\"><img \nng-if=\"company.logo == null || company.logo.length === 0\" class=\"nl-prestataire-search-item-img nl-img--logo\" \nsrc=\"assets/images/slick/1.jpg\" alt=\"\"> <img ng-if=\"company.logo != null && company.logo.length > 0\" \nclass=\"nl-prestataire-search-item-img nl-img--logo\" ng-src=\"{{URL.alternatedocroots + \'/\' + company.logo}}\" alt=\"\">\n</div></div></div><div id=\"anchor--informations\" layout=\"row\" class=\"nl-prestataire-search-item item-2\" layout-wrap>\n<div flex-xs=\"100\" \nflex=\"{{ company.contactFavourite != null && company.contactFavourite.valuedFields != null ? \'70\' : \'100\' }}\"><div \nclass=\"nl-prestataire-search-item-maintitle\">Main information</div><div layout=\"column\" class=\"p-20\"><div \nclass=\"mb-25 mt-10\"><div layout=\"row\" layout-align=\"start center\" ng-if=\"company.website != null\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Website :</b></div><div class=\"nl-prestataire-search-item-text\"><a \nng-href=\"http://{{company.website}}\" target=\"_blank\">{{company.website}}</a></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\"><b>Phone :</b></div><div \nclass=\"nl-prestataire-search-item-text\"><md-button md-no-ink class=\"nl-listing-item-button nl-button--blue\" \ntype=\"button\" ng-if=\"!showElt.PHONE\" ng-click=\"show(\'PHONE\')\">CLICK</md-button><a ng-if=\"showElt.PHONE\" \nhref=\"mailto:{{searchValueById(4)}}\">{{searchValueById(4)}}</a></div></div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\"><b>Email :</b></div><div \nclass=\"nl-prestataire-search-item-text\"><md-button md-no-ink class=\"nl-listing-item-button nl-button--blue\" \ntype=\"button\" ng-if=\"!showElt.EMAIL\" ng-click=\"show(\'EMAIL\')\">CLICK</md-button><a ng-if=\"showElt.EMAIL\" \nhref=\"mailto:{{searchValueById(6)}}\">{{searchValueById(6)}}</a></div></div><div class=\"p-20\" \nng-if=\"company.category || company.bedrooms || company.rooms || company.maxTheatre\"><table \nclass=\"dataTable row-border nl-Tablegit nl-Table--center nl-prestataire-table nl-prestataire-table--common\"><tr><th \nng-if=\"searchValueById(15)\">Star Rating</th><th ng-if=\"company.bedrooms\">Bedrooms</th><th ng-if=\"company.rooms\">\nMeeting Rooms</th><th ng-if=\"company.maxTheatre\">Max. Theatre</th></tr><tr><td ng-if=\"searchValueById(15)\">\n{{searchValueById(15)}}</td><td ng-if=\"company.bedrooms\">{{company.bedrooms}}</td><td ng-if=\"company.rooms\">\n{{company.rooms}}</td><td ng-if=\"company.maxTheatre\">{{company.maxTheatre ? company.maxTheatre + \' pax\' : \'\'}}</td>\n</tr></table></div><div layout=\"row\" layout-align=\"start center\"><div class=\"nl-prestataire-search-item-strong\"><b>\nAddress :</b></div><div class=\"nl-prestataire-search-item-text\"><span \nng-if=\"searchValueById(8) && searchValueById(8).length>0\">{{searchValueById(8)}}</span> <span \nng-if=\"searchValueById(9) && searchValueById(9).length>0\">,&nbsp;{{searchValueById(9)}}</span> <span \nng-if=\"searchValueById(10) && searchValueById(10).length>0\">,&nbsp;{{searchValueById(10)}}</span> <span \nng-if=\"searchValueById(11) && searchValueById(11).length>0\">,&nbsp;{{searchValueById(11)}}</span> <span \nng-if=\"searchValueById(145) && searchValueById(145).length>0\">,&nbsp;{{searchValueById(145)}}</span> <span \nng-if=\"searchValueById(13) && searchValueById(13).length>0\">,&nbsp;{{searchValueById(13)}}</span> <span \nng-if=\"searchValueById(14) && searchValueById(14).length>0\">,&nbsp;{{searchValueById(14)}}</span></div></div><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"searchValueById(36) != null && searchValueById(36).length>0\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Creation :</b></div><div class=\"nl-prestataire-search-item-text\">\n{{searchValueById(36)}}</div></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"searchValueById(37) != null && searchValueById(37).length>0\"><div class=\"nl-prestataire-search-item-strong\"><b>\nLast refurbishment :</b></div><div class=\"nl-prestataire-search-item-text\">{{searchValueById(37)}}</div></div><div \nlayout=\"row\" layout-align=\"start center\" ng-if=\"searchValueById(49) != null && searchValueById(49).length>0\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Spoken Languages by the sales Department :</b></div><div \nclass=\"nl-prestataire-search-item-text\">{{searchValueById(49)}}</div></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"searchValueById(48) != null && searchValueById(48).length>0\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Agency specialized in :</b></div><div \nclass=\"nl-prestataire-search-item-text\">{{searchValueById(48)}}</div></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"searchValueById(94) != null && searchValueById(94).length>0\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Can organize :</b></div><div class=\"nl-prestataire-search-item-text\">\n{{searchValueById(94)}}</div></div></div></div></div><div flex=\"30\" flex-xs=\"100\" \nclass=\"nl-prestataire-search-item-side side-contact\" \nng-if=\"company.contactFavourite != null && company.contactFavourite.valuedFields != null\"><div \nclass=\"nl-prestataire-search-item-maintitle\">Main contact</div><div layout=\"column\"><div \nclass=\"nl-prestataire-search-side-avatar\" \nng-if=\"searchContactValueById(22) != null && searchContactValueById(22).length>0\"><img \nng-src=\"{{URL.alternatedocroots + \'/\' + searchContactValueById(22)}}\" alt=\"\" \nclass=\"nl-prestataire-search-side-avatar-img\" alt=\"\"></div><div class=\"nl-prestataire-search-side-text mt-10\"><i \nclass=\"icon-account\"></i> <span class=\"\"><b><span>{{searchContactValueById(19)}}&nbsp;</span> <span>\n{{searchContactValueById(20)}}&nbsp;</span> <span>{{searchContactValueById(21)}}</span></b></span></div><div \nclass=\"nl-prestataire-search-side-text\" \nng-if=\"(searchContactValueById(24) != null && searchContactValueById(24).length>0) || \n                            (searchContactValueById(23) != null && searchContactValueById(23).length>0)\">\n<i class=\"icon-worker\"></i> <span class=\"\"><span \nng-if=\"searchContactValueById(24) != null && searchContactValueById(24).length>0\">{{searchContactValueById(24)}},\n</span> <span ng-if=\"searchContactValueById(23) != null && searchContactValueById(23).length>0\">\n&nbsp;{{searchContactValueById(23)}}</span></span></div><div class=\"nl-prestataire-search-side-text\" \nng-if=\"searchContactValueById(27) != null && searchContactValueById(27).length>0\"><i class=\"icon-phone-forward\"></i> \n<span class=\"\"><md-button md-no-ink class=\"nl-listing-item-button nl-button--blue\" type=\"button\" \nng-if=\"!showElt.PHONE\" ng-click=\"show(\'PHONE\')\">CLICK</md-button><a ng-if=\"showElt.PHONE\" \nhref=\"mailto:{{searchContactValueById(27)}}\">{{searchContactValueById(27)}}</a></span></div><div \nclass=\"nl-prestataire-search-side-text\" \nng-if=\"searchContactValueById(28) != null && searchContactValueById(28).length>0\"><i class=\"icon-cellphone-iphone\"></i>\n <span class=\"\"><md-button md-no-ink class=\"nl-listing-item-button nl-button--blue\" type=\"button\" \nng-if=\"!showElt.PHONE\" ng-click=\"show(\'PHONE\')\">CLICK</md-button><a ng-if=\"showElt.PHONE\" \nhref=\"mailto:{{searchContactValueById(28)}}\">{{searchContactValueById(28)}}</a></span></div><div \nclass=\"nl-prestataire-search-side-text\" \nng-if=\"searchContactValueById(29) != null && searchContactValueById(29).length>0\"><i class=\"icon-email\"></i> <span \nclass=\"\" style=\"word-break: break-all\"><md-button md-no-ink class=\"nl-listing-item-button nl-button--blue\" \ntype=\"button\" ng-if=\"!showElt.EMAIL\" ng-click=\"show(\'EMAIL\')\">CLICK</md-button><a ng-if=\"showElt.EMAIL\" \nhref=\"mailto:{{searchContactValueById(29)}}\">{{searchContactValueById(29)}}</a></span></div><div \nclass=\"nl-prestataire-search-side-text\" \nng-if=\"searchContactValueById(26) != null && searchContactValueById(26).length>0\"><i \nclass=\"icon-flag-checkered-variant\"></i> <span class=\"\">{{searchContactValueById(26)}}</span></div><button \ntype=\"button\" class=\"nl-Item-button-warm mt-5\" ng-click=\"onAskForAQuote(company);\">Ask for a quote</button> <button \ntype=\"button\" ng-click=\"onAddToSelection(\'{{{PAGE_NAME_DETAILS_COMPANY}}}\',company)\" class=\"nl-Item-button mt-5 pr-20\" \nng-if=\"!onGetSessionStorageItem(company)\">Add to my selection</button> <button type=\"button\" \nng-click=\"onDeleteFromSelection(company)\" class=\"nl-Item-button md-red-200-bg mt-5 pr-20\" \nng-if=\"onGetSessionStorageItem(company)\">remove from my selection</button></div></div></div><div \nid=\"anchor--meetingrooms\" layout=\"column\" class=\"nl-prestataire-search-item item-2 mt-50\"><div><div \nclass=\"nl-prestataire-search-item-maintitle\">Presentation</div></div><div class=\"ph-20\"><div layout=\"column\" \nlayout-align=\"center start\" ng-if=\"searchValueById(38) != null && searchValueById(38).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Company Profile :</b></div><div class=\"nl-prestataire-search-item-text\">\n<pre style=\"font-family:roboto\">{{searchValueById(38)}}</pre></div></div><div layout=\"column\" \nlayout-align=\"center start\" ng-if=\"searchValueById(171) != null && searchValueById(171).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Classification :</b></div><div class=\"nl-prestataire-search-item-text\">\n<pre style=\"font-family:roboto\">{{searchValueById(171)}}</pre></div></div><div layout=\"column\" \nlayout-align=\"center start\" ng-if=\"searchValueById(168) != null && searchValueById(168).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Type(s) of cuisine :</b></div><div \nclass=\"nl-prestataire-search-item-text\"><pre style=\"font-family:roboto\">{{searchValueById(168)}}</pre></div></div><div \nlayout=\"column\" layout-align=\"center start\" ng-if=\"searchValueById(169) != null && searchValueById(169).length>0\" \nclass=\"pv-10\"><div class=\"nl-prestataire-search-item-strong\"><b>Specialities :</b></div><div \nclass=\"nl-prestataire-search-item-text\"><pre style=\"font-family:roboto\">{{searchValueById(169)}}</pre></div></div><div \nlayout=\"column\" layout-align=\"center start\" ng-if=\"searchValueById(39) != null && searchValueById(39).length>0\" \nclass=\"pv-10\"><div class=\"nl-prestataire-search-item-strong\"><b>Services :</b></div><div \nclass=\"nl-prestataire-search-item-text\"><pre style=\"font-family:roboto\">{{searchValueById(39)}}</pre></div></div><div \nlayout=\"column\" layout-align=\"center start\" ng-if=\"searchValueById(40) != null && searchValueById(40).length>0\" \nclass=\"pv-10\"><div class=\"nl-prestataire-search-item-strong\"><b>Main Asset :</b></div><div \nclass=\"nl-prestataire-search-item-text\"><pre style=\"font-family:roboto\">{{searchValueById(40)}}</pre></div></div><div \nlayout=\"column\" layout-align=\"center start\" ng-if=\"searchValueById(41) != null && searchValueById(41).length>0\" \nclass=\"pv-10\"><div class=\"nl-prestataire-search-item-strong\"><b>Facilities :</b></div><div \nclass=\"nl-prestataire-search-item-text\"><pre style=\"font-family:roboto\">{{searchValueById(41)}}</pre></div></div><div \nlayout=\"column\" layout-align=\"center start\" ng-if=\"searchValueById(42) != null && searchValueById(42).length>0\" \nclass=\"pv-10\"><div class=\"nl-prestataire-search-item-strong\"><b>Main events organized :</b></div><div \nclass=\"nl-prestataire-search-item-text\"><pre style=\"font-family:roboto\">{{searchValueById(42)}}</pre></div></div><div \nlayout=\"column\" layout-align=\"center start\" ng-if=\"searchValueById(43) != null && searchValueById(43).length>0\" \nclass=\"pv-10\"><div class=\"nl-prestataire-search-item-strong\"><b>Last events organized :</b></div><div \nclass=\"nl-prestataire-search-item-text\"><pre style=\"font-family:roboto\">{{searchValueById(43)}}</pre></div></div><div \nlayout=\"column\" layout-align=\"center start\" ng-if=\"searchValueById(44) != null && searchValueById(44).length>0\" \nclass=\"pv-10\"><div class=\"nl-prestataire-search-item-strong\"><b>Highlights of the destination :</b></div><div \nclass=\"nl-prestataire-search-item-text\"><pre style=\"font-family:roboto\">{{searchValueById(44)}}</pre></div></div><div \nlayout=\"column\" layout-align=\"center start\" ng-if=\"searchValueById(45) != null && searchValueById(45).length>0\" \nclass=\"pv-10\"><div class=\"nl-prestataire-search-item-strong\"><b>Cultural and leisure assets of the destination :</b>\n</div><div class=\"nl-prestataire-search-item-text\"><pre style=\"font-family:roboto\">{{searchValueById(45)}}</pre></div>\n</div><div layout=\"column\" layout-align=\"center start\" \nng-if=\"searchValueById(170) != null && searchValueById(170).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Number of seats :</b></div><div class=\"nl-prestataire-search-item-text\">\n<pre style=\"font-family:roboto\">{{searchValueById(170)}}</pre></div></div><div layout=\"column\" \nlayout-align=\"center start\" ng-if=\"searchValueById(173) != null && searchValueById(173).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Average Cost :</b></div><div class=\"nl-prestataire-search-item-text\"><pre \nstyle=\"font-family:roboto\">{{searchValueById(173)}}</pre></div></div><div layout=\"column\" layout-align=\"center start\" \nng-if=\"searchValueById(172) != null && searchValueById(172).length>0\" class=\"pv-10\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Owner :</b></div><div class=\"nl-prestataire-search-item-text\"><pre \nstyle=\"font-family:roboto\">{{searchValueById(172)}}</pre></div></div></div></div><div id=\"anchor--capacities\" \nlayout=\"column\" class=\"nl-prestataire-search-item item-2 mt-50\" \nng-if=\"(searchValueById(53) != null && searchValueById(53).length>0) || (searchValueById(52) != null && searchValueById(52).length>0) || (searchValueById(51) != null && searchValueById(51).length>0) || (searchValueById(57) != null && searchValueById(57).length>0) ||(searchValueById(54) != null && searchValueById(54).length>0) || (searchValueById(55) != null && searchValueById(55).length>0) || (searchValueById(56) != null && searchValueById(56).length>0) || (searchValueById(58) != null && searchValueById(58).length>0) || (searchValueById(61) != null && earchValueById(61).length>0) || (searchValueById(64) != null && searchValueById(64).length>0) || (searchValueById(67) != null && searchValueById(67).length>0) || (searchValueById(70) != null && searchValueById(70).length>0)\">\n<div><div class=\"nl-prestataire-search-item-maintitle\">Capacities</div></div><div class=\"p-20\"><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" class=\"pr-20\" \nng-if=\"(searchValueById(53) != null && searchValueById(53).length>0) || (searchValueById(52) != null && searchValueById(52).length>0) || (searchValueById(51) != null && searchValueById(51).length>0)\">\n<div class=\"nl-prestataire-search-item-mainsubtitle\">Maximum capacities</div><table \nclass=\"dataTable row-border nl-Tablegit nl-Table--center nl-prestataire-table nl-prestataire-table--common\"><tr><th \nng-if=\"searchValueById(51) != null && searchValueById(51).length>0\">Theatre</th><th \nng-if=\"searchValueById(52) != null && searchValueById(52).length>0\">Conference</th><th \nng-if=\"searchValueById(53) != null && searchValueById(53).length>0\">Cocktail</th></tr><tr><td \nng-if=\"searchValueById(51) != null && searchValueById(51).length>0\">{{searchValueById(51)}} pax</td><td \nng-if=\"searchValueById(52) != null && searchValueById(52).length>0\">{{searchValueById(52)}} pax</td><td \nng-if=\"searchValueById(53) != null && searchValueById(53).length>0\">{{searchValueById(53)}} pax</td></tr><tr \nng-if=\"!(searchValueById(51) != null && searchValueById(51).length>0) && !(searchValueById(52) != null && searchValueById(52).length>0) \n                                && !(searchValueById(53) != null && searchValueById(53).length>0)\">\n<td></td><td></td><td></td></tr></table></div><div flex=\"50\" flex-sm=\"100\" flex-xs=\"100\" class=\"pl-20\" \nng-if=\"(searchValueById(57) != null && searchValueById(57).length>0) ||(searchValueById(54) != null && searchValueById(54).length>0) || (searchValueById(55) != null && searchValueById(55).length>0) || (searchValueById(56) != null && searchValueById(56).length>0)\">\n<div class=\"nl-prestataire-search-item-mainsubtitle\">Exposition surface</div><table \nclass=\"dataTable row-border nl-Tablegit nl-Table--center nl-prestataire-table nl-prestataire-table--common\"><tr><th \nng-if=\"searchValueById(54) != null && searchValueById(54).length>0\">Largest Room (m2)</th><th \nng-if=\"searchValueById(55) != null && earchValueById(55).length>0\">Indoor (m2)</th><th \nng-if=\"searchValueById(56) != null && searchValueById(56).length>0\">Outdoor (m2)</th><th \nng-if=\"searchValueById(57) != null && searchValueById(57).length>0\">Total (m2)</th></tr><tr><td \nng-if=\"searchValueById(54) != null && searchValueById(54).length>0\">{{searchValueById(54)}}</td><td \nng-if=\"searchValueById(55) != null && earchValueById(55).length>0\">{{searchValueById(55)}}</td><td \nng-if=\"searchValueById(56) != null && searchValueById(56).length>0\">{{searchValueById(56)}}</td><td \nng-if=\"searchValueById(57) != null && searchValueById(57).length>0\">{{searchValueById(57)}}</td></tr><tr \nng-if=\"!(searchValueById(54) != null && searchValueById(54).length>0) && !(searchValueById(55) != null && earchValueById(55).length>0) \n                                && !(searchValueById(56) != null && searchValueById(56).length>0) && !(searchValueById(57) != null && searchValueById(57).length>0)\">\n<td></td><td></td><td></td><td></td></tr></table></div></div><div class=\"mt-25\" layout=\"row\" \nlayout-align=\"center center\" \nng-if=\"(searchValueById(58) != null && searchValueById(58).length>0) || (searchValueById(61) != null && earchValueById(61).length>0) \n                                || (searchValueById(64) != null && searchValueById(64).length>0) || (searchValueById(67) != null && searchValueById(67).length>0) || (searchValueById(70) != null && searchValueById(70).length>0)\">\n<div flex=\"100\"><div class=\"nl-prestataire-search-item-mainsubtitle\">Bedrooms</div><table \nclass=\"dataTable row-border nl-Tablegit nl-Table--center nl-prestataire-table nl-prestataire-table--common\"><tr><th>\nRoom Type</th><th>Number</th><th>Size (m2)</th><th>Size (sq.ft)</th></tr><tr><td>Single Room</td><td>\n{{searchValueById(58)}}</td><td>{{searchValueById(59)}}</td><td>{{searchValueById(60)}}</td></tr><tr><td>Double Room\n</td><td>{{searchValueById(61)}}</td><td>{{searchValueById(62)}}</td><td>{{searchValueById(63)}}</td></tr><tr><td>\nTwin Room</td><td>{{searchValueById(64)}}</td><td>{{searchValueById(65)}}</td><td>{{searchValueById(66)}}</td></tr><tr>\n<td>Superior Room</td><td>{{searchValueById(67)}}</td><td>{{searchValueById(68)}}</td><td>{{searchValueById(69)}}</td>\n</tr><tr><td>Suites</td><td>{{searchValueById(70)}}</td><td>{{searchValueById(71)}}</td><td>{{searchValueById(72)}}\n</td></tr></table></div></div></div></div><div id=\"anchor--situation\" layout=\"column\" \nclass=\"nl-prestataire-search-item item-2 mt-50\" \nng-if=\"(searchValueById(84) != null && searchValueById(84).length>0) || \n            (searchValueById(90) != null && searchValueById(90).length>0) || (searchValueById(85) != null && searchValueById(85).length>0) \n            || (searchValueById(86) != null && searchValueById(86).length>0)\">\n<div><div class=\"nl-prestataire-search-item-maintitle\">Situation</div></div><div class=\"p-20\"><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"searchValueById(84) != null && searchValueById(84).length>0\"><div \nclass=\"nl-prestataire-search-item-strong\"><b>Situation :</b></div><div class=\"nl-prestataire-search-item-text\">\n{{searchValueById(84)}}</div></div><div layout=\"row\" layout-align=\"start center\" \nng-if=\"searchValueById(90) != null && searchValueById(90).length>0\"><div class=\"nl-prestataire-search-item-strong\"><b>\nParking :</b></div><div class=\"nl-prestataire-search-item-text\">{{searchValueById(90)}} places</div></div><div \nlayout=\"row\" layout-align=\"start center\" \nng-if=\"(searchValueById(85) != null && searchValueById(85).length>0) \n                    || (searchValueById(86) != null && searchValueById(86).length>0)\">\n<div class=\"nl-prestataire-search-item-strong\"><b>Closest International Airport :</b></div><div \nclass=\"nl-prestataire-search-item-text\">{{searchValueById(85)}} <span ng-if=\"searchValueById(86)\">\n({{searchValueById(86)}}km)</span></div></div></div></div><div id=\"anchor--meetingrooms\" layout=\"column\" \nclass=\"nl-Table--wrapper nl-prestataire-search-item nl-prestataire-search-item--table mt-50\" \nng-show=\"dispositions != null && dispositions.length > 0\"><div><div class=\"nl-prestataire-search-item-maintitle\">\nMeeting Rooms</div></div><table \nclass=\"dataTable row-border hover nl-Tablegit nl-Table--center nl-prestataire-table--common\"><thead><tr><th \nclass=\"secondary-text\">{{\"COMPANIES.DISPOSITION.NAME\" | translate }}</th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.SQUARE_METTER\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"COMPANIES.DISPOSITION.SQUARE_FEET\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.L_W_H\"></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.DAY_LIGHT\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" \naria-label=\"square meter\"><md-tooltip>{{\"COMPANIES.DISPOSITION.THEATER\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/theatre.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.CLASS_ROOM\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/classroom.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.BOARD_ROOM\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/boardroom.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.U_STYLE\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/ustyle.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.BANQUET\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/banquet.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.COCKTAIL\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/cocktail.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.CONFERENCE\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/conference.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.CABARET\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/cabaret.svg\"></md-icon></md-button></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" aria-label=\"square meter\">\n<md-tooltip>{{\"COMPANIES.DISPOSITION.AUDITORIUM\" | translate}}</md-tooltip><md-icon \nmd-svg-src=\"assets/icons/dispositions/auditorium.svg\"></md-icon></md-button></div></th></tr></thead><tbody><tr \nng-repeat=\"_disposition in dispositions track by $index\"><td>{{ _disposition.name }}</td><td>\n{{ _disposition.squareMeter }}</td><td>{{ _disposition.squareFeet }}</td><td>\n{{ _disposition.length ? _disposition.length : \"xx\" }}/{{ _disposition.width ? _disposition.width : \"xx\" }}/{{ _disposition.height ? _disposition.height : \"xx\" }}\n</td><td>{{ !_disposition.dayLight ? \'COMPANIES.NO\' : \'COMPANIES.YES\' | translate }}</td><td>{{ _disposition.theatre }}\n</td><td>{{ _disposition.classRoom }}</td><td>{{ _disposition.boardRoom }}</td><td>{{ _disposition.uStyle }}</td><td>\n{{ _disposition.banquet }}</td><td>{{ _disposition.cocktail }}</td><td>{{ _disposition.conference }}</td><td>\n{{ _disposition.cabaret }}</td><td>{{ _disposition.auditorium }}</td></tr></tbody></table></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/company_selection.template.type.html","<div class=\"nl_Row-content\" ng-init=\"getCompanies([{{{Reference of favorite companies - separated by a comma }}}])\" \nng-if=\"showBlocByDates(\'{{{start date - dd/MM/yyyy - \'null\' if you dont\'t want}}}\', \'{{{date de fin - dd/MM/yyyy- \'null\' if you dont\'t want}}}\')\">\n<div layout=\"row\" layout-wrap><div flex=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div class=\"nl_slick--wrapper wrapper-mw\"><button ng-if=\"companies.length>4\" type=\"button\" \nng-click=\"slickConfig.method.slickPrev()\" class=\"nl-Favorite-slick__btn__left\"><img \nsrc=\"assets/images/slick/arrow_left.svg\" alt=\"\"></button> <button ng-if=\"companies.length>4\" type=\"button\" \nng-click=\"slickConfig.method.slickNext()\" class=\"nl-Favorite-slick__btn__right\"><img \nsrc=\"assets/images/slick/arrow_right.svg\" alt=\"\"></button><slick settings=\"slickConfig\" class=\"nl-Slick--favorite\" \nng-class=\"{\'nl-Slick--empty\': companies.length<5 }\"><div \nng-repeat=\"company in companies | orderBy: \'index\' track by company.id \"><div class=\"nl-relArticle__item\" \nng-click=\"details(\'{{{Company Page Name}}}\', company.id)\"><div class=\"nl-relArticle__item__inner\"><div \nclass=\"nl-relArticle__imgWrapper\"><img ng-if=\"company.photos == null || company.photos.length === 0\" \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"> <img \nng-if=\"company.photos != null && company.photos.length > 0\" class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + company.photos[0].location}}\" alt=\"\"></div><div \nclass=\"nl-relArticle__infos nl-relArticle__infos--alt nl-relArticle__infos--centered\"><div \nclass=\"nl-relArticle__title\">{{company.modelPattern}}</div><div class=\"nl-relArticle__date\">{{showDesc(company) }}\n</div></div></div></div></div></slick></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/company_with_status.template.type.html","<div class=\"nl_Row-content\"><div class=\"pt-40\" ng-if=\"company\" id=\"DetailsCompany\"><div class=\"nl-Details__mainTitle\">\n{{company.modelPattern}} {{searchValueById(15) != null ? \' - \' + searchValueById(15) : \'\'}}</div><div \nclass=\"nl-Details__subText\">{{showDescNoCategory(company) }}</div></div><div layout=\"row\" layout-wrap class=\"pt-25\">\n<div class=\"p-10 flex-100 flex-gt-md-50\" flex-order=\"1\" flex-order-gt-sm=\"0\" id=\"BlocLeft\"><div \nclass=\"nl-Details__group nl-Details__group__full\"><div class=\"nl-Article__side__item\" \nng-if=\"searchValueById(35) || searchValueById(36) || searchValueById(37) || searchValueById(38)\"><table \nclass=\"dataTable nl-TablePure\"><thead><tr><th width=\"25%\" class=\"text-center\" ng-if=\"searchValueById(35)\">\n{{\'SITE_GEN.COMPANY.STARS\' | translate}}</th><th width=\"25%\" class=\"text-center\" ng-if=\"searchValueById(36)\">\n{{\'SITE_GEN.COMPANY.BEDROOMS\' | translate}}</th><th width=\"25%\" class=\"text-center\" ng-if=\"searchValueById(37)\">\n{{\'SITE_GEN.COMPANY.MEETING\' | translate}}</th><th width=\"25%\" class=\"text-center\" ng-if=\"searchValueById(38)\">\n{{\'SITE_GEN.COMPANY.CAPACITY\' | translate}}</th></tr></thead><tbody><tr><td align=\"center\" ng-if=\"searchValueById(35)\">\n{{searchValueById(35)}}</td><td align=\"center\" ng-if=\"searchValueById(36)\">{{searchValueById(36)}}</td><td \nalign=\"center\" ng-if=\"searchValueById(37)\">{{searchValueById(37)}}</td><td align=\"center\" ng-if=\"searchValueById(38)\">\n{{searchValueById(38)}}</td></tr></tbody></table></div><div class=\"nl-Article__side__item\" ng-if=\"searchValueById(11)\">\n<div class=\"nl-Article__side__title mb-4\">{{\'SITE_GEN.COMPANY.WEBSITE\' | translate}}:</div><div \nclass=\"nl-Article__side__tags\"><button class=\"nl-Btn nl-BtnPure nl-BtnPure--primary\" ng-if=\"!showWebsite\" \nng-click=\"setShowWebsite(true)\"><span>{{\'SITE_GEN.COMPANY.CLICK\' | translate}}</span></button><div ng-if=\"showWebsite\" \nclass=\"nl-Article__side__tag\"><a class=\"nl-Details__link\" ng-href=\"http://{{company.website}}\" target=\"_blank\">\n{{searchValueById(11)}}</a></div></div></div><div class=\"nl-Article__side__item\"><div \nclass=\"nl-Article__side__title mb-4\">{{\'SITE_GEN.COMPANY.ADDRESS\' | translate}} :</div><div \nclass=\"nl-Article__side__tags\"><div><div class=\"nl-Article__side__tag\">\n{{searchValueById(2)}}{{searchValueById(3) ? \', \'+searchValueById(3):\'\'}}</div></div><div><div \nclass=\"nl-Article__side__tag\">{{searchValueById(4)}} - {{searchValueById(5)}}</div></div></div></div></div></div><div \nclass=\"p-10 flex-100 flex-gt-md-50\" flex-order=\"0\" flex-order-gt-sm=\"1\" id=\"BlocRight\"><div \nclass=\"nl-Details__slide nl-relArticle__slickWrapper mb-24\" ng-if=\"company.photos && company.photos.length > 0\"><div \nclass=\"nl_slick--wrapper\"><button type=\"button\" ng-click=\"_companySlickConfig.method.slickPrev()\" \nclass=\"nl_slick--button--sm\" ng-if=\"company.photos.length > 1\"><img class=\"nl-Slick__arrow\" \nsrc=\"./assets/images/slick/back_thin_white.svg\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_companySlickConfig.method.slickNext()\" class=\"nl_slick--button--sm nl_slick--button-right\" \nng-if=\"company.photos.length > 1\"><img class=\"nl-Slick__arrow\" src=\"./assets/images/slick/next_thin_white.svg\" alt=\"\">\n</button><slick settings=\"_companySlickConfig\" class=\"nl_slick nl_slick__search\"><div class=\"nl_slick--slide\" \nng-repeat=\"_photo in company.photos | orderBy:\'index\'\" \nng-if=\"company.status === \'PREMIUM\' || company.status !== \'PREMIUM\' && $index <=2\"><img class=\"nl_slick--slide--img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + _photo.location}}\" alt=\"\" ng-click=\"showSlider($index)\"></div></slick></div>\n</div><div class=\"mb-24\" ng-if=\"company.youtube != null && company.youtube != \'\'\"><iframe width=\"100%\" height=\"330\" \nsrc=\"{{convertAndTrustYoutube(company.youtube)}}\" frameborder=\"0\" \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe></div><div \nclass=\"mb-24\" ng-if=\"searchValueById(60) != null && searchValueById(60) != \'\'\"><iframe \nsrc=\"{{convertAndTrustYoutube(searchValueById(60))}}\" width=\"100%\" height=\"600\" frameborder=\"0\" style=\"border:0\" \nallowfullscreen=\"\"></iframe></div><div class=\"nl-Details__group\" flex=\"100\"><button \nclass=\"nl-BtnPure nl-BtnPure--primary nl-BtnPure--block mt-5 pr-20\" ng-if=\"!onGetSessionStorageItem(company)\" \nng-click=\"onAddToSelection(\'{{{PAGE_NAME_DETAILS_COMPANY}}}\',company)\" type=\"button\" \nng-class=\"{\'nl-Active\': onGetSessionStorageItem(company)}\"><img src=\"./assets/images/slick/plus_white.svg\" alt=\"\"> \n<span>{{\'SITE_GEN.COMPANY.ADD_SELECTION\' | translate}}</span></button><div ng-if=\"onGetSessionStorageItem(company)\" \nclass=\"layout-row layout-align-start-start\"><button class=\"nl-BtnPure nl-BtnPure--primary pr-20 nl-Active\" \ntype=\"button\"><img src=\"./assets/images/slick/check.svg\" alt=\"\"> <span>{{\'SITE_GEN.COMPANY.IS_SELECTION\' | translate}}\n</span></button> <button class=\"nl-BtnPure nl-BtnPure--danger ml-5 pr-20\" type=\"button\" \nng-click=\"onDeleteFromSelection(company)\"><img src=\"./assets/images/slick/delete_white.svg\" alt=\"\"> <span>\n{{\'SITE_GEN.COMPANY.REMOVE_SELECTION\' | translate}}</span></button></div><button \nclass=\"nl-BtnPure nl-BtnPure--primary nl-BtnPure--block mt-5\" type=\"button\" \nng-click=\"onAskForAQuotePure(\'{{{PAGE_NAME_DETAILS_COMPANY}}}\',company);\"><img \nsrc=\"./assets/images/slick/email_white.svg\" alt=\"\"> <span>{{\'SITE_GEN.COMPANY.ASK_QUOTE\' | translate}}</span></button> \n<button class=\"nl-BtnPure nl-BtnPure--primary nl-BtnPure--block mt-5\" ng-disabled=\"loaderExport\" type=\"button\" \nng-click=\"setShowWebsite(true);exportCompany()\"><md-progress-circular \nclass=\"md-accent ng-isolate-scope md-default-theme md-mode-indeterminate mr-10\" md-mode=\"indeterminate\" \nmd-diameter=\"20\" ng-if=\"loaderExport\"></md-progress-circular><img src=\"./assets/images/slick/download_white.svg\" \nalt=\"\"> <span>{{\'SITE_GEN.COMPANY.EXPORT\' | translate}}</span></button></div></div><div \nclass=\"p-10 flex-100 flex-gt-md-100\" flex-order=\"2\" flex-order-gt-sm=\"2\"><div><div id=\"FirstBloc\" \nclass=\"nl-Details__group pb-0\"><div class=\"nl-Article__side__item\" \nng-if=\"searchValueById(40) || searchValueById(41) || searchValueById(42) || searchValueById(43) || searchValueById(44) || searchValueById(45) || searchValueById(46) || searchValueById(47) || searchValueById(48)\">\n<div class=\"nl-Article__side__title mb-4\">{{\'SITE_GEN.COMPANY.CAPACITIES\' | translate}}</div><table \nclass=\"dataTable nl-TablePure\"><thead><tr><th width=\"16%\"></th><th width=\"28%\" class=\"text-center\" \nng-if=\"searchValueById(40) || searchValueById(43) || searchValueById(46)\">\n{{\'SITE_GEN.COMPANY.NUMBER_HOTELS\' | translate}}</th><th width=\"28%\" class=\"text-center\" \nng-if=\"searchValueById(41) || searchValueById(44) || searchValueById(47)\">\n{{\'SITE_GEN.COMPANY.NUMBER_BEDROOMS\' | translate}}</th><th width=\"28%\" class=\"text-center\" \nng-if=\"searchValueById(42) || searchValueById(45) || searchValueById(48)\">\n{{\'SITE_GEN.COMPANY.NUMBER_BEDS\' | translate}}</th></tr></thead><tbody><tr><td align=\"center\" \nng-if=\"searchValueById(40) || searchValueById(41) || searchValueById(42)\">3 {{\'SITE_GEN.COMPANY.STARS\' | translate}}\n</td><td align=\"center\" ng-if=\"searchValueById(40)\">{{searchValueById(40)}}</td><td align=\"center\" \nng-if=\"searchValueById(41)\">{{searchValueById(41)}}</td><td align=\"center\" ng-if=\"searchValueById(42)\">\n{{searchValueById(42)}}</td></tr><tr><td align=\"center\" \nng-if=\"searchValueById(43) || searchValueById(44) || searchValueById(45)\">4 {{\'SITE_GEN.COMPANY.STARS\' | translate}}\n</td><td align=\"center\" ng-if=\"searchValueById(43)\">{{searchValueById(43)}}</td><td align=\"center\" \nng-if=\"searchValueById(44)\">{{searchValueById(44)}}</td><td align=\"center\" ng-if=\"searchValueById(45)\">\n{{searchValueById(45)}}</td></tr><tr><td align=\"center\" \nng-if=\"searchValueById(46) || searchValueById(47) || searchValueById(48)\">5 {{\'SITE_GEN.COMPANY.STARS\' | translate}}\n</td><td align=\"center\" ng-if=\"searchValueById(46)\">{{searchValueById(46)}}</td><td align=\"center\" \nng-if=\"searchValueById(47)\">{{searchValueById(47)}}</td><td align=\"center\" ng-if=\"searchValueById(48)\">\n{{searchValueById(48)}}</td></tr></tbody></table></div><div class=\"nl-Article__side__item\" ng-if=\"searchValueById(55)\">\n<div class=\"nl-Article__side__title mb-4\">{{\'SITE_GEN.COMPANY.SERVICES\' | translate}}</div><div \nclass=\"nl-Article__side__tags\"><div class=\"nl-Article__side__tag\">{{searchValueById(55)}}</div></div></div><div \nclass=\"nl-Article__side__item\" ng-if=\"searchValueById(56)\"><div class=\"nl-Article__side__title mb-4\">\n{{\'SITE_GEN.COMPANY.SPECIALITY\' | translate}}:</div><div class=\"nl-Article__side__tags\"><div \nclass=\"nl-Article__side__tag\">{{searchValueById(56)}}</div></div></div><div class=\"nl-Article__side__item\" \nng-if=\"searchValueById(54)\"><div class=\"nl-Article__side__title mb-4\">{{\'SITE_GEN.COMPANY.SITUATION\' | translate}}:\n</div><div class=\"nl-Article__side__tags\"><div class=\"nl-Article__side__tag\">{{searchValueById(54)}}</div></div></div>\n<div class=\"nl-Article__side__item\" \nng-if=\"searchValueById(49) || searchValueById(50) || searchValueById(51) || searchValueById(52) || searchValueById(53)\">\n<div class=\"nl-Article__side__title mb-4\">{{\'SITE_GEN.COMPANY.ACCESS\' | translate}}</div><table \nclass=\"dataTable nl-TablePure\"><thead><tr><th class=\"text-center\" width=\"33%\" \nng-if=\"searchValueById(49) && searchValueById(50)\"><img class=\"nl-Article__icone\" \nsrc=\"./assets/icons/dispositions/airplane.svg\" alt=\"\"></th><th class=\"text-center\" width=\"33%\" \nng-if=\"searchValueById(51) && searchValueById(52)\"><img class=\"nl-Article__icone\" \nsrc=\"./assets/icons/dispositions/train.svg\" alt=\"\"></th><th class=\"text-center\" width=\"33%\" \nng-if=\"searchValueById(53)\"><img class=\"nl-Article__icone\" src=\"./assets/icons/dispositions/car.svg\" alt=\"\"></th></tr>\n</thead><tbody><tr><td align=\"center\" ng-if=\"searchValueById(49) && searchValueById(50)\"><span>\n{{searchValueById(49)}} ({{searchValueById(50)}} km)</span></td><td align=\"center\" \nng-if=\"searchValueById(51) && searchValueById(52)\"><span>{{searchValueById(51)}} ({{searchValueById(52)}} km)</span>\n</td><td align=\"center\" ng-if=\"searchValueById(53)\"><span>\n{{searchValueById(53)}} {{\'SITE_GEN.COMPANY.PLACES\' | translate}}</span></td></tr></tbody></table></div></div><div \nid=\"SecondBloc\" class=\"nl-Details__group pt-0\"><div class=\"nl-Article__side__item\" ng-if=\"searchValueById(27)\"><div \nclass=\"nl-Article__side__title mb-4\">{{\'SITE_GEN.COMPANY.PRESENTATION\' | translate}}</div><div \nclass=\"nl-Article__side__tags\"><div class=\"nl-Article__side__tag\" ng-bind-html=\"searchValueById(27)\"></div></div></div>\n<div class=\"nl-Article__side__item\" ng-if=\"searchValueById(28)\"><div class=\"nl-Article__side__title mb-4\">\n{{\'SITE_GEN.COMPANY.STRONG_POINTS\' | translate}}</div><div class=\"nl-Article__side__tags\"><div \nclass=\"nl-Article__side__tag\" ng-bind-html=\"searchValueById(28)\"></div></div></div><div class=\"nl-Article__side__item\" \nng-if=\"searchValueById(29)\"><div class=\"nl-Article__side__title mb-4\">{{\'SITE_GEN.COMPANY.MICE_POINTS\' | translate}}\n</div><div class=\"nl-Article__side__tags\"><div class=\"nl-Article__side__tag\" ng-bind-html=\"searchValueById(29)\"></div>\n</div></div><div class=\"nl-Article__side__item\" ng-if=\"searchValueById(30)\"><div class=\"nl-Article__side__title mb-4\">\n{{\'SITE_GEN.COMPANY.CULTURAL_HOBBIES\' | translate}}</div><div class=\"nl-Article__side__tags\"><div \nclass=\"nl-Article__side__tag\" ng-bind-html=\"searchValueById(30)\"></div></div></div><div class=\"nl-Article__side__item\" \nng-if=\"searchValueById(31)\"><div class=\"nl-Article__side__title mb-4\">\n{{\'SITE_GEN.COMPANY.PRINCIPAL_ASSET\' | translate}}</div><div class=\"nl-Article__side__tags\"><div \nclass=\"nl-Article__side__tag\" ng-bind-html=\"searchValueById(31)\"></div></div></div><div class=\"nl-Article__side__item\" \nng-if=\"searchValueById(32)\"><div class=\"nl-Article__side__title mb-4\">{{\'SITE_GEN.COMPANY.LAST_EVENTS\' | translate}}\n</div><div class=\"nl-Article__side__tags\"><div class=\"nl-Article__side__tag\" ng-bind-html=\"searchValueById(32)\"></div>\n</div></div><div class=\"nl-Article__side__item\" ng-if=\"searchValueById(33)\"><div class=\"nl-Article__side__title mb-4\">\n{{\'SITE_GEN.COMPANY.SERVICES\' | translate}}</div><div class=\"nl-Article__side__tags\"><div \nclass=\"nl-Article__side__tag\" ng-bind-html=\"searchValueById(33)\"></div></div></div><div class=\"nl-Article__side__item\" \nng-if=\"searchValueById(34)\"><div class=\"nl-Article__side__title mb-4\">{{\'SITE_GEN.COMPANY.RESTORATION\' | translate}}\n</div><div class=\"nl-Article__side__tags\"><div class=\"nl-Article__side__tag\" ng-bind-html=\"searchValueById(34)\"></div>\n</div></div><div id=\"anchor--meetingrooms\" class=\"flex-100 flex-gt-md-100\" flex-order=\"1\" flex-order-gt-sm=\"0\" \nng-show=\"dispositions !=null && dispositions.length> 0\"><div class=\"pb-4\"><div class=\"nl-Article__side__title\" \ntranslate=\"SITE_GEN.COMPANY.MEETING\"></div></div><table class=\"dataTable nl-TablePure\"><thead><tr><th \nclass=\"secondary-text\">{{\"COMPANIES.DISPOSITION.NAME\" | translate }}</th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.SQUARE_METTER\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"COMPANIES.DISPOSITION.SQUARE_FEET\"></span></div></th><th class=\"secondary-text\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.L_W_H\"></span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"COMPANIES.DISPOSITION.DAY_LIGHT\"></span></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" \naria-label=\"square meter\"><md-tooltip>{{\"COMPANIES.DISPOSITION.THEATER\" | translate}}</md-tooltip><img \nclass=\"nl-Article__icone\" src=\"assets/icons/dispositions/theatre.svg\"></md-button></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" \naria-label=\"square meter\"><md-tooltip>{{\"COMPANIES.DISPOSITION.CLASS_ROOM\" | translate}}</md-tooltip><img \nclass=\"nl-Article__icone\" src=\"assets/icons/dispositions/classroom.svg\"></md-button></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" \naria-label=\"square meter\"><md-tooltip>{{\"COMPANIES.DISPOSITION.BOARD_ROOM\" | translate}}</md-tooltip><img \nclass=\"nl-Article__icone\" src=\"assets/icons/dispositions/boardroom.svg\"></md-button></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" \naria-label=\"square meter\"><md-tooltip>{{\"COMPANIES.DISPOSITION.U_STYLE\" | translate}}</md-tooltip><img \nclass=\"nl-Article__icone\" src=\"assets/icons/dispositions/ustyle.svg\"></md-button></div></th><th class=\"secondary-text\">\n<div class=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" \naria-label=\"square meter\"><md-tooltip>{{\"COMPANIES.DISPOSITION.BANQUET\" | translate}}</md-tooltip><img \nclass=\"nl-Article__icone\" src=\"assets/icons/dispositions/banquet.svg\"></md-button></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" \naria-label=\"square meter\"><md-tooltip>{{\"COMPANIES.DISPOSITION.COCKTAIL\" | translate}}</md-tooltip><img \nclass=\"nl-Article__icone\" src=\"assets/icons/dispositions/cocktail.svg\"></md-button></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" \naria-label=\"square meter\"><md-tooltip>{{\"COMPANIES.DISPOSITION.CONFERENCE\" | translate}}</md-tooltip><img \nclass=\"nl-Article__icone\" src=\"assets/icons/dispositions/conference.svg\"></md-button></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" \naria-label=\"square meter\"><md-tooltip>{{\"COMPANIES.DISPOSITION.CABARET\" | translate}}</md-tooltip><img \nclass=\"nl-Article__icone\" src=\"assets/icons/dispositions/cabaret.svg\"></md-button></div></th><th \nclass=\"secondary-text\"><div class=\"table-header\"><md-button md-no-ink class=\"nl-Button--disabled nl-Button-tableIcon\" \naria-label=\"square meter\"><md-tooltip>{{\"COMPANIES.DISPOSITION.AUDITORIUM\" | translate}}</md-tooltip><img \nclass=\"nl-Article__icone\" src=\"assets/icons/dispositions/auditorium.svg\"></md-button></div></th></tr></thead><tbody><tr\n ng-repeat=\"_disposition in dispositions track by $index\"><td>{{ _disposition.name }}</td><td>\n{{ _disposition.squareMeter }}</td><td>{{ _disposition.squareFeet }}</td><td>\n{{ _disposition.length ? _disposition.length : \"xx\" }}/{{ _disposition.width ? _disposition.width : \"xx\" }}/{{ _disposition.height ? _disposition.height : \"xx\" }}\n</td><td>{{ !_disposition.dayLight ? \'COMPANIES.NO\' : \'COMPANIES.YES\' | translate }}</td><td>{{ _disposition.theatre }}\n</td><td>{{ _disposition.classRoom }}</td><td>{{ _disposition.boardRoom }}</td><td>{{ _disposition.uStyle }}</td><td>\n{{ _disposition.banquet }}</td><td>{{ _disposition.cocktail }}</td><td>{{ _disposition.conference }}</td><td>\n{{ _disposition.cabaret }}</td><td>{{ _disposition.auditorium }}</td></tr></tbody></table></div></div></div><div \nclass=\"mt-16 flex-100 flex-gt-md-100\" flex-order=\"2\" flex-order-gt-sm=\"2\"><div class=\"nl-Details__group\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"nl-Article__side__title\" flex>\n{{\'SITE_GEN.NOTATION.TITLE\' | translate}}</div><div><button ng-if=\"account\" class=\"nl-BtnPure nl-BtnPure--primary\" \ntype=\"button\" ng-click=\"addNotation()\"><span>{{\'SITE_GEN.NOTATION.ADD_NOTATION\' | translate}}</span></button></div>\n</div><div class=\"nl-Comment__empty\" ng-if=\"!account\"><p>{{\'SITE_GEN.NOTATION.CONNECT\' | translate}}</p><button \nclass=\"nl-BtnPure nl-BtnPure--primary\" type=\"button\" ng-click=\"goToLogin()\"><span>Identifiez-vous</span></button></div>\n<div ng-if=\"account\"><div class=\"nl-Comment__list\" ng-if=\"notation && notation.comments && notation.comments.length>0\">\n<div class=\"pt-40 pb-16 layout-row layout-align-start-end\"><span class=\"nl-Comment__note\">\n{{notation.percent | number: 1}}<span class=\"nl-Comment__note--minus\">/5</span> </span><span \nclass=\"ml-5 mr-5 nl-Comment__item__heart nl-Comment__item__heart--big\"><div><img ng-if=\"notation.percent < 0.25\" \nclass=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_o.svg\" alt=\"\"> <img \nng-if=\"notation.percent >= 0.25 && notation.percent < 0.75\" class=\"nl-Comment__item__img\" \nsrc=\"./assets/images/logo/heart_half.svg\" alt=\"\"> <img ng-if=\"notation.percent >= 0.75\" class=\"nl-Comment__item__img\" \nsrc=\"./assets/images/logo/heart_full.svg\" alt=\"\"></div><div><img ng-if=\"notation.percent < 1.25\" \nclass=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_o.svg\" alt=\"\"> <img \nng-if=\"notation.percent >= 1.25 && notation.percent < 1.75\" class=\"nl-Comment__item__img\" \nsrc=\"./assets/images/logo/heart_half.svg\" alt=\"\"> <img ng-if=\"notation.percent >= 1.75\" class=\"nl-Comment__item__img\" \nsrc=\"./assets/images/logo/heart_full.svg\" alt=\"\"></div><div><img ng-if=\"notation.percent < 2.25\" \nclass=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_o.svg\" alt=\"\"> <img \nng-if=\"notation.percent >= 2.25 && notation.percent < 2.75\" class=\"nl-Comment__item__img\" \nsrc=\"./assets/images/logo/heart_half.svg\" alt=\"\"> <img ng-if=\"notation.percent >= 2.75\" class=\"nl-Comment__item__img\" \nsrc=\"./assets/images/logo/heart_full.svg\" alt=\"\"></div><div><img ng-if=\"notation.percent < 3.25\" \nclass=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_o.svg\" alt=\"\"> <img \nng-if=\"notation.percent >= 3.25 && notation.percent < 3.75\" class=\"nl-Comment__item__img\" \nsrc=\"./assets/images/logo/heart_half.svg\" alt=\"\"> <img ng-if=\"notation.percent >=3.75\" class=\"nl-Comment__item__img\" \nsrc=\"./assets/images/logo/heart_full.svg\" alt=\"\"></div><div><img ng-if=\"notation.percent < 4.25\" \nclass=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_o.svg\" alt=\"\"> <img \nng-if=\"notation.percent >= 4.25 && notation.percent < 4.75\" class=\"nl-Comment__item__img\" \nsrc=\"./assets/images/logo/heart_half.svg\" alt=\"\"> <img ng-if=\"notation.percent >= 4.75\" class=\"nl-Comment__item__img\" \nsrc=\"./assets/images/logo/heart_full.svg\" alt=\"\"></div></span>{{\"SITE_GEN.NOTATION.WITH\" | translate}} <span \nclass=\"nl-Comment__nbrComment\">\n{{notation.comments.length}} {{\"SITE_GEN.NOTATION.COMMENT_LOW\" | translate}}{{notation.comments.length==1 ? \'\':\'s\'}} \n</span>.</div><div class=\"nl-Comment__item\" ng-repeat=\"comment in notation.visibleComments | orderBy:\'-creationDate\'\">\n<div class=\"nl-Comment__item__heart\"><div class=\"mr-10\">\n{{comment.creator.applicantLastName}} {{comment.creator.applicantFirstName}} ({{comment.creator.applicantCompany}})\n</div><div><img ng-if=\"comment.value >= 1\" class=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_full.svg\" \nalt=\"\"></div><div><img ng-if=\"comment.value < 2\" class=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_o.svg\" \nalt=\"\"> <img ng-if=\"comment.value >= 2\" class=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_full.svg\" alt=\"\">\n</div><div><img ng-if=\"comment.value < 3\" class=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_o.svg\" alt=\"\"> \n<img ng-if=\"comment.value >= 3\" class=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_full.svg\" alt=\"\"></div>\n<div><img ng-if=\"comment.value < 4\" class=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_o.svg\" alt=\"\"> <img \nng-if=\"comment.value >= 4\" class=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_full.svg\" alt=\"\"></div><div>\n<img ng-if=\"comment.value < 5\" class=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_o.svg\" alt=\"\"> <img \nng-if=\"comment.value >= 5\" class=\"nl-Comment__item__img\" src=\"./assets/images/logo/heart_full.svg\" alt=\"\"></div></div>\n<div ng-if=\"!comment.showAll && comment.content.length>80\"><div class=\"nl-Comment__item__text\">\n{{comment.content | limitTo : 80}} ...</div><div class=\"nl-Comment__link\" ng-click=\"comment.showAll=!comment.showAll\">\n{{\"SITE_GEN.NOTATION.SHOW_MORE\" | translate}}</div></div><div class=\"nl-Comment__item__text\" \nng-if=\"comment.showAll || comment.content.length<=80\">{{comment.content}}</div></div><div class=\"flex-30 mt-20\"><button\n class=\"nl-BtnPure nl-BtnPure--primary\" \nng-if=\"notation.visibleComments && notation.comments && notation.visibleComments.length<4 && notation.comments.length>3\" \nng-click=\"showMoreComments()\"><span>{{\"SITE_GEN.NOTATION.SHOW_ALL_COMMENTS\" | translate}}</span></button></div></div>\n<div class=\"nl-Comment__empty\" ng-if=\"!notation || !notation.comments || notation.comments.length==0\">\n{{\"SITE_GEN.NOTATION.NO_NOTATIONS\" | translate}}</div></div></div></div></div><div \nng-click=\"hideSlider();_companySlickConfig.method.slickGoTo(currentIndex)\" ng-if=\"showSlick\" class=\"nl_Slick--wrapper\">\n<div style=\"position: relative; height: 100%; width: 100%\"><button type=\"button\" \nng-click=\"_companyPopUpSlickConfig.method.slickPrev(); $event.stopPropagation();\" class=\"nl_slick--button\"><img \nclass=\"nl-Slick__arrow\" src=\"./assets/images/slick/back_thin_white.svg\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_companyPopUpSlickConfig.method.slickNext(); $event.stopPropagation();\" \nclass=\"nl_slick--button nl_slick--button-right\"><img class=\"nl-Slick__arrow\" \nsrc=\"./assets/images/slick/next_thin_white.svg\" alt=\"\"></button> <button type=\"button\" class=\"nl_slick--buttonClose\">\n<img class=\"\" src=\"./assets/images/slick/delete_white.svg\" alt=\"\"></button><slick current-index=\"currentIndex\" \nng-click=\"$event.stopPropagation();\" settings=\"_companyPopUpSlickConfig\" class=\"nl_Slick--popup\"><div \nclass=\"nl_slick--slide\" ng-repeat=\"photo in company.photos | orderBy:\'index\'\" \nng-if=\"company.status === \'PREMIUM\' || company.status !== \'PREMIUM\' && $index <=2\"><div class=\"nl_slick--wrapper\"><img \nng-src=\"{{URL.alternatedocroots + \'/\' + photo.location}}\" alt=\"\"><div class=\"nl_slick--description\" \nng-if=\"photo.description\">{{photo.description}}</div></div></div></slick><div class=\"\">\n{{currentIndex + 1}}/{{gallery.pictures.length}}</div></div></div></div><div class=\"ph-10\" \nng-if=\"(blogs != null && blogs.length > 0) || (companiesRelated != null && companiesRelated.length > 0) \"><div \nclass=\"nl-Article\"><div class=\"nl_Row-content\" ng-if=\"companiesRelated != null && companiesRelated.length > 0\"><h1 \nclass=\"nl-relArticle__mainTitle\">{{\'SITE_GEN.ARTICLE.COMPANIES_RELATED\' | translate}}</h1><div layout=\"row\" \nlayout-wrap><div class=\"nl-relArticle__item flex-100 flex-gt-xs-50 flex-gt-sm-25\" \nng-repeat=\"comp in companiesRelated track by comp.id\" ng-click=\"details(\'{{{PAGE_NAME_DETAILS_COMPANY}}}\', comp.id)\">\n<div class=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img \nng-if=\"comp.photos == null || comp.photos.length === 0\" class=\"nl-relArticle__img nl-relArticle__img--noLogo\" \nsrc=\"assets/images/logo/pure.png\" alt=\"\"> <img ng-if=\"comp.photos != null && comp.photos.length > 0\" \nclass=\"nl-relArticle__img\" ng-src=\"{{URL.alternatedocroots + \'/\' + comp.photos[0].location}}\" alt=\"\"></div><div \nclass=\"nl-relArticle__infos nl-relArticle__infos--centered\"><div class=\"nl-relArticle__title\">{{comp.modelPattern}}\n</div><div class=\"nl-relArticle__date\">{{showDesc(comp) }}</div></div></div></div></div></div><div \nclass=\"nl_Row-content\" ng-if=\"blogs != null && blogs.length > 0\"><h1 class=\"nl-relArticle__mainTitle\">\n{{\'SITE_GEN.ARTICLE.LAST_NEWS\' | translate}}</h1><div layout=\"row\" layout-wrap><div \nclass=\"nl-relArticle__item flex-100 flex-gt-xs-50 flex-gt-sm-25\" ng-repeat=\"blog in blogs track by blog.id\" \nng-click=\"details(\'{{{Article Page Name}}}\', blog.id)\"><div class=\"nl-relArticle__item__inner\"><div \nclass=\"nl-relArticle__imgWrapper\"><img class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + blog.miniature.location}}\" alt=\"\"></div><div class=\"nl-relArticle__infos\"><div \nclass=\"nl-relArticle__title\">{{blog.name}}</div><div class=\"nl-relArticle__date\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date:blog.dateStart} }}</div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/contact.template.type.html","<div class=\"nl_Row-content\"><h1 class=\"nl-titre--main\">{{\'SITES_MANAGEMENT.BLOCS.CONTACT.TITLE\' | translate}}</h1><div \nng-if=\"senderMail\" class=\"nl-prestataire-search-item\"><div class=\"nl-prestataire-search-item-title\">\n{{\'SITES_MANAGEMENT.BLOCS.CONTACT.CONTACT\' | translate}}</div>{{senderMail}}</div><div \nclass=\"nl-prestataire-search-item\"><span ng-if=\"!formSent\"><div class=\"nl-prestataire-search-item-title\">\n{{\'SITES_MANAGEMENT.BLOCS.CONTACT.CONTACT_FORM\' | translate}}</div>\n{{\'SITES_MANAGEMENT.BLOCS.CONTACT.ALL_FIELDS_REQUIRED\' | translate}}<form name=\"ContactForm\" layout=\"row\" \nng-submit=\"ContactForm.$valid && sendContact()\"><div flex layout=\"column\"><md-input-container flex><label>\n{{\'SITES_MANAGEMENT.BLOCS.CONTACT.MAIL\'|translate}}</label><input type=\"email\" ng-pattern=\"/^.+@.+\\..+$/\" required \nng-model=\"contact.email\" name=\"email\"><div ng-messages=\"ContactForm.email.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container flex><label>{{\'SITES_MANAGEMENT.BLOCS.CONTACT.PHONE\'|translate}}</label><input type=\"text\" \nrequired ng-model=\"contact.phone\" name=\"phone\"><div ng-messages=\"ContactForm.phone.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container>\n<md-input-container flex><label>{{\'SITES_MANAGEMENT.BLOCS.CONTACT.FIRSTNAME\'|translate}}</label><input type=\"text\" \nmaxlength=\"255\" required ng-model=\"contact.firstName\" name=\"firstName\"><div ng-messages=\"ContactForm.firstName.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container flex><label>{{\'SITES_MANAGEMENT.BLOCS.CONTACT.LASTNAME\'|translate}}</label>\n<input type=\"text\" maxlength=\"255\" required ng-model=\"contact.lastName\" name=\"lastName\"><div \nng-messages=\"ContactForm.lastName.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container flex><label>\n{{\'SITES_MANAGEMENT.BLOCS.CONTACT.COMPANY\'|translate}}</label><input type=\"text\" maxlength=\"255\" required \nng-model=\"contact.company\" name=\"company\"><div ng-messages=\"ContactForm.company.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container></div><div flex \nlayout=\"column\"><md-input-container class=\"ml-25 mt-25 mb-0\" flex><label>\n{{\'SITES_MANAGEMENT.BLOCS.CONTACT.YOUR_MESSAGE\'|translate}}</label><textarea ng-model=\"contact.message\" rows=\"8\" \nname=\"message\" required>\n						</textarea><div ng-messages=\"ContactForm.message.$error\" role=\"alert\"><div \nng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><div \nlayout=\"row\" align=\"center\"><div ng-model=\"recaptchaResponse\" flex vc-recaptcha \nkey=\"\'6LeiFGAUAAAAABf2un4SgDrdZMpuB-R4UIsi7Dvg\'\"></div><md-button type=\"submit\" flex=\"30\" \nclass=\"md-raised md-primary md-hue-2\">{{\'SITES_MANAGEMENT.BLOCS.CONTACT.SEND_MESSAGE\'|translate}}</md-button></div>\n</div></form></span><span ng-if=\"formSent\">{{\'SITES_MANAGEMENT.BLOCS.CONTACT.SUCCESS_MSG\'|translate}}</span></div>\n</div>");
$templateCache.put("app/main/sites_management/blocs/bloc/decouvrez.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" layout-align=\"start stretch\"><div flex=\"33\"><a href=\"\" \nclass=\"nl-discover-wrapper nl-discover-wrapper--md\"><div class=\"nl-discover-title\">Quartiers</div><img \nsrc=\"assets/images/slick/2.jpg\" alt=\"\"> </a><a href=\"\" class=\"nl-discover-wrapper nl-discover-wrapper--sm\"><div \nclass=\"nl-discover-title\">Lieux de culte</div><img src=\"assets/images/slick/2.jpg\" alt=\"\"> </a><a href=\"\" \nclass=\"nl-discover-wrapper nl-discover-wrapper--sm\"><div class=\"nl-discover-title\">Jardins</div><img \nsrc=\"assets/images/slick/2.jpg\" alt=\"\"></a></div><div flex=\"33\"><a href=\"\" \nclass=\"nl-discover-wrapper nl-discover-wrapper--md\"><div class=\"nl-discover-title\">Places</div><img \nsrc=\"assets/images/slick/2.jpg\" alt=\"\"> </a><a href=\"\" class=\"nl-discover-wrapper nl-discover-wrapper--md\"><div \nclass=\"nl-discover-title\">Sites archéologiques</div><img src=\"assets/images/slick/2.jpg\" alt=\"\"></a></div><div \nflex=\"33\"><a href=\"\" class=\"nl-discover-wrapper nl-discover-wrapper--lg\"><div class=\"nl-discover-title\">Restaurants\n</div><img src=\"assets/images/slick/1.jpg\" alt=\"\"></a></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/favorite.template.type.html","<div class=\"nl_Row-content\" \nng-init=\"getBlogs([{{{Reference of favorite blogs - separated by a comma }}}],\'{{{Article Page Name}}}\')\" \nng-if=\"showBlocByDates(\'{{{start date - dd/MM/yyyy - \'null\' if you dont\'t want}}}\', \'{{{date de fin - dd/MM/yyyy- \'null\' if you dont\'t want}}}\')\">\n<div layout=\"row\" layout-wrap><div flex=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div class=\"nl_slick--wrapper wrapper-mw\"><button ng-if=\"blogs.length>4\" type=\"button\" \nng-click=\"slickConfig.method.slickPrev()\" class=\"nl-Favorite-slick__btn__left\"><img \nsrc=\"assets/images/slick/arrow_left.svg\" alt=\"\"></button> <button ng-if=\"blogs.length>4\" type=\"button\" \nng-click=\"slickConfig.method.slickNext()\" class=\"nl-Favorite-slick__btn__right\"><img \nsrc=\"assets/images/slick/arrow_right.svg\" alt=\"\"></button><slick settings=\"slickConfig\" class=\"nl-Slick--favorite\" \nng-class=\"{\'nl-Slick--empty\': blogs.length<5 }\"><div ng-repeat=\"blog in blogs track by blog.id\"><div \nclass=\"nl-relArticle__item\" role=\"button\" ng-click=\"details(blog.id)\"><div class=\"nl-relArticle__item__inner\"><div \nclass=\"nl-relArticle__imgWrapper\"><img class=\"nl-relArticle__img\" \nng-if=\"blog.photos != null && blog.photos.length > 0\" \nng-src=\"{{URL.alternatedocroots + \'/\' + blog.photos[0].location}}\" alt=\"\"> <img \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" ng-if=\"blog.photos == null || blog.photos.length === 0\" \nsrc=\"assets/images/logo/pure.png\" alt=\"\"></div><div \nclass=\"nl-relArticle__infos nl-relArticle__infos--alt nl-relArticle__infos--centered\"><div \nclass=\"nl-relArticle__title\">{{blog.name}}</div><div class=\"nl-relArticle__date\">\n{{\'GENERAL.DATE_FORMAT\' | translate: {date:blog.dateStart} }}</div></div></div></div></div></slick></div></div></div>\n</div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/festival.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-prestataire-search--slick\" \nng-if=\"festival.photos && festival.photos.length > 0\"><div class=\"nl_slick--wrapper\"><button type=\"button\" \nng-click=\"_festivalSlickConfig.method.slickPrev()\" class=\"nl_slick--button\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_festivalSlickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"_festivalSlickConfig\" \nclass=\"nl_slick nl_slick--article\"><div class=\"nl_slick--slide\" ng-repeat=\"_photo in festival.photos\"><img \nclass=\"nl_slick--slide--img\" ng-src=\"{{_photo.url}}\" alt=\"\"></div></slick></div></div><div layout=\"row\" \nclass=\"nl-prestataire-search-item\" layout-wrap><div flex=\"70\" flex-sm=\"60\" flex-xs=\"100\" class=\"pr-20\"><div \nlayout=\"column\"><div class=\"nl-titre--main nl--item\">{{festival.name}}</div><div><div \nclass=\"nl-prestataire-search-item-description ql-editor\" ng-bind-html=\"trustAsHtml(festival.description)\"></div></div>\n</div></div><div flex=\"30\" flex-sm=\"40\" flex-xs=\"100\" class=\"nl-prestataire-search-item-side\"><div layout=\"column\"><div\n class=\"nl-prestataire-search-detail-aside\"><div class=\"nl-prestataire-search-item-title title--panel\" \nng-if=\"festival.dateStart != null || festival.dateEnd != null\">Dates:</div><div \nclass=\"nl-prestataire-search-item-text mb-10\">\n{{\'GENERAL.DATE_TIME_FORMAT\' | translate: {date:getDate(festival.dateStart)} }} <span \nng-if=\"festival.dateStart != null && festival.dateEnd != null\">- </span>\n{{\'GENERAL.DATE_TIME_FORMAT\' | translate:{date:getDate(festival.dateEnd)} }}</div><div \nclass=\"nl-prestataire-search-item-title title--panel\">Adresse:</div><div class=\"nl-prestataire-search-item-text mb-10\">\n{{festival.address+\' \'+festival.country}}</div><div class=\"nl-prestataire-search-item-title title--panel\">Website:\n</div><div class=\"nl-prestataire-search-item-text\"><a ng-href=\"{{festival.website}}\" target=\"_blank\">\n{{festival.website}}</a></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/festivals.template.type.html","<div class=\"nl_Row-content\"><h1 class=\"nl-titre--main nl--center\" translate=\"\">Festivals organized in Lebanon</h1><div \nclass=\"mv-50\" infinite-scroll=\"loadMoreFestivals()\" infinite-scroll-container=\"\'#content-generated\'\" \ninfinite-scroll-disabled=\"infiniteScrollPrevent\" infinite-scroll-immediate-check=\"false\"><div \nclass=\"nl-prestataire-search-item animated fadeIn\" layout=\"row\" layout-align=\"start start\" \nng-repeat=\"festival in festivals\"><div flex=\"75\" layout=\"column\" class=\"pr-20\"><div><div \nclass=\"nl-prestataire-search-item-title\">{{festival.name}}</div><div class=\"nl-prestataire-search-item-subtitle\" \nng-if=\"festival.dateStart != null || festival.dateEnd != null\"><md-icon md-font-icon=\"icon-calendar\" class=\"s25\">\n</md-icon>{{\'GENERAL.DATE_TIME_FORMAT\' | translate: {date:getDate(festival.dateStart)} }} <span \nng-if=\"festival.dateStart != null && festival.dateEnd != null\">- </span>\n{{\'GENERAL.DATE_TIME_FORMAT\' | translate:{date:getDate(festival.dateEnd)} }}</div><div \nclass=\"nl-prestataire-search-item-subtitle\">{{festival.address+\' \'+festival.country}} | <a \nng-href=\"{{festival.website}}\" target=\"_blank\">{{festival.website}}</a></div></div><div><div \nclass=\"nl-prestataire-search-item-description nl-crop pr-5 ql-editor\" \nng-bind-html=\"trustAsHtml(festival.description | nlEllipsis: 400)\"></div></div></div><div flex=\"25\" layout=\"column\">\n<div class=\"nl-prestataire-search-item-imgWrapper\"><img class=\"nl-prestataire-search-item-img\" \nng-if=\"festival.photos != null && festival.photos.length > 0\" \nng-src=\"{{URL.alternatedocroots + \'/\' + festival.photos[0].location}}\" alt=\"\"></div><div class=\"mt-16\"><button \ntype=\"button\" ng-click=\"details(\'{{{PAGE_NAME_DETAILS_FESTIVAL}}}\', festival.id)\" class=\"nl-Item-button pr-20\">\nRead more</button></div></div></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\">\n<div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div \nclass=\"half-circle\"></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/ficheType.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-FicheType\" layout=\"row\" layout-align=\"start stretch\"><div class=\"\" \nlayout=\"row\"></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/galleries.template.type.html","<div class=\"nl_Row-content\" ng-init=\"getGalleries([\'ffa9beb0\', \'c68c90ad\', \'5efa5261\', \'e3278234\'])\"><div \nng-repeat=\"gallery in galleries\"><h1 class=\"nl-titre--main\">{{gallery.title}}</h1><div layout=\"row\" layout-wrap \nlayout-align=\"start\"><div class=\"nl-rowImage p-5\" flex=\"33\" \nng-repeat=\"subGallery in gallery.subGalleries | orderBy: \'index\'\" \nng-click=\"goSubGallery(\'{{{PAGE_NAME_DETAILS_GALLERY}}}\', subGallery.uuid)\"><a href=\"\"><div \nclass=\"nl-rowImage-wrapper m-10\"><div class=\"nl-rowImage-title\">{{subGallery.title}}</div><img class=\"nl-rowImage-img\" \nng-if=\"subGallery.previewPicture\" ng-src=\"{{URL.alternatedocroots + \'/\' + subGallery.previewPicture.location}}\" alt=\"\">\n</div></a></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/gallery.template.type.html","<div class=\"nl_Row-content\" ng-init=\"myIndex = 0;\"><md-button type=\"button\" class=\"md-raised md-primary md-hue-2\" \nng-click=\"goBack(\'{{{PAGE_NAME_GALLERIES}}}\')\">{{\"GALLERY.BACK_TO_GALLERIES\" | translate}}</md-button><br><h1 \nclass=\"nl-titre--main\">{{gallery.title}}</h1><div class=\"nl-rowImage\" layout=\"row\" layout-wrap layout-align=\"start\">\n<div flex=\"33\" ng-repeat=\"picture in gallery.pictures\" class=\"nl-rowImage p-5\"><div class=\"nl-rowImage-wrapper\"><img \nimg-dimensions-bind-directive=\"picture\" ng-click=\"showSlider($index)\" class=\"nl-rowImage-img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + picture.location}}\" alt=\"\"></div><md-button type=\"button\" \nclass=\"md-raised md-primary md-hue-2\" ng-click=\"downloadFromFileName(picture.location)\">\n{{\"GALLERY.DOWNLOAD_HIGH\" | translate}}</md-button></div></div><div ng-click=\"hideSlider()\" ng-if=\"showSlick\" \nclass=\"nl_Slick--wrapper\"><div style=\"position: relative; height: 100%; width: 100%\"><button type=\"button\" \nng-click=\"gallerySlickConfig.method.slickPrev(); $event.stopPropagation();\" class=\"nl_slick--button\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"gallerySlickConfig.method.slickNext(); $event.stopPropagation();\" \nclass=\"nl_slick--button nl_slick--button-right\"><img src=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick \ncurrent-index=\"myIndex\" ng-click=\"$event.stopPropagation();\" settings=\"gallerySlickConfig\" class=\"nl_Slick--popup\"><div\n class=\"nl_slick--slide\" ng-repeat=\"picture in gallery.pictures\"><img \nng-src=\"{{URL.alternatedocroots + \'/\' + picture.location}}\" alt=\"\"></div></slick><div class=\"\">\n{{myIndex + 1}}/{{gallery.pictures.length}}</div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/html_100.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-relArticle__item nl-relArticle__floating flex-100\" \nng-click=\"goToUrl(\'{{{URL}}}\')\"><div class=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img \nclass=\"nl-relArticle__img\" src=\"{{{IMAGE}}}\" alt=\"\"></div><div class=\"nl-relArticle__infos\"><div \nclass=\"nl-relArticle__title\">{{{TITRE}}}</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">\n{{{SOUS_TITRE}}}</div><div class=\"nl-relArticle__text\">{{{DESCRIPTION}}}</div><div class=\"nl-relArticle__btn\" \nrole=\"button\" ng-click=\"$event.stopPropagation();goToUrl(\'{{{URL}}}\')\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/html_25.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" layout-wrap layout-align=\"start start\"><div \nclass=\"nl-relArticle__item flex-100 flex-gt-md-25\" role=\"button\" ng-click=\"goToUrl(\'{{{URL_1}}}\')\"><div \nclass=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img class=\"nl-relArticle__img\" \nsrc=\"{{{IMAGE_1}}}\" alt=\"\"></div><div class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{{TITRE_1}}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">{{{SOUS_TITRE_1}}}</div><div \nclass=\"nl-relArticle__btn\" role=\"button\" ng-click=\"$event.stopPropagation();goToUrl(\'{{{URL_1}}}\')\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div><div \nclass=\"nl-relArticle__item flex-100 flex-gt-md-25\" role=\"button\" ng-click=\"goToUrl(\'{{{URL_2}}}\')\"><div \nclass=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img class=\"nl-relArticle__img\" \nsrc=\"{{{IMAGE_2}}}\" alt=\"\"></div><div class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{{TITRE_2}}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">{{{SOUS_TITRE_2}}}</div><div \nclass=\"nl-relArticle__btn\" role=\"button\" ng-click=\"$event.stopPropagation();goToUrl(\'{{{URL_2}}}\')\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div><div \nclass=\"nl-relArticle__item flex-100 flex-gt-md-25\" role=\"button\" ng-click=\"goToUrl(\'{{{URL_3}}}\')\"><div \nclass=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img class=\"nl-relArticle__img\" \nsrc=\"{{{IMAGE_3}}}\" alt=\"\"></div><div class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{{TITRE_3}}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">{{{SOUS_TITRE_3}}}</div><div \nclass=\"nl-relArticle__btn\" role=\"button\" ng-click=\"$event.stopPropagation();goToUrl(\'{{{URL_3}}}\')\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div><div \nclass=\"nl-relArticle__item flex-100 flex-gt-md-25\" role=\"button\" ng-click=\"goToUrl(\'{{{URL_4}}}\')\"><div \nclass=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img class=\"nl-relArticle__img\" \nsrc=\"{{{IMAGE_4}}}\" alt=\"\"></div><div class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{{TITRE_4}}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">{{{SOUS_TITRE_4}}}</div><div \nclass=\"nl-relArticle__btn\" role=\"button\" ng-click=\"$event.stopPropagation();goToUrl(\'{{{URL_4}}}\')\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/html_33.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" layout-wrap layout-align=\"start start\"><div \nclass=\"nl-relArticle__item flex-100 flex-gt-md-33\" role=\"button\" ng-click=\"goToUrl(\'{{{URL_1}}}\')\"><div \nclass=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img class=\"nl-relArticle__img\" \nsrc=\"{{{IMAGE_1}}}\" alt=\"\"></div><div class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{{TITRE_1}}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">{{{SOUS_TITRE_1}}}</div><div \nclass=\"nl-relArticle__btn\" role=\"button\" ng-click=\"$event.stopPropagation();goToUrl(\'{{{URL_1}}}\')\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div><div \nclass=\"nl-relArticle__item flex-100 flex-gt-md-33\" role=\"button\" ng-click=\"goToUrl(\'{{{URL_2}}}\')\"><div \nclass=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img class=\"nl-relArticle__img\" \nsrc=\"{{{IMAGE_2}}}\" alt=\"\"></div><div class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{{TITRE_2}}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">{{{SOUS_TITRE_2}}}</div><div \nclass=\"nl-relArticle__btn\" role=\"button\" ng-click=\"$event.stopPropagation();goToUrl(\'{{{URL_2}}}\')\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div><div \nclass=\"nl-relArticle__item flex-100 flex-gt-md-33\" role=\"button\" ng-click=\"goToUrl(\'{{{URL_3}}}\')\"><div \nclass=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img class=\"nl-relArticle__img\" \nsrc=\"{{{IMAGE_3}}}\" alt=\"\"></div><div class=\"nl-relArticle__infos\"><div class=\"nl-relArticle__title\">{{{TITRE_3}}}\n</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">{{{SOUS_TITRE_3}}}</div><div \nclass=\"nl-relArticle__btn\" role=\"button\" ng-click=\"$event.stopPropagation();goToUrl(\'{{{URL_3}}}\')\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/html_50.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" layout-wrap layout-align=\"start start\"><div \nclass=\"nl-relArticle__item nl-relArticle__floating flex-100 flex-gt-md-50\" role=\"button\" \nng-click=\"goToUrl(\'{{{URL_1}}}\')\"><div class=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img \nclass=\"nl-relArticle__img\" src=\"{{{IMAGE_1}}}\" alt=\"\"></div><div class=\"nl-relArticle__infos\"><div \nclass=\"nl-relArticle__title\">{{{TITRE_1}}}</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">\n{{{SOUS_TITRE_1}}}</div><div class=\"nl-relArticle__text\">{{{DESCRIPTION_1}}}</div><div class=\"nl-relArticle__btn\" \nrole=\"button\" ng-click=\"$event.stopPropagation();goToUrl(\'{{{URL_1}}}\')\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div><div \nclass=\"nl-relArticle__item nl-relArticle__floating flex-100 flex-gt-md-50\" role=\"button\" \nng-click=\"goToUrl(\'{{{URL_2}}}\')\"><div class=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img \nclass=\"nl-relArticle__img\" src=\"{{{IMAGE_2}}}\" alt=\"\"></div><div class=\"nl-relArticle__infos\"><div \nclass=\"nl-relArticle__title\">{{{TITRE_2}}}</div><div class=\"nl-relArticle__aside\"><div class=\"nl-relArticle__date\">\n{{{SOUS_TITRE_2}}}</div><div class=\"nl-relArticle__text\">{{{DESCRIPTION_2}}}</div><div class=\"nl-relArticle__btn\" \nrole=\"button\" ng-click=\"$event.stopPropagation();goToUrl(\'{{{URL_2}}}\')\"><span>\n{{\'SITE_GEN.ARTICLE.READ_MORE\' | translate}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/itemMonument.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" layout-align=\"start stretch\" class=\"nl-Item\"><div layout=\"column\" \nlayout-align=\"start start\"><div class=\"nl-Item-title\">Musée National de Beyrouth</div><div class=\"nl-Item-adresse\">\nAdresse National de Beyrouth</div><div class=\"nl-Item-text\">\nLorem, ipsum dolor sit amet consectetur adipisicing elit. Quod, illum cupiditate! Facilis dolor numquam laboriosam, error nobis unde quasi. Quia, voluptatem? Veritatis hic atque facilis repudiandae labore optio minima modi. Molestiae corporis odit incidunt maiores eaque architecto aliquam perferendis aspernatur molestias blanditiis, obcaecati consequatur ut reiciendis cum sed. Soluta dolorem maiores quaerat nam deleniti fuga a ratione voluptatem veniam aliquam? Tempora dolorum, adipisci earum eligendi rem corrupti optio tenetur explicabo, iusto ut nostrum, dolorem hic id.\n<br><br>\nHic magnam facilis fugit laudantium fuga laboriosam voluptates animi fugiat delectus, ipsam architecto nulla. Unde, quis officiis laborum incidunt est iure dolor, ducimus aperiam modi earum necessitatibus? Suscipit aperiam obcaecati, doloribus provident recusandae inventore maiores, harum alias voluptate, in libero quaerat mollitia veniam ex?\n</div></div><div layout=\"column\" layout-align=\"start start\"><div class=\"nl-Item-carte\"><iframe \nsrc=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.436393166397!2d35.512889251312686!3d33.878413180558695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151f1705bf01caff%3A0x241292ecea61d223!2sMus%C3%A9e+national+de+Beyrouth!5e0!3m2!1sfr!2sfr!4v1523537000893\" \nwidth=\"100%\" height=\"250\" frameborder=\"0\" style=\"border:0\" allowfullscreen></iframe></div><div \nclass=\"nl-Item-imgwrapper\"><img class=\"nl-Item-img\" src=\"assets/images/etc/early-sunrise.jpg\" alt=\"\"></div><button \ntype=\"button\" class=\"nl-Item-button mt-10\">En savoir plus</button></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/listItem.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-LongList\" layout=\"row\" layout-align=\"start start\"><div><div \nclass=\"nl-LongList-number\">1</div></div><div><div class=\"nl-LongList-text\">\nLorem ipsum, dolor sit amet consectetur adipisicing elit. Nihil odit corporis similique placeat. Distinctio repellat, quisquam iure adipisci soluta suscipit quis a, saepe praesentium ducimus ut, nemo ratione earum molestiae?\n</div></div><div><div class=\"nl-LongList-imageWrapper\"><img class=\"nl-LongList-image\" src=\"assets/images/slick/3.jpg\" \nalt=\"\"></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/mainTitre.template.type.html","<div class=\"nl_Row-content\"><h1 class=\"nl-titre--main nl--center\">10 bonnes raisons d\'organiser un événement au Liban\n</h1></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/maps.template.type.html","<div layout=\"row\"><iframe \nsrc=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2614.7038400597294!2d2.0403605160307725!3d49.054254479307126!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47e68ace239d7501%3A0xdd10b9677d7d23a2!2sNooline!5e0!3m2!1sfr!2sfr!4v1567009776448!5m2!1sfr!2sfr\" \nwidth=\"600\" height=\"450\" frameborder=\"0\" style=\"border:0\" allowfullscreen=\"\"></iframe></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/newRowImageTitle.type.html","<div class=\"nl_Row-content\"><div class=\"nl-rowImage\" layout=\"row\" layout-align=\"center stretch\" layout-wrap><div \nflex=\"33\" class=\"p-5\" flex-xs=\"100\"><a href=\"{{{URL Link 1}}}\"><div class=\"nl-rowImage-wrapper\"><div \nclass=\"nl-NewRowImage-title\">{{{Title 1}}}</div><img class=\"nl-NewRowImage-img\" src=\"{{{Image 1 URL Link}}}\" alt=\"\">\n</div></a></div></div><div flex=\"33\" class=\"p-5\" flex-xs=\"100\"><a href=\"{{{URL Link 2}}}\"><div \nclass=\"nl-rowImage-wrapper\"><div class=\"nl-NewRowImage-title\">{{{Title 2}}}</div><img class=\"nl-NewRowImage-img\" \nsrc=\"{{{Image 2 URL Link}}}\" alt=\"\"></div></a></div></div><div flex=\"33\" class=\"p-5\" flex-xs=\"100\"><a \nhref=\"{{{URL Link 3}}}\"><div class=\"nl-rowImage-wrapper\"><div class=\"nl-NewRowImage-title\">{{{Title 3}}}</div><img \nclass=\"nl-NewRowImage-img\" src=\"{{{Image 3 URL Link}}}\" alt=\"\"></div></a></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/newsletter.template.type.html","<div class=\"nl-Article__content\"><div layout=\"row\" layout-align=\"center start\" layout-wrap><div \nclass=\"flex-100 flex-gt-xs-100 flex-gt-md-60\"><div class=\"nl-Article-column mt-15\"><div class=\"\"><div \nclass=\"nl-Article__side__title\">Newsletter</div><div ng-if=\"!mailsended\" class=\"nl-Newsletter--description\">\n{{\'SITE_GEN.NEWSLETTER.SUBSCRIBE\' | translate}}</div><div ng-if=\"mailsended\" class=\"nl-Newsletter--description\">\n{{\'SITE_GEN.NEWSLETTER.THANKS\' | translate}}</div><div ng-if=\"!mailsended\"><form name=\"newsletterForm\" \nclass=\"md-inline-form\" novalidate><md-input-container class=\"nl-Article__Input\" flex=\"100\" md-no-float><input \ntype=\"email\" ng-model=\"newsletterMail.mail\" placeholder=\"{{ \'SITE_GEN.ARTICLE.MAIL\' | translate }}\" name=\"mail\" \nrequired><div ng-messages=\"newsletterForm.mail.$error\" class=\"nl-fixeDivError\"><span ng-message=\"email\">\n{{\'GENERAL.PATTERN\' | translate}}</span> <span ng-message=\"required\">{{\'GENERAL.REQUIRED\' | translate}}</span></div>\n</md-input-container><button class=\"nl-Article__btn\" ng-disabled=\"!newsletterForm.$valid\" ng-click=\"sendNewsletter()\">\n{{\'SITE_GEN.NEWSLETTER.CONNECT\' | translate}}</button></form></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/package.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-prestataire-search--slick\" \nng-if=\"package.documents && package.documents.length > 0\"><div class=\"nl_slick--wrapper\"><button type=\"button\" \nng-click=\"_packageSlickConfig.method.slickPrev()\" class=\"nl_slick--button\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_packageSlickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"_packageSlickConfig\" \nclass=\"nl_slick nl_slick--article\"><div class=\"nl_slick--slide\" ng-repeat=\"_photo in package.documents\"><img \nclass=\"nl_slick--slide--img\" ng-src=\"{{URL.alternatedocroots + \'/\' + _photo.location}}\" alt=\"\"></div></slick></div>\n</div><div layout=\"row\" class=\"nl-prestataire-search-item\" layout-wrap><div flex=\"70\" flex-sm=\"60\" flex-xs=\"100\" \nclass=\"pr-20\"><div layout=\"column\"><div class=\"nl-titre--main nl--item\">{{package.name}}</div><div><div \nclass=\"nl-prestataire-search-item-description ql-editor\" ng-bind-html=\"trustAsHtml(package.description)\"></div></div>\n</div></div><div flex=\"30\" flex-sm=\"40\" flex-xs=\"100\" class=\"nl-prestataire-search-item-side\"><div layout=\"column\"><div\n class=\"nl-prestataire-search-item-imgWrapper\"><img \nng-if=\"package.companyLogo == null || package.companyLogo.length === 0\" \nclass=\"nl-prestataire-search-item-img nl-img--logo\" src=\"assets/images/slick/1.jpg\" alt=\"\"> <img \nng-if=\"package.companyLogo != null && package.companyLogo.length > 0\" \nclass=\"nl-prestataire-search-item-img nl-img--logo\" ng-src=\"{{URL.alternatedocroots + \'/\' + package.companyLogo}}\" \nalt=\"\"></div><div class=\"mt-16\"><button type=\"button\" class=\"nl-Item-button\">Demander un devis</button></div><div \nclass=\"nl-prestataire-search-detail-aside\"><div class=\"nl-prestataire-search-item-title title--panel\">Durée:</div><div \nclass=\"nl-prestataire-search-item-text mb-10\">{{package.duration}} jours</div><div \nclass=\"nl-prestataire-search-item-title title--panel\">Lieux:</div><div class=\"nl-prestataire-search-item-text mb-10\">\n<span ng-if=\"package.regions != null && package.regions.length > 0\" ng-repeat=\"region in package.regions | limitTo: 3\">\n{{region.value}} <span ng-if=\"!$last\">{{\', \'}}</span> <span ng-if=\"$last && package.regions.length > 3\">{{\',...\'}}\n</span></span></div><div class=\"nl-prestataire-search-item-title title--panel\">Types:</div><div \nclass=\"nl-prestataire-search-item-text\"><span \nng-if=\"package.typesTourisme != null && package.typesTourisme.length > 0\" \nng-repeat=\"type in package.typesTourisme | limitTo: 3\">{{type.value}} <span ng-if=\"!$last\">{{\', \'}}</span> <span \nng-if=\"$last && package.typesTourisme.length > 3\">{{\',...\'}}</span></span></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/pageSiteTourist.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" class=\"nl-prestataire-search-item\"><div flex=\"70\" class=\"pr-20\"><div \nlayout=\"column\"><div class=\"nl-titre--main nl--item\">Musée National de Beyrouth</div><div><div \nclass=\"nl-prestataire-search-item-description\">\nLorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt fugiat consequuntur nostrum? Vero, sapiente adipisci? Quo nisi placeat, nostrum aspernatur inventore sapiente dolore eveniet, aliquid harum in velit labore. Magni! Ducimus vero, facere eaque aut veniam nulla doloremque iure iste ad. Nulla possimus animi nesciunt non ipsum dolores accusamus, quia harum veritatis molestias, deleniti facilis earum eos et quasi perspiciatis.\n<br><br>\nNesciunt, magnam pariatur? Quidem voluptas accusamus tempora aliquam soluta quas, illo assumenda consequatur consectetur reprehenderit aut sint, hic praesentium molestiae deleniti voluptatibus doloremque eaque nam accusantium saepe! Modi, vitae dolores. Similique magnam natus consectetur atque praesentium iure beatae nemo quae, asperiores reprehenderit est aliquam, sint ipsum ea vitae porro dolorum fuga illum. Explicabo omnis a necessitatibus vel possimus harum hic.\n</div></div><div><a href=\"#\" class=\"nl-download-pdf\"><img src=\"assets/images/slick/2.jpg\" alt=\"\"><div \nclass=\"nl-download-pdf-title\">Cliquez ici pour télécharger notre visite guidée en PDF</div></a></div></div></div><div \nflex=\"30\" class=\"nl-prestataire-search-item-side\"><div layout=\"column\"><div class=\"nl-Paragraphe-aside-img\"><iframe \nwidth=\"100%\" height=\"220px\" src=\"https://www.youtube.com/embed/8DHV0q-qb0o?rel=0\" frameborder=\"0\" \nallow=\"autoplay; encrypted-media\"></iframe></div><div class=\"nl-prestataire-search-detail-aside\"><div \nclass=\"nl-prestataire-search-item-title title--panel\">Adresse:</div><div class=\"nl-prestataire-search-item-text mb-10\">\nValley of the Dog River / Keserwan, Beirut, Liban</div><div class=\"nl-prestataire-search-item-title title--panel\">\nWebsite:</div><div class=\"nl-prestataire-search-item-text mb-10\"><a ng-href=\"\" target=\"_blank\">www.jeitagrotto.com</a>\n</div><div class=\"nl-prestataire-search-item-title title--panel\">Horaires:</div><div \nclass=\"nl-prestataire-search-item-text mb-10\">Lundi au Samedi de 09:00 à 17:00</div></div><div class=\"nl-Item-carte\">\n<iframe \nsrc=\"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3312.436393166397!2d35.512889251312686!3d33.878413180558695!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x151f1705bf01caff%3A0x241292ecea61d223!2sMus%C3%A9e+national+de+Beyrouth!5e0!3m2!1sfr!2sfr!4v1523537000893\" \nwidth=\"100%\" height=\"250\" frameborder=\"0\" style=\"border:0\" allowfullscreen></iframe></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/paragraphe.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-Paragraphe mv-25\">\nLorem ipsum dolor sit amet consectetur adipisicing elit. Autem, nam inventore. Dicta sint sed, officiis doloribus, pariatur optio sunt tempore corporis, ad debitis earum consequuntur maxime molestiae explicabo dolor expedita!Voluptate provident facilis porro reprehenderit fugit, explicabo laborum sed praesentium quod aspernatur velit excepturi iure impedit, consectetur fugiat facere accusantium cumque? Autem vitae quibusdam exercitationem ea quas cum, quasi inventore.\n</div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/paragrapheAsideList.html","<div class=\"nl_Row-content\"><div layout=\"row\" layout-align=\"start start\"><div flex=\"66\"><div class=\"nl-Paragraphe\">\nLorem ipsum dolor sit amet consectetur adipisicing elit. Voluptas assumenda, recusandae ipsa aliquam dolor omnis vero nostrum asperiores perspiciatis eaque vel placeat in hic enim ducimus? Cum impedit aliquam eos? Optio, iste iusto? Voluptas ipsum quibusdam quae sint hic explicabo, dignissimos vitae, sed perferendis iste vero! Saepe eaque voluptas nostrum quis id corporis iste eos nulla, reiciendis exercitationem quasi fugit? Error assumenda ipsum doloribus deserunt accusamus voluptas totam aperiam, quidem quo unde dolorum nulla illum corporis neque maiores odit? Assumenda maxime libero magnam minus incidunt, illo expedita distinctio quam eligendi. Voluptatibus ea dolorum animi perspiciatis! Earum doloribus cupiditate voluptate repellendus accusamus corporis, at quas. Tempora atque beatae voluptatum, doloremque reiciendis dolorum consequatur molestias aperiam aut eius voluptatem rerum tempore nisi.\n<br><br>\nLorem ipsum dolor sit amet consectetur adipisicing elit. Nesciunt libero, recusandae, quos temporibus exercitationem facere quasi iste, quam voluptatem quaerat sint! Exercitationem quia, beatae velit eius eaque architecto accusamus eos!\n</div></div><div flex=\"33\"><div class=\"nl-Paragraphe-aside-img\"><iframe width=\"100%\" height=\"220px\" \nsrc=\"https://www.youtube.com/embed/8DHV0q-qb0o?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\"></iframe></div>\n<div class=\"nl-Paragraphe-aside-listWrapper\"><div class=\"p-5\"><div class=\"nl-Paragraphe-aside-list-title\">\nJe souhaite découvrir...</div><ul class=\"nl-Paragraphe-aside-list-item\"><li><a href=\"\">Les lieux de culte islamiques\n</a></li><li><a href=\"\">Les lieux de culte chétiens</a></li></ul></div><div class=\"p-5\"><div \nclass=\"nl-Paragraphe-aside-list-title\">Liste des lieux de culte par région :</div><ul \nclass=\"nl-Paragraphe-aside-list-item\"><li><a href=\"\">Beirut</a></li><li><a href=\"\">Mont Liban</a></li><li><a href=\"\">\nVallée de la bekaa</a></li><li><a href=\"\">Nord du Liban</a></li><li><a href=\"\">Sud du Liban</a></li></ul></div></div>\n</div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/rowImage.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-rowImage\" layout=\"row\" layout-align=\"center stretch\"><div flex=\"33\" \nclass=\"p-5\"><div class=\"nl-rowImage-wrapper\"><img class=\"nl-rowImage-img\" src=\"assets/images/slick/1.jpg\" alt=\"\"></div>\n</div><div flex=\"33\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><img class=\"nl-rowImage-img\" \nsrc=\"assets/images/slick/2.jpg\" alt=\"\"></div></div><div flex=\"33\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><img \nclass=\"nl-rowImage-img\" src=\"assets/images/slick/3.jpg\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/rowImage5Title.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-rowImage nl-rowImage--sm\" layout=\"row\" layout-align=\"center stretch\"><div \nflex=\"20\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><div class=\"nl-rowImage-title\">Site 1</div><img \nclass=\"nl-rowImage-img\" src=\"assets/images/slick/1.jpg\" alt=\"\"></div></div><div flex=\"20\" class=\"p-5\"><div \nclass=\"nl-rowImage-wrapper\"><div class=\"nl-rowImage-title\">Site 2</div><img class=\"nl-rowImage-img\" \nsrc=\"assets/images/slick/2.jpg\" alt=\"\"></div></div><div flex=\"20\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><div \nclass=\"nl-rowImage-title\">Site 3</div><img class=\"nl-rowImage-img\" src=\"assets/images/slick/3.jpg\" alt=\"\"></div></div>\n<div flex=\"20\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><div class=\"nl-rowImage-title\">Site 4</div><img \nclass=\"nl-rowImage-img\" src=\"assets/images/slick/1.jpg\" alt=\"\"></div></div><div flex=\"20\" class=\"p-5\"><div \nclass=\"nl-rowImage-wrapper\"><div class=\"nl-rowImage-title\">Site 5</div><img class=\"nl-rowImage-img\" \nsrc=\"assets/images/slick/2.jpg\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/rowImageTitle.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-rowImage\" layout=\"row\" layout-align=\"center stretch\"><div flex=\"33\" \nclass=\"p-5\"><div class=\"nl-rowImage-wrapper\"><div class=\"nl-rowImage-title\">Site 1</div><img class=\"nl-rowImage-img\" \nsrc=\"assets/images/slick/1.jpg\" alt=\"\"></div></div><div flex=\"33\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><div \nclass=\"nl-rowImage-title\">Site 2</div><img class=\"nl-rowImage-img\" src=\"assets/images/slick/2.jpg\" alt=\"\"></div></div>\n<div flex=\"33\" class=\"p-5\"><div class=\"nl-rowImage-wrapper\"><div class=\"nl-rowImage-title\">Site 3</div><img \nclass=\"nl-rowImage-img\" src=\"assets/images/slick/3.jpg\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/search_companies.template.type.html","<div class=\"nl-prestataire--page\" ng-init=\"filter(null, 1)\"><form name=\"filterCompaniesForm\" novalidate \nng-submit=\"filter(null, 1)\"><div class=\"nl_Row-content\"><h1 class=\"nl-titre--main nl--center\" translate=\"\">\nSearch for a provider</h1><div class=\"nl-prestataire-search-wrapper\" layout=\"row\" layout-align=\"center stretch\" \nlayout-wrap><div flex=\"25\" class=\"nl-prestataire-search-category pl-5 pr-15\"><div class=\"\"><div \nclass=\"nl-prestataire-search-title\"><b>By Activity</b></div><md-input-container><label \ntranslate=\"SETTINGS.DATABASE.COMPANIES.COMPANY_TYPE\"></label><md-select class=\"\" ng-model=\"companyTypes.values\" \nmultiple=\"multiple\"><md-option \nng-repeat=\"type in companyTypes.fieldModel.listFieldsDTO | orderBy: \'index\' track by type.id\" ng-value=\"type\">\n{{type.value}}</md-option></md-select></md-input-container><md-input-container><label \ntranslate=\"SETTINGS.DATABASE.COMPANIES.CATEGORY\"></label><md-select ng-model=\"categories.value\"><md-option \nng-repeat=\"category in categories.fieldModel.listFieldsDTO | orderBy: \'index\' track by category.id\" \nng-value=\"category\">{{category.value}}</md-option></md-select></md-input-container><md-input-container><label \ntranslate=\"SETTINGS.DATABASE.SEARCHE_ENGINE_CREATION.MODEL_FIELD_KEYWORD\"></label><input type=\"text\" \nng-model=\"keyword.value\"></md-input-container></div></div><div flex=\"25\" \nclass=\"nl-prestataire-search-category pl-15 pr-15\"><div class=\"\"><div class=\"nl-prestataire-search-title\"><b>By Region\n</b></div><md-input-container><md-select ng-model=\"regions.value\"><md-option ng-value=\"region\" \nng-repeat=\"region in regions.fieldModel.listFieldsDTO | orderBy: \'index\' track by region.id\">{{region.value}}\n</md-option></md-select><label translate=\"SETTINGS.DATABASE.COMPANIES.REGION\"></label></md-input-container>\n<md-input-container><md-select ng-model=\"cities.value\"><md-option ng-value=\"city\" \nng-repeat=\"city in cities.fieldModel.listFieldsDTO | orderBy: \'index\' track by city.id\">{{city.value}}</md-option>\n</md-select><label translate=\"SETTINGS.DATABASE.COMPANIES.CITY\"></label></md-input-container></div></div><div \nflex=\"25\" class=\"nl-prestataire-search-category pl-15 pr-15\"><div class=\"\"><div class=\"nl-prestataire-search-title\"><b>\nBy Capacity</b></div><div layout=\"row\"><md-input-container flex=\"50\" class=\"nl-Form-input--noError\"><label \ntranslate=\"SETTINGS.DATABASE.COMPANIES.BEDROOMS\"></label><input type=\"number\" min=\"0\" max=\"10000\" \nng-model=\"rooms.minValue\" placeholder=\"more than\"></md-input-container><md-input-container flex=\"50\" \nclass=\"nl-Form-input--noError\"><input type=\"number\" min=\"0\" max=\"10000\" ng-model=\"rooms.maxValue\" \nplaceholder=\"less than\"></md-input-container></div><div layout=\"row\"><md-input-container flex=\"50\" \nclass=\"nl-Form-input--noError\"><label translate=\"SETTINGS.DATABASE.COMPANIES.CAPACITY\"></label><input type=\"number\" \nmin=\"0\" max=\"10000\" ng-model=\"capacities.minValue\" placeholder=\"more than\"></md-input-container><md-input-container \nflex=\"50\" class=\"nl-Form-input--noError\"><input type=\"number\" min=\"0\" max=\"10000\" ng-model=\"capacities.maxValue\" \nplaceholder=\"less than\"></md-input-container></div></div></div><div flex=\"25\" class=\"pr-5 pl-15\"><div class=\"\"><div \nclass=\"nl-prestataire-search-title\"><b>By Meeting room</b></div><md-input-container><md-select \nng-model=\"peoples.value.value\"><md-option value=\"theatre\" translate=\"COMPANIES.DISPOSITION.THEATER\"></md-option>\n<md-option value=\"classRoom\" translate=\"COMPANIES.DISPOSITION.CLASS_ROOM\"></md-option><md-option value=\"boardRoom\" \ntranslate=\"COMPANIES.DISPOSITION.BOARD_ROOM\"></md-option><md-option value=\"uStyle\" \ntranslate=\"COMPANIES.DISPOSITION.U_STYLE\"></md-option><md-option value=\"banquet\" \ntranslate=\"COMPANIES.DISPOSITION.BANQUET\"></md-option><md-option value=\"cocktail\" \ntranslate=\"COMPANIES.DISPOSITION.COCKTAIL\"></md-option><md-option value=\"conference\" \ntranslate=\"COMPANIES.DISPOSITION.CONFERENCE\"></md-option><md-option value=\"cabaret\" \ntranslate=\"COMPANIES.DISPOSITION.CABARET\"></md-option><md-option value=\"auditorium\" \ntranslate=\"COMPANIES.DISPOSITION.AUDITORIUM\"></md-option></md-select><label \ntranslate=\"SETTINGS.DATABASE.COMPANIES.CONFIG\"></label></md-input-container><div layout=\"row\"><md-input-container \nflex=\"50\" class=\"\"><label translate=\"SETTINGS.DATABASE.COMPANIES.PEOPLE\"></label><input type=\"number\" min=\"0\" \nmax=\"10000\" ng-model=\"peoples.minValue\" placeholder=\"more than\"></md-input-container><md-input-container flex=\"50\" \nclass=\"\"><input type=\"number\" min=\"0\" max=\"10000\" ng-model=\"peoples.maxValue\" placeholder=\"less than\">\n</md-input-container></div><md-input-container><label translate=\"SETTINGS.DATABASE.COMPANIES.MEETING_ROOMS\"></label>\n<input type=\"number\" step=\"1\" ng-model=\"meetingRooms.minValue\" min=\"0\" max=\"10000\" placeholder=\"more than\">\n</md-input-container></div></div><div flex=\"25\" flex-offset=\"75\" class=\"pt-20\"><button type=\"submit\" \nclass=\"nl-Item-button\">{{\'COMPANIES.FILTER\' | translate}}</button></div></div><div class=\"pv-25\" \ninfinite-scroll=\"loadMoreCompanies(null, 1)\" infinite-scroll-disabled=\"infiniteScrollPrevent\" \ninfinite-scroll-container=\"\'#content-container\'\" infinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"3\">\n<div class=\"nl-prestataire-search-item animated fadeIn\" layout=\"row\" layout-align=\"start start\" \nng-repeat=\"company in companies track by company.id\"><div flex=\"75\" class=\"pr-20\" layout=\"column\"><div><div \nclass=\"nl-prestataire-search-item-title\">\n{{company.modelPattern}}{{ company.category != null ? \' - \' + company.category : \'\'}}{{ company.location != null ? \' - \' + company.location : \'\' }}\n</div><div class=\"nl-prestataire-search-item-subtitle\">\n{{company.category}} {{company.category != null ? (company.bedrooms ? \' | \' + company.bedrooms + \" bedrooms \": \'\') : (company.bedrooms ? company.bedrooms+ \" bedrooms \":\'\')}} {{company.category != null || company.bedrooms !=null ? (company.rooms ? \' | \' + company.rooms + \" meeting rooms \":\'\') : (company.rooms ? company.rooms+ \" meeting rooms \":\'\')}} {{company.category != null || company.bedrooms !=null || company.rooms !=null ? (company.maxTheatre ? \' | \' + company.maxTheatre + \" max capacity in theatre style \":\'\') : (company.maxTheatre ? company.maxTheatre+ \" max capacity in theatre style \":\'\')}}\n</div></div><div><div class=\"nl-prestataire-search-item-description\">{{company.resume | nlEllipsis: 1200}}</div></div>\n</div><div flex=\"25\" layout=\"column\" class=\"nl-prestataire-search-item-side\"><div \nclass=\"nl-prestataire-search-item-imgWrapper mb-15\" ng-if=\"company.logo != null && company.logo.length > 0\"><img \nclass=\"nl-prestataire-search-item-img nl-img--logo\" ng-src=\"{{URL.alternatedocroots + \'/\' + company.logo}}\" alt=\"\">\n</div><div ng-if=\"company.photos != null && company.photos.length > 0\" class=\"nl-prestataire-search-item-imgWrapper\">\n<img class=\"nl-prestataire-search-item-img\" ng-src=\"{{URL.alternatedocroots + \'/\' + company.photos[0].location}}\" \nalt=\"\"></div><div class=\"mt-16\"><button type=\"button\" \nng-click=\"details(\'{{{PAGE_NAME_DETAILS_COMPANY}}}\', company.id)\" class=\"nl-Item-button pr-20\">Read more</button> \n<button type=\"button\" ng-click=\"onAddToSelection(\'{{{PAGE_NAME_DETAILS_COMPANY}}}\', company)\" \nclass=\"nl-Item-button mt-5 pr-20\" ng-if=\"!onGetSessionStorageItem(company)\">Add to my selection</button> <button \ntype=\"button\" ng-click=\"onDeleteFromSelection(company)\" class=\"nl-Item-button md-red-200-bg mt-5 pr-20\" \nng-if=\"onGetSessionStorageItem(company)\">remove from my selection</button></div></div></div><div class=\"nl-loader\" \nng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div \nclass=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\"></div></div></div></div></div></div></div>\n</form></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/search_company_with_status.template.type.html","<div class=\"nl-Search__page\"><form name=\"filterCompaniesForm\" novalidate ng-submit=\"filter(null, null)\"><div \nclass=\"nl_Row-content\"><h1 class=\"nl-titre--main nl--center nl-Search__title\">\n{{\'SITE_GEN.SEARCH_FOR_PROVIDERS\' | translate}}</h1><div class=\"nl-Search__wrapper\" layout=\"row\" \nlayout-align=\"center stretch\" layout-wrap><div class=\"nl-Article__search flex-100 flex-gt-xs-50 flex-gt-sm-20\"><div \nclass=\"pl-5 pr-15\"><div class=\"nl-Article__side__title\"><b>{{\'SITE_GEN.SEARCH_COMPANIES.ACTIVITY\' | translate}}</b>\n</div><md-input-container class=\"nl-Article__Input\" md-no-float><md-select class=\"nl-Article__Select\" \nng-model=\"companyTypes.values\" multiple=\"multiple\" placeholder=\"{{\'SITE_GEN.SEARCH_COMPANIES.ACTIVITY\' | translate}}\" \nng-init=\"preselectTypes([])\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"type in companyTypes.fieldModel.listFieldsDTO | orderBy: \'index\' track by type.id\" ng-value=\"type\">\n{{type.name}}</md-option></md-select></md-input-container></div></div><div \nclass=\"nl-Article__search flex-100 flex-gt-xs-50 flex-gt-sm-20\"><div class=\"pl-15 pr-15\"><div \nclass=\"nl-Article__side__title\"><b>{{\'SITE_GEN.SEARCH_COMPANIES.CATEGORY\' | translate}}</b></div><md-input-container \nclass=\"nl-Article__Input\" md-no-float><md-select class=\"nl-Article__Select\" ng-model=\"categories.value\" \nplaceholder=\"{{\'SITE_GEN.SEARCH_COMPANIES.CATEGORY\' | translate}}\" ng-init=\"preselectCat()\" \nng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"category in categories.fieldModel.listFieldsDTO | orderBy: \'index\' track by category.id\" \nng-value=\"category\">{{category.value}}</md-option></md-select></md-input-container></div></div><div \nclass=\"nl-Article__search flex-100 flex-gt-xs-50 flex-gt-sm-20\"><div class=\"pl-15 pr-15\"><div \nclass=\"nl-Article__side__title\"><b>{{\'SITE_GEN.SEARCH_COMPANIES.COUNTRY\' | translate}}</b></div><div layout=\"row\">\n<md-input-container class=\"nl-Article__Input\" md-no-float><md-select class=\"nl-Article__Select\" \nng-model=\"countries.values\" placeholder=\"{{\'GENERAL.COUNTRIES\' | translate}}\" multiple=\"multiple\" \nng-init=\"preselectCountries([])\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"country in countries.fieldModel.listFieldsDTO | orderBy: \'libelle\' track by country.id\" ng-value=\"country\">\n{{country.libelle}}</md-option></md-select></md-input-container></div></div></div><div \nclass=\"nl-Article__search flex-100 flex-gt-xs-50 flex-gt-sm-20\"><div class=\"pl-15 pr-15\"><div \nclass=\"nl-Article__side__title\"><b>{{\'SITE_GEN.SEARCH_COMPANIES.REGION\' | translate}}</b></div><div layout=\"row\">\n<md-input-container class=\"nl-Article__Input\" md-no-float><md-select class=\"nl-Article__Select\" \nng-model=\"regions.values\" placeholder=\"{{\'GENERAL.REGIONS\' | translate}}\" multiple=\"multiple\" \nng-init=\"preselectRegions([])\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option \nng-repeat=\"region in regions.fieldModel.listFieldsDTO | orderBy: \'libelle\' track by region.id\" ng-value=\"region\">\n{{region.libelle}}</md-option></md-select></md-input-container></div></div></div><div \nclass=\"nl-Article__search layout-row layout-align-start-end flex-100 flex-gt-sm-20\"><button type=\"submit\" \nclass=\"nl-Article__btn\">{{\'COMPANIES.FILTER\' | translate}}</button></div></div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"flex\" layout=\"row\" layout-wrap infinite-scroll=\"loadMoreCompanies(null, null)\" \ninfinite-scroll-disabled=\"infiniteScrollPrevent\" infinite-scroll-container=\"\'#content-container\'\" \ninfinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"3\"><div \nclass=\"nl-relArticle__item nl-relArticle__floating flex-100 flex-gt-sm-50\" ng-repeat=\"company in companies\"><div \nclass=\"nl-relArticle__item__inner animated fadeIn\"><div class=\"nl-relArticle__slickWrapper\"><div \nclass=\"animated fadeIn\"><div class=\"nl_slick--wrapper\"><div class=\"nl-Slick__stars\" \nng-if=\"company.status === \'PREMIUM\'\"><img class=\"nl-Slick__stars__img\" src=\"./assets/images/slick/star.svg\" alt=\"\">\n</div><button type=\"button\" ng-click=\"company._companySlickConfig.method.slickPrev()\" class=\"nl_slick--button\" \nng-if=\"company.photos.length > 1\"><img class=\"nl-Slick__arrow\" src=\"./assets/images/slick/back_thin_white.svg\" alt=\"\">\n</button> <button type=\"button\" ng-click=\"company._companySlickConfig.method.slickNext()\" \nclass=\"nl_slick--button nl_slick--button-right\" ng-if=\"company.photos.length > 1\"><img class=\"nl-Slick__arrow\" \nsrc=\"./assets/images/slick/next_thin_white.svg\" alt=\"\"></button><slick settings=\"company._companySlickConfig\" \nclass=\"nl_slick nl_slick__search\"><div \nng-if=\"company.photos && company.photos.length>0 && company.status === \'PREMIUM\' || company.status !== \'PREMIUM\' && $index <=2\" \nclass=\"nl_slick--slide\" ng-repeat=\"_photo in company.photos | orderBy:\'index\'\"><img class=\"nl-relArticle__img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + _photo.location}}\" alt=\"\"></div><div \nng-if=\"!company.photos || company.photos.length==0\" class=\"nl_slick--slide\"><img \nclass=\"nl-relArticle__img nl-relArticle__img--noLogo\" src=\"assets/images/logo/pure.png\" alt=\"\"></div></slick></div>\n</div></div><div class=\"nl-Search__item__btn-wrapper\"><button class=\"nl-Search__item__btn nl-Search__item__btn--valid\" \ntype=\"button\" title=\"{{\'COMPANIES.ADD_SELECTION\' | translate}}\" ng-if=\"!onGetSessionStorageItem(company)\" \nng-click=\"onAddToSelectionPure(\'{{{Page Name Details Company}}}\', company)\"><img src=\"./assets/images/slick/plus.svg\" \nalt=\"\"></button> <button class=\"nl-Search__item__btn nl-Search__item__btn--error\" type=\"button\" \ntitle=\"{{\'COMPANIES.REMOVE_SELECTION\' | translate}}\" ng-if=\"onGetSessionStorageItem(company)\" \nng-click=\"onDeleteFromSelection(company)\"><img src=\"./assets/images/slick/delete.svg\" alt=\"\"></button> <button \nclass=\"nl-Search__item__btn\" type=\"button\" title=\"{{\'COMPANIES.ASK_FOR_QUOTE\' | translate}}\" \nng-click=\"onAskForAllQuotePure(\'{{{Page Name Details Company}}}\', company)\"><img \nsrc=\"./assets/images/slick/euro_white.svg\" alt=\"\"></button></div><div class=\"nl-relArticle__infos\"><div \nclass=\"nl-relArticle__title\" ng-click=\"details(\'{{{Page Name Details Company}}}\', company.id)\">\n{{company.modelPattern}}{{ company.category != null ? \' - \' + company.category : \'\'}}{{ company.tags == null || company.tags.length === 0 ? \'\' : \' - \'}}\n<div ng-repeat=\"tag in company.tags | orderBy: \'name\'\">{{tag.name}}{{$last ? \'\' : \',\'}}</div></div><div \nclass=\"nl-Search__item__date\" layout=\"row\"><div ng-repeat=\"country in company.countries | orderBy: \'libelle\'\">\n{{country.libelle}}&nbsp;</div></div></div></div></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\">\n<div class=\"inner\"><div class=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\">\n<div class=\"half-circle\"></div></div></div></div></div></div></div></div></form></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/search_packages.template.type.html","<div class=\"nl-prestataire--page\"><form name=\"filterPackagesForm\" novalidate ng-submit=\"filterPackages()\"><div \nclass=\"nl_Row-content\" md-theme=\"teal-theme\"><h1 class=\"nl-titre--main nl--center\" translate=\"\">Search for a package\n</h1><div class=\"nl-prestataire-search-wrapper\" layout=\"row\" layout-align=\"center stretch\" layout-wrap><div flex=\"50\" \nflex-sm=\"50\" flex-xs=\"100\" class=\"pl-5 pr-20\"><div class=\"\"><div class=\"nl-prestataire-search-title\">By Region</div>\n<md-input-container><md-select ng-model=\"filter.regions.value\"><md-option ng-value=\"region\" \nng-repeat=\"region in filter.regions.listFieldsDTO | orderBy: \'index\' track by region.id\">{{region.value}}</md-option>\n</md-select><label translate=\"SETTINGS.DATABASE.COMPANIES.REGION\"></label></md-input-container></div></div><div \nflex=\"50\" flex-sm=\"50\" flex-xs=\"100\" class=\"pr-5 pl-20\"><div class=\"\"><div class=\"nl-prestataire-search-title\">\nBy Thematic</div><md-input-container><md-select ng-model=\"filter.tourisms.value\"><md-option ng-value=\"type\" \nng-repeat=\"type in filter.tourisms.listFieldsDTO | orderBy: \'index\' track by type.id\">{{type.value}}</md-option>\n</md-select><label translate=\"SETTINGS.DATABASE.COMPANIES.TOURISM\"></label></md-input-container></div></div><div \nflex=\"20\" flex-offset=\"80\" flex-xs=\"100\"><button type=\"submit\" class=\"nl-Item-button\">\n{{\'COMPANIES.FILTER\' | translate}}</button></div></div><div class=\"pv-25\" infinite-scroll=\"loadMorePackages()\" \ninfinite-scroll-disabled=\"infiniteScrollPrevent\" infinite-scroll-container=\"\'#content-container\'\" \ninfinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"3\"><div \nclass=\"nl-prestataire-search-item animated fadeIn\" layout=\"row\" layout-align=\"start start\" \nng-repeat=\"package in packages track by package.id\"><div flex=\"75\" flex-sm=\"60\" flex-xs=\"100\" layout=\"column\" \nclass=\"pr-20\"><div><div class=\"nl-prestataire-search-item-title\">{{package.name}}</div></div><div><div \nclass=\"nl-prestataire-search-item-description pr-20 ql-editor\" \nng-bind-html=\"trustAsHtml(package.description | nlEllipsis: 400)\"></div></div></div><div flex=\"25\" flex-sm=\"40\" \nflex-xs=\"100\" layout=\"column\" class=\"nl-prestataire-search-item-side\"><div \nclass=\"nl-prestataire-search-item-imgWrapper mb-15\"><img \nng-if=\"package.companyLogo == null || package.companyLogo.length === 0\" \nclass=\"nl-prestataire-search-item-img nl-img--logo\" src=\"assets/images/slick/1.jpg\" alt=\"\"> <img \nng-if=\"package.companyLogo != null && package.companyLogo.length > 0\" \nclass=\"nl-prestataire-search-item-img nl-img--logo\" ng-src=\"{{URL.alternatedocroots + \'/\' + package.companyLogo}}\" \nalt=\"\"></div><div class=\"nl-prestataire-search-item-imgWrapper\"><img \nng-if=\"package.documents != null && package.documents.length > 0\" class=\"nl-prestataire-search-item-img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + package.documents[0].location}}\" alt=\"\"></div><div class=\"mt-16\"><button \ntype=\"button\" ng-click=\"details(\'{{{PAGE_NAME_DETAILS_PACKAGE}}}\', package.id)\" class=\"nl-Item-button\">Read more\n</button></div></div></div></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div></div></form></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/search_tourist_attractions.template.type.html","<div class=\"nl-prestataire--page\"><form name=\"filterAttractionsForm\" novalidate ng-submit=\"filterTourists()\"><div \nclass=\"nl_Row-content\" md-theme=\"teal-theme\"><h1 class=\"nl-titre--main nl--center\" translate=\"\">\nLook for a touristic site</h1><div class=\"nl-prestataire-search-wrapper\" layout=\"row\" layout-align=\"center stretch\" \nlayout-wrap><div flex=\"50\" flex-xs=\"100\" class=\"nl-prestataire-search-category pl-5 pr-20\"><div class=\"\"><div \nclass=\"nl-prestataire-search-title\"><b>By Region</b></div><md-input-container><md-select \nng-model=\"filter.regions.value\"><md-option ng-value=\"region\" \nng-repeat=\"region in filter.regions.listFieldsDTO | orderBy: \'index\' track by region.id\">{{region.value}}</md-option>\n</md-select><label translate=\"SETTINGS.DATABASE.COMPANIES.REGION\"></label></md-input-container></div></div><div \nflex=\"50\" flex-xs=\"100\" class=\"pr-5 pl-20\"><div class=\"\"><div class=\"nl-prestataire-search-title\"><b>By Thematic</b>\n</div><md-input-container><md-select ng-model=\"filter.tourisms.value\"><md-option ng-value=\"type\" \nng-repeat=\"type in filter.tourisms.listFieldsDTO | orderBy: \'index\' track by type.id\">{{type.value}}</md-option>\n</md-select><label translate=\"SETTINGS.DATABASE.COMPANIES.TOURISM\"></label></md-input-container></div></div><div \nflex=\"25\" flex-xs=\"100\" flex-offset-xs=\"0\" flex-offset=\"75\" class=\"pt-20\"><button type=\"submit\" class=\"nl-Item-button\">\n{{\'COMPANIES.FILTER\' | translate}}</button></div></div><div class=\"pv-25\" infinite-scroll=\"loadMoreTourists()\" \ninfinite-scroll-disabled=\"infiniteScrollPrevent\" infinite-scroll-container=\"\'#content-container\'\" \ninfinite-scroll-immediate-check=\"false\" infinite-scroll-distance=\"3\"><div \nclass=\"nl-prestataire-search-item animated fadeIn\" layout=\"row\" layout-wrap layout-align=\"start start\" \nng-repeat=\"tourist in tourists\"><div flex=\"75\" flex-sm=\"60\" flex-xs=\"100\" layout=\"column\" class=\"pr-20\"><div><div \nclass=\"nl-prestataire-search-item-title\">{{tourist.name}}</div></div><div><div \nclass=\"nl-prestataire-search-item-description pr-5 ql-editor\" \nng-bind-html=\"trustAsHtml(tourist.description | nlEllipsis: 400)\"></div></div></div><div flex=\"25\" flex-sm=\"40\" \nflex-xs=\"100\" layout=\"column\"><div class=\"nl-prestataire-search-item-imgWrapper pr-20\"><img \nng-if=\"tourist.photos != null && tourist.photos.length > 0\" class=\"nl-prestataire-search-item-img\" \nng-src=\"{{URL.alternatedocroots + \'/\' + tourist.photos[0].location}}\" alt=\"\"></div><div class=\"mt-16\"><button \ntype=\"button\" ng-click=\"details(\'{{{PAGE_NAME_DETAILS_TOURIST}}}\', tourist.id)\" class=\"nl-Item-button pr-20\">Read more\n</button></div></div></div></div><div class=\"nl-loader\" ng-show=\"!loaded\"><div class=\"spinner\"><div class=\"inner\"><div \nclass=\"gap\"></div><div class=\"left\"><div class=\"half-circle\"></div></div><div class=\"right\"><div class=\"half-circle\">\n</div></div></div></div></div></div></form></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/selection.template.type.html","<div class=\"nl_Row-content\" ng-init=\"getCompanies([{{{Reference of favorite companies - separated by a comma }}}])\" \nng-if=\"showBlocByDates(\'{{{start date - dd/MM/yyyy - \'null\' if you dont\'t want}}}\', \'{{{date de fin - dd/MM/yyyy- \'null\' if you dont\'t want}}}\')\">\n<div layout=\"row\" layout-wrap><div flex=\"100\" flex-sm=\"100\" flex-xs=\"100\"><div layout=\"row\" layout-align=\"start start\" \nlayout-wrap><div class=\"nl_slick--wrapper wrapper-mw\"><button ng-if=\"companies.length>4\" type=\"button\" \nng-click=\"slickConfig.method.slickPrev()\" class=\"nl-Favorite-slick__btn__left\"><img \nsrc=\"assets/images/slick/arrow_left.svg\" alt=\"\"></button> <button ng-if=\"companies.length>4\" type=\"button\" \nng-click=\"slickConfig.method.slickNext()\" class=\"nl-Favorite-slick__btn__right\"><img \nsrc=\"assets/images/slick/arrow_right.svg\" alt=\"\"></button><slick settings=\"slickConfig\" class=\"nl-Slick--favorite\" \nng-class=\"{\'nl-Slick--empty\': companies.length<5 }\"><div ng-repeat=\"company in companies track by company.id\"><div \nclass=\"nl-relArticle__item\" ng-click=\"details(\'{{{Company Page Name}}}\', company.id)\"><div \nclass=\"nl-relArticle__item__inner\"><div class=\"nl-relArticle__imgWrapper\"><img \nng-if=\"company.photos == null || company.photos.length === 0\" class=\"nl-relArticle__img nl-relArticle__img--noLogo\" \nsrc=\"assets/images/logo/pure.png\" alt=\"\"> <img ng-if=\"company.photos != null && company.photos.length > 0\" \nclass=\"nl-relArticle__img\" ng-src=\"{{URL.alternatedocroots + \'/\' + company.photos[0].location}}\" alt=\"\"></div><div \nclass=\"nl-relArticle__infos nl-relArticle__infos--alt nl-relArticle__infos--centered\"><div \nclass=\"nl-relArticle__title\">{{company.modelPattern}}</div><div class=\"nl-relArticle__date\">{{showDesc(company) }}\n</div></div></div></div></div></slick></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/table.template.type.html","<div class=\"nl_Row-content\"><table \nclass=\"dataTable row-border nl-Tablegit nl-Table--center nl-prestataire-table nl-prestataire-table--common\"><tr><th>\nColumn 1</th><th>Column 2</th><th>Column 3</th><th>Column 4</th></tr><tr><td>Line 1-1</td><td>Line 1-2</td><td>Line 1-3\n</td><td>Line 1-4</td></tr><tr><td>Line 2-1</td><td>Line 2-2</td><td>Line 2-3</td><td>Line 2-4</td></tr></table></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/temoignages.template.type.html","<div class=\"nl_Row-content\"><div layout=\"row\" class=\"nl-Temoignage\"><div><div class=\"nl-Temoignage-avatar\"><img \nclass=\"nl-Temoignage-avatar-img\" src=\"assets/images/avatars/alice.jpg\" alt=\"\"></div></div><div><div \nclass=\"nl-Temoignage-name\">Ine Gerrits<span>, 3vents, Belgique</span></div><div class=\"nl-Temoignage-text\">\nOur first event in Beirut was a big success! And the DMC did a great job; our client was very happy !</div><div \nclass=\"nl-Temoignage-date\">26/01/2018</div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/tourist_attraction.template.type.html","<div class=\"nl_Row-content\"><div class=\"nl-prestataire-search--slick\" \nng-if=\"tourist.photos && tourist.photos.length > 0\"><div class=\"nl_slick--wrapper\"><button type=\"button\" \nng-click=\"_touristSlickConfig.method.slickPrev()\" class=\"nl_slick--button\"><img \nsrc=\"assets/images/slick/arrow_left.png\" alt=\"\"></button> <button type=\"button\" \nng-click=\"_touristSlickConfig.method.slickNext()\" class=\"nl_slick--button nl_slick--button-right\"><img \nsrc=\"assets/images/slick/arrow_right.png\" alt=\"\"></button><slick settings=\"_touristSlickConfig\" \nclass=\"nl_slick nl_slick--article\"><div class=\"nl_slick--slide\" ng-repeat=\"_photo in tourist.photos\"><img \nclass=\"nl_slick--slide--img\" ng-src=\"{{_photo.url}}\" alt=\"\"></div></slick></div></div><div layout=\"row\" \nclass=\"nl-prestataire-search-item\" layout-wrap><div flex=\"70\" flex-sm=\"60\" flex-xs=\"100\" class=\"pr-20\"><div \nlayout=\"column\"><div class=\"nl-titre--main nl--item\">{{tourist.name}}</div><div><div \nclass=\"nl-prestataire-search-item-description ql-editor\" ng-bind-html=\"trustAsHtml(tourist.description)\"></div></div>\n</div></div><div flex=\"30\" flex-sm=\"40\" flex-xs=\"100\" class=\"nl-prestataire-search-item-side\"><div layout=\"column\"><div\n class=\"nl-prestataire-search-detail-aside\"><div class=\"nl-prestataire-search-item-title title--panel\">City:</div><div \nclass=\"nl-prestataire-search-item-text mb-10\">{{tourist.city.value}}</div><div \nclass=\"nl-prestataire-search-item-title title--panel\">Region:</div><div class=\"nl-prestataire-search-item-text mb-10\">\n{{tourist.region.value}}</div><div class=\"nl-prestataire-search-item-title title--panel\">Thematic:</div><div \nclass=\"nl-prestataire-search-item-text\"><span ng-repeat=\"type in tourist.typeTourisme | orderBy: \'value\'\">\n{{type.value}}{{!$last && tourist.typeTourisme.length > 1 ? \' - \' : \'\'}}</span></div></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/video.template.type.html","<div class=\"nl_Row-content\"><div class=\"mv-20\"><iframe width=\"100%\" height=\"350px\" \nsrc=\"https://www.youtube.com/embed/8DHV0q-qb0o?rel=0\" frameborder=\"0\" allow=\"autoplay; encrypted-media\"></iframe></div>\n</div>");
$templateCache.put("app/main/sites_management/blocs/bloc/youtube.template.type.html","<div layout=\"row\" ng-if=\"company.youtube != null && company.status === \'PREMIUM\'\"><iframe width=\"560\" height=\"315\" \nng-src=\"{{convertAndTrustYoutube(company.youtube)}}\" frameborder=\"0\" \nallow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/events/inscriptions/forms/popup/add_form.html","<md-dialog class=\"company-disposition-dialog nl-Modal\" aria-label=\"Disposition\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"addForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'INSCRIPTION_FORMS.NEW\' | translate}}</div>\n</div><md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container><input \ntype=\"text\" maxlength=\"255\" ng-model=\"newForm.name\" name=\"name\" required><label>\n{{\"INSCRIPTION_FORMS.COLUMNS.NAME\"|translate}} *</label><div class=\"pl-5\" ng-messages=\"addForm.name.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span>{{\"GENERAL.REQUIRED\" | translate}}</span></div></div>\n</md-input-container><md-input-container><label>{{\"INSCRIPTION_FORMS.COLUMNS.MODEL_SUBTYPE\"|translate}}</label>\n<md-select ng-model=\"newForm.subtype\" ng-model-options=\"{trackBy: \'$value.id\'}\" name=\"subtype\" required><md-option \nng-repeat=\"subtype in subtypes track by subtype.id\" ng-value=\"subtype\">{{subtype.name}}</md-option></md-select><div \nclass=\"pl-5\" ng-messages=\"addForm.subtype.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n{{\"GENERAL.REQUIRED\" | translate}}</span></div></div></md-input-container><md-input-container><label>\n{{\"INSCRIPTION_FORMS.COLUMNS.SUB_CATEGORY\"|translate}}</label><md-select ng-model=\"newForm.subCategory\" \nng-model-options=\"{trackBy: \'$value.id\'}\" name=\"subCategory\"><md-option \nng-repeat=\"category in subcategories track by category.id\" ng-value=\"category\">{{category.name}}</md-option>\n</md-select></md-input-container><md-input-container><label>\n{{\"INSCRIPTION_FORMS.COLUMNS.DEFAULT_REGISTRATION_STATUS\"|translate}}</label><md-select \nng-model=\"newForm.defaultRegistrationStatus\" ng-model-options=\"{trackBy: \'$value.id\'}\" \nname=\"defaultRegistrationStatus\"><md-option \nng-repeat=\"defaultRegistrationStatus in defaultRegistrationsStatus track by defaultRegistrationStatus.id\" \nng-value=\"defaultRegistrationStatus\">{{defaultRegistrationStatus.name}}</md-option></md-select></md-input-container>\n<md-input-container><label>{{\"INSCRIPTION_FORMS.COLUMNS.DEFAULT_LOGISTICAL_STATUS\"|translate}}</label><md-select \nng-model=\"newForm.defaultLogisticalStatus\" ng-model-options=\"{trackBy: \'$value.id\'}\" name=\"defaultLogisticalStatus\">\n<md-option ng-repeat=\"defaultLogisticalStatus in defaultLogisticalsStatus track by defaultLogisticalStatus.id\" \nng-value=\"defaultLogisticalStatus\">{{defaultLogisticalStatus.name}}</md-option></md-select></md-input-container>\n<md-input-container><md-checkbox class=\"md-primary md-hue-2\" ng-model=\"newForm.paginated\" name=\"paginated\">\n{{\"INSCRIPTION_FORMS.COLUMNS.MULTIPLE_PAGES\"|translate}}</md-checkbox></md-input-container></md-dialog-content>\n<md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"button\" ng-click=\"save();\" md-no-ink \nclass=\"md-primary md-hue-2 md-raised\" ng-disabled=\"addForm.$invalid || addForm.$pristine\" translate=\"GENERAL.SAVE\">\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/events/inscriptions/forms/popup/condition.html","<md-dialog class=\"company-disposition-dialog nl-Modal\" aria-label=\"Disposition\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"conditionForm\" class=\"md-inline-form\" novalidate ng-submit=\"conditionForm.$valid && saveCondition()\"><md-toolbar \nclass=\"nl-Modal-header\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" \nlayout-align=\"space-between center\"><div></div><div layout=\"column\" layout-align=\"center center\"><div \nclass=\"contact-name\">{{\'INSCRIPTION_FORMS.ADD_CONDITION\' | translate}}</div></div><md-button class=\"md-icon-button\" \nng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content><div translate=\"INSCRIPTION_FORMS.ADD_CONDITION_HELP\" class=\"mb-10\"></div>\n<md-input-container><label>{{\"INSCRIPTION_FORMS.FORM_FIELD\"|translate}}</label><md-select \nng-model=\"field.fieldCondition\" ng-model-options=\"{trackBy: \'$value.id\'}\" name=\"fieldCondition\" required><md-option \nng-value=\"null\"></md-option><md-option ng-repeat=\"field in conditionalFields | orderBy: \'name\' track by field.id\" \nng-value=\"field\">{{field.name}}</md-option></md-select></md-input-container><md-input-container><label>\n{{\"INSCRIPTION_FORMS.CONDITION\"|translate}}</label><md-select ng-model=\"field.conditions\" \nng-disabled=\"field.fieldCondition == null || field.fieldCondition.field == null\" \nng-model-options=\"{trackBy: \'$value.id\'}\" name=\"condition\" required multiple=\"multiple\"><md-option \nng-repeat=\"list in field.fieldCondition.field.listFieldsDTO | orderBy: \'index\' track by list.id\" ng-value=\"list\">\n{{list.value}}</md-option></md-select></md-input-container></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button type=\"submit\" md-no-ink class=\"md-primary md-hue-2 md-raised\" \nng-disabled=\"conditionForm.$invalid || conditionForm.$pristine\" translate=\"GENERAL.SAVE\"></md-button>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/globe_network/companies/contacts/popup/add_contact.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Add contact\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"addContactForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'CONTACTS.ADD\' | translate}}</div></div>\n<md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><noo-infos-model \nng-model=\"categories\" edition=\"false\" form-name=\"addContactForm\" model-type=\"modelType\" model=\"newContact\">\n</noo-infos-model></md-dialog-content><md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nng-click=\"saveContact(addContactForm)\" class=\"md-primary md-hue-2 submit-button md-raised\" \nng-disabled=\"addContactForm.$invalid || addContactForm.$pristine\" aria-label=\"Sauvegarder\">\n{{\'GENERAL.SAVE\' | translate}}</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/globe_network/companies/contacts/popup/move_contact.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Move contact\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"moveContactForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'CONTACTS.MOVE\' | translate}}</div></div>\n<md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div layout=\"row\" \nlayout-align=\"start center\"><button flex=\"10\" ng-if=\"contact.company\" ng-click=\"modifyContact()\" class=\"m-0\" \naria-label=\"Fermeture modal\"><md-icon md-font-icon=\"icon-close\"></md-icon></button><md-input-container flex \nclass=\"nl-Input-container\"><label translate=\"SETTINGS.DATABASE.COMPANIES.TITLE\"></label><md-autocomplete \nmd-selected-item=\"contact.company\" md-item-text=\"printCompany(item)\" md-search-text=\"searchText\" \nmd-items=\"item in searchCompany(searchText)\" md-selected-item-change=\"selectedItemChange(contact.company)\" \nng-disabled=\"disabled\" md-clear-button=\"true\"><md-item-template><span md-highlight-text=\"searchText\">\n{{printCompany(item)}}</span></md-item-template></md-autocomplete></md-input-container></div></md-dialog-content>\n<md-dialog-actions class=\"\" style=\"padding-right: 24px\"><md-button type=\"submit\" \nng-click=\"moveContact(moveContactForm)\" class=\"md-primary md-hue-2 submit-button md-raised\" \nng-disabled=\"moveContactForm.$invalid || moveContactForm.$pristine || buttonDisabled\" aria-label=\"Sauvegarder\" \ntranslate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/globe_network/companies/contacts/popup/subscribe.html","<md-dialog class=\"admin-user-dialog\" aria-label=\"Subscribe contact\" flex=\"40\" md-theme=\"teal-theme\"><form \nname=\"subscribeForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"nl-Modal-header\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"row\" layout-align=\"space-between center\"><div></div><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contact-name\">{{\'CONTACTS.SUBSCRIBE\' | translate}}</div></div>\n<md-button class=\"md-icon-button\" ng-click=\"hidePopup()\" aria-label=\"Fermeture modal\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content><md-input-container \nclass=\"nl-Input-container\"><label translate=\"EVENT.TITLE\"></label><md-select ng-model=\"event\" \nng-model-options=\"{trackBy: \'$value.id\'}\" name=\"event\" required><md-option \nng-repeat=\"event in events | orderBy: \'event.name\' track by event.id\" ng-value=\"event\">{{event.name}}</md-option>\n</md-select><div ng-messages=\"subscribeForm.event.$error\"><span ng-message=\"required\">\n{{\'GENERAL.REQUIRED\' | translate}}</span></div></md-input-container></md-dialog-content><md-dialog-actions class=\"\" \nstyle=\"padding-right: 24px\"><md-button type=\"submit\" ng-click=\"subscribe(subscribeForm)\" \nclass=\"md-primary md-hue-2 submit-button md-raised\" ng-disabled=\"subscribeForm.$invalid || subscribeForm.$pristine\" \naria-label=\"Sauvegarder\" translate=\"GENERAL.SAVE\"></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/mailing/blocs/bloc/templates/test.template.type.html","<div><h1>Bonjour {{{NAME}}} Lorem ipsum dolor sit amet consectetur adipisicing elit.</h1><div>\nLorem ipsum dolor sit amet consectetur adipisicing elit. Autem, nam inventore. Dicta sint sed, officiis doloribus, pariatur optio sunt tempore corporis, ad debitis earum consequuntur maxime molestiae explicabo dolor expedita!Voluptate provident facilis porro reprehenderit fugit, explicabo laborum sed praesentium quod aspernatur velit excepturi iure impedit, consectetur fugiat facere accusantium cumque? Autem vitae quibusdam exercitationem ea quas cum, quasi inventore.\n</div><div layout=\"row\" layout-align=\"center stretch\"><div flex=\"20\" class=\"\"><div class=\"\"><div \nclass=\"nl-rowImage-title\">Img 1</div><img class=\"nl-rowImage-img\" src=\"http://placehold.it/120x120&text=image1\" alt=\"\">\n</div></div><div flex=\"20\" class=\"\"><div class=\"\"><div class=\"nl-rowImage-title\">Img 2</div><img \nclass=\"nl-rowImage-img\" src=\"http://placehold.it/120x120&text=image2\" alt=\"\"></div></div><div flex=\"20\" class=\"\"><div \nclass=\"\"><div class=\"nl-rowImage-title\">Img 3</div><img class=\"nl-rowImage-img\" \nsrc=\"http://placehold.it/120x120&text=image3\" alt=\"\"></div></div><div flex=\"20\" class=\"\"><div class=\"\"><div \nclass=\"nl-rowImage-title\">Img 4</div><img class=\"nl-rowImage-img\" src=\"http://placehold.it/120x120&text=image4\" alt=\"\">\n</div></div><div flex=\"20\" class=\"\"><div class=\"\"><div class=\"nl-rowImage-title\">Img 5</div><img \nclass=\"nl-rowImage-img\" src=\"http://placehold.it/120x120&text=image5\" alt=\"\"></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/event/event_inscription.template.type.html","<div class=\"nl_Row-content\" ng-init=\"init({{{FORM_ID}}})\"><div class=\"nl--Container\"><div class=\"nl--Steps\" \nng-if=\"!subscribed && form.paginated && form.nbPages > 1\"><ms-form-wizard ng-init=\"msWizard.selectedIndex = 0\"><md-tabs\n md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nng-class=\"{\'etape-0\': msWizard.selectedIndex == 0, \'etape-1\': msWizard.selectedIndex == 1,\'etape-2\': msWizard.selectedIndex == 2,\'etape-3\': msWizard.selectedIndex == 3}\" \nmd-center-tabs=\"true\" class=\"nl--Steps--Tabs\"><md-tab md-on-select=\"updateTitle(msWizard.selectedIndex);\">\n<md-tab-label><span class=\"ms-form-wizard-step-text nl--Steps--Tabs--title\"><span class=\"nl--Steps--Tabs--title-nbr\">1\n</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" ms-form-wizard-form novalidate><div layout=\"row\" \nclass=\"nl-Form-xs nl-Form-xs-registration\"><div flex=\"50\"><div \nng-repeat=\"field in form.fields | filter: {column: 1, page: 1} track by field.id\" ng-form=\"fieldForm\" \nng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" class=\"nl--Steps--mainTitle\">\n{{field.header}}</h1><noo-input-event ng-disabled=\"formValidated\" watch=\"checkConditionAfterUpdate(field)\" \nfield=\"field\" ng-show=\"field._show\" ng-if=\"field.typeField === \'FIELD\'\" ng-required=\"field.required && field._show\" \nsub-type=\"form.subtype.id\" form-name=\"fieldForm\" ng-model=\"field.genericField\" index=\"field.index\" \ncontent=\"{{field.genericField.typeChamps}}\" model-type=\"field.modelType\"></noo-input-event><div \nng-if=\"field.typeField === \'EXPLANATION\' && field._show\" ng-bind-html=\"field.text\"></div></div></div><div flex=\"45\" \nflex-offset=\"5\"><div ng-repeat=\"field in form.fields | filter: {column: 2, page: 1} track by field.id\" \nng-form=\"fieldForm\" ng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" \nclass=\"nl--Steps--mainTitle\">{{field.header}}</h1><noo-input-event ng-disabled=\"formValidated\" \nwatch=\"checkConditionAfterUpdate(field)\" field=\"field\" ng-show=\"field._show\" ng-if=\"field.typeField === \'FIELD\'\" \nng-required=\"field.required && field._show\" sub-type=\"form.subtype.id\" form-name=\"fieldForm\" \nng-model=\"field.genericField\" index=\"field.index\" content=\"{{field.genericField.typeChamps}}\" \nmodel-type=\"field.modelType\"></noo-input-event><div ng-if=\"field.typeField === \'EXPLANATION\'\" \nng-bind-html=\"field.text\"></div></div></div></div></form></md-tab-body></md-tab><md-tab \nmd-on-select=\"updateTitle(msWizard.selectedIndex);\" ng-disabled=\"wizardStep1.$invalid\" ng-if=\"form.nbPages > 1\">\n<md-tab-label><span class=\"ms-form-wizard-step-text nl--Steps--Tabs--title\"><span class=\"nl--Steps--Tabs--title-nbr\">2\n</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" ms-form-wizard-form novalidate><div layout=\"row\" \nclass=\"nl-Form-xs nl-Form-xs-registration\"><div flex=\"50\"><div \nng-repeat=\"field in form.fields | filter: {column: 1, page: 2} track by field.id\" ng-form=\"fieldForm\" \nng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" class=\"nl--Steps--mainTitle\">\n{{field.header}}</h1><noo-input-event ng-disabled=\"formValidated\" watch=\"checkConditionAfterUpdate(field)\" \nfield=\"field\" ng-show=\"field._show\" ng-if=\"field.typeField === \'FIELD\'\" ng-required=\"field.required && field._show\" \nsub-type=\"form.subtype.id\" form-name=\"fieldForm\" ng-model=\"field.genericField\" index=\"field.index\" \ncontent=\"{{field.genericField.typeChamps}}\" model-type=\"field.modelType\"></noo-input-event><div \nng-if=\"field.typeField === \'EXPLANATION\' && field._show\" ng-bind-html=\"field.text\"></div></div></div><div flex=\"45\" \nflex-offset=\"5\"><div ng-repeat=\"field in form.fields | filter: {column: 2, page: 2} track by field.id\" \nng-form=\"fieldForm\" ng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" \nclass=\"nl--Steps--mainTitle\">{{field.header}}</h1><noo-input-event ng-disabled=\"formValidated\" \nwatch=\"checkConditionAfterUpdate(field)\" field=\"field\" ng-show=\"field._show\" ng-if=\"field.typeField === \'FIELD\'\" \nng-required=\"field.required && field._show\" sub-type=\"form.subtype.id\" form-name=\"fieldForm\" \nng-model=\"field.genericField\" index=\"field.index\" content=\"{{field.genericField.typeChamps}}\" \nmodel-type=\"field.modelType\"></noo-input-event><div ng-if=\"field.typeField === \'EXPLANATION\' && field._show\" \nng-bind-html=\"field.text\"></div></div></div></div></form></md-tab-body></md-tab><md-tab \nmd-on-select=\"updateTitle(msWizard.selectedIndex);\" ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\" \nng-if=\"form.nbPages > 2\"><md-tab-label><span class=\"ms-form-wizard-step-text nl--Steps--Tabs--title\"><span \nclass=\"nl--Steps--Tabs--title-nbr\">3</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" \nms-form-wizard-form novalidate><div layout=\"row\" class=\"nl-Form-xs nl-Form-xs-registration\"><div flex=\"50\"><div \nng-repeat=\"field in form.fields | filter: {column: 1, page: 3} track by field.id\" ng-form=\"fieldForm\" \nng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" class=\"nl--Steps--mainTitle\">\n{{field.header}}</h1><noo-input-event ng-disabled=\"formValidated\" watch=\"checkConditionAfterUpdate(field)\" \nfield=\"field\" ng-show=\"field._show\" ng-if=\"field.typeField === \'FIELD\'\" ng-required=\"field.required && field._show\" \nsub-type=\"form.subtype.id\" form-name=\"fieldForm\" ng-model=\"field.genericField\" index=\"field.index\" \ncontent=\"{{field.genericField.typeChamps}}\" model-type=\"field.modelType\"></noo-input-event><div \nng-if=\"field.typeField === \'EXPLANATION\' && field._show\" ng-bind-html=\"field.text\"></div></div></div><div flex=\"45\" \nflex-offset=\"5\"><div ng-repeat=\"field in form.fields | filter: {column: 2, page: 3} track by field.id\" \nng-form=\"fieldForm\" ng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" \nclass=\"nl--Steps--mainTitle\">{{field.header}}</h1><noo-input-event ng-disabled=\"formValidated\" \nwatch=\"checkConditionAfterUpdate(field)\" field=\"field\" ng-show=\"field._show\" ng-if=\"field.typeField === \'FIELD\'\" \nng-required=\"field.required && field._show\" sub-type=\"form.subtype.id\" form-name=\"fieldForm\" \nng-model=\"field.genericField\" index=\"field.index\" content=\"{{field.genericField.typeChamps}}\" \nmodel-type=\"field.modelType\"></noo-input-event><div ng-if=\"field.typeField === \'EXPLANATION\' && field._show\" \nng-bind-html=\"field.text\"></div></div></div></div></form></md-tab-body></md-tab></md-tabs><div flex layout=\"row\" \nlayout-align=\"space-between center\" class=\"nl--Steps--footer\"><md-button class=\"nl-Btn nl-Btn-primary nl-Btn-clear\" \ntype=\"button\" ng-if=\"msWizard.isFirstStep()\" ng-click=\"msWizard.previousStep()\">{{\'GENERAL.CANCEL\' | translate }}\n</md-button><md-button class=\"nl-Btn nl-Btn-primary nl-Btn-clear\" type=\"button\" ng-if=\"!msWizard.isFirstStep()\" \nng-click=\"msWizard.previousStep()\">{{\'GENERAL.PREVIOUS\' | translate }}</md-button><md-button \nclass=\"nl-Btn nl-Btn-primary\" type=\"button\" ng-if=\"!msWizard.isLastStep()\" ng-click=\"saveStep(msWizard);\">\n{{\'GENERAL.NEXT\' | translate }}</md-button><md-button class=\"nl-Btn nl-Btn-primary\" type=\"button\" \nng-if=\"msWizard.isLastStep()\" ng-click=\"saveStep(msWizard);\">{{\'GENERAL.SAVE\' | translate }}</md-button></div>\n</ms-form-wizard></div><div class=\"nl--Steps--contentNoTabs\" \nng-if=\"!subscribed && (!form.paginated || form.nbPages <= 1)\"><form name=\"inscriptionForm\" novalidate \nng-submit=\"setSubmittedWizardNestedForm() && inscriptionForm.$valid && save(inscriptionForm)\"><div layout=\"row\" \nclass=\"nl-Form-xs nl-Form-xs-registration\"><div flex=\"50\"><div \nng-repeat=\"field in form.fields | filter: {column: 1} track by field.id\" ng-form=\"fieldForm\" \nng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" class=\"nl--Steps--mainTitle\">\n{{field.header}}</h1><noo-input-event watch=\"checkConditionAfterUpdate(field)\" field=\"field\" ng-show=\"field._show\" \nng-if=\"field.typeField === \'FIELD\'\" ng-required=\"field.required && field._show\" sub-type=\"form.subtype.id\" \nform-name=\"fieldForm\" ng-model=\"field.genericField\" index=\"field.index\" content=\"{{field.genericField.typeChamps}}\" \nmodel-type=\"field.modelType\"></noo-input-event><div ng-if=\"field.typeField === \'EXPLANATION\' && field._show\" \nng-bind-html=\"field.text\"></div></div></div><div flex=\"45\" flex-offset=\"5\"><div \nng-repeat=\"field in form.fields | filter: {column: 2} track by field.id\" ng-form=\"fieldForm\" \nng-init=\"checkCondition(field);\"><h1 ng-if=\"field.typeField === \'HEADER\' && field._show\" class=\"nl--Steps--mainTitle\">\n{{field.header}}</h1><noo-input-event watch=\"checkConditionAfterUpdate(field)\" field=\"field\" ng-show=\"field._show\" \nng-if=\"field.typeField === \'FIELD\'\" ng-required=\"field.required && field._show\" sub-type=\"form.subtype.id\" \nform-name=\"fieldForm\" ng-model=\"field.genericField\" index=\"field.index\" content=\"{{field.genericField.typeChamps}}\" \nmodel-type=\"field.modelType\"></noo-input-event><div ng-if=\"field.typeField === \'EXPLANATION\' && field._show\" \nng-bind-html=\"field.text\"></div></div></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"nl-Btn nl-Btn-primary\" type=\"submit\" translate=\"GENERAL.SAVE\"></md-button></div></form></div><div \nclass=\"nl--Steps--contentNoTabs\" ng-if=\"subscribed\"><div layout=\"row\" layout-align=\"center center\"><div><h2 \nclass=\"nl--Steps--mainTitle\">{{{Registration Confirmation Text}}}</h2></div></div></div></div></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/event/input.html","<div ng-form=\"cellForm\" ng-switch=\"content\"><md-input-container ng-switch-when=\"STRING\"><label \nfor=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><input ng-model=\"model.value\" \nid=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" type=\"text\" class=\"\" ng-required=\"required\"><div \nng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"DATE\"><label class=\"floating-label textarea-label\" \nfor=\"genericField_{{model.id+ \'_\'+index}} \">{{field.name}}</label><md-datepicker \nclass=\"nl-Datepicker nl-Datepicker--fw\" md-open-on-focus md-hide-icons=\"calendar\" ng-model=\"model.dateTime\" \nid=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" ng-required=\"required\"></md-datepicker>\n</md-input-container><md-input-container ng-switch-when=\"URL\" ng-class=\"\"><label \nfor=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><input ng-required=\"required\" ng-model=\"model.value\" \nid=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" type=\"text\" class=\"\"><div \nng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span> <span \nng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div></md-input-container><md-input-container \nng-switch-when=\"EMAIL\" ng-class=\"\"><label for=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><input \nng-required=\"required\" ng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" type=\"text\" \nclass=\"\"><div ng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\">\n</span> <span ng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div></md-input-container><md-input-container \nng-switch-when=\"INTEGER\"><label for=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><input \nstring-to-number ng-required=\"required\" ng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" \nname=\"genericField\" type=\"number\" class=\"\" step=\"1\" ng-pattern=\"/^[0-9]\\d*$/\"><div \nng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span> <span \nng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div></md-input-container><md-input-container \nng-switch-when=\"NUMBER\"><label for=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><input string-to-number \nng-required=\"required\" ng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" \ntype=\"number\" class=\"\" step=\"any\"><div ng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" \ntranslate=\"GENERAL.REQUIRED\"></span> <span ng-message=\"pattern\" translate=\"GENERAL.PATTERN\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"LONG_STRING\"><label for=\"genericField_{{model.id+\'_\'+index}}\" \nclass=\"floating-label textarea-label\">{{field.name}}</label><textarea md-detect-hidden ng-required=\"required\" \nng-model=\"model.value\" id=\"genericField_{{model.id+\'_\'+index}}\" name=\"genericField\" class=\"\" rows=\"3\"></textarea><div \nng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div>\n</md-input-container><div ng-switch-when=\"RICH_TEXT\" class=\"nl_Trix\"><label for=\"genericField_{{model.id+\'_\'+index}}\" \nclass=\"nl_Trix-label\">{{field.name}}</label><ng-quill-editor ng-required=\"required\" ng-model=\"model.value\" \nname=\"genericField\"></ng-quill-editor></div><md-input-container ng-switch-when=\"BOOLEAN\"><md-switch \nid=\"genericField_{{model.id+ \'_\'+index}}\" ng-model=\"model.value\" aria-label=\"Switch 2\" class=\"md-primary\" \nname=\"genericField\">{{field.name}}</md-switch><div ng-messages=\"cellForm.genericField.$error\"><span \nng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div></md-input-container><md-input-container \nng-switch-when=\"LIST_SELECT\"><md-select md-on-open=\"\" md-on-close=\"filterSelectText = \'\'\" \nid=\"genericField_{{model.id+ \'_\'+index}} \" name=\"genericField \" ng-required=\"required\" ng-model=\"model.value\" \nng-model-options=\"{\'trackBy\': \'$value.id\'}\" ng-style=\"model.value.color != null ?{\'color\': model.value.color} : {}\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"event.stopPropagation()\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"option in model.listFieldsDTO | filterText: filterSelectText | orderBy : \'index\' track by option.id\" \nng-value=\"option\" ng-style=\"option.color != null ?{\'color\': option.color} : {}\">{{option.value}}</md-option>\n</md-select><label for=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><div \nng-messages=\"cellForm.genericField.$error\"><span ng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div>\n</md-input-container><md-input-container ng-switch-when=\"MULTIPLE_SELECT\"><md-select md-on-open=\"\" \nmd-on-close=\"filterSelectText = \'\'\" id=\"genericField_{{model.id+ \'_\'+index}} \" name=\"genericField \" \nng-required=\"required\" ng-model=\"model.values \" ng-model-options=\"{\'trackBy\': \'$value.id\'}\" multiple=\"multiple\">\n<md-select-header><section><input force-select-focus type=\"text\" onkeydown=\"event.stopPropagation()\" \nng-model=\"filterSelectText\"></section></md-select-header><md-option \nng-repeat=\"option in model.selectableObject | filterText: filterSelectText | orderBy: \'index\' track by option.id\" \nng-value=\"option\">{{option.libelle != null ? option.libelle : option.value}}</md-option></md-select><label \nfor=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><div ng-messages=\"cellForm.genericField.$error\"><span \nng-message=\"required\" translate=\"GENERAL.REQUIRED\"></span></div></md-input-container><div \nclass=\"nl-info-block-list-img animated fadeIn\" ng-switch-when=\"IMAGE\"><label for=\"genericField_{{model.id+\'_\'+index}}\" \nstyle=\"color: rgba(0,0,0,0.38)\">{{field.name}} <span ng-if=\"required\" style=\"color:rgb(213,0,0)\">*</span></label>\n<dropify-directive id=\"genericField_file_{{model.id+ \'_\'+model.index}}\" filesave=\"photo.uploadFile\" ng-model=\"model\">\n</div><md-input-container ng-switch-when=\"FILE\"><input type=\"file\" class=\"nl_form--file\" ng-model=\"model.value\" \nid=\"genericField_file_{{model.id+ \'_\'+model.index}}\" name=\"genericField\"><div ng-if=\"model.location != null\" \nng-click=\"download()\" style=\"text-decoration: underline\">{{model.filename}}</div></md-input-container>\n<md-input-container ng-switch-default><label for=\"genericField_{{model.id+\'_\'+index}}\">{{field.name}}</label><input \nng-model=\"model.value \" id=\"genericField_{{model.id+ \'_\'+index}} \" name=\"genericField \" type=\"text \" class=\"\">\n</md-input-container></div>");
$templateCache.put("app/main/sites_management/blocs/bloc/event/page.html","");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");}]);